/* tslint:disable */


export type Timestamp = any;

export interface INode {
  _id?: string | null; 
}

export interface Query {
  cspSearch?: reverb_search_SearchResponse | null; 
  completions?: reverb_search_SearchResponse | null; 
  priceGuidesSearch?: reverb_search_SearchResponse | null; 
  listingsSearch?: reverb_search_SearchResponse | null; 
  listingsAggregationSearch?: reverb_search_ListingsAggregationResponse | null; 
  shippingRegionFilter?: reverb_search_ShippingRegionFilterResponse | null; 
  bumpedSortedListings?: ListingCollection | null; 
  priceRecordsSearch?: reverb_search_SearchResponse | null; 
  ordersSearch?: reverb_search_SearchResponse | null; 
  gearCollectionItemsSearch?: reverb_search_SearchResponse | null; 
  similarListingsSearch?: reverb_search_SearchResponse | null; 
  userWatchesSearch?: WatchCollection | null; 
  lpCompletions?: reverb_search_SearchResponse | null; 
  lpListingsSearch?: reverb_search_SearchResponse | null; 
  lpAlbumsSearch?: reverb_search_SearchResponse | null; 
  lpArtistsSearch?: reverb_search_SearchResponse | null; 
  lpLabelsSearch?: reverb_search_SearchResponse | null; 
  lpReleasesSearch?: reverb_search_SearchResponse | null; 
  cmsPagesSearch?: reverb_search_SearchResponse | null; 
  exchangeRates?: reverb_config_cache_CurrencyResponse | null; 
  collection?: (Reflection | null)[] | null; 
  node?: Reflection | null; 
  me?: rql_Me | null; 
  listings?: (Listing | null)[] | null; 
  csps?: (CSP | null)[] | null; 
  sellingFees?: core_apimessages_SellingFeesResponse | null; 
  countries?: core_apimessages_CountriesResponse | null; 
  cmsPages?: cms_PagesResponse | null; 
  cmsPagesFetch?: (CMSPage | null)[] | null; 
  curatedSets?: (CuratedSet | null)[] | null; 
  collectionHeader?: CollectionHeader | null; 
  articles?: (Article | null)[] | null; 
  brands?: (Brand | null)[] | null; 
  chatDepartment?: core_apimessages_ChatDepartmentResponse | null; 
  categories?: (Category | null)[] | null; 
  traitValues?: reverb_taxonomy_GetTraitValueTranslationsResponse | null; 
  orderBundles?: (OrderBundle | null)[] | null; 
  recentlyViewedListings?: (Listing | null)[] | null; 
  searchMetadata?: core_apimessages_SearchMetadataResponse | null; 
  trendingSearches?: reverb_personalization_TrendingSearchesResponse | null; 
  priceRecommendations?: reverb_pricing_PriceRecommendationsResponse | null; 
  cspPriceRecommendations?: reverb_pricing_PriceRecommendationsResponse | null; 
  cpSuggestions?: (core_apimessages_CPSuggestions | null)[] | null; 
  seedListingData?: rql_SeedableListingFields | null; 
  adServe?: core_apimessages_AdServeResponse | null; 
  myDirectCheckoutProfile?: core_apimessages_MyDirectCheckoutProfileResponse | null; 
  experiments?: core_apimessages_ExperimentsResponse | null; 
  intlAddressFormConfig?: reverb_config_cache_InternationalAddressFormConfigResponse | null; 
  mosaicTilesHomepage?: core_apimessages_MosaicTilesResponse | null; 
  promotionalCodeVerify?: core_apimessages_VerifyPromotionalCodeResponse | null; 
  bearerV2Token?: core_apimessages_BearerV2TokenResponse | null; 
  featuredListing?: arbiter_FeaturedListingResponse | null; 
  album?: Album | null; 
  artist?: Artist | null; 
  category?: Category | null; 
  cartitem?: CartItem | null; 
  cmspage?: CMSPage | null; 
  collectionheader?: CollectionHeader | null; 
  csp?: CSP | null; 
  checkout?: Checkout | null; 
  checkoutaction?: CheckoutAction | null; 
  curatedset?: CuratedSet | null; 
  expresssalecheckout?: ExpressSaleCheckout | null; 
  gearcollectionitem?: GearCollectionItem | null; 
  order?: Order | null; 
  listing?: Listing | null; 
  myshop?: MyShop | null; 
  negotiation?: Negotiation | null; 
  orderbundle?: OrderBundle | null; 
  pages?: lp_PagesResponse | null; 
  page?: Page | null; 
  priceguide?: PriceGuide | null; 
  publiccomponent?: PublicComponent | null; 
  release?: Release | null; 
  sale?: Sale | null; 
  sellercheckout?: SellerCheckout | null; 
  shipment?: Shipment | null; 
  shop?: Shop | null; 
  storefront?: Storefront | null; 
  user?: User | null; 
  article?: Article | null; 
  brand?: Brand | null; 
  auction?: Auction | null; 
  watch?: Watch | null; 
  siteBanner?: core_apimessages_SiteBanner | null; 
  sitebanner?: SiteBanner | null; 
  pricechange?: PriceChange | null; 
  myupdate?: MyUpdate | null; 
  myupdatespromotion?: MyUpdatesPromotion | null; 
  shipmentpackage?: ShipmentPackage | null; 
  publicpricerecord?: PublicPriceRecord | null; 
  advertisersSearch?: core_apimessages_AdvertisersSearchResponse | null; 
  adCampaignsSearch?: core_apimessages_AdCampaignsSearchResponse | null; 
  adGroupsSearch?: core_apimessages_AdGroupsSearchResponse | null; 
  adsSearch?: core_apimessages_AdsSearchResponse | null; 
  adZonesSearch?: core_apimessages_AdZonesSearchResponse | null; 
  userSearch?: core_apimessages_AdminUserSearchResponse | null; 
  advertiser?: Advertiser | null; 
  adcampaign?: AdCampaign | null; 
  adgroup?: AdGroup | null; 
  ad?: Ad | null; 
  adzone?: AdZone | null; 
  universalpromocampaign?: UniversalPromoCampaign | null; 
}

export interface reverb_search_SearchResponse {
  resultIds?: (string | null)[] | null; 
  results?: (reverb_search_Document | null)[] | null; 
  total?: number | null; 
  offset?: number | null; 
  limit?: number | null; 
  completions?: (reverb_search_Completion | null)[] | null; 
  percentiles?: (reverb_search_Percentile | null)[] | null; 
  bestListings?: (reverb_search_BestListing | null)[] | null; 
  resultUuids?: (string | null)[] | null; 
  filters?: (reverb_search_Filter | null)[] | null; 
  bumpIds?: (string | null)[] | null; 
  topCollections?: reverb_search_TopCollectionsResult | null; 
  suggestedQueries?: (string | null)[] | null; 
  fallbackResultIds?: (string | null)[] | null; 
  orderMetrics?: reverb_search_OrderMetrics | null; 
  dateBuckets?: (reverb_search_DateBucket | null)[] | null; 
  priceStats?: reverb_search_PriceStatsResults | null; 
  bumpRecommendations?: reverb_search_BumpRecommendationsResults | null; 
  gearCollectionStats?: reverb_search_GearCollectionStats | null; 
  totalHits?: reverb_search_SearchResponse_TotalHits | null; 
  suggestions?: (reverb_search_SearchResponse_Suggestion | null)[] | null; 
  autodirected?: boolean | null; 
  eligibleAutodirects?: (reverb_search_Autodirects | null)[] | null; 
  averageMonthlyProductPrices?: (reverb_search_AverageMonthlyProductPrice | null)[] | null; 
  querySpellCorrections?: (reverb_search_QuerySpellCorrection | null)[] | null; 
  negotiations?: (Negotiation | null)[] | null; 
  auctions?: (Auction | null)[] | null; 
  metadata?: rql_PageMetadata | null; 
  csps?: (CSP | null)[] | null; 
  priceGuides?: (PriceGuide | null)[] | null; 
  listings?: (Listing | null)[] | null; 
  fallbackListings?: (Listing | null)[] | null; 
  bumpedListings?: (Listing | null)[] | null; 
  orders?: (Order | null)[] | null; 
  priceRecords?: (PublicPriceRecord | null)[] | null; 
  gearCollectionItems?: (GearCollectionItem | null)[] | null; 
  releases?: (Release | null)[] | null; 
  albums?: (Album | null)[] | null; 
  bestListing?: Listing | null; 
  cmsPages?: (CMSPage | null)[] | null; 
  ordersForShipment?: (Order | null)[] | null; 
}

export interface reverb_search_Document {
  id?: string | null; 
  source?: string | null; 
  type?: string | null; 
  esCsp?: reverb_search_CSPResponse | null; 
  esGearCollectionItem?: reverb_search_GearCollectionItemResponse | null; 
  node?: Node | null; 
}

export interface reverb_search_CSPResponse {
  id?: string | null; 
  title?: string | null; 
  webLink?: string | null; 
  newListingsLink?: string | null; 
  usedListingsLink?: string | null; 
  cardSquareImageUrl?: string | null; 
  thumbnailImageUrl?: string | null; 
  inventory?: reverb_search_CSPInventory | null; 
  reviewsCount?: number | null; 
  averageReviewRating?: number | null; 
  uuid?: string | null; 
  slug?: string | null; 
}

export interface reverb_search_CSPInventory {
  usedTotal?: number | null; 
  newTotal?: number | null; 
  newLowPrice?: reverb_search_Money | null; 
  usedLowPrice?: reverb_search_Money | null; 
}

export interface reverb_search_Money {
  cents?: number | null; 
  currency?: string | null; 
  amountCents?: number | null; 
}

export interface reverb_search_GearCollectionItemResponse {
  id?: string | null; 
  priceEstimate?: reverb_search_PriceEstimate | null; 
}

export interface reverb_search_PriceEstimate {
  priceLow?: reverb_search_Money | null; 
  priceHigh?: reverb_search_Money | null; 
}

export interface CSP extends INode {
  _id?: string | null; 
  id?: string | null; 
  title?: string | null; 
  summary?: string | null; 
  webLink?: core_apimessages_Link | null; 
  newListingsLink?: core_apimessages_Link | null; 
  usedListingsLink?: core_apimessages_Link | null; 
  brandUuid?: string | null; 
  categoryUuids?: (string | null)[] | null; 
  slug?: string | null; 
  metaDescription?: string | null; 
  body?: string | null; 
  model?: string | null; 
  canonicalProductIds?: (string | null)[] | null; 
  upcs?: (string | null)[] | null; 
  finishes?: (string | null)[] | null; 
  generic?: boolean | null; 
  categoryRootUuid?: string | null; 
  image?: core_apimessages_Image | null; 
  images?: (core_apimessages_Image | null)[] | null; 
  inventory?: core_apimessages_CSPInventory | null; 
  categories?: (Category | null)[] | null; 
  brand?: Brand | null; 
  videos?: core_apimessages_CSPVideo | null; 
  specs?: core_apimessages_CSPSpec | null; 
  reviews?: core_apimessages_CSPReviews | null; 
  featuredListing?: arbiter_FeaturedListingResponse | null; 
  indexedFeaturedListing?: Listing | null; 
  reviewsCount?: number | null; 
  averageReviewRating?: number | null; 
  similarCSPs?: (CSP | null)[] | null; 
  priceGuide?: core_apimessages_PriceGuide | null; 
  expressSalePriceEstimate?: reverb_pricing_PriceRecommendation | null; 
  variants?: (core_apimessages_CspVariant | null)[] | null; 
  expressSaleItemBid?: core_apimessages_CSPExpressSaleItemBid | null; 
}

export interface core_apimessages_Link {
  href?: string | null; 
  path?: string | null; 
}

export interface core_apimessages_Image {
  source?: string | null; 
  itemId?: string | null; 
  itemType?: string | null; 
  publicId?: string | null; 
  version?: string | null; 
  id?: string | null; 
  fallbackType?: core_apimessages_Image_FallbackType | null; 
  transformation?: core_apimessages_ImageEntry_Transformation | null; 
  width?: number | null; 
  height?: number | null; 
}

export interface core_apimessages_ImageEntry_Transformation {
  width?: string | null; 
  height?: string | null; 
  x?: string | null; 
  y?: string | null; 
  crop?: string | null; 
  angle?: number | null; 
}

export interface core_apimessages_CSPInventory {
  id?: string | null; 
  usedTotal?: number | null; 
  newTotal?: number | null; 
  newLowPrice?: core_apimessages_Money | null; 
  usedLowPrice?: core_apimessages_Money | null; 
  uuid?: string | null; 
  slug?: string | null; 
}

export interface core_apimessages_Money {
  amount?: string | null; 
  amountCents?: number | null; 
  currency?: string | null; 
  symbol?: string | null; 
  display?: string | null; 
}

export interface Category extends INode {
  _id?: string | null; 
  id?: string | null; 
  name?: string | null; 
  webLink?: core_apimessages_Link | null; 
  children?: (core_apimessages_Category | null)[] | null; 
  cmsLink?: core_apimessages_Link | null; 
  parent?: core_apimessages_Category | null; 
  slug?: string | null; 
  rootSlug?: string | null; 
  cmsUrl?: core_apimessages_Link | null; 
  root?: boolean | null; 
  leaf?: boolean | null; 
  images?: (core_apimessages_Image | null)[] | null; 
  childCategories?: (Category | null)[] | null; 
  parentCategories?: (Category | null)[] | null; 
}

export interface core_apimessages_Category {
  id?: string | null; 
  name?: string | null; 
  webLink?: core_apimessages_Link | null; 
  children?: (core_apimessages_Category | null)[] | null; 
  cmsLink?: core_apimessages_Link | null; 
  parent?: core_apimessages_Category | null; 
  slug?: string | null; 
  rootSlug?: string | null; 
  cmsUrl?: core_apimessages_Link | null; 
  root?: boolean | null; 
  leaf?: boolean | null; 
}

export interface Brand extends INode {
  _id?: string | null; 
  id?: string | null; 
  name?: string | null; 
  webLink?: core_apimessages_Link | null; 
  slug?: string | null; 
  images?: (core_apimessages_Image | null)[] | null; 
  metrics?: reverb_search_SearchResponse | null; 
  manager?: rql_BrandManager | null; 
}

export interface rql_BrandManager {
  slug?: string | null; 
  id?: string | null; 
  statsByCSP?: reverb_reporting_CSPStatsByCSPResponse | null; 
  statsByDate?: reverb_reporting_CSPStatsByDateResponse | null; 
  totalStats?: reverb_reporting_CSPStats | null; 
}

export interface reverb_reporting_CSPStatsByCSPResponse {
  byCsp?: (reverb_reporting_CSPStatsByCSP | null)[] | null; 
  totalCount?: number | null; 
}

export interface reverb_reporting_CSPStatsByCSP {
  cspId?: string | null; 
  cspSlug?: string | null; 
  brandSlug?: string | null; 
  liveListingCount?: number | null; 
  minListingPriceUsc?: reverb_reporting_Int32Value | null; 
  orderQuantity?: number | null; 
  totalOrderValueUsc?: number | null; 
  avgOrderPriceUsc?: reverb_reporting_Int32Value | null; 
  csp?: CSP | null; 
}

export interface reverb_reporting_Int32Value {
  value?: number | null; 
}

export interface reverb_reporting_CSPStatsByDateResponse {
  byDate?: (reverb_reporting_CSPStatsByDate | null)[] | null; 
}

export interface reverb_reporting_CSPStatsByDate {
  date?: string | null; 
  liveListingCount?: number | null; 
  minListingPriceUsc?: reverb_reporting_Int32Value | null; 
  orderQuantity?: number | null; 
  totalOrderValueUsc?: number | null; 
  avgOrderPriceUsc?: reverb_reporting_Int32Value | null; 
}

export interface reverb_reporting_CSPStats {
  liveListingCount?: number | null; 
  minListingPriceUsc?: reverb_reporting_Int32Value | null; 
  orderQuantity?: number | null; 
  totalOrderValueUsc?: number | null; 
  avgOrderPriceUsc?: reverb_reporting_Int32Value | null; 
}

export interface core_apimessages_CSPVideo {
  videoLinks?: (core_apimessages_VideoLink | null)[] | null; 
}

export interface core_apimessages_VideoLink {
  youtubeVideoId?: string | null; 
  youtubeLink?: string | null; 
}

export interface core_apimessages_CSPSpec {
  productSpecs?: (core_apimessages_ProductSpec | null)[] | null; 
}

export interface core_apimessages_ProductSpec {
  name?: string | null; 
  value?: string | null; 
  path?: string | null; 
  type?: core_apimessages_ProductSpec_Type | null; 
  slug?: string | null; 
}

export interface core_apimessages_CSPReviews {
  reviews?: (core_apimessages_CSPReview | null)[] | null; 
  offset?: number | null; 
  limit?: number | null; 
  total?: number | null; 
  avgRating?: number | null; 
  myReview?: core_apimessages_CSPReview | null; 
}

export interface core_apimessages_CSPReview {
  id?: string | null; 
  body?: string | null; 
  createdAt?: string | null; 
  title?: string | null; 
  rating?: number | null; 
  voteCount?: number | null; 
  reviewer?: core_apimessages_Reviewer | null; 
  verified?: boolean | null; 
  blocked?: boolean | null; 
  isMyReview?: boolean | null; 
  didIVote?: boolean | null; 
}

export interface core_apimessages_Reviewer {
  shortname?: string | null; 
  links?: core_apimessages_ReviewerLinks | null; 
}

export interface core_apimessages_ReviewerLinks {
  avatar?: core_apimessages_Link | null; 
}

export interface arbiter_FeaturedListingResponse {
  productId?: string | null; 
  bumped?: boolean | null; 
  rank?: number | null; 
  bid?: number | null; 
  qualityScore?: number | null; 
  runnerUp?: arbiter_FeaturedListingResponse | null; 
  listing?: Listing | null; 
}

export interface Listing extends INode {
  _id?: string | null; 
  id?: string | null; 
  title?: string | null; 
  merchandisingUuid?: string | null; 
  price?: core_apimessages_Money | null; 
  shopId?: string | null; 
  sellerId?: string | null; 
  sellerUuid?: string | null; 
  hasInventory?: boolean | null; 
  inventory?: number | null; 
  shopUuid?: string | null; 
  categoryUuids?: (string | null)[] | null; 
  state?: string | null; 
  condition?: core_apimessages_Condition | null; 
  slug?: string | null; 
  listingType?: core_apimessages_Listing_ListingType | null; 
  publishedAt?: google_protobuf_Timestamp | null; 
  description?: string | null; 
  merchandisingType?: string | null; 
  countryOfOrigin?: string | null; 
  finish?: string | null; 
  make?: string | null; 
  model?: string | null; 
  productTypeId?: string | null; 
  year?: string | null; 
  canonicalProductId?: string | null; 
  seedId?: string | null; 
  seedType?: core_apimessages_Listing_SeedType | null; 
  sku?: string | null; 
  stateDescription?: string | null; 
  taxIncluded?: boolean | null; 
  priceGuideUuid?: string | null; 
  cspUuid?: string | null; 
  currentAuctionId?: string | null; 
  salePrice?: core_apimessages_Money | null; 
  categoryRootUuid?: string | null; 
  taxIncludedHint?: string | null; 
  bumped?: boolean | null; 
  upc?: string | null; 
  exclusiveChannel?: string | null; 
  brandSlug?: string | null; 
  soldAsIs?: boolean | null; 
  bumpEligible?: boolean | null; 
  propSixtyFiveWarning?: string | null; 
  propSixtyFiveWarningImg?: core_apimessages_Link | null; 
  maxBuyerQuantity?: number | null; 
  currency?: string | null; 
  cspId?: string | null; 
  allowedBuyerQuantity?: number | null; 
  sameDayShippingIneligible?: boolean | null; 
  overriddenAttributes?: (string | null)[] | null; 
  sellerCost?: core_apimessages_Money | null; 
  storageLocation?: string | null; 
  sellerPrice?: core_apimessages_Money | null; 
  handmade?: boolean | null; 
  upcDoesNotApply?: boolean | null; 
  localizedContents?: (core_apimessages_LocalizedListingContent | null)[] | null; 
  shippingProfileId?: string | null; 
  prefersReverbShippingLabel?: boolean | null; 
  taxExempt?: boolean | null; 
  adyenCheckoutPaymentMethodsConfig?: string | null; 
  images?: (core_apimessages_Image | null)[] | null; 
  sale?: core_apimessages_Sale | null; 
  sales?: (core_apimessages_Sale | null)[] | null; 
  specs?: core_apimessages_ListingSpec | null; 
  pricing?: core_apimessages_ListingPricing | null; 
  shippingPrice?: core_apimessages_Money | null; 
  shipping?: core_apimessages_ShippingPrices | null; 
  allShippingPrices?: core_apimessages_ShippingPrices | null; 
  shop?: Shop | null; 
  counts?: core_apimessages_ListingCounts | null; 
  release?: Release | null; 
  auction?: Auction | null; 
  traits?: (core_apimessages_Trait | null)[] | null; 
  acceptedPaymentMethods?: (string | null)[] | null; 
  estimatedMonthlyPayment?: core_apimessages_Money | null; 
  estimatedMonthlyPaymentPlan?: core_apimessages_EstimatedMonthlyPayment | null; 
  seller?: User | null; 
  video?: core_apimessages_Video | null; 
  preorderInfo?: core_apimessages_PreorderInfo | null; 
  affirmFinancingPromotion?: core_apimessages_AffirmFinancingPromotion | null; 
  csp?: CSP | null; 
  bumpRate?: core_apimessages_BumpRate | null; 
  priceGuide?: PriceGuide | null; 
  watching?: boolean | null; 
  otherBuyersWithListingInCartCounts?: number | null; 
  categories?: (Category | null)[] | null; 
  curatedSets?: (CuratedSet | null)[] | null; 
  taxPolicies?: (core_apimessages_ShopTaxPolicy | null)[] | null; 
  orders?: OrderCollection | null; 
  similarCSPs?: (CSP | null)[] | null; 
  similarListings?: (Listing | null)[] | null; 
  autoOffers?: core_apimessages_AutoOffer | null; 
  bumpKey?: core_apimessages_BumpKey | null; 
  bumpRecommendations?: reverb_search_BumpRecommendationsResults | null; 
  orderPricing?: reverb_search_SearchResponse | null; 
  bumpInteractionsCounts?: arbiter_BumpInteractionCountsResponse | null; 
  priceRecommendation?: reverb_pricing_PriceRecommendation | null; 
  signals?: (reverb_signals_Signal | null)[] | null; 
  shipmentPackage?: ShipmentPackage | null; 
  experiments?: (core_apimessages_NonUserExperiment | null)[] | null; 
}

export interface core_apimessages_Condition {
  conditionUuid?: string | null; 
  displayName?: string | null; 
  conditionSlug?: string | null; 
  description?: string | null; 
}

export interface google_protobuf_Timestamp {
  seconds?: number | null; 
  nanos?: number | null; 
}

export interface core_apimessages_LocalizedListingContent {
  locale?: string | null; 
  make?: string | null; 
  model?: string | null; 
  finish?: string | null; 
  title?: string | null; 
  description?: string | null; 
  prop65Warning?: string | null; 
  defaultForShop?: boolean | null; 
}

export interface core_apimessages_Sale {
  id?: string | null; 
  slug?: string | null; 
  name?: string | null; 
  code?: string | null; 
  startsAt?: google_protobuf_Timestamp | null; 
  endsAt?: google_protobuf_Timestamp | null; 
  summary?: string | null; 
  state?: core_apimessages_Sale_SaleState | null; 
  display?: string | null; 
  withSalePriceDisplay?: string | null; 
  percent?: number | null; 
  buyerIneligibilityReason?: string | null; 
  saleType?: string | null; 
  showCode?: boolean | null; 
  shopSlug?: string | null; 
  shopName?: string | null; 
  links?: core_apimessages_SaleLinks | null; 
}

export interface core_apimessages_SaleLinks {
  self?: core_apimessages_Link | null; 
}

export interface core_apimessages_ListingSpec {
  productSpecs?: (core_apimessages_ProductSpec | null)[] | null; 
}

export interface core_apimessages_ListingPricing {
  id?: string | null; 
  buyerPrice?: core_apimessages_Money | null; 
  originalPrice?: core_apimessages_Money | null; 
  ribbon?: core_apimessages_Ribbon | null; 
}

export interface core_apimessages_Ribbon {
  display?: string | null; 
  reason?: core_apimessages_Ribbon_Reason | null; 
}

export interface core_apimessages_ShippingPrices {
  shippingPrices?: (core_apimessages_ShippingPrice | null)[] | null; 
  localPickup?: boolean | null; 
  freeExpeditedShipping?: boolean | null; 
  localPickupOnly?: boolean | null; 
  shippingRegionCode?: string | null; 
  shippingAddress?: core_apimessages_Address | null; 
}

export interface core_apimessages_ShippingPrice {
  shippingMethod?: core_apimessages_ShippingMethod | null; 
  rate?: core_apimessages_Money | null; 
  originalRate?: core_apimessages_Money | null; 
  shippingRegionCode?: string | null; 
  carrierCalculated?: boolean | null; 
  destinationPostalCodeNeeded?: boolean | null; 
  regional?: boolean | null; 
}

export interface core_apimessages_Address {
  name?: string | null; 
  streetAddress?: string | null; 
  extendedAddress?: string | null; 
  postalCode?: string | null; 
  phone?: string | null; 
  region?: string | null; 
  locality?: string | null; 
  countryCode?: string | null; 
  displayLocation?: string | null; 
  id?: string | null; 
  primary?: boolean | null; 
  legacyId?: string | null; 
  uuid?: string | null; 
  addressPresent?: boolean | null; 
  email?: string | null; 
  country?: core_apimessages_Country | null; 
  regionName?: string | null; 
  isComplete?: boolean | null; 
}

export interface core_apimessages_Country {
  countryCode?: string | null; 
  name?: string | null; 
  subregionRequired?: boolean | null; 
  subregions?: (core_apimessages_Subregion | null)[] | null; 
  superRegion?: core_apimessages_SuperRegion | null; 
}

export interface core_apimessages_Subregion {
  code?: string | null; 
  name?: string | null; 
}

export interface core_apimessages_SuperRegion {
  code?: string | null; 
  name?: string | null; 
}

export interface Shop extends INode {
  _id?: string | null; 
  uuid?: string | null; 
  name?: string | null; 
  slug?: string | null; 
  currency?: string | null; 
  originCountryCode?: string | null; 
  shopType?: core_apimessages_Shop_ShopType | null; 
  paymentPolicy?: string | null; 
  shippingPolicy?: string | null; 
  id?: string | null; 
  preferredSeller?: boolean | null; 
  quickShipper?: boolean | null; 
  quickResponder?: boolean | null; 
  userUuid?: string | null; 
  onVacation?: boolean | null; 
  description?: string | null; 
  userId?: string | null; 
  website?: string | null; 
  showSold?: boolean | null; 
  vatId?: string | null; 
  recentlyShipped?: boolean | null; 
  quickShipperSpeed?: core_apimessages_Shop_QuickShipperSpeed | null; 
  createdAt?: Timestamp | null; 
  defaultLocale?: string | null; 
  currencySetting?: string | null; 
  shippingRegionSettings?: (core_apimessages_ShippingRegionSetting | null)[] | null; 
  sameDayShippingConfigured?: boolean | null; 
  listableConditions?: (core_apimessages_Condition | null)[] | null; 
  offerPolicy?: core_apimessages_Shop_OfferPolicy | null; 
  shopSupportedLocaleCodes?: (string | null)[] | null; 
  address?: core_apimessages_Address | null; 
  sales?: (core_apimessages_Sale | null)[] | null; 
  shippingProfiles?: (core_apimessages_ShippingProfile | null)[] | null; 
  banner?: core_apimessages_Image | null; 
  video?: core_apimessages_Video | null; 
  returnPolicy?: core_apimessages_ReturnPolicy | null; 
  taxPolicies?: (core_apimessages_ShopTaxPolicy | null)[] | null; 
  user?: User | null; 
  euOdrAddress?: core_apimessages_Address | null; 
  orders?: reverb_search_SearchResponse | null; 
  freeDomesticShippingRate?: core_apimessages_ShippingRates | null; 
}

export interface core_apimessages_ShippingRegionSetting {
  regionCode?: string | null; 
  regionName?: string | null; 
  isDomestic?: boolean | null; 
  allowedToShipCarrierCalculated?: boolean | null; 
}

export interface core_apimessages_Shop_OfferPolicy {
  autoRejectLowOffers?: boolean | null; 
  lowballPercentage?: number | null; 
}

export interface core_apimessages_ShippingProfile {
  localPickup?: boolean | null; 
  categoryUuids?: (string | null)[] | null; 
  shippingRates?: core_apimessages_ShippingRates | null; 
  name?: string | null; 
  id?: string | null; 
  allShippingRates?: (core_apimessages_ShippingRates | null)[] | null; 
}

export interface core_apimessages_ShippingRates {
  regionCode?: string | null; 
  rate?: core_apimessages_Money | null; 
  incrementalRate?: core_apimessages_Money | null; 
  freeShippingThreshold?: core_apimessages_Money | null; 
  regionType?: core_apimessages_ShippingRates_RegionType | null; 
  expeditedRate?: core_apimessages_Money | null; 
  regionName?: string | null; 
  rateType?: string | null; 
  regionalRates?: (core_apimessages_RegionalShippingRate | null)[] | null; 
  regionalExpeditedRates?: (core_apimessages_RegionalShippingRate | null)[] | null; 
}

export interface core_apimessages_RegionalShippingRate {
  areas?: (string | null)[] | null; 
  rate?: core_apimessages_Money | null; 
}

export interface core_apimessages_Video {
  id?: string | null; 
  itemId?: string | null; 
  itemType?: string | null; 
  link?: string | null; 
  youtubeVideoId?: string | null; 
  empty?: boolean | null; 
}

export interface core_apimessages_ReturnPolicy {
  newReturnWindowDays?: number | null; 
  usedReturnWindowDays?: number | null; 
  restockingFeePercent?: number | null; 
  specialConditions?: string | null; 
  legacyReturnPolicyText?: string | null; 
}

export interface core_apimessages_ShopTaxPolicy {
  policyType?: core_apimessages_ShopTaxPolicy_PolicyType | null; 
  displayLocation?: string | null; 
  displayRate?: string | null; 
  vatPolicy?: boolean | null; 
}

export interface User extends INode {
  _id?: string | null; 
  name?: string | null; 
  shopUuid?: string | null; 
  id?: string | null; 
  firstName?: string | null; 
  uuid?: string | null; 
  shop?: core_apimessages_Shop | null; 
  avatar?: core_apimessages_Image | null; 
  feedback?: core_apimessages_FeedbacksResponse | null; 
  feedbackSummary?: core_apimessages_FeedbackSummary | null; 
}

export interface core_apimessages_Shop {
  uuid?: string | null; 
  name?: string | null; 
  slug?: string | null; 
  currency?: string | null; 
  originCountryCode?: string | null; 
  shopType?: core_apimessages_Shop_ShopType | null; 
  paymentPolicy?: string | null; 
  shippingPolicy?: string | null; 
  id?: string | null; 
  preferredSeller?: boolean | null; 
  quickShipper?: boolean | null; 
  quickResponder?: boolean | null; 
  userUuid?: string | null; 
  onVacation?: boolean | null; 
  description?: string | null; 
  userId?: string | null; 
  website?: string | null; 
  showSold?: boolean | null; 
  vatId?: string | null; 
  recentlyShipped?: boolean | null; 
  quickShipperSpeed?: core_apimessages_Shop_QuickShipperSpeed | null; 
  createdAt?: Timestamp | null; 
  defaultLocale?: string | null; 
  currencySetting?: string | null; 
  shippingRegionSettings?: (core_apimessages_ShippingRegionSetting | null)[] | null; 
  sameDayShippingConfigured?: boolean | null; 
  listableConditions?: (core_apimessages_Condition | null)[] | null; 
  offerPolicy?: core_apimessages_Shop_OfferPolicy | null; 
  shopSupportedLocaleCodes?: (string | null)[] | null; 
}

export interface core_apimessages_FeedbacksResponse {
  feedbacks?: (core_apimessages_Feedback | null)[] | null; 
  total?: number | null; 
  offset?: number | null; 
  limit?: number | null; 
}

export interface core_apimessages_Feedback {
  authorUuid?: string | null; 
  orderTitle?: string | null; 
  rating?: number | null; 
  createdAt?: google_protobuf_Timestamp | null; 
  message?: string | null; 
  type?: core_apimessages_Feedback_Type | null; 
  recipientUuid?: string | null; 
  response?: core_apimessages_Feedback_Response | null; 
  shippingSatisfactory?: google_protobuf_BoolValue | null; 
  conditionSatisfactory?: google_protobuf_BoolValue | null; 
  listingLink?: core_apimessages_Link | null; 
  author?: User | null; 
  recipient?: User | null; 
}

export interface core_apimessages_Feedback_Response {
  body?: string | null; 
  createdAt?: google_protobuf_Timestamp | null; 
}

export interface google_protobuf_BoolValue {
  value?: boolean | null; 
}

export interface core_apimessages_FeedbackSummary {
  userId?: string | null; 
  receivedCount?: number | null; 
  rollingRatingPercentage?: number | null; 
}

export interface core_apimessages_ListingCounts {
  id?: string | null; 
  views?: number | null; 
  watchers?: number | null; 
  offers?: number | null; 
}

export interface Release extends INode {
  _id?: string | null; 
  uuid?: string | null; 
  catalogNumbers?: (string | null)[] | null; 
  title?: string | null; 
  artistName?: string | null; 
  releaseDate?: string | null; 
  formats?: (lp_ReleaseFormat | null)[] | null; 
  genres?: (string | null)[] | null; 
  masterUuid?: string | null; 
  country?: string | null; 
  merchandisingTitle?: string | null; 
  shippingQuantity?: number | null; 
  tracks?: (lp_Track | null)[] | null; 
  collaborators?: (lp_Collaborator | null)[] | null; 
  id?: string | null; 
  transactionPercentiles?: (reverb_search_Percentile | null)[] | null; 
  relatedReleases?: ReleaseCollection | null; 
  album?: Album | null; 
  label?: lp_APILabel | null; 
  artists?: (lp_APIArtist | null)[] | null; 
  images?: (lp_APIImage | null)[] | null; 
  listingsCollection?: ListingCollection | null; 
}

export interface lp_ReleaseFormat {
  name?: string | null; 
  uuid?: string | null; 
  descriptions?: (string | null)[] | null; 
  text?: string | null; 
  quantity?: number | null; 
}

export interface lp_Track {
  duration?: string | null; 
  position?: string | null; 
  title?: string | null; 
}

export interface lp_Collaborator {
  name?: string | null; 
  role?: string | null; 
}

export interface reverb_search_Percentile {
  key?: string | null; 
  count?: number | null; 
  p1?: number | null; 
  p5?: number | null; 
  p25?: number | null; 
  p50?: number | null; 
  p75?: number | null; 
  p95?: number | null; 
  p99?: number | null; 
}

export interface ReleaseCollection {
  _ids?: (string | null)[] | null; 
  nodes?: (Release | null)[] | null; 
  pageInfo?: rql_PageInfo | null; 
  transactionPercentiles?: (reverb_search_Percentile | null)[] | null; 
  releases?: (Release | null)[] | null; 
}

export interface rql_PageInfo {
  limit?: number | null; 
  offset?: number | null; 
  total?: number | null; 
}

export interface Album extends INode {
  _id?: string | null; 
  artistSlug?: string | null; 
  artistUuid?: string | null; 
  catalogNumbers?: (string | null)[] | null; 
  collaborators?: (lp_Collaborator | null)[] | null; 
  companies?: (lp_Company | null)[] | null; 
  editorialContent?: string | null; 
  formatDescriptions?: (string | null)[] | null; 
  hasLiveListings?: boolean | null; 
  id?: string | null; 
  identifiers?: (lp_Identifier | null)[] | null; 
  labelName?: string | null; 
  labelSlug?: string | null; 
  labelUuid?: string | null; 
  labelWeight?: number | null; 
  listingCount?: number | null; 
  lowestPriceCents?: number | null; 
  notes?: string | null; 
  releaseDate?: string | null; 
  releaseUuids?: (string | null)[] | null; 
  slug?: string | null; 
  title?: string | null; 
  tracks?: (lp_Track | null)[] | null; 
  uuid?: string | null; 
  artistName?: string | null; 
  highestPrice?: lp_Price | null; 
  lowestPrice?: lp_Price | null; 
  releaseCount?: number | null; 
  artists?: (lp_AlbumArtist | null)[] | null; 
  images?: (lp_LPImage | null)[] | null; 
  attributionId?: string | null; 
  genres?: (string | null)[] | null; 
  deletedAt?: string | null; 
}

export interface lp_Company {
  function?: string | null; 
  name?: string | null; 
}

export interface lp_Identifier {
  type?: string | null; 
  value?: string | null; 
}

export interface lp_Price {
  amount?: string | null; 
  amountCents?: number | null; 
  currency?: string | null; 
  symbol?: string | null; 
  display?: string | null; 
}

export interface lp_AlbumArtist {
  name?: string | null; 
  uuid?: string | null; 
  slug?: string | null; 
  nameVariations?: (string | null)[] | null; 
}

export interface lp_LPImage {
  Links?: lp_LPImageLinks | null; 
  imageLinks?: lp_LPImageLinks | null; 
  key?: string | null; 
}

export interface lp_LPImageLinks {
  thumbSmall?: lp_Link | null; 
  thumbLarge?: lp_Link | null; 
  original?: lp_Link | null; 
}

export interface lp_Link {
  href?: string | null; 
}

export interface lp_APILabel {
  uuid?: string | null; 
  slug?: string | null; 
  name?: string | null; 
}

export interface lp_APIArtist {
  uuid?: string | null; 
  name?: string | null; 
  slug?: string | null; 
  featuredAlbumIds?: (string | null)[] | null; 
  bannerImageKey?: string | null; 
}

export interface lp_APIImage {
  key?: string | null; 
}

export interface ListingCollection {
  _ids?: (string | null)[] | null; 
  nodes?: (Listing | null)[] | null; 
  pageInfo?: rql_PageInfo | null; 
  listings?: (Listing | null)[] | null; 
}

export interface Auction extends INode {
  _id?: string | null; 
  id?: string | null; 
  endAt?: google_protobuf_Timestamp | null; 
  startAt?: google_protobuf_Timestamp | null; 
  minBid?: core_apimessages_Money | null; 
  listingId?: string | null; 
  relistIfUnsold?: boolean | null; 
  listing?: Listing | null; 
  auctionBids?: core_apimessages_AuctionBidsResponse | null; 
  bidDetails?: core_apimessages_BidDetails | null; 
  myBidDetails?: core_apimessages_MyBidDetails | null; 
}

export interface core_apimessages_AuctionBidsResponse {
  auctionId?: string | null; 
  bids?: (core_apimessages_Bid | null)[] | null; 
  offset?: number | null; 
  limit?: number | null; 
  total?: number | null; 
}

export interface core_apimessages_Bid {
  id?: string | null; 
  price?: core_apimessages_Money | null; 
  obfuscatedUserName?: string | null; 
  createdAt?: google_protobuf_Timestamp | null; 
}

export interface core_apimessages_BidDetails {
  auctionId?: string | null; 
  highBidPrice?: core_apimessages_Money | null; 
  totalBids?: number | null; 
}

export interface core_apimessages_MyBidDetails {
  auctionId?: string | null; 
  maxBidPrice?: core_apimessages_Money | null; 
  isWinning?: boolean | null; 
  status?: core_apimessages_MyBidDetails_BidDetailStatus | null; 
}

export interface core_apimessages_Trait {
  keyId?: string | null; 
  valueId?: string | null; 
  value?: string | null; 
}

export interface core_apimessages_EstimatedMonthlyPayment {
  id?: string | null; 
  estimatedMonthlyPayment?: core_apimessages_Money | null; 
  maxTermMonth?: number | null; 
  availableTermMonths?: (number | null)[] | null; 
  lowestAprAtMaxTerm?: number | null; 
  zeroPercentFinancingPlan?: boolean | null; 
  splitPay?: boolean | null; 
}

export interface core_apimessages_PreorderInfo {
  id?: string | null; 
  estimatedShipDate?: google_protobuf_Timestamp | null; 
  onPreorder?: boolean | null; 
  leadTimeDays?: number | null; 
  shipDate?: google_protobuf_Timestamp | null; 
}

export interface core_apimessages_AffirmFinancingPromotion {
  id?: string | null; 
  financingPlan?: string | null; 
  startsAt?: google_protobuf_Timestamp | null; 
  endsAt?: google_protobuf_Timestamp | null; 
  availableTermMonths?: (number | null)[] | null; 
  maxTermMonth?: number | null; 
  zeroPercentFinancing?: boolean | null; 
  links?: core_apimessages_AffirmFinancingPromotionLinks | null; 
}

export interface core_apimessages_AffirmFinancingPromotionLinks {
  curatedSet?: core_apimessages_Link | null; 
}

export interface core_apimessages_BumpRate {
  rate?: number | null; 
}

export interface PriceGuide extends INode {
  _id?: string | null; 
  id?: string | null; 
  title?: string | null; 
  webLink?: core_apimessages_Link | null; 
  priceLow?: core_apimessages_Money | null; 
  priceHigh?: core_apimessages_Money | null; 
  images?: (core_apimessages_Image | null)[] | null; 
}

export interface CuratedSet extends INode {
  _id?: string | null; 
  id?: string | null; 
  title?: string | null; 
  webLink?: core_apimessages_Link | null; 
  slug?: string | null; 
  setType?: string | null; 
  images?: (core_apimessages_Image | null)[] | null; 
}

export interface OrderCollection {
  _ids?: (string | null)[] | null; 
  nodes?: (Order | null)[] | null; 
  pageInfo?: rql_PageInfo | null; 
}

export interface Order extends INode {
  _id?: string | null; 
  buyerUuid?: string | null; 
  shopUuid?: string | null; 
  listingId?: string | null; 
  status?: core_apimessages_Order_Status | null; 
  shippingMethod?: core_apimessages_ShippingMethod | null; 
  sellerUuid?: string | null; 
  checkoutUuid?: string | null; 
  legacyOrderId?: string | null; 
  createdAt?: google_protobuf_Timestamp | null; 
  settlementAmountProductSubtotal?: core_apimessages_Money | null; 
  quantity?: number | null; 
  legacyBuyerId?: string | null; 
  paidAt?: google_protobuf_Timestamp | null; 
  updatedAt?: google_protobuf_Timestamp | null; 
  shippedAt?: google_protobuf_Timestamp | null; 
  needsFeedbackForBuyer?: boolean | null; 
  needsFeedbackForSeller?: boolean | null; 
  orderType?: string | null; 
  shippingProvider?: string | null; 
  shippingCode?: string | null; 
  amountProduct?: core_apimessages_Money | null; 
  amountTotal?: core_apimessages_Money | null; 
  amountTax?: core_apimessages_Money | null; 
  amountShipping?: core_apimessages_Money | null; 
  statusDescription?: string | null; 
  webTrackingUrl?: string | null; 
  shipmentStatus?: string | null; 
  orderUrl?: core_apimessages_Link | null; 
  mobileStatus?: string | null; 
  carrierCalculatedShippingAmount?: core_apimessages_Money | null; 
  uuid?: string | null; 
  id?: string | null; 
  customsInfo?: core_apimessages_OrderCustomsInfo | null; 
  listing?: Listing | null; 
  verifiedShippingAddress?: core_apimessages_OrderVerifyShippingAddressResponse | null; 
  flatRateShippingOptions?: core_apimessages_OrderFlatRateShippingOptionsResponse | null; 
  buyer?: User | null; 
  seller?: User | null; 
  feedback?: (core_apimessages_Feedback | null)[] | null; 
  payments?: (core_apimessages_Payment | null)[] | null; 
  packlinkShipment?: core_apimessages_PacklinkShipment | null; 
  notes?: (core_apimessages_OrderNote | null)[] | null; 
  refunds?: core_apimessages_OrderRefunds | null; 
  buyerOrder?: core_apimessages_BuyerOrder | null; 
  sellerOrder?: core_apimessages_SellerOrder | null; 
  shippingAddress?: core_apimessages_Address | null; 
}

export interface core_apimessages_OrderCustomsInfo {
  tariffNumber?: string | null; 
  categoryName?: string | null; 
  description?: string | null; 
  countryOfOrigin?: string | null; 
}

export interface core_apimessages_OrderVerifyShippingAddressResponse {
  address?: core_apimessages_Address | null; 
  errorMessage?: string | null; 
  verificationStatus?: core_apimessages_AddressVerificationStatus | null; 
  isResidential?: boolean | null; 
}

export interface core_apimessages_OrderFlatRateShippingOptionsResponse {
  flatRateShippingOptions?: (core_apimessages_FlatRateShippingOption | null)[] | null; 
}

export interface core_apimessages_FlatRateShippingOption {
  carrier?: string | null; 
  displayTitle?: string | null; 
  displayName?: string | null; 
  optionValue?: string | null; 
  displayDimensions?: string | null; 
  maximumPounds?: number | null; 
  displayPosition?: number | null; 
}

export interface core_apimessages_Payment {
  paymentMethod?: core_apimessages_Payment_PaymentMethod | null; 
  paymentStatus?: core_apimessages_Payment_PaymentStatus | null; 
  amount?: core_apimessages_Money | null; 
}

export interface core_apimessages_PacklinkShipment {
  id?: string | null; 
  orderId?: string | null; 
  packlinkAccountId?: string | null; 
  reference?: string | null; 
  status?: core_apimessages_PacklinkShipment_Status | null; 
}

export interface core_apimessages_OrderNote {
  id?: string | null; 
  body?: string | null; 
  orderId?: string | null; 
  createdAt?: google_protobuf_Timestamp | null; 
}

export interface core_apimessages_OrderRefunds {
  refundableState?: core_apimessages_OrderRefunds_RefundableState | null; 
  refundRequests?: (core_apimessages_RefundRequest | null)[] | null; 
  completedRefunds?: (core_apimessages_Refund | null)[] | null; 
}

export interface core_apimessages_RefundRequest {
  amount?: core_apimessages_Money | null; 
  type?: core_apimessages_RefundRequest_RefundType | null; 
  state?: core_apimessages_RefundRequest_RefundState | null; 
  createdAt?: google_protobuf_Timestamp | null; 
  updatedAt?: google_protobuf_Timestamp | null; 
  id?: string | null; 
  markItemReturnedWebUrl?: string | null; 
  respondToRequestWebUrl?: string | null; 
}

export interface core_apimessages_Refund {
  id?: string | null; 
  amount?: core_apimessages_ConvertedMoney | null; 
  createdAt?: google_protobuf_Timestamp | null; 
  updatedAt?: google_protobuf_Timestamp | null; 
  noteToBuyer?: string | null; 
  buyerRefund?: core_apimessages_BuyerRefund | null; 
}

export interface core_apimessages_ConvertedMoney {
  original?: core_apimessages_Money | null; 
  display?: core_apimessages_Money | null; 
}

export interface core_apimessages_BuyerRefund {
  id?: string | null; 
  nonBucksRefundAmount?: core_apimessages_ConvertedMoney | null; 
  reverbBucksAmountRefunded?: core_apimessages_Money | null; 
}

export interface core_apimessages_BuyerOrder {
  uuid?: string | null; 
  amountOwed?: core_apimessages_Money | null; 
  amountCreditBucks?: core_apimessages_Money | null; 
  amountBonusBucks?: core_apimessages_Money | null; 
  buyerActions?: core_apimessages_BuyerActions | null; 
  amountProduct?: core_apimessages_Money | null; 
  amountProductSubtotal?: core_apimessages_Money | null; 
  amountTotal?: core_apimessages_Money | null; 
  amountTax?: core_apimessages_Money | null; 
  amountShipping?: core_apimessages_Money | null; 
}

export interface core_apimessages_BuyerActions {
  canBeResold?: boolean | null; 
  canMarkReceived?: boolean | null; 
}

export interface core_apimessages_SellerOrder {
  uuid?: string | null; 
  shippingLabel?: core_apimessages_OrderShippingLabel | null; 
  packingSlip?: core_apimessages_OrderPackingSlip | null; 
  taxResponsibleParty?: core_apimessages_SellerOrder_TaxResponsibleParty | null; 
}

export interface core_apimessages_OrderShippingLabel {
  shippingLabelWebUrl?: string | null; 
  purchaseShippingLabelWebUrl?: string | null; 
}

export interface core_apimessages_OrderPackingSlip {
  packingSlipWebUrl?: string | null; 
}

export interface core_apimessages_AutoOffer {
  id?: string | null; 
  listingId?: string | null; 
  message?: string | null; 
  price?: core_apimessages_Money | null; 
  pushToExisting?: boolean | null; 
  percentage?: number | null; 
}

export interface core_apimessages_BumpKey {
  key?: string | null; 
}

export interface reverb_search_BumpRecommendationsResults {
  bumpRecommendationAmount?: number | null; 
  maxBumpRecommendationAmount?: number | null; 
}

export interface arbiter_BumpInteractionCountsResponse {
  listingId?: string | null; 
  click?: number | null; 
  addToWatchlist?: number | null; 
  addToCart?: number | null; 
  makeAnOffer?: number | null; 
  total?: number | null; 
  messageSeller?: number | null; 
}

export interface reverb_pricing_PriceRecommendation {
  canonicalProductId?: string | null; 
  conditionUuid?: string | null; 
  priceLow?: reverb_pricing_Money | null; 
  priceHigh?: reverb_pricing_Money | null; 
  priceMiddle?: reverb_pricing_Money | null; 
  priceLowThirtyDaysAgo?: reverb_pricing_Money | null; 
  priceHighThirtyDaysAgo?: reverb_pricing_Money | null; 
  priceMiddleThirtyDaysAgo?: reverb_pricing_Money | null; 
  countryCode?: string | null; 
  comparisonShoppingPageId?: string | null; 
}

export interface reverb_pricing_Money {
  amount?: string | null; 
  amountCents?: number | null; 
  currency?: string | null; 
  symbol?: string | null; 
  display?: string | null; 
}

export interface reverb_signals_Signal {
  name?: reverb_signals_Signal_Name | null; 
  group?: reverb_signals_Signal_Group | null; 
  slot?: reverb_signals_Signal_Slot | null; 
  title?: string | null; 
  subtitle?: string | null; 
  tooltipText?: string | null; 
  link?: reverb_signals_SignalLink | null; 
  icon?: string | null; 
}

export interface reverb_signals_SignalLink {
  url?: string | null; 
  text?: string | null; 
}

export interface ShipmentPackage extends INode {
  _id?: string | null; 
  length?: core_apimessages_Measurement | null; 
  height?: core_apimessages_Measurement | null; 
  width?: core_apimessages_Measurement | null; 
  weight?: core_apimessages_Measurement | null; 
  predefinedPackage?: string | null; 
  id?: string | null; 
}

export interface core_apimessages_Measurement {
  value?: string | null; 
  unit?: string | null; 
}

export interface core_apimessages_NonUserExperiment {
  name?: string | null; 
  bucket?: string | null; 
}

export interface core_apimessages_PriceGuide {
  id?: string | null; 
  title?: string | null; 
  webLink?: core_apimessages_Link | null; 
  priceLow?: core_apimessages_Money | null; 
  priceHigh?: core_apimessages_Money | null; 
  uuid?: string | null; 
}

export interface core_apimessages_CspVariant {
  id?: string | null; 
  name?: string | null; 
  model?: string | null; 
  year?: string | null; 
  finish?: string | null; 
  countryOfOrigin?: string | null; 
}

export interface core_apimessages_CSPExpressSaleItemBid {
  cspUuid?: string | null; 
  estimatedPayout?: core_apimessages_Money | null; 
  carrier?: string | null; 
  bidId?: string | null; 
  shopName?: string | null; 
}

export interface Negotiation extends INode {
  _id?: string | null; 
  id?: string | null; 
  state?: core_apimessages_NegotiationState | null; 
  buyerUuid?: string | null; 
  sellerUuid?: string | null; 
  expiresAt?: google_protobuf_Timestamp | null; 
  orderUuids?: (string | null)[] | null; 
  lastOffer?: core_apimessages_Offer | null; 
  taxIncluded?: boolean | null; 
  taxIncludedHint?: string | null; 
  buyerOutsideListingShippingRegions?: boolean | null; 
  negotiationType?: core_apimessages_NegotiationType | null; 
  sellerShippingWarning?: string | null; 
  buyer?: User | null; 
  seller?: User | null; 
  orders?: (Order | null)[] | null; 
  offers?: (core_apimessages_Offer | null)[] | null; 
  shippingLocation?: core_apimessages_Address | null; 
  orderHistory?: reverb_search_SearchResponse | null; 
}

export interface core_apimessages_Offer {
  offerItems?: (core_apimessages_OfferItem | null)[] | null; 
  message?: string | null; 
  prices?: core_apimessages_OfferPrices | null; 
  createdAt?: google_protobuf_Timestamp | null; 
  initiatingParty?: core_apimessages_NegotiationParty | null; 
  status?: core_apimessages_Offer_OfferStatus | null; 
  shippingMethod?: core_apimessages_ShippingMethod | null; 
  layawayTerms?: core_apimessages_LayawayTerms | null; 
}

export interface core_apimessages_OfferItem {
  listingId?: string | null; 
  prices?: core_apimessages_OfferPrices | null; 
  quantity?: number | null; 
  listing?: Listing | null; 
}

export interface core_apimessages_OfferPrices {
  price?: core_apimessages_ConvertedMoney | null; 
  shippingPrice?: core_apimessages_ConvertedMoney | null; 
  totalPrice?: core_apimessages_ConvertedMoney | null; 
}

export interface core_apimessages_LayawayTerms {
  name?: string | null; 
  percentDown?: number | null; 
  timePeriod?: google_protobuf_Duration | null; 
}

export interface google_protobuf_Duration {
  seconds?: number | null; 
  nanos?: number | null; 
}

export interface Article extends INode {
  _id?: string | null; 
  id?: string | null; 
  title?: string | null; 
  webLink?: core_apimessages_Link | null; 
  articleCategories?: (core_apimessages_ArticleCategory | null)[] | null; 
  slug?: string | null; 
  images?: (core_apimessages_Image | null)[] | null; 
  categories?: (core_apimessages_Category | null)[] | null; 
}

export interface core_apimessages_ArticleCategory {
  id?: string | null; 
  name?: string | null; 
  slug?: string | null; 
}

export interface GearCollectionItem extends INode {
  _id?: string | null; 
  id?: string | null; 
  deleted?: boolean | null; 
  title?: string | null; 
  make?: string | null; 
  model?: string | null; 
  finish?: string | null; 
  year?: string | null; 
  price?: core_apimessages_Money | null; 
  description?: string | null; 
  notes?: string | null; 
  canonicalProductId?: string | null; 
  ownerCost?: core_apimessages_Money | null; 
  serialNumber?: string | null; 
  created?: boolean | null; 
  updated?: boolean | null; 
  condition?: core_apimessages_Condition | null; 
  tags?: (core_apimessages_GearCollectionItemTag | null)[] | null; 
  hideListingPhotos?: boolean | null; 
  hideListingDescription?: boolean | null; 
  seedId?: string | null; 
  seedType?: core_apimessages_GearCollectionItem_SeedType | null; 
  categories?: (Category | null)[] | null; 
  listing?: Listing | null; 
  csp?: CSP | null; 
  images?: (core_apimessages_Image | null)[] | null; 
  priceGuide?: PriceGuide | null; 
  esPriceEstimate?: reverb_search_PriceEstimate | null; 
  dataServicesPriceEstimate?: reverb_pricing_PriceRecommendation | null; 
  originalListing?: Listing | null; 
}

export interface core_apimessages_GearCollectionItemTag {
  id?: string | null; 
  name?: string | null; 
}

export interface CMSPage extends INode {
  _id?: string | null; 
  id?: string | null; 
  slug?: string | null; 
  goLiveAt?: string | null; 
  title?: string | null; 
  description?: string | null; 
  metaTitle?: string | null; 
  metaDescription?: string | null; 
  componentIds?: (string | null)[] | null; 
  imageAttributionUri?: string | null; 
  image?: cms_PageImage | null; 
  authorId?: string | null; 
  pageType?: string | null; 
  authorName?: string | null; 
  albumIds?: (string | null)[] | null; 
  channels?: (string | null)[] | null; 
  locale?: string | null; 
  layoutId?: string | null; 
  layoutSlug?: string | null; 
  metaImage?: cms_PageImage | null; 
  headerStyle?: string | null; 
  actionText?: string | null; 
  actionUrl?: string | null; 
  searchPlaceholder?: string | null; 
  noIndex?: boolean | null; 
  secondaryImage?: cms_PageImage | null; 
  live?: boolean | null; 
  pageNotFound?: boolean | null; 
  targetLocales?: (string | null)[] | null; 
  breadcrumbs?: string | null; 
  components?: (PublicComponent | null)[] | null; 
}

export interface cms_PageImage {
  imageUrl?: string | null; 
}

export interface PublicComponent extends INode {
  _id?: string | null; 
  id?: string | null; 
  pageId?: string | null; 
  position?: number | null; 
  componentType?: string | null; 
  data?: string | null; 
  layoutSection?: string | null; 
  active?: boolean | null; 
  experimentKey?: string | null; 
  experimentBucket?: string | null; 
  title?: string | null; 
  subtitle?: string | null; 
  searchUrlParams?: string | null; 
  searchSort?: string | null; 
  searchType?: cms_PublicComponent_SearchType | null; 
  entities?: (rql_PublicComponentEntity | null)[] | null; 
}

export interface rql_PublicComponentEntity {
  id?: string | null; 
  type?: string | null; 
  entity?: PublicComponentEntity | null; 
}

export interface reverb_search_Completion {
  text?: string | null; 
  options?: (reverb_search_SuggestOption | null)[] | null; 
  type?: reverb_search_CompletionType | null; 
}

export interface reverb_search_SuggestOption {
  text?: string | null; 
  output?: string | null; 
  cspPayload?: reverb_search_SuggestOption_CSPPayload | null; 
  corePayload?: reverb_search_SuggestOption_CorePayload | null; 
  lpPayload?: reverb_search_SuggestOption_LPPayload | null; 
  completionPayload?: reverb_search_SuggestOption_CompletionPayload | null; 
  score?: number | null; 
  id?: string | null; 
  slug?: string | null; 
  scope?: reverb_search_SuggestOptionScope | null; 
  scopes?: (reverb_search_SuggestOptionScope | null)[] | null; 
}

export interface reverb_search_SuggestOption_CSPPayload {
  title?: string | null; 
  categories?: (string | null)[] | null; 
  primaryImage?: string | null; 
}

export interface reverb_search_SuggestOption_CorePayload {
  type?: string | null; 
  uuid?: string | null; 
  filter?: string | null; 
  filters?: (reverb_search_SuggestOption_CoreFilter | null)[] | null; 
  params?: reverb_search_SuggestOption_CorePayloadParams | null; 
}

export interface reverb_search_SuggestOption_CoreFilter {
  name?: string | null; 
  type?: string | null; 
  count?: number | null; 
  params?: reverb_search_SuggestOption_CorePayloadParams | null; 
}

export interface reverb_search_SuggestOption_CorePayloadParams {
  productType?: string | null; 
  query?: string | null; 
  categoryUuid?: string | null; 
  brandSlug?: string | null; 
  shop?: string | null; 
  id?: string | null; 
  category?: string | null; 
  curatedSetSlug?: string | null; 
}

export interface reverb_search_SuggestOption_LPPayload {
  type?: string | null; 
  params?: reverb_search_SuggestOption_LPParams | null; 
  metadata?: reverb_search_SuggestOption_LPMetadata | null; 
}

export interface reverb_search_SuggestOption_LPParams {
  artist?: string | null; 
  label?: string | null; 
  album?: string | null; 
}

export interface reverb_search_SuggestOption_LPMetadata {
  primaryImageUuid?: string | null; 
  artistName?: string | null; 
  labelName?: string | null; 
  releaseDate?: string | null; 
  formatDescriptions?: (string | null)[] | null; 
}

export interface reverb_search_SuggestOption_CompletionPayload {
  thumbnailUrl?: string | null; 
  inventoryNew?: reverb_search_Inventory | null; 
  inventoryUsed?: reverb_search_Inventory | null; 
}

export interface reverb_search_Inventory {
  listingCount?: number | null; 
  listingMinPrice?: reverb_search_Money | null; 
}

export interface reverb_search_SuggestOptionScope {
  id?: string | null; 
  slug?: string | null; 
  output?: string | null; 
  type?: reverb_search_SuggestOptionScope_Type | null; 
}

export interface reverb_search_BestListing {
  key?: string | null; 
  id?: string | null; 
}

export interface reverb_search_Filter {
  name?: string | null; 
  options?: (reverb_search_FilterOption | null)[] | null; 
  widgetType?: reverb_search_Filter_WidgetType | null; 
  aggregationName?: string | null; 
  key?: string | null; 
}

export interface reverb_search_FilterOption {
  name?: string | null; 
  optionValue?: string | null; 
  selected?: boolean | null; 
  paramName?: string | null; 
  setValues?: (string | null)[] | null; 
  unsetValues?: (string | null)[] | null; 
  count?: google_protobuf_Int32Value | null; 
  all?: boolean | null; 
  subFilter?: reverb_search_Filter | null; 
  urlParamName?: string | null; 
  autoselected?: boolean | null; 
  trackingValue?: string | null; 
}

export interface google_protobuf_Int32Value {
  value?: number | null; 
}

export interface reverb_search_TopCollectionsResult {
  brandUuids?: (string | null)[] | null; 
  categoryUuids?: (string | null)[] | null; 
  categories?: (Category | null)[] | null; 
  brands?: (Brand | null)[] | null; 
}

export interface reverb_search_OrderMetrics {
  totalAmountProductCentsUsd?: number | null; 
  averageProductPriceCentsUsd?: number | null; 
  topCsps?: (reverb_search_TopCSP | null)[] | null; 
  orderCount?: number | null; 
  totalAmountProductCentsUsdDouble?: number | null; 
  totalSellerRevenueAmount?: reverb_search_Money | null; 
  totalBumpSpendAmount?: reverb_search_Money | null; 
}

export interface reverb_search_TopCSP {
  count?: number | null; 
  id?: string | null; 
  CSP?: CSP | null; 
}

export interface reverb_search_DateBucket {
  fromDate?: string | null; 
  toDate?: string | null; 
  metrics?: reverb_search_OrderMetrics | null; 
}

export interface reverb_search_PriceStatsResults {
  purchasePrice?: reverb_search_PriceStatsResult | null; 
  publicPrice?: reverb_search_PriceStatsResult | null; 
  docCount?: number | null; 
}

export interface reverb_search_PriceStatsResult {
  middle?: reverb_search_Money | null; 
}

export interface reverb_search_GearCollectionStats {
  totalCollectionEstimate?: reverb_search_GearCollectionTotalEstimate | null; 
}

export interface reverb_search_GearCollectionTotalEstimate {
  totalEstimateLow?: reverb_search_Money | null; 
  totalEstimateHigh?: reverb_search_Money | null; 
}

export interface reverb_search_SearchResponse_TotalHits {
  value?: number | null; 
  relation?: reverb_search_SearchResponse_TotalHits_Relation | null; 
}

export interface reverb_search_SearchResponse_Suggestion {
  text?: string | null; 
  score?: number | null; 
  frequency?: number | null; 
}

export interface reverb_search_AverageMonthlyProductPrice {
  date?: string | null; 
  averageProductPriceInUsd?: reverb_search_Money | null; 
  docCount?: number | null; 
}

export interface reverb_search_QuerySpellCorrection {
  correction?: string | null; 
}

export interface rql_PageMetadata {
  mainClause?: string | null; 
  prefixClause?: string | null; 
  hasSubjectClause?: boolean | null; 
  fallbackSubject?: string | null; 
  inPreposition?: string | null; 
  collectionClause?: string | null; 
}

export interface PublicPriceRecord extends INode {
  _id?: string | null; 
  uuid?: string | null; 
  listingId?: string | null; 
  createdAt?: google_protobuf_Timestamp | null; 
  settlementAmountProductSubtotal?: core_apimessages_Money | null; 
  orderType?: string | null; 
  amountProduct?: core_apimessages_Money | null; 
  amountTotal?: core_apimessages_Money | null; 
  amountTax?: core_apimessages_Money | null; 
  amountShipping?: core_apimessages_Money | null; 
  condition?: core_apimessages_Condition | null; 
}

export interface reverb_search_ListingsAggregationResponse {
  aggregationResults?: (reverb_search_AggregationResult | null)[] | null; 
  topCollections?: reverb_search_TopCollectionsResult | null; 
  shops?: (Shop | null)[] | null; 
}

export interface reverb_search_AggregationResult {
  name?: reverb_search_ListingsSearchRequest_Aggregation | null; 
  aggregationDetails?: (reverb_search_AggregationDetails | null)[] | null; 
  displayName?: string | null; 
}

export interface reverb_search_AggregationDetails {
  key?: string | null; 
  count?: number | null; 
  displayName?: string | null; 
}

export interface reverb_search_ShippingRegionFilterResponse {
  filter?: reverb_search_Filter | null; 
}

export interface WatchCollection {
  _ids?: (string | null)[] | null; 
  nodes?: (Watch | null)[] | null; 
  pageInfo?: rql_PageInfo | null; 
}

export interface Watch extends INode {
  _id?: string | null; 
  listing?: Listing | null; 
}

export interface reverb_config_cache_CurrencyResponse {
  rates?: (reverb_config_cache_ExchangeRate | null)[] | null; 
}

export interface reverb_config_cache_ExchangeRate {
  from?: string | null; 
  to?: string | null; 
  rate?: number | null; 
}

export interface Artist extends INode {
  _id?: string | null; 
  uuid?: string | null; 
  name?: string | null; 
  slug?: string | null; 
  featuredAlbumIds?: (string | null)[] | null; 
  bannerImageKey?: string | null; 
  featuredAlbums?: (lp_Album | null)[] | null; 
}

export interface lp_Album {
  artistSlug?: string | null; 
  artistUuid?: string | null; 
  catalogNumbers?: (string | null)[] | null; 
  collaborators?: (lp_Collaborator | null)[] | null; 
  companies?: (lp_Company | null)[] | null; 
  editorialContent?: string | null; 
  formatDescriptions?: (string | null)[] | null; 
  hasLiveListings?: boolean | null; 
  id?: string | null; 
  identifiers?: (lp_Identifier | null)[] | null; 
  labelName?: string | null; 
  labelSlug?: string | null; 
  labelUuid?: string | null; 
  labelWeight?: number | null; 
  listingCount?: number | null; 
  lowestPriceCents?: number | null; 
  notes?: string | null; 
  releaseDate?: string | null; 
  releaseUuids?: (string | null)[] | null; 
  slug?: string | null; 
  title?: string | null; 
  tracks?: (lp_Track | null)[] | null; 
  uuid?: string | null; 
  artistName?: string | null; 
  highestPrice?: lp_Price | null; 
  lowestPrice?: lp_Price | null; 
  releaseCount?: number | null; 
  artists?: (lp_AlbumArtist | null)[] | null; 
  images?: (lp_LPImage | null)[] | null; 
  attributionId?: string | null; 
  genres?: (string | null)[] | null; 
  deletedAt?: string | null; 
}

export interface CartItem extends INode {
  _id?: string | null; 
  uuid?: string | null; 
  listingId?: string | null; 
  orderId?: string | null; 
  subtotal?: core_apimessages_Money | null; 
  shopId?: string | null; 
  quantity?: number | null; 
  listing?: Listing | null; 
  order?: Order | null; 
}

export interface CollectionHeader extends INode {
  _id?: string | null; 
  id?: string | null; 
  title?: string | null; 
  description?: string | null; 
  metaTitle?: string | null; 
  metaDescription?: string | null; 
  collectionType?: core_apimessages_CollectionHeader_CollectionType | null; 
  collectionId?: string | null; 
  fullBleedImage?: core_apimessages_Image | null; 
  searchFilterPresets?: (core_apimessages_SearchFilterPreset | null)[] | null; 
  sale?: core_apimessages_Sale | null; 
}

export interface core_apimessages_SearchFilterPreset {
  collectionId?: string | null; 
  collectionType?: string | null; 
  title?: string | null; 
  url?: string | null; 
  id?: string | null; 
  image?: core_apimessages_Image | null; 
}

export interface Checkout extends INode {
  _id?: string | null; 
  id?: string | null; 
  checkoutBundlingId?: string | null; 
  paymentMethod?: core_apimessages_CheckoutPaymentMethod | null; 
  shippingAddress?: core_apimessages_Address | null; 
  billingAddress?: core_apimessages_Address | null; 
  orders?: (core_apimessages_CheckoutOrder | null)[] | null; 
  lineItems?: (core_apimessages_CheckoutLineItem | null)[] | null; 
  status?: core_apimessages_Checkout_Status | null; 
  paymentErrorMessage?: string | null; 
  type?: core_apimessages_Checkout_Type | null; 
  creditCard?: core_apimessages_CreditCard | null; 
  guest?: core_apimessages_CheckoutGuest | null; 
  adyenPaymentAction?: string | null; 
  orderBundle?: OrderBundle | null; 
  action?: CheckoutAction | null; 
}

export interface core_apimessages_CheckoutPaymentMethod {
  type?: core_apimessages_CheckoutPaymentMethod_Type | null; 
  name?: string | null; 
  isComplete?: boolean | null; 
  supportsDiscountCodes?: boolean | null; 
}

export interface core_apimessages_CheckoutOrder {
  id?: string | null; 
  listingId?: string | null; 
  subtotal?: core_apimessages_CheckoutOrder_Subtotal | null; 
  shippingTotal?: core_apimessages_CheckoutOrder_ShippingTotal | null; 
  taxIncluded?: boolean | null; 
  taxLabel?: string | null; 
  shippingMethod?: core_apimessages_CheckoutShippingMethod | null; 
  quantity?: number | null; 
  buyerCanChangeQuantity?: boolean | null; 
  cannotBeShippedToAddress?: boolean | null; 
  availableShippingMethods?: (core_apimessages_CheckoutShippingMethod | null)[] | null; 
  listing?: Listing | null; 
}

export interface core_apimessages_CheckoutOrder_Subtotal {
  listingPrice?: core_apimessages_Money | null; 
  discounted?: boolean | null; 
  discount?: core_apimessages_CheckoutOrder_SubtotalDiscount | null; 
}

export interface core_apimessages_CheckoutOrder_SubtotalDiscount {
  type?: core_apimessages_CheckoutOrder_SubtotalDiscount_Type | null; 
  label?: string | null; 
}

export interface core_apimessages_CheckoutOrder_ShippingTotal {
  originalAmountOwed?: core_apimessages_Money | null; 
  amountOwed?: core_apimessages_Money | null; 
  discounted?: boolean | null; 
  discount?: core_apimessages_CheckoutOrder_ShippingTotalDiscount | null; 
}

export interface core_apimessages_CheckoutOrder_ShippingTotalDiscount {
  type?: core_apimessages_CheckoutOrder_ShippingTotalDiscount_Type | null; 
  label?: string | null; 
}

export interface core_apimessages_CheckoutShippingMethod {
  type?: core_apimessages_ShippingMethod | null; 
  name?: string | null; 
  description?: string | null; 
  amount?: core_apimessages_Money | null; 
}

export interface core_apimessages_CheckoutLineItem {
  type?: core_apimessages_CheckoutLineItem_Type | null; 
  label?: string | null; 
  amount?: core_apimessages_Money | null; 
}

export interface core_apimessages_CreditCard {
  id?: string | null; 
  last4?: string | null; 
  cardType?: string | null; 
  expirationMonth?: string | null; 
  expirationYear?: string | null; 
  cardholderName?: string | null; 
  cardSource?: string | null; 
  primaryBilling?: boolean | null; 
  address?: core_apimessages_Address | null; 
  needsReverification?: boolean | null; 
  primaryForCheckout?: boolean | null; 
  brand?: core_apimessages_CreditCard_Brand | null; 
  display?: core_apimessages_CreditCard_Display | null; 
}

export interface core_apimessages_CreditCard_Brand {
  type?: core_apimessages_CreditCard_Brand_Type | null; 
  name?: string | null; 
}

export interface core_apimessages_CreditCard_Display {
  summary?: string | null; 
  expirationDate?: string | null; 
}

export interface core_apimessages_CheckoutGuest {
  firstName?: string | null; 
  lastName?: string | null; 
  email?: string | null; 
  isComplete?: boolean | null; 
}

export interface OrderBundle extends INode {
  _id?: string | null; 
  amountTotal?: core_apimessages_Money | null; 
  amountProductSubtotal?: core_apimessages_Money | null; 
  amountShipping?: core_apimessages_Money | null; 
  amountCredit?: core_apimessages_Money | null; 
  amountTax?: core_apimessages_Money | null; 
  bonusBucks?: core_apimessages_Money | null; 
  paymentMethod?: core_apimessages_Payment_PaymentMethod | null; 
  uuid?: string | null; 
  localPickup?: boolean | null; 
  id?: string | null; 
  shippingAddress?: core_apimessages_Address | null; 
  orders?: OrderCollection | null; 
}

export interface CheckoutAction extends INode {
  _id?: string | null; 
  type?: core_apimessages_CheckoutAction_Type | null; 
  redirectUrl?: string | null; 
}

export interface ExpressSaleCheckout extends INode {
  _id?: string | null; 
  checkoutId?: string | null; 
  cspId?: string | null; 
  status?: core_apimessages_ExpressSaleCheckout_Status | null; 
  expressSaleItemBid?: core_apimessages_CSPExpressSaleItemBid | null; 
  csp?: CSP | null; 
}

export interface MyShop extends INode {
  _id?: string | null; 
  ordersSearch?: reverb_search_SearchResponse | null; 
  uuid?: string | null; 
  name?: string | null; 
  slug?: string | null; 
  currency?: string | null; 
  shopType?: core_apimessages_Shop_ShopType | null; 
  paymentPolicy?: string | null; 
  shippingPolicy?: string | null; 
  id?: string | null; 
  preferredSeller?: boolean | null; 
  quickShipper?: boolean | null; 
  quickResponder?: boolean | null; 
  userUuid?: string | null; 
  onVacation?: boolean | null; 
  description?: string | null; 
  userId?: string | null; 
  website?: string | null; 
  showSold?: boolean | null; 
  vatId?: string | null; 
  recentlyShipped?: boolean | null; 
  quickShipperSpeed?: core_apimessages_Shop_QuickShipperSpeed | null; 
  createdAt?: Timestamp | null; 
  defaultLocale?: string | null; 
  currencySetting?: string | null; 
  shippingRegionSettings?: (core_apimessages_ShippingRegionSetting | null)[] | null; 
  sameDayShippingConfigured?: boolean | null; 
  listableConditions?: (core_apimessages_Condition | null)[] | null; 
  offerPolicy?: core_apimessages_Shop_OfferPolicy | null; 
  shopSupportedLocaleCodes?: (string | null)[] | null; 
  billingMethodStatus?: core_apimessages_MyShopOnboardingResponse_BillingMethodStatus | null; 
  originCountryCode?: string | null; 
  paypalSetupStatus?: core_apimessages_MyShopOnboardingResponse_PaypalSetupStatus | null; 
  paymentMethod?: core_apimessages_MyShopOnboardingResponse_PaymentMethod | null; 
  address?: core_apimessages_Address | null; 
  kycAccountDetails?: core_apimessages_KYCAccountDetails | null; 
  returnPolicy?: core_apimessages_ReturnPolicy | null; 
  paypalProfile?: core_apimessages_MyShopPaypalProfileResponse_PaypalProfile | null; 
  shippingProfiles?: (core_apimessages_MyShippingProfile | null)[] | null; 
  packlink?: core_apimessages_MyPacklinkAccountStatusResponse | null; 
  interactions?: arbiter_SellerInteractionTimeSeriesResponse | null; 
  taxIdentifications?: (core_apimessages_TaxIdentification | null)[] | null; 
  listings?: reverb_search_SearchResponse | null; 
  orderRefundStats?: core_apimessages_MyShopOrderRefundStatsResponse | null; 
}

export interface core_apimessages_KYCAccountDetails {
  bankAccountOwnerName?: string | null; 
  maskedBankAccountNumber?: string | null; 
  bankAccountCountryCode?: string | null; 
  bankAccountCurrencyCode?: string | null; 
  bankAccountOwnerAddress?: core_apimessages_KYCAddress | null; 
  personalInformation?: (core_apimessages_PersonalInformation | null)[] | null; 
  businessTaxId?: string | null; 
  legalBusinessName?: string | null; 
  accountPhoneNumber?: core_apimessages_AdyenPhoneNumber | null; 
  businessRegistrationNumber?: string | null; 
  accountHolderAddress?: core_apimessages_KYCAddress | null; 
  legalEntity?: core_apimessages_AdyenLegalEntity | null; 
  parentCompanyDetails?: core_apimessages_AdyenParentCompanyDetails | null; 
}

export interface core_apimessages_KYCAddress {
  streetAddress?: string | null; 
  postalCode?: string | null; 
  region?: string | null; 
  locality?: string | null; 
  countryCode?: string | null; 
  houseNumber?: string | null; 
}

export interface core_apimessages_PersonalInformation {
  firstName?: string | null; 
  lastName?: string | null; 
  dateOfBirth?: core_apimessages_Date | null; 
  phoneNumber?: string | null; 
  idNumber?: string | null; 
  email?: string | null; 
  address?: core_apimessages_KYCAddress | null; 
  maskedIdNumber?: string | null; 
  shareholderType?: core_apimessages_PersonalInformation_AdyenShareholderType | null; 
  jobTitle?: string | null; 
}

export interface core_apimessages_Date {
  day?: string | null; 
  month?: string | null; 
  year?: string | null; 
}

export interface core_apimessages_AdyenPhoneNumber {
  phoneNumber?: string | null; 
  countryCode?: string | null; 
}

export interface core_apimessages_AdyenParentCompanyDetails {
  stockExchange?: string | null; 
  stockNumber?: string | null; 
  stockTicker?: string | null; 
  legalBusinessName?: string | null; 
  registrationNumber?: string | null; 
  countryCode?: string | null; 
  companyCode?: string | null; 
}

export interface core_apimessages_MyShopPaypalProfileResponse_PaypalProfile {
  email?: string | null; 
}

export interface core_apimessages_MyShippingProfile {
  id?: string | null; 
  name?: string | null; 
  categoryUuids?: (string | null)[] | null; 
  localPickup?: boolean | null; 
  offersIncrementalRates?: boolean | null; 
  shippingRates?: (core_apimessages_ShippingRates | null)[] | null; 
}

export interface core_apimessages_MyPacklinkAccountStatusResponse {
  account?: core_apimessages_PacklinkAccount | null; 
}

export interface core_apimessages_PacklinkAccount {
  id?: string | null; 
  email?: string | null; 
  status?: core_apimessages_PacklinkAccount_Status | null; 
}

export interface arbiter_SellerInteractionTimeSeriesResponse {
  data?: (arbiter_InteractionTimeSeriesMetric | null)[] | null; 
  click?: number | null; 
  addToWatchlist?: number | null; 
  addToCart?: number | null; 
  makeAnOffer?: number | null; 
  total?: number | null; 
  messageSeller?: number | null; 
}

export interface arbiter_InteractionTimeSeriesMetric {
  date?: string | null; 
  click?: number | null; 
  addToWatchlist?: number | null; 
  addToCart?: number | null; 
  makeAnOffer?: number | null; 
  total?: number | null; 
  messageSeller?: number | null; 
}

export interface core_apimessages_TaxIdentification {
  id?: string | null; 
  taxId?: string | null; 
  status?: core_apimessages_TaxIdentification_Status | null; 
  taxType?: core_apimessages_TaxIdentification_TaxType | null; 
  countryCode?: string | null; 
  active?: boolean | null; 
}

export interface core_apimessages_MyShopOrderRefundStatsResponse {
  sellerInitiatedRefundCount?: number | null; 
}

export interface Page extends INode {
  _id?: string | null; 
}

export interface Sale extends INode {
  _id?: string | null; 
  id?: string | null; 
  slug?: string | null; 
  name?: string | null; 
  code?: string | null; 
  startsAt?: google_protobuf_Timestamp | null; 
  endsAt?: google_protobuf_Timestamp | null; 
  summary?: string | null; 
  state?: core_apimessages_Sale_SaleState | null; 
  display?: string | null; 
  withSalePriceDisplay?: string | null; 
  percent?: number | null; 
  buyerIneligibilityReason?: string | null; 
  saleType?: string | null; 
  showCode?: boolean | null; 
  shopSlug?: string | null; 
  shopName?: string | null; 
  links?: core_apimessages_SaleLinks | null; 
}

export interface SellerCheckout extends INode {
  _id?: string | null; 
  ordersForShipmentSearch?: reverb_search_SearchResponse | null; 
  verifiedShippingAddress?: core_apimessages_OrderVerifyShippingAddressResponse | null; 
  flatRateShippingOptions?: core_apimessages_OrderFlatRateShippingOptionsResponse | null; 
}

export interface Shipment extends INode {
  _id?: string | null; 
  toAddress?: core_apimessages_Address | null; 
  fromAddress?: core_apimessages_Address | null; 
  package?: core_apimessages_ShippingLabelPackage | null; 
  shippingProtection?: boolean | null; 
  signatureRequired?: boolean | null; 
  mediaMailQualified?: boolean | null; 
  defaultPaymentMethod?: core_apimessages_FeePaymentMethod | null; 
  carrierRates?: (core_apimessages_CarrierRateGroup | null)[] | null; 
  shippingMethod?: core_apimessages_ShippingMethod | null; 
  id?: string | null; 
  orderUuids?: (string | null)[] | null; 
  shippingProtectionPrice?: core_apimessages_Money | null; 
  toAddressIsResidential?: boolean | null; 
  orders?: (Order | null)[] | null; 
}

export interface core_apimessages_ShippingLabelPackage {
  length?: core_apimessages_Measurement | null; 
  height?: core_apimessages_Measurement | null; 
  width?: core_apimessages_Measurement | null; 
  weight?: core_apimessages_Measurement | null; 
  predefinedPackage?: string | null; 
  id?: string | null; 
}

export interface core_apimessages_CarrierRateGroup {
  displayPosition?: number | null; 
  carrier?: string | null; 
  rates?: (core_apimessages_CarrierRate | null)[] | null; 
}

export interface core_apimessages_CarrierRate {
  displayPosition?: number | null; 
  uuid?: string | null; 
  carrier?: string | null; 
  service?: string | null; 
  description?: string | null; 
  paymentMethod?: core_apimessages_FeePaymentMethod | null; 
  rackRateAmount?: core_apimessages_Money | null; 
  shippingProtectionAmount?: core_apimessages_Money | null; 
  reverbDiscountAmount?: core_apimessages_Money | null; 
  totalAmount?: core_apimessages_Money | null; 
  signatureRequiredAmount?: core_apimessages_Money | null; 
}

export interface Storefront extends INode {
  _id?: string | null; 
  channel?: string | null; 
  slug?: string | null; 
  name?: string | null; 
  shopUuid?: string | null; 
  id?: string | null; 
  description?: string | null; 
  shippingPolicy?: string | null; 
  shop?: Shop | null; 
  curatedSets?: (core_apimessages_CuratedSet | null)[] | null; 
  returnPolicy?: core_apimessages_ReturnPolicy | null; 
  banner?: core_apimessages_Image | null; 
}

export interface core_apimessages_CuratedSet {
  id?: string | null; 
  title?: string | null; 
  webLink?: core_apimessages_Link | null; 
  slug?: string | null; 
  setType?: string | null; 
}

export interface SiteBanner extends INode {
  _id?: string | null; 
  id?: string | null; 
  heading?: string | null; 
  subheading?: string | null; 
  callToAction?: string | null; 
  url?: core_apimessages_Link | null; 
  mobileUrl?: core_apimessages_Link | null; 
  mobileWebUrl?: core_apimessages_Link | null; 
  imageUrl?: string | null; 
  webOnly?: boolean | null; 
  mobileImageUrl?: string | null; 
  startsAt?: Timestamp | null; 
  endsAt?: Timestamp | null; 
  contentSponsorship?: core_apimessages_ContentSponsorship | null; 
  downtime?: boolean | null; 
  hasPhotos?: boolean | null; 
  showOnMobile?: boolean | null; 
  showOnMyUpdates?: boolean | null; 
}

export interface core_apimessages_ContentSponsorship {
  sponsorshipType?: core_apimessages_ContentSponsorship_SponsorshipType | null; 
  partnershipName?: string | null; 
}

export interface PriceChange extends INode {
  _id?: string | null; 
  id?: string | null; 
  listingId?: string | null; 
  previousPrice?: core_apimessages_Money | null; 
  newPrice?: core_apimessages_Money | null; 
  currentPriceDropPercent?: number | null; 
  totalPriceDropPercent?: number | null; 
  listing?: Listing | null; 
}

export interface MyUpdate extends INode {
  _id?: string | null; 
}

export interface MyUpdatesPromotion extends INode {
  _id?: string | null; 
  id?: string | null; 
  title?: string | null; 
  subtitle?: string | null; 
  url?: core_apimessages_Link | null; 
  startsAt?: Timestamp | null; 
  images?: (core_apimessages_Image | null)[] | null; 
}

export interface Advertiser extends INode {
  _id?: string | null; 
  uuid?: string | null; 
  name?: string | null; 
  brandSlugs?: (string | null)[] | null; 
  shopSlugs?: (string | null)[] | null; 
  adCampaignCollection?: AdCampaignCollection | null; 
}

export interface AdCampaignCollection {
  _ids?: (string | null)[] | null; 
  nodes?: (AdCampaign | null)[] | null; 
  pageInfo?: rql_PageInfo | null; 
  adCampaigns?: (AdCampaign | null)[] | null; 
}

export interface AdCampaign extends INode {
  _id?: string | null; 
  uuid?: string | null; 
  name?: string | null; 
  description?: string | null; 
  status?: core_apimessages_AdCampaign_AdStatus | null; 
  startsAt?: Timestamp | null; 
  endsAt?: Timestamp | null; 
  advertiserUuid?: string | null; 
  adGroupCollection?: AdGroupCollection | null; 
}

export interface AdGroupCollection {
  _ids?: (string | null)[] | null; 
  nodes?: (AdGroup | null)[] | null; 
  pageInfo?: rql_PageInfo | null; 
  adGroups?: (AdGroup | null)[] | null; 
}

export interface AdGroup extends INode {
  _id?: string | null; 
  uuid?: string | null; 
  name?: string | null; 
  description?: string | null; 
  status?: core_apimessages_AdGroup_AdStatus | null; 
  adCampaignUuid?: string | null; 
  targetedCountryCodes?: (string | null)[] | null; 
  targetedCategoryUuids?: (string | null)[] | null; 
  targetedAdZoneSlugs?: (string | null)[] | null; 
  targetedAdZones?: (core_apimessages_AdGroupZone | null)[] | null; 
  targetedDevices?: (string | null)[] | null; 
  targetedBrandSlugs?: (string | null)[] | null; 
  adGroupKeywords?: (core_apimessages_AdGroupKeyword | null)[] | null; 
  adCollection?: AdCollection | null; 
  adZoneCollection?: AdZoneCollection | null; 
}

export interface core_apimessages_AdGroupZone {
  adGroup?: core_apimessages_AdGroup | null; 
  adZone?: core_apimessages_AdZone | null; 
  startsAt?: Timestamp | null; 
  endsAt?: Timestamp | null; 
}

export interface core_apimessages_AdGroup {
  uuid?: string | null; 
  name?: string | null; 
  description?: string | null; 
  status?: core_apimessages_AdGroup_AdStatus | null; 
  adCampaignUuid?: string | null; 
  targetedCountryCodes?: (string | null)[] | null; 
  targetedCategoryUuids?: (string | null)[] | null; 
  targetedAdZoneSlugs?: (string | null)[] | null; 
  targetedAdZones?: (core_apimessages_AdGroupZone | null)[] | null; 
  targetedDevices?: (string | null)[] | null; 
  targetedBrandSlugs?: (string | null)[] | null; 
}

export interface core_apimessages_AdZone {
  uuid?: string | null; 
  slug?: string | null; 
  name?: string | null; 
  status?: core_apimessages_AdZone_AdZoneStatus | null; 
  description?: string | null; 
}

export interface core_apimessages_AdGroupKeyword {
  id?: string | null; 
  keyword?: string | null; 
}

export interface AdCollection {
  _ids?: (string | null)[] | null; 
  nodes?: (Ad | null)[] | null; 
  pageInfo?: rql_PageInfo | null; 
  ads?: (Ad | null)[] | null; 
}

export interface Ad extends INode {
  _id?: string | null; 
  id?: number | null; 
  campaignId?: number | null; 
  format?: core_apimessages_AdFormat | null; 
  imageAdCreative?: core_apimessages_ImageAdCreative | null; 
  uuid?: string | null; 
  adGroupUuid?: string | null; 
  adCampaignUuid?: string | null; 
  advertiserUuid?: string | null; 
  localizedContents?: (core_apimessages_AdLocalizedContent | null)[] | null; 
  deletedAt?: Timestamp | null; 
  adGroupName?: string | null; 
}

export interface core_apimessages_ImageAdCreative {
  title?: string | null; 
  titleColor?: string | null; 
  subtitle?: string | null; 
  subtitleColor?: string | null; 
  ctaText?: string | null; 
  ctaHref?: string | null; 
  ctaTextColor?: string | null; 
  ctaButtonColor?: string | null; 
  backgroundImage?: string | null; 
  mobileBackgroundImage?: string | null; 
  backgroundColor?: string | null; 
  overlayImage?: string | null; 
  description?: string | null; 
  hideAdCallout?: boolean | null; 
  partnershipText?: string | null; 
  backgroundColors?: (string | null)[] | null; 
  cspRowQuery?: core_apimessages_CspRowQuery | null; 
}

export interface core_apimessages_CspRowQuery {
  rowTitle?: string | null; 
  cspSlugs?: (string | null)[] | null; 
  brandSlugs?: (string | null)[] | null; 
  sort?: string | null; 
  categoryUuids?: (string | null)[] | null; 
}

export interface core_apimessages_AdLocalizedContent {
  locale?: string | null; 
  imageAdCreative?: core_apimessages_ImageAdCreative | null; 
}

export interface AdZoneCollection {
  _ids?: (string | null)[] | null; 
  nodes?: (AdZone | null)[] | null; 
  pageInfo?: rql_PageInfo | null; 
  adZones?: (AdZone | null)[] | null; 
}

export interface AdZone extends INode {
  _id?: string | null; 
  uuid?: string | null; 
  slug?: string | null; 
  name?: string | null; 
  status?: core_apimessages_AdZone_AdZoneStatus | null; 
  description?: string | null; 
  adGroupCollection?: AdGroupCollection | null; 
}

export interface UniversalPromoCampaign extends INode {
  _id?: string | null; 
  id?: string | null; 
  name?: string | null; 
  code?: string | null; 
  expiresAt?: Timestamp | null; 
  marketingChannel?: string | null; 
  newBuyer?: boolean | null; 
  redemptionLimit?: number | null; 
  hasRedemptionLimit?: boolean | null; 
  universalPromoCurrencies?: (core_apimessages_UniversalPromoCurrency | null)[] | null; 
  categories?: (core_apimessages_NodesCategory | null)[] | null; 
}

export interface core_apimessages_UniversalPromoCurrency {
  amount?: core_apimessages_Money | null; 
  minPurchaseAmount?: core_apimessages_Money | null; 
}

export interface core_apimessages_NodesCategory {
  id?: string | null; 
  name?: string | null; 
  webLink?: core_apimessages_Link | null; 
  cmsLink?: core_apimessages_Link | null; 
  slug?: string | null; 
  rootSlug?: string | null; 
  cmsUrl?: core_apimessages_Link | null; 
  root?: boolean | null; 
  leaf?: boolean | null; 
}

export interface rql_Me {
  token?: string | null; 
  follows?: reverb_feed_GetFollowsResponse | null; 
  feed?: reverb_feed_FeedResponse | null; 
  name?: string | null; 
  firstName?: string | null; 
  id?: string | null; 
  uuid?: string | null; 
  shopUuid?: string | null; 
  admin?: boolean | null; 
  status?: core_apimessages_UserStatus | null; 
  shopId?: string | null; 
  shopSlug?: string | null; 
  requireOptIn?: boolean | null; 
  profileSlug?: string | null; 
  recentlyViewedListings?: core_apimessages_RecentlyViewedListingsResponse | null; 
  shipments?: (Shipment | null)[] | null; 
  counts?: core_apimessages_CountsResponse | null; 
  profile?: mparticle_ProfileResponse | null; 
  referAFriend?: core_apimessages_ReferAFriend | null; 
  myNegotiations?: reverb_search_SearchResponse | null; 
  myAuctions?: reverb_search_SearchResponse | null; 
  orders?: (Order | null)[] | null; 
  avatar?: core_apimessages_Image | null; 
  sellerCheckout?: SellerCheckout | null; 
  creditCards?: (core_apimessages_CreditCard | null)[] | null; 
  payoutBalances?: (core_apimessages_Money | null)[] | null; 
  reverbCredits?: (core_apimessages_Money | null)[] | null; 
  shippingAddresses?: (core_apimessages_Address | null)[] | null; 
  alerts?: (core_apimessages_Alert | null)[] | null; 
  watches?: WatchCollection | null; 
  brandManagerBrands?: (Brand | null)[] | null; 
  brandManagerBrand?: Brand | null; 
  emailSubscriptions?: (rql_EmailSubscription | null)[] | null; 
  emailGlobalSubscribe?: rql_SubscribeState | null; 
  gearCollectionItems?: (GearCollectionItem | null)[] | null; 
  cartItems?: (CartItem | null)[] | null; 
  cart?: rql_MyCart | null; 
  recentlyViewedCsps?: (CSP | null)[] | null; 
  recommendedListings?: reverb_search_SearchResponse | null; 
  updates?: rql_MyUpdatesResponse | null; 
  plaidLinkToken?: string | null; 
  userServices?: (core_apimessages_UserService | null)[] | null; 
  adaChatToken?: core_apimessages_AdaChatTokenResponse | null; 
  shop?: MyShop | null; 
}

export interface reverb_feed_GetFollowsResponse {
  follows?: (reverb_feed_Follow | null)[] | null; 
  page?: number | null; 
  perPage?: number | null; 
  total?: number | null; 
}

export interface reverb_feed_Follow {
  userId?: string | null; 
  savedSearchId?: string | null; 
  createdAt?: Timestamp | null; 
  queryParams?: string | null; 
  searchableType?: reverb_feed_SearchableType | null; 
  searchableId?: string | null; 
  id?: string | null; 
  localizedContents?: (reverb_feed_FollowLocalizedContents | null)[] | null; 
  digestEnabled?: boolean | null; 
}

export interface reverb_feed_FollowLocalizedContents {
  locale?: string | null; 
  title?: string | null; 
  subtitle?: string | null; 
  shortDescription?: string | null; 
  description?: string | null; 
}

export interface reverb_feed_FeedResponse {
  entries?: (reverb_feed_FeedEntry | null)[] | null; 
  page?: number | null; 
  perPage?: number | null; 
  total?: number | null; 
  offset?: number | null; 
  limit?: number | null; 
  filters?: (reverb_search_Filter | null)[] | null; 
}

export interface reverb_feed_FeedEntry {
  id?: number | null; 
  type?: reverb_feed_FeedEntry_EntryType | null; 
  metadata?: reverb_feed_FeedMetadata | null; 
  uuid?: string | null; 
  searchableType?: reverb_feed_SearchableType | null; 
  searchableId?: string | null; 
  queryParams?: string | null; 
  localizedContents?: (reverb_feed_FollowLocalizedContents | null)[] | null; 
  deleted?: boolean | null; 
  userId?: string | null; 
  entry?: FeedEntry | null; 
}

export interface reverb_feed_FeedMetadata {
  sourceType?: reverb_feed_FeedSourceType | null; 
  sourceId?: number | null; 
  matchedAt?: Timestamp | null; 
  fromFeedService?: boolean | null; 
  matchedAtIso?: string | null; 
}

export interface core_apimessages_RecentlyViewedListingsResponse {
  listingIds?: (string | null)[] | null; 
  listings?: (Listing | null)[] | null; 
}

export interface core_apimessages_CountsResponse {
  Links?: core_apimessages_CountsLinks | null; 
  total?: core_apimessages_CountsTotal | null; 
  activeCartItemTotal?: core_apimessages_UserBadge | null; 
  activeOffers?: core_apimessages_UserBadge | null; 
  billingProfile?: core_apimessages_UserBadge | null; 
  buyerActiveOffers?: core_apimessages_UserBadge | null; 
  invoicedStatementCount?: core_apimessages_UserBadge | null; 
  layawayOrders?: core_apimessages_UserBadge | null; 
  outstandingFeedback?: core_apimessages_UserBadge | null; 
  sellerActiveOffers?: core_apimessages_UserBadge | null; 
  sellerOrdersAwaitingShipment?: core_apimessages_UserBadge | null; 
  sellerOrdersRefundRequested?: core_apimessages_UserBadge | null; 
  unpaidOrders?: core_apimessages_UserBadge | null; 
  unreadMessages?: core_apimessages_UserBadge | null; 
  sellerOrdersAwaitingPickup?: core_apimessages_UserBadge | null; 
  buyerOrdersAwaitingPickup?: core_apimessages_UserBadge | null; 
  countsLinks?: core_apimessages_CountsLinks | null; 
  userNotifications?: (core_apimessages_UserNotification | null)[] | null; 
}

export interface core_apimessages_CountsLinks {
  self?: core_apimessages_Link | null; 
}

export interface core_apimessages_CountsTotal {
  count?: number | null; 
}

export interface core_apimessages_UserBadge {
  count?: number | null; 
  displayText?: string | null; 
  Links?: core_apimessages_UserBadgeLinks | null; 
  badgeLinks?: core_apimessages_UserBadgeLinks | null; 
}

export interface core_apimessages_UserBadgeLinks {
  web?: core_apimessages_Link | null; 
}

export interface core_apimessages_UserNotification {
  notificationType?: core_apimessages_UserNotificationType | null; 
  title?: string | null; 
  description?: string | null; 
  notificationLinks?: core_apimessages_UserNotificationLinks | null; 
  key?: core_apimessages_UserNotification_UserNotificationKey | null; 
}

export interface core_apimessages_UserNotificationLinks {
  web?: core_apimessages_Link | null; 
}

export interface mparticle_ProfileResponse {
  mpid?: string | null; 
  topProductType?: string | null; 
  topProductTypes?: (string | null)[] | null; 
  topCategories?: (string | null)[] | null; 
  topBrands?: (string | null)[] | null; 
  recentlyViewedCsps?: (string | null)[] | null; 
  averageOrderValue?: number | null; 
  totalListingsCreated?: number | null; 
  totalListingsSold?: number | null; 
  totalListingsDraft?: number | null; 
  totalListingsSuspended?: number | null; 
  totalListingsLive?: number | null; 
  cumulativeGmv?: number | null; 
  totalPurchases?: number | null; 
  buyerLabel?: string | null; 
  sellerLabel?: string | null; 
  totalFeedFollows?: number | null; 
  totalBuyerOffersCreated?: number | null; 
  totalBuyerOffersAccepted?: number | null; 
  sellerFeedbackRating?: number | null; 
  buyerFeedbackRating?: number | null; 
  mostRecentOrderDate?: string | null; 
  firstOrderDate?: string | null; 
  topProductTypeUuids?: (string | null)[] | null; 
  topCategoryUuids?: (string | null)[] | null; 
  topBrandCategories?: (string | null)[] | null; 
}

export interface core_apimessages_ReferAFriend {
  shareUrl?: string | null; 
  signUpBonus?: core_apimessages_Money | null; 
  rewardAmount?: core_apimessages_Money | null; 
  minOrderAmount?: core_apimessages_Money | null; 
}

export interface core_apimessages_Alert {
  title?: string | null; 
  description?: string | null; 
  url?: string | null; 
}

export interface rql_EmailSubscription {
  id?: string | null; 
  subscribed?: boolean | null; 
  translationKey?: rql_EmailSubscription_TranslationKey | null; 
}

export interface rql_MyCart {
  cartItems?: (core_apimessages_CartItem | null)[] | null; 
}

export interface core_apimessages_CartItem {
  uuid?: string | null; 
  listingId?: string | null; 
  orderId?: string | null; 
  subtotal?: core_apimessages_Money | null; 
  shopId?: string | null; 
  quantity?: number | null; 
  listing?: Listing | null; 
  order?: Order | null; 
}

export interface rql_MyUpdatesResponse {
  updates?: (rql_Update | null)[] | null; 
  limit?: number | null; 
  offset?: number | null; 
  total?: number | null; 
}

export interface rql_Update {
  entity?: rql_UpdateEntity | null; 
  createdAt?: string | null; 
}

export interface rql_UpdateEntity {
  _?: boolean | null; 
  id?: string | null; 
  type?: reverb_updates_Entity_EntityType | null; 
  listing?: Listing | null; 
  priceDrop?: PriceChange | null; 
  siteBanner?: SiteBanner | null; 
  affinityListingByCategory?: (Listing | null)[] | null; 
  affinityCategories?: (Category | null)[] | null; 
  cartCount?: number | null; 
  shop?: Shop | null; 
  listingsCount?: number | null; 
  listings?: (Listing | null)[] | null; 
  offerCount?: number | null; 
  sale?: core_apimessages_Sale | null; 
  promotion?: MyUpdatesPromotion | null; 
}

export interface core_apimessages_UserService {
  id?: string | null; 
  email?: string | null; 
  provider?: core_apimessages_UserService_Provider | null; 
}

export interface core_apimessages_AdaChatTokenResponse {
  token?: string | null; 
}

export interface core_apimessages_SellingFeesResponse {
  fees?: core_apimessages_SellingFees | null; 
}

export interface core_apimessages_SellingFees {
  minFee?: core_apimessages_Money | null; 
  maxFee?: core_apimessages_Money | null; 
  sellingFeePercent?: string | null; 
  processingFees?: core_apimessages_ProcessingFees | null; 
}

export interface core_apimessages_ProcessingFees {
  percent?: string | null; 
  flatFee?: core_apimessages_Money | null; 
}

export interface core_apimessages_CountriesResponse {
  countries?: (core_apimessages_Country | null)[] | null; 
}

export interface cms_PagesResponse {
  pages?: (cms_PublicPage | null)[] | null; 
  meta?: cms_BulkPagination | null; 
}

export interface cms_PublicPage {
  id?: string | null; 
  slug?: string | null; 
  goLiveAt?: string | null; 
  title?: string | null; 
  description?: string | null; 
  metaTitle?: string | null; 
  metaDescription?: string | null; 
  componentIds?: (string | null)[] | null; 
  imageAttributionUri?: string | null; 
  image?: cms_PageImage | null; 
  authorId?: string | null; 
  pageType?: string | null; 
  authorName?: string | null; 
  albumIds?: (string | null)[] | null; 
  channels?: (string | null)[] | null; 
  locale?: string | null; 
  layoutId?: string | null; 
  layoutSlug?: string | null; 
  metaImage?: cms_PageImage | null; 
  headerStyle?: string | null; 
  actionText?: string | null; 
  actionUrl?: string | null; 
  searchPlaceholder?: string | null; 
  noIndex?: boolean | null; 
  secondaryImage?: cms_PageImage | null; 
  live?: boolean | null; 
  pageNotFound?: boolean | null; 
  targetLocales?: (string | null)[] | null; 
  breadcrumbs?: string | null; 
  components?: (cms_PublicComponent | null)[] | null; 
  albums?: (lp_Album | null)[] | null; 
}

export interface cms_PublicComponent {
  id?: string | null; 
  pageId?: string | null; 
  position?: number | null; 
  componentType?: string | null; 
  data?: string | null; 
  layoutSection?: string | null; 
  active?: boolean | null; 
  experimentKey?: string | null; 
  experimentBucket?: string | null; 
  title?: string | null; 
  subtitle?: string | null; 
  searchUrlParams?: string | null; 
  searchSort?: string | null; 
  searchType?: cms_PublicComponent_SearchType | null; 
}

export interface cms_BulkPagination {
  total?: number | null; 
  offset?: number | null; 
  limit?: number | null; 
}

export interface core_apimessages_ChatDepartmentResponse {
  chatDepartment?: core_apimessages_ChatDepartment | null; 
}

export interface core_apimessages_ChatDepartment {
  id?: string | null; 
  tag?: string | null; 
}

export interface reverb_taxonomy_GetTraitValueTranslationsResponse {
  traitValueTranslations?: (reverb_taxonomy_Translation | null)[] | null; 
}

export interface reverb_taxonomy_Translation {
  uuid?: string | null; 
  locale?: string | null; 
  translation?: string | null; 
}

export interface core_apimessages_SearchMetadataResponse {
  title?: string | null; 
}

export interface reverb_personalization_TrendingSearchesResponse {
  trendingSearches?: (reverb_personalization_TrendingSearch | null)[] | null; 
}

export interface reverb_personalization_TrendingSearch {
  query?: string | null; 
  score?: number | null; 
  categorySlug?: string | null; 
  categoryUuid?: string | null; 
}

export interface reverb_pricing_PriceRecommendationsResponse {
  priceRecommendations?: (reverb_pricing_PriceRecommendation | null)[] | null; 
}

export interface core_apimessages_CPSuggestions {
  suggestions?: (core_apimessages_CPSuggestion | null)[] | null; 
}

export interface core_apimessages_CPSuggestion {
  canonicalProductId?: string | null; 
  service?: string | null; 
  confidence?: number | null; 
  canonicalProduct?: core_apimessages_AutomatchingCanonicalProduct | null; 
}

export interface core_apimessages_AutomatchingCanonicalProduct {
  id?: string | null; 
  model?: string | null; 
  year?: string | null; 
  finish?: string | null; 
  upc?: string | null; 
  brand?: core_apimessages_Brand | null; 
  primaryImage?: core_apimessages_Image | null; 
}

export interface core_apimessages_Brand {
  id?: string | null; 
  name?: string | null; 
  webLink?: core_apimessages_Link | null; 
  slug?: string | null; 
}

export interface rql_SeedableListingFields {
  make?: string | null; 
  model?: string | null; 
  brandSlug?: string | null; 
  finish?: string | null; 
  year?: string | null; 
  canonicalProductId?: string | null; 
  categoryRootUuid?: string | null; 
  categories?: (core_apimessages_NodesCategory | null)[] | null; 
  condition?: core_apimessages_Condition | null; 
  countryOfOrigin?: string | null; 
  comparisonShoppingPageId?: string | null; 
  sellerCost?: core_apimessages_Money | null; 
}

export interface core_apimessages_AdServeResponse {
  ad?: core_apimessages_Ad | null; 
  placements?: (core_apimessages_AdPlacementResponse | null)[] | null; 
}

export interface core_apimessages_Ad {
  id?: number | null; 
  campaignId?: number | null; 
  format?: core_apimessages_AdFormat | null; 
  imageAdCreative?: core_apimessages_ImageAdCreative | null; 
  uuid?: string | null; 
  adGroupUuid?: string | null; 
  adCampaignUuid?: string | null; 
  advertiserUuid?: string | null; 
  localizedContents?: (core_apimessages_AdLocalizedContent | null)[] | null; 
  deletedAt?: Timestamp | null; 
  adGroupName?: string | null; 
}

export interface core_apimessages_AdPlacementResponse {
  ad?: core_apimessages_Ad | null; 
  adZones?: (core_apimessages_AdZone | null)[] | null; 
  candidates?: (core_apimessages_Candidate | null)[] | null; 
}

export interface core_apimessages_Candidate {
  adGroup?: core_apimessages_AdGroup | null; 
  matches?: (string | null)[] | null; 
  weight?: number | null; 
}

export interface core_apimessages_MyDirectCheckoutProfileResponse {
  nameOnAccount?: string | null; 
  maskedNameSummary?: string | null; 
  bankName?: string | null; 
  currency?: string | null; 
  countryCode?: string | null; 
  payoutMethod?: string | null; 
  hasAcceptedReverbBankTerms?: boolean | null; 
  profileErrors?: (string | null)[] | null; 
  plaidAccountId?: string | null; 
}

export interface core_apimessages_ExperimentsResponse {
  experiments?: (reverb_event_Experiment | null)[] | null; 
}

export interface reverb_event_Experiment {
  name?: string | null; 
  value?: string | null; 
  useInFrontend?: boolean | null; 
  multivariateExperiment?: boolean | null; 
  qualifyForMobile?: boolean | null; 
  mobileContext?: reverb_event_Experiment_MobileContext | null; 
  useInMarketplaceListingsSearch?: boolean | null; 
}

export interface reverb_event_Experiment_MobileContext {
  value?: string | null; 
  reportAs?: string | null; 
}

export interface reverb_config_cache_InternationalAddressFormConfigResponse {
  configs?: (reverb_config_cache_AddressFormConfig | null)[] | null; 
}

export interface reverb_config_cache_AddressFormConfig {
  countryCode?: string | null; 
  fields?: (reverb_config_cache_AddressFormField | null)[] | null; 
}

export interface reverb_config_cache_AddressFormField {
  fieldName?: string | null; 
  displayNames?: (reverb_config_cache_LocalizedAddressFormDisplayName | null)[] | null; 
  required?: boolean | null; 
}

export interface reverb_config_cache_LocalizedAddressFormDisplayName {
  locale?: string | null; 
  displayName?: string | null; 
}

export interface core_apimessages_MosaicTilesResponse {
  mosaicTiles?: (core_apimessages_MosaicTile | null)[] | null; 
}

export interface core_apimessages_MosaicTile {
  id?: string | null; 
  url?: string | null; 
  imageTitle?: string | null; 
  imageSubtitle?: string | null; 
  imageUrl?: string | null; 
  contentSponsorship?: core_apimessages_ContentSponsorship | null; 
  position?: core_apimessages_MosaicTilePosition | null; 
}

export interface core_apimessages_VerifyPromotionalCodeResponse {
  success?: boolean | null; 
  message?: string | null; 
}

export interface core_apimessages_BearerV2TokenResponse {
  token?: string | null; 
}

export interface lp_PagesResponse {
  pages?: (lp_PublicPage | null)[] | null; 
  meta?: lp_BulkPagination | null; 
}

export interface lp_PublicPage {
  id?: string | null; 
  slug?: string | null; 
  goLiveAt?: string | null; 
  title?: string | null; 
  description?: string | null; 
  metaTitle?: string | null; 
  metaDescription?: string | null; 
  componentIds?: (string | null)[] | null; 
  imageAttributionUri?: string | null; 
  image?: lp_PageImage | null; 
  authorId?: string | null; 
  pageType?: string | null; 
  authorName?: string | null; 
  albumIds?: (string | null)[] | null; 
  imageKey?: string | null; 
  components?: (lp_Component | null)[] | null; 
  albums?: (lp_Album | null)[] | null; 
}

export interface lp_PageImage {
  Links?: lp_PageImageLinks | null; 
}

export interface lp_PageImageLinks {
  original?: lp_Link | null; 
}

export interface lp_Component {
  id?: string | null; 
  pageId?: string | null; 
  position?: number | null; 
  componentType?: string | null; 
  data?: string | null; 
}

export interface lp_BulkPagination {
  total?: number | null; 
  offset?: number | null; 
  limit?: number | null; 
}

export interface core_apimessages_SiteBanner {
  id?: string | null; 
  heading?: string | null; 
  subheading?: string | null; 
  callToAction?: string | null; 
  url?: core_apimessages_Link | null; 
  mobileUrl?: core_apimessages_Link | null; 
  mobileWebUrl?: core_apimessages_Link | null; 
  imageUrl?: string | null; 
  webOnly?: boolean | null; 
  mobileImageUrl?: string | null; 
  startsAt?: Timestamp | null; 
  endsAt?: Timestamp | null; 
  contentSponsorship?: core_apimessages_ContentSponsorship | null; 
  downtime?: boolean | null; 
  hasPhotos?: boolean | null; 
  showOnMobile?: boolean | null; 
  showOnMyUpdates?: boolean | null; 
}

export interface core_apimessages_AdvertisersSearchResponse {
  resultUuids?: (string | null)[] | null; 
  offset?: number | null; 
  limit?: number | null; 
  total?: number | null; 
  advertisers?: (Advertiser | null)[] | null; 
}

export interface core_apimessages_AdCampaignsSearchResponse {
  resultUuids?: (string | null)[] | null; 
  offset?: number | null; 
  limit?: number | null; 
  total?: number | null; 
  adCampaigns?: (AdCampaign | null)[] | null; 
}

export interface core_apimessages_AdGroupsSearchResponse {
  resultUuids?: (string | null)[] | null; 
  offset?: number | null; 
  limit?: number | null; 
  total?: number | null; 
  adGroups?: (AdGroup | null)[] | null; 
}

export interface core_apimessages_AdsSearchResponse {
  resultUuids?: (string | null)[] | null; 
  offset?: number | null; 
  limit?: number | null; 
  total?: number | null; 
  ads?: (Ad | null)[] | null; 
}

export interface core_apimessages_AdZonesSearchResponse {
  resultUuids?: (string | null)[] | null; 
  adZones?: (AdZone | null)[] | null; 
}

export interface core_apimessages_AdminUserSearchResponse {
  totalResults?: string | null; 
  page?: string | null; 
  perPage?: string | null; 
  users?: (core_apimessages_UserSearchResult | null)[] | null; 
}

export interface core_apimessages_UserSearchResult {
  id?: string | null; 
  email?: string | null; 
  shopId?: string | null; 
  shopName?: string | null; 
}

export interface Mutation {
  createBid?: core_apimessages_BidsCreateResponse | null; 
  adminDeleteBid?: core_apimessages_DeleteResponse | null; 
  createNegotiation?: core_apimessages_NegotiationsResponse | null; 
  createAutoOffer?: core_apimessages_CreateAutoOfferResponse | null; 
  updateShopKYC?: core_apimessages_UpdateShopKYCResponse | null; 
  setupShopPaymentMethods?: core_apimessages_SetupPaymentMethodsResponse | null; 
  updateMyShopBillingMethod?: core_apimessages_UpdateBillingMethodResponse | null; 
  billingMethodVerifyShopper?: core_apimessages_BillingMethodVerifyShopperResponse | null; 
  billingMethodIdentifyShopper?: core_apimessages_BillingMethodIdentifyShopperResponse | null; 
  billingMethodChallengeShopper?: core_apimessages_BillingMethodChallengeShopperResponse | null; 
  promotionalCodeRedeem?: core_apimessages_RedeemPromotionalCodeResponse | null; 
  updateNegotiation?: core_apimessages_UpdateNegotiationResponse | null; 
  shippingProtection?: core_apimessages_ShippingProtectionResponse | null; 
  createShipment?: Shipment | null; 
  purchaseShippingRate?: core_apimessages_PurchaseShippingRateResponse | null; 
  updateReturnPolicy?: core_apimessages_UpdateReturnPolicyResponse | null; 
  updateMyShop?: core_apimessages_UpdateMyShopResponse | null; 
  generateDraft?: core_apimessages_GenerateDraftResponse | null; 
  updateMyAddress?: core_apimessages_UpdateAddressResponse | null; 
  deleteMyAddress?: core_apimessages_DeleteResponse | null; 
  updateMyShopShippingProfiles?: core_apimessages_UpdateMyShopShippingProfilesResponse | null; 
  createWatch?: core_apimessages_UpdateWatchResponse | null; 
  deleteWatch?: core_apimessages_UpdateWatchResponse | null; 
  updateFeedbackRequest?: core_apimessages_UpdateFeedbackResponse | null; 
  declineFeedbackRequest?: core_apimessages_DeclineFeedbackResponse | null; 
  addListingToCuratedSet?: core_apimessages_AdminCuratedSetsCurateResponse | null; 
  removeListingFromCuratedSet?: core_apimessages_AdminCuratedSetsCurateResponse | null; 
  featureListingInCuratedSet?: core_apimessages_AdminCuratedSetsCurateResponse | null; 
  unfeatureListingInCuratedSet?: core_apimessages_AdminCuratedSetsCurateResponse | null; 
  voteProductReview?: core_apimessages_ProductReviewVoteResponse | null; 
  addListingToMyCuratedSet?: core_apimessages_MyCuratedSetMembershipResponse | null; 
  removeListingFromMyCuratedSet?: core_apimessages_MyCuratedSetMembershipResponse | null; 
  reverifyCreditCard?: core_apimessages_ReverifyCreditCardResponse | null; 
  createCheckout?: core_apimessages_CheckoutCreateResponse | null; 
  createExpressSaleCheckout?: core_apimessages_CreateExpressSaleCheckoutResponse | null; 
  completeExpressSaleCheckout?: core_apimessages_CompleteExpressSaleCheckoutResponse | null; 
  updateCheckoutShippingAddress?: core_apimessages_CheckoutUpdateShippingAddressResponse | null; 
  selectCheckoutShippingAddress?: core_apimessages_CheckoutSelectShippingAddressResponse | null; 
  selectCheckoutOrderShippingMethod?: core_apimessages_CheckoutSelectOrderShippingMethodResponse | null; 
  updateCheckoutShippingEstimate?: core_apimessages_CheckoutUpdateShippingEstimateResponse | null; 
  finalizeDigitalWalletPayment?: core_apimessages_CheckoutFinalizeDigitalWalletPaymentResponse | null; 
  finalizeDirectCheckoutPayment?: core_apimessages_CheckoutFinalizeDirectCheckoutPaymentResponse | null; 
  createCheckoutPaymentRedirectUrl?: core_apimessages_CheckoutCreatePaymentRedirectUrlResponse | null; 
  startCheckoutForListing?: core_apimessages_StartCheckoutForListingResponse | null; 
  applyCheckoutDiscountCode?: core_apimessages_ApplyCheckoutDiscountCodeResponse | null; 
  selectCheckoutCreditCard?: core_apimessages_SelectCheckoutCreditCardResponse | null; 
  updateCheckoutGuestCreditCard?: core_apimessages_UpdateCheckoutGuestCreditCardResponse | null; 
  selectCheckoutPaymentMethod?: core_apimessages_SelectCheckoutPaymentMethodResponse | null; 
  editCart?: core_apimessages_CheckoutCartEditResponse | null; 
  editCheckoutCart?: rql_CheckoutCartEditResponse | null; 
  finalizeRedirectPaymentCheckout?: core_apimessages_CheckoutFinalizeRedirectPaymentCheckoutResponse | null; 
  checkoutVerifyShopper?: core_apimessages_CheckoutVerifyShopperResponse | null; 
  checkoutIdentifyShopper?: core_apimessages_CheckoutIdentifyShopperResponse | null; 
  checkoutChallengeShopper?: core_apimessages_CheckoutChallengeShopperResponse | null; 
  guestCheckoutVerifyShopper?: core_apimessages_CheckoutVerifyShopperResponse | null; 
  guestCheckoutApplePayLineItems?: core_apimessages_GuestCheckoutApplePayLineItemsResponse | null; 
  guestCheckoutApplePayPayment?: core_apimessages_GuestCheckoutApplePayPaymentResponse | null; 
  deleteAutoOffer?: core_apimessages_DeleteAutoOfferResponse | null; 
  cancelOrder?: core_apimessages_CancelOrderResponse | null; 
  trackBumpInteraction?: core_apimessages_TrackBumpInteractionResponse | null; 
  registerMyPacklinkAccount?: core_apimessages_RegisterMyPacklinkAccountResponse | null; 
  loginMyPacklinkAccount?: core_apimessages_LoginMyPacklinkAccountResponse | null; 
  createPacklinkDraft?: core_apimessages_CreatePacklinkDraftResponse | null; 
  crupdateGearCollectionItem?: GearCollectionItem | null; 
  deleteGearCollectionItem?: GearCollectionItem | null; 
  createTaxIdentification?: core_apimessages_CreateTaxIdentificationResponse | null; 
  updateTaxIdentification?: core_apimessages_UpdateTaxIdentificationResponse | null; 
  deactivateTaxIdentification?: core_apimessages_DeactivateTaxIdentificationResponse | null; 
  createMyPlaidLinkToken?: core_apimessages_CreateMyPlaidLinkTokenResponse | null; 
  requestAccountDeletion?: core_apimessages_RequestAccountDeletionResponse | null; 
  saveMyPlaidAccount?: core_apimessages_SaveMyPlaidAccountResponse | null; 
  delinkUserService?: core_apimessages_DelinkUserServiceResponse | null; 
  cancelPlaidAccount?: core_apimessages_CancelPlaidAccountResponse | null; 
  updateUniversalPromoCampaign?: core_apimessages_UpdateUniversalPromoCampaignResponse | null; 
  crupdateListing?: Listing | null; 
  createMyCreditCard?: core_apimessages_CreateMyCreditCardResponse | null; 
  updateMyCreditCard?: core_apimessages_UpdateMyCreditCardResponse | null; 
  deleteMyCreditCard?: core_apimessages_DeleteMyCreditCardResponse | null; 
  removeFeedEntry?: reverb_feed_RemoveEntryResponse | null; 
  setMyLPFollowDigests?: reverb_feed_SetFollowDigestsByUserResponse | null; 
  bulkTrackImpressions?: arbiter_BulkTrackImpressionsResponse | null; 
  setEmailSubscription?: rql_EmailSubscription | null; 
  setEmailGlobalSubscribe?: rql_Me | null; 
  triggerOptInEmail?: braze_TriggerCampaignSendResponse | null; 
  exchangeCurrency?: reverb_config_cache_ExchangeCurrencyResponse | null; 
  updateAdvertiser?: core_apimessages_UpdateAdvertiserResponse | null; 
  updateAdCampaign?: core_apimessages_UpdateAdCampaignResponse | null; 
  updateAdGroup?: core_apimessages_UpdateAdGroupResponse | null; 
  copyAdGroup?: core_apimessages_CopyAdGroupResponse | null; 
  updateAdGroupKeywords?: core_apimessages_UpdateAdGroupKeywordsResponse | null; 
  updateAd?: core_apimessages_UpdateAdResponse | null; 
  updateAdZone?: core_apimessages_UpdateAdZoneResponse | null; 
  DeleteAd?: core_apimessages_DeleteAdResponse | null; 
}

export interface core_apimessages_BidsCreateResponse {
  bid?: core_apimessages_PrivateBid | null; 
}

export interface core_apimessages_PrivateBid {
  auctionId?: string | null; 
  maxBid?: core_apimessages_Money | null; 
}

export interface core_apimessages_DeleteResponse {
  id?: string | null; 
  uuid?: string | null; 
}

export interface core_apimessages_NegotiationsResponse {
  negotiations?: (core_apimessages_Negotiation | null)[] | null; 
}

export interface core_apimessages_Negotiation {
  id?: string | null; 
  state?: core_apimessages_NegotiationState | null; 
  buyerUuid?: string | null; 
  sellerUuid?: string | null; 
  expiresAt?: google_protobuf_Timestamp | null; 
  orderUuids?: (string | null)[] | null; 
  lastOffer?: core_apimessages_Offer | null; 
  taxIncluded?: boolean | null; 
  taxIncludedHint?: string | null; 
  buyerOutsideListingShippingRegions?: boolean | null; 
  negotiationType?: core_apimessages_NegotiationType | null; 
  sellerShippingWarning?: string | null; 
}

export interface core_apimessages_CreateAutoOfferResponse {
  autoOffer?: core_apimessages_AutoOffer | null; 
}

export interface core_apimessages_UpdateShopKYCResponse {
  errors?: (core_apimessages_Error | null)[] | null; 
}

export interface core_apimessages_Error {
  message?: string | null; 
  field?: string | null; 
  context?: string | null; 
  errorType?: string | null; 
}

export interface core_apimessages_SetupPaymentMethodsResponse {
  errors?: (core_apimessages_Error | null)[] | null; 
}

export interface core_apimessages_UpdateBillingMethodResponse {
  errors?: (core_apimessages_Error | null)[] | null; 
  creditCard?: core_apimessages_CreditCard | null; 
  adyenPaymentResult?: core_apimessages_AdyenPaymentResult | null; 
  billingMethodUuid?: string | null; 
  me?: rql_Me | null; 
}

export interface core_apimessages_AdyenPaymentResult {
  paymentStatus?: core_apimessages_AdyenPaymentResult_PaymentStatus | null; 
  paymentData?: string | null; 
  fingerprintToken?: string | null; 
  challengeToken?: string | null; 
  action?: string | null; 
  threeDsOneRedirectUrl?: string | null; 
  threeDsOneData?: core_apimessages_ThreeDSOneData | null; 
}

export interface core_apimessages_ThreeDSOneData {
  paReq?: string | null; 
  md?: string | null; 
  termUrl?: string | null; 
  redirectUrl?: string | null; 
}

export interface core_apimessages_BillingMethodVerifyShopperResponse {
  errors?: (core_apimessages_Error | null)[] | null; 
  creditCard?: core_apimessages_CreditCard | null; 
  adyenPaymentResult?: core_apimessages_AdyenPaymentResult | null; 
  billingMethodUuid?: string | null; 
  me?: rql_Me | null; 
}

export interface core_apimessages_BillingMethodIdentifyShopperResponse {
  errors?: (core_apimessages_Error | null)[] | null; 
  creditCard?: core_apimessages_CreditCard | null; 
  adyenPaymentResult?: core_apimessages_AdyenPaymentResult | null; 
  billingMethodUuid?: string | null; 
  me?: rql_Me | null; 
}

export interface core_apimessages_BillingMethodChallengeShopperResponse {
  errors?: (core_apimessages_Error | null)[] | null; 
  creditCard?: core_apimessages_CreditCard | null; 
  adyenPaymentResult?: core_apimessages_AdyenPaymentResult | null; 
  billingMethodUuid?: string | null; 
  me?: rql_Me | null; 
}

export interface core_apimessages_RedeemPromotionalCodeResponse {
  message?: string | null; 
}

export interface core_apimessages_UpdateNegotiationResponse {
  negotiation?: core_apimessages_Negotiation | null; 
}

export interface core_apimessages_ShippingProtectionResponse {
  price?: core_apimessages_Money | null; 
  shippingProtectionStatus?: core_apimessages_ShippingProtectionStatus | null; 
  signatureRequiredStatus?: core_apimessages_SignatureRequiredStatus | null; 
  signatureRequiredCosts?: (core_apimessages_SignatureRequiredCost | null)[] | null; 
}

export interface core_apimessages_SignatureRequiredCost {
  carrier?: string | null; 
  amount?: core_apimessages_Money | null; 
}

export interface core_apimessages_PurchaseShippingRateResponse {
  errors?: (core_apimessages_Error | null)[] | null; 
}

export interface core_apimessages_UpdateReturnPolicyResponse {
  errors?: (core_apimessages_Error | null)[] | null; 
  returnPolicy?: core_apimessages_ReturnPolicy | null; 
}

export interface core_apimessages_UpdateMyShopResponse {
  errors?: (core_apimessages_Error | null)[] | null; 
  shop?: core_apimessages_Shop | null; 
}

export interface core_apimessages_GenerateDraftResponse {
  listing?: core_apimessages_Listing | null; 
  seedCategories?: (core_apimessages_NodesCategory | null)[] | null; 
  sellerCost?: core_apimessages_Money | null; 
}

export interface core_apimessages_Listing {
  id?: string | null; 
  title?: string | null; 
  merchandisingUuid?: string | null; 
  price?: core_apimessages_Money | null; 
  shopId?: string | null; 
  sellerId?: string | null; 
  sellerUuid?: string | null; 
  hasInventory?: boolean | null; 
  inventory?: number | null; 
  shopUuid?: string | null; 
  categoryUuids?: (string | null)[] | null; 
  state?: string | null; 
  condition?: core_apimessages_Condition | null; 
  slug?: string | null; 
  listingType?: core_apimessages_Listing_ListingType | null; 
  publishedAt?: google_protobuf_Timestamp | null; 
  description?: string | null; 
  merchandisingType?: string | null; 
  countryOfOrigin?: string | null; 
  finish?: string | null; 
  make?: string | null; 
  model?: string | null; 
  productTypeId?: string | null; 
  year?: string | null; 
  canonicalProductId?: string | null; 
  seedId?: string | null; 
  seedType?: core_apimessages_Listing_SeedType | null; 
  sku?: string | null; 
  stateDescription?: string | null; 
  taxIncluded?: boolean | null; 
  priceGuideUuid?: string | null; 
  cspUuid?: string | null; 
  currentAuctionId?: string | null; 
  salePrice?: core_apimessages_Money | null; 
  categoryRootUuid?: string | null; 
  taxIncludedHint?: string | null; 
  bumped?: boolean | null; 
  upc?: string | null; 
  exclusiveChannel?: string | null; 
  brandSlug?: string | null; 
  soldAsIs?: boolean | null; 
  bumpEligible?: boolean | null; 
  propSixtyFiveWarning?: string | null; 
  propSixtyFiveWarningImg?: core_apimessages_Link | null; 
  maxBuyerQuantity?: number | null; 
  currency?: string | null; 
  cspId?: string | null; 
  allowedBuyerQuantity?: number | null; 
  sameDayShippingIneligible?: boolean | null; 
  overriddenAttributes?: (string | null)[] | null; 
}

export interface core_apimessages_UpdateAddressResponse {
  address?: core_apimessages_Address | null; 
}

export interface core_apimessages_UpdateMyShopShippingProfilesResponse {
  shippingProfiles?: (core_apimessages_UpdateMyShippingProfile | null)[] | null; 
}

export interface core_apimessages_UpdateMyShippingProfile {
  id?: string | null; 
  name?: string | null; 
  categoryUuids?: (string | null)[] | null; 
  localPickup?: boolean | null; 
  offersIncrementalRates?: boolean | null; 
  shippingRates?: (core_apimessages_ShippingRates | null)[] | null; 
}

export interface core_apimessages_UpdateWatchResponse {
  listingId?: string | null; 
  userId?: string | null; 
  id?: string | null; 
  listing?: Listing | null; 
}

export interface core_apimessages_UpdateFeedbackResponse {
  feedback?: core_apimessages_Feedback | null; 
}

export interface core_apimessages_DeclineFeedbackResponse {
  orderUuid?: string | null; 
}

export interface core_apimessages_AdminCuratedSetsCurateResponse {
  curatedSetSlug?: string | null; 
  listingId?: string | null; 
  featuredInSet?: boolean | null; 
}

export interface core_apimessages_ProductReviewVoteResponse {
  _?: boolean | null; 
}

export interface core_apimessages_MyCuratedSetMembershipResponse {
  curatedSetMembership?: core_apimessages_CuratedSetMembership | null; 
}

export interface core_apimessages_CuratedSetMembership {
  id?: string | null; 
  curatedSetId?: string | null; 
  productId?: string | null; 
}

export interface core_apimessages_ReverifyCreditCardResponse {
  creditCard?: core_apimessages_CreditCard | null; 
}

export interface core_apimessages_CheckoutCreateResponse {
  id?: string | null; 
  checkout?: Checkout | null; 
}

export interface core_apimessages_CreateExpressSaleCheckoutResponse {
  checkoutId?: string | null; 
}

export interface core_apimessages_CompleteExpressSaleCheckoutResponse {
  orderId?: string | null; 
}

export interface core_apimessages_CheckoutUpdateShippingAddressResponse {
  id?: string | null; 
  checkout?: Checkout | null; 
}

export interface core_apimessages_CheckoutSelectShippingAddressResponse {
  id?: string | null; 
  checkout?: Checkout | null; 
}

export interface core_apimessages_CheckoutSelectOrderShippingMethodResponse {
  id?: string | null; 
  checkout?: Checkout | null; 
}

export interface core_apimessages_CheckoutUpdateShippingEstimateResponse {
  id?: string | null; 
  checkout?: Checkout | null; 
}

export interface core_apimessages_CheckoutFinalizeDigitalWalletPaymentResponse {
  id?: string | null; 
  checkout?: Checkout | null; 
}

export interface core_apimessages_CheckoutFinalizeDirectCheckoutPaymentResponse {
  id?: string | null; 
  checkout?: Checkout | null; 
}

export interface core_apimessages_CheckoutCreatePaymentRedirectUrlResponse {
  id?: string | null; 
  redirectUrl?: string | null; 
  checkout?: Checkout | null; 
}

export interface core_apimessages_StartCheckoutForListingResponse {
  redirectUrl?: string | null; 
  checkoutId?: string | null; 
  checkout?: Checkout | null; 
}

export interface core_apimessages_ApplyCheckoutDiscountCodeResponse {
  id?: string | null; 
  checkout?: Checkout | null; 
}

export interface core_apimessages_SelectCheckoutCreditCardResponse {
  id?: string | null; 
  checkout?: Checkout | null; 
}

export interface core_apimessages_UpdateCheckoutGuestCreditCardResponse {
  id?: string | null; 
  checkout?: Checkout | null; 
}

export interface core_apimessages_SelectCheckoutPaymentMethodResponse {
  id?: string | null; 
  checkout?: Checkout | null; 
}

export interface core_apimessages_CheckoutCartEditResponse {
  listingId?: string | null; 
}

export interface rql_CheckoutCartEditResponse {
  id?: string | null; 
  checkout?: Checkout | null; 
}

export interface core_apimessages_CheckoutFinalizeRedirectPaymentCheckoutResponse {
  id?: string | null; 
  checkout?: Checkout | null; 
}

export interface core_apimessages_CheckoutVerifyShopperResponse {
  checkoutUuid?: string | null; 
  adyenPaymentResult?: core_apimessages_AdyenPaymentResult | null; 
  orderBundleId?: string | null; 
  checkoutId?: string | null; 
  paymentResultUrl?: string | null; 
}

export interface core_apimessages_CheckoutIdentifyShopperResponse {
  checkoutUuid?: string | null; 
  adyenPaymentResult?: core_apimessages_AdyenPaymentResult | null; 
  orderBundleId?: string | null; 
  checkoutId?: string | null; 
  paymentResultUrl?: string | null; 
}

export interface core_apimessages_CheckoutChallengeShopperResponse {
  checkoutUuid?: string | null; 
  adyenPaymentResult?: core_apimessages_AdyenPaymentResult | null; 
  orderBundleId?: string | null; 
  checkoutId?: string | null; 
  paymentResultUrl?: string | null; 
}

export interface core_apimessages_GuestCheckoutApplePayLineItemsResponse {
  lineItems?: (core_apimessages_GuestCheckoutApplePayLineItem | null)[] | null; 
  total?: core_apimessages_GuestCheckoutApplePayLineItem | null; 
}

export interface core_apimessages_GuestCheckoutApplePayLineItem {
  name?: string | null; 
  description?: string | null; 
  amount?: core_apimessages_Money | null; 
}

export interface core_apimessages_GuestCheckoutApplePayPaymentResponse {
  orderBundleId?: string | null; 
  paymentResultUrl?: string | null; 
}

export interface core_apimessages_DeleteAutoOfferResponse {
  autoOffer?: core_apimessages_AutoOffer | null; 
}

export interface core_apimessages_CancelOrderResponse {
  order?: core_apimessages_Order | null; 
  relisted?: boolean | null; 
}

export interface core_apimessages_Order {
  uuid?: string | null; 
  buyerUuid?: string | null; 
  shopUuid?: string | null; 
  listingId?: string | null; 
  status?: core_apimessages_Order_Status | null; 
  shippingMethod?: core_apimessages_ShippingMethod | null; 
  sellerUuid?: string | null; 
  checkoutUuid?: string | null; 
  legacyOrderId?: string | null; 
  createdAt?: google_protobuf_Timestamp | null; 
  settlementAmountProductSubtotal?: core_apimessages_Money | null; 
  quantity?: number | null; 
  legacyBuyerId?: string | null; 
  paidAt?: google_protobuf_Timestamp | null; 
  updatedAt?: google_protobuf_Timestamp | null; 
  shippedAt?: google_protobuf_Timestamp | null; 
  needsFeedbackForBuyer?: boolean | null; 
  needsFeedbackForSeller?: boolean | null; 
  orderType?: string | null; 
  shippingProvider?: string | null; 
  shippingCode?: string | null; 
  amountProduct?: core_apimessages_Money | null; 
  amountTotal?: core_apimessages_Money | null; 
  amountTax?: core_apimessages_Money | null; 
  amountShipping?: core_apimessages_Money | null; 
  statusDescription?: string | null; 
  webTrackingUrl?: string | null; 
  shipmentStatus?: string | null; 
  orderUrl?: core_apimessages_Link | null; 
  mobileStatus?: string | null; 
  carrierCalculatedShippingAmount?: core_apimessages_Money | null; 
}

export interface core_apimessages_TrackBumpInteractionResponse {
  bumpKey?: core_apimessages_BumpKey | null; 
}

export interface core_apimessages_RegisterMyPacklinkAccountResponse {
  shopId?: string | null; 
}

export interface core_apimessages_LoginMyPacklinkAccountResponse {
  shopId?: string | null; 
}

export interface core_apimessages_CreatePacklinkDraftResponse {
  shipment?: core_apimessages_PacklinkShipment | null; 
}

export interface core_apimessages_CreateTaxIdentificationResponse {
  taxIdentification?: core_apimessages_TaxIdentification | null; 
  shopId?: string | null; 
  shop?: MyShop | null; 
}

export interface core_apimessages_UpdateTaxIdentificationResponse {
  taxIdentification?: core_apimessages_TaxIdentification | null; 
  shopId?: string | null; 
  shop?: MyShop | null; 
}

export interface core_apimessages_DeactivateTaxIdentificationResponse {
  taxIdentification?: core_apimessages_TaxIdentification | null; 
  shopId?: string | null; 
  shop?: MyShop | null; 
}

export interface core_apimessages_CreateMyPlaidLinkTokenResponse {
  linkToken?: string | null; 
}

export interface core_apimessages_RequestAccountDeletionResponse {
  uuid?: string | null; 
}

export interface core_apimessages_SaveMyPlaidAccountResponse {
  plaidAccountId?: string | null; 
}

export interface core_apimessages_DelinkUserServiceResponse {
  _?: boolean | null; 
}

export interface core_apimessages_CancelPlaidAccountResponse {
  shopId?: string | null; 
}

export interface core_apimessages_UpdateUniversalPromoCampaignResponse {
  universalPromoCampaign?: core_apimessages_UniversalPromoCampaign | null; 
}

export interface core_apimessages_UniversalPromoCampaign {
  id?: string | null; 
  name?: string | null; 
  code?: string | null; 
  expiresAt?: Timestamp | null; 
  marketingChannel?: string | null; 
  newBuyer?: boolean | null; 
  redemptionLimit?: number | null; 
  hasRedemptionLimit?: boolean | null; 
  universalPromoCurrencies?: (core_apimessages_UniversalPromoCurrency | null)[] | null; 
  categories?: (core_apimessages_NodesCategory | null)[] | null; 
}

export interface core_apimessages_CreateMyCreditCardResponse {
  creditCard?: core_apimessages_CreditCard | null; 
}

export interface core_apimessages_UpdateMyCreditCardResponse {
  creditCard?: core_apimessages_CreditCard | null; 
}

export interface core_apimessages_DeleteMyCreditCardResponse {
  id?: string | null; 
}

export interface reverb_feed_RemoveEntryResponse {
  entry?: reverb_feed_FeedEntry | null; 
}

export interface reverb_feed_SetFollowDigestsByUserResponse {
  follows?: (reverb_feed_Follow | null)[] | null; 
}

export interface arbiter_BulkTrackImpressionsResponse {
  listingIds?: (string | null)[] | null; 
}

export interface braze_TriggerCampaignSendResponse {
  dispatchId?: string | null; 
  message?: string | null; 
}

export interface reverb_config_cache_ExchangeCurrencyResponse {
  amountMinorUnits?: number | null; 
  from?: string | null; 
  to?: string | null; 
}

export interface core_apimessages_UpdateAdvertiserResponse {
  advertiser?: core_apimessages_Advertiser | null; 
}

export interface core_apimessages_Advertiser {
  uuid?: string | null; 
  name?: string | null; 
  brandSlugs?: (string | null)[] | null; 
  shopSlugs?: (string | null)[] | null; 
}

export interface core_apimessages_UpdateAdCampaignResponse {
  adCampaign?: core_apimessages_AdCampaign | null; 
}

export interface core_apimessages_AdCampaign {
  uuid?: string | null; 
  name?: string | null; 
  description?: string | null; 
  status?: core_apimessages_AdCampaign_AdStatus | null; 
  startsAt?: Timestamp | null; 
  endsAt?: Timestamp | null; 
  advertiserUuid?: string | null; 
}

export interface core_apimessages_UpdateAdGroupResponse {
  adGroup?: core_apimessages_AdGroup | null; 
}

export interface core_apimessages_CopyAdGroupResponse {
  adGroup?: core_apimessages_AdGroup | null; 
}

export interface core_apimessages_UpdateAdGroupKeywordsResponse {
  adGroupKeywords?: (core_apimessages_AdGroupKeyword | null)[] | null; 
}

export interface core_apimessages_UpdateAdResponse {
  ad?: core_apimessages_Ad | null; 
}

export interface core_apimessages_UpdateAdZoneResponse {
  adZone?: core_apimessages_AdZone | null; 
}

export interface core_apimessages_DeleteAdResponse {
  ad?: core_apimessages_Ad | null; 
}

export interface google_api_Http {
  rules?: (google_api_HttpRule | null)[] | null; 
  fullyDecodeReservedExpansion?: boolean | null; 
}

export interface google_api_HttpRule {
  selector?: string | null; 
  get?: string | null; 
  put?: string | null; 
  post?: string | null; 
  delete?: string | null; 
  patch?: string | null; 
  custom?: google_api_CustomHttpPattern | null; 
  body?: string | null; 
  additionalBindings?: (google_api_HttpRule | null)[] | null; 
}

export interface google_api_CustomHttpPattern {
  kind?: string | null; 
  path?: string | null; 
}

export interface google_protobuf_FileDescriptorSet {
  file?: (google_protobuf_FileDescriptorProto | null)[] | null; 
}

export interface google_protobuf_FileDescriptorProto {
  name?: string | null; 
  package?: string | null; 
  dependency?: (string | null)[] | null; 
  publicDependency?: (number | null)[] | null; 
  weakDependency?: (number | null)[] | null; 
  messageType?: (google_protobuf_DescriptorProto | null)[] | null; 
  enumType?: (google_protobuf_EnumDescriptorProto | null)[] | null; 
  service?: (google_protobuf_ServiceDescriptorProto | null)[] | null; 
  extension?: (google_protobuf_FieldDescriptorProto | null)[] | null; 
  options?: google_protobuf_FileOptions | null; 
  sourceCodeInfo?: google_protobuf_SourceCodeInfo | null; 
  syntax?: string | null; 
}

export interface google_protobuf_DescriptorProto {
  name?: string | null; 
  field?: (google_protobuf_FieldDescriptorProto | null)[] | null; 
  extension?: (google_protobuf_FieldDescriptorProto | null)[] | null; 
  nestedType?: (google_protobuf_DescriptorProto | null)[] | null; 
  enumType?: (google_protobuf_EnumDescriptorProto | null)[] | null; 
  extensionRange?: (google_protobuf_DescriptorProto_ExtensionRange | null)[] | null; 
  oneofDecl?: (google_protobuf_OneofDescriptorProto | null)[] | null; 
  options?: google_protobuf_MessageOptions | null; 
  reservedRange?: (google_protobuf_DescriptorProto_ReservedRange | null)[] | null; 
  reservedName?: (string | null)[] | null; 
}

export interface google_protobuf_FieldDescriptorProto {
  name?: string | null; 
  number?: number | null; 
  label?: google_protobuf_FieldDescriptorProto_Label | null; 
  type?: google_protobuf_FieldDescriptorProto_Type | null; 
  typeName?: string | null; 
  extendee?: string | null; 
  defaultValue?: string | null; 
  oneofIndex?: number | null; 
  jsonName?: string | null; 
  options?: google_protobuf_FieldOptions | null; 
}

export interface google_protobuf_FieldOptions {
  ctype?: google_protobuf_FieldOptions_CType | null; 
  packed?: boolean | null; 
  jstype?: google_protobuf_FieldOptions_JSType | null; 
  lazy?: boolean | null; 
  deprecated?: boolean | null; 
  weak?: boolean | null; 
  uninterpretedOption?: (google_protobuf_UninterpretedOption | null)[] | null; 
}

export interface google_protobuf_UninterpretedOption {
  name?: (google_protobuf_UninterpretedOption_NamePart | null)[] | null; 
  identifierValue?: string | null; 
  positiveIntValue?: number | null; 
  negativeIntValue?: number | null; 
  doubleValue?: number | null; 
  stringValue?: string | null; 
  aggregateValue?: string | null; 
}

export interface google_protobuf_UninterpretedOption_NamePart {
  namePart?: string | null; 
  isExtension?: boolean | null; 
}

export interface google_protobuf_EnumDescriptorProto {
  name?: string | null; 
  value?: (google_protobuf_EnumValueDescriptorProto | null)[] | null; 
  options?: google_protobuf_EnumOptions | null; 
  reservedRange?: (google_protobuf_EnumDescriptorProto_EnumReservedRange | null)[] | null; 
  reservedName?: (string | null)[] | null; 
}

export interface google_protobuf_EnumValueDescriptorProto {
  name?: string | null; 
  number?: number | null; 
  options?: google_protobuf_EnumValueOptions | null; 
}

export interface google_protobuf_EnumValueOptions {
  deprecated?: boolean | null; 
  uninterpretedOption?: (google_protobuf_UninterpretedOption | null)[] | null; 
}

export interface google_protobuf_EnumOptions {
  allowAlias?: boolean | null; 
  deprecated?: boolean | null; 
  uninterpretedOption?: (google_protobuf_UninterpretedOption | null)[] | null; 
}

export interface google_protobuf_EnumDescriptorProto_EnumReservedRange {
  start?: number | null; 
  end?: number | null; 
}

export interface google_protobuf_DescriptorProto_ExtensionRange {
  start?: number | null; 
  end?: number | null; 
  options?: google_protobuf_ExtensionRangeOptions | null; 
}

export interface google_protobuf_ExtensionRangeOptions {
  uninterpretedOption?: (google_protobuf_UninterpretedOption | null)[] | null; 
}

export interface google_protobuf_OneofDescriptorProto {
  name?: string | null; 
  options?: google_protobuf_OneofOptions | null; 
}

export interface google_protobuf_OneofOptions {
  uninterpretedOption?: (google_protobuf_UninterpretedOption | null)[] | null; 
}

export interface google_protobuf_MessageOptions {
  messageSetWireFormat?: boolean | null; 
  noStandardDescriptorAccessor?: boolean | null; 
  deprecated?: boolean | null; 
  mapEntry?: boolean | null; 
  uninterpretedOption?: (google_protobuf_UninterpretedOption | null)[] | null; 
}

export interface google_protobuf_DescriptorProto_ReservedRange {
  start?: number | null; 
  end?: number | null; 
}

export interface google_protobuf_ServiceDescriptorProto {
  name?: string | null; 
  method?: (google_protobuf_MethodDescriptorProto | null)[] | null; 
  options?: google_protobuf_ServiceOptions | null; 
}

export interface google_protobuf_MethodDescriptorProto {
  name?: string | null; 
  inputType?: string | null; 
  outputType?: string | null; 
  options?: google_protobuf_MethodOptions | null; 
  clientStreaming?: boolean | null; 
  serverStreaming?: boolean | null; 
}

export interface google_protobuf_MethodOptions {
  deprecated?: boolean | null; 
  idempotencyLevel?: google_protobuf_MethodOptions_IdempotencyLevel | null; 
  uninterpretedOption?: (google_protobuf_UninterpretedOption | null)[] | null; 
}

export interface google_protobuf_ServiceOptions {
  deprecated?: boolean | null; 
  uninterpretedOption?: (google_protobuf_UninterpretedOption | null)[] | null; 
}

export interface google_protobuf_FileOptions {
  javaPackage?: string | null; 
  javaOuterClassname?: string | null; 
  javaMultipleFiles?: boolean | null; 
  javaGenerateEqualsAndHash?: boolean | null; 
  javaStringCheckUtf8?: boolean | null; 
  optimizeFor?: google_protobuf_FileOptions_OptimizeMode | null; 
  goPackage?: string | null; 
  ccGenericServices?: boolean | null; 
  javaGenericServices?: boolean | null; 
  pyGenericServices?: boolean | null; 
  phpGenericServices?: boolean | null; 
  deprecated?: boolean | null; 
  ccEnableArenas?: boolean | null; 
  objcClassPrefix?: string | null; 
  csharpNamespace?: string | null; 
  swiftPrefix?: string | null; 
  phpClassPrefix?: string | null; 
  phpNamespace?: string | null; 
  uninterpretedOption?: (google_protobuf_UninterpretedOption | null)[] | null; 
}

export interface google_protobuf_SourceCodeInfo {
  location?: (google_protobuf_SourceCodeInfo_Location | null)[] | null; 
}

export interface google_protobuf_SourceCodeInfo_Location {
  path?: (number | null)[] | null; 
  span?: (number | null)[] | null; 
  leadingComments?: string | null; 
  trailingComments?: string | null; 
  leadingDetachedComments?: (string | null)[] | null; 
}

export interface google_protobuf_GeneratedCodeInfo_Annotation {
  path?: (number | null)[] | null; 
  sourceFile?: string | null; 
  begin?: number | null; 
  end?: number | null; 
}

export interface google_protobuf_GeneratedCodeInfo {
  annotation?: (google_protobuf_GeneratedCodeInfo_Annotation | null)[] | null; 
}

export interface mparticle_TokenRequest {
  clientId?: string | null; 
  clientSecret?: string | null; 
  audience?: string | null; 
  grantType?: string | null; 
}

export interface mparticle_TokenResponse {
  accessToken?: string | null; 
  tokenType?: string | null; 
  expiresIn?: number | null; 
}

export interface mparticle_Identity {
  type?: string | null; 
  value?: string | null; 
}

export interface mparticle_ProfileRequest {
  orgId?: string | null; 
  accountId?: string | null; 
  workspaceId?: string | null; 
  environmentType?: string | null; 
  identity?: mparticle_Identity | null; 
}

export interface mparticle_MparticleOauth {
  Token?: mparticle_TokenResponse | null; 
}

export interface mparticle_Mparticle {
  Profile?: mparticle_ProfileResponse | null; 
}

export interface reverb_feed_PruneFeedRequest {
  userId?: string | null; 
  savedSearchId?: number | null; 
  fromFeedService?: boolean | null; 
}

export interface reverb_feed_RemoveEntryRequest {
  entryId?: string | null; 
  userId?: string | null; 
  entryType?: reverb_feed_FeedEntry_EntryType | null; 
}

export interface reverb_feed_PruneFeedResponse {
  _?: boolean | null; 
}

export interface reverb_feed_AlertableUsersRequest {
  _?: boolean | null; 
}

export interface reverb_feed_AlertableUsersStreamRequest {
  chunkSize?: number | null; 
}

export interface reverb_feed_AlertableUsersResponse {
  userIds?: (string | null)[] | null; 
}

export interface reverb_feed_DigestFollows {
  follow?: reverb_feed_Follow | null; 
  entries?: (reverb_feed_FeedEntry | null)[] | null; 
}

export interface reverb_feed_UserDigest {
  userId?: string | null; 
  digestFollows?: (reverb_feed_DigestFollows | null)[] | null; 
}

export interface reverb_feed_UserDigestsResponse {
  userDigests?: (reverb_feed_UserDigest | null)[] | null; 
}

export interface reverb_feed_User {
  userId?: string | null; 
  locale?: string | null; 
  lastActiveAt?: Timestamp | null; 
}

export interface reverb_feed_UserDigestsRequest {
  users?: (reverb_feed_User | null)[] | null; 
  matchedAfter?: Timestamp | null; 
}

export interface reverb_feed_ClearUserDigestRequest {
  userId?: string | null; 
}

export interface reverb_feed_ClearUserDigestResponse {
  _?: boolean | null; 
}

export interface reverb_feed_CreateFollowResponse {
  follow?: reverb_feed_Follow | null; 
}

export interface reverb_feed_RemoveFollowRequest {
  follow?: reverb_feed_Follow | null; 
  locale?: string | null; 
  removeEntries?: boolean | null; 
}

export interface reverb_feed_RemoveFollowsBySearchableRequest {
  searchableId?: number | null; 
  searchableType?: reverb_feed_SearchableType | null; 
}

export interface reverb_feed_RemoveFollowsBySearchableResponse {
  _?: boolean | null; 
}

export interface reverb_feed_UpsertFollowResponse {
  follow?: reverb_feed_Follow | null; 
  following?: boolean | null; 
  followCount?: number | null; 
}

export interface reverb_feed_SetFollowDigestRequest {
  id?: string | null; 
  userId?: string | null; 
  digestEnabled?: boolean | null; 
  locale?: string | null; 
}

export interface reverb_feed_SetFollowDigestResponse {
  follow?: reverb_feed_Follow | null; 
}

export interface reverb_feed_SetFollowDigestsByUserRequest {
  userId?: string | null; 
  digestsEnabled?: boolean | null; 
}

export interface reverb_feed_EntriesRequest {
  userId?: string | null; 
  perPage?: number | null; 
  page?: number | null; 
  offset?: number | null; 
  locale?: string | null; 
  limit?: number | null; 
  readFromDatabase?: boolean | null; 
}

export interface reverb_feed_FollowsRequest {
  userId?: string | null; 
  perPage?: number | null; 
  page?: number | null; 
  offset?: number | null; 
  locale?: string | null; 
}

export interface reverb_feed_FeedEntryUpdated {
  action?: reverb_feed_FeedEntryUpdated_Action | null; 
  entries?: (reverb_feed_FeedEntry | null)[] | null; 
  userId?: number | null; 
  sourceId?: number | null; 
  sourceType?: reverb_feed_FeedSourceType | null; 
  sourceIds?: (number | null)[] | null; 
  entityUpdatedAt?: Timestamp | null; 
  userIds?: (number | null)[] | null; 
}

export interface reverb_feed_FollowsTopic {
  action?: reverb_feed_FollowsTopic_Action | null; 
  followId?: number | null; 
  userId?: number | null; 
  searchableId?: number | null; 
  searchableType?: reverb_feed_SearchableType | null; 
}

export interface reverb_feed_GetFollowResponse {
  following?: boolean | null; 
  follow?: reverb_feed_Follow | null; 
  followCount?: number | null; 
}

export interface reverb_feed_FindFollowBySearchableRequest {
  searchableId?: string | null; 
  searchableType?: reverb_feed_SearchableType | null; 
  userId?: string | null; 
}

export interface reverb_feed_FindFollowsBySearchableRequest {
  searchableId?: string | null; 
  searchableType?: reverb_feed_SearchableType | null; 
  limit?: number | null; 
  offset?: number | null; 
}

export interface reverb_feed_FindFollowsBySearchableResponse {
  follows?: (reverb_feed_Follow | null)[] | null; 
  limit?: number | null; 
  offset?: number | null; 
  total?: number | null; 
}

export interface reverb_feed_FindFollowByIdRequest {
  id?: string | null; 
  userId?: string | null; 
}

export interface reverb_feed_FindFollowRequest {
  queryParams?: string | null; 
  userId?: string | null; 
}

export interface reverb_feed_GetSavedSearchRequest {
  id?: number | null; 
  withMostRecentFollow?: boolean | null; 
}

export interface reverb_feed_GetSavedSearchResponse {
  esQuery?: string | null; 
  mostRecentFollowedUserId?: string | null; 
  queryParams?: string | null; 
}

export interface reverb_feed_CreateSavedSearchRequest {
  esQuery?: string | null; 
  searchableType?: reverb_feed_SearchableType | null; 
  queryParams?: string | null; 
  searchableUuid?: string | null; 
  localizedContents?: (reverb_feed_FollowLocalizedContents | null)[] | null; 
}

export interface reverb_feed_CreateSavedSearchResponse {
  id?: number | null; 
}

export interface reverb_feed_UpdateSavedSearchRequest {
  id?: number | null; 
  esQuery?: string | null; 
}

export interface reverb_feed_UpdateSavedSearchResponse {
  id?: number | null; 
}

export interface reverb_feed_FollowUpdated {
  savedSearchId?: number | null; 
  userId?: number | null; 
  esQuery?: string | null; 
  searchableType?: reverb_feed_SearchableType | null; 
  searchableId?: number | null; 
  queryParams?: string | null; 
  searchableUuid?: string | null; 
  id?: string | null; 
  localizedContents?: (reverb_feed_FollowLocalizedContents | null)[] | null; 
  digestEnabled?: boolean | null; 
}

export interface reverb_feed_DigestListings {
  listingIds?: (string | null)[] | null; 
}

export interface reverb_feed_GetFollowedSavedSearchesRequest {
  startId?: number | null; 
}

export interface reverb_feed_GetFollowedSavedSearchesResponse {
  savedSearchIds?: (number | null)[] | null; 
}

export interface reverb_feed_Users {
  users?: (reverb_feed_User | null)[] | null; 
}

export interface reverb_feed_FeedService {
  GetFeedEntries?: reverb_feed_FeedResponse | null; 
  GetFollows?: reverb_feed_GetFollowsResponse | null; 
  FindFollow?: reverb_feed_GetFollowResponse | null; 
  FindFollowBySearchable?: reverb_feed_GetFollowResponse | null; 
  FindFollowById?: reverb_feed_GetFollowResponse | null; 
  FindFollowsBySearchable?: reverb_feed_FindFollowsBySearchableResponse | null; 
  GetSavedSearch?: reverb_feed_GetSavedSearchResponse | null; 
  CreateSavedSearch?: reverb_feed_CreateSavedSearchResponse | null; 
  UpdateSavedSearch?: reverb_feed_UpdateSavedSearchResponse | null; 
  RemoveFollow?: reverb_feed_GetFollowsResponse | null; 
  RemoveFollowsBySearchable?: reverb_feed_RemoveFollowsBySearchableResponse | null; 
  UpsertFollow?: reverb_feed_UpsertFollowResponse | null; 
  SetFollowDigest?: reverb_feed_SetFollowDigestResponse | null; 
  SetFollowDigestsByUser?: reverb_feed_SetFollowDigestsByUserResponse | null; 
  GetAlertableUsers?: reverb_feed_AlertableUsersResponse | null; 
  GetAlertableUsersStream?: reverb_feed_AlertableUsersResponse | null; 
  GetUserDigests?: reverb_feed_UserDigestsResponse | null; 
  ClearUserDigest?: reverb_feed_ClearUserDigestResponse | null; 
  PruneFeed?: reverb_feed_PruneFeedResponse | null; 
  RemoveEntry?: reverb_feed_RemoveEntryResponse | null; 
  GetFollowedSavedSearches?: reverb_feed_GetFollowedSavedSearchesResponse | null; 
}

export interface reverb_updates_Update {
  action?: reverb_updates_Update_Action | null; 
  entity?: reverb_updates_Entity | null; 
  userIds?: (string | null)[] | null; 
  createdAt?: string | null; 
  updateId?: number | null; 
}

export interface reverb_updates_Entity {
  entityType?: reverb_updates_Entity_EntityType | null; 
  entityId?: string | null; 
  metadata?: reverb_updates_Metadata | null; 
  entity?: rql_UpdateEntity | null; 
}

export interface reverb_updates_Metadata {
  priceDrop?: reverb_updates_PriceDrop | null; 
  listing?: reverb_updates_Listing | null; 
  siteBanner?: reverb_updates_SiteBanner | null; 
  categories?: (reverb_updates_Category | null)[] | null; 
  cartCount?: number | null; 
  shop?: reverb_updates_Shop | null; 
  listingsCount?: number | null; 
  listings?: (reverb_updates_Listing | null)[] | null; 
  offerCount?: number | null; 
  sale?: reverb_updates_Sale | null; 
  promotion?: reverb_updates_Promotion | null; 
}

export interface reverb_updates_PriceDrop {
  id?: string | null; 
  listingId?: string | null; 
}

export interface reverb_updates_Listing {
  id?: string | null; 
}

export interface reverb_updates_SiteBanner {
  id?: string | null; 
}

export interface reverb_updates_Category {
  uuid?: string | null; 
}

export interface reverb_updates_Shop {
  id?: string | null; 
}

export interface reverb_updates_Sale {
  id?: string | null; 
}

export interface reverb_updates_Promotion {
  id?: string | null; 
}

export interface reverb_updates_MyUpdatesRequest {
  userId?: string | null; 
}

export interface reverb_updates_MyUpdatesResponse {
  updates?: (reverb_updates_Update | null)[] | null; 
}

export interface reverb_updates_CreateMyUpdateRequest {
  entity?: reverb_updates_Entity | null; 
}

export interface reverb_updates_MyUpdateResponse {
  update?: reverb_updates_Update | null; 
}

export interface reverb_updates_PruneMyUpdates {
  pruneType?: reverb_updates_PruneMyUpdates_PruneType | null; 
  userId?: number | null; 
  updateId?: number | null; 
}

export interface reverb_updates_UpdatesService {
  GetMyUpdates?: reverb_updates_MyUpdatesResponse | null; 
  CreateMyUpdate?: reverb_updates_MyUpdateResponse | null; 
}

export interface core_apimessages_MoneyMinorUnitsEntry {
  amountCents?: number | null; 
  currency?: string | null; 
}

export interface core_apimessages_MoneyMajorUnitsEntry {
  amount?: string | null; 
  currency?: string | null; 
}

export interface reverb_signals_SignalRequest {
  groups?: (reverb_signals_Signal_Group | null)[] | null; 
  imageType?: reverb_signals_SignalImageType | null; 
}

export interface cms_AdminTakeSlugRequest {
  currentSlug?: string | null; 
  desiredSlug?: string | null; 
}

export interface cms_AdminTakeSlugResponse {
  updatedSlug?: string | null; 
  legacySlug?: string | null; 
}

export interface cms_AdminClonePageRequest {
  slug?: string | null; 
}

export interface cms_AdminClonePageResponse {
  clonedPageSlug?: string | null; 
}

export interface cms_AdminCreatePage {
  id?: string | null; 
  goLiveAt?: string | null; 
  imageAttributionUri?: string | null; 
  authorId?: string | null; 
  pageType?: string | null; 
  imageKey?: string | null; 
  slug?: string | null; 
  channels?: (string | null)[] | null; 
  componentIds?: (string | null)[] | null; 
  localizedContents?: (cms_PageLocalizedContent | null)[] | null; 
  layoutId?: string | null; 
  metaImageKey?: string | null; 
  headerStyle?: string | null; 
  noIndex?: boolean | null; 
  secondaryImageKey?: string | null; 
  pageTemplateId?: string | null; 
}

export interface cms_PageLocalizedContent {
  locale?: string | null; 
  title?: string | null; 
  description?: string | null; 
  metaTitle?: string | null; 
  metaDescription?: string | null; 
  actionText?: string | null; 
  actionUrl?: string | null; 
  searchPlaceholder?: string | null; 
  customVariableData?: string | null; 
  breadcrumbs?: string | null; 
}

export interface cms_AdminPageCreateRequest {
  page?: cms_AdminCreatePage | null; 
}

export interface cms_AdminPageIndexRequest {
  page?: string | null; 
  perPage?: string | null; 
  q?: string | null; 
  ids?: (string | null)[] | null; 
  pageType?: string | null; 
  channels?: (string | null)[] | null; 
}

export interface cms_AdminCreatePageTemplate {
  id?: string | null; 
  name?: string | null; 
  layoutId?: string | null; 
  customVariables?: (string | null)[] | null; 
}

export interface cms_AdminCreatePageTemplateRequest {
  pageTemplate?: cms_AdminCreatePageTemplate | null; 
}

export interface cms_AdminPagesResponse {
  pages?: (cms_Page | null)[] | null; 
  meta?: cms_Pagination | null; 
}

export interface cms_Page {
  id?: string | null; 
  slug?: string | null; 
  goLiveAt?: string | null; 
  componentIds?: (string | null)[] | null; 
  imageAttributionUri?: string | null; 
  imageKey?: string | null; 
  authorId?: string | null; 
  pageType?: string | null; 
  channels?: (string | null)[] | null; 
  localizedContents?: (cms_PageLocalizedContent | null)[] | null; 
  layoutId?: string | null; 
  metaImageKey?: string | null; 
  headerStyle?: string | null; 
  noIndex?: boolean | null; 
  secondaryImageKey?: string | null; 
  pageTemplateId?: string | null; 
}

export interface cms_Pagination {
  total?: number | null; 
  currentPage?: number | null; 
  perPage?: number | null; 
}

export interface cms_AdminComponentsResponse {
  components?: (cms_Component | null)[] | null; 
}

export interface cms_Component {
  id?: string | null; 
  pageId?: string | null; 
  position?: number | null; 
  componentType?: string | null; 
  localizedContents?: (cms_ComponentLocalizedContent | null)[] | null; 
  layoutSection?: string | null; 
  targetCountries?: (string | null)[] | null; 
  blacklistCountries?: (string | null)[] | null; 
  active?: boolean | null; 
  experimentKey?: string | null; 
  experimentBucket?: string | null; 
  type?: string | null; 
  pageTemplateId?: string | null; 
}

export interface cms_ComponentLocalizedContent {
  locale?: string | null; 
  data?: string | null; 
}

export interface cms_AdminDeletePageRequest {
  id?: string | null; 
}

export interface cms_Author {
  id?: string | null; 
  slug?: string | null; 
  name?: string | null; 
}

export interface cms_AuthorIndexResponse {
  authors?: (cms_Author | null)[] | null; 
}

export interface cms_AuthorRequest {
  author?: cms_Author | null; 
}

export interface cms_AuthorResponse {
  author?: cms_Author | null; 
}

export interface cms_AdminPageTemplateIndexRequest {
  page?: string | null; 
  perPage?: string | null; 
  q?: string | null; 
  ids?: (string | null)[] | null; 
}

export interface cms_PageTemplateIndexResponse {
  pageTemplates?: (cms_PageTemplate | null)[] | null; 
  meta?: cms_Pagination | null; 
}

export interface cms_PageTemplate {
  id?: string | null; 
  name?: string | null; 
  layoutId?: string | null; 
  customVariables?: (string | null)[] | null; 
}

export interface cms_PageTemplateResponse {
  pageTemplate?: cms_PageTemplate | null; 
}

export interface cms_PageTemplatePageInfo {
  pageTemplateId?: string | null; 
  pageCount?: number | null; 
  pageTitles?: (string | null)[] | null; 
}

export interface cms_PageTemplatePageInfoResponse {
  pageTemplatePageInfo?: (cms_PageTemplatePageInfo | null)[] | null; 
}

export interface cms_ComponentDeleteRequest {
  id?: string | null; 
}

export interface cms_ComponentResponse {
  component?: cms_Component | null; 
}

export interface cms_ComponentRequest {
  component?: cms_Component | null; 
}

export interface cms_BulkComponentResponse {
  components?: (cms_Component | null)[] | null; 
}

export interface cms_BulkComponentRequest {
  components?: (cms_Component | null)[] | null; 
}

export interface cms_ComponentsRequest {
  ids?: (string | null)[] | null; 
  layoutSection?: string | null; 
  pageId?: string | null; 
}

export interface cms_ComponentTemplatesRequest {
  pageTemplateId?: string | null; 
  layoutSection?: string | null; 
}

export interface cms_Layout {
  id?: string | null; 
  name?: string | null; 
  sections?: (string | null)[] | null; 
}

export interface cms_LayoutsResponse {
  layouts?: (cms_Layout | null)[] | null; 
}

export interface cms_LayoutsIndexRequest {
  ids?: (string | null)[] | null; 
  q?: string | null; 
}

export interface cms_NodeRequest_Lookup {
  lid?: string | null; 
  rel?: string | null; 
}

export interface cms_NodeRequest {
  lookups?: (cms_NodeRequest_Lookup | null)[] | null; 
}

export interface cms_NodeResponse_Result_Meta {
  total?: number | null; 
}

export interface cms_NodeResponse_Result {
  lookup?: cms_NodeRequest_Lookup | null; 
  meta?: cms_NodeResponse_Result_Meta | null; 
  publicComponents?: (cms_PublicComponent | null)[] | null; 
}

export interface cms_NodeResponse {
  results?: (cms_NodeResponse_Result | null)[] | null; 
}

export interface cms_PageRequest {
  page?: cms_PublicPage | null; 
}

export interface cms_PageResponse {
  page?: cms_Page | null; 
}

export interface cms_PagesRequest {
  ids?: (string | null)[] | null; 
  slugs?: (string | null)[] | null; 
  includeDrafts?: string | null; 
  pageType?: string | null; 
  limit?: string | null; 
  offset?: string | null; 
  channels?: (string | null)[] | null; 
  excludeBlacklistedEmbeds?: boolean | null; 
  pageTypes?: (string | null)[] | null; 
  query?: string | null; 
}

export interface cms_PublicAPI {
  GetPages?: cms_PagesResponse | null; 
  NodesPublicComponents?: cms_NodeResponse | null; 
}

export interface reverb_event_SessionStart {
  userContext?: reverb_event_UserContext | null; 
  referer?: string | null; 
  url?: string | null; 
  aid?: string | null; 
  utmCampaign?: string | null; 
  requestId?: string | null; 
  id?: string | null; 
  utmSource?: string | null; 
  utmMedium?: string | null; 
  gsPartner?: string | null; 
}

export interface reverb_event_UserContext {
  id?: string | null; 
  cookieId?: string | null; 
  distinctId?: string | null; 
  device?: reverb_event_Device | null; 
  experiments?: (reverb_event_Experiment | null)[] | null; 
  timestamp?: string | null; 
  adminId?: string | null; 
  bot?: boolean | null; 
  locale?: string | null; 
  currency?: string | null; 
  shippingRegion?: string | null; 
  lat?: number | null; 
  long?: number | null; 
  lastGoogleClick?: reverb_event_GoogleShoppingClick | null; 
  requestId?: string | null; 
  sellerSitesId?: string | null; 
  reverbApp?: string | null; 
  hasLoggedIn?: boolean | null; 
  countryCode?: string | null; 
  sessionId?: string | null; 
  advertisingId?: string | null; 
  signalSciencesBot?: boolean | null; 
  signalSciencesBadBot?: boolean | null; 
  signalSciencesIp?: boolean | null; 
  signalSciencesTornode?: boolean | null; 
}

export interface reverb_event_Device {
  name?: string | null; 
  userAgent?: string | null; 
  version?: string | null; 
  appVersion?: string | null; 
  osVersion?: string | null; 
  manufacturer?: string | null; 
  brand?: string | null; 
  model?: string | null; 
}

export interface reverb_event_GoogleShoppingClick {
  productId?: string | null; 
  comparisonShoppingPageId?: string | null; 
  timestamp?: string | null; 
  origin?: string | null; 
}

export interface reverb_event_ComponentInteraction {
  componentName?: string | null; 
  interactionType?: string | null; 
  url?: string | null; 
  referer?: string | null; 
  userContext?: reverb_event_UserContext | null; 
  context?: string | null; 
  entityId?: string | null; 
  entityType?: string | null; 
  position?: number | null; 
  page?: number | null; 
  perPage?: number | null; 
  totalResults?: number | null; 
  targetUrl?: string | null; 
  pageViewId?: string | null; 
  impressionUuid?: string | null; 
  utmSource?: string | null; 
  utmMedium?: string | null; 
  utmCampaign?: string | null; 
  freeTextQuery?: string | null; 
  bumped?: boolean | null; 
}

export interface reverb_event_ComponentsView {
  componentName?: string | null; 
  context?: string | null; 
  url?: string | null; 
  referer?: string | null; 
  userContext?: reverb_event_UserContext | null; 
  entityIds?: (string | null)[] | null; 
  entityType?: string | null; 
  pageViewId?: string | null; 
  impressionUuid?: string | null; 
  algorithmVersion?: string | null; 
  utmSource?: string | null; 
  utmMedium?: string | null; 
  utmCampaign?: string | null; 
}

export interface reverb_event_ComparisonShoppingPageClick {
  comparisonShoppingPage?: reverb_event_ComparisonShoppingPage | null; 
  userContext?: reverb_event_UserContext | null; 
  url?: string | null; 
  referer?: string | null; 
  componentName?: string | null; 
}

export interface reverb_event_ComparisonShoppingPage {
  id?: string | null; 
  lowestPriceForNew?: reverb_event_Price | null; 
  lowestPriceForUsed?: reverb_event_Price | null; 
  usedListingCount?: number | null; 
  newListingCount?: number | null; 
}

export interface reverb_event_Price {
  amount?: number | null; 
  currency?: string | null; 
}

export interface reverb_event_FollowAdded {
  userContext?: reverb_event_UserContext | null; 
  referer?: string | null; 
  searchableType?: string | null; 
  searchableId?: string | null; 
  searchParams?: string | null; 
}

export interface reverb_event_UserSignedIn {
  userContext?: reverb_event_UserContext | null; 
  referer?: string | null; 
  userId?: string | null; 
  signup?: boolean | null; 
}

export interface reverb_event_TrackingPixelEvent {
  name?: string | null; 
  data?: string | null; 
}

export interface reverb_event_PMBView {
  userContext?: reverb_event_UserContext | null; 
  persona?: string | null; 
  listings?: (reverb_event_Listing | null)[] | null; 
  utmCampaign?: string | null; 
}

export interface reverb_event_Listing {
  id?: string | null; 
  price?: reverb_event_Price | null; 
  status?: string | null; 
  categoryUuids?: (string | null)[] | null; 
  bumped?: boolean | null; 
  canonicalProductId?: string | null; 
}

export interface reverb_event_MarketingEmailView {
  userContext?: reverb_event_UserContext | null; 
  listings?: (reverb_event_Listing | null)[] | null; 
  utmCampaign?: string | null; 
  upsellOrderId?: string | null; 
  persona?: string | null; 
  entityIds?: (string | null)[] | null; 
  entityType?: string | null; 
}

export interface reverb_event_MailLinkClick {
  userContext?: reverb_event_UserContext | null; 
  utmCampaign?: string | null; 
  url?: string | null; 
  sourceType?: string | null; 
  sourceId?: string | null; 
  variations?: string | null; 
}

export interface reverb_event_MessagesMailer {
  userContext?: reverb_event_UserContext | null; 
  messageId?: string | null; 
  action?: string | null; 
}

export interface reverb_event_WatcherListingSoldMailer {
  userContext?: reverb_event_UserContext | null; 
  action?: string | null; 
  productId?: string | null; 
  orderId?: string | null; 
  similarProductIds?: (string | null)[] | null; 
  comparisonShoppingPageId?: string | null; 
}

export interface reverb_event_GenericMailer {
  userContext?: reverb_event_UserContext | null; 
  emailType?: string | null; 
  action?: string | null; 
  sourceType?: string | null; 
  sourceId?: string | null; 
  utmCampaign?: string | null; 
  variations?: string | null; 
}

export interface reverb_event_WatchAdded {
  userContext?: reverb_event_UserContext | null; 
  referer?: string | null; 
  listingId?: string | null; 
  watchId?: string | null; 
}

export interface reverb_event_AdminAbilityAndAbilityProfileUpdated {
  abilityManagerUserId?: string | null; 
  abilityRecipientUserId?: string | null; 
  adHocAbilities?: (string | null)[] | null; 
  abilityProfiles?: (string | null)[] | null; 
}

export interface reverb_event_ClickStats {
  entityType?: string | null; 
  entityId?: string | null; 
  impressions?: number | null; 
  clicks?: number | null; 
  bumpImpressions?: number | null; 
  bumpClicks?: number | null; 
}

export interface reverb_event_DigitalListing {
  id?: string | null; 
  price?: reverb_event_Price | null; 
  status?: string | null; 
  categoryUuids?: (string | null)[] | null; 
}

export interface reverb_event_CanonicalProduct {
  id?: string | null; 
}

export interface reverb_event_Article {
  id?: string | null; 
}

export interface reverb_event_AttributeChange {
  name?: string | null; 
  previousValue?: string | null; 
  newValue?: string | null; 
}

export interface reverb_event_Message {
  id?: string | null; 
  conversationId?: string | null; 
}

export interface reverb_event_MobileInteraction {
  name?: string | null; 
  action?: string | null; 
  type?: reverb_event_MobileInteraction_InteractionType | null; 
  context?: string | null; 
  userContext?: reverb_event_UserContext | null; 
}

export interface reverb_event_Error {
  error?: string | null; 
  userContext?: reverb_event_UserContext | null; 
}

export interface reverb_event_EntityUpdated {
  name?: string | null; 
  id?: string | null; 
  timestamp?: string | null; 
  action?: reverb_event_EntityUpdated_Action | null; 
}

export interface reverb_event_OrderUpdated {
  userContext?: reverb_event_UserContext | null; 
  id?: string | null; 
  status?: string | null; 
  listing?: reverb_event_Listing | null; 
  buyerId?: string | null; 
  createdAt?: string | null; 
}

export interface reverb_event_OrderPaid {
  userContext?: reverb_event_UserContext | null; 
  id?: string | null; 
  listingId?: string | null; 
  buyerId?: string | null; 
}

export interface reverb_event_NegotiationUpdated {
  userContext?: reverb_event_UserContext | null; 
  status?: string | null; 
  id?: string | null; 
  lastOfferId?: string | null; 
  listing?: reverb_event_Listing | null; 
}

export interface reverb_event_NegotiationStarted {
  userContext?: reverb_event_UserContext | null; 
  id?: string | null; 
  buyerInitiated?: boolean | null; 
  offerId?: string | null; 
  buyerId?: string | null; 
  listingIds?: (string | null)[] | null; 
}

export interface reverb_event_ConversationUpdated {
  userContext?: reverb_event_UserContext | null; 
  id?: string | null; 
  initialRecipientId?: string | null; 
  initialAuthorId?: string | null; 
  listing?: reverb_event_Listing | null; 
  lastMessageId?: string | null; 
  requestId?: string | null; 
}

export interface reverb_event_UserUpdated {
  userContext?: reverb_event_UserContext | null; 
  id?: string | null; 
  status?: string | null; 
  newsletterOptIn?: boolean | null; 
}

export interface reverb_event_ListingMatched {
  userContext?: reverb_event_UserContext | null; 
  listingId?: string | null; 
  canonicalProductId?: string | null; 
}

export interface reverb_event_ListingUpdated {
  userContext?: reverb_event_UserContext | null; 
  listing?: reverb_event_Listing | null; 
  changes?: (reverb_event_AttributeChange | null)[] | null; 
}

export interface reverb_event_CanonicalProductUpdated {
  userContext?: reverb_event_UserContext | null; 
  canonicalProduct?: reverb_event_CanonicalProduct | null; 
  changes?: (reverb_event_AttributeChange | null)[] | null; 
}

export interface reverb_event_MessageUpdated {
  userContext?: reverb_event_UserContext | null; 
  message?: reverb_event_Message | null; 
  changes?: (reverb_event_AttributeChange | null)[] | null; 
}

export interface reverb_event_ShippingLabelUpdated {
  userContext?: reverb_event_UserContext | null; 
  id?: string | null; 
  status?: string | null; 
}

export interface reverb_event_FollowUpdated {
  userContext?: reverb_event_UserContext | null; 
  id?: string | null; 
  savedSearchId?: string | null; 
  destroyed?: boolean | null; 
}

export interface reverb_event_BumpsReserved {
  userContext?: reverb_event_UserContext | null; 
  amount?: number | null; 
  price?: reverb_event_Price | null; 
  listing?: reverb_event_Listing | null; 
  budgetType?: string | null; 
}

export interface reverb_event_AddedToCart {
  userContext?: reverb_event_UserContext | null; 
  listing?: reverb_event_Listing | null; 
  otherListings?: (reverb_event_Listing | null)[] | null; 
  referer?: string | null; 
  aid?: string | null; 
  cartItemUuid?: string | null; 
}

export interface reverb_event_RemovedFromCart {
  userContext?: reverb_event_UserContext | null; 
  listing?: reverb_event_Listing | null; 
  cartItemUuid?: string | null; 
}

export interface reverb_event_DiscountCodeApplied {
  userContext?: reverb_event_UserContext | null; 
  discountCode?: string | null; 
  success?: boolean | null; 
  referer?: string | null; 
  error?: string | null; 
}

export interface reverb_event_ShopEmptied {
  shopId?: string | null; 
}

export interface reverb_event_Event {
  messageName?: string | null; 
  payload?: string | null; 
  level?: string | null; 
}

export interface reverb_event_EventRequest {
  events?: (reverb_event_Event | null)[] | null; 
}

export interface reverb_event_AttributedLanding {
  landingId?: string | null; 
  landingTime?: string | null; 
  userId?: string | null; 
  aid?: string | null; 
  referer?: string | null; 
  url?: string | null; 
  utmCampaign?: string | null; 
  cookieId?: string | null; 
  userShippingRegion?: string | null; 
  landingDevice?: string | null; 
  landingBucket?: string | null; 
  orderedAt?: string | null; 
  productId?: string | null; 
  orderId?: string | null; 
  orderDevice?: string | null; 
  registeredAt?: string | null; 
}

export interface reverb_event_UserSignedUp {
  newsletterOptIn?: boolean | null; 
  userId?: string | null; 
  registrationSource?: string | null; 
  referer?: string | null; 
  aid?: string | null; 
  utmCampaign?: string | null; 
  url?: string | null; 
  countryCode?: string | null; 
  sourceProductUuid?: string | null; 
  userContext?: reverb_event_UserContext | null; 
}

export interface reverb_event_ContestSignUp {
  userContext?: reverb_event_UserContext | null; 
  referer?: string | null; 
  aid?: string | null; 
  utmCampaign?: string | null; 
  questionResponse?: string | null; 
}

export interface reverb_event_MailListSignUp {
  userContext?: reverb_event_UserContext | null; 
  email?: string | null; 
  referer?: string | null; 
  listId?: string | null; 
  countryCode?: string | null; 
  source?: string | null; 
  sourceProductUuid?: string | null; 
  userId?: string | null; 
}

export interface reverb_event_ComparisonShoppingPageView {
  listings?: (reverb_event_Listing | null)[] | null; 
  canonicalProductIds?: (string | null)[] | null; 
  lowestPriceForNew?: reverb_event_Price | null; 
  lowestPriceForUsed?: reverb_event_Price | null; 
  userContext?: reverb_event_UserContext | null; 
  requestId?: string | null; 
  buyButtonListingId?: string | null; 
  buyButtonListingType?: string | null; 
  comparisonShoppingPageId?: string | null; 
  buyButtonReason?: string | null; 
  priceGuideId?: string | null; 
  condition?: string | null; 
  referer?: string | null; 
  url?: string | null; 
  utmCampaign?: string | null; 
  utmSource?: string | null; 
  utmMedium?: string | null; 
}

export interface reverb_event_ListingsView {
  listings?: (reverb_event_Listing | null)[] | null; 
  query?: string | null; 
  totalResults?: number | null; 
  userContext?: reverb_event_UserContext | null; 
  viewType?: string | null; 
  curatedLinkIds?: (string | null)[] | null; 
  curatedSetIds?: (string | null)[] | null; 
  bumpedListings?: (reverb_event_Listing | null)[] | null; 
  featuredListing?: reverb_event_Listing | null; 
  requestId?: string | null; 
  bumpAlgorithm?: string | null; 
  url?: string | null; 
  referer?: string | null; 
  utmCampaign?: string | null; 
  aid?: string | null; 
  resultCount?: number | null; 
  version?: number | null; 
  responseTime?: number | null; 
  fallbackStrategy?: string | null; 
  fallbackListings?: (reverb_event_Listing | null)[] | null; 
  totalFallbackListings?: number | null; 
}

export interface reverb_event_ListingView {
  userContext?: reverb_event_UserContext | null; 
  listing?: reverb_event_Listing | null; 
  requestId?: string | null; 
  url?: string | null; 
  referer?: string | null; 
  aid?: string | null; 
  utmCampaign?: string | null; 
}

export interface reverb_event_ListingViewRelatedContent {
  userContext?: reverb_event_UserContext | null; 
  listingViewListingId?: string | null; 
  type?: string | null; 
  url?: string | null; 
  referer?: string | null; 
  listings?: (reverb_event_Listing | null)[] | null; 
  articles?: (reverb_event_Article | null)[] | null; 
}

export interface reverb_event_DigitalListingView {
  userContext?: reverb_event_UserContext | null; 
  digitalListing?: reverb_event_DigitalListing | null; 
  requestId?: string | null; 
}

export interface reverb_event_DigitalListingDownload {
  userContext?: reverb_event_UserContext | null; 
  digitalListingId?: string | null; 
  digitalVariantId?: string | null; 
  requestId?: string | null; 
}

export interface reverb_event_CuratedSetView {
  curatedSetId?: string | null; 
  userContext?: reverb_event_UserContext | null; 
  listings?: (reverb_event_Listing | null)[] | null; 
  requestId?: string | null; 
}

export interface reverb_event_SaleView {
  saleId?: string | null; 
  userContext?: reverb_event_UserContext | null; 
  listings?: (reverb_event_Listing | null)[] | null; 
  requestId?: string | null; 
}

export interface reverb_event_CartView {
  userContext?: reverb_event_UserContext | null; 
  listings?: (reverb_event_Listing | null)[] | null; 
  requestId?: string | null; 
}

export interface reverb_event_ArticleView {
  userContext?: reverb_event_UserContext | null; 
  articleId?: string | null; 
  requestId?: string | null; 
  referer?: string | null; 
  url?: string | null; 
  aid?: string | null; 
  utmCampaign?: string | null; 
}

export interface reverb_event_ArticleViewRelatedContent {
  userContext?: reverb_event_UserContext | null; 
  articleViewArticleId?: string | null; 
  type?: string | null; 
  url?: string | null; 
  referer?: string | null; 
  articles?: (reverb_event_Article | null)[] | null; 
}

export interface reverb_event_PageView {
  userContext?: reverb_event_UserContext | null; 
  referer?: string | null; 
  url?: string | null; 
  aid?: string | null; 
  utmCampaign?: string | null; 
  controller?: string | null; 
  action?: string | null; 
  remoteAddress?: string | null; 
  requestId?: string | null; 
  params?: string | null; 
  method?: string | null; 
  viewRuntime?: number | null; 
  dbRuntime?: number | null; 
  status?: string | null; 
  duration?: number | null; 
  customHeaders?: string | null; 
  oauthAppId?: string | null; 
  devTeam?: string | null; 
  pageExperiments?: string | null; 
  id?: string | null; 
  sku?: string | null; 
  paramsId?: string | null; 
  threadId?: string | null; 
  utmSource?: string | null; 
  utmMedium?: string | null; 
  urlRegion?: string | null; 
}

export interface reverb_event_CheckoutView {
  userContext?: reverb_event_UserContext | null; 
  paymentMethod?: string | null; 
  stepName?: string | null; 
  referer?: string | null; 
  checkoutId?: string | null; 
  checkoutUuid?: string | null; 
}

export interface reverb_event_ComparisonShoppingPagesView {
  comparisonShoppingPages?: (reverb_event_ComparisonShoppingPage | null)[] | null; 
  userContext?: reverb_event_UserContext | null; 
  url?: string | null; 
  referer?: string | null; 
  componentName?: string | null; 
}

export interface reverb_event_ScreenView {
  userContext?: reverb_event_UserContext | null; 
  referer?: string | null; 
  screenName?: string | null; 
  context?: string | null; 
}

export interface reverb_event_BrowserFingerprint {
  hash?: string | null; 
  liedLanguages?: boolean | null; 
  liedResolution?: boolean | null; 
  liedOs?: boolean | null; 
  liedBrowser?: boolean | null; 
  plugins?: number | null; 
  resolution?: string | null; 
  session?: boolean | null; 
  localstorage?: boolean | null; 
}

export interface reverb_event_JsLoad {
  app?: string | null; 
  userContext?: reverb_event_UserContext | null; 
  fingerprint?: reverb_event_BrowserFingerprint | null; 
}

export interface core_apimessages_PublicShopAddress {
  region?: string | null; 
  locality?: string | null; 
  countryCode?: string | null; 
  displayLocation?: string | null; 
  country?: core_apimessages_Country | null; 
}

export interface core_apimessages_AddressEntry {
  name?: string | null; 
  streetAddress?: string | null; 
  extendedAddress?: string | null; 
  postalCode?: string | null; 
  phone?: string | null; 
  region?: string | null; 
  locality?: string | null; 
  countryCode?: string | null; 
  email?: string | null; 
}

export interface core_apimessages_AdyenIdentifyShopperResults {
  threeds2FingerprintResult?: string | null; 
  paymentData?: string | null; 
}

export interface core_apimessages_AdyenChallengeShopperResults {
  threeds2ChallengeResult?: string | null; 
  paymentData?: string | null; 
}

export interface core_apimessages_AdyenVerifyShopperResults {
  threeds2Result?: string | null; 
}

export interface core_apimessages_SetupPaymentMethodsRequestAdyenParentCompanyDetails {
  stockExchange?: string | null; 
  stockNumber?: string | null; 
  stockTicker?: string | null; 
  legalBusinessName?: string | null; 
  registrationNumber?: string | null; 
  countryCode?: string | null; 
}

export interface core_apimessages_SetupPaymentMethodsRequestAdyenDetails {
  legalEntity?: core_apimessages_AdyenLegalEntity | null; 
  individualDetails?: core_apimessages_SetupPaymentMethodsRequestIndividualAdyenDetails | null; 
  businessDetails?: core_apimessages_SetupPaymentMethodsRequestBusinessAdyenDetails | null; 
}

export interface core_apimessages_SetupPaymentMethodsRequestIndividualAdyenDetails {
  firstName?: string | null; 
  lastName?: string | null; 
  originCountryCode?: string | null; 
}

export interface core_apimessages_SetupPaymentMethodsRequestBusinessAdyenDetails {
  firstName?: string | null; 
  lastName?: string | null; 
  originCountryCode?: string | null; 
  legalBusinessName?: string | null; 
  shareholderType?: core_apimessages_SetupPaymentMethodsRequestBusinessAdyenDetails_AdyenShareholderType | null; 
  jobTitle?: string | null; 
  parentCompanyDetails?: core_apimessages_SetupPaymentMethodsRequestAdyenParentCompanyDetails | null; 
}

export interface core_apimessages_SetupPaymentMethodsRequestPaypalDetails {
  email?: string | null; 
  legalCountryCode?: string | null; 
}

export interface core_apimessages_BankDetails {
  name?: string | null; 
  euBankDetails?: core_apimessages_EUBankDetails | null; 
  usBankDetails?: core_apimessages_USBankDetails | null; 
  ukBankDetails?: core_apimessages_UKBankDetails | null; 
  address?: core_apimessages_KYCAddress | null; 
  bankCountryCode?: string | null; 
}

export interface core_apimessages_EUBankDetails {
  iban?: string | null; 
}

export interface core_apimessages_USBankDetails {
  accountNumber?: string | null; 
  routingNumber?: string | null; 
}

export interface core_apimessages_UKBankDetails {
  sortCode?: string | null; 
  accountNumber?: string | null; 
  bankCode?: string | null; 
}

export interface core_apimessages_CompanyInformation {
  taxId?: string | null; 
  legalBusinessName?: string | null; 
  phoneNumber?: string | null; 
  registrationNumber?: string | null; 
  parentCompanyDetails?: core_apimessages_AdyenParentCompanyDetails | null; 
}

export interface core_apimessages_KYCVerificationCheck {
  verificationType?: string | null; 
  status?: string | null; 
  reverbStatus?: string | null; 
  codes?: (core_apimessages_KYCVerificationCode | null)[] | null; 
  actionRequired?: boolean | null; 
  action?: core_apimessages_KYCAction | null; 
  errorDescription?: string | null; 
}

export interface core_apimessages_KYCVerificationCode {
  code?: string | null; 
}

export interface core_apimessages_ChannelBranding {
  name?: string | null; 
  logoImageUrl?: string | null; 
  completeUrl?: string | null; 
  channel?: core_apimessages_Channel | null; 
  shopIdentifier?: string | null; 
  abandonUrl?: string | null; 
}

export interface core_apimessages_LocalizationSettings {
  locale?: string | null; 
  currency?: string | null; 
  shippingRegion?: string | null; 
}

export interface core_apimessages_CheckoutCartItem {
  listingId?: string | null; 
  quantity?: number | null; 
}

export interface core_apimessages_GoogleShoppingClick {
  listingId?: string | null; 
  comparisonShoppingPageId?: string | null; 
  timestamp?: string | null; 
  origin?: string | null; 
  expiration?: string | null; 
}

export interface core_apimessages_ErrorResponse {
  errors?: (core_apimessages_Error | null)[] | null; 
}

export interface core_apimessages_ArticleCategories {
  categories?: (core_apimessages_ArticleCategory | null)[] | null; 
}

export interface core_apimessages_Article {
  id?: string | null; 
  title?: string | null; 
  webLink?: core_apimessages_Link | null; 
  articleCategories?: (core_apimessages_ArticleCategory | null)[] | null; 
  slug?: string | null; 
}

export interface core_apimessages_Auction {
  id?: string | null; 
  endAt?: google_protobuf_Timestamp | null; 
  startAt?: google_protobuf_Timestamp | null; 
  minBid?: core_apimessages_Money | null; 
  listingId?: string | null; 
  relistIfUnsold?: boolean | null; 
}

export interface core_apimessages_BumpKeyContents {
  jti?: string | null; 
  iat?: number | null; 
  userId?: string | null; 
  sessionId?: string | null; 
  cookieId?: string | null; 
  productId?: string | null; 
  source?: core_apimessages_BumpKeyContents_OffsiteSource | null; 
}

export interface core_apimessages_ActionSourceAttributes {
  device?: string | null; 
}

export interface core_apimessages_CartItemAttributes {
  actionSourceAttributes?: core_apimessages_ActionSourceAttributes | null; 
  cartSource?: string | null; 
  listingId?: number | null; 
  quantity?: number | null; 
  upsell?: boolean | null; 
  uuid?: string | null; 
  saleId?: number | null; 
}

export interface core_apimessages_CreditCardTokenizedFields {
  encryptedCardNumber?: string | null; 
  encryptedExpiryMonth?: string | null; 
  encryptedExpiryYear?: string | null; 
  encryptedSecurityCode?: string | null; 
}

export interface core_apimessages_CreateMyCreditCardRequest_CreditCardEntry {
  tokenizedFields?: core_apimessages_CreditCardTokenizedFields | null; 
  cardholderName?: string | null; 
}

export interface core_apimessages_CreateMyCreditCardRequest {
  creditCard?: core_apimessages_CreateMyCreditCardRequest_CreditCardEntry | null; 
  billingAddress?: core_apimessages_AddressEntry | null; 
}

export interface core_apimessages_UpdateMyCreditCardRequest_CreditCardEntry {
  expirationMonth?: string | null; 
  expirationYear?: string | null; 
  cardholderName?: string | null; 
  primaryForCheckout?: boolean | null; 
}

export interface core_apimessages_UpdateMyCreditCardRequest {
  id?: string | null; 
  creditCard?: core_apimessages_UpdateMyCreditCardRequest_CreditCardEntry | null; 
  billingAddress?: core_apimessages_AddressEntry | null; 
}

export interface core_apimessages_DeleteMyCreditCardRequest {
  id?: string | null; 
}

export interface core_apimessages_CheckoutAction {
  type?: core_apimessages_CheckoutAction_Type | null; 
  redirectUrl?: string | null; 
}

export interface core_apimessages_Checkout {
  id?: string | null; 
  checkoutBundlingId?: string | null; 
  paymentMethod?: core_apimessages_CheckoutPaymentMethod | null; 
  shippingAddress?: core_apimessages_Address | null; 
  billingAddress?: core_apimessages_Address | null; 
  orders?: (core_apimessages_CheckoutOrder | null)[] | null; 
  lineItems?: (core_apimessages_CheckoutLineItem | null)[] | null; 
  status?: core_apimessages_Checkout_Status | null; 
  paymentErrorMessage?: string | null; 
  type?: core_apimessages_Checkout_Type | null; 
  creditCard?: core_apimessages_CreditCard | null; 
  guest?: core_apimessages_CheckoutGuest | null; 
  adyenPaymentAction?: string | null; 
}

export interface core_apimessages_CheckoutCreateRequest {
  checkoutBundlingId?: string | null; 
  paymentMethod?: core_apimessages_CheckoutPaymentMethod_Type | null; 
}

export interface core_apimessages_CheckoutShowRequest {
  id?: string | null; 
}

export interface core_apimessages_CheckoutShowResponse {
  checkout?: core_apimessages_Checkout | null; 
}

export interface core_apimessages_CheckoutUpdateShippingAddressRequest {
  id?: string | null; 
  shippingAddress?: core_apimessages_AddressEntry | null; 
  guest?: core_apimessages_GuestCheckoutUserEntry | null; 
}

export interface core_apimessages_GuestCheckoutUserEntry {
  firstName?: string | null; 
  lastName?: string | null; 
  email?: string | null; 
}

export interface core_apimessages_CheckoutSelectShippingAddressRequest {
  id?: string | null; 
  shippingAddressId?: string | null; 
}

export interface core_apimessages_CheckoutCreatePaymentRedirectUrlRequest {
  id?: string | null; 
  reverbApp?: string | null; 
}

export interface core_apimessages_StartCheckoutForListingRequest {
  listingId?: string | null; 
  paymentMethod?: core_apimessages_CheckoutPaymentMethod_Type | null; 
}

export interface core_apimessages_ApplyCheckoutDiscountCodeRequest {
  id?: string | null; 
  discountCode?: string | null; 
}

export interface core_apimessages_SelectCheckoutCreditCardRequest {
  id?: string | null; 
  creditCardId?: string | null; 
}

export interface core_apimessages_UpdateCheckoutGuestCreditCardRequest_CreditCardEntry {
  tokenizedFields?: core_apimessages_CreditCardTokenizedFields | null; 
  cardholderName?: string | null; 
  brandType?: string | null; 
  lastDigits?: string | null; 
}

export interface core_apimessages_UpdateCheckoutGuestCreditCardRequest {
  id?: string | null; 
  creditCard?: core_apimessages_UpdateCheckoutGuestCreditCardRequest_CreditCardEntry | null; 
  billingAddress?: core_apimessages_AddressEntry | null; 
}

export interface core_apimessages_CheckoutUpdateGuestContactInfoRequest {
  id?: string | null; 
  guest?: core_apimessages_GuestCheckoutUserEntry | null; 
}

export interface core_apimessages_CheckoutUpdateGuestContactInfoResponse {
  id?: string | null; 
}

export interface core_apimessages_SelectCheckoutPaymentMethodRequest {
  id?: string | null; 
  paymentMethod?: core_apimessages_CheckoutPaymentMethod_Type | null; 
}

export interface core_apimessages_CheckoutFinalizeRedirectPaymentCheckoutRequest {
  id?: string | null; 
  redirectResult?: string | null; 
  merchantReference?: string | null; 
  displayedAmountOwedCents?: string | null; 
}

export interface core_apimessages_CheckoutFinalizeDigitalWalletPaymentRequest {
  id?: string | null; 
  paymentToken?: string | null; 
  totalPrice?: core_apimessages_MoneyMinorUnitsEntry | null; 
  shippingAddress?: core_apimessages_AddressEntry | null; 
  guestUser?: core_apimessages_GuestCheckoutUserEntry | null; 
  resultConfirmation?: core_apimessages_CheckoutFinalizeDigitalWalletPaymentRequest_ResultConfirmation | null; 
}

export interface core_apimessages_CheckoutFinalizeDirectCheckoutPaymentRequest_BrowserInfo {
  screenWidth?: number | null; 
  screenHeight?: number | null; 
  colorDepth?: number | null; 
  userAgent?: string | null; 
  language?: string | null; 
  javaEnabled?: boolean | null; 
  timeZoneOffset?: number | null; 
}

export interface core_apimessages_CheckoutFinalizeDirectCheckoutPaymentRequest {
  id?: string | null; 
  browserInfo?: core_apimessages_CheckoutFinalizeDirectCheckoutPaymentRequest_BrowserInfo | null; 
  displayedAmountOwed?: core_apimessages_MoneyMinorUnitsEntry | null; 
}

export interface core_apimessages_CheckoutCartEditRequest {
  listingId?: string | null; 
  quantity?: number | null; 
}

export interface core_apimessages_CheckoutUpdateShippingEstimateRequest {
  id?: string | null; 
  shippingAddress?: core_apimessages_AddressEntry | null; 
}

export interface core_apimessages_CheckoutSelectOrderShippingMethodRequest_OrderEntry {
  listingId?: string | null; 
  shippingMethodType?: core_apimessages_ShippingMethod | null; 
}

export interface core_apimessages_CheckoutSelectOrderShippingMethodRequest {
  id?: string | null; 
  order?: core_apimessages_CheckoutSelectOrderShippingMethodRequest_OrderEntry | null; 
}

export interface core_apimessages_CheckoutActionRequest {
  checkoutId?: string | null; 
  reverbApp?: string | null; 
}

export interface core_apimessages_CheckoutActionResponse {
  action?: core_apimessages_CheckoutAction | null; 
}

export interface core_apimessages_CollectionHeader {
  id?: string | null; 
  title?: string | null; 
  description?: string | null; 
  metaTitle?: string | null; 
  metaDescription?: string | null; 
  collectionType?: core_apimessages_CollectionHeader_CollectionType | null; 
  collectionId?: string | null; 
}

export interface core_apimessages_ImageEntry {
  id?: string | null; 
  publicId?: string | null; 
  version?: string | null; 
  width?: number | null; 
  height?: number | null; 
  format?: string | null; 
  resourceType?: string | null; 
  originalFilename?: string | null; 
  transformation?: core_apimessages_ImageEntry_Transformation | null; 
}

export interface core_apimessages_CSP {
  id?: string | null; 
  title?: string | null; 
  summary?: string | null; 
  webLink?: core_apimessages_Link | null; 
  newListingsLink?: core_apimessages_Link | null; 
  usedListingsLink?: core_apimessages_Link | null; 
  uuid?: string | null; 
  brandUuid?: string | null; 
  categoryUuids?: (string | null)[] | null; 
  slug?: string | null; 
  metaDescription?: string | null; 
  body?: string | null; 
  model?: string | null; 
  canonicalProductIds?: (string | null)[] | null; 
  upcs?: (string | null)[] | null; 
  finishes?: (string | null)[] | null; 
  generic?: boolean | null; 
  categoryRootUuid?: string | null; 
}

export interface core_apimessages_CSPPricing {
  low?: core_apimessages_Money | null; 
  mid?: core_apimessages_Money | null; 
  high?: core_apimessages_Money | null; 
  hasData?: boolean | null; 
}

export interface core_apimessages_ExpressSaleCheckout {
  checkoutId?: string | null; 
  cspId?: string | null; 
  status?: core_apimessages_ExpressSaleCheckout_Status | null; 
  expressSaleItemBid?: core_apimessages_CSPExpressSaleItemBid | null; 
}

export interface core_apimessages_ExpressSaleCheckoutShowRequest {
  checkoutId?: string | null; 
}

export interface core_apimessages_ExpressSaleCheckoutShowResponse {
  expressSaleCheckout?: core_apimessages_ExpressSaleCheckout | null; 
}

export interface core_apimessages_CreateExpressSaleCheckoutRequest {
  checkoutId?: string | null; 
  payoutAmountCents?: number | null; 
  isTermsAccepted?: boolean | null; 
  addressUuid?: string | null; 
  address?: core_apimessages_AddressEntry | null; 
}

export interface core_apimessages_CompleteExpressSaleCheckoutRequest {
  checkoutId?: string | null; 
}

export interface core_apimessages_FollowGroup {
  calloutLinkText?: string | null; 
  description?: string | null; 
  follows?: (core_apimessages_Follow | null)[] | null; 
  title?: string | null; 
  Links?: core_apimessages_FollowGroupLinks | null; 
}

export interface core_apimessages_Follow {
  following?: boolean | null; 
  header?: string | null; 
  savedSearchType?: string | null; 
  subtitle?: string | null; 
  title?: string | null; 
  Links?: core_apimessages_FollowLinks | null; 
  alert?: core_apimessages_FollowAlert | null; 
  id?: string | null; 
  queryParams?: string | null; 
  followedSubcategories?: (string | null)[] | null; 
}

export interface core_apimessages_FollowLinks {
  self?: core_apimessages_Link | null; 
  alert?: core_apimessages_Link | null; 
  remove?: core_apimessages_Link | null; 
  search?: core_apimessages_Link | null; 
}

export interface core_apimessages_FollowAlert {
  type?: string | null; 
}

export interface core_apimessages_FollowGroupLinks {
  callout?: core_apimessages_Link | null; 
}

export interface core_apimessages_Followers {
  count?: number | null; 
  display?: string | null; 
}

export interface core_apimessages_FollowQueryParams {
  category?: string | null; 
  categoryUuid?: string | null; 
  condition?: (string | null)[] | null; 
  countryOfOrigin?: string | null; 
  cpIds?: (number | null)[] | null; 
  curatedSetId?: number | null; 
  curatedSearchId?: number | null; 
  currency?: string | null; 
  decade?: string | null; 
  finish?: string | null; 
  handmade?: string | null; 
  itemCity?: string | null; 
  itemRegion?: string | null; 
  itemCountry?: string | null; 
  itemState?: string | null; 
  make?: (string | null)[] | null; 
  model?: string | null; 
  priceMax?: string | null; 
  priceMin?: string | null; 
  productType?: string | null; 
  productTypeUuid?: string | null; 
  query?: string | null; 
  yearMax?: string | null; 
  yearMin?: string | null; 
  shopId?: number | null; 
  acceptsGiftCards?: boolean | null; 
  preferredSeller?: boolean | null; 
  listingType?: string | null; 
  shipsTo?: string | null; 
  acceptsPaymentPlans?: boolean | null; 
  freeShipping?: boolean | null; 
  personalProfile?: string | null; 
  freeExpeditedShipping?: boolean | null; 
  zeroPercentFinancing?: boolean | null; 
  decades?: (string | null)[] | null; 
}

export interface core_apimessages_GearCollectionItem {
  id?: string | null; 
  deleted?: boolean | null; 
  title?: string | null; 
  make?: string | null; 
  model?: string | null; 
  finish?: string | null; 
  year?: string | null; 
  price?: core_apimessages_Money | null; 
  description?: string | null; 
  notes?: string | null; 
  canonicalProductId?: string | null; 
  ownerCost?: core_apimessages_Money | null; 
  serialNumber?: string | null; 
  created?: boolean | null; 
  updated?: boolean | null; 
  condition?: core_apimessages_Condition | null; 
  tags?: (core_apimessages_GearCollectionItemTag | null)[] | null; 
  hideListingPhotos?: boolean | null; 
  hideListingDescription?: boolean | null; 
  seedId?: string | null; 
  seedType?: core_apimessages_GearCollectionItem_SeedType | null; 
}

export interface core_apimessages_GearCollectionItemEntry {
  id?: string | null; 
  title?: string | null; 
  make?: string | null; 
  model?: string | null; 
  finish?: string | null; 
  year?: string | null; 
  price?: core_apimessages_Money | null; 
  description?: string | null; 
  notes?: string | null; 
  categoryUuids?: (string | null)[] | null; 
  canonicalProductId?: string | null; 
  seedId?: string | null; 
  seedType?: core_apimessages_GearCollectionItem_SeedType | null; 
  photos?: (core_apimessages_ImageEntry | null)[] | null; 
  categoryRootUuid?: string | null; 
  ownerCost?: core_apimessages_Money | null; 
  serialNumber?: string | null; 
  conditionSlug?: string | null; 
  tags?: (core_apimessages_GearCollectionItemTag | null)[] | null; 
  hideListingPhotos?: boolean | null; 
  hideListingDescription?: boolean | null; 
  quickCreateItemFromSeed?: boolean | null; 
  source?: core_apimessages_GearCollectionItemEntry_Source | null; 
}

export interface google_protobuf_DoubleValue {
  value?: number | null; 
}

export interface google_protobuf_FloatValue {
  value?: number | null; 
}

export interface google_protobuf_Int64Value {
  value?: number | null; 
}

export interface google_protobuf_UInt64Value {
  value?: number | null; 
}

export interface google_protobuf_UInt32Value {
  value?: number | null; 
}

export interface google_protobuf_StringValue {
  value?: string | null; 
}

export interface google_protobuf_BytesValue {
  value?: string | null; 
}

export interface core_apimessages_ShippingRatesForShippingProfile {
  shippingProfileId?: string | null; 
  shippingRates?: (core_apimessages_ShippingRates | null)[] | null; 
}

export interface core_apimessages_ShopShippingProfiles {
  shopUuid?: string | null; 
  shippingProfiles?: (core_apimessages_ShippingProfile | null)[] | null; 
}

export interface core_apimessages_ShipmentItem {
  productId?: string | null; 
  declaredValue?: core_apimessages_Money | null; 
}

export interface core_apimessages_OrderCustoms {
  uuid?: string | null; 
  description?: string | null; 
  countryOfOrigin?: string | null; 
  declaredValue?: core_apimessages_Money | null; 
  tariffNumber?: string | null; 
  quantity?: number | null; 
}

export interface core_apimessages_CustomsInfo {
  signer?: string | null; 
  certifiedAccuracy?: boolean | null; 
  orders?: (core_apimessages_OrderCustoms | null)[] | null; 
}

export interface core_apimessages_Shipment {
  toAddress?: core_apimessages_Address | null; 
  fromAddress?: core_apimessages_Address | null; 
  package?: core_apimessages_ShippingLabelPackage | null; 
  shippingProtection?: boolean | null; 
  signatureRequired?: boolean | null; 
  mediaMailQualified?: boolean | null; 
  defaultPaymentMethod?: core_apimessages_FeePaymentMethod | null; 
  carrierRates?: (core_apimessages_CarrierRateGroup | null)[] | null; 
  shippingMethod?: core_apimessages_ShippingMethod | null; 
  id?: string | null; 
  orderUuids?: (string | null)[] | null; 
  shippingProtectionPrice?: core_apimessages_Money | null; 
  toAddressIsResidential?: boolean | null; 
}

export interface core_apimessages_PreorderInfoEntry {
  timeType?: core_apimessages_PreorderInfoEntry_TimeType | null; 
  leadTimeUnit?: core_apimessages_PreorderInfoEntry_LeadTimeUnit | null; 
  shipDate?: string | null; 
  leadTimeDays?: number | null; 
}

export interface core_apimessages_SellerListing {
  sellerCost?: core_apimessages_Money | null; 
  storageLocation?: string | null; 
  sellerPrice?: core_apimessages_Money | null; 
  handmade?: boolean | null; 
  upcDoesNotApply?: boolean | null; 
  localizedContents?: (core_apimessages_LocalizedListingContent | null)[] | null; 
  shippingProfileId?: string | null; 
  prefersReverbShippingLabel?: boolean | null; 
  taxExempt?: boolean | null; 
}

export interface core_apimessages_ListingInCartCount {
  count?: google_protobuf_Int32Value | null; 
}

export interface core_apimessages_ListingCuratedSet {
  id?: string | null; 
  slug?: string | null; 
  uuid?: string | null; 
  featuredInSet?: boolean | null; 
  name?: string | null; 
  setType?: string | null; 
}

export interface core_apimessages_CuratedSetsForListing {
  id?: string | null; 
  curatedSets?: (core_apimessages_ListingCuratedSet | null)[] | null; 
}

export interface core_apimessages_ListingEntry {
  id?: string | null; 
  sku?: string | null; 
  year?: string | null; 
  countryOfOrigin?: string | null; 
  seedId?: string | null; 
  seedType?: core_apimessages_Listing_SeedType | null; 
  categoryRootUuid?: string | null; 
  categoryUuids?: (string | null)[] | null; 
  localizedContents?: (core_apimessages_LocalizedListingContent | null)[] | null; 
  handmade?: boolean | null; 
  traits?: (core_apimessages_Trait | null)[] | null; 
  conditionSlug?: string | null; 
  hasInventory?: boolean | null; 
  inventory?: number | null; 
  upc?: string | null; 
  upcDoesNotApply?: boolean | null; 
  videoLinkUrl?: string | null; 
  photos?: (core_apimessages_ImageEntry | null)[] | null; 
  shippingProfileId?: string | null; 
  offersLocalPickup?: boolean | null; 
  shippingRates?: (core_apimessages_ShippingRates | null)[] | null; 
  carrierCalculatedPackage?: core_apimessages_ShippingLabelPackage | null; 
  prefersReverbShippingLabel?: boolean | null; 
  price?: core_apimessages_Money | null; 
  sellerCost?: core_apimessages_Money | null; 
  soldAsIs?: boolean | null; 
  offersEnabled?: boolean | null; 
  sameDayShippingIneligible?: boolean | null; 
  preorderInfo?: core_apimessages_PreorderInfoEntry | null; 
  taxExempt?: boolean | null; 
}

export interface core_apimessages_MyUpdatesPromotion {
  id?: string | null; 
  title?: string | null; 
  subtitle?: string | null; 
  url?: core_apimessages_Link | null; 
  startsAt?: Timestamp | null; 
}

export interface core_apimessages_NegotiationOffers {
  offers?: (core_apimessages_Offer | null)[] | null; 
}

export interface core_apimessages_OrderFeedbacks {
  orderUuid?: string | null; 
  feedbacks?: (core_apimessages_Feedback | null)[] | null; 
}

export interface core_apimessages_OrderPayments {
  payments?: (core_apimessages_Payment | null)[] | null; 
}

export interface core_apimessages_OrderNotes {
  notes?: (core_apimessages_OrderNote | null)[] | null; 
}

export interface core_apimessages_OrderRefundRequests {
  refundRequests?: (core_apimessages_RefundRequest | null)[] | null; 
}

export interface core_apimessages_PublicPriceRecord {
  uuid?: string | null; 
  listingId?: string | null; 
  createdAt?: google_protobuf_Timestamp | null; 
  settlementAmountProductSubtotal?: core_apimessages_Money | null; 
  orderType?: string | null; 
  amountProduct?: core_apimessages_Money | null; 
  amountTotal?: core_apimessages_Money | null; 
  amountTax?: core_apimessages_Money | null; 
  amountShipping?: core_apimessages_Money | null; 
  condition?: core_apimessages_Condition | null; 
}

export interface core_apimessages_OrderBundle {
  amountTotal?: core_apimessages_Money | null; 
  amountProductSubtotal?: core_apimessages_Money | null; 
  amountShipping?: core_apimessages_Money | null; 
  amountCredit?: core_apimessages_Money | null; 
  amountTax?: core_apimessages_Money | null; 
  bonusBucks?: core_apimessages_Money | null; 
  paymentMethod?: core_apimessages_Payment_PaymentMethod | null; 
  uuid?: string | null; 
  localPickup?: boolean | null; 
  id?: string | null; 
}

export interface core_apimessages_PacklinkPolicies {
  dataProcessing?: boolean | null; 
  marketingCalls?: boolean | null; 
  marketingEmails?: boolean | null; 
  termsAndConditions?: boolean | null; 
}

export interface core_apimessages_CreateMyPlaidLinkTokenRequest {
  countryCode?: string | null; 
  plaidAccountId?: string | null; 
  requiresMobileRedirect?: boolean | null; 
}

export interface core_apimessages_SaveMyPlaidAccountRequest {
  accountId?: string | null; 
  publicToken?: string | null; 
  verificationStatus?: string | null; 
  countryCode?: string | null; 
}

export interface core_apimessages_CancelPlaidAccountRequest {
  _?: boolean | null; 
}

export interface core_apimessages_MyDirectCheckoutProfileRequest {
  _?: boolean | null; 
}

export interface core_apimessages_EstimatedShipping {
  description?: string | null; 
  rates?: (core_apimessages_ShippingRate | null)[] | null; 
}

export interface core_apimessages_ShippingRate {
  displayName?: string | null; 
  price?: core_apimessages_Money | null; 
}

export interface core_apimessages_Storefront {
  channel?: string | null; 
  slug?: string | null; 
  name?: string | null; 
  shopUuid?: string | null; 
  id?: string | null; 
  description?: string | null; 
  shippingPolicy?: string | null; 
}

export interface core_apimessages_ShopEntry {
  currency?: string | null; 
  originCountryCode?: string | null; 
  defaultLocale?: string | null; 
  name?: string | null; 
  address?: core_apimessages_AddressEntry | null; 
}

export interface core_apimessages_ShopReturnPolicy {
  shopUuid?: string | null; 
  returnPolicy?: core_apimessages_ReturnPolicy | null; 
}

export interface core_apimessages_ShopTaxPolicies {
  shopUuid?: string | null; 
  taxPolicies?: (core_apimessages_ShopTaxPolicy | null)[] | null; 
}

export interface core_apimessages_User {
  uuid?: string | null; 
  name?: string | null; 
  shopUuid?: string | null; 
  id?: string | null; 
  firstName?: string | null; 
}

export interface core_apimessages_AdyenCreditCardEntry {
  tokenizedFields?: string | null; 
  cardholderName?: string | null; 
}

export interface core_apimessages_BillingCreditCardEntry {
  creditCardId?: string | null; 
  adyenToken?: string | null; 
  adyenCreditCard?: core_apimessages_AdyenCreditCardEntry | null; 
  address?: core_apimessages_AddressEntry | null; 
}

export interface core_apimessages_AdPlacement {
  format?: core_apimessages_AdFormat | null; 
}

export interface core_apimessages_MparticleProfileResponse {
  mpid?: string | null; 
  topProductType?: string | null; 
  topProductTypes?: (string | null)[] | null; 
  topCategories?: (string | null)[] | null; 
  topBrands?: (string | null)[] | null; 
  recentlyViewedCsps?: (string | null)[] | null; 
  averageOrderValue?: number | null; 
  totalListingsCreated?: number | null; 
  totalListingsSold?: number | null; 
  totalListingsDraft?: number | null; 
  totalListingsSuspended?: number | null; 
  totalListingsLive?: number | null; 
  cumulativeGmv?: number | null; 
  totalPurchases?: number | null; 
  buyerLabel?: string | null; 
  sellerLabel?: string | null; 
  totalFeedFollows?: number | null; 
  totalBuyerOffersCreated?: number | null; 
  totalBuyerOffersAccepted?: number | null; 
  sellerFeedbackRating?: number | null; 
  buyerFeedbackRating?: number | null; 
  mostRecentOrderDate?: string | null; 
  firstOrderDate?: string | null; 
  topProductTypeUuids?: (string | null)[] | null; 
  topCategoryUuids?: (string | null)[] | null; 
  topBrandCategories?: (string | null)[] | null; 
}

export interface core_apimessages_AdUserContext {
  mparticleProfileResponse?: core_apimessages_MparticleProfileResponse | null; 
}

export interface core_apimessages_TargetingContext {
  keywords?: (string | null)[] | null; 
  categories?: (string | null)[] | null; 
}

export interface core_apimessages_AdType {
  format?: core_apimessages_AdFormat | null; 
}

export interface core_apimessages_AdPlacementRequest {
  adZones?: (core_apimessages_AdZone | null)[] | null; 
  adTypes?: (core_apimessages_AdType | null)[] | null; 
}

export interface core_apimessages_AdServeRequest {
  userContext?: core_apimessages_AdUserContext | null; 
  targeting?: core_apimessages_TargetingContext | null; 
  placements?: (core_apimessages_AdPlacementRequest | null)[] | null; 
}

export interface core_apimessages_UpdateAdRequest {
  ad?: core_apimessages_Ad | null; 
}

export interface core_apimessages_DeleteAdRequest {
  uuid?: string | null; 
}

export interface core_apimessages_UpdateAdvertiserRequest {
  advertiser?: core_apimessages_Advertiser | null; 
}

export interface core_apimessages_UpdateAdGroupRequest {
  adGroup?: core_apimessages_AdGroup | null; 
}

export interface core_apimessages_CopyAdGroupRequest {
  adGroupUuid?: string | null; 
}

export interface core_apimessages_UpdateAdGroupKeywordsRequest {
  keywords?: (string | null)[] | null; 
  adGroupUuid?: string | null; 
}

export interface core_apimessages_UpdateAdZoneRequest {
  adZone?: core_apimessages_AdZone | null; 
}

export interface core_apimessages_UpdateAdCampaignRequest {
  adCampaign?: core_apimessages_AdCampaign | null; 
}

export interface core_apimessages_AdvertisersSearchRequest {
  offset?: number | null; 
  limit?: number | null; 
}

export interface core_apimessages_AdCampaignsSearchRequest {
  offset?: number | null; 
  limit?: number | null; 
  status?: core_apimessages_AdCampaignsSearchRequest_Status | null; 
  withinDate?: string | null; 
  advertiserUuids?: (string | null)[] | null; 
  adZoneSlugs?: (string | null)[] | null; 
}

export interface core_apimessages_AdGroupsSearchRequest {
  offset?: number | null; 
  limit?: number | null; 
  adCampaignUuids?: (string | null)[] | null; 
}

export interface core_apimessages_AdsSearchRequest {
  offset?: number | null; 
  limit?: number | null; 
  adGroupUuids?: (string | null)[] | null; 
}

export interface core_apimessages_PriceChange {
  id?: string | null; 
  listingId?: string | null; 
  previousPrice?: core_apimessages_Money | null; 
  newPrice?: core_apimessages_Money | null; 
  currentPriceDropPercent?: number | null; 
  totalPriceDropPercent?: number | null; 
}

export interface rql_MonitoringData {
  warn?: number | null; 
  timeout?: number | null; 
  owner?: string | null; 
}

export interface google_protobuf_Empty {
  _?: boolean | null; 
}

export interface arbiter_APIErrorResponse {
  errors?: (arbiter_APIError | null)[] | null; 
}

export interface arbiter_APIError {
  message?: string | null; 
}

export interface arbiter_Listing {
  id?: string | null; 
}

export interface arbiter_BumpedSortedListingsRequest {
  userShippingRegion?: string | null; 
  listingIds?: (string | null)[] | null; 
  condition?: string | null; 
  total?: number | null; 
  bumpedMax?: number | null; 
  itemRegion?: string | null; 
  auctionType?: arbiter_AuctionType | null; 
}

export interface arbiter_FeaturedListingRequest {
  cspSlug?: string | null; 
  canonicalFinish?: string | null; 
  userShippingRegion?: string | null; 
  cspId?: string | null; 
  traitValues?: (string | null)[] | null; 
  categoryUuids?: (string | null)[] | null; 
  deterministic?: boolean | null; 
  itemRegion?: string | null; 
  conditionUuids?: (string | null)[] | null; 
  auctionType?: arbiter_AuctionType | null; 
  userCurrency?: string | null; 
}

export interface arbiter_BulkFeaturedListingRequest {
  requests?: (arbiter_FeaturedListingRequest | null)[] | null; 
}

export interface arbiter_BulkFeaturedListingResponse {
  responses?: (arbiter_FeaturedListingResponse | null)[] | null; 
}

export interface arbiter_BumpedSortedListingsResponse {
  products?: (arbiter_BumpedSortedListingResponseListing | null)[] | null; 
  resultIds?: (string | null)[] | null; 
}

export interface arbiter_BumpedSortedListingResponseListing {
  productId?: string | null; 
  bumped?: boolean | null; 
  rank?: number | null; 
  bid?: number | null; 
  qualityScore?: number | null; 
  discountPercent?: number | null; 
}

export interface arbiter_BulkTrackImpressionsRequest {
  listingIds?: (string | null)[] | null; 
}

export interface arbiter_Interaction {
  uuid?: string | null; 
  userId?: string | null; 
  sessionId?: string | null; 
  cookieId?: string | null; 
  productId?: string | null; 
  bumpRate?: string | null; 
  referrerUrl?: string | null; 
  sellerId?: string | null; 
  componentName?: string | null; 
  position?: number | null; 
  issuedAt?: Timestamp | null; 
  createdAt?: Timestamp | null; 
  interactionType?: arbiter_Interaction_InteractionType | null; 
  offsiteSource?: string | null; 
  currentUrl?: string | null; 
  userExperimentsJson?: string | null; 
  userDeviceName?: string | null; 
}

export interface arbiter_CreateInteractionRequest {
  interaction?: arbiter_Interaction | null; 
}

export interface arbiter_FindInteractionRequest {
  productId?: string | null; 
  userId?: string | null; 
  cookieId?: string | null; 
  orderedAt?: Timestamp | null; 
}

export interface arbiter_FindInteractionResponse {
  interaction?: arbiter_Interaction | null; 
}

export interface arbiter_SellerInteractionTimeSeriesRequest {
  sellerId?: string | null; 
  startDate?: string | null; 
  endDate?: string | null; 
}

export interface arbiter_BumpInteractionCountsRequest {
  sellerId?: string | null; 
  listingId?: string | null; 
}

export interface arbiter_BulkBumpInteractionCountsRequest {
  requests?: (arbiter_BumpInteractionCountsRequest | null)[] | null; 
}

export interface arbiter_BulkBumpInteractionCountsResponse {
  responses?: (arbiter_BumpInteractionCountsResponse | null)[] | null; 
}

export interface arbiter_Arbiter {
  BumpedSortedListings?: arbiter_BumpedSortedListingsResponse | null; 
  FeaturedListing?: arbiter_FeaturedListingResponse | null; 
  BulkFeaturedListing?: arbiter_BulkFeaturedListingResponse | null; 
  BulkTrackImpressions?: arbiter_BulkTrackImpressionsResponse | null; 
  SellerInteractionTimeSeries?: arbiter_SellerInteractionTimeSeriesResponse | null; 
  BulkBumpInteractionCounts?: arbiter_BulkBumpInteractionCountsResponse | null; 
}

export interface core_apimessages_NodeRequest_Lookup_Params_Images {
  transform?: core_apimessages_NamedImageTransforms | null; 
  scope?: core_apimessages_Image_Scope | null; 
  limit?: number | null; 
}

export interface core_apimessages_NodeRequest_Lookup_Params_Sales {
  all?: boolean | null; 
}

export interface core_apimessages_NodeRequest_Lookup_Params_ShippingRates {
  inOriginalCurrency?: boolean | null; 
}

export interface core_apimessages_NodeRequest_Lookup_Params {
  images?: core_apimessages_NodeRequest_Lookup_Params_Images | null; 
  sales?: core_apimessages_NodeRequest_Lookup_Params_Sales | null; 
  shippingRates?: core_apimessages_NodeRequest_Lookup_Params_ShippingRates | null; 
}

export interface core_apimessages_NodeRequest_Lookup {
  lid?: string | null; 
  rel?: string | null; 
  params?: core_apimessages_NodeRequest_Lookup_Params | null; 
}

export interface core_apimessages_NodeRequest {
  lookups?: (core_apimessages_NodeRequest_Lookup | null)[] | null; 
  debug?: boolean | null; 
}

export interface core_apimessages_NodeResponse_Result_Meta {
  total?: number | null; 
}

export interface core_apimessages_NodeResponse_Result {
  lookup?: core_apimessages_NodeRequest_Lookup | null; 
  meta?: core_apimessages_NodeResponse_Result_Meta | null; 
  listings?: (core_apimessages_Listing | null)[] | null; 
  csps?: (core_apimessages_CSP | null)[] | null; 
  images?: (core_apimessages_Image | null)[] | null; 
  listingsPricings?: (core_apimessages_ListingPricing | null)[] | null; 
  orders?: (core_apimessages_Order | null)[] | null; 
  sales?: (core_apimessages_Sale | null)[] | null; 
  curatedSets?: (core_apimessages_CuratedSet | null)[] | null; 
  packlinkShipments?: (core_apimessages_PacklinkShipment | null)[] | null; 
  shippingRates?: (core_apimessages_ShippingRates | null)[] | null; 
  bumpRates?: (core_apimessages_BumpRate | null)[] | null; 
  cspVariants?: (core_apimessages_CspVariant | null)[] | null; 
  categories?: (core_apimessages_NodesCategory | null)[] | null; 
  gearCollectionItems?: (core_apimessages_GearCollectionItem | null)[] | null; 
  priceGuides?: (core_apimessages_PriceGuide | null)[] | null; 
  cartItems?: (core_apimessages_CartItem | null)[] | null; 
  adyenCheckoutPaymentMethods?: (core_apimessages_AdyenCheckoutPaymentMethods | null)[] | null; 
  taxIdentifications?: (core_apimessages_TaxIdentification | null)[] | null; 
  priceChanges?: (core_apimessages_PriceChange | null)[] | null; 
  adCampaigns?: (core_apimessages_AdCampaign | null)[] | null; 
  advertisers?: (core_apimessages_Advertiser | null)[] | null; 
  adGroups?: (core_apimessages_AdGroup | null)[] | null; 
  adGroupKeywords?: (core_apimessages_AdGroupKeyword | null)[] | null; 
  ads?: (core_apimessages_Ad | null)[] | null; 
  siteBanners?: (core_apimessages_SiteBanner | null)[] | null; 
  shops?: (core_apimessages_Shop | null)[] | null; 
  myUpdatesPromotions?: (core_apimessages_MyUpdatesPromotion | null)[] | null; 
  adZones?: (core_apimessages_AdZone | null)[] | null; 
  listingsSignals?: (core_apimessages_ListingSignals | null)[] | null; 
  universalPromoCampaigns?: (core_apimessages_UniversalPromoCampaign | null)[] | null; 
  shipmentPackages?: (core_apimessages_ShippingLabelPackage | null)[] | null; 
  cspExpressSaleItemBids?: (core_apimessages_CSPExpressSaleItemBid | null)[] | null; 
  orderBundles?: (core_apimessages_OrderBundle | null)[] | null; 
  publicPriceRecords?: (core_apimessages_PublicPriceRecord | null)[] | null; 
  nonUserExperiments?: (core_apimessages_NonUserExperiment | null)[] | null; 
  users?: (core_apimessages_User | null)[] | null; 
  addresses?: (core_apimessages_Address | null)[] | null; 
}

export interface core_apimessages_AdyenCheckoutPaymentMethods {
  adyenCheckoutPaymentMethodsConfig?: string | null; 
}

export interface core_apimessages_ListingSignals {
  id?: string | null; 
  onSaleSignal?: core_apimessages_OnSaleSignal | null; 
  paymentPlanSignal?: core_apimessages_PaymentPlanSignal | null; 
  priceDropSignal?: core_apimessages_PriceDropSignal | null; 
  lowStockSignal?: core_apimessages_LowStockSignal | null; 
  predictedToSellSoonSignal?: core_apimessages_PredictedToSellSoonSignal | null; 
  greatValueSignal?: core_apimessages_GreatValueSignal | null; 
  sharedSignalData?: core_apimessages_SharedSignalData | null; 
  returnPolicySignal?: core_apimessages_ReturnPolicySignal | null; 
  buyWithConfidenceSignal?: core_apimessages_BuyWithConfidenceSignal | null; 
  secureCheckoutSignal?: core_apimessages_SecureCheckoutSignal | null; 
  priceRecommendationData?: core_apimessages_PriceRecommendationData | null; 
  availableNearbyForPickupSignal?: core_apimessages_AvailableNearbyForPickupSignal | null; 
  expeditedShippingAvailableSignal?: core_apimessages_ExpeditedShippingAvailableSignal | null; 
  freeExpeditedShippingSignal?: core_apimessages_FreeExpeditedShippingSignal | null; 
  freeStandardShippingSignal?: core_apimessages_FreeStandardShippingSignal | null; 
  newListingSignal?: core_apimessages_NewListingSignal | null; 
  shipsSoonSignal?: core_apimessages_ShipsSoonSignal | null; 
  availableForPickupSignal?: core_apimessages_AvailableForPickupSignal | null; 
  localPickupOnlySignal?: core_apimessages_LocalPickupOnlySignal | null; 
  inOtherCartsSignal?: core_apimessages_InOtherCartsSignal | null; 
}

export interface core_apimessages_OnSaleSignal {
  isValid?: boolean | null; 
  translations?: core_apimessages_SignalTranslation | null; 
  link?: core_apimessages_SignalLink | null; 
}

export interface core_apimessages_SignalTranslation {
  title?: string | null; 
  subtitle?: string | null; 
  tooltipText?: string | null; 
}

export interface core_apimessages_SignalLink {
  url?: string | null; 
  text?: string | null; 
}

export interface core_apimessages_PaymentPlanSignal {
  isValid?: boolean | null; 
  translations?: core_apimessages_SignalTranslation | null; 
}

export interface core_apimessages_PriceDropSignal {
  isValid?: boolean | null; 
  translations?: core_apimessages_SignalTranslation | null; 
}

export interface core_apimessages_LowStockSignal {
  isValid?: boolean | null; 
  translations?: core_apimessages_SignalTranslation | null; 
}

export interface core_apimessages_PredictedToSellSoonSignal {
  isValid?: boolean | null; 
  translations?: core_apimessages_SignalTranslation | null; 
}

export interface core_apimessages_GreatValueSignal {
  translations?: core_apimessages_SignalTranslation | null; 
  isUsaBrandNew?: boolean | null; 
}

export interface core_apimessages_SharedSignalData {
  buyerPrice?: core_apimessages_Money | null; 
  originalPrice?: core_apimessages_Money | null; 
  sellerLocationDisplay?: string | null; 
}

export interface core_apimessages_ReturnPolicySignal {
  isValid?: boolean | null; 
  translations?: core_apimessages_SignalTranslation | null; 
  link?: core_apimessages_SignalLink | null; 
}

export interface core_apimessages_BuyWithConfidenceSignal {
  isValid?: boolean | null; 
  translations?: core_apimessages_SignalTranslation | null; 
  link?: core_apimessages_SignalLink | null; 
}

export interface core_apimessages_SecureCheckoutSignal {
  isValid?: boolean | null; 
  translations?: core_apimessages_SignalTranslation | null; 
}

export interface core_apimessages_PriceRecommendationData {
  eligibleForPriceRecommendation?: boolean | null; 
  listingConditionUuid?: string | null; 
  canonicalProductId?: number | null; 
}

export interface core_apimessages_AvailableNearbyForPickupSignal {
  translations?: core_apimessages_SignalTranslation | null; 
}

export interface core_apimessages_ExpeditedShippingAvailableSignal {
  translations?: core_apimessages_SignalTranslation | null; 
}

export interface core_apimessages_FreeExpeditedShippingSignal {
  translations?: core_apimessages_SignalTranslation | null; 
}

export interface core_apimessages_FreeStandardShippingSignal {
  translations?: core_apimessages_SignalTranslation | null; 
  freeShippingThresholdRequirementsMet?: boolean | null; 
}

export interface core_apimessages_NewListingSignal {
  translations?: core_apimessages_SignalTranslation | null; 
  isValid?: boolean | null; 
}

export interface core_apimessages_ShipsSoonSignal {
  translations?: core_apimessages_SignalTranslation | null; 
  isValid?: boolean | null; 
}

export interface core_apimessages_AvailableForPickupSignal {
  translations?: core_apimessages_SignalTranslation | null; 
  isValid?: boolean | null; 
}

export interface core_apimessages_LocalPickupOnlySignal {
  translations?: core_apimessages_SignalTranslation | null; 
  isValid?: boolean | null; 
}

export interface core_apimessages_InOtherCartsSignal {
  isValid?: boolean | null; 
  translations?: core_apimessages_SignalTranslation | null; 
}

export interface core_apimessages_NodeResponse {
  results?: (core_apimessages_NodeResponse_Result | null)[] | null; 
}

export interface core_apimessages_MeResponse {
  id?: string | null; 
  uuid?: string | null; 
  shopUuid?: string | null; 
  admin?: boolean | null; 
  status?: core_apimessages_UserStatus | null; 
  shopId?: string | null; 
  shopSlug?: string | null; 
  requireOptIn?: boolean | null; 
  profileSlug?: string | null; 
}

export interface core_apimessages_BrandManagerBrandsRequest {
  slugs?: (string | null)[] | null; 
  offset?: number | null; 
  limit?: number | null; 
  uuids?: (string | null)[] | null; 
}

export interface core_apimessages_BrandManagerBrandsResponse {
  brandManagerBrands?: (core_apimessages_Brand | null)[] | null; 
  offset?: number | null; 
  limit?: number | null; 
}

export interface core_apimessages_BrandManagerBrandRequest {
  slug?: string | null; 
}

export interface core_apimessages_BrandManagerBrandResponse {
  brand?: core_apimessages_Brand | null; 
}

export interface core_apimessages_CSPsVideoRequest {
  ids?: (string | null)[] | null; 
  slugs?: (string | null)[] | null; 
  uuids?: (string | null)[] | null; 
}

export interface core_apimessages_CSPsVideoResponse {
  videos?: (core_apimessages_CSPVideo | null)[] | null; 
}

export interface core_apimessages_CSPsRequest {
  ids?: (string | null)[] | null; 
  slugs?: (string | null)[] | null; 
  uuids?: (string | null)[] | null; 
}

export interface core_apimessages_CSPsResponse {
  csps?: (core_apimessages_CSP | null)[] | null; 
}

export interface core_apimessages_CSPsInventoryRequest {
  ids?: (string | null)[] | null; 
  uuids?: (string | null)[] | null; 
  slugs?: (string | null)[] | null; 
}

export interface core_apimessages_CSPsInventoryResponse {
  inventories?: (core_apimessages_CSPInventory | null)[] | null; 
}

export interface core_apimessages_CSPsFeaturedListingRequest {
  ids?: (string | null)[] | null; 
  uuids?: (string | null)[] | null; 
  slugs?: (string | null)[] | null; 
}

export interface core_apimessages_CSPsFeaturedListingResponse {
  featuredListingIds?: (string | null)[] | null; 
}

export interface core_apimessages_CSPsSpecsRequest {
  ids?: (string | null)[] | null; 
  slugs?: (string | null)[] | null; 
  uuids?: (string | null)[] | null; 
}

export interface core_apimessages_CSPsSpecsResponse {
  specs?: (core_apimessages_CSPSpec | null)[] | null; 
}

export interface core_apimessages_CuratedSetsRequest {
  ids?: (string | null)[] | null; 
  slugs?: (string | null)[] | null; 
}

export interface core_apimessages_CuratedSetsResponse {
  curatedSets?: (core_apimessages_CuratedSet | null)[] | null; 
}

export interface core_apimessages_FindFollowResponse {
  following?: boolean | null; 
  followers?: core_apimessages_Followers | null; 
  Links?: core_apimessages_FollowLinks | null; 
  follow?: core_apimessages_Follow | null; 
  display?: string | null; 
  header?: string | null; 
  savedSearchType?: string | null; 
  subtitle?: string | null; 
  title?: string | null; 
  alert?: core_apimessages_FollowAlert | null; 
  id?: string | null; 
  queryParams?: string | null; 
  followedSubcategories?: (string | null)[] | null; 
  hidden?: boolean | null; 
}

export interface core_apimessages_ImagesResponse {
  images?: (core_apimessages_ItemImages | null)[] | null; 
}

export interface core_apimessages_ItemImages {
  id?: string | null; 
  images?: (core_apimessages_Image | null)[] | null; 
}

export interface core_apimessages_ImagesRequest {
  type?: string | null; 
  ids?: (string | null)[] | null; 
  count?: number | null; 
  transform?: string | null; 
  scope?: string | null; 
  uuids?: (string | null)[] | null; 
  slugs?: (string | null)[] | null; 
  namedTransform?: core_apimessages_NamedImageTransforms | null; 
}

export interface core_apimessages_ImageRequest {
  id?: string | null; 
  uuid?: string | null; 
  slug?: string | null; 
  type?: string | null; 
  transform?: string | null; 
  scope?: string | null; 
  limit?: number | null; 
  namedTransform?: core_apimessages_NamedImageTransforms | null; 
}

export interface core_apimessages_BulkImageRequest {
  requests?: (core_apimessages_ImageRequest | null)[] | null; 
}

export interface core_apimessages_OrderBundleShowResponse {
  orderBundle?: core_apimessages_OrderBundle | null; 
}

export interface core_apimessages_UpdateBankAccountRequest {
  bankDetails?: core_apimessages_BankDetails | null; 
}

export interface core_apimessages_UpdateBankAccountResponse {
  errors?: (core_apimessages_Error | null)[] | null; 
}

export interface core_apimessages_UpdateCompanyRequest {
  companyInformation?: core_apimessages_CompanyInformation | null; 
  personalInformation?: (core_apimessages_PersonalInformation | null)[] | null; 
  accountHolderAddress?: core_apimessages_KYCAddress | null; 
}

export interface core_apimessages_UpdateCompanyResponse {
  errors?: (core_apimessages_Error | null)[] | null; 
}

export interface core_apimessages_MyShopOrderRefundStatsRequest {
  startDate?: string | null; 
  endDate?: string | null; 
}

export interface core_apimessages_MyShopShippingRatesRequest {
  shippingProfileIds?: (string | null)[] | null; 
}

export interface core_apimessages_MyShopShippingRatesResponse {
  shippingRatesForShippingProfiles?: (core_apimessages_ShippingRatesForShippingProfile | null)[] | null; 
}

export interface core_apimessages_MyShopShippingProfilesRequest {
  _?: boolean | null; 
}

export interface core_apimessages_MyShopShippingProfilesResponse {
  shippingProfiles?: (core_apimessages_MyShippingProfile | null)[] | null; 
}

export interface core_apimessages_UpdateMyShopShippingProfilesRequest {
  shippingProfiles?: (core_apimessages_UpdateMyShippingProfile | null)[] | null; 
}

export interface core_apimessages_UpdateOwnerInformationRequest {
  personalInformation?: (core_apimessages_PersonalInformation | null)[] | null; 
}

export interface core_apimessages_UpdateOwnerInformationResponse {
  errors?: (core_apimessages_Error | null)[] | null; 
}

export interface core_apimessages_ListingsRequest {
  Aid?: string | null; 
  utmCompaign?: string | null; 
  ids?: (string | null)[] | null; 
}

export interface core_apimessages_ListingsResponse {
  listings?: (core_apimessages_Listing | null)[] | null; 
}

export interface core_apimessages_SellerListingsResponse {
  listings?: (core_apimessages_SellerListing | null)[] | null; 
}

export interface core_apimessages_ListingsPricingResponse {
  listings?: (core_apimessages_ListingPricing | null)[] | null; 
}

export interface core_apimessages_ListingsPricingRequest {
  ids?: (string | null)[] | null; 
}

export interface core_apimessages_ListingsSignalsRequest {
  ids?: (string | null)[] | null; 
}

export interface core_apimessages_ListingsSignalsResponse {
  listingsSignals?: (core_apimessages_ListingSignals | null)[] | null; 
}

export interface core_apimessages_ListingsSpecsRequest {
  ids?: (string | null)[] | null; 
}

export interface core_apimessages_ListingsSpecsResponse {
  specs?: (core_apimessages_ListingSpec | null)[] | null; 
}

export interface core_apimessages_ListingCountsRequest {
  ids?: (string | null)[] | null; 
}

export interface core_apimessages_ListingCountsResponse {
  listings?: (core_apimessages_ListingCounts | null)[] | null; 
}

export interface core_apimessages_ShippingPricesRequest {
  listingIds?: (string | null)[] | null; 
  shippingRegionCode?: string | null; 
  usePrimaryShippingAddress?: boolean | null; 
  returnAllShippingPrices?: boolean | null; 
}

export interface core_apimessages_ShippingPricesResponse {
  prices?: (core_apimessages_Money | null)[] | null; 
  shippingPrices?: (core_apimessages_ShippingPrices | null)[] | null; 
}

export interface core_apimessages_CreateKYCRequest {
  bankDetails?: core_apimessages_BankDetails | null; 
  personalInformation?: (core_apimessages_PersonalInformation | null)[] | null; 
  companyInformation?: core_apimessages_CompanyInformation | null; 
  legalEntity?: string | null; 
}

export interface core_apimessages_CreateKYCResponse {
  errors?: (core_apimessages_Error | null)[] | null; 
}

export interface core_apimessages_SetupPaymentMethodsRequest {
  shopCurrency?: string | null; 
  adyenDetails?: core_apimessages_SetupPaymentMethodsRequestAdyenDetails | null; 
  paypalDetails?: core_apimessages_SetupPaymentMethodsRequestPaypalDetails | null; 
  returnPolicyDetails?: core_apimessages_ReturnPolicy | null; 
  creditCard?: core_apimessages_BillingCreditCardEntry | null; 
}

export interface core_apimessages_UpdateShopKYCRequest {
  personalInformation?: core_apimessages_PersonalInformation | null; 
  bankDetails?: core_apimessages_BankDetails | null; 
  companyInformation?: core_apimessages_CompanyInformation | null; 
}

export interface core_apimessages_UploadShopKYCCompanyRegistrationRequest {
  fileKey?: string | null; 
}

export interface core_apimessages_UploadShopKYCCompanyRegistrationResponse {
  _?: boolean | null; 
}

export interface core_apimessages_ProductReviewVoteRequest {
  id?: string | null; 
}

export interface core_apimessages_CSPReviewsRequest {
  ids?: (string | null)[] | null; 
  slugs?: (string | null)[] | null; 
  uuids?: (string | null)[] | null; 
  offset?: number | null; 
  limit?: number | null; 
}

export interface core_apimessages_CSPReviewsResponse {
  reviews?: (core_apimessages_CSPReviews | null)[] | null; 
}

export interface core_apimessages_ConvertShopTypeRequest {
  bankDetails?: core_apimessages_BankDetails | null; 
  personalInformation?: (core_apimessages_PersonalInformation | null)[] | null; 
  companyInformation?: core_apimessages_CompanyInformation | null; 
}

export interface core_apimessages_ConvertShopTypeResponse {
  errors?: (core_apimessages_Error | null)[] | null; 
}

export interface core_apimessages_KYCAccountDetailsResponse {
  accountDetails?: core_apimessages_KYCAccountDetails | null; 
}

export interface core_apimessages_CreateKYCPresignedS3UrlResponse {
  url?: string | null; 
  fileKey?: string | null; 
  headers?: string | null; 
}

export interface core_apimessages_KYCBankAccountVerificationRequest {
  fileKey?: string | null; 
}

export interface core_apimessages_KYCPhotoIDVerificationRequest {
  kycPhotoIdType?: core_apimessages_KYCPhotoIDType | null; 
  fileKeys?: (string | null)[] | null; 
}

export interface core_apimessages_CreateBillingCardRequest {
  creditCardId?: string | null; 
  adyenToken?: string | null; 
  adyenCreditCard?: core_apimessages_AdyenCreditCardEntry | null; 
  address?: core_apimessages_AddressEntry | null; 
}

export interface core_apimessages_EstimatedShippingRequest {
  weight?: number | null; 
  length?: number | null; 
  width?: number | null; 
  height?: number | null; 
  fromPostal?: string | null; 
  metric?: boolean | null; 
  toCountrycode?: string | null; 
  fromCountrycode?: string | null; 
}

export interface core_apimessages_EstimateShippingResponse {
  estimatedShipping?: core_apimessages_EstimatedShipping | null; 
}

export interface core_apimessages_KYCVerificationChecksResponse {
  kycVerificationCheck?: (core_apimessages_KYCVerificationCheck | null)[] | null; 
}

export interface core_apimessages_CreateBillingCardResponse {
  creditCard?: core_apimessages_CreditCard | null; 
}

export interface core_apimessages_CuratedSetFeatureRequest {
  id?: string | null; 
  productId?: string | null; 
}

export interface core_apimessages_ArticleCategoriesResponse {
  articleCategories?: core_apimessages_ArticleCategories | null; 
}

export interface core_apimessages_OrdersRequest {
  uuids?: (string | null)[] | null; 
  ids?: (string | null)[] | null; 
}

export interface core_apimessages_OrdersResponse {
  orders?: (core_apimessages_Order | null)[] | null; 
}

export interface core_apimessages_OrderFeedbacksRequest {
  orderUuids?: (string | null)[] | null; 
  orderIds?: (string | null)[] | null; 
}

export interface core_apimessages_OrderFeedbacksResponse {
  orderFeedbacks?: (core_apimessages_OrderFeedbacks | null)[] | null; 
}

export interface core_apimessages_OrderShippingAddressesRequest {
  orderUuids?: (string | null)[] | null; 
  orderIds?: (string | null)[] | null; 
}

export interface core_apimessages_OrderShippingAddressesResponse {
  addresses?: (core_apimessages_Address | null)[] | null; 
}

export interface core_apimessages_BuyerOrdersResponse {
  orders?: (core_apimessages_BuyerOrder | null)[] | null; 
}

export interface core_apimessages_SellerOrdersResponse {
  orders?: (core_apimessages_SellerOrder | null)[] | null; 
}

export interface core_apimessages_CancelOrderRequest {
  uuid?: string | null; 
  id?: string | null; 
  cancellationReason?: core_apimessages_CancelOrderRequest_CancellationReason | null; 
  relist?: boolean | null; 
}

export interface core_apimessages_MyAddressesRequest {
  addressType?: core_apimessages_MyAddressType | null; 
}

export interface core_apimessages_MyAddressesResponse {
  addresses?: (core_apimessages_Address | null)[] | null; 
}

export interface core_apimessages_UpdateAddressRequest {
  id?: string | null; 
  addressType?: core_apimessages_MyAddressType | null; 
  isPrimary?: boolean | null; 
  address?: core_apimessages_AddressEntry | null; 
  uuid?: string | null; 
}

export interface core_apimessages_AddressDeleteRequest {
  id?: string | null; 
  uuid?: string | null; 
  addressType?: core_apimessages_MyAddressType | null; 
}

export interface core_apimessages_OrderVerifyShippingAddressRequest {
  checkoutUuid?: string | null; 
  orderUuid?: string | null; 
}

export interface core_apimessages_OrderFlatRateShippingOptionsRequest {
  checkoutUuid?: string | null; 
  orderUuid?: string | null; 
}

export interface core_apimessages_OrdersAddressRequest {
  uuids?: (string | null)[] | null; 
  addressType?: string | null; 
}

export interface core_apimessages_OrdersAddressResponse {
  addresses?: (core_apimessages_Address | null)[] | null; 
}

export interface core_apimessages_OrdersCustomsInfoRequest {
  uuids?: (string | null)[] | null; 
  ids?: (string | null)[] | null; 
}

export interface core_apimessages_OrdersCustomsInfoResponse {
  ordersCustomsInfo?: (core_apimessages_OrderCustomsInfo | null)[] | null; 
}

export interface core_apimessages_NegotiationsRequest {
  ids?: (string | null)[] | null; 
}

export interface core_apimessages_OffersRequest {
  ids?: (string | null)[] | null; 
}

export interface core_apimessages_OffersResponse {
  offers?: (core_apimessages_NegotiationOffers | null)[] | null; 
}

export interface core_apimessages_NegotiationsShippingLocationRequest {
  ids?: (string | null)[] | null; 
}

export interface core_apimessages_NegotiationsShippingLocationResponse {
  shippingLocations?: (core_apimessages_Address | null)[] | null; 
}

export interface core_apimessages_CreateNegotiationRequest_ConversationData {
  listingId?: string | null; 
  photos?: (core_apimessages_ImageEntry | null)[] | null; 
}

export interface core_apimessages_CreateNegotiationRequest {
  message?: string | null; 
  offerItems?: (core_apimessages_OfferItemRequest | null)[] | null; 
  recipientUuid?: string | null; 
  countryCode?: string | null; 
  regionCode?: string | null; 
  shippingRegionCode?: string | null; 
  postalCode?: string | null; 
  conversation?: core_apimessages_CreateNegotiationRequest_ConversationData | null; 
  bumpKey?: core_apimessages_BumpKey | null; 
}

export interface core_apimessages_OfferItemRequest {
  listingId?: string | null; 
  price?: core_apimessages_Money | null; 
  shippingPrice?: core_apimessages_Money | null; 
  quantity?: number | null; 
}

export interface core_apimessages_UpdateNegotiationRequest {
  id?: string | null; 
  message?: string | null; 
  offerItems?: (core_apimessages_OfferItemRequest | null)[] | null; 
  action?: core_apimessages_NegotiationAction | null; 
}

export interface core_apimessages_CreateAutoOfferRequest {
  listingId?: string | null; 
  message?: string | null; 
  price?: core_apimessages_Money | null; 
  pushToExisting?: boolean | null; 
  percentage?: number | null; 
}

export interface core_apimessages_AutoOffersRequest {
  listingIds?: (string | null)[] | null; 
}

export interface core_apimessages_AutoOffersResponse {
  autoOffers?: (core_apimessages_AutoOffer | null)[] | null; 
}

export interface core_apimessages_DeleteAutoOfferRequest {
  listingId?: string | null; 
}

export interface core_apimessages_RedeemPromotionalCodeRequest {
  token?: string | null; 
}

export interface core_apimessages_VerifyPromotionalCodeRequest {
  token?: string | null; 
}

export interface core_apimessages_FeedCustomizationResponse {
  articleFollows?: (string | null)[] | null; 
  followGroups?: (core_apimessages_FollowGroup | null)[] | null; 
  follows?: (core_apimessages_Follow | null)[] | null; 
}

export interface core_apimessages_ShopsRequest {
  uuids?: (string | null)[] | null; 
  channel?: core_apimessages_Channel | null; 
  slugs?: (string | null)[] | null; 
}

export interface core_apimessages_ShopsResponse {
  shops?: (core_apimessages_Shop | null)[] | null; 
}

export interface core_apimessages_ArticlesRequest {
  ids?: (string | null)[] | null; 
  slugs?: (string | null)[] | null; 
}

export interface core_apimessages_ArticlesResponse {
  articles?: (core_apimessages_Article | null)[] | null; 
}

export interface core_apimessages_SellingFeesRequest {
  channel?: core_apimessages_Channel | null; 
}

export interface core_apimessages_UsersRequest {
  uuids?: (string | null)[] | null; 
}

export interface core_apimessages_UsersResponse {
  users?: (core_apimessages_User | null)[] | null; 
}

export interface core_apimessages_OrderNotesRequest {
  orderIds?: (string | null)[] | null; 
}

export interface core_apimessages_OrderNotesResponse {
  orderNotes?: (core_apimessages_OrderNote | null)[] | null; 
}

export interface core_apimessages_OrderNotesIndexRequest {
  orderUuids?: (string | null)[] | null; 
  orderIds?: (string | null)[] | null; 
}

export interface core_apimessages_OrderNotesIndexResponse {
  orderNotes?: (core_apimessages_OrderNotes | null)[] | null; 
}

export interface core_apimessages_CreateOrderNoteRequest {
  body?: string | null; 
  orderId?: string | null; 
}

export interface core_apimessages_CreateOrderNoteResponse {
  errors?: (core_apimessages_Error | null)[] | null; 
  orderNote?: core_apimessages_OrderNote | null; 
}

export interface core_apimessages_DeleteOrderNotesRequest {
  orderNoteIds?: (string | null)[] | null; 
}

export interface core_apimessages_SearchFilterPresetsRequest {
  categoryUuids?: (string | null)[] | null; 
  collectionType?: core_apimessages_CollectionHeader_CollectionType | null; 
  collectionIds?: (string | null)[] | null; 
  collectionSlugs?: (string | null)[] | null; 
}

export interface core_apimessages_ItemSearchFilterPresets {
  collectionId?: string | null; 
  collectionType?: string | null; 
  presets?: (core_apimessages_SearchFilterPreset | null)[] | null; 
  collectionSlug?: string | null; 
}

export interface core_apimessages_SearchFilterPresetsResponse {
  searchFilterPresets?: (core_apimessages_ItemSearchFilterPresets | null)[] | null; 
}

export interface core_apimessages_RecentlyViewedListingsRequest {
  limit?: number | null; 
}

export interface core_apimessages_UserWatchesRequest {
  listingIds?: (string | null)[] | null; 
  offset?: number | null; 
  limit?: number | null; 
  channel?: core_apimessages_Channel | null; 
  listingsState?: core_apimessages_UserWatchesRequest_ListingState | null; 
  profileSlug?: string | null; 
}

export interface core_apimessages_MyShopResponse {
  shop?: core_apimessages_Shop | null; 
}

export interface core_apimessages_ShippingProtectionRequest {
  shipmentItems?: (core_apimessages_ShipmentItem | null)[] | null; 
  fromCountryCode?: string | null; 
  toCountryCode?: string | null; 
  shipmentType?: core_apimessages_Shipment_ShipmentType | null; 
}

export interface core_apimessages_CreateShipmentRequest {
  toAddress?: core_apimessages_Address | null; 
  fromAddress?: core_apimessages_Address | null; 
  package?: core_apimessages_ShippingLabelPackage | null; 
  shippingProtection?: boolean | null; 
  signatureRequired?: boolean | null; 
  mediaMailQualified?: boolean | null; 
  customs?: core_apimessages_CustomsInfo | null; 
  orderUuids?: (string | null)[] | null; 
  shippingProtectionPrice?: core_apimessages_Money | null; 
  id?: string | null; 
  toAddressIsResidential?: boolean | null; 
  shipmentType?: core_apimessages_Shipment_ShipmentType | null; 
  modifiedCarrierCalculatedShipment?: boolean | null; 
}

export interface core_apimessages_CreateShipmentResponse {
  shipment?: core_apimessages_Shipment | null; 
  errors?: (core_apimessages_CreateShipmentError | null)[] | null; 
}

export interface core_apimessages_CreateShipmentError {
  message?: string | null; 
  errorType?: core_apimessages_CreateShipmentErrorType | null; 
}

export interface core_apimessages_ShipmentsRequest {
  shipmentUuids?: (string | null)[] | null; 
}

export interface core_apimessages_ShipmentsResponse {
  shipments?: (core_apimessages_Shipment | null)[] | null; 
}

export interface core_apimessages_PurchaseShippingRateRequest {
  shipmentUuid?: string | null; 
  rateUuid?: string | null; 
}

export interface core_apimessages_RegisterMyPacklinkAccountRequest {
  email?: string | null; 
  password?: string | null; 
  policies?: core_apimessages_PacklinkPolicies | null; 
}

export interface core_apimessages_LoginMyPacklinkAccountRequest {
  email?: string | null; 
  password?: string | null; 
  countryCode?: string | null; 
}

export interface core_apimessages_CreatePacklinkDraftRequest {
  orderId?: string | null; 
}

export interface core_apimessages_UpdateBillingMethodRequest {
  creditCard?: core_apimessages_BillingCreditCardEntry | null; 
  browserInfo?: string | null; 
  returnUrl?: string | null; 
  origin?: string | null; 
}

export interface core_apimessages_ShopAddressesRequest {
  uuids?: (string | null)[] | null; 
  ids?: (string | null)[] | null; 
  slugs?: (string | null)[] | null; 
}

export interface core_apimessages_ShopAddressesResponse {
  addresses?: (core_apimessages_PublicShopAddress | null)[] | null; 
}

export interface core_apimessages_TraitsRequest {
  ids?: (string | null)[] | null; 
  type?: core_apimessages_TraitsRequest_TraitableType | null; 
}

export interface core_apimessages_TraitResponse {
  traitableId?: string | null; 
  traits?: (core_apimessages_Trait | null)[] | null; 
}

export interface core_apimessages_TraitsResponse {
  traits?: (core_apimessages_TraitResponse | null)[] | null; 
}

export interface core_apimessages_MyShopOnboardingResponse {
  billingMethodStatus?: core_apimessages_MyShopOnboardingResponse_BillingMethodStatus | null; 
  originCountryCode?: string | null; 
  paypalSetupStatus?: core_apimessages_MyShopOnboardingResponse_PaypalSetupStatus | null; 
  paymentMethod?: core_apimessages_MyShopOnboardingResponse_PaymentMethod | null; 
}

export interface core_apimessages_MyCreditCardsResponse {
  creditCards?: (core_apimessages_CreditCard | null)[] | null; 
}

export interface core_apimessages_MyPayoutBalancesResponse {
  payoutBalances?: (core_apimessages_Money | null)[] | null; 
}

export interface core_apimessages_MyUserServicesResponse {
  userServices?: (core_apimessages_UserService | null)[] | null; 
}

export interface core_apimessages_MyReverbCreditsResponse {
  reverbCredits?: (core_apimessages_Money | null)[] | null; 
}

export interface core_apimessages_ShopShippingProfilesRequest {
  shopUuids?: (string | null)[] | null; 
  ids?: (string | null)[] | null; 
  uuids?: (string | null)[] | null; 
  slugs?: (string | null)[] | null; 
}

export interface core_apimessages_ShopShippingProfilesResponse {
  shopShippingProfiles?: (core_apimessages_ShopShippingProfiles | null)[] | null; 
}

export interface core_apimessages_ChatDepartmentRequest {
  countryCode?: string | null; 
}

export interface core_apimessages_GenerateDraftRequest {
  seedId?: string | null; 
  seedType?: core_apimessages_Listing_SeedType | null; 
}

export interface core_apimessages_UpdateReturnPolicyRequest {
  newReturnWindowDays?: number | null; 
  usedReturnWindowDays?: number | null; 
  restockingFeePercent?: number | null; 
  specialConditions?: string | null; 
}

export interface core_apimessages_ShopReturnPoliciesRequest {
  shopUuids?: (string | null)[] | null; 
  ids?: (string | null)[] | null; 
  uuids?: (string | null)[] | null; 
  slugs?: (string | null)[] | null; 
}

export interface core_apimessages_ShopReturnPoliciesResponse {
  shopReturnPolicies?: (core_apimessages_ShopReturnPolicy | null)[] | null; 
}

export interface core_apimessages_BulkTaxPoliciesRequest {
  requests?: (core_apimessages_TaxPoliciesRequest | null)[] | null; 
}

export interface core_apimessages_TaxPoliciesRequest {
  id?: string | null; 
  uuid?: string | null; 
  slug?: string | null; 
  type?: core_apimessages_TaxPoliciesRequest_TaxPoliciesType | null; 
}

export interface core_apimessages_BulkTaxPoliciesResponse {
  shops?: (core_apimessages_ShopTaxPolicies | null)[] | null; 
}

export interface core_apimessages_MyShopPaypalProfileResponse {
  paypalProfile?: core_apimessages_MyShopPaypalProfileResponse_PaypalProfile | null; 
}

export interface core_apimessages_UpdateMyShopRequest {
  shop?: core_apimessages_ShopEntry | null; 
}

export interface core_apimessages_BrandsRequest {
  uuids?: (string | null)[] | null; 
  slugs?: (string | null)[] | null; 
}

export interface core_apimessages_BrandsResponse {
  brands?: (core_apimessages_Brand | null)[] | null; 
}

export interface core_apimessages_CategoryRequest {
  id?: string | null; 
  withChildren?: boolean | null; 
  withParent?: boolean | null; 
  uuid?: string | null; 
  slug?: string | null; 
  type?: core_apimessages_CategoryRequest_CategoryType | null; 
}

export interface core_apimessages_BulkCategoriesRequest {
  requests?: (core_apimessages_CategoryRequest | null)[] | null; 
}

export interface core_apimessages_BulkCategoriesResponse {
  responses?: (core_apimessages_CategoriesResponse | null)[] | null; 
}

export interface core_apimessages_CategoriesResponse {
  categories?: (core_apimessages_Category | null)[] | null; 
}

export interface core_apimessages_CategoriesRequest {
  ids?: (string | null)[] | null; 
  withChildren?: boolean | null; 
  withParent?: boolean | null; 
  uuids?: (string | null)[] | null; 
  slugs?: (string | null)[] | null; 
}

export interface core_apimessages_CollectionHeaderRequest {
  collectionType?: core_apimessages_CollectionHeader_CollectionType | null; 
  collectionSlug?: string | null; 
}

export interface core_apimessages_CollectionHeaderResponse {
  collectionHeader?: core_apimessages_CollectionHeader | null; 
}

export interface core_apimessages_SearchMetadataRequest {
  categorySlugs?: (string | null)[] | null; 
  brandSlugs?: (string | null)[] | null; 
  conditionSlugs?: (string | null)[] | null; 
  curatedSetSlug?: string | null; 
  shopSlug?: string | null; 
  yearMin?: string | null; 
  yearMax?: string | null; 
  query?: string | null; 
}

export interface core_apimessages_FeedbacksRequest {
  offset?: number | null; 
  limit?: number | null; 
  userUuid?: string | null; 
  type?: core_apimessages_Feedback_Type | null; 
}

export interface core_apimessages_FeedbackSummariesRequest {
  userIds?: (string | null)[] | null; 
  ids?: (string | null)[] | null; 
  uuids?: (string | null)[] | null; 
}

export interface core_apimessages_FeedbackSummariesResponse {
  feedbackSummaries?: (core_apimessages_FeedbackSummary | null)[] | null; 
}

export interface core_apimessages_PreorderInfoRequest {
  listingIds?: (string | null)[] | null; 
}

export interface core_apimessages_PreorderInfoResponse {
  preorderInfo?: (core_apimessages_PreorderInfo | null)[] | null; 
}

export interface core_apimessages_VideosRequest {
  type?: core_apimessages_VideosRequest_VideolinkableType | null; 
  ids?: (string | null)[] | null; 
  uuids?: (string | null)[] | null; 
  slugs?: (string | null)[] | null; 
}

export interface core_apimessages_VideosResponse {
  videos?: (core_apimessages_Video | null)[] | null; 
}

export interface core_apimessages_EstimatedMonthlyPaymentsRequest {
  ids?: (string | null)[] | null; 
}

export interface core_apimessages_EstimatedMonthlyPaymentsResponse {
  estimatedMonthlyPayments?: (core_apimessages_EstimatedMonthlyPayment | null)[] | null; 
}

export interface core_apimessages_OtherBuyersWithListingInCartCountsRequest {
  ids?: (string | null)[] | null; 
}

export interface core_apimessages_OtherBuyersWithListingInCartCountsResponse {
  listingInCartCount?: (core_apimessages_ListingInCartCount | null)[] | null; 
}

export interface core_apimessages_AcceptedPaymentMethodsRequest {
  ids?: (string | null)[] | null; 
  type?: core_apimessages_AcceptedPaymentMethodsRequest_PaymentMethodsType | null; 
}

export interface core_apimessages_AcceptedPaymentMethodsResponse {
  paymentMethods?: (core_apimessages_PaymentMethods | null)[] | null; 
}

export interface core_apimessages_PaymentMethods {
  itemId?: string | null; 
  itemType?: string | null; 
  acceptedPaymentMethods?: (string | null)[] | null; 
}

export interface core_apimessages_DeleteRequest {
  id?: string | null; 
  uuid?: string | null; 
}

export interface core_apimessages_AffirmFinancingPromotionsRequest {
  ids?: (string | null)[] | null; 
}

export interface core_apimessages_AffirmFinancingPromotionsResponse {
  affirmFinancingPromotions?: (core_apimessages_AffirmFinancingPromotion | null)[] | null; 
}

export interface core_apimessages_AuctionsRequest {
  ids?: (string | null)[] | null; 
}

export interface core_apimessages_AuctionsResponse {
  auctions?: (core_apimessages_Auction | null)[] | null; 
}

export interface core_apimessages_AuctionBidsRequest {
  auctionId?: string | null; 
  offset?: number | null; 
  limit?: number | null; 
}

export interface core_apimessages_BidsCreateRequest {
  bid?: core_apimessages_PrivateBid | null; 
}

export interface core_apimessages_AuctionBidDetailsResponse {
  auctionBidDetails?: (core_apimessages_BidDetails | null)[] | null; 
}

export interface core_apimessages_AuctionBidDetailsRequest {
  auctionIds?: (string | null)[] | null; 
}

export interface core_apimessages_MyBidDetailsResponse {
  myBidDetails?: (core_apimessages_MyBidDetails | null)[] | null; 
}

export interface core_apimessages_MyBidDetailsRequest {
  auctionIds?: (string | null)[] | null; 
}

export interface core_apimessages_AccountAlertsResponse {
  alerts?: (core_apimessages_Alert | null)[] | null; 
}

export interface core_apimessages_WatchesRequest {
  listingIds?: (string | null)[] | null; 
  offset?: number | null; 
  limit?: number | null; 
  channel?: core_apimessages_Channel | null; 
  listingsState?: core_apimessages_WatchesRequest_ListingState | null; 
}

export interface core_apimessages_WatchesResponse {
  watches?: (core_apimessages_WatchResponse | null)[] | null; 
  offset?: number | null; 
  limit?: number | null; 
  total?: number | null; 
}

export interface core_apimessages_WatchResponse {
  listingId?: string | null; 
  watching?: boolean | null; 
}

export interface core_apimessages_OrderPaymentsRequest {
  orderUuids?: (string | null)[] | null; 
  orderIds?: (string | null)[] | null; 
}

export interface core_apimessages_OrderPaymentsResponse {
  orderPayments?: (core_apimessages_OrderPayments | null)[] | null; 
}

export interface core_apimessages_OrderRefundsRequest {
  orderUuids?: (string | null)[] | null; 
  orderIds?: (string | null)[] | null; 
}

export interface core_apimessages_OrderRefundsResponse {
  orderRefunds?: (core_apimessages_OrderRefunds | null)[] | null; 
}

export interface core_apimessages_BuyerRefundsRequest {
  ids?: (string | null)[] | null; 
}

export interface core_apimessages_BuyerRefundsResponse {
  buyerRefunds?: (core_apimessages_BuyerRefund | null)[] | null; 
}

export interface core_apimessages_WatchesCreateRequest {
  listingId?: string | null; 
  channel?: core_apimessages_Channel | null; 
  bumpKey?: core_apimessages_BumpKey | null; 
}

export interface core_apimessages_WatchesDeleteRequest {
  listingId?: string | null; 
}

export interface core_apimessages_StorefrontsRequest {
  slugs?: (string | null)[] | null; 
}

export interface core_apimessages_StorefrontsResponse {
  storefronts?: (core_apimessages_Storefront | null)[] | null; 
}

export interface core_apimessages_StorefrontReturnPoliciesRequest {
  slugs?: (string | null)[] | null; 
}

export interface core_apimessages_StorefrontReturnPoliciesResponse {
  returnPolicies?: (core_apimessages_ReturnPolicy | null)[] | null; 
}

export interface core_apimessages_UpdateFeedbackRequest {
  orderUuid?: string | null; 
  message?: string | null; 
  rating?: number | null; 
  shippingSatisfactory?: google_protobuf_BoolValue | null; 
  conditionSatisfactory?: google_protobuf_BoolValue | null; 
}

export interface core_apimessages_DeclineFeedbackRequest {
  orderUuid?: string | null; 
}

export interface core_apimessages_ListingsCuratedSetsRequest {
  ids?: (string | null)[] | null; 
  curatedSetSlugs?: (string | null)[] | null; 
}

export interface core_apimessages_ListingsCuratedSetsResponse {
  curatedSetsForListings?: (core_apimessages_CuratedSetsForListing | null)[] | null; 
}

export interface core_apimessages_AdminCuratedSetsCurateRequest {
  curatedSetSlug?: string | null; 
  listingId?: string | null; 
  featuredInSet?: boolean | null; 
}

export interface core_apimessages_PrimaryKey {
  type?: core_apimessages_PrimaryKey_Type | null; 
  value?: string | null; 
}

export interface core_apimessages_BulkAddressesRequest_Query {
  relation?: core_apimessages_BulkAddressesRequest_Relation | null; 
  primaryKey?: core_apimessages_PrimaryKey | null; 
}

export interface core_apimessages_BulkAddressesRequest {
  queries?: (core_apimessages_BulkAddressesRequest_Query | null)[] | null; 
}

export interface core_apimessages_BulkAddressesResponse_QueryResult {
  addresses?: (core_apimessages_Address | null)[] | null; 
}

export interface core_apimessages_BulkAddressesResponse {
  results?: (core_apimessages_BulkAddressesResponse_QueryResult | null)[] | null; 
}

export interface core_apimessages_BulkOrdersRequest_Query {
  relation?: core_apimessages_BulkOrdersRequest_Relation | null; 
  primaryKey?: core_apimessages_PrimaryKey | null; 
  as?: core_apimessages_BulkOrdersRequest_Party | null; 
}

export interface core_apimessages_BulkOrdersRequest {
  queries?: (core_apimessages_BulkOrdersRequest_Query | null)[] | null; 
}

export interface core_apimessages_BulkOrdersResponse_QueryResult {
  orders?: (core_apimessages_Order | null)[] | null; 
}

export interface core_apimessages_BulkOrdersResponse {
  results?: (core_apimessages_BulkOrdersResponse_QueryResult | null)[] | null; 
}

export interface core_apimessages_MyCuratedSetMembershipRequest {
  setType?: core_apimessages_CuratedSet_SetType | null; 
  productId?: string | null; 
}

export interface core_apimessages_BulkCuratedSetsRequest_Query {
  relation?: core_apimessages_BulkCuratedSetsRequest_Relation | null; 
  primaryKey?: core_apimessages_PrimaryKey | null; 
  setTypes?: (core_apimessages_CuratedSet_SetType | null)[] | null; 
}

export interface core_apimessages_BulkCuratedSetsRequest {
  queries?: (core_apimessages_BulkCuratedSetsRequest_Query | null)[] | null; 
}

export interface core_apimessages_BulkCuratedSetsResponse_QueryResult {
  curatedSets?: (core_apimessages_CuratedSet | null)[] | null; 
}

export interface core_apimessages_BulkCuratedSetsResponse {
  results?: (core_apimessages_BulkCuratedSetsResponse_QueryResult | null)[] | null; 
}

export interface core_apimessages_ReverifyCreditCardRequest {
  creditCardId?: string | null; 
  tokenizedFields?: string | null; 
}

export interface core_apimessages_ReferAFriendResponse {
  referAFriend?: core_apimessages_ReferAFriend | null; 
}

export interface core_apimessages_CheckoutPaymentResponse {
  checkoutUuid?: string | null; 
  adyenPaymentResult?: core_apimessages_AdyenPaymentResult | null; 
  orderBundleId?: string | null; 
  checkoutId?: string | null; 
  paymentResultUrl?: string | null; 
}

export interface core_apimessages_CheckoutVerifyShopperRequest {
  checkoutUuid?: string | null; 
  checkoutId?: string | null; 
  totalPrice?: core_apimessages_Money | null; 
  results?: core_apimessages_AdyenVerifyShopperResults | null; 
}

export interface core_apimessages_CheckoutIdentifyShopperRequest {
  checkoutUuid?: string | null; 
  checkoutId?: string | null; 
  totalPrice?: core_apimessages_Money | null; 
  results?: core_apimessages_AdyenIdentifyShopperResults | null; 
  channelBrandingToken?: string | null; 
}

export interface core_apimessages_CheckoutChallengeShopperRequest {
  checkoutUuid?: string | null; 
  checkoutId?: string | null; 
  totalPrice?: core_apimessages_Money | null; 
  results?: core_apimessages_AdyenChallengeShopperResults | null; 
  channelBrandingToken?: string | null; 
}

export interface core_apimessages_GuestCheckoutVerifyShopperRequest {
  checkoutUuid?: string | null; 
  checkoutId?: string | null; 
  totalPrice?: core_apimessages_Money | null; 
  results?: core_apimessages_AdyenVerifyShopperResults | null; 
  cartItemAttributes?: (core_apimessages_CartItemAttributes | null)[] | null; 
}

export interface core_apimessages_GuestCheckoutApplePayLineItemsRequest {
  shippingAddress?: core_apimessages_Address | null; 
  paymentMethod?: string | null; 
  checkoutId?: string | null; 
  cartItemAttributes?: (core_apimessages_CartItemAttributes | null)[] | null; 
}

export interface core_apimessages_GuestCheckoutApplePayPaymentRequest {
  checkoutUuid?: string | null; 
  checkoutId?: string | null; 
  totalPrice?: core_apimessages_Money | null; 
  cartItemAttributes?: (core_apimessages_CartItemAttributes | null)[] | null; 
  adyenToken?: string | null; 
  shippingAddress?: core_apimessages_Address | null; 
  acceptsTerms?: boolean | null; 
  email?: string | null; 
  firstName?: string | null; 
  lastName?: string | null; 
}

export interface core_apimessages_BillingMethodVerifyShopperRequest {
  results?: core_apimessages_AdyenVerifyShopperResults | null; 
  billingMethodUuid?: string | null; 
}

export interface core_apimessages_BillingMethodIdentifyShopperRequest {
  results?: core_apimessages_AdyenIdentifyShopperResults | null; 
  billingMethodUuid?: string | null; 
}

export interface core_apimessages_BillingMethodChallengeShopperRequest {
  results?: core_apimessages_AdyenChallengeShopperResults | null; 
  billingMethodUuid?: string | null; 
}

export interface core_apimessages_AdyenThreeDSBillingMethodEntry {
  billingCardEntry?: core_apimessages_BillingCreditCardEntry | null; 
  paymentData?: string | null; 
}

export interface core_apimessages_BumpKeysRequest {
  listingIds?: (string | null)[] | null; 
}

export interface core_apimessages_BumpKeysResponse {
  bumpKeys?: (core_apimessages_BumpKey | null)[] | null; 
}

export interface core_apimessages_TrackBumpInteractionRequest {
  bumpKey?: core_apimessages_BumpKey | null; 
  listingId?: string | null; 
  interactionType?: arbiter_Interaction_InteractionType | null; 
}

export interface core_apimessages_SiteBannerRequest {
  limit?: number | null; 
  visibilityScope?: core_apimessages_SiteBannerRequest_VisibilityScope | null; 
}

export interface core_apimessages_SiteBannerResponse {
  siteBanner?: core_apimessages_SiteBanner | null; 
  siteBanners?: (core_apimessages_SiteBanner | null)[] | null; 
}

export interface core_apimessages_CPSuggestionsRequest {
  listingIds?: (string | null)[] | null; 
}

export interface core_apimessages_CPSuggestionsResponse {
  cpSuggestions?: (core_apimessages_CPSuggestions | null)[] | null; 
}

export interface core_apimessages_DeleteGearCollectionItemRequest {
  id?: string | null; 
}

export interface core_apimessages_DeleteGearCollectionItemResponse {
  gearCollectionItem?: core_apimessages_GearCollectionItem | null; 
}

export interface core_apimessages_UpdateGearCollectionItemRequest {
  gearCollectionItemEntry?: core_apimessages_GearCollectionItemEntry | null; 
}

export interface core_apimessages_UpdateGearCollectionItemResponse {
  gearCollectionItem?: core_apimessages_GearCollectionItem | null; 
}

export interface core_apimessages_CreateTaxIdentificationRequest {
  taxId?: string | null; 
  countryCode?: string | null; 
}

export interface core_apimessages_UpdateTaxIdentificationRequest {
  taxIdentification?: core_apimessages_TaxIdentificationUpdate | null; 
}

export interface core_apimessages_TaxIdentificationUpdate {
  id?: string | null; 
  taxId?: string | null; 
  countryCode?: string | null; 
}

export interface core_apimessages_DeactivateTaxIdentificationRequest {
  id?: string | null; 
}

export interface core_apimessages_AdZonesSearchRequest {
  offset?: number | null; 
  limit?: number | null; 
}

export interface core_apimessages_DelinkUserServiceRequest {
  provider?: core_apimessages_UserService_Provider | null; 
}

export interface core_apimessages_UpdateUniversalPromoCampaignRequest {
  universalPromoCampaign?: core_apimessages_UniversalPromoCampaign | null; 
}

export interface core_apimessages_AdminUserSearchRequest {
  search?: string | null; 
  activated?: core_apimessages_AdminUserSearchRequest_ActivatedFilter | null; 
  userFilter?: string | null; 
  page?: string | null; 
  perPage?: string | null; 
}

export interface core_apimessages_UpdateListingRequest {
  listingEntry?: core_apimessages_ListingEntry | null; 
}

export interface core_apimessages_UpdateListingResponse {
  listing?: core_apimessages_Listing | null; 
}

export interface core_apimessages_BearerV2TokenRequest {
  client?: core_apimessages_BearerV2TokenRequest_Client | null; 
}

export interface core_apimessages_MyCartItemsIndexResponse {
  cartItems?: (core_apimessages_CartItem | null)[] | null; 
}

export interface core_apimessages_Core {
  BidsCreate?: core_apimessages_BidsCreateResponse | null; 
  AdminBidsDelete?: core_apimessages_DeleteResponse | null; 
  Listings?: core_apimessages_ListingsResponse | null; 
  OrdersCustomsInfo?: core_apimessages_OrdersCustomsInfoResponse | null; 
  Me?: core_apimessages_MeResponse | null; 
  BrandManagerBrands?: core_apimessages_BrandManagerBrandsResponse | null; 
  BrandManagerBrand?: core_apimessages_BrandManagerBrandResponse | null; 
  CSPs?: core_apimessages_CSPsResponse | null; 
  CSPsInventory?: core_apimessages_CSPsInventoryResponse | null; 
  CSPsFeaturedListing?: core_apimessages_CSPsFeaturedListingResponse | null; 
  CSPsVideo?: core_apimessages_CSPsVideoResponse | null; 
  CSPsSpecs?: core_apimessages_CSPsSpecsResponse | null; 
  Countries?: core_apimessages_CountriesResponse | null; 
  CuratedSets?: core_apimessages_CuratedSetsResponse | null; 
  ShippingPrices?: core_apimessages_ShippingPricesResponse | null; 
  Users?: core_apimessages_UsersResponse | null; 
  ShopShippingProfiles?: core_apimessages_ShopShippingProfilesResponse | null; 
  CreateMyCuratedSetsMembership?: core_apimessages_MyCuratedSetMembershipResponse | null; 
  DeleteMyCuratedSetsMembership?: core_apimessages_MyCuratedSetMembershipResponse | null; 
  MyDirectCheckoutProfile?: core_apimessages_MyDirectCheckoutProfileResponse | null; 
  MyShopOrderRefundStats?: core_apimessages_MyShopOrderRefundStatsResponse | null; 
  MyShopShippingProfiles?: core_apimessages_MyShopShippingProfilesResponse | null; 
  MyShopShippingRates?: core_apimessages_MyShopShippingRatesResponse | null; 
  UpdateMyShopShippingProfiles?: core_apimessages_UpdateMyShopShippingProfilesResponse | null; 
  Articles?: core_apimessages_ArticlesResponse | null; 
  Shops?: core_apimessages_ShopsResponse | null; 
  SearchFilterPresets?: core_apimessages_SearchFilterPresetsResponse | null; 
  Categories?: core_apimessages_CategoriesResponse | null; 
  BulkCategories?: core_apimessages_BulkCategoriesResponse | null; 
  CollectionHeader?: core_apimessages_CollectionHeaderResponse | null; 
  SearchMetadata?: core_apimessages_SearchMetadataResponse | null; 
  MyAddresses?: core_apimessages_MyAddressesResponse | null; 
  DeleteMyAddress?: core_apimessages_DeleteResponse | null; 
  AutoOfferCreate?: core_apimessages_CreateAutoOfferResponse | null; 
  AutoOffers?: core_apimessages_AutoOffersResponse | null; 
  AutoOffersDelete?: core_apimessages_DeleteAutoOfferResponse | null; 
  NegotiationsCreate?: core_apimessages_NegotiationsResponse | null; 
  NegotiationsAccept?: core_apimessages_UpdateNegotiationResponse | null; 
  NegotiationsReject?: core_apimessages_UpdateNegotiationResponse | null; 
  NegotiationsCounter?: core_apimessages_UpdateNegotiationResponse | null; 
  NegotiationsShippingLocations?: core_apimessages_NegotiationsShippingLocationResponse | null; 
  PromotionalCodesRedeem?: core_apimessages_RedeemPromotionalCodeResponse | null; 
  PromotionalCodesVerify?: core_apimessages_VerifyPromotionalCodeResponse | null; 
  RecentlyViewedListings?: core_apimessages_RecentlyViewedListingsResponse | null; 
  ListingsPricing?: core_apimessages_ListingsPricingResponse | null; 
  ListingsSpecs?: core_apimessages_ListingsSpecsResponse | null; 
  SellerListings?: core_apimessages_SellerListingsResponse | null; 
  ListingCounts?: core_apimessages_ListingCountsResponse | null; 
  MyCounts?: core_apimessages_CountsResponse | null; 
  Images?: core_apimessages_ImagesResponse | null; 
  BulkImages?: core_apimessages_ImagesResponse | null; 
  Orders?: core_apimessages_OrdersResponse | null; 
  OrdersFeedbacks?: core_apimessages_OrderFeedbacksResponse | null; 
  DeclineFeedback?: core_apimessages_DeclineFeedbackResponse | null; 
  UpdateFeedback?: core_apimessages_UpdateFeedbackResponse | null; 
  VerifiedShippingAddress?: core_apimessages_OrderVerifyShippingAddressResponse | null; 
  OrderFlatRateShippingOptions?: core_apimessages_OrderFlatRateShippingOptionsResponse | null; 
  Negotiations?: core_apimessages_NegotiationsResponse | null; 
  Offers?: core_apimessages_OffersResponse | null; 
  SellingFees?: core_apimessages_SellingFeesResponse | null; 
  MyShop?: core_apimessages_MyShopResponse | null; 
  UpdateMyShop?: core_apimessages_UpdateMyShopResponse | null; 
  MyShopKYC?: core_apimessages_KYCAccountDetailsResponse | null; 
  UpdateMyShopKYC?: core_apimessages_UpdateShopKYCResponse | null; 
  UploadShopKYCCompanyRegistration?: core_apimessages_UploadShopKYCCompanyRegistrationResponse | null; 
  UpdateMyShopBillingMethod?: core_apimessages_UpdateBillingMethodResponse | null; 
  BillingMethodIdentifyShopper?: core_apimessages_BillingMethodIdentifyShopperResponse | null; 
  BillingMethodChallengeShopper?: core_apimessages_BillingMethodChallengeShopperResponse | null; 
  BillingMethodVerifyShopper?: core_apimessages_BillingMethodVerifyShopperResponse | null; 
  SetupShopPaymentMethods?: core_apimessages_SetupPaymentMethodsResponse | null; 
  ShippingProtection?: core_apimessages_ShippingProtectionResponse | null; 
  CreateShipment?: core_apimessages_CreateShipmentResponse | null; 
  Shipments?: core_apimessages_ShipmentsResponse | null; 
  PurchaseShippingRate?: core_apimessages_PurchaseShippingRateResponse | null; 
  ShopAddresses?: core_apimessages_ShopAddressesResponse | null; 
  Traits?: core_apimessages_TraitsResponse | null; 
  MyShopOnboarding?: core_apimessages_MyShopOnboardingResponse | null; 
  MyCreditCards?: core_apimessages_MyCreditCardsResponse | null; 
  CreateMyCreditCard?: core_apimessages_CreateMyCreditCardResponse | null; 
  UpdateMyCreditCard?: core_apimessages_UpdateMyCreditCardResponse | null; 
  DeleteMyCreditCard?: core_apimessages_DeleteMyCreditCardResponse | null; 
  MyPayoutBalances?: core_apimessages_MyPayoutBalancesResponse | null; 
  MyUserServices?: core_apimessages_MyUserServicesResponse | null; 
  MyReverbCredits?: core_apimessages_MyReverbCreditsResponse | null; 
  MyCartItemsIndex?: core_apimessages_MyCartItemsIndexResponse | null; 
  GenerateDraft?: core_apimessages_GenerateDraftResponse | null; 
  ChatDepartment?: core_apimessages_ChatDepartmentResponse | null; 
  UpdateReturnPolicy?: core_apimessages_UpdateReturnPolicyResponse | null; 
  ShopReturnPolicies?: core_apimessages_ShopReturnPoliciesResponse | null; 
  BulkTaxPolicies?: core_apimessages_BulkTaxPoliciesResponse | null; 
  MyShopPaypalProfile?: core_apimessages_MyShopPaypalProfileResponse | null; 
  AccoutAlerts?: core_apimessages_AccountAlertsResponse | null; 
  Brands?: core_apimessages_BrandsResponse | null; 
  Feedback?: core_apimessages_FeedbacksResponse | null; 
  FeedbackSummaries?: core_apimessages_FeedbackSummariesResponse | null; 
  PreorderInfo?: core_apimessages_PreorderInfoResponse | null; 
  Videos?: core_apimessages_VideosResponse | null; 
  EstimatedMonthlyPayments?: core_apimessages_EstimatedMonthlyPaymentsResponse | null; 
  OtherBuyersWithListingInCartCounts?: core_apimessages_OtherBuyersWithListingInCartCountsResponse | null; 
  AcceptedPaymentMethods?: core_apimessages_AcceptedPaymentMethodsResponse | null; 
  UpdateMyAddress?: core_apimessages_UpdateAddressResponse | null; 
  AffirmFinancingPromotions?: core_apimessages_AffirmFinancingPromotionsResponse | null; 
  Auctions?: core_apimessages_AuctionsResponse | null; 
  Bids?: core_apimessages_AuctionBidsResponse | null; 
  BidDetails?: core_apimessages_AuctionBidDetailsResponse | null; 
  MyBidDetails?: core_apimessages_MyBidDetailsResponse | null; 
  MyWatches?: core_apimessages_WatchesResponse | null; 
  UserWatches?: core_apimessages_WatchesResponse | null; 
  OrderShippingAddresses?: core_apimessages_OrderShippingAddressesResponse | null; 
  BuyerOrders?: core_apimessages_BuyerOrdersResponse | null; 
  OrderPayments?: core_apimessages_OrderPaymentsResponse | null; 
  OrderNotes?: core_apimessages_OrderNotesIndexResponse | null; 
  SellerOrders?: core_apimessages_SellerOrdersResponse | null; 
  CancelOrder?: core_apimessages_CancelOrderResponse | null; 
  OrderRefunds?: core_apimessages_OrderRefundsResponse | null; 
  BuyerRefunds?: core_apimessages_BuyerRefundsResponse | null; 
  CreateMyWatches?: core_apimessages_UpdateWatchResponse | null; 
  DeleteMyWatches?: core_apimessages_UpdateWatchResponse | null; 
  Storefronts?: core_apimessages_StorefrontsResponse | null; 
  BulkCuratedSets?: core_apimessages_BulkCuratedSetsResponse | null; 
  StorefrontReturnPolicies?: core_apimessages_StorefrontReturnPoliciesResponse | null; 
  CSPReviews?: core_apimessages_CSPReviewsResponse | null; 
  VoteProductReview?: core_apimessages_ProductReviewVoteResponse | null; 
  ListingsCuratedSets?: core_apimessages_ListingsCuratedSetsResponse | null; 
  AddListingToCuratedSet?: core_apimessages_AdminCuratedSetsCurateResponse | null; 
  RemoveListingFromCuratedSet?: core_apimessages_AdminCuratedSetsCurateResponse | null; 
  FeatureListingInCuratedSet?: core_apimessages_AdminCuratedSetsCurateResponse | null; 
  UnfeatureListingInCuratedSet?: core_apimessages_AdminCuratedSetsCurateResponse | null; 
  BulkAddresses?: core_apimessages_BulkAddressesResponse | null; 
  BulkOrders?: core_apimessages_BulkOrdersResponse | null; 
  ReverifyCreditCard?: core_apimessages_ReverifyCreditCardResponse | null; 
  ReferAFriend?: core_apimessages_ReferAFriendResponse | null; 
  CheckoutCreatePaymentRedirectUrl?: core_apimessages_CheckoutCreatePaymentRedirectUrlResponse | null; 
  StartCheckoutForListing?: core_apimessages_StartCheckoutForListingResponse | null; 
  ApplyCheckoutDiscountCode?: core_apimessages_ApplyCheckoutDiscountCodeResponse | null; 
  SelectCheckoutCreditCard?: core_apimessages_SelectCheckoutCreditCardResponse | null; 
  UpdateCheckoutGuestCreditCard?: core_apimessages_UpdateCheckoutGuestCreditCardResponse | null; 
  CheckoutUpdateGuestContactInfo?: core_apimessages_CheckoutUpdateGuestContactInfoResponse | null; 
  SelectCheckoutPaymentMethod?: core_apimessages_SelectCheckoutPaymentMethodResponse | null; 
  CheckoutFinalizeDigitalWalletPayment?: core_apimessages_CheckoutFinalizeDigitalWalletPaymentResponse | null; 
  CheckoutFinalizeRedirectPaymentCheckout?: core_apimessages_CheckoutFinalizeRedirectPaymentCheckoutResponse | null; 
  CheckoutFinalizeDirectCheckoutPayment?: core_apimessages_CheckoutFinalizeDirectCheckoutPaymentResponse | null; 
  CheckoutVerifyShopper?: core_apimessages_CheckoutVerifyShopperResponse | null; 
  CheckoutIdentifyShopper?: core_apimessages_CheckoutIdentifyShopperResponse | null; 
  CheckoutChallengeShopper?: core_apimessages_CheckoutChallengeShopperResponse | null; 
  GuestCheckoutVerifyShopper?: core_apimessages_CheckoutVerifyShopperResponse | null; 
  GuestCheckoutApplePayLineItems?: core_apimessages_GuestCheckoutApplePayLineItemsResponse | null; 
  GuestCheckoutApplePayPayment?: core_apimessages_GuestCheckoutApplePayPaymentResponse | null; 
  BumpKeys?: core_apimessages_BumpKeysResponse | null; 
  SiteBanner?: core_apimessages_SiteBannerResponse | null; 
  SiteBanners?: core_apimessages_SiteBannerResponse | null; 
  TrackBumpInteraction?: core_apimessages_TrackBumpInteractionResponse | null; 
  CPSuggestions?: core_apimessages_CPSuggestionsResponse | null; 
  NodesAdvertisers?: core_apimessages_NodeResponse | null; 
  NodesAdCampaigns?: core_apimessages_NodeResponse | null; 
  NodesAddresses?: core_apimessages_NodeResponse | null; 
  NodesAdGroups?: core_apimessages_NodeResponse | null; 
  NodesAdGroupKeywords?: core_apimessages_NodeResponse | null; 
  NodesAds?: core_apimessages_NodeResponse | null; 
  NodesAdZones?: core_apimessages_NodeResponse | null; 
  NodesCsps?: core_apimessages_NodeResponse | null; 
  NodesCartItems?: core_apimessages_NodeResponse | null; 
  NodesCategories?: core_apimessages_NodeResponse | null; 
  NodesCuratedSets?: core_apimessages_NodeResponse | null; 
  NodesImages?: core_apimessages_NodeResponse | null; 
  NodesListings?: core_apimessages_NodeResponse | null; 
  NodesListingsPricings?: core_apimessages_NodeResponse | null; 
  NodesListingsSignals?: core_apimessages_NodeResponse | null; 
  NodesOrders?: core_apimessages_NodeResponse | null; 
  NodesOrderBundles?: core_apimessages_NodeResponse | null; 
  NodesPacklinkShipments?: core_apimessages_NodeResponse | null; 
  NodesSales?: core_apimessages_NodeResponse | null; 
  NodesShippingRates?: core_apimessages_NodeResponse | null; 
  NodesBumpRates?: core_apimessages_NodeResponse | null; 
  NodesCspVariants?: core_apimessages_NodeResponse | null; 
  NodesCspExpressSaleItemBids?: core_apimessages_NodeResponse | null; 
  NodesGearCollectionItems?: core_apimessages_NodeResponse | null; 
  NodesPublicPriceRecords?: core_apimessages_NodeResponse | null; 
  NodesUsers?: core_apimessages_NodeResponse | null; 
  NodesNonUserExperiments?: core_apimessages_NodeResponse | null; 
  NodesPriceGuides?: core_apimessages_NodeResponse | null; 
  NodesAdyenCheckoutPaymentMethods?: core_apimessages_NodeResponse | null; 
  NodesTaxIdentifications?: core_apimessages_NodeResponse | null; 
  NodesPriceChanges?: core_apimessages_NodeResponse | null; 
  NodesSiteBanners?: core_apimessages_NodeResponse | null; 
  NodesShops?: core_apimessages_NodeResponse | null; 
  NodesMyUpdatesPromotions?: core_apimessages_NodeResponse | null; 
  NodesUniversalPromoCampaigns?: core_apimessages_NodeResponse | null; 
  NodesShipmentPackages?: core_apimessages_NodeResponse | null; 
  RegisterMyPacklinkAccount?: core_apimessages_RegisterMyPacklinkAccountResponse | null; 
  LoginMyPacklinkAccount?: core_apimessages_LoginMyPacklinkAccountResponse | null; 
  MyPacklinkAccountStatus?: core_apimessages_MyPacklinkAccountStatusResponse | null; 
  CreatePacklinkDraft?: core_apimessages_CreatePacklinkDraftResponse | null; 
  DeleteMyGearCollectionItem?: core_apimessages_DeleteGearCollectionItemResponse | null; 
  UpdateGearCollectionItem?: core_apimessages_UpdateGearCollectionItemResponse | null; 
  CreateTaxIdentification?: core_apimessages_CreateTaxIdentificationResponse | null; 
  UpdateTaxIdentification?: core_apimessages_UpdateTaxIdentificationResponse | null; 
  DeactivateTaxIdentification?: core_apimessages_DeactivateTaxIdentificationResponse | null; 
  AdServe?: core_apimessages_AdServeResponse | null; 
  UpdateAdCampaign?: core_apimessages_UpdateAdCampaignResponse | null; 
  UpdateAdvertiser?: core_apimessages_UpdateAdvertiserResponse | null; 
  UpdateAdZone?: core_apimessages_UpdateAdZoneResponse | null; 
  AdvertisersSearch?: core_apimessages_AdvertisersSearchResponse | null; 
  AdCampaignsSearch?: core_apimessages_AdCampaignsSearchResponse | null; 
  AdGroupsSearch?: core_apimessages_AdGroupsSearchResponse | null; 
  AdsSearch?: core_apimessages_AdsSearchResponse | null; 
  AdZonesSearch?: core_apimessages_AdZonesSearchResponse | null; 
  UpdateAdGroupKeywords?: core_apimessages_UpdateAdGroupKeywordsResponse | null; 
  CopyAdGroup?: core_apimessages_CopyAdGroupResponse | null; 
  UpdateAdGroup?: core_apimessages_UpdateAdGroupResponse | null; 
  UpdateAd?: core_apimessages_UpdateAdResponse | null; 
  DeleteAd?: core_apimessages_DeleteAdResponse | null; 
  CreateMyPlaidLinkToken?: core_apimessages_CreateMyPlaidLinkTokenResponse | null; 
  SaveMyPlaidAccount?: core_apimessages_SaveMyPlaidAccountResponse | null; 
  CancelPlaidAccount?: core_apimessages_CancelPlaidAccountResponse | null; 
  RequestAccountDeletion?: core_apimessages_RequestAccountDeletionResponse | null; 
  DelinkUserService?: core_apimessages_DelinkUserServiceResponse | null; 
  AdaChatToken?: core_apimessages_AdaChatTokenResponse | null; 
  BearerV2Token?: core_apimessages_BearerV2TokenResponse | null; 
  Experiments?: core_apimessages_ExperimentsResponse | null; 
  MosaicTilesHomepage?: core_apimessages_MosaicTilesResponse | null; 
  UpdateUniversalPromoCampaign?: core_apimessages_UpdateUniversalPromoCampaignResponse | null; 
  CheckoutCreate?: core_apimessages_CheckoutCreateResponse | null; 
  CheckoutShow?: core_apimessages_CheckoutShowResponse | null; 
  CheckoutCartEdit?: core_apimessages_CheckoutCartEditResponse | null; 
  CheckoutAction?: core_apimessages_CheckoutActionResponse | null; 
  CheckoutSelectShippingAddress?: core_apimessages_CheckoutSelectShippingAddressResponse | null; 
  CheckoutUpdateShippingAddress?: core_apimessages_CheckoutUpdateShippingAddressResponse | null; 
  CheckoutSelectOrderShippingMethod?: core_apimessages_CheckoutSelectOrderShippingMethodResponse | null; 
  CheckoutUpdateShippingEstimate?: core_apimessages_CheckoutUpdateShippingEstimateResponse | null; 
  ExpressSaleCheckoutShow?: core_apimessages_ExpressSaleCheckoutShowResponse | null; 
  CreateExpressSaleCheckout?: core_apimessages_CreateExpressSaleCheckoutResponse | null; 
  CompleteExpressSaleCheckout?: core_apimessages_CompleteExpressSaleCheckoutResponse | null; 
  AdminUserSearch?: core_apimessages_AdminUserSearchResponse | null; 
  UpdateListing?: core_apimessages_UpdateListingResponse | null; 
}

export interface reverb_search_LimitedAggregation {
  brandUuids?: number | null; 
  categoryUuids?: number | null; 
}

export interface reverb_search_TopCollectionsRequest {
  brandUuids?: number | null; 
  categoryUuids?: number | null; 
}

export interface reverb_search_PageMetaDataRequest {
  excludeCategories?: boolean | null; 
  excludeBrands?: boolean | null; 
}

export interface reverb_search_BumpedSortedListingsQuery {
  total?: number | null; 
  bumpedMax?: number | null; 
  condition?: string | null; 
  itemRegion?: string | null; 
}

export interface reverb_search_ProximityFilterRequest {
  postalCode?: string | null; 
  distance?: string | null; 
  proximity?: boolean | null; 
}

export interface reverb_search_Distance {
  value?: string | null; 
  unit?: reverb_search_Distance_DistanceUnit | null; 
}

export interface reverb_search_Location {
  type?: reverb_search_Location_LocationType | null; 
  value?: string | null; 
}

export interface reverb_search_ProximityRequest {
  applyFilter?: boolean | null; 
  distance?: reverb_search_Distance | null; 
  location?: reverb_search_Location | null; 
}

export interface reverb_search_ExperimentData {
  name?: string | null; 
  groupNum?: number | null; 
}

export interface reverb_search_ListingsSearchRequest {
  brandUuids?: (string | null)[] | null; 
  categoryUuids?: (string | null)[] | null; 
  conditionUuids?: (string | null)[] | null; 
  curatedSetId?: string | null; 
  currency?: string | null; 
  locale?: string | null; 
  priceMax?: string | null; 
  priceMin?: string | null; 
  query?: string | null; 
  sort?: reverb_search_ListingsSearchRequest_Sort | null; 
  statuses?: (string | null)[] | null; 
  yearMax?: string | null; 
  yearMin?: string | null; 
  aggregationsOnly?: boolean | null; 
  limit?: number | null; 
  offset?: number | null; 
  withLimitedAggregations?: reverb_search_LimitedAggregation | null; 
  withAggregations?: (reverb_search_ListingsSearchRequest_Aggregation | null)[] | null; 
  conditionSlugs?: (string | null)[] | null; 
  shippingRegionCodes?: (string | null)[] | null; 
  onSale?: boolean | null; 
  saleCuratedSetId?: string | null; 
  brandSlugs?: (string | null)[] | null; 
  categorySlugs?: (string | null)[] | null; 
  curatedSetSlugs?: (string | null)[] | null; 
  saleSlugs?: (string | null)[] | null; 
  handmade?: boolean | null; 
  freeShipping?: boolean | null; 
  freeExpeditedShipping?: boolean | null; 
  acceptsOffers?: boolean | null; 
  acceptsGiftCards?: boolean | null; 
  preferredSeller?: boolean | null; 
  acceptsPaymentPlans?: boolean | null; 
  itemRegion?: string | null; 
  holidaySale?: boolean | null; 
  shopSlug?: string | null; 
  ids?: (string | null)[] | null; 
  sortSlug?: string | null; 
  bumpCount?: number | null; 
  showOnlySold?: boolean | null; 
  decades?: (string | null)[] | null; 
  traitValues?: (string | null)[] | null; 
  cspSlug?: string | null; 
  showSold?: boolean | null; 
  withTopCollections?: reverb_search_TopCollectionsRequest | null; 
  itemState?: (string | null)[] | null; 
  itemCity?: (string | null)[] | null; 
  bumpedSortedListingsQuery?: reverb_search_BumpedSortedListingsQuery | null; 
  fallbackToOr?: boolean | null; 
  bumpedOnly?: boolean | null; 
  filterSuperRegionCode?: string | null; 
  canonicalFinishes?: (string | null)[] | null; 
  shopId?: string | null; 
  randomSeed?: number | null; 
  withPageMetadata?: reverb_search_PageMetaDataRequest | null; 
  shopSlugs?: (string | null)[] | null; 
  searchUrlParams?: string | null; 
  excludeMerchandisingTypes?: (string | null)[] | null; 
  boostByBumpRate?: boolean | null; 
  cspId?: string | null; 
  notMatchedToCsp?: boolean | null; 
  combinedShipping?: boolean | null; 
  boostCombinedShippingCategories?: (string | null)[] | null; 
  excludeShopIds?: (string | null)[] | null; 
  collapsible?: reverb_search_ListingsSearchRequest_Collapsible | null; 
  priceValue?: reverb_search_ListingsSearchRequest_PriceValue | null; 
  experiments?: (string | null)[] | null; 
  acceptsAffirm?: boolean | null; 
  terminateEarly?: boolean | null; 
  withProximityFilter?: reverb_search_ProximityFilterRequest | null; 
  localPickup?: boolean | null; 
  querylessBumpBoost?: boolean | null; 
  proximity?: reverb_search_ProximityRequest | null; 
  traitSlugs?: (string | null)[] | null; 
  shopUuids?: (string | null)[] | null; 
  es7?: boolean | null; 
  trackTotalHits?: reverb_search_TrackTotalHits | null; 
  minSaleDiscountPercent?: string | null; 
  boostedItemRegionCode?: string | null; 
  useExperimentalQuery?: boolean | null; 
  dealsOrWellPriced?: boolean | null; 
  similarListingIds?: (string | null)[] | null; 
  useExperimentalBestMatchSignalsV1?: boolean | null; 
  useExperimentalRecall?: boolean | null; 
  bestMatchSignalsV2ExperimentGroup?: number | null; 
  useExperimentalRegionBoost?: boolean | null; 
  shipsToMe?: boolean | null; 
  priceValueV2?: reverb_search_ListingsSearchRequest_PriceValue | null; 
  withMyShopAggregations?: (reverb_search_ListingsSearchRequest_MyShopAggregation | null)[] | null; 
  likelihoodToSellExperimentGroup?: number | null; 
  useTotalPrice?: boolean | null; 
  mpTotalPriceExperimentGroup?: number | null; 
  countryOfOrigin?: (string | null)[] | null; 
  itemRegionRelation?: reverb_search_ListingItemRegionRelation | null; 
  ecsBoostExperimentGroup?: number | null; 
  autodirects?: reverb_search_Autodirects | null; 
  skipAutodirects?: boolean | null; 
  listingRecommendationsVersion?: number | null; 
  canonicalProductIds?: (string | null)[] | null; 
  includeDrafts?: boolean | null; 
  contexts?: (reverb_search_Context | null)[] | null; 
  fallbackToEverywhereElse?: boolean | null; 
  excludeLocalPickupOnly?: boolean | null; 
  includeQuerySpellCorrections?: boolean | null; 
  dealsAndSteals?: boolean | null; 
  multiClientExperiments?: (reverb_search_ExperimentData | null)[] | null; 
}

export interface reverb_search_CSPSearchRequest {
  fullTextQuery?: string | null; 
  fuzzy?: boolean | null; 
  locale?: string | null; 
  offset?: number | null; 
  limit?: number | null; 
  withAggregations?: (reverb_search_CSPSearchRequest_Aggregation | null)[] | null; 
  brandNames?: (string | null)[] | null; 
  finishes?: (string | null)[] | null; 
  categoryUuids?: (string | null)[] | null; 
  decades?: (string | null)[] | null; 
  suggestTitle?: string | null; 
  excludedCategoryUuids?: (string | null)[] | null; 
  curatedSetId?: string | null; 
  condition?: string | null; 
  withInventory?: boolean | null; 
  listingsThatShipTo?: string | null; 
  sortByQuality?: boolean | null; 
  boostByClicks?: boolean | null; 
  withLimitedAggregations?: reverb_search_LimitedAggregation | null; 
  categorySlugs?: (string | null)[] | null; 
  brandSlugs?: (string | null)[] | null; 
  maxPriceUsdCents?: number | null; 
  minPriceUsdCents?: number | null; 
  yearMin?: number | null; 
  yearMax?: number | null; 
  curatedSetSlugs?: (string | null)[] | null; 
  fullTextQueryOperand?: reverb_search_FullTextQueryOperand | null; 
  sort?: reverb_search_CSPSearchRequest_Sort | null; 
  slugs?: (string | null)[] | null; 
  includeFields?: (string | null)[] | null; 
  similarListingId?: string | null; 
  similarCspSlug?: string | null; 
  currency?: string | null; 
  ids?: (string | null)[] | null; 
  includeOutOfStock?: boolean | null; 
  searchUrlParams?: string | null; 
  priceMax?: string | null; 
  priceMin?: string | null; 
  traitValues?: (string | null)[] | null; 
  uuids?: (string | null)[] | null; 
  traitSlugs?: (string | null)[] | null; 
  es7?: boolean | null; 
  hasExpressSaleBid?: boolean | null; 
  countryOfOrigin?: (string | null)[] | null; 
  autodirects?: reverb_search_Autodirects | null; 
  skipAutodirects?: boolean | null; 
  contexts?: (reverb_search_Context | null)[] | null; 
}

export interface reverb_search_PriceGuidesSearchRequest {
  fullTextQuery?: string | null; 
  locale?: string | null; 
  offset?: number | null; 
  limit?: number | null; 
  withAggregations?: (reverb_search_PriceGuidesSearchRequest_Aggregation | null)[] | null; 
  brandNames?: (string | null)[] | null; 
  categoryUuids?: (string | null)[] | null; 
  decades?: (string | null)[] | null; 
  categorySlugs?: (string | null)[] | null; 
  withLimitedAggregations?: reverb_search_LimitedAggregation | null; 
}

export interface reverb_search_AuctionsSearchRequest {
  bidderId?: string | null; 
  query?: string | null; 
  offset?: number | null; 
  limit?: number | null; 
  withAggregations?: (reverb_search_AuctionsSearchRequest_Aggregation | null)[] | null; 
  userBidStatus?: reverb_search_AuctionsSearchRequest_UserBidStatus | null; 
  merchandisingTypes?: (reverb_search_AuctionsSearchRequest_MerchandisingType | null)[] | null; 
}

export interface reverb_search_NegotiationSearchRequest {
  offset?: number | null; 
  limit?: number | null; 
  sellerUuids?: (string | null)[] | null; 
  buyerUuids?: (string | null)[] | null; 
  states?: (reverb_search_NegotiationSearchRequest_State | null)[] | null; 
  ids?: (string | null)[] | null; 
  listingIds?: (string | null)[] | null; 
  sort?: string | null; 
  fullTextQuery?: string | null; 
  participantUuids?: (string | null)[] | null; 
  negotiationTypes?: (reverb_search_NegotiationSearchRequest_Type | null)[] | null; 
  withAggregations?: (reverb_search_NegotiationSearchRequest_Aggregation | null)[] | null; 
}

export interface reverb_search_CompletionsRequest {
  query?: string | null; 
  types?: (reverb_search_CompletionType | null)[] | null; 
  currency?: string | null; 
  shippingRegionCode?: string | null; 
  locale?: string | null; 
  experiments?: (string | null)[] | null; 
}

export interface reverb_search_LPCompletionsRequest {
  query?: string | null; 
}

export interface reverb_search_OrderSearchRequest {
  offset?: number | null; 
  limit?: number | null; 
  buyerUuid?: string | null; 
  sellerUuid?: string | null; 
  checkoutUuid?: string | null; 
  actionableStatuses?: (string | null)[] | null; 
  shippingMethods?: (string | null)[] | null; 
  cspSlugs?: (string | null)[] | null; 
  withMetricAggregations?: boolean | null; 
  createdBeforeDate?: string | null; 
  createdAfterDate?: string | null; 
  brandSlugs?: (string | null)[] | null; 
  aggregationsOnly?: boolean | null; 
  listingConditionSlugs?: (string | null)[] | null; 
  listingCategoryUuids?: (string | null)[] | null; 
  listingConditionUuids?: (string | null)[] | null; 
  canonicalProductIds?: (string | null)[] | null; 
  sellerCountries?: (string | null)[] | null; 
  withPriceStatsAggregations?: boolean | null; 
  soldWithBumpOnly?: boolean | null; 
  soldWithoutBumpOnly?: boolean | null; 
  withAggregations?: (reverb_search_OrderSearchRequest_Aggregation | null)[] | null; 
  categorySlugs?: (string | null)[] | null; 
  categoryUuids?: (string | null)[] | null; 
  conditionSlugs?: (string | null)[] | null; 
  shopCurrency?: string | null; 
  minAmountProductCentsUsd?: string | null; 
  maxAmountProductCentsUsd?: string | null; 
  withGearCollectionItemOnly?: boolean | null; 
  withoutGearCollectionItemOnly?: boolean | null; 
  searchUrlParams?: string | null; 
  orderType?: string | null; 
  expressSaleItemEvaluation?: string | null; 
  listingId?: string | null; 
  fullTextQuery?: string | null; 
  actionableStatusGroup?: string | null; 
  withAverageMonthlyProductPricesAggregations?: boolean | null; 
}

export interface reverb_search_LPAlbumSearchRequest {
  offset?: number | null; 
  limit?: number | null; 
  suggest?: string | null; 
  artistUuid?: string | null; 
  ids?: (string | null)[] | null; 
  artistSlug?: string | null; 
  withInventory?: boolean | null; 
  slugs?: (string | null)[] | null; 
}

export interface reverb_search_LPArtistSearchRequest {
  offset?: number | null; 
  limit?: number | null; 
  suggest?: string | null; 
}

export interface reverb_search_LPLabelSearchRequest {
  offset?: number | null; 
  limit?: number | null; 
  suggest?: string | null; 
}

export interface reverb_search_LPReleasesSearchRequest {
  masterUuid?: string | null; 
  sort?: string | null; 
  countries?: (string | null)[] | null; 
  formatUuids?: (string | null)[] | null; 
  releaseDecades?: (string | null)[] | null; 
  fullTextQuery?: string | null; 
  withInventory?: boolean | null; 
  withAggregations?: (reverb_search_LPReleasesSearchRequest_Aggregation | null)[] | null; 
  offset?: number | null; 
  limit?: number | null; 
  withLimitedAggregations?: reverb_search_LimitedAggregation | null; 
}

export interface reverb_search_LPListingsSearchRequest {
  releaseUuid?: string | null; 
  offset?: number | null; 
  limit?: number | null; 
  excludeIds?: (string | null)[] | null; 
  sort?: string | null; 
  includeBestListings?: boolean | null; 
  releaseSlug?: string | null; 
  albumSlug?: string | null; 
  shippingRegion?: string | null; 
  condition?: reverb_search_LPListingsSearchRequest_Condition | null; 
  format?: (string | null)[] | null; 
  country?: (string | null)[] | null; 
  mediaCondition?: (string | null)[] | null; 
  sleeveCondition?: (string | null)[] | null; 
  releaseDecades?: (string | null)[] | null; 
  lengths?: (string | null)[] | null; 
  acceptsDirectCheckout?: boolean | null; 
  acceptsOffers?: boolean | null; 
  priceRange?: string | null; 
  priceMinCents?: number | null; 
  priceMaxCents?: number | null; 
  currency?: string | null; 
  sidebarSearch?: string | null; 
  ids?: (string | null)[] | null; 
  onSale?: boolean | null; 
  auctions?: boolean | null; 
  itemRegion?: string | null; 
  storefrontSlug?: string | null; 
  noAuctions?: boolean | null; 
}

export interface reverb_search_LPTransactionsSearchRequest {
  actionableStatuses?: (reverb_search_LPTransactionsSearchRequest_ActionableStatus | null)[] | null; 
  createdAfter?: string | null; 
  createdBefore?: string | null; 
  filterPurchased?: boolean | null; 
  releaseUuids?: (string | null)[] | null; 
  withAggregations?: (reverb_search_LPTransactionsSearchRequest_Aggregation | null)[] | null; 
  withLimitedAggregations?: reverb_search_LimitedAggregation | null; 
}

export interface reverb_search_GearCollectionItemsSearchRequest {
  offset?: number | null; 
  limit?: number | null; 
  withAggregations?: (reverb_search_GearCollectionItemsSearchRequest_Aggregation | null)[] | null; 
  userUuids?: (string | null)[] | null; 
  categoryUuids?: (string | null)[] | null; 
  categorySlugs?: (string | null)[] | null; 
  ids?: (string | null)[] | null; 
  withCollectionStats?: boolean | null; 
  currency?: string | null; 
  tags?: (string | null)[] | null; 
  canonicalProductIds?: (string | null)[] | null; 
}

export interface reverb_search_CMSPagesSearchRequest {
  offset?: number | null; 
  limit?: number | null; 
  ids?: (string | null)[] | null; 
  fullTextQuery?: string | null; 
  pageTypes?: (string | null)[] | null; 
}

export interface reverb_search_ShippingRegionFilterRequest {
  paramName?: string | null; 
  selectedValues?: (string | null)[] | null; 
  locale?: string | null; 
}

export interface reverb_search_SubAggregationsByListingRequest {
  index?: reverb_search_SubAggregationsByListingRequest_TargetIndex | null; 
  listingIds?: (string | null)[] | null; 
  sellerUuids?: (string | null)[] | null; 
  withAggregations?: (reverb_search_SubAggregationsByListingRequest_Aggregation | null)[] | null; 
}

export interface reverb_search_SubAggregationsResult {
  filterOptions?: (reverb_search_FilterOption | null)[] | null; 
}

export interface reverb_search_SubAggregationsResponse {
  results?: (reverb_search_SubAggregationsResult | null)[] | null; 
}

export interface reverb_search_ListingsPercolationQueryRequest {
  savedSearchQueryParams?: string | null; 
}

export interface reverb_search_ListingsPercolationQueryResponse {
  esQuery?: string | null; 
}

export interface reverb_search_SimilarListingsSearchRequest {
  listingId?: string | null; 
  includeForLiveListings?: boolean | null; 
  limit?: number | null; 
  offset?: number | null; 
  shippingRegionCodes?: (string | null)[] | null; 
  itemRegion?: string | null; 
  itemRegionRelation?: reverb_search_ListingItemRegionRelation | null; 
}

export interface reverb_search_RPCSearch {
  ListingsSearch?: reverb_search_SearchResponse | null; 
  CMSPagesSearch?: reverb_search_SearchResponse | null; 
  CSPSearch?: reverb_search_SearchResponse | null; 
  NegotiationsSearch?: reverb_search_SearchResponse | null; 
  Completions?: reverb_search_SearchResponse | null; 
  LPCompletions?: reverb_search_SearchResponse | null; 
  OrdersSearch?: reverb_search_SearchResponse | null; 
  LPAlbumsSearch?: reverb_search_SearchResponse | null; 
  LPArtistsSearch?: reverb_search_SearchResponse | null; 
  LPLabelsSearch?: reverb_search_SearchResponse | null; 
  LPTransactionsSearch?: reverb_search_SearchResponse | null; 
  LPReleasesSearch?: reverb_search_SearchResponse | null; 
  PriceGuidesSearch?: reverb_search_SearchResponse | null; 
  LPListingsSearch?: reverb_search_SearchResponse | null; 
  AuctionsSearch?: reverb_search_SearchResponse | null; 
  GearCollectionItemsSearch?: reverb_search_SearchResponse | null; 
  ShippingRegionFilter?: reverb_search_ShippingRegionFilterResponse | null; 
  ListingsAggregation?: reverb_search_ListingsAggregationResponse | null; 
  SubAggregationsByListing?: reverb_search_SubAggregationsResponse | null; 
  ListingsPercolationQuery?: reverb_search_ListingsPercolationQueryResponse | null; 
  SimilarListingsSearch?: reverb_search_SearchResponse | null; 
}

export interface reverb_taxonomy_Category {
  slug?: string | null; 
  uuid?: string | null; 
  uuidPath?: (string | null)[] | null; 
  slugPath?: (string | null)[] | null; 
  enabled?: boolean | null; 
  public?: boolean | null; 
}

export interface reverb_taxonomy_TraitValue {
  slug?: string | null; 
  uuid?: string | null; 
  uuidPath?: (string | null)[] | null; 
  slugPath?: (string | null)[] | null; 
  name?: string | null; 
}

export interface reverb_taxonomy_Trait {
  slug?: string | null; 
  uuid?: string | null; 
  type?: string | null; 
  name?: string | null; 
  multivalue?: boolean | null; 
  required?: boolean | null; 
  traitValues?: (reverb_taxonomy_TraitValue | null)[] | null; 
}

export interface reverb_taxonomy_GetTraitValueTranslationsRequest {
  _?: boolean | null; 
}

export interface reverb_taxonomy_GetCategoryTranslationsRequest {
  _?: boolean | null; 
}

export interface reverb_taxonomy_GetCategoryTranslationsResponse {
  categoryTranslations?: (reverb_taxonomy_Translation | null)[] | null; 
}

export interface reverb_taxonomy_GetCategoriesRequest {
  _?: boolean | null; 
}

export interface reverb_taxonomy_GetCategoriesResponse {
  categories?: (reverb_taxonomy_Category | null)[] | null; 
}

export interface reverb_taxonomy_GetTraitTranslationsRequest {
  _?: boolean | null; 
}

export interface reverb_taxonomy_GetTraitTranslationsResponse {
  traitTranslations?: (reverb_taxonomy_Translation | null)[] | null; 
}

export interface reverb_taxonomy_GetTraitsRequest {
  _?: boolean | null; 
}

export interface reverb_taxonomy_GetTraitsResponse {
  traits?: (reverb_taxonomy_Trait | null)[] | null; 
}

export interface reverb_taxonomy_GetTaxonomyYamlRequest {
  _?: boolean | null; 
}

export interface reverb_taxonomy_GetTaxonomyYamlResponse {
  yaml?: string | null; 
}

export interface reverb_taxonomy_TaxonomyService {
  GetTraitValueTranslations?: reverb_taxonomy_GetTraitValueTranslationsResponse | null; 
  GetCategoryTranslations?: reverb_taxonomy_GetCategoryTranslationsResponse | null; 
  GetCategories?: reverb_taxonomy_GetCategoriesResponse | null; 
  GetTraitTranslations?: reverb_taxonomy_GetTraitTranslationsResponse | null; 
  GetTraits?: reverb_taxonomy_GetTraitsResponse | null; 
  GetTaxonomyYaml?: reverb_taxonomy_GetTaxonomyYamlResponse | null; 
}

export interface reverb_reporting_ctr_CspCtr {
  cspId?: string | null; 
  impressions?: number | null; 
  clicks?: number | null; 
}

export interface reverb_reporting_ctr_CspsCtrByDateRangeRequest {
  cspIds?: (string | null)[] | null; 
  datetimeStart?: string | null; 
  datetimeEnd?: string | null; 
}

export interface reverb_reporting_ctr_CspsCtrByDateRangeResponse {
  ctrs?: (reverb_reporting_ctr_CspCtr | null)[] | null; 
}

export interface reverb_reporting_CSPStatsRequest {
  cspIds?: (string | null)[] | null; 
  cspSlugs?: (string | null)[] | null; 
  brandSlugs?: (string | null)[] | null; 
  dateStart?: string | null; 
  dateEnd?: string | null; 
  condition?: reverb_reporting_Condition | null; 
}

export interface reverb_reporting_CSPStatsByCSPRequest {
  cspIds?: (string | null)[] | null; 
  cspSlugs?: (string | null)[] | null; 
  brandSlugs?: (string | null)[] | null; 
  dateStart?: string | null; 
  dateEnd?: string | null; 
  condition?: reverb_reporting_Condition | null; 
  includeTotal?: boolean | null; 
  orderBy?: reverb_reporting_CSPStatsMetric | null; 
  orderDesc?: boolean | null; 
  limit?: number | null; 
  offset?: number | null; 
}

export interface reverb_reporting_ShopStatsRequest {
  shopId?: string | null; 
  currency?: string | null; 
  startTime?: string | null; 
  endTime?: string | null; 
}

export interface reverb_reporting_ShopStatsByDateRequest {
  shopId?: string | null; 
  currency?: string | null; 
  startTime?: string | null; 
  endTime?: string | null; 
  timeGrouping?: reverb_reporting_TimeGrouping | null; 
  timeZone?: string | null; 
}

export interface reverb_reporting_ShopStatsTimeBucket {
  timestamp?: string | null; 
  salesCents?: number | null; 
}

export interface reverb_reporting_ShopStatsResponse {
  salesCents?: number | null; 
  watchersCount?: number | null; 
  offersCount?: number | null; 
  ordersCount?: number | null; 
}

export interface reverb_reporting_ShopStatsCurrencyCountResponse {
  currencyCount?: number | null; 
}

export interface reverb_reporting_ShopStatsByDateResponse {
  buckets?: (reverb_reporting_ShopStatsTimeBucket | null)[] | null; 
}

export interface reverb_reporting_Reporting {
  CSPStatsTotal?: reverb_reporting_CSPStats | null; 
  CSPStatsByDate?: reverb_reporting_CSPStatsByDateResponse | null; 
  CSPStatsByCSP?: reverb_reporting_CSPStatsByCSPResponse | null; 
  ShopStats?: reverb_reporting_ShopStatsResponse | null; 
  ShopStatsByDate?: reverb_reporting_ShopStatsByDateResponse | null; 
  ShopStatsCurrencyCount?: reverb_reporting_ShopStatsCurrencyCountResponse | null; 
  CspsCtrByDateRange?: reverb_reporting_ctr_CspsCtrByDateRangeResponse | null; 
}

export interface rql_Node {
  Id?: string | null; 
}

export interface rql_NodeError {
  type?: rql_NodeError_ErrorType | null; 
  message?: string | null; 
}

export interface rql_Blank {
  _?: boolean | null; 
}

export interface rql_NodeQuery {
  id?: string | null; 
  uuid?: string | null; 
  slug?: string | null; 
}

export interface rql_ReflectQuery {
  key?: string | null; 
}

export interface rql_ReflectCollectionQuery {
  keys?: (string | null)[] | null; 
}

export interface rql_BumpedListingsQuery {
  entityType?: string | null; 
  count?: number | null; 
}

export interface rql_CollectionQuery {
  ids?: (string | null)[] | null; 
  uuids?: (string | null)[] | null; 
  slugs?: (string | null)[] | null; 
}

export interface rql_CollectionWithDraftsQuery {
  ids?: (string | null)[] | null; 
  uuids?: (string | null)[] | null; 
  slugs?: (string | null)[] | null; 
  includeDrafts?: boolean | null; 
}

export interface rql_BrandOrderSearch {
  createdBeforeDate?: string | null; 
  createdAfterDate?: string | null; 
  cspSlugs?: (string | null)[] | null; 
  listingConditionSlugs?: (string | null)[] | null; 
  completedOnly?: boolean | null; 
  listingCategoryUuids?: (string | null)[] | null; 
}

export interface rql_BrandStatsSearch {
  dateStart?: string | null; 
  dateEnd?: string | null; 
  condition?: reverb_reporting_Condition | null; 
  orderBy?: reverb_reporting_CSPStatsMetric | null; 
  orderDesc?: boolean | null; 
  limit?: number | null; 
  offset?: number | null; 
}

export interface rql_AuthToken {
  token?: string | null; 
}

export interface rql_NegotiationQuery {
  as?: rql_NegotiationQuery_Party | null; 
  state?: rql_NegotiationQuery_State | null; 
  limit?: number | null; 
  offset?: number | null; 
  ids?: (string | null)[] | null; 
  listingIds?: (string | null)[] | null; 
  sort?: string | null; 
  fullTextQuery?: string | null; 
}

export interface rql_FeedQuery {
  limit?: number | null; 
  offset?: number | null; 
  channel?: rql_FeedQuery_Channel | null; 
  listingsFilter?: reverb_search_ListingsSearchRequest | null; 
  lpListingsFilter?: reverb_search_LPListingsSearchRequest | null; 
  readFromDatabase?: boolean | null; 
}

export interface rql_FollowsQuery {
  limit?: number | null; 
  offset?: number | null; 
  channel?: rql_FollowsQuery_Channel | null; 
}

export interface rql_OrderQuery {
  limit?: number | null; 
  offset?: number | null; 
  checkoutUuid?: string | null; 
  actionableStatuses?: (string | null)[] | null; 
}

export interface rql_SellerCheckoutInput {
  id?: string | null; 
}

export interface rql_ImageQuery {
  transform?: string | null; 
  scope?: string | null; 
  limit?: number | null; 
  namedTransform?: core_apimessages_NamedImageTransforms | null; 
}

export interface rql_ExpressSalePriceEstimate {
  conditionUuid?: string | null; 
}

export interface rql_OrderPricingQuery {
  sellerCountries?: (string | null)[] | null; 
  createdAfterDate?: string | null; 
}

export interface rql_SetGlobalSubscribeRequest {
  state?: rql_SubscribeState | null; 
}

export interface rql_OrdersSearchRequest {
  as?: core_apimessages_BulkOrdersRequest_Party | null; 
  searchFilters?: reverb_search_OrderSearchRequest | null; 
}

export interface rql_GearCollectionItemsSearchRequest {
  as?: rql_GearCollectionItemsSearchRequest_Party | null; 
  searchInput?: reverb_search_GearCollectionItemsSearchRequest | null; 
}

export interface rql_MyUpdatesQuery {
  limit?: number | null; 
  offset?: number | null; 
}

export interface rql_CheckoutActionRequestInput {
  reverbApp?: string | null; 
}

export interface rql_CheckoutCartEditRequest_OrderEntry {
  listingId?: string | null; 
  quantity?: number | null; 
}

export interface rql_CheckoutCartEditRequest {
  id?: string | null; 
  order?: rql_CheckoutCartEditRequest_OrderEntry | null; 
}

export interface rql_PriceRecordSearchRequest {
  offset?: number | null; 
  limit?: number | null; 
  actionableStatuses?: (string | null)[] | null; 
  createdBeforeDate?: string | null; 
  createdAfterDate?: string | null; 
  listingConditionSlugs?: (string | null)[] | null; 
  listingConditionUuids?: (string | null)[] | null; 
  canonicalProductIds?: (string | null)[] | null; 
  sellerCountries?: (string | null)[] | null; 
  conditionSlugs?: (string | null)[] | null; 
  shopCurrency?: string | null; 
  minAmountProductCentsUsd?: string | null; 
  maxAmountProductCentsUsd?: string | null; 
  orderType?: string | null; 
  listingId?: string | null; 
  actionableStatusGroup?: string | null; 
  withAverageMonthlyProductPricesAggregations?: boolean | null; 
}

export interface lp_AdminAlbum {
  uuid?: string | null; 
  slug?: string | null; 
  title?: string | null; 
  genres?: (string | null)[] | null; 
  styles?: (string | null)[] | null; 
  deletedAt?: string | null; 
}

export interface lp_Release {
  releaseDate?: string | null; 
  catalogNumbers?: (string | null)[] | null; 
  labelName?: string | null; 
  labelUuid?: string | null; 
  labelSlug?: string | null; 
  country?: string | null; 
  formats?: (lp_ReleaseFormat | null)[] | null; 
  uuid?: string | null; 
  slug?: string | null; 
  title?: string | null; 
  artistName?: string | null; 
  artistSlug?: string | null; 
  albumSlug?: string | null; 
  releaseSiblingCount?: number | null; 
  masterUuid?: string | null; 
  notes?: string | null; 
  identifiers?: (lp_Identifier | null)[] | null; 
  tracks?: (lp_Track | null)[] | null; 
  companies?: (lp_Company | null)[] | null; 
  collaborators?: (lp_Collaborator | null)[] | null; 
  listingCount?: number | null; 
  hasLiveListings?: boolean | null; 
  id?: string | null; 
  highestPrice?: lp_Price | null; 
  lowestPrice?: lp_Price | null; 
  artists?: (lp_AlbumArtist | null)[] | null; 
  suggestedTitle?: string | null; 
  images?: (lp_LPImage | null)[] | null; 
  attributionId?: string | null; 
  formatQuantity?: number | null; 
}

export interface lp_ReleaseManifest {
  uuid?: string | null; 
  taxonomyUuids?: (string | null)[] | null; 
  suggestedTitle?: string | null; 
  formatQuantity?: number | null; 
}

export interface lp_Artist {
  id?: string | null; 
  uuid?: string | null; 
  slug?: string | null; 
  name?: string | null; 
  realName?: string | null; 
  profile?: string | null; 
  nameVariations?: (string | null)[] | null; 
  aliases?: (string | null)[] | null; 
  labelUuids?: (string | null)[] | null; 
  masterUuids?: (string | null)[] | null; 
  images?: (lp_LPImage | null)[] | null; 
  listingCount?: number | null; 
}

export interface lp_Author {
  id?: string | null; 
  slug?: string | null; 
  name?: string | null; 
}

export interface lp_CollectionHeader {
  title?: string | null; 
  description?: string | null; 
  metaTitle?: string | null; 
  metaDescription?: string | null; 
  banner?: string | null; 
}

export interface lp_ESListing {
  id?: number | null; 
  images?: (lp_LPImage | null)[] | null; 
  imagesSource?: string | null; 
  state?: string | null; 
}

export interface lp_FacetOption {
  name?: string | null; 
  selected?: boolean | null; 
  queryParams?: string | null; 
  count?: number | null; 
  param?: string | null; 
  value?: string | null; 
  all?: boolean | null; 
  facet?: lp_Facet | null; 
}

export interface lp_Facet {
  name?: string | null; 
  options?: (lp_FacetOption | null)[] | null; 
  widgetType?: string | null; 
}

export interface lp_PriceDrop {
  percent?: number | null; 
  display?: string | null; 
}

export interface lp_ListingState {
  slug?: string | null; 
  description?: string | null; 
}

export interface lp_FeedListingCondition {
  displayName?: string | null; 
  slug?: string | null; 
  uuid?: string | null; 
}

export interface lp_SaleRibbon {
  display?: string | null; 
  value?: string | null; 
  slug?: string | null; 
}

export interface lp_Ribbon {
  display?: string | null; 
  reason?: lp_Ribbon_Reason | null; 
}

export interface lp_FeedListing {
  state?: lp_ListingState | null; 
  priceDrop?: lp_PriceDrop | null; 
  price?: lp_Price | null; 
  condition?: lp_FeedListingCondition | null; 
  auction?: boolean | null; 
  saleRibbon?: lp_SaleRibbon | null; 
  mediaConditionUuid?: string | null; 
  sleeveConditionUuid?: string | null; 
  categoryUuids?: (string | null)[] | null; 
  buyerPrice?: lp_Price | null; 
  originalPrice?: lp_Price | null; 
  ribbon?: lp_Ribbon | null; 
}

export interface lp_FeedItemLinks {
  savedSearch?: lp_Link | null; 
  web?: lp_Link | null; 
  image?: lp_Link | null; 
}

export interface lp_FeedItem {
  id?: string | null; 
  title?: string | null; 
  type?: string | null; 
  Links?: lp_FeedItemLinks | null; 
  feedSource?: string | null; 
  Listing?: lp_FeedListing | null; 
  description?: string | null; 
  subtitle?: string | null; 
}

export interface lp_FeedLinks {
  next?: lp_Link | null; 
  prev?: lp_Link | null; 
}

export interface lp_Label {
  id?: string | null; 
  uuid?: string | null; 
  name?: string | null; 
  slug?: string | null; 
  masterCount?: number | null; 
  artistCount?: number | null; 
  contactInfo?: string | null; 
  profile?: string | null; 
  urls?: (string | null)[] | null; 
}

export interface lp_Auction {
  id?: string | null; 
  endAt?: Timestamp | null; 
  startAt?: Timestamp | null; 
}

export interface lp_CloudinaryPhoto {
  id?: number | null; 
  publicId?: string | null; 
  version?: string | null; 
  format?: string | null; 
  resourceType?: string | null; 
  path?: string | null; 
  previewUrl?: string | null; 
}

export interface lp_PhotosLinks {
  largeCrop?: lp_Link | null; 
  smallCrop?: lp_Link | null; 
  full?: lp_Link | null; 
  thumbnail?: lp_Link | null; 
}

export interface lp_Photos {
  Links?: lp_PhotosLinks | null; 
}

export interface lp_ListingShop {
  id?: number | null; 
  name?: string | null; 
  slug?: string | null; 
}

export interface lp_Location {
  countryCode?: string | null; 
  locality?: string | null; 
  region?: string | null; 
}

export interface lp_ListingLinks {
  shop?: lp_Link | null; 
}

export interface lp_ListingSale {
  id?: number | null; 
  curatedSetId?: number | null; 
  isFeatured?: boolean | null; 
}

export interface lp_Listing {
  id?: number | null; 
  albumUuid?: string | null; 
  releaseCountry?: string | null; 
  releaseGenres?: (string | null)[] | null; 
  formats?: (string | null)[] | null; 
  price?: lp_Price | null; 
  releaseUuid?: string | null; 
  shop?: lp_ListingShop | null; 
  title?: string | null; 
  conditions?: (string | null)[] | null; 
  release?: lp_Release | null; 
  isMyListing?: boolean | null; 
  description?: string | null; 
  storageLocation?: string | null; 
  sellerCost?: lp_Price | null; 
  cloudinaryPhotos?: (lp_CloudinaryPhoto | null)[] | null; 
  album?: lp_Album | null; 
  photos?: lp_Photos | null; 
  location?: lp_Location | null; 
  images?: (lp_LPImage | null)[] | null; 
  mediaConditionUuid?: string | null; 
  sleeveConditionUuid?: string | null; 
  imagesSource?: string | null; 
  sku?: string | null; 
  sellerId?: number | null; 
  Links?: lp_ListingLinks | null; 
  storefront?: lp_ListingShop | null; 
  state?: string | null; 
  saleRibbon?: lp_SaleRibbon | null; 
  sales?: (lp_ListingSale | null)[] | null; 
  offersEnabled?: boolean | null; 
  priceDrop?: lp_PriceDrop | null; 
  hasOfferForBuyer?: boolean | null; 
  acceptedPaymentMethods?: (string | null)[] | null; 
  auction?: lp_Auction | null; 
}

export interface lp_Page {
  id?: string | null; 
  slug?: string | null; 
  goLiveAt?: string | null; 
  title?: string | null; 
  description?: string | null; 
  metaTitle?: string | null; 
  metaDescription?: string | null; 
  componentIds?: (string | null)[] | null; 
  imageAttributionUri?: string | null; 
  imageKey?: string | null; 
  authorId?: string | null; 
  pageType?: string | null; 
  blacklistFromEmbeds?: boolean | null; 
}

export interface lp_Pagination {
  total?: number | null; 
  currentPage?: number | null; 
  perPage?: number | null; 
}

export interface lp_SortOption {
  queryParams?: string | null; 
  name?: string | null; 
  selected?: boolean | null; 
}

export interface lp_SaleLinks {
  web?: lp_Link | null; 
}

export interface lp_Sale {
  slug?: string | null; 
  title?: string | null; 
  description?: string | null; 
  metaTitle?: string | null; 
  metaDescription?: string | null; 
  live?: boolean | null; 
  startsAt?: string | null; 
  endsAt?: string | null; 
  banner?: string | null; 
  Links?: lp_SaleLinks | null; 
  buyerIneligibilityReason?: string | null; 
  saleType?: string | null; 
  discountPercent?: number | null; 
  shopName?: string | null; 
  shopSlug?: string | null; 
  curatedSetId?: number | null; 
}

export interface lp_SuggestionMetadata {
  primaryImage?: string | null; 
  artistName?: string | null; 
  labelName?: string | null; 
  releaseYear?: number | null; 
}

export interface lp_Suggestion {
  type?: string | null; 
  url?: string | null; 
  value?: string | null; 
  score?: number | null; 
  metadata?: lp_SuggestionMetadata | null; 
  Links?: lp_SuggestionLinks | null; 
}

export interface lp_SuggestionLinks {
  sell?: lp_Link | null; 
}

export interface lp_SuggestionData {
  suggestions?: (lp_Suggestion | null)[] | null; 
}

export interface lp_ShopLocation {
  region?: string | null; 
  locality?: string | null; 
  countryCode?: string | null; 
  displayLocation?: string | null; 
}

export interface lp_ShopLinks {
  storefrontBanner?: lp_Link | null; 
  avatar?: lp_Link | null; 
}

export interface lp_ShopShippingPolicy {
  regionCode?: string | null; 
  rate?: lp_Price | null; 
  incrementalRate?: lp_Price | null; 
  freeShippingThreshold?: lp_Price | null; 
}

export interface lp_Shop {
  id?: number | null; 
  slug?: string | null; 
  name?: string | null; 
  description?: string | null; 
  preferredSeller?: boolean | null; 
  location?: lp_ShopLocation | null; 
  feedbackCount?: number | null; 
  rating?: number | null; 
  onVacation?: boolean | null; 
  quickShipper?: boolean | null; 
  quickResponder?: boolean | null; 
  isMyShop?: boolean | null; 
  Links?: lp_ShopLinks | null; 
  shippingPolicy?: lp_ShopShippingPolicy | null; 
}

export interface lp_ShopReturnPolicyProfile {
  type?: string | null; 
  name?: string | null; 
  returnWindowDays?: number | null; 
}

export interface lp_ShopReturnPolicies {
  returnPolicyProfiles?: (lp_ShopReturnPolicyProfile | null)[] | null; 
  restockingFeePercent?: number | null; 
  isReverbRecommended?: boolean | null; 
  specialConditions?: string | null; 
}

export interface lp_ExternalOrderTransaction {
  id?: string | null; 
  merchandisingUuid?: string | null; 
  mediaConditionUuid?: string | null; 
  currency?: string | null; 
  price?: string | null; 
  usdPrice?: string | null; 
  source?: string | null; 
}

export interface lp_APIImageGroup {
  images?: (lp_APIImage | null)[] | null; 
}

export interface lp_APIRelease {
  uuid?: string | null; 
  catalogNumbers?: (string | null)[] | null; 
  title?: string | null; 
  artistName?: string | null; 
  releaseDate?: string | null; 
  formats?: (lp_ReleaseFormat | null)[] | null; 
  genres?: (string | null)[] | null; 
  masterUuid?: string | null; 
  country?: string | null; 
  merchandisingTitle?: string | null; 
  shippingQuantity?: number | null; 
  tracks?: (lp_Track | null)[] | null; 
  collaborators?: (lp_Collaborator | null)[] | null; 
}

export interface lp_MyFollowsResponse {
  followGroups?: (lp_FollowGroup | null)[] | null; 
}

export interface lp_FollowGroup {
  follows?: (lp_Follow | null)[] | null; 
  title?: string | null; 
  savedSearchType?: string | null; 
}

export interface lp_Follow {
  title?: string | null; 
  savedSearchType?: string | null; 
  Links?: lp_FollowLinks | null; 
  header?: string | null; 
  subtitle?: string | null; 
  id?: string | null; 
  queryParams?: lp_FollowCreateRequest | null; 
  digestEnabled?: boolean | null; 
}

export interface lp_FollowLinks {
  remove?: lp_Link | null; 
  search?: lp_Link | null; 
  image?: lp_Link | null; 
}

export interface lp_FollowCreateRequest {
  format?: (string | null)[] | null; 
  labels?: (string | null)[] | null; 
  priceMax?: string | null; 
  priceMin?: string | null; 
  currency?: string | null; 
  storefrontSlug?: string | null; 
  album?: string | null; 
  artist?: string | null; 
  release?: string | null; 
  mediaCondition?: (string | null)[] | null; 
  sleeveCondition?: (string | null)[] | null; 
  shipsTo?: (string | null)[] | null; 
  lengths?: (string | null)[] | null; 
}

export interface lp_FindFollowResponse {
  following?: boolean | null; 
}

export interface lp_GetFollowResponse {
  following?: boolean | null; 
  follow?: lp_Follow | null; 
}

export interface lp_ListingsSearchRequest {
  format?: (string | null)[] | null; 
  labels?: (string | null)[] | null; 
  priceMax?: string | null; 
  priceMin?: string | null; 
  currency?: string | null; 
  storefrontSlug?: string | null; 
  album?: string | null; 
  artist?: string | null; 
  release?: string | null; 
  mediaCondition?: (string | null)[] | null; 
  sleeveCondition?: (string | null)[] | null; 
}

export interface lp_ListingsSearchResponse {
  listings?: (lp_Listing | null)[] | null; 
}

export interface lp_FollowDigestUpdateRequest {
  enabled?: boolean | null; 
}

export interface lp_FollowDigestUpdateResponse {
  enabled?: boolean | null; 
}

export interface lp_ShopListingsResponse {
  listings?: (lp_Listing | null)[] | null; 
  facets?: (lp_Facet | null)[] | null; 
  meta?: lp_Pagination | null; 
  sorts?: (lp_SortOption | null)[] | null; 
}

export interface lp_SuggestionsResponse {
  data?: lp_SuggestionData | null; 
}

export interface lp_ReleasesResponse {
  releases?: (lp_Release | null)[] | null; 
}

export interface lp_GuestCartResponse {
  products?: (lp_CartProduct | null)[] | null; 
  selectedPaymentMethod?: string | null; 
}

export interface lp_CartProduct {
  id?: string | null; 
  quantity?: number | null; 
}

export interface lp_ListingsBulkResponse {
  listings?: (lp_ESListing | null)[] | null; 
}

export interface lp_ListingsShowResponse {
  listing?: lp_Listing | null; 
}

export interface lp_AlbumsListingsResponse {
  listings?: (lp_Listing | null)[] | null; 
  facets?: (lp_Facet | null)[] | null; 
  meta?: lp_Pagination | null; 
  sorts?: (lp_SortOption | null)[] | null; 
}

export interface lp_AlbumsIndexResponse {
  albums?: (lp_Album | null)[] | null; 
  facets?: (lp_Facet | null)[] | null; 
  meta?: lp_Pagination | null; 
}

export interface lp_AlbumsReleasesResponse {
  releases?: (lp_Release | null)[] | null; 
  facets?: (lp_Facet | null)[] | null; 
  meta?: lp_Pagination | null; 
  sorts?: (lp_SortOption | null)[] | null; 
}

export interface lp_CartResponse {
  cartItems?: lp_CartItem | null; 
  estimatedTotal?: lp_Price | null; 
  subtotal?: lp_Price | null; 
  shipping?: lp_Price | null; 
  paymentMethodGroups?: lp_PaymentMethodGroup | null; 
}

export interface lp_CartItem {
  merchandisingUuid?: string | null; 
  productId?: number | null; 
  itemPrice?: lp_Price | null; 
  traits?: (string | null)[] | null; 
  title?: string | null; 
  shippingPrice?: lp_Price | null; 
  type?: string | null; 
}

export interface lp_PaymentMethodGroup {
  directCheckout?: lp_Countable | null; 
  paypal?: lp_Countable | null; 
}

export interface lp_Countable {
  count?: number | null; 
}

export interface lp_FeedIndex {
  items?: (lp_FeedItem | null)[] | null; 
  Links?: lp_FeedLinks | null; 
}

export interface lp_LabelResponse {
  label?: lp_Label | null; 
}

export interface lp_ArtistShowResponse {
  artist?: lp_Artist | null; 
}

export interface lp_ShopShowResponse {
  shop?: lp_Shop | null; 
}

export interface lp_ShopReturnPoliciesResponse {
  returnPolicies?: lp_ShopReturnPolicies | null; 
}

export interface lp_SaleShowResponse {
  sale?: lp_Sale | null; 
}

export interface lp_SaleIndexResponse {
  sales?: (lp_Sale | null)[] | null; 
}

export interface lp_PagesRequest {
  ids?: (string | null)[] | null; 
  slugs?: (string | null)[] | null; 
  page?: string | null; 
  perPage?: string | null; 
  includeDrafts?: string | null; 
  pageType?: string | null; 
  limit?: string | null; 
  offset?: string | null; 
  albumSlugs?: (string | null)[] | null; 
  excludeBlacklistedEmbeds?: string | null; 
}

export interface lp_ComponentsResponse {
  components?: (lp_Component | null)[] | null; 
}

export interface lp_AdminPagesRequest {
  page?: string | null; 
  perPage?: string | null; 
  q?: string | null; 
  ids?: (string | null)[] | null; 
  pageType?: string | null; 
}

export interface lp_AdminPagesResponse {
  pages?: (lp_Page | null)[] | null; 
  meta?: lp_Pagination | null; 
}

export interface lp_PageRequest {
  page?: lp_Page | null; 
}

export interface lp_PageResponse {
  page?: lp_Page | null; 
}

export interface lp_ComponentResponse {
  component?: lp_Component | null; 
}

export interface lp_ComponentRequest {
  component?: lp_Component | null; 
}

export interface lp_ComponentDeleteRequest {
  id?: string | null; 
}

export interface lp_ExternalOrderTransactionsRequest {
  ids?: (string | null)[] | null; 
  merchandisingUuid?: string | null; 
  limit?: string | null; 
  offset?: string | null; 
}

export interface lp_ExternalOrderTransactionsResponse {
  externalOrderTransactions?: (lp_ExternalOrderTransaction | null)[] | null; 
  meta?: lp_BulkPagination | null; 
}

export interface lp_ExternalOrderTransactionResponse {
  externalOrderTransaction?: lp_ExternalOrderTransaction | null; 
}

export interface lp_ExternalOrderTransactionRequest {
  externalOrderTransaction?: lp_ExternalOrderTransaction | null; 
}

export interface lp_AuthorIndexResponse {
  authors?: (lp_Author | null)[] | null; 
}

export interface lp_AuthorRequest {
  author?: lp_Author | null; 
}

export interface lp_AuthorResponse {
  author?: lp_Author | null; 
}

export interface lp_AdminAlbumRequest {
  album?: lp_AdminAlbum | null; 
}

export interface lp_CuratedSetCollectionHeaderResponse {
  collectionHeader?: lp_CollectionHeader | null; 
}

export interface lp_ComponentsRequest {
  ids?: (string | null)[] | null; 
  limit?: string | null; 
  offset?: string | null; 
}

export interface lp_V2AlbumsIndexRequest {
  ids?: (string | null)[] | null; 
  limit?: string | null; 
  offset?: string | null; 
}

export interface lp_APIArtistsResponse {
  artists?: (lp_APIArtist | null)[] | null; 
  meta?: lp_BulkPagination | null; 
}

export interface lp_APIArtists {
  artists?: (lp_APIArtist | null)[] | null; 
}

export interface lp_APIRelatedArtistsResponse {
  artists?: (lp_APIArtists | null)[] | null; 
  meta?: lp_BulkPagination | null; 
}

export interface lp_APIArtistsRequest {
  slugs?: (string | null)[] | null; 
  limit?: string | null; 
  offset?: string | null; 
}

export interface lp_APIRelatedArtistsRequest {
  ids?: (string | null)[] | null; 
  type?: lp_APIArtistType | null; 
  limit?: string | null; 
  offset?: string | null; 
}

export interface lp_APIImagesRequest {
  ids?: (string | null)[] | null; 
  type?: lp_APIImagesRequest_ImageType | null; 
  limit?: string | null; 
  offset?: string | null; 
}

export interface lp_APIImagesResponse {
  imageGroups?: (lp_APIImageGroup | null)[] | null; 
  meta?: lp_BulkPagination | null; 
}

export interface lp_APILabelsRequest {
  releaseIds?: (string | null)[] | null; 
  limit?: string | null; 
  offset?: string | null; 
}

export interface lp_APILabelsResponse {
  labels?: (lp_APILabel | null)[] | null; 
  meta?: lp_BulkPagination | null; 
}

export interface lp_APIReleasesResponse {
  releases?: (lp_APIRelease | null)[] | null; 
  meta?: lp_BulkPagination | null; 
}

export interface lp_APIReleasesRequest {
  ids?: (string | null)[] | null; 
  limit?: string | null; 
  offset?: string | null; 
  barcode?: string | null; 
}

export interface lp_APIErrorDetail {
  target?: string | null; 
  message?: string | null; 
}

export interface lp_APIErrorResponse {
  message?: string | null; 
  errors?: (lp_APIErrorDetail | null)[] | null; 
  requestId?: string | null; 
}

export interface lp_V2AlbumsIndexResponse {
  albums?: (lp_Album | null)[] | null; 
  meta?: lp_BulkPagination | null; 
}

export interface lp_LP {
  GetPages?: lp_PagesResponse | null; 
  GetComponents?: lp_ComponentsResponse | null; 
  GetAlbums?: lp_V2AlbumsIndexResponse | null; 
  GetArtists?: lp_APIArtistsResponse | null; 
  GetRelatedArtists?: lp_APIRelatedArtistsResponse | null; 
  GetLabels?: lp_APILabelsResponse | null; 
  GetReleases?: lp_APIReleasesResponse | null; 
  GetImages?: lp_APIImagesResponse | null; 
}

export interface reverb_config_cache_AddressValidationsResponse {
  addresses?: (reverb_config_cache_AddressValidation | null)[] | null; 
}

export interface reverb_config_cache_AddressValidation {
  postalCode?: string | null; 
  state?: string | null; 
}

export interface reverb_config_cache_ExchangeRateRequest {
  useMajorUnitConversion?: boolean | null; 
  inverseReverseRates?: boolean | null; 
}

export interface reverb_config_cache_VersionedExchangeRatesRequest {
  version?: string | null; 
  inverseReverseRates?: boolean | null; 
}

export interface reverb_config_cache_VersionedExchangeRatesResponse {
  rates?: (reverb_config_cache_ExchangeRate | null)[] | null; 
}

export interface reverb_config_cache_ExchangeCurrencyRequest {
  from?: string | null; 
  to?: string | null; 
  amountMinorUnits?: number | null; 
  inverseReverseRates?: boolean | null; 
}

export interface reverb_config_cache_TaxRatesResponse {
  rates?: (reverb_config_cache_TaxRate | null)[] | null; 
}

export interface reverb_config_cache_TaxRate {
  postalcode?: string | null; 
  totalSalesTaxRate?: string | null; 
  totalSalesTaxRatePrecision?: number | null; 
  state?: string | null; 
}

export interface reverb_config_cache_TranslationsRequest {
  project?: string | null; 
  resource?: string | null; 
  locales?: (string | null)[] | null; 
}

export interface reverb_config_cache_TranslationsResponse_Translation {
  project?: string | null; 
  resource?: string | null; 
  locale?: string | null; 
  content?: string | null; 
}

export interface reverb_config_cache_TranslationsResponse {
  translations?: (reverb_config_cache_TranslationsResponse_Translation | null)[] | null; 
}

export interface reverb_config_cache_Filters {
  productType?: string | null; 
  category?: string | null; 
  brand?: string | null; 
  productFamily?: string | null; 
}

export interface reverb_config_cache_SearchRedirect {
  queryTerm?: string | null; 
  redirectTerm?: string | null; 
  type?: reverb_config_cache_SearchRedirect_Type | null; 
  redirectTerms?: (string | null)[] | null; 
  filters?: reverb_config_cache_Filters | null; 
}

export interface reverb_config_cache_SearchRedirectsRequest {
  _?: boolean | null; 
}

export interface reverb_config_cache_SearchRedirectsResponse {
  redirects?: (reverb_config_cache_SearchRedirect | null)[] | null; 
}

export interface reverb_config_cache_ConfigService {
  GetExchangeRates?: reverb_config_cache_CurrencyResponse | null; 
  GetVersionedExchangeRates?: reverb_config_cache_VersionedExchangeRatesResponse | null; 
  ExchangeCurrency?: reverb_config_cache_ExchangeCurrencyResponse | null; 
  TaxRates?: reverb_config_cache_TaxRatesResponse | null; 
  AddressValidations?: reverb_config_cache_AddressValidationsResponse | null; 
  GetTranslations?: reverb_config_cache_TranslationsResponse | null; 
  GetSearchRedirects?: reverb_config_cache_SearchRedirectsResponse | null; 
  GetInternationalAddressFormConfig?: reverb_config_cache_InternationalAddressFormConfigResponse | null; 
}

export interface braze_GetUserDataRequest {
  externalIds?: (string | null)[] | null; 
  fieldsToExport?: (string | null)[] | null; 
}

export interface braze_GetUserDataResponse {
  message?: string | null; 
  users?: (braze_BrazeUser | null)[] | null; 
  invalidUserIds?: (string | null)[] | null; 
}

export interface braze_BrazeUser {
  externalId?: string | null; 
  email?: string | null; 
  pushSubscribe?: string | null; 
  emailSubscribe?: string | null; 
}

export interface braze_UserTrackRequest {
  attributes?: (braze_UserAttributes | null)[] | null; 
}

export interface braze_UserAttributes {
  externalId?: string | null; 
  brazeId?: string | null; 
  UpdateExistingOnly?: boolean | null; 
  emailSubscribe?: string | null; 
  pushSubscribe?: string | null; 
}

export interface braze_UserTrackResponse {
  message?: string | null; 
}

export interface braze_SetSubscriptionGroupsRequest {
  subscriptionGroupId?: string | null; 
  subscriptionState?: string | null; 
  externalId?: string | null; 
  email?: string | null; 
}

export interface braze_SetSubscriptionGroupsResponse {
  message?: string | null; 
}

export interface braze_GetSubscriptionGroupsRequest {
  externalId?: (string | null)[] | null; 
  email?: (string | null)[] | null; 
}

export interface braze_GetSubscriptionGroupsResponse {
  users?: (braze_SubscriptionUser | null)[] | null; 
  totalCount?: number | null; 
  message?: string | null; 
}

export interface braze_SubscriptionUser {
  email?: string | null; 
  phone?: string | null; 
  externalId?: string | null; 
  subscriptionGroups?: (braze_SubscriptionGroupConfig | null)[] | null; 
}

export interface braze_SubscriptionGroupConfig {
  id?: string | null; 
  name?: string | null; 
  channel?: string | null; 
  status?: string | null; 
}

export interface braze_OptInRecipient {
  externalUserId?: string | null; 
}

export interface braze_TriggerCampaignSendRequest {
  campaignId?: string | null; 
  recipients?: (braze_OptInRecipient | null)[] | null; 
}

export interface braze_Braze {
  GetSubscriptionGroups?: braze_GetSubscriptionGroupsResponse | null; 
  SetSubscriptionGroups?: braze_SetSubscriptionGroupsResponse | null; 
  GetUserData?: braze_GetUserDataResponse | null; 
  UserTrack?: braze_UserTrackResponse | null; 
  TriggerCampaignSend?: braze_TriggerCampaignSendResponse | null; 
}

export interface reverb_pricing_CSPPriceRecommendationQuery {
  comparisonShoppingPageId?: string | null; 
  conditionUuid?: string | null; 
  currency?: string | null; 
  countryCode?: string | null; 
}

export interface reverb_pricing_CSPPriceRecommendationsRequest {
  cspPriceRecommendationQueries?: (reverb_pricing_CSPPriceRecommendationQuery | null)[] | null; 
}

export interface reverb_pricing_PriceRecommendationQuery {
  canonicalProductId?: string | null; 
  conditionUuid?: string | null; 
  currency?: string | null; 
  countryCode?: string | null; 
}

export interface reverb_pricing_PriceRecommendationsRequest {
  priceRecommendationQueries?: (reverb_pricing_PriceRecommendationQuery | null)[] | null; 
}

export interface reverb_pricing_PriceScoreQuery {
  canonicalProductId?: string | null; 
  conditionUuid?: string | null; 
  price?: reverb_pricing_Money | null; 
  countryCode?: string | null; 
}

export interface reverb_pricing_PriceScoresRequest {
  priceScoreQueries?: (reverb_pricing_PriceScoreQuery | null)[] | null; 
}

export interface reverb_pricing_PriceScore {
  canonicalProductId?: string | null; 
  conditionUuid?: string | null; 
  priceScore?: number | null; 
}

export interface reverb_pricing_PriceScoresResponse {
  priceScores?: (reverb_pricing_PriceScore | null)[] | null; 
}

export interface reverb_pricing_Pricing {
  GetPriceRecommendations?: reverb_pricing_PriceRecommendationsResponse | null; 
  GetCSPPriceRecommendations?: reverb_pricing_PriceRecommendationsResponse | null; 
  GetPriceScores?: reverb_pricing_PriceScoresResponse | null; 
}

export interface reverb_personalization_User {
  id?: string | null; 
  recommendedListingIds?: (string | null)[] | null; 
}

export interface reverb_personalization_GetUserRequest {
  id?: string | null; 
  version?: number | null; 
}

export interface reverb_personalization_RefreshListingRecommendationsRequest {
  _?: boolean | null; 
}

export interface reverb_personalization_RefreshListingRecommendationsRequestV2 {
  runId?: string | null; 
}

export interface reverb_personalization_RefreshTrendingSearchesRequest {
  _?: boolean | null; 
}

export interface reverb_personalization_GetTrendingSearchesRequest {
  nResults?: number | null; 
  categoryUuids?: (string | null)[] | null; 
}

export interface reverb_personalization_Personalization {
  GetUser?: reverb_personalization_User | null; 
  RefreshListingRecommendations?: google_protobuf_Empty | null; 
  RefreshListingRecsV2?: google_protobuf_Empty | null; 
  RefreshTrendingSearches?: google_protobuf_Empty | null; 
  GetTrendingSearches?: reverb_personalization_TrendingSearchesResponse | null; 
}

export interface AlbumCollection {
  _ids?: (string | null)[] | null; 
  nodes?: (Album | null)[] | null; 
  pageInfo?: rql_PageInfo | null; 
}

export interface UniversalPromoCampaignCollection {
  _ids?: (string | null)[] | null; 
  nodes?: (UniversalPromoCampaign | null)[] | null; 
  pageInfo?: rql_PageInfo | null; 
}

export interface Input_reverb_search_CSPSearchRequest {
  fullTextQuery?: string | null; 
  fuzzy?: boolean | null; 
  locale?: string | null; 
  offset?: number | null; 
  limit?: number | null; 
  withAggregations?: (reverb_search_CSPSearchRequest_Aggregation | null)[] | null; 
  brandNames?: (string | null)[] | null; 
  finishes?: (string | null)[] | null; 
  categoryUuids?: (string | null)[] | null; 
  decades?: (string | null)[] | null; 
  suggestTitle?: string | null; 
  excludedCategoryUuids?: (string | null)[] | null; 
  curatedSetId?: string | null; 
  condition?: string | null; 
  withInventory?: boolean | null; 
  listingsThatShipTo?: string | null; 
  sortByQuality?: boolean | null; 
  boostByClicks?: boolean | null; 
  withLimitedAggregations?: Input_reverb_search_LimitedAggregation | null; 
  categorySlugs?: (string | null)[] | null; 
  brandSlugs?: (string | null)[] | null; 
  maxPriceUsdCents?: number | null; 
  minPriceUsdCents?: number | null; 
  yearMin?: number | null; 
  yearMax?: number | null; 
  curatedSetSlugs?: (string | null)[] | null; 
  fullTextQueryOperand?: reverb_search_FullTextQueryOperand | null; 
  sort?: reverb_search_CSPSearchRequest_Sort | null; 
  slugs?: (string | null)[] | null; 
  includeFields?: (string | null)[] | null; 
  similarListingId?: string | null; 
  similarCspSlug?: string | null; 
  currency?: string | null; 
  ids?: (string | null)[] | null; 
  includeOutOfStock?: boolean | null; 
  searchUrlParams?: string | null; 
  priceMax?: string | null; 
  priceMin?: string | null; 
  traitValues?: (string | null)[] | null; 
  uuids?: (string | null)[] | null; 
  traitSlugs?: (string | null)[] | null; 
  es7?: boolean | null; 
  hasExpressSaleBid?: boolean | null; 
  countryOfOrigin?: (string | null)[] | null; 
  autodirects?: reverb_search_Autodirects | null; 
  skipAutodirects?: boolean | null; 
  contexts?: (reverb_search_Context | null)[] | null; 
}

export interface Input_reverb_search_LimitedAggregation {
  brandUuids?: number | null; 
  categoryUuids?: number | null; 
}

export interface Input_core_apimessages_ImagesRequest {
  type?: string | null; 
  ids?: (string | null)[] | null; 
  count?: number | null; 
  transform?: string | null; 
  scope?: string | null; 
  uuids?: (string | null)[] | null; 
  slugs?: (string | null)[] | null; 
  namedTransform?: core_apimessages_NamedImageTransforms | null; 
}

export interface Input_rql_ImageQuery {
  transform?: string | null; 
  scope?: string | null; 
  limit?: number | null; 
  namedTransform?: core_apimessages_NamedImageTransforms | null; 
}

export interface Input_reverb_search_ListingsSearchRequest {
  brandUuids?: (string | null)[] | null; 
  categoryUuids?: (string | null)[] | null; 
  conditionUuids?: (string | null)[] | null; 
  curatedSetId?: string | null; 
  currency?: string | null; 
  locale?: string | null; 
  priceMax?: string | null; 
  priceMin?: string | null; 
  query?: string | null; 
  sort?: reverb_search_ListingsSearchRequest_Sort | null; 
  statuses?: (string | null)[] | null; 
  yearMax?: string | null; 
  yearMin?: string | null; 
  aggregationsOnly?: boolean | null; 
  limit?: number | null; 
  offset?: number | null; 
  withLimitedAggregations?: Input_reverb_search_LimitedAggregation | null; 
  withAggregations?: (reverb_search_ListingsSearchRequest_Aggregation | null)[] | null; 
  conditionSlugs?: (string | null)[] | null; 
  shippingRegionCodes?: (string | null)[] | null; 
  onSale?: boolean | null; 
  saleCuratedSetId?: string | null; 
  brandSlugs?: (string | null)[] | null; 
  categorySlugs?: (string | null)[] | null; 
  curatedSetSlugs?: (string | null)[] | null; 
  saleSlugs?: (string | null)[] | null; 
  handmade?: boolean | null; 
  freeShipping?: boolean | null; 
  freeExpeditedShipping?: boolean | null; 
  acceptsOffers?: boolean | null; 
  acceptsGiftCards?: boolean | null; 
  preferredSeller?: boolean | null; 
  acceptsPaymentPlans?: boolean | null; 
  itemRegion?: string | null; 
  holidaySale?: boolean | null; 
  shopSlug?: string | null; 
  ids?: (string | null)[] | null; 
  sortSlug?: string | null; 
  bumpCount?: number | null; 
  showOnlySold?: boolean | null; 
  decades?: (string | null)[] | null; 
  traitValues?: (string | null)[] | null; 
  cspSlug?: string | null; 
  showSold?: boolean | null; 
  withTopCollections?: Input_reverb_search_TopCollectionsRequest | null; 
  itemState?: (string | null)[] | null; 
  itemCity?: (string | null)[] | null; 
  bumpedSortedListingsQuery?: Input_reverb_search_BumpedSortedListingsQuery | null; 
  fallbackToOr?: boolean | null; 
  bumpedOnly?: boolean | null; 
  filterSuperRegionCode?: string | null; 
  canonicalFinishes?: (string | null)[] | null; 
  shopId?: string | null; 
  randomSeed?: number | null; 
  withPageMetadata?: Input_reverb_search_PageMetaDataRequest | null; 
  shopSlugs?: (string | null)[] | null; 
  searchUrlParams?: string | null; 
  excludeMerchandisingTypes?: (string | null)[] | null; 
  boostByBumpRate?: boolean | null; 
  cspId?: string | null; 
  notMatchedToCsp?: boolean | null; 
  combinedShipping?: boolean | null; 
  boostCombinedShippingCategories?: (string | null)[] | null; 
  excludeShopIds?: (string | null)[] | null; 
  collapsible?: reverb_search_ListingsSearchRequest_Collapsible | null; 
  priceValue?: reverb_search_ListingsSearchRequest_PriceValue | null; 
  experiments?: (string | null)[] | null; 
  acceptsAffirm?: boolean | null; 
  terminateEarly?: boolean | null; 
  withProximityFilter?: Input_reverb_search_ProximityFilterRequest | null; 
  localPickup?: boolean | null; 
  querylessBumpBoost?: boolean | null; 
  proximity?: Input_reverb_search_ProximityRequest | null; 
  traitSlugs?: (string | null)[] | null; 
  shopUuids?: (string | null)[] | null; 
  es7?: boolean | null; 
  trackTotalHits?: reverb_search_TrackTotalHits | null; 
  minSaleDiscountPercent?: string | null; 
  boostedItemRegionCode?: string | null; 
  useExperimentalQuery?: boolean | null; 
  dealsOrWellPriced?: boolean | null; 
  similarListingIds?: (string | null)[] | null; 
  useExperimentalBestMatchSignalsV1?: boolean | null; 
  useExperimentalRecall?: boolean | null; 
  bestMatchSignalsV2ExperimentGroup?: number | null; 
  useExperimentalRegionBoost?: boolean | null; 
  shipsToMe?: boolean | null; 
  priceValueV2?: reverb_search_ListingsSearchRequest_PriceValue | null; 
  withMyShopAggregations?: (reverb_search_ListingsSearchRequest_MyShopAggregation | null)[] | null; 
  likelihoodToSellExperimentGroup?: number | null; 
  useTotalPrice?: boolean | null; 
  mpTotalPriceExperimentGroup?: number | null; 
  countryOfOrigin?: (string | null)[] | null; 
  itemRegionRelation?: reverb_search_ListingItemRegionRelation | null; 
  ecsBoostExperimentGroup?: number | null; 
  autodirects?: reverb_search_Autodirects | null; 
  skipAutodirects?: boolean | null; 
  listingRecommendationsVersion?: number | null; 
  canonicalProductIds?: (string | null)[] | null; 
  includeDrafts?: boolean | null; 
  contexts?: (reverb_search_Context | null)[] | null; 
  fallbackToEverywhereElse?: boolean | null; 
  excludeLocalPickupOnly?: boolean | null; 
  includeQuerySpellCorrections?: boolean | null; 
  dealsAndSteals?: boolean | null; 
  multiClientExperiments?: (Input_reverb_search_ExperimentData | null)[] | null; 
}

export interface Input_reverb_search_TopCollectionsRequest {
  brandUuids?: number | null; 
  categoryUuids?: number | null; 
}

export interface Input_reverb_search_BumpedSortedListingsQuery {
  total?: number | null; 
  bumpedMax?: number | null; 
  condition?: string | null; 
  itemRegion?: string | null; 
}

export interface Input_reverb_search_PageMetaDataRequest {
  excludeCategories?: boolean | null; 
  excludeBrands?: boolean | null; 
}

export interface Input_reverb_search_ProximityFilterRequest {
  postalCode?: string | null; 
  distance?: string | null; 
  proximity?: boolean | null; 
}

export interface Input_reverb_search_ProximityRequest {
  applyFilter?: boolean | null; 
  distance?: Input_reverb_search_Distance | null; 
  location?: Input_reverb_search_Location | null; 
}

export interface Input_reverb_search_Distance {
  value?: string | null; 
  unit?: reverb_search_Distance_DistanceUnit | null; 
}

export interface Input_reverb_search_Location {
  type?: reverb_search_Location_LocationType | null; 
  value?: string | null; 
}

export interface Input_reverb_search_ExperimentData {
  name?: string | null; 
  groupNum?: number | null; 
}

export interface Input_rql_BrandOrderSearch {
  createdBeforeDate?: string | null; 
  createdAfterDate?: string | null; 
  cspSlugs?: (string | null)[] | null; 
  listingConditionSlugs?: (string | null)[] | null; 
  completedOnly?: boolean | null; 
  listingCategoryUuids?: (string | null)[] | null; 
}

export interface Input_reverb_reporting_CSPStatsByCSPRequest {
  cspIds?: (string | null)[] | null; 
  cspSlugs?: (string | null)[] | null; 
  brandSlugs?: (string | null)[] | null; 
  dateStart?: string | null; 
  dateEnd?: string | null; 
  condition?: reverb_reporting_Condition | null; 
  includeTotal?: boolean | null; 
  orderBy?: reverb_reporting_CSPStatsMetric | null; 
  orderDesc?: boolean | null; 
  limit?: number | null; 
  offset?: number | null; 
}

export interface Input_reverb_reporting_CSPStatsRequest {
  cspIds?: (string | null)[] | null; 
  cspSlugs?: (string | null)[] | null; 
  brandSlugs?: (string | null)[] | null; 
  dateStart?: string | null; 
  dateEnd?: string | null; 
  condition?: reverb_reporting_Condition | null; 
}

export interface Input_core_apimessages_CSPReviewsRequest {
  ids?: (string | null)[] | null; 
  slugs?: (string | null)[] | null; 
  uuids?: (string | null)[] | null; 
  offset?: number | null; 
  limit?: number | null; 
}

export interface Input_core_apimessages_ShippingPricesRequest {
  listingIds?: (string | null)[] | null; 
  shippingRegionCode?: string | null; 
  usePrimaryShippingAddress?: boolean | null; 
  returnAllShippingPrices?: boolean | null; 
}

export interface Input_core_apimessages_ShopsRequest {
  uuids?: (string | null)[] | null; 
  channel?: core_apimessages_Channel | null; 
  slugs?: (string | null)[] | null; 
}

export interface Input_core_apimessages_NodeRequest_Lookup_Params_ShippingRates {
  inOriginalCurrency?: boolean | null; 
}

export interface Input_core_apimessages_FeedbacksRequest {
  offset?: number | null; 
  limit?: number | null; 
  userUuid?: string | null; 
  type?: core_apimessages_Feedback_Type | null; 
}

export interface Input_reverb_search_LPListingsSearchRequest {
  releaseUuid?: string | null; 
  offset?: number | null; 
  limit?: number | null; 
  excludeIds?: (string | null)[] | null; 
  sort?: string | null; 
  includeBestListings?: boolean | null; 
  releaseSlug?: string | null; 
  albumSlug?: string | null; 
  shippingRegion?: string | null; 
  condition?: reverb_search_LPListingsSearchRequest_Condition | null; 
  format?: (string | null)[] | null; 
  country?: (string | null)[] | null; 
  mediaCondition?: (string | null)[] | null; 
  sleeveCondition?: (string | null)[] | null; 
  releaseDecades?: (string | null)[] | null; 
  lengths?: (string | null)[] | null; 
  acceptsDirectCheckout?: boolean | null; 
  acceptsOffers?: boolean | null; 
  priceRange?: string | null; 
  priceMinCents?: number | null; 
  priceMaxCents?: number | null; 
  currency?: string | null; 
  sidebarSearch?: string | null; 
  ids?: (string | null)[] | null; 
  onSale?: boolean | null; 
  auctions?: boolean | null; 
  itemRegion?: string | null; 
  storefrontSlug?: string | null; 
  noAuctions?: boolean | null; 
}

export interface Input_core_apimessages_AuctionBidsRequest {
  auctionId?: string | null; 
  offset?: number | null; 
  limit?: number | null; 
}

export interface Input_core_apimessages_BulkOrdersRequest_Query {
  relation?: core_apimessages_BulkOrdersRequest_Relation | null; 
  primaryKey?: Input_core_apimessages_PrimaryKey | null; 
  as?: core_apimessages_BulkOrdersRequest_Party | null; 
}

export interface Input_core_apimessages_PrimaryKey {
  type?: core_apimessages_PrimaryKey_Type | null; 
  value?: string | null; 
}

export interface Input_reverb_search_SimilarListingsSearchRequest {
  listingId?: string | null; 
  includeForLiveListings?: boolean | null; 
  limit?: number | null; 
  offset?: number | null; 
  shippingRegionCodes?: (string | null)[] | null; 
  itemRegion?: string | null; 
  itemRegionRelation?: reverb_search_ListingItemRegionRelation | null; 
}

export interface Input_rql_OrderPricingQuery {
  sellerCountries?: (string | null)[] | null; 
  createdAfterDate?: string | null; 
}

export interface Input_reverb_signals_SignalRequest {
  groups?: (reverb_signals_Signal_Group | null)[] | null; 
  imageType?: reverb_signals_SignalImageType | null; 
}

export interface Input_rql_ExpressSalePriceEstimate {
  conditionUuid?: string | null; 
}

export interface Input_rql_OrderQuery {
  limit?: number | null; 
  offset?: number | null; 
  checkoutUuid?: string | null; 
  actionableStatuses?: (string | null)[] | null; 
}

export interface Input_reverb_search_CompletionsRequest {
  query?: string | null; 
  types?: (reverb_search_CompletionType | null)[] | null; 
  currency?: string | null; 
  shippingRegionCode?: string | null; 
  locale?: string | null; 
  experiments?: (string | null)[] | null; 
}

export interface Input_reverb_search_PriceGuidesSearchRequest {
  fullTextQuery?: string | null; 
  locale?: string | null; 
  offset?: number | null; 
  limit?: number | null; 
  withAggregations?: (reverb_search_PriceGuidesSearchRequest_Aggregation | null)[] | null; 
  brandNames?: (string | null)[] | null; 
  categoryUuids?: (string | null)[] | null; 
  decades?: (string | null)[] | null; 
  categorySlugs?: (string | null)[] | null; 
  withLimitedAggregations?: Input_reverb_search_LimitedAggregation | null; 
}

export interface Input_reverb_search_ShippingRegionFilterRequest {
  paramName?: string | null; 
  selectedValues?: (string | null)[] | null; 
  locale?: string | null; 
}

export interface Input_rql_PriceRecordSearchRequest {
  offset?: number | null; 
  limit?: number | null; 
  actionableStatuses?: (string | null)[] | null; 
  createdBeforeDate?: string | null; 
  createdAfterDate?: string | null; 
  listingConditionSlugs?: (string | null)[] | null; 
  listingConditionUuids?: (string | null)[] | null; 
  canonicalProductIds?: (string | null)[] | null; 
  sellerCountries?: (string | null)[] | null; 
  conditionSlugs?: (string | null)[] | null; 
  shopCurrency?: string | null; 
  minAmountProductCentsUsd?: string | null; 
  maxAmountProductCentsUsd?: string | null; 
  orderType?: string | null; 
  listingId?: string | null; 
  actionableStatusGroup?: string | null; 
  withAverageMonthlyProductPricesAggregations?: boolean | null; 
}

export interface Input_rql_OrdersSearchRequest {
  as?: core_apimessages_BulkOrdersRequest_Party | null; 
  searchFilters?: Input_reverb_search_OrderSearchRequest | null; 
}

export interface Input_reverb_search_OrderSearchRequest {
  offset?: number | null; 
  limit?: number | null; 
  buyerUuid?: string | null; 
  sellerUuid?: string | null; 
  checkoutUuid?: string | null; 
  actionableStatuses?: (string | null)[] | null; 
  shippingMethods?: (string | null)[] | null; 
  cspSlugs?: (string | null)[] | null; 
  withMetricAggregations?: boolean | null; 
  createdBeforeDate?: string | null; 
  createdAfterDate?: string | null; 
  brandSlugs?: (string | null)[] | null; 
  aggregationsOnly?: boolean | null; 
  listingConditionSlugs?: (string | null)[] | null; 
  listingCategoryUuids?: (string | null)[] | null; 
  listingConditionUuids?: (string | null)[] | null; 
  canonicalProductIds?: (string | null)[] | null; 
  sellerCountries?: (string | null)[] | null; 
  withPriceStatsAggregations?: boolean | null; 
  soldWithBumpOnly?: boolean | null; 
  soldWithoutBumpOnly?: boolean | null; 
  withAggregations?: (reverb_search_OrderSearchRequest_Aggregation | null)[] | null; 
  categorySlugs?: (string | null)[] | null; 
  categoryUuids?: (string | null)[] | null; 
  conditionSlugs?: (string | null)[] | null; 
  shopCurrency?: string | null; 
  minAmountProductCentsUsd?: string | null; 
  maxAmountProductCentsUsd?: string | null; 
  withGearCollectionItemOnly?: boolean | null; 
  withoutGearCollectionItemOnly?: boolean | null; 
  searchUrlParams?: string | null; 
  orderType?: string | null; 
  expressSaleItemEvaluation?: string | null; 
  listingId?: string | null; 
  fullTextQuery?: string | null; 
  actionableStatusGroup?: string | null; 
  withAverageMonthlyProductPricesAggregations?: boolean | null; 
}

export interface Input_rql_GearCollectionItemsSearchRequest {
  as?: rql_GearCollectionItemsSearchRequest_Party | null; 
  searchInput?: Input_reverb_search_GearCollectionItemsSearchRequest | null; 
}

export interface Input_reverb_search_GearCollectionItemsSearchRequest {
  offset?: number | null; 
  limit?: number | null; 
  withAggregations?: (reverb_search_GearCollectionItemsSearchRequest_Aggregation | null)[] | null; 
  userUuids?: (string | null)[] | null; 
  categoryUuids?: (string | null)[] | null; 
  categorySlugs?: (string | null)[] | null; 
  ids?: (string | null)[] | null; 
  withCollectionStats?: boolean | null; 
  currency?: string | null; 
  tags?: (string | null)[] | null; 
  canonicalProductIds?: (string | null)[] | null; 
}

export interface Input_core_apimessages_UserWatchesRequest {
  listingIds?: (string | null)[] | null; 
  offset?: number | null; 
  limit?: number | null; 
  channel?: core_apimessages_Channel | null; 
  listingsState?: core_apimessages_UserWatchesRequest_ListingState | null; 
  profileSlug?: string | null; 
}

export interface Input_reverb_search_LPCompletionsRequest {
  query?: string | null; 
}

export interface Input_reverb_search_LPAlbumSearchRequest {
  offset?: number | null; 
  limit?: number | null; 
  suggest?: string | null; 
  artistUuid?: string | null; 
  ids?: (string | null)[] | null; 
  artistSlug?: string | null; 
  withInventory?: boolean | null; 
  slugs?: (string | null)[] | null; 
}

export interface Input_reverb_search_LPArtistSearchRequest {
  offset?: number | null; 
  limit?: number | null; 
  suggest?: string | null; 
}

export interface Input_reverb_search_LPLabelSearchRequest {
  offset?: number | null; 
  limit?: number | null; 
  suggest?: string | null; 
}

export interface Input_reverb_search_LPReleasesSearchRequest {
  masterUuid?: string | null; 
  sort?: string | null; 
  countries?: (string | null)[] | null; 
  formatUuids?: (string | null)[] | null; 
  releaseDecades?: (string | null)[] | null; 
  fullTextQuery?: string | null; 
  withInventory?: boolean | null; 
  withAggregations?: (reverb_search_LPReleasesSearchRequest_Aggregation | null)[] | null; 
  offset?: number | null; 
  limit?: number | null; 
  withLimitedAggregations?: Input_reverb_search_LimitedAggregation | null; 
}

export interface Input_reverb_search_CMSPagesSearchRequest {
  offset?: number | null; 
  limit?: number | null; 
  ids?: (string | null)[] | null; 
  fullTextQuery?: string | null; 
  pageTypes?: (string | null)[] | null; 
}

export interface Input_reverb_config_cache_ExchangeRateRequest {
  useMajorUnitConversion?: boolean | null; 
  inverseReverseRates?: boolean | null; 
}

export interface Input_rql_ReflectCollectionQuery {
  keys?: (string | null)[] | null; 
}

export interface Input_rql_CheckoutActionRequestInput {
  reverbApp?: string | null; 
}

export interface Input_arbiter_SellerInteractionTimeSeriesRequest {
  sellerId?: string | null; 
  startDate?: string | null; 
  endDate?: string | null; 
}

export interface Input_core_apimessages_MyShopOrderRefundStatsRequest {
  startDate?: string | null; 
  endDate?: string | null; 
}

export interface Input_rql_ReflectQuery {
  key?: string | null; 
}

export interface Input_rql_FollowsQuery {
  limit?: number | null; 
  offset?: number | null; 
  channel?: rql_FollowsQuery_Channel | null; 
}

export interface Input_rql_FeedQuery {
  limit?: number | null; 
  offset?: number | null; 
  channel?: rql_FeedQuery_Channel | null; 
  listingsFilter?: Input_reverb_search_ListingsSearchRequest | null; 
  lpListingsFilter?: Input_reverb_search_LPListingsSearchRequest | null; 
  readFromDatabase?: boolean | null; 
}

export interface Input_core_apimessages_RecentlyViewedListingsRequest {
  limit?: number | null; 
}

export interface Input_rql_CollectionQuery {
  ids?: (string | null)[] | null; 
  uuids?: (string | null)[] | null; 
  slugs?: (string | null)[] | null; 
}

export interface Input_rql_NegotiationQuery {
  as?: rql_NegotiationQuery_Party | null; 
  state?: rql_NegotiationQuery_State | null; 
  limit?: number | null; 
  offset?: number | null; 
  ids?: (string | null)[] | null; 
  listingIds?: (string | null)[] | null; 
  sort?: string | null; 
  fullTextQuery?: string | null; 
}

export interface Input_reverb_search_AuctionsSearchRequest {
  bidderId?: string | null; 
  query?: string | null; 
  offset?: number | null; 
  limit?: number | null; 
  withAggregations?: (reverb_search_AuctionsSearchRequest_Aggregation | null)[] | null; 
  userBidStatus?: reverb_search_AuctionsSearchRequest_UserBidStatus | null; 
  merchandisingTypes?: (reverb_search_AuctionsSearchRequest_MerchandisingType | null)[] | null; 
}

export interface Input_rql_SellerCheckoutInput {
  id?: string | null; 
}

export interface Input_core_apimessages_WatchesRequest {
  listingIds?: (string | null)[] | null; 
  offset?: number | null; 
  limit?: number | null; 
  channel?: core_apimessages_Channel | null; 
  listingsState?: core_apimessages_WatchesRequest_ListingState | null; 
}

export interface Input_core_apimessages_BrandManagerBrandsRequest {
  slugs?: (string | null)[] | null; 
  offset?: number | null; 
  limit?: number | null; 
  uuids?: (string | null)[] | null; 
}

export interface Input_core_apimessages_BrandManagerBrandRequest {
  slug?: string | null; 
}

export interface Input_rql_MyUpdatesQuery {
  limit?: number | null; 
  offset?: number | null; 
}

export interface Input_core_apimessages_SellingFeesRequest {
  channel?: core_apimessages_Channel | null; 
}

export interface Input_cms_PagesRequest {
  ids?: (string | null)[] | null; 
  slugs?: (string | null)[] | null; 
  includeDrafts?: string | null; 
  pageType?: string | null; 
  limit?: string | null; 
  offset?: string | null; 
  channels?: (string | null)[] | null; 
  excludeBlacklistedEmbeds?: boolean | null; 
  pageTypes?: (string | null)[] | null; 
  query?: string | null; 
}

export interface Input_rql_CollectionWithDraftsQuery {
  ids?: (string | null)[] | null; 
  uuids?: (string | null)[] | null; 
  slugs?: (string | null)[] | null; 
  includeDrafts?: boolean | null; 
}

export interface Input_core_apimessages_CollectionHeaderRequest {
  collectionType?: core_apimessages_CollectionHeader_CollectionType | null; 
  collectionSlug?: string | null; 
}

export interface Input_core_apimessages_ChatDepartmentRequest {
  countryCode?: string | null; 
}

export interface Input_core_apimessages_CategoriesRequest {
  ids?: (string | null)[] | null; 
  withChildren?: boolean | null; 
  withParent?: boolean | null; 
  uuids?: (string | null)[] | null; 
  slugs?: (string | null)[] | null; 
}

export interface Input_reverb_taxonomy_GetTraitValueTranslationsRequest {
  _?: boolean | null; 
}

export interface Input_core_apimessages_SearchMetadataRequest {
  categorySlugs?: (string | null)[] | null; 
  brandSlugs?: (string | null)[] | null; 
  conditionSlugs?: (string | null)[] | null; 
  curatedSetSlug?: string | null; 
  shopSlug?: string | null; 
  yearMin?: string | null; 
  yearMax?: string | null; 
  query?: string | null; 
}

export interface Input_reverb_personalization_GetTrendingSearchesRequest {
  nResults?: number | null; 
  categoryUuids?: (string | null)[] | null; 
}

export interface Input_reverb_pricing_PriceRecommendationsRequest {
  priceRecommendationQueries?: (Input_reverb_pricing_PriceRecommendationQuery | null)[] | null; 
}

export interface Input_reverb_pricing_PriceRecommendationQuery {
  canonicalProductId?: string | null; 
  conditionUuid?: string | null; 
  currency?: string | null; 
  countryCode?: string | null; 
}

export interface Input_reverb_pricing_CSPPriceRecommendationsRequest {
  cspPriceRecommendationQueries?: (Input_reverb_pricing_CSPPriceRecommendationQuery | null)[] | null; 
}

export interface Input_reverb_pricing_CSPPriceRecommendationQuery {
  comparisonShoppingPageId?: string | null; 
  conditionUuid?: string | null; 
  currency?: string | null; 
  countryCode?: string | null; 
}

export interface Input_core_apimessages_GenerateDraftRequest {
  seedId?: string | null; 
  seedType?: core_apimessages_Listing_SeedType | null; 
}

export interface Input_core_apimessages_AdServeRequest {
  userContext?: Input_core_apimessages_AdUserContext | null; 
  targeting?: Input_core_apimessages_TargetingContext | null; 
  placements?: (Input_core_apimessages_AdPlacementRequest | null)[] | null; 
}

export interface Input_core_apimessages_AdUserContext {
  mparticleProfileResponse?: Input_core_apimessages_MparticleProfileResponse | null; 
}

export interface Input_core_apimessages_MparticleProfileResponse {
  mpid?: string | null; 
  topProductType?: string | null; 
  topProductTypes?: (string | null)[] | null; 
  topCategories?: (string | null)[] | null; 
  topBrands?: (string | null)[] | null; 
  recentlyViewedCsps?: (string | null)[] | null; 
  averageOrderValue?: number | null; 
  totalListingsCreated?: number | null; 
  totalListingsSold?: number | null; 
  totalListingsDraft?: number | null; 
  totalListingsSuspended?: number | null; 
  totalListingsLive?: number | null; 
  cumulativeGmv?: number | null; 
  totalPurchases?: number | null; 
  buyerLabel?: string | null; 
  sellerLabel?: string | null; 
  totalFeedFollows?: number | null; 
  totalBuyerOffersCreated?: number | null; 
  totalBuyerOffersAccepted?: number | null; 
  sellerFeedbackRating?: number | null; 
  buyerFeedbackRating?: number | null; 
  mostRecentOrderDate?: string | null; 
  firstOrderDate?: string | null; 
  topProductTypeUuids?: (string | null)[] | null; 
  topCategoryUuids?: (string | null)[] | null; 
  topBrandCategories?: (string | null)[] | null; 
}

export interface Input_core_apimessages_TargetingContext {
  keywords?: (string | null)[] | null; 
  categories?: (string | null)[] | null; 
}

export interface Input_core_apimessages_AdPlacementRequest {
  adZones?: (Input_core_apimessages_AdZone | null)[] | null; 
  adTypes?: (Input_core_apimessages_AdType | null)[] | null; 
}

export interface Input_core_apimessages_AdZone {
  uuid?: string | null; 
  slug?: string | null; 
  name?: string | null; 
  status?: core_apimessages_AdZone_AdZoneStatus | null; 
  description?: string | null; 
}

export interface Input_core_apimessages_AdType {
  format?: core_apimessages_AdFormat | null; 
}

export interface Input_core_apimessages_MyDirectCheckoutProfileRequest {
  _?: boolean | null; 
}

export interface Input_core_apimessages_VerifyPromotionalCodeRequest {
  token?: string | null; 
}

export interface Input_core_apimessages_BearerV2TokenRequest {
  client?: core_apimessages_BearerV2TokenRequest_Client | null; 
}

export interface Input_arbiter_FeaturedListingRequest {
  cspSlug?: string | null; 
  canonicalFinish?: string | null; 
  userShippingRegion?: string | null; 
  cspId?: string | null; 
  traitValues?: (string | null)[] | null; 
  categoryUuids?: (string | null)[] | null; 
  deterministic?: boolean | null; 
  itemRegion?: string | null; 
  conditionUuids?: (string | null)[] | null; 
  auctionType?: arbiter_AuctionType | null; 
  userCurrency?: string | null; 
}

export interface Input_rql_NodeQuery {
  id?: string | null; 
  uuid?: string | null; 
  slug?: string | null; 
}

export interface Input_lp_PagesRequest {
  ids?: (string | null)[] | null; 
  slugs?: (string | null)[] | null; 
  page?: string | null; 
  perPage?: string | null; 
  includeDrafts?: string | null; 
  pageType?: string | null; 
  limit?: string | null; 
  offset?: string | null; 
  albumSlugs?: (string | null)[] | null; 
  excludeBlacklistedEmbeds?: string | null; 
}

export interface Input_core_apimessages_SiteBannerRequest {
  limit?: number | null; 
  visibilityScope?: core_apimessages_SiteBannerRequest_VisibilityScope | null; 
}

export interface Input_core_apimessages_AdvertisersSearchRequest {
  offset?: number | null; 
  limit?: number | null; 
}

export interface Input_core_apimessages_AdCampaignsSearchRequest {
  offset?: number | null; 
  limit?: number | null; 
  status?: core_apimessages_AdCampaignsSearchRequest_Status | null; 
  withinDate?: string | null; 
  advertiserUuids?: (string | null)[] | null; 
  adZoneSlugs?: (string | null)[] | null; 
}

export interface Input_core_apimessages_AdGroupsSearchRequest {
  offset?: number | null; 
  limit?: number | null; 
  adCampaignUuids?: (string | null)[] | null; 
}

export interface Input_core_apimessages_AdsSearchRequest {
  offset?: number | null; 
  limit?: number | null; 
  adGroupUuids?: (string | null)[] | null; 
}

export interface Input_core_apimessages_AdZonesSearchRequest {
  offset?: number | null; 
  limit?: number | null; 
}

export interface Input_core_apimessages_AdminUserSearchRequest {
  search?: string | null; 
  activated?: core_apimessages_AdminUserSearchRequest_ActivatedFilter | null; 
  userFilter?: string | null; 
  page?: string | null; 
  perPage?: string | null; 
}

export interface Input_core_apimessages_BidsCreateRequest {
  bid?: Input_core_apimessages_PrivateBid | null; 
}

export interface Input_core_apimessages_PrivateBid {
  auctionId?: string | null; 
  maxBid?: Input_core_apimessages_Money | null; 
}

export interface Input_core_apimessages_Money {
  amount?: string | null; 
  amountCents?: number | null; 
  currency?: string | null; 
  symbol?: string | null; 
  display?: string | null; 
}

export interface Input_core_apimessages_DeleteRequest {
  id?: string | null; 
  uuid?: string | null; 
}

export interface Input_core_apimessages_CreateNegotiationRequest {
  message?: string | null; 
  offerItems?: (Input_core_apimessages_OfferItemRequest | null)[] | null; 
  recipientUuid?: string | null; 
  countryCode?: string | null; 
  regionCode?: string | null; 
  shippingRegionCode?: string | null; 
  postalCode?: string | null; 
  conversation?: Input_core_apimessages_CreateNegotiationRequest_ConversationData | null; 
  bumpKey?: Input_core_apimessages_BumpKey | null; 
}

export interface Input_core_apimessages_OfferItemRequest {
  listingId?: string | null; 
  price?: Input_core_apimessages_Money | null; 
  shippingPrice?: Input_core_apimessages_Money | null; 
  quantity?: number | null; 
}

export interface Input_core_apimessages_CreateNegotiationRequest_ConversationData {
  listingId?: string | null; 
  photos?: (Input_core_apimessages_ImageEntry | null)[] | null; 
}

export interface Input_core_apimessages_ImageEntry {
  id?: string | null; 
  publicId?: string | null; 
  version?: string | null; 
  width?: number | null; 
  height?: number | null; 
  format?: string | null; 
  resourceType?: string | null; 
  originalFilename?: string | null; 
  transformation?: Input_core_apimessages_ImageEntry_Transformation | null; 
}

export interface Input_core_apimessages_ImageEntry_Transformation {
  width?: string | null; 
  height?: string | null; 
  x?: string | null; 
  y?: string | null; 
  crop?: string | null; 
  angle?: number | null; 
}

export interface Input_core_apimessages_BumpKey {
  key?: string | null; 
}

export interface Input_core_apimessages_CreateAutoOfferRequest {
  listingId?: string | null; 
  message?: string | null; 
  price?: Input_core_apimessages_Money | null; 
  pushToExisting?: boolean | null; 
  percentage?: number | null; 
}

export interface Input_core_apimessages_UpdateShopKYCRequest {
  personalInformation?: Input_core_apimessages_PersonalInformation | null; 
  bankDetails?: Input_core_apimessages_BankDetails | null; 
  companyInformation?: Input_core_apimessages_CompanyInformation | null; 
}

export interface Input_core_apimessages_PersonalInformation {
  firstName?: string | null; 
  lastName?: string | null; 
  dateOfBirth?: Input_core_apimessages_Date | null; 
  phoneNumber?: string | null; 
  idNumber?: string | null; 
  email?: string | null; 
  address?: Input_core_apimessages_KYCAddress | null; 
  maskedIdNumber?: string | null; 
  shareholderType?: core_apimessages_PersonalInformation_AdyenShareholderType | null; 
  jobTitle?: string | null; 
}

export interface Input_core_apimessages_Date {
  day?: string | null; 
  month?: string | null; 
  year?: string | null; 
}

export interface Input_core_apimessages_KYCAddress {
  streetAddress?: string | null; 
  postalCode?: string | null; 
  region?: string | null; 
  locality?: string | null; 
  countryCode?: string | null; 
  houseNumber?: string | null; 
}

export interface Input_core_apimessages_BankDetails {
  name?: string | null; 
  euBankDetails?: Input_core_apimessages_EUBankDetails | null; 
  usBankDetails?: Input_core_apimessages_USBankDetails | null; 
  ukBankDetails?: Input_core_apimessages_UKBankDetails | null; 
  address?: Input_core_apimessages_KYCAddress | null; 
  bankCountryCode?: string | null; 
}

export interface Input_core_apimessages_EUBankDetails {
  iban?: string | null; 
}

export interface Input_core_apimessages_USBankDetails {
  accountNumber?: string | null; 
  routingNumber?: string | null; 
}

export interface Input_core_apimessages_UKBankDetails {
  sortCode?: string | null; 
  accountNumber?: string | null; 
  bankCode?: string | null; 
}

export interface Input_core_apimessages_CompanyInformation {
  taxId?: string | null; 
  legalBusinessName?: string | null; 
  phoneNumber?: string | null; 
  registrationNumber?: string | null; 
  parentCompanyDetails?: Input_core_apimessages_AdyenParentCompanyDetails | null; 
}

export interface Input_core_apimessages_AdyenParentCompanyDetails {
  stockExchange?: string | null; 
  stockNumber?: string | null; 
  stockTicker?: string | null; 
  legalBusinessName?: string | null; 
  registrationNumber?: string | null; 
  countryCode?: string | null; 
  companyCode?: string | null; 
}

export interface Input_core_apimessages_SetupPaymentMethodsRequest {
  shopCurrency?: string | null; 
  adyenDetails?: Input_core_apimessages_SetupPaymentMethodsRequestAdyenDetails | null; 
  paypalDetails?: Input_core_apimessages_SetupPaymentMethodsRequestPaypalDetails | null; 
  returnPolicyDetails?: Input_core_apimessages_ReturnPolicy | null; 
  creditCard?: Input_core_apimessages_BillingCreditCardEntry | null; 
}

export interface Input_core_apimessages_SetupPaymentMethodsRequestAdyenDetails {
  legalEntity?: core_apimessages_AdyenLegalEntity | null; 
  individualDetails?: Input_core_apimessages_SetupPaymentMethodsRequestIndividualAdyenDetails | null; 
  businessDetails?: Input_core_apimessages_SetupPaymentMethodsRequestBusinessAdyenDetails | null; 
}

export interface Input_core_apimessages_SetupPaymentMethodsRequestIndividualAdyenDetails {
  firstName?: string | null; 
  lastName?: string | null; 
  originCountryCode?: string | null; 
}

export interface Input_core_apimessages_SetupPaymentMethodsRequestBusinessAdyenDetails {
  firstName?: string | null; 
  lastName?: string | null; 
  originCountryCode?: string | null; 
  legalBusinessName?: string | null; 
  shareholderType?: core_apimessages_SetupPaymentMethodsRequestBusinessAdyenDetails_AdyenShareholderType | null; 
  jobTitle?: string | null; 
  parentCompanyDetails?: Input_core_apimessages_SetupPaymentMethodsRequestAdyenParentCompanyDetails | null; 
}

export interface Input_core_apimessages_SetupPaymentMethodsRequestAdyenParentCompanyDetails {
  stockExchange?: string | null; 
  stockNumber?: string | null; 
  stockTicker?: string | null; 
  legalBusinessName?: string | null; 
  registrationNumber?: string | null; 
  countryCode?: string | null; 
}

export interface Input_core_apimessages_SetupPaymentMethodsRequestPaypalDetails {
  email?: string | null; 
  legalCountryCode?: string | null; 
}

export interface Input_core_apimessages_ReturnPolicy {
  newReturnWindowDays?: number | null; 
  usedReturnWindowDays?: number | null; 
  restockingFeePercent?: number | null; 
  specialConditions?: string | null; 
  legacyReturnPolicyText?: string | null; 
}

export interface Input_core_apimessages_BillingCreditCardEntry {
  creditCardId?: string | null; 
  adyenToken?: string | null; 
  adyenCreditCard?: Input_core_apimessages_AdyenCreditCardEntry | null; 
  address?: Input_core_apimessages_AddressEntry | null; 
}

export interface Input_core_apimessages_AdyenCreditCardEntry {
  tokenizedFields?: string | null; 
  cardholderName?: string | null; 
}

export interface Input_core_apimessages_AddressEntry {
  name?: string | null; 
  streetAddress?: string | null; 
  extendedAddress?: string | null; 
  postalCode?: string | null; 
  phone?: string | null; 
  region?: string | null; 
  locality?: string | null; 
  countryCode?: string | null; 
  email?: string | null; 
}

export interface Input_core_apimessages_UpdateBillingMethodRequest {
  creditCard?: Input_core_apimessages_BillingCreditCardEntry | null; 
  browserInfo?: string | null; 
  returnUrl?: string | null; 
  origin?: string | null; 
}

export interface Input_core_apimessages_BillingMethodVerifyShopperRequest {
  results?: Input_core_apimessages_AdyenVerifyShopperResults | null; 
  billingMethodUuid?: string | null; 
}

export interface Input_core_apimessages_AdyenVerifyShopperResults {
  threeds2Result?: string | null; 
}

export interface Input_core_apimessages_BillingMethodIdentifyShopperRequest {
  results?: Input_core_apimessages_AdyenIdentifyShopperResults | null; 
  billingMethodUuid?: string | null; 
}

export interface Input_core_apimessages_AdyenIdentifyShopperResults {
  threeds2FingerprintResult?: string | null; 
  paymentData?: string | null; 
}

export interface Input_core_apimessages_BillingMethodChallengeShopperRequest {
  results?: Input_core_apimessages_AdyenChallengeShopperResults | null; 
  billingMethodUuid?: string | null; 
}

export interface Input_core_apimessages_AdyenChallengeShopperResults {
  threeds2ChallengeResult?: string | null; 
  paymentData?: string | null; 
}

export interface Input_core_apimessages_RedeemPromotionalCodeRequest {
  token?: string | null; 
}

export interface Input_core_apimessages_UpdateNegotiationRequest {
  id?: string | null; 
  message?: string | null; 
  offerItems?: (Input_core_apimessages_OfferItemRequest | null)[] | null; 
  action?: core_apimessages_NegotiationAction | null; 
}

export interface Input_core_apimessages_ShippingProtectionRequest {
  shipmentItems?: (Input_core_apimessages_ShipmentItem | null)[] | null; 
  fromCountryCode?: string | null; 
  toCountryCode?: string | null; 
  shipmentType?: core_apimessages_Shipment_ShipmentType | null; 
}

export interface Input_core_apimessages_ShipmentItem {
  productId?: string | null; 
  declaredValue?: Input_core_apimessages_Money | null; 
}

export interface Input_core_apimessages_CreateShipmentRequest {
  toAddress?: Input_core_apimessages_Address | null; 
  fromAddress?: Input_core_apimessages_Address | null; 
  package?: Input_core_apimessages_ShippingLabelPackage | null; 
  shippingProtection?: boolean | null; 
  signatureRequired?: boolean | null; 
  mediaMailQualified?: boolean | null; 
  customs?: Input_core_apimessages_CustomsInfo | null; 
  orderUuids?: (string | null)[] | null; 
  shippingProtectionPrice?: Input_core_apimessages_Money | null; 
  id?: string | null; 
  toAddressIsResidential?: boolean | null; 
  shipmentType?: core_apimessages_Shipment_ShipmentType | null; 
  modifiedCarrierCalculatedShipment?: boolean | null; 
}

export interface Input_core_apimessages_Address {
  name?: string | null; 
  streetAddress?: string | null; 
  extendedAddress?: string | null; 
  postalCode?: string | null; 
  phone?: string | null; 
  region?: string | null; 
  locality?: string | null; 
  countryCode?: string | null; 
  displayLocation?: string | null; 
  id?: string | null; 
  primary?: boolean | null; 
  legacyId?: string | null; 
  uuid?: string | null; 
  addressPresent?: boolean | null; 
  email?: string | null; 
  country?: Input_core_apimessages_Country | null; 
  regionName?: string | null; 
  isComplete?: boolean | null; 
}

export interface Input_core_apimessages_Country {
  countryCode?: string | null; 
  name?: string | null; 
  subregionRequired?: boolean | null; 
  subregions?: (Input_core_apimessages_Subregion | null)[] | null; 
  superRegion?: Input_core_apimessages_SuperRegion | null; 
}

export interface Input_core_apimessages_Subregion {
  code?: string | null; 
  name?: string | null; 
}

export interface Input_core_apimessages_SuperRegion {
  code?: string | null; 
  name?: string | null; 
}

export interface Input_core_apimessages_ShippingLabelPackage {
  length?: Input_core_apimessages_Measurement | null; 
  height?: Input_core_apimessages_Measurement | null; 
  width?: Input_core_apimessages_Measurement | null; 
  weight?: Input_core_apimessages_Measurement | null; 
  predefinedPackage?: string | null; 
  id?: string | null; 
}

export interface Input_core_apimessages_Measurement {
  value?: string | null; 
  unit?: string | null; 
}

export interface Input_core_apimessages_CustomsInfo {
  signer?: string | null; 
  certifiedAccuracy?: boolean | null; 
  orders?: (Input_core_apimessages_OrderCustoms | null)[] | null; 
}

export interface Input_core_apimessages_OrderCustoms {
  uuid?: string | null; 
  description?: string | null; 
  countryOfOrigin?: string | null; 
  declaredValue?: Input_core_apimessages_Money | null; 
  tariffNumber?: string | null; 
  quantity?: number | null; 
}

export interface Input_core_apimessages_PurchaseShippingRateRequest {
  shipmentUuid?: string | null; 
  rateUuid?: string | null; 
}

export interface Input_core_apimessages_UpdateReturnPolicyRequest {
  newReturnWindowDays?: number | null; 
  usedReturnWindowDays?: number | null; 
  restockingFeePercent?: number | null; 
  specialConditions?: string | null; 
}

export interface Input_core_apimessages_UpdateMyShopRequest {
  shop?: Input_core_apimessages_ShopEntry | null; 
}

export interface Input_core_apimessages_ShopEntry {
  currency?: string | null; 
  originCountryCode?: string | null; 
  defaultLocale?: string | null; 
  name?: string | null; 
  address?: Input_core_apimessages_AddressEntry | null; 
}

export interface Input_core_apimessages_UpdateAddressRequest {
  id?: string | null; 
  addressType?: core_apimessages_MyAddressType | null; 
  isPrimary?: boolean | null; 
  address?: Input_core_apimessages_AddressEntry | null; 
  uuid?: string | null; 
}

export interface Input_core_apimessages_AddressDeleteRequest {
  id?: string | null; 
  uuid?: string | null; 
  addressType?: core_apimessages_MyAddressType | null; 
}

export interface Input_core_apimessages_UpdateMyShopShippingProfilesRequest {
  shippingProfiles?: (Input_core_apimessages_UpdateMyShippingProfile | null)[] | null; 
}

export interface Input_core_apimessages_UpdateMyShippingProfile {
  id?: string | null; 
  name?: string | null; 
  categoryUuids?: (string | null)[] | null; 
  localPickup?: boolean | null; 
  offersIncrementalRates?: boolean | null; 
  shippingRates?: (Input_core_apimessages_ShippingRates | null)[] | null; 
}

export interface Input_core_apimessages_ShippingRates {
  regionCode?: string | null; 
  rate?: Input_core_apimessages_Money | null; 
  incrementalRate?: Input_core_apimessages_Money | null; 
  freeShippingThreshold?: Input_core_apimessages_Money | null; 
  regionType?: core_apimessages_ShippingRates_RegionType | null; 
  expeditedRate?: Input_core_apimessages_Money | null; 
  regionName?: string | null; 
  rateType?: string | null; 
  regionalRates?: (Input_core_apimessages_RegionalShippingRate | null)[] | null; 
  regionalExpeditedRates?: (Input_core_apimessages_RegionalShippingRate | null)[] | null; 
}

export interface Input_core_apimessages_RegionalShippingRate {
  areas?: (string | null)[] | null; 
  rate?: Input_core_apimessages_Money | null; 
}

export interface Input_core_apimessages_WatchesCreateRequest {
  listingId?: string | null; 
  channel?: core_apimessages_Channel | null; 
  bumpKey?: Input_core_apimessages_BumpKey | null; 
}

export interface Input_core_apimessages_WatchesDeleteRequest {
  listingId?: string | null; 
}

export interface Input_core_apimessages_UpdateFeedbackRequest {
  orderUuid?: string | null; 
  message?: string | null; 
  rating?: number | null; 
  shippingSatisfactory?: Input_google_protobuf_BoolValue | null; 
  conditionSatisfactory?: Input_google_protobuf_BoolValue | null; 
}

export interface Input_google_protobuf_BoolValue {
  value?: boolean | null; 
}

export interface Input_core_apimessages_DeclineFeedbackRequest {
  orderUuid?: string | null; 
}

export interface Input_core_apimessages_AdminCuratedSetsCurateRequest {
  curatedSetSlug?: string | null; 
  listingId?: string | null; 
  featuredInSet?: boolean | null; 
}

export interface Input_core_apimessages_ProductReviewVoteRequest {
  id?: string | null; 
}

export interface Input_core_apimessages_MyCuratedSetMembershipRequest {
  setType?: core_apimessages_CuratedSet_SetType | null; 
  productId?: string | null; 
}

export interface Input_core_apimessages_ReverifyCreditCardRequest {
  creditCardId?: string | null; 
  tokenizedFields?: string | null; 
}

export interface Input_core_apimessages_CheckoutCreateRequest {
  checkoutBundlingId?: string | null; 
  paymentMethod?: core_apimessages_CheckoutPaymentMethod_Type | null; 
}

export interface Input_core_apimessages_CreateExpressSaleCheckoutRequest {
  checkoutId?: string | null; 
  payoutAmountCents?: number | null; 
  isTermsAccepted?: boolean | null; 
  addressUuid?: string | null; 
  address?: Input_core_apimessages_AddressEntry | null; 
}

export interface Input_core_apimessages_CompleteExpressSaleCheckoutRequest {
  checkoutId?: string | null; 
}

export interface Input_core_apimessages_CheckoutUpdateShippingAddressRequest {
  id?: string | null; 
  shippingAddress?: Input_core_apimessages_AddressEntry | null; 
  guest?: Input_core_apimessages_GuestCheckoutUserEntry | null; 
}

export interface Input_core_apimessages_GuestCheckoutUserEntry {
  firstName?: string | null; 
  lastName?: string | null; 
  email?: string | null; 
}

export interface Input_core_apimessages_CheckoutSelectShippingAddressRequest {
  id?: string | null; 
  shippingAddressId?: string | null; 
}

export interface Input_core_apimessages_CheckoutSelectOrderShippingMethodRequest {
  id?: string | null; 
  order?: Input_core_apimessages_CheckoutSelectOrderShippingMethodRequest_OrderEntry | null; 
}

export interface Input_core_apimessages_CheckoutSelectOrderShippingMethodRequest_OrderEntry {
  listingId?: string | null; 
  shippingMethodType?: core_apimessages_ShippingMethod | null; 
}

export interface Input_core_apimessages_CheckoutUpdateShippingEstimateRequest {
  id?: string | null; 
  shippingAddress?: Input_core_apimessages_AddressEntry | null; 
}

export interface Input_core_apimessages_CheckoutFinalizeDigitalWalletPaymentRequest {
  id?: string | null; 
  paymentToken?: string | null; 
  totalPrice?: Input_core_apimessages_MoneyMinorUnitsEntry | null; 
  shippingAddress?: Input_core_apimessages_AddressEntry | null; 
  guestUser?: Input_core_apimessages_GuestCheckoutUserEntry | null; 
  resultConfirmation?: core_apimessages_CheckoutFinalizeDigitalWalletPaymentRequest_ResultConfirmation | null; 
}

export interface Input_core_apimessages_MoneyMinorUnitsEntry {
  amountCents?: number | null; 
  currency?: string | null; 
}

export interface Input_core_apimessages_CheckoutFinalizeDirectCheckoutPaymentRequest {
  id?: string | null; 
  browserInfo?: Input_core_apimessages_CheckoutFinalizeDirectCheckoutPaymentRequest_BrowserInfo | null; 
  displayedAmountOwed?: Input_core_apimessages_MoneyMinorUnitsEntry | null; 
}

export interface Input_core_apimessages_CheckoutFinalizeDirectCheckoutPaymentRequest_BrowserInfo {
  screenWidth?: number | null; 
  screenHeight?: number | null; 
  colorDepth?: number | null; 
  userAgent?: string | null; 
  language?: string | null; 
  javaEnabled?: boolean | null; 
  timeZoneOffset?: number | null; 
}

export interface Input_core_apimessages_CheckoutCreatePaymentRedirectUrlRequest {
  id?: string | null; 
  reverbApp?: string | null; 
}

export interface Input_core_apimessages_StartCheckoutForListingRequest {
  listingId?: string | null; 
  paymentMethod?: core_apimessages_CheckoutPaymentMethod_Type | null; 
}

export interface Input_core_apimessages_ApplyCheckoutDiscountCodeRequest {
  id?: string | null; 
  discountCode?: string | null; 
}

export interface Input_core_apimessages_SelectCheckoutCreditCardRequest {
  id?: string | null; 
  creditCardId?: string | null; 
}

export interface Input_core_apimessages_UpdateCheckoutGuestCreditCardRequest {
  id?: string | null; 
  creditCard?: Input_core_apimessages_UpdateCheckoutGuestCreditCardRequest_CreditCardEntry | null; 
  billingAddress?: Input_core_apimessages_AddressEntry | null; 
}

export interface Input_core_apimessages_UpdateCheckoutGuestCreditCardRequest_CreditCardEntry {
  tokenizedFields?: Input_core_apimessages_CreditCardTokenizedFields | null; 
  cardholderName?: string | null; 
  brandType?: string | null; 
  lastDigits?: string | null; 
}

export interface Input_core_apimessages_CreditCardTokenizedFields {
  encryptedCardNumber?: string | null; 
  encryptedExpiryMonth?: string | null; 
  encryptedExpiryYear?: string | null; 
  encryptedSecurityCode?: string | null; 
}

export interface Input_core_apimessages_SelectCheckoutPaymentMethodRequest {
  id?: string | null; 
  paymentMethod?: core_apimessages_CheckoutPaymentMethod_Type | null; 
}

export interface Input_core_apimessages_CheckoutCartEditRequest {
  listingId?: string | null; 
  quantity?: number | null; 
}

export interface Input_rql_CheckoutCartEditRequest {
  id?: string | null; 
  order?: Input_rql_CheckoutCartEditRequest_OrderEntry | null; 
}

export interface Input_rql_CheckoutCartEditRequest_OrderEntry {
  listingId?: string | null; 
  quantity?: number | null; 
}

export interface Input_core_apimessages_CheckoutFinalizeRedirectPaymentCheckoutRequest {
  id?: string | null; 
  redirectResult?: string | null; 
  merchantReference?: string | null; 
  displayedAmountOwedCents?: string | null; 
}

export interface Input_core_apimessages_CheckoutVerifyShopperRequest {
  checkoutUuid?: string | null; 
  checkoutId?: string | null; 
  totalPrice?: Input_core_apimessages_Money | null; 
  results?: Input_core_apimessages_AdyenVerifyShopperResults | null; 
}

export interface Input_core_apimessages_CheckoutIdentifyShopperRequest {
  checkoutUuid?: string | null; 
  checkoutId?: string | null; 
  totalPrice?: Input_core_apimessages_Money | null; 
  results?: Input_core_apimessages_AdyenIdentifyShopperResults | null; 
  channelBrandingToken?: string | null; 
}

export interface Input_core_apimessages_CheckoutChallengeShopperRequest {
  checkoutUuid?: string | null; 
  checkoutId?: string | null; 
  totalPrice?: Input_core_apimessages_Money | null; 
  results?: Input_core_apimessages_AdyenChallengeShopperResults | null; 
  channelBrandingToken?: string | null; 
}

export interface Input_core_apimessages_GuestCheckoutVerifyShopperRequest {
  checkoutUuid?: string | null; 
  checkoutId?: string | null; 
  totalPrice?: Input_core_apimessages_Money | null; 
  results?: Input_core_apimessages_AdyenVerifyShopperResults | null; 
  cartItemAttributes?: (Input_core_apimessages_CartItemAttributes | null)[] | null; 
}

export interface Input_core_apimessages_CartItemAttributes {
  actionSourceAttributes?: Input_core_apimessages_ActionSourceAttributes | null; 
  cartSource?: string | null; 
  listingId?: number | null; 
  quantity?: number | null; 
  upsell?: boolean | null; 
  uuid?: string | null; 
  saleId?: number | null; 
}

export interface Input_core_apimessages_ActionSourceAttributes {
  device?: string | null; 
}

export interface Input_core_apimessages_GuestCheckoutApplePayLineItemsRequest {
  shippingAddress?: Input_core_apimessages_Address | null; 
  paymentMethod?: string | null; 
  checkoutId?: string | null; 
  cartItemAttributes?: (Input_core_apimessages_CartItemAttributes | null)[] | null; 
}

export interface Input_core_apimessages_GuestCheckoutApplePayPaymentRequest {
  checkoutUuid?: string | null; 
  checkoutId?: string | null; 
  totalPrice?: Input_core_apimessages_Money | null; 
  cartItemAttributes?: (Input_core_apimessages_CartItemAttributes | null)[] | null; 
  adyenToken?: string | null; 
  shippingAddress?: Input_core_apimessages_Address | null; 
  acceptsTerms?: boolean | null; 
  email?: string | null; 
  firstName?: string | null; 
  lastName?: string | null; 
}

export interface Input_core_apimessages_DeleteAutoOfferRequest {
  listingId?: string | null; 
}

export interface Input_core_apimessages_CancelOrderRequest {
  uuid?: string | null; 
  id?: string | null; 
  cancellationReason?: core_apimessages_CancelOrderRequest_CancellationReason | null; 
  relist?: boolean | null; 
}

export interface Input_core_apimessages_TrackBumpInteractionRequest {
  bumpKey?: Input_core_apimessages_BumpKey | null; 
  listingId?: string | null; 
  interactionType?: arbiter_Interaction_InteractionType | null; 
}

export interface Input_core_apimessages_RegisterMyPacklinkAccountRequest {
  email?: string | null; 
  password?: string | null; 
  policies?: Input_core_apimessages_PacklinkPolicies | null; 
}

export interface Input_core_apimessages_PacklinkPolicies {
  dataProcessing?: boolean | null; 
  marketingCalls?: boolean | null; 
  marketingEmails?: boolean | null; 
  termsAndConditions?: boolean | null; 
}

export interface Input_core_apimessages_LoginMyPacklinkAccountRequest {
  email?: string | null; 
  password?: string | null; 
  countryCode?: string | null; 
}

export interface Input_core_apimessages_CreatePacklinkDraftRequest {
  orderId?: string | null; 
}

export interface Input_core_apimessages_UpdateGearCollectionItemRequest {
  gearCollectionItemEntry?: Input_core_apimessages_GearCollectionItemEntry | null; 
}

export interface Input_core_apimessages_GearCollectionItemEntry {
  id?: string | null; 
  title?: string | null; 
  make?: string | null; 
  model?: string | null; 
  finish?: string | null; 
  year?: string | null; 
  price?: Input_core_apimessages_Money | null; 
  description?: string | null; 
  notes?: string | null; 
  categoryUuids?: (string | null)[] | null; 
  canonicalProductId?: string | null; 
  seedId?: string | null; 
  seedType?: core_apimessages_GearCollectionItem_SeedType | null; 
  photos?: (Input_core_apimessages_ImageEntry | null)[] | null; 
  categoryRootUuid?: string | null; 
  ownerCost?: Input_core_apimessages_Money | null; 
  serialNumber?: string | null; 
  conditionSlug?: string | null; 
  tags?: (Input_core_apimessages_GearCollectionItemTag | null)[] | null; 
  hideListingPhotos?: boolean | null; 
  hideListingDescription?: boolean | null; 
  quickCreateItemFromSeed?: boolean | null; 
  source?: core_apimessages_GearCollectionItemEntry_Source | null; 
}

export interface Input_core_apimessages_GearCollectionItemTag {
  id?: string | null; 
  name?: string | null; 
}

export interface Input_core_apimessages_DeleteGearCollectionItemRequest {
  id?: string | null; 
}

export interface Input_core_apimessages_CreateTaxIdentificationRequest {
  taxId?: string | null; 
  countryCode?: string | null; 
}

export interface Input_core_apimessages_UpdateTaxIdentificationRequest {
  taxIdentification?: Input_core_apimessages_TaxIdentificationUpdate | null; 
}

export interface Input_core_apimessages_TaxIdentificationUpdate {
  id?: string | null; 
  taxId?: string | null; 
  countryCode?: string | null; 
}

export interface Input_core_apimessages_DeactivateTaxIdentificationRequest {
  id?: string | null; 
}

export interface Input_core_apimessages_CreateMyPlaidLinkTokenRequest {
  countryCode?: string | null; 
  plaidAccountId?: string | null; 
  requiresMobileRedirect?: boolean | null; 
}

export interface Input_core_apimessages_SaveMyPlaidAccountRequest {
  accountId?: string | null; 
  publicToken?: string | null; 
  verificationStatus?: string | null; 
  countryCode?: string | null; 
}

export interface Input_core_apimessages_DelinkUserServiceRequest {
  provider?: core_apimessages_UserService_Provider | null; 
}

export interface Input_core_apimessages_CancelPlaidAccountRequest {
  _?: boolean | null; 
}

export interface Input_core_apimessages_UpdateUniversalPromoCampaignRequest {
  universalPromoCampaign?: Input_core_apimessages_UniversalPromoCampaign | null; 
}

export interface Input_core_apimessages_UniversalPromoCampaign {
  id?: string | null; 
  name?: string | null; 
  code?: string | null; 
  expiresAt?: Timestamp | null; 
  marketingChannel?: string | null; 
  newBuyer?: boolean | null; 
  redemptionLimit?: number | null; 
  hasRedemptionLimit?: boolean | null; 
  universalPromoCurrencies?: (Input_core_apimessages_UniversalPromoCurrency | null)[] | null; 
  categories?: (Input_core_apimessages_NodesCategory | null)[] | null; 
}

export interface Input_core_apimessages_UniversalPromoCurrency {
  amount?: Input_core_apimessages_Money | null; 
  minPurchaseAmount?: Input_core_apimessages_Money | null; 
}

export interface Input_core_apimessages_NodesCategory {
  id?: string | null; 
  name?: string | null; 
  webLink?: Input_core_apimessages_Link | null; 
  cmsLink?: Input_core_apimessages_Link | null; 
  slug?: string | null; 
  rootSlug?: string | null; 
  cmsUrl?: Input_core_apimessages_Link | null; 
  root?: boolean | null; 
  leaf?: boolean | null; 
}

export interface Input_core_apimessages_Link {
  href?: string | null; 
  path?: string | null; 
}

export interface Input_core_apimessages_UpdateListingRequest {
  listingEntry?: Input_core_apimessages_ListingEntry | null; 
}

export interface Input_core_apimessages_ListingEntry {
  id?: string | null; 
  sku?: string | null; 
  year?: string | null; 
  countryOfOrigin?: string | null; 
  seedId?: string | null; 
  seedType?: core_apimessages_Listing_SeedType | null; 
  categoryRootUuid?: string | null; 
  categoryUuids?: (string | null)[] | null; 
  localizedContents?: (Input_core_apimessages_LocalizedListingContent | null)[] | null; 
  handmade?: boolean | null; 
  traits?: (Input_core_apimessages_Trait | null)[] | null; 
  conditionSlug?: string | null; 
  hasInventory?: boolean | null; 
  inventory?: number | null; 
  upc?: string | null; 
  upcDoesNotApply?: boolean | null; 
  videoLinkUrl?: string | null; 
  photos?: (Input_core_apimessages_ImageEntry | null)[] | null; 
  shippingProfileId?: string | null; 
  offersLocalPickup?: boolean | null; 
  shippingRates?: (Input_core_apimessages_ShippingRates | null)[] | null; 
  carrierCalculatedPackage?: Input_core_apimessages_ShippingLabelPackage | null; 
  prefersReverbShippingLabel?: boolean | null; 
  price?: Input_core_apimessages_Money | null; 
  sellerCost?: Input_core_apimessages_Money | null; 
  soldAsIs?: boolean | null; 
  offersEnabled?: boolean | null; 
  sameDayShippingIneligible?: boolean | null; 
  preorderInfo?: Input_core_apimessages_PreorderInfoEntry | null; 
  taxExempt?: boolean | null; 
}

export interface Input_core_apimessages_LocalizedListingContent {
  locale?: string | null; 
  make?: string | null; 
  model?: string | null; 
  finish?: string | null; 
  title?: string | null; 
  description?: string | null; 
  prop65Warning?: string | null; 
  defaultForShop?: boolean | null; 
}

export interface Input_core_apimessages_Trait {
  keyId?: string | null; 
  valueId?: string | null; 
  value?: string | null; 
}

export interface Input_core_apimessages_PreorderInfoEntry {
  timeType?: core_apimessages_PreorderInfoEntry_TimeType | null; 
  leadTimeUnit?: core_apimessages_PreorderInfoEntry_LeadTimeUnit | null; 
  shipDate?: string | null; 
  leadTimeDays?: number | null; 
}

export interface Input_core_apimessages_CreateMyCreditCardRequest {
  creditCard?: Input_core_apimessages_CreateMyCreditCardRequest_CreditCardEntry | null; 
  billingAddress?: Input_core_apimessages_AddressEntry | null; 
}

export interface Input_core_apimessages_CreateMyCreditCardRequest_CreditCardEntry {
  tokenizedFields?: Input_core_apimessages_CreditCardTokenizedFields | null; 
  cardholderName?: string | null; 
}

export interface Input_core_apimessages_UpdateMyCreditCardRequest {
  id?: string | null; 
  creditCard?: Input_core_apimessages_UpdateMyCreditCardRequest_CreditCardEntry | null; 
  billingAddress?: Input_core_apimessages_AddressEntry | null; 
}

export interface Input_core_apimessages_UpdateMyCreditCardRequest_CreditCardEntry {
  expirationMonth?: string | null; 
  expirationYear?: string | null; 
  cardholderName?: string | null; 
  primaryForCheckout?: boolean | null; 
}

export interface Input_core_apimessages_DeleteMyCreditCardRequest {
  id?: string | null; 
}

export interface Input_reverb_feed_RemoveEntryRequest {
  entryId?: string | null; 
  userId?: string | null; 
  entryType?: reverb_feed_FeedEntry_EntryType | null; 
}

export interface Input_reverb_feed_SetFollowDigestsByUserRequest {
  userId?: string | null; 
  digestsEnabled?: boolean | null; 
}

export interface Input_arbiter_BulkTrackImpressionsRequest {
  listingIds?: (string | null)[] | null; 
}

export interface Input_rql_EmailSubscription {
  id?: string | null; 
  subscribed?: boolean | null; 
  translationKey?: rql_EmailSubscription_TranslationKey | null; 
}

export interface Input_rql_SetGlobalSubscribeRequest {
  state?: rql_SubscribeState | null; 
}

export interface Input_rql_Blank {
  _?: boolean | null; 
}

export interface Input_reverb_config_cache_ExchangeCurrencyRequest {
  from?: string | null; 
  to?: string | null; 
  amountMinorUnits?: number | null; 
  inverseReverseRates?: boolean | null; 
}

export interface Input_core_apimessages_UpdateAdvertiserRequest {
  advertiser?: Input_core_apimessages_Advertiser | null; 
}

export interface Input_core_apimessages_Advertiser {
  uuid?: string | null; 
  name?: string | null; 
  brandSlugs?: (string | null)[] | null; 
  shopSlugs?: (string | null)[] | null; 
}

export interface Input_core_apimessages_UpdateAdCampaignRequest {
  adCampaign?: Input_core_apimessages_AdCampaign | null; 
}

export interface Input_core_apimessages_AdCampaign {
  uuid?: string | null; 
  name?: string | null; 
  description?: string | null; 
  status?: core_apimessages_AdCampaign_AdStatus | null; 
  startsAt?: Timestamp | null; 
  endsAt?: Timestamp | null; 
  advertiserUuid?: string | null; 
}

export interface Input_core_apimessages_UpdateAdGroupRequest {
  adGroup?: Input_core_apimessages_AdGroup | null; 
}

export interface Input_core_apimessages_AdGroup {
  uuid?: string | null; 
  name?: string | null; 
  description?: string | null; 
  status?: core_apimessages_AdGroup_AdStatus | null; 
  adCampaignUuid?: string | null; 
  targetedCountryCodes?: (string | null)[] | null; 
  targetedCategoryUuids?: (string | null)[] | null; 
  targetedAdZoneSlugs?: (string | null)[] | null; 
  targetedAdZones?: (Input_core_apimessages_AdGroupZone | null)[] | null; 
  targetedDevices?: (string | null)[] | null; 
  targetedBrandSlugs?: (string | null)[] | null; 
}

export interface Input_core_apimessages_AdGroupZone {
  adGroup?: Input_core_apimessages_AdGroup | null; 
  adZone?: Input_core_apimessages_AdZone | null; 
  startsAt?: Timestamp | null; 
  endsAt?: Timestamp | null; 
}

export interface Input_core_apimessages_CopyAdGroupRequest {
  adGroupUuid?: string | null; 
}

export interface Input_core_apimessages_UpdateAdGroupKeywordsRequest {
  keywords?: (string | null)[] | null; 
  adGroupUuid?: string | null; 
}

export interface Input_core_apimessages_UpdateAdRequest {
  ad?: Input_core_apimessages_Ad | null; 
}

export interface Input_core_apimessages_Ad {
  id?: number | null; 
  campaignId?: number | null; 
  format?: core_apimessages_AdFormat | null; 
  imageAdCreative?: Input_core_apimessages_ImageAdCreative | null; 
  uuid?: string | null; 
  adGroupUuid?: string | null; 
  adCampaignUuid?: string | null; 
  advertiserUuid?: string | null; 
  localizedContents?: (Input_core_apimessages_AdLocalizedContent | null)[] | null; 
  deletedAt?: Timestamp | null; 
  adGroupName?: string | null; 
}

export interface Input_core_apimessages_ImageAdCreative {
  title?: string | null; 
  titleColor?: string | null; 
  subtitle?: string | null; 
  subtitleColor?: string | null; 
  ctaText?: string | null; 
  ctaHref?: string | null; 
  ctaTextColor?: string | null; 
  ctaButtonColor?: string | null; 
  backgroundImage?: string | null; 
  mobileBackgroundImage?: string | null; 
  backgroundColor?: string | null; 
  overlayImage?: string | null; 
  description?: string | null; 
  hideAdCallout?: boolean | null; 
  partnershipText?: string | null; 
  backgroundColors?: (string | null)[] | null; 
  cspRowQuery?: Input_core_apimessages_CspRowQuery | null; 
}

export interface Input_core_apimessages_CspRowQuery {
  rowTitle?: string | null; 
  cspSlugs?: (string | null)[] | null; 
  brandSlugs?: (string | null)[] | null; 
  sort?: string | null; 
  categoryUuids?: (string | null)[] | null; 
}

export interface Input_core_apimessages_AdLocalizedContent {
  locale?: string | null; 
  imageAdCreative?: Input_core_apimessages_ImageAdCreative | null; 
}

export interface Input_core_apimessages_UpdateAdZoneRequest {
  adZone?: Input_core_apimessages_AdZone | null; 
}

export interface Input_core_apimessages_DeleteAdRequest {
  uuid?: string | null; 
}

export interface Input_google_api_Http {
  rules?: (Input_google_api_HttpRule | null)[] | null; 
  fullyDecodeReservedExpansion?: boolean | null; 
}

export interface Input_google_api_HttpRule {
  selector?: string | null; 
  get?: string | null; 
  put?: string | null; 
  post?: string | null; 
  delete?: string | null; 
  patch?: string | null; 
  custom?: Input_google_api_CustomHttpPattern | null; 
  body?: string | null; 
  additionalBindings?: (Input_google_api_HttpRule | null)[] | null; 
}

export interface Input_google_api_CustomHttpPattern {
  kind?: string | null; 
  path?: string | null; 
}

export interface Input_google_protobuf_FileDescriptorSet {
  file?: (Input_google_protobuf_FileDescriptorProto | null)[] | null; 
}

export interface Input_google_protobuf_FileDescriptorProto {
  name?: string | null; 
  package?: string | null; 
  dependency?: (string | null)[] | null; 
  publicDependency?: (number | null)[] | null; 
  weakDependency?: (number | null)[] | null; 
  messageType?: (Input_google_protobuf_DescriptorProto | null)[] | null; 
  enumType?: (Input_google_protobuf_EnumDescriptorProto | null)[] | null; 
  service?: (Input_google_protobuf_ServiceDescriptorProto | null)[] | null; 
  extension?: (Input_google_protobuf_FieldDescriptorProto | null)[] | null; 
  options?: Input_google_protobuf_FileOptions | null; 
  sourceCodeInfo?: Input_google_protobuf_SourceCodeInfo | null; 
  syntax?: string | null; 
}

export interface Input_google_protobuf_DescriptorProto {
  name?: string | null; 
  field?: (Input_google_protobuf_FieldDescriptorProto | null)[] | null; 
  extension?: (Input_google_protobuf_FieldDescriptorProto | null)[] | null; 
  nestedType?: (Input_google_protobuf_DescriptorProto | null)[] | null; 
  enumType?: (Input_google_protobuf_EnumDescriptorProto | null)[] | null; 
  extensionRange?: (Input_google_protobuf_DescriptorProto_ExtensionRange | null)[] | null; 
  oneofDecl?: (Input_google_protobuf_OneofDescriptorProto | null)[] | null; 
  options?: Input_google_protobuf_MessageOptions | null; 
  reservedRange?: (Input_google_protobuf_DescriptorProto_ReservedRange | null)[] | null; 
  reservedName?: (string | null)[] | null; 
}

export interface Input_google_protobuf_FieldDescriptorProto {
  name?: string | null; 
  number?: number | null; 
  label?: google_protobuf_FieldDescriptorProto_Label | null; 
  type?: google_protobuf_FieldDescriptorProto_Type | null; 
  typeName?: string | null; 
  extendee?: string | null; 
  defaultValue?: string | null; 
  oneofIndex?: number | null; 
  jsonName?: string | null; 
  options?: Input_google_protobuf_FieldOptions | null; 
}

export interface Input_google_protobuf_FieldOptions {
  ctype?: google_protobuf_FieldOptions_CType | null; 
  packed?: boolean | null; 
  jstype?: google_protobuf_FieldOptions_JSType | null; 
  lazy?: boolean | null; 
  deprecated?: boolean | null; 
  weak?: boolean | null; 
  uninterpretedOption?: (Input_google_protobuf_UninterpretedOption | null)[] | null; 
}

export interface Input_google_protobuf_UninterpretedOption {
  name?: (Input_google_protobuf_UninterpretedOption_NamePart | null)[] | null; 
  identifierValue?: string | null; 
  positiveIntValue?: number | null; 
  negativeIntValue?: number | null; 
  doubleValue?: number | null; 
  stringValue?: string | null; 
  aggregateValue?: string | null; 
}

export interface Input_google_protobuf_UninterpretedOption_NamePart {
  namePart?: string | null; 
  isExtension?: boolean | null; 
}

export interface Input_google_protobuf_EnumDescriptorProto {
  name?: string | null; 
  value?: (Input_google_protobuf_EnumValueDescriptorProto | null)[] | null; 
  options?: Input_google_protobuf_EnumOptions | null; 
  reservedRange?: (Input_google_protobuf_EnumDescriptorProto_EnumReservedRange | null)[] | null; 
  reservedName?: (string | null)[] | null; 
}

export interface Input_google_protobuf_EnumValueDescriptorProto {
  name?: string | null; 
  number?: number | null; 
  options?: Input_google_protobuf_EnumValueOptions | null; 
}

export interface Input_google_protobuf_EnumValueOptions {
  deprecated?: boolean | null; 
  uninterpretedOption?: (Input_google_protobuf_UninterpretedOption | null)[] | null; 
}

export interface Input_google_protobuf_EnumOptions {
  allowAlias?: boolean | null; 
  deprecated?: boolean | null; 
  uninterpretedOption?: (Input_google_protobuf_UninterpretedOption | null)[] | null; 
}

export interface Input_google_protobuf_EnumDescriptorProto_EnumReservedRange {
  start?: number | null; 
  end?: number | null; 
}

export interface Input_google_protobuf_DescriptorProto_ExtensionRange {
  start?: number | null; 
  end?: number | null; 
  options?: Input_google_protobuf_ExtensionRangeOptions | null; 
}

export interface Input_google_protobuf_ExtensionRangeOptions {
  uninterpretedOption?: (Input_google_protobuf_UninterpretedOption | null)[] | null; 
}

export interface Input_google_protobuf_OneofDescriptorProto {
  name?: string | null; 
  options?: Input_google_protobuf_OneofOptions | null; 
}

export interface Input_google_protobuf_OneofOptions {
  uninterpretedOption?: (Input_google_protobuf_UninterpretedOption | null)[] | null; 
}

export interface Input_google_protobuf_MessageOptions {
  messageSetWireFormat?: boolean | null; 
  noStandardDescriptorAccessor?: boolean | null; 
  deprecated?: boolean | null; 
  mapEntry?: boolean | null; 
  uninterpretedOption?: (Input_google_protobuf_UninterpretedOption | null)[] | null; 
}

export interface Input_google_protobuf_DescriptorProto_ReservedRange {
  start?: number | null; 
  end?: number | null; 
}

export interface Input_google_protobuf_ServiceDescriptorProto {
  name?: string | null; 
  method?: (Input_google_protobuf_MethodDescriptorProto | null)[] | null; 
  options?: Input_google_protobuf_ServiceOptions | null; 
}

export interface Input_google_protobuf_MethodDescriptorProto {
  name?: string | null; 
  inputType?: string | null; 
  outputType?: string | null; 
  options?: Input_google_protobuf_MethodOptions | null; 
  clientStreaming?: boolean | null; 
  serverStreaming?: boolean | null; 
}

export interface Input_google_protobuf_MethodOptions {
  deprecated?: boolean | null; 
  idempotencyLevel?: google_protobuf_MethodOptions_IdempotencyLevel | null; 
  uninterpretedOption?: (Input_google_protobuf_UninterpretedOption | null)[] | null; 
}

export interface Input_google_protobuf_ServiceOptions {
  deprecated?: boolean | null; 
  uninterpretedOption?: (Input_google_protobuf_UninterpretedOption | null)[] | null; 
}

export interface Input_google_protobuf_FileOptions {
  javaPackage?: string | null; 
  javaOuterClassname?: string | null; 
  javaMultipleFiles?: boolean | null; 
  javaGenerateEqualsAndHash?: boolean | null; 
  javaStringCheckUtf8?: boolean | null; 
  optimizeFor?: google_protobuf_FileOptions_OptimizeMode | null; 
  goPackage?: string | null; 
  ccGenericServices?: boolean | null; 
  javaGenericServices?: boolean | null; 
  pyGenericServices?: boolean | null; 
  phpGenericServices?: boolean | null; 
  deprecated?: boolean | null; 
  ccEnableArenas?: boolean | null; 
  objcClassPrefix?: string | null; 
  csharpNamespace?: string | null; 
  swiftPrefix?: string | null; 
  phpClassPrefix?: string | null; 
  phpNamespace?: string | null; 
  uninterpretedOption?: (Input_google_protobuf_UninterpretedOption | null)[] | null; 
}

export interface Input_google_protobuf_SourceCodeInfo {
  location?: (Input_google_protobuf_SourceCodeInfo_Location | null)[] | null; 
}

export interface Input_google_protobuf_SourceCodeInfo_Location {
  path?: (number | null)[] | null; 
  span?: (number | null)[] | null; 
  leadingComments?: string | null; 
  trailingComments?: string | null; 
  leadingDetachedComments?: (string | null)[] | null; 
}

export interface Input_google_protobuf_GeneratedCodeInfo_Annotation {
  path?: (number | null)[] | null; 
  sourceFile?: string | null; 
  begin?: number | null; 
  end?: number | null; 
}

export interface Input_google_protobuf_GeneratedCodeInfo {
  annotation?: (Input_google_protobuf_GeneratedCodeInfo_Annotation | null)[] | null; 
}

export interface Input_mparticle_TokenRequest {
  clientId?: string | null; 
  clientSecret?: string | null; 
  audience?: string | null; 
  grantType?: string | null; 
}

export interface Input_mparticle_TokenResponse {
  accessToken?: string | null; 
  tokenType?: string | null; 
  expiresIn?: number | null; 
}

export interface Input_mparticle_Identity {
  type?: string | null; 
  value?: string | null; 
}

export interface Input_mparticle_ProfileRequest {
  orgId?: string | null; 
  accountId?: string | null; 
  workspaceId?: string | null; 
  environmentType?: string | null; 
  identity?: Input_mparticle_Identity | null; 
}

export interface Input_mparticle_ProfileResponse {
  mpid?: string | null; 
  topProductType?: string | null; 
  topProductTypes?: (string | null)[] | null; 
  topCategories?: (string | null)[] | null; 
  topBrands?: (string | null)[] | null; 
  recentlyViewedCsps?: (string | null)[] | null; 
  averageOrderValue?: number | null; 
  totalListingsCreated?: number | null; 
  totalListingsSold?: number | null; 
  totalListingsDraft?: number | null; 
  totalListingsSuspended?: number | null; 
  totalListingsLive?: number | null; 
  cumulativeGmv?: number | null; 
  totalPurchases?: number | null; 
  buyerLabel?: string | null; 
  sellerLabel?: string | null; 
  totalFeedFollows?: number | null; 
  totalBuyerOffersCreated?: number | null; 
  totalBuyerOffersAccepted?: number | null; 
  sellerFeedbackRating?: number | null; 
  buyerFeedbackRating?: number | null; 
  mostRecentOrderDate?: string | null; 
  firstOrderDate?: string | null; 
  topProductTypeUuids?: (string | null)[] | null; 
  topCategoryUuids?: (string | null)[] | null; 
  topBrandCategories?: (string | null)[] | null; 
}

export interface Input_reverb_feed_PruneFeedRequest {
  userId?: string | null; 
  savedSearchId?: number | null; 
  fromFeedService?: boolean | null; 
}

export interface Input_reverb_feed_RemoveEntryResponse {
  entry?: Input_reverb_feed_FeedEntry | null; 
}

export interface Input_reverb_feed_FeedEntry {
  id?: number | null; 
  type?: reverb_feed_FeedEntry_EntryType | null; 
  metadata?: Input_reverb_feed_FeedMetadata | null; 
  uuid?: string | null; 
  searchableType?: reverb_feed_SearchableType | null; 
  searchableId?: string | null; 
  queryParams?: string | null; 
  localizedContents?: (Input_reverb_feed_FollowLocalizedContents | null)[] | null; 
  deleted?: boolean | null; 
  userId?: string | null; 
}

export interface Input_reverb_feed_FeedMetadata {
  sourceType?: reverb_feed_FeedSourceType | null; 
  sourceId?: number | null; 
  matchedAt?: Timestamp | null; 
  fromFeedService?: boolean | null; 
}

export interface Input_reverb_feed_FollowLocalizedContents {
  locale?: string | null; 
  title?: string | null; 
  subtitle?: string | null; 
  shortDescription?: string | null; 
  description?: string | null; 
}

export interface Input_reverb_feed_PruneFeedResponse {
  _?: boolean | null; 
}

export interface Input_reverb_feed_AlertableUsersRequest {
  _?: boolean | null; 
}

export interface Input_reverb_feed_AlertableUsersStreamRequest {
  chunkSize?: number | null; 
}

export interface Input_reverb_feed_AlertableUsersResponse {
  userIds?: (string | null)[] | null; 
}

export interface Input_reverb_feed_DigestFollows {
  follow?: Input_reverb_feed_Follow | null; 
  entries?: (Input_reverb_feed_FeedEntry | null)[] | null; 
}

export interface Input_reverb_feed_Follow {
  userId?: string | null; 
  savedSearchId?: string | null; 
  createdAt?: Timestamp | null; 
  queryParams?: string | null; 
  searchableType?: reverb_feed_SearchableType | null; 
  searchableId?: string | null; 
  id?: string | null; 
  localizedContents?: (Input_reverb_feed_FollowLocalizedContents | null)[] | null; 
  digestEnabled?: boolean | null; 
}

export interface Input_reverb_feed_UserDigest {
  userId?: string | null; 
  digestFollows?: (Input_reverb_feed_DigestFollows | null)[] | null; 
}

export interface Input_reverb_feed_UserDigestsResponse {
  userDigests?: (Input_reverb_feed_UserDigest | null)[] | null; 
}

export interface Input_reverb_feed_User {
  userId?: string | null; 
  locale?: string | null; 
  lastActiveAt?: Timestamp | null; 
}

export interface Input_reverb_feed_UserDigestsRequest {
  users?: (Input_reverb_feed_User | null)[] | null; 
  matchedAfter?: Timestamp | null; 
}

export interface Input_reverb_feed_ClearUserDigestRequest {
  userId?: string | null; 
}

export interface Input_reverb_feed_ClearUserDigestResponse {
  _?: boolean | null; 
}

export interface Input_reverb_feed_CreateFollowResponse {
  follow?: Input_reverb_feed_Follow | null; 
}

export interface Input_reverb_feed_RemoveFollowRequest {
  follow?: Input_reverb_feed_Follow | null; 
  locale?: string | null; 
  removeEntries?: boolean | null; 
}

export interface Input_reverb_feed_RemoveFollowsBySearchableRequest {
  searchableId?: number | null; 
  searchableType?: reverb_feed_SearchableType | null; 
}

export interface Input_reverb_feed_RemoveFollowsBySearchableResponse {
  _?: boolean | null; 
}

export interface Input_reverb_feed_UpsertFollowResponse {
  follow?: Input_reverb_feed_Follow | null; 
  following?: boolean | null; 
  followCount?: number | null; 
}

export interface Input_reverb_feed_SetFollowDigestRequest {
  id?: string | null; 
  userId?: string | null; 
  digestEnabled?: boolean | null; 
  locale?: string | null; 
}

export interface Input_reverb_feed_SetFollowDigestResponse {
  follow?: Input_reverb_feed_Follow | null; 
}

export interface Input_reverb_feed_SetFollowDigestsByUserResponse {
  follows?: (Input_reverb_feed_Follow | null)[] | null; 
}

export interface Input_reverb_feed_EntriesRequest {
  userId?: string | null; 
  perPage?: number | null; 
  page?: number | null; 
  offset?: number | null; 
  locale?: string | null; 
  limit?: number | null; 
  readFromDatabase?: boolean | null; 
}

export interface Input_reverb_feed_FollowsRequest {
  userId?: string | null; 
  perPage?: number | null; 
  page?: number | null; 
  offset?: number | null; 
  locale?: string | null; 
}

export interface Input_reverb_feed_FeedEntryUpdated {
  action?: reverb_feed_FeedEntryUpdated_Action | null; 
  entries?: (Input_reverb_feed_FeedEntry | null)[] | null; 
  userId?: number | null; 
  sourceId?: number | null; 
  sourceType?: reverb_feed_FeedSourceType | null; 
  sourceIds?: (number | null)[] | null; 
  entityUpdatedAt?: Timestamp | null; 
  userIds?: (number | null)[] | null; 
}

export interface Input_reverb_feed_FollowsTopic {
  action?: reverb_feed_FollowsTopic_Action | null; 
  followId?: number | null; 
  userId?: number | null; 
  searchableId?: number | null; 
  searchableType?: reverb_feed_SearchableType | null; 
}

export interface Input_reverb_feed_FeedResponse {
  entries?: (Input_reverb_feed_FeedEntry | null)[] | null; 
  page?: number | null; 
  perPage?: number | null; 
  total?: number | null; 
  offset?: number | null; 
  limit?: number | null; 
}

export interface Input_reverb_feed_GetFollowResponse {
  following?: boolean | null; 
  follow?: Input_reverb_feed_Follow | null; 
  followCount?: number | null; 
}

export interface Input_reverb_feed_GetFollowsResponse {
  follows?: (Input_reverb_feed_Follow | null)[] | null; 
  page?: number | null; 
  perPage?: number | null; 
  total?: number | null; 
}

export interface Input_reverb_feed_FindFollowBySearchableRequest {
  searchableId?: string | null; 
  searchableType?: reverb_feed_SearchableType | null; 
  userId?: string | null; 
}

export interface Input_reverb_feed_FindFollowsBySearchableRequest {
  searchableId?: string | null; 
  searchableType?: reverb_feed_SearchableType | null; 
  limit?: number | null; 
  offset?: number | null; 
}

export interface Input_reverb_feed_FindFollowsBySearchableResponse {
  follows?: (Input_reverb_feed_Follow | null)[] | null; 
  limit?: number | null; 
  offset?: number | null; 
  total?: number | null; 
}

export interface Input_reverb_feed_FindFollowByIdRequest {
  id?: string | null; 
  userId?: string | null; 
}

export interface Input_reverb_feed_FindFollowRequest {
  queryParams?: string | null; 
  userId?: string | null; 
}

export interface Input_reverb_feed_GetSavedSearchRequest {
  id?: number | null; 
  withMostRecentFollow?: boolean | null; 
}

export interface Input_reverb_feed_GetSavedSearchResponse {
  esQuery?: string | null; 
  mostRecentFollowedUserId?: string | null; 
  queryParams?: string | null; 
}

export interface Input_reverb_feed_CreateSavedSearchRequest {
  esQuery?: string | null; 
  searchableType?: reverb_feed_SearchableType | null; 
  queryParams?: string | null; 
  searchableUuid?: string | null; 
  localizedContents?: (Input_reverb_feed_FollowLocalizedContents | null)[] | null; 
}

export interface Input_reverb_feed_CreateSavedSearchResponse {
  id?: number | null; 
}

export interface Input_reverb_feed_UpdateSavedSearchRequest {
  id?: number | null; 
  esQuery?: string | null; 
}

export interface Input_reverb_feed_UpdateSavedSearchResponse {
  id?: number | null; 
}

export interface Input_reverb_feed_FollowUpdated {
  savedSearchId?: number | null; 
  userId?: number | null; 
  esQuery?: string | null; 
  searchableType?: reverb_feed_SearchableType | null; 
  searchableId?: number | null; 
  queryParams?: string | null; 
  searchableUuid?: string | null; 
  id?: string | null; 
  localizedContents?: (Input_reverb_feed_FollowLocalizedContents | null)[] | null; 
  digestEnabled?: boolean | null; 
}

export interface Input_reverb_feed_DigestListings {
  listingIds?: (string | null)[] | null; 
}

export interface Input_reverb_feed_GetFollowedSavedSearchesRequest {
  startId?: number | null; 
}

export interface Input_reverb_feed_GetFollowedSavedSearchesResponse {
  savedSearchIds?: (number | null)[] | null; 
}

export interface Input_reverb_feed_Users {
  users?: (Input_reverb_feed_User | null)[] | null; 
}

export interface Input_reverb_updates_Update {
  action?: reverb_updates_Update_Action | null; 
  entity?: Input_reverb_updates_Entity | null; 
  userIds?: (string | null)[] | null; 
  createdAt?: string | null; 
  updateId?: number | null; 
}

export interface Input_reverb_updates_Entity {
  entityType?: reverb_updates_Entity_EntityType | null; 
  entityId?: string | null; 
  metadata?: Input_reverb_updates_Metadata | null; 
}

export interface Input_reverb_updates_Metadata {
  priceDrop?: Input_reverb_updates_PriceDrop | null; 
  listing?: Input_reverb_updates_Listing | null; 
  siteBanner?: Input_reverb_updates_SiteBanner | null; 
  categories?: (Input_reverb_updates_Category | null)[] | null; 
  cartCount?: number | null; 
  shop?: Input_reverb_updates_Shop | null; 
  listingsCount?: number | null; 
  listings?: (Input_reverb_updates_Listing | null)[] | null; 
  offerCount?: number | null; 
  sale?: Input_reverb_updates_Sale | null; 
  promotion?: Input_reverb_updates_Promotion | null; 
}

export interface Input_reverb_updates_PriceDrop {
  id?: string | null; 
  listingId?: string | null; 
}

export interface Input_reverb_updates_Listing {
  id?: string | null; 
}

export interface Input_reverb_updates_SiteBanner {
  id?: string | null; 
}

export interface Input_reverb_updates_Category {
  uuid?: string | null; 
}

export interface Input_reverb_updates_Shop {
  id?: string | null; 
}

export interface Input_reverb_updates_Sale {
  id?: string | null; 
}

export interface Input_reverb_updates_Promotion {
  id?: string | null; 
}

export interface Input_reverb_updates_MyUpdatesRequest {
  userId?: string | null; 
}

export interface Input_reverb_updates_MyUpdatesResponse {
  updates?: (Input_reverb_updates_Update | null)[] | null; 
}

export interface Input_reverb_updates_CreateMyUpdateRequest {
  entity?: Input_reverb_updates_Entity | null; 
}

export interface Input_reverb_updates_MyUpdateResponse {
  update?: Input_reverb_updates_Update | null; 
}

export interface Input_reverb_updates_PruneMyUpdates {
  pruneType?: reverb_updates_PruneMyUpdates_PruneType | null; 
  userId?: number | null; 
  updateId?: number | null; 
}

export interface Input_core_apimessages_ConvertedMoney {
  original?: Input_core_apimessages_Money | null; 
  display?: Input_core_apimessages_Money | null; 
}

export interface Input_core_apimessages_MoneyMajorUnitsEntry {
  amount?: string | null; 
  currency?: string | null; 
}

export interface Input_reverb_signals_Signal {
  name?: reverb_signals_Signal_Name | null; 
  group?: reverb_signals_Signal_Group | null; 
  slot?: reverb_signals_Signal_Slot | null; 
  title?: string | null; 
  subtitle?: string | null; 
  tooltipText?: string | null; 
  link?: Input_reverb_signals_SignalLink | null; 
  icon?: string | null; 
}

export interface Input_reverb_signals_SignalLink {
  url?: string | null; 
  text?: string | null; 
}

export interface Input_cms_AdminTakeSlugRequest {
  currentSlug?: string | null; 
  desiredSlug?: string | null; 
}

export interface Input_cms_AdminTakeSlugResponse {
  updatedSlug?: string | null; 
  legacySlug?: string | null; 
}

export interface Input_cms_AdminClonePageRequest {
  slug?: string | null; 
}

export interface Input_cms_AdminClonePageResponse {
  clonedPageSlug?: string | null; 
}

export interface Input_cms_AdminCreatePage {
  id?: string | null; 
  goLiveAt?: string | null; 
  imageAttributionUri?: string | null; 
  authorId?: string | null; 
  pageType?: string | null; 
  imageKey?: string | null; 
  slug?: string | null; 
  channels?: (string | null)[] | null; 
  componentIds?: (string | null)[] | null; 
  localizedContents?: (Input_cms_PageLocalizedContent | null)[] | null; 
  layoutId?: string | null; 
  metaImageKey?: string | null; 
  headerStyle?: string | null; 
  noIndex?: boolean | null; 
  secondaryImageKey?: string | null; 
  pageTemplateId?: string | null; 
}

export interface Input_cms_PageLocalizedContent {
  locale?: string | null; 
  title?: string | null; 
  description?: string | null; 
  metaTitle?: string | null; 
  metaDescription?: string | null; 
  actionText?: string | null; 
  actionUrl?: string | null; 
  searchPlaceholder?: string | null; 
  customVariableData?: string | null; 
  breadcrumbs?: string | null; 
}

export interface Input_cms_AdminPageCreateRequest {
  page?: Input_cms_AdminCreatePage | null; 
}

export interface Input_cms_AdminPageIndexRequest {
  page?: string | null; 
  perPage?: string | null; 
  q?: string | null; 
  ids?: (string | null)[] | null; 
  pageType?: string | null; 
  channels?: (string | null)[] | null; 
}

export interface Input_cms_AdminCreatePageTemplate {
  id?: string | null; 
  name?: string | null; 
  layoutId?: string | null; 
  customVariables?: (string | null)[] | null; 
}

export interface Input_cms_AdminCreatePageTemplateRequest {
  pageTemplate?: Input_cms_AdminCreatePageTemplate | null; 
}

export interface Input_cms_AdminPagesResponse {
  pages?: (Input_cms_Page | null)[] | null; 
  meta?: Input_cms_Pagination | null; 
}

export interface Input_cms_Page {
  id?: string | null; 
  slug?: string | null; 
  goLiveAt?: string | null; 
  componentIds?: (string | null)[] | null; 
  imageAttributionUri?: string | null; 
  imageKey?: string | null; 
  authorId?: string | null; 
  pageType?: string | null; 
  channels?: (string | null)[] | null; 
  localizedContents?: (Input_cms_PageLocalizedContent | null)[] | null; 
  layoutId?: string | null; 
  metaImageKey?: string | null; 
  headerStyle?: string | null; 
  noIndex?: boolean | null; 
  secondaryImageKey?: string | null; 
  pageTemplateId?: string | null; 
}

export interface Input_cms_Pagination {
  total?: number | null; 
  currentPage?: number | null; 
  perPage?: number | null; 
}

export interface Input_cms_AdminComponentsResponse {
  components?: (Input_cms_Component | null)[] | null; 
}

export interface Input_cms_Component {
  id?: string | null; 
  pageId?: string | null; 
  position?: number | null; 
  componentType?: string | null; 
  localizedContents?: (Input_cms_ComponentLocalizedContent | null)[] | null; 
  layoutSection?: string | null; 
  targetCountries?: (string | null)[] | null; 
  blacklistCountries?: (string | null)[] | null; 
  active?: boolean | null; 
  experimentKey?: string | null; 
  experimentBucket?: string | null; 
  type?: string | null; 
  pageTemplateId?: string | null; 
}

export interface Input_cms_ComponentLocalizedContent {
  locale?: string | null; 
  data?: string | null; 
}

export interface Input_cms_AdminDeletePageRequest {
  id?: string | null; 
}

export interface Input_cms_Author {
  id?: string | null; 
  slug?: string | null; 
  name?: string | null; 
}

export interface Input_cms_AuthorIndexResponse {
  authors?: (Input_cms_Author | null)[] | null; 
}

export interface Input_cms_AuthorRequest {
  author?: Input_cms_Author | null; 
}

export interface Input_cms_AuthorResponse {
  author?: Input_cms_Author | null; 
}

export interface Input_cms_AdminPageTemplateIndexRequest {
  page?: string | null; 
  perPage?: string | null; 
  q?: string | null; 
  ids?: (string | null)[] | null; 
}

export interface Input_cms_PageTemplateIndexResponse {
  pageTemplates?: (Input_cms_PageTemplate | null)[] | null; 
  meta?: Input_cms_Pagination | null; 
}

export interface Input_cms_PageTemplate {
  id?: string | null; 
  name?: string | null; 
  layoutId?: string | null; 
  customVariables?: (string | null)[] | null; 
}

export interface Input_cms_PageTemplateResponse {
  pageTemplate?: Input_cms_PageTemplate | null; 
}

export interface Input_cms_PageTemplatePageInfo {
  pageTemplateId?: string | null; 
  pageCount?: number | null; 
  pageTitles?: (string | null)[] | null; 
}

export interface Input_cms_PageTemplatePageInfoResponse {
  pageTemplatePageInfo?: (Input_cms_PageTemplatePageInfo | null)[] | null; 
}

export interface Input_cms_BulkPagination {
  total?: number | null; 
  offset?: number | null; 
  limit?: number | null; 
}

export interface Input_cms_ComponentDeleteRequest {
  id?: string | null; 
}

export interface Input_cms_ComponentResponse {
  component?: Input_cms_Component | null; 
}

export interface Input_cms_ComponentRequest {
  component?: Input_cms_Component | null; 
}

export interface Input_cms_BulkComponentResponse {
  components?: (Input_cms_Component | null)[] | null; 
}

export interface Input_cms_BulkComponentRequest {
  components?: (Input_cms_Component | null)[] | null; 
}

export interface Input_cms_ComponentsRequest {
  ids?: (string | null)[] | null; 
  layoutSection?: string | null; 
  pageId?: string | null; 
}

export interface Input_cms_ComponentTemplatesRequest {
  pageTemplateId?: string | null; 
  layoutSection?: string | null; 
}

export interface Input_cms_Layout {
  id?: string | null; 
  name?: string | null; 
  sections?: (string | null)[] | null; 
}

export interface Input_cms_LayoutsResponse {
  layouts?: (Input_cms_Layout | null)[] | null; 
}

export interface Input_cms_LayoutsIndexRequest {
  ids?: (string | null)[] | null; 
  q?: string | null; 
}

export interface Input_cms_NodeRequest_Lookup {
  lid?: string | null; 
  rel?: string | null; 
}

export interface Input_cms_NodeRequest {
  lookups?: (Input_cms_NodeRequest_Lookup | null)[] | null; 
}

export interface Input_cms_NodeResponse_Result_Meta {
  total?: number | null; 
}

export interface Input_cms_NodeResponse_Result {
  lookup?: Input_cms_NodeRequest_Lookup | null; 
  meta?: Input_cms_NodeResponse_Result_Meta | null; 
  publicComponents?: (Input_cms_PublicComponent | null)[] | null; 
}

export interface Input_cms_PublicComponent {
  id?: string | null; 
  pageId?: string | null; 
  position?: number | null; 
  componentType?: string | null; 
  data?: string | null; 
  layoutSection?: string | null; 
  active?: boolean | null; 
  experimentKey?: string | null; 
  experimentBucket?: string | null; 
  title?: string | null; 
  subtitle?: string | null; 
  searchUrlParams?: string | null; 
  searchSort?: string | null; 
  searchType?: cms_PublicComponent_SearchType | null; 
}

export interface Input_cms_NodeResponse {
  results?: (Input_cms_NodeResponse_Result | null)[] | null; 
}

export interface Input_cms_PageImage {
  imageUrl?: string | null; 
}

export interface Input_cms_PageRequest {
  page?: Input_cms_PublicPage | null; 
}

export interface Input_cms_PublicPage {
  id?: string | null; 
  slug?: string | null; 
  goLiveAt?: string | null; 
  title?: string | null; 
  description?: string | null; 
  metaTitle?: string | null; 
  metaDescription?: string | null; 
  componentIds?: (string | null)[] | null; 
  imageAttributionUri?: string | null; 
  image?: Input_cms_PageImage | null; 
  authorId?: string | null; 
  pageType?: string | null; 
  authorName?: string | null; 
  albumIds?: (string | null)[] | null; 
  channels?: (string | null)[] | null; 
  locale?: string | null; 
  layoutId?: string | null; 
  layoutSlug?: string | null; 
  metaImage?: Input_cms_PageImage | null; 
  headerStyle?: string | null; 
  actionText?: string | null; 
  actionUrl?: string | null; 
  searchPlaceholder?: string | null; 
  noIndex?: boolean | null; 
  secondaryImage?: Input_cms_PageImage | null; 
  live?: boolean | null; 
  pageNotFound?: boolean | null; 
  targetLocales?: (string | null)[] | null; 
  breadcrumbs?: string | null; 
}

export interface Input_cms_PageResponse {
  page?: Input_cms_Page | null; 
}

export interface Input_cms_PagesResponse {
  pages?: (Input_cms_PublicPage | null)[] | null; 
  meta?: Input_cms_BulkPagination | null; 
}

export interface Input_reverb_event_SessionStart {
  userContext?: Input_reverb_event_UserContext | null; 
  referer?: string | null; 
  url?: string | null; 
  aid?: string | null; 
  utmCampaign?: string | null; 
  requestId?: string | null; 
  id?: string | null; 
  utmSource?: string | null; 
  utmMedium?: string | null; 
  gsPartner?: string | null; 
}

export interface Input_reverb_event_UserContext {
  id?: string | null; 
  cookieId?: string | null; 
  distinctId?: string | null; 
  device?: Input_reverb_event_Device | null; 
  experiments?: (Input_reverb_event_Experiment | null)[] | null; 
  timestamp?: string | null; 
  adminId?: string | null; 
  bot?: boolean | null; 
  locale?: string | null; 
  currency?: string | null; 
  shippingRegion?: string | null; 
  lat?: number | null; 
  long?: number | null; 
  lastGoogleClick?: Input_reverb_event_GoogleShoppingClick | null; 
  requestId?: string | null; 
  sellerSitesId?: string | null; 
  reverbApp?: string | null; 
  hasLoggedIn?: boolean | null; 
  countryCode?: string | null; 
  sessionId?: string | null; 
  advertisingId?: string | null; 
  signalSciencesBot?: boolean | null; 
  signalSciencesBadBot?: boolean | null; 
  signalSciencesIp?: boolean | null; 
  signalSciencesTornode?: boolean | null; 
}

export interface Input_reverb_event_Device {
  name?: string | null; 
  userAgent?: string | null; 
  version?: string | null; 
  appVersion?: string | null; 
  osVersion?: string | null; 
  manufacturer?: string | null; 
  brand?: string | null; 
  model?: string | null; 
}

export interface Input_reverb_event_Experiment {
  name?: string | null; 
  value?: string | null; 
  useInFrontend?: boolean | null; 
  multivariateExperiment?: boolean | null; 
  qualifyForMobile?: boolean | null; 
  mobileContext?: Input_reverb_event_Experiment_MobileContext | null; 
  useInMarketplaceListingsSearch?: boolean | null; 
}

export interface Input_reverb_event_Experiment_MobileContext {
  value?: string | null; 
  reportAs?: string | null; 
}

export interface Input_reverb_event_GoogleShoppingClick {
  productId?: string | null; 
  comparisonShoppingPageId?: string | null; 
  timestamp?: string | null; 
  origin?: string | null; 
}

export interface Input_reverb_event_ComponentInteraction {
  componentName?: string | null; 
  interactionType?: string | null; 
  url?: string | null; 
  referer?: string | null; 
  userContext?: Input_reverb_event_UserContext | null; 
  context?: string | null; 
  entityId?: string | null; 
  entityType?: string | null; 
  position?: number | null; 
  page?: number | null; 
  perPage?: number | null; 
  totalResults?: number | null; 
  targetUrl?: string | null; 
  pageViewId?: string | null; 
  impressionUuid?: string | null; 
  utmSource?: string | null; 
  utmMedium?: string | null; 
  utmCampaign?: string | null; 
  freeTextQuery?: string | null; 
  bumped?: boolean | null; 
}

export interface Input_reverb_event_ComponentsView {
  componentName?: string | null; 
  context?: string | null; 
  url?: string | null; 
  referer?: string | null; 
  userContext?: Input_reverb_event_UserContext | null; 
  entityIds?: (string | null)[] | null; 
  entityType?: string | null; 
  pageViewId?: string | null; 
  impressionUuid?: string | null; 
  algorithmVersion?: string | null; 
  utmSource?: string | null; 
  utmMedium?: string | null; 
  utmCampaign?: string | null; 
}

export interface Input_reverb_event_ComparisonShoppingPageClick {
  comparisonShoppingPage?: Input_reverb_event_ComparisonShoppingPage | null; 
  userContext?: Input_reverb_event_UserContext | null; 
  url?: string | null; 
  referer?: string | null; 
  componentName?: string | null; 
}

export interface Input_reverb_event_ComparisonShoppingPage {
  id?: string | null; 
  lowestPriceForNew?: Input_reverb_event_Price | null; 
  lowestPriceForUsed?: Input_reverb_event_Price | null; 
  usedListingCount?: number | null; 
  newListingCount?: number | null; 
}

export interface Input_reverb_event_Price {
  amount?: number | null; 
  currency?: string | null; 
}

export interface Input_reverb_event_FollowAdded {
  userContext?: Input_reverb_event_UserContext | null; 
  referer?: string | null; 
  searchableType?: string | null; 
  searchableId?: string | null; 
  searchParams?: string | null; 
}

export interface Input_reverb_event_UserSignedIn {
  userContext?: Input_reverb_event_UserContext | null; 
  referer?: string | null; 
  userId?: string | null; 
  signup?: boolean | null; 
}

export interface Input_reverb_event_TrackingPixelEvent {
  name?: string | null; 
  data?: string | null; 
}

export interface Input_reverb_event_PMBView {
  userContext?: Input_reverb_event_UserContext | null; 
  persona?: string | null; 
  listings?: (Input_reverb_event_Listing | null)[] | null; 
  utmCampaign?: string | null; 
}

export interface Input_reverb_event_Listing {
  id?: string | null; 
  price?: Input_reverb_event_Price | null; 
  status?: string | null; 
  categoryUuids?: (string | null)[] | null; 
  bumped?: boolean | null; 
  canonicalProductId?: string | null; 
}

export interface Input_reverb_event_MarketingEmailView {
  userContext?: Input_reverb_event_UserContext | null; 
  listings?: (Input_reverb_event_Listing | null)[] | null; 
  utmCampaign?: string | null; 
  upsellOrderId?: string | null; 
  persona?: string | null; 
  entityIds?: (string | null)[] | null; 
  entityType?: string | null; 
}

export interface Input_reverb_event_MailLinkClick {
  userContext?: Input_reverb_event_UserContext | null; 
  utmCampaign?: string | null; 
  url?: string | null; 
  sourceType?: string | null; 
  sourceId?: string | null; 
  variations?: string | null; 
}

export interface Input_reverb_event_MessagesMailer {
  userContext?: Input_reverb_event_UserContext | null; 
  messageId?: string | null; 
  action?: string | null; 
}

export interface Input_reverb_event_WatcherListingSoldMailer {
  userContext?: Input_reverb_event_UserContext | null; 
  action?: string | null; 
  productId?: string | null; 
  orderId?: string | null; 
  similarProductIds?: (string | null)[] | null; 
  comparisonShoppingPageId?: string | null; 
}

export interface Input_reverb_event_GenericMailer {
  userContext?: Input_reverb_event_UserContext | null; 
  emailType?: string | null; 
  action?: string | null; 
  sourceType?: string | null; 
  sourceId?: string | null; 
  utmCampaign?: string | null; 
  variations?: string | null; 
}

export interface Input_reverb_event_WatchAdded {
  userContext?: Input_reverb_event_UserContext | null; 
  referer?: string | null; 
  listingId?: string | null; 
  watchId?: string | null; 
}

export interface Input_reverb_event_AdminAbilityAndAbilityProfileUpdated {
  abilityManagerUserId?: string | null; 
  abilityRecipientUserId?: string | null; 
  adHocAbilities?: (string | null)[] | null; 
  abilityProfiles?: (string | null)[] | null; 
}

export interface Input_reverb_event_ClickStats {
  entityType?: string | null; 
  entityId?: string | null; 
  impressions?: number | null; 
  clicks?: number | null; 
  bumpImpressions?: number | null; 
  bumpClicks?: number | null; 
}

export interface Input_reverb_event_DigitalListing {
  id?: string | null; 
  price?: Input_reverb_event_Price | null; 
  status?: string | null; 
  categoryUuids?: (string | null)[] | null; 
}

export interface Input_reverb_event_CanonicalProduct {
  id?: string | null; 
}

export interface Input_reverb_event_Article {
  id?: string | null; 
}

export interface Input_reverb_event_AttributeChange {
  name?: string | null; 
  previousValue?: string | null; 
  newValue?: string | null; 
}

export interface Input_reverb_event_Message {
  id?: string | null; 
  conversationId?: string | null; 
}

export interface Input_reverb_event_MobileInteraction {
  name?: string | null; 
  action?: string | null; 
  type?: reverb_event_MobileInteraction_InteractionType | null; 
  context?: string | null; 
  userContext?: Input_reverb_event_UserContext | null; 
}

export interface Input_reverb_event_Error {
  error?: string | null; 
  userContext?: Input_reverb_event_UserContext | null; 
}

export interface Input_reverb_event_EntityUpdated {
  name?: string | null; 
  id?: string | null; 
  timestamp?: string | null; 
  action?: reverb_event_EntityUpdated_Action | null; 
}

export interface Input_reverb_event_OrderUpdated {
  userContext?: Input_reverb_event_UserContext | null; 
  id?: string | null; 
  status?: string | null; 
  listing?: Input_reverb_event_Listing | null; 
  buyerId?: string | null; 
  createdAt?: string | null; 
}

export interface Input_reverb_event_OrderPaid {
  userContext?: Input_reverb_event_UserContext | null; 
  id?: string | null; 
  listingId?: string | null; 
  buyerId?: string | null; 
}

export interface Input_reverb_event_NegotiationUpdated {
  userContext?: Input_reverb_event_UserContext | null; 
  status?: string | null; 
  id?: string | null; 
  lastOfferId?: string | null; 
  listing?: Input_reverb_event_Listing | null; 
}

export interface Input_reverb_event_NegotiationStarted {
  userContext?: Input_reverb_event_UserContext | null; 
  id?: string | null; 
  buyerInitiated?: boolean | null; 
  offerId?: string | null; 
  buyerId?: string | null; 
  listingIds?: (string | null)[] | null; 
}

export interface Input_reverb_event_ConversationUpdated {
  userContext?: Input_reverb_event_UserContext | null; 
  id?: string | null; 
  initialRecipientId?: string | null; 
  initialAuthorId?: string | null; 
  listing?: Input_reverb_event_Listing | null; 
  lastMessageId?: string | null; 
  requestId?: string | null; 
}

export interface Input_reverb_event_UserUpdated {
  userContext?: Input_reverb_event_UserContext | null; 
  id?: string | null; 
  status?: string | null; 
  newsletterOptIn?: boolean | null; 
}

export interface Input_reverb_event_ListingMatched {
  userContext?: Input_reverb_event_UserContext | null; 
  listingId?: string | null; 
  canonicalProductId?: string | null; 
}

export interface Input_reverb_event_ListingUpdated {
  userContext?: Input_reverb_event_UserContext | null; 
  listing?: Input_reverb_event_Listing | null; 
  changes?: (Input_reverb_event_AttributeChange | null)[] | null; 
}

export interface Input_reverb_event_CanonicalProductUpdated {
  userContext?: Input_reverb_event_UserContext | null; 
  canonicalProduct?: Input_reverb_event_CanonicalProduct | null; 
  changes?: (Input_reverb_event_AttributeChange | null)[] | null; 
}

export interface Input_reverb_event_MessageUpdated {
  userContext?: Input_reverb_event_UserContext | null; 
  message?: Input_reverb_event_Message | null; 
  changes?: (Input_reverb_event_AttributeChange | null)[] | null; 
}

export interface Input_reverb_event_ShippingLabelUpdated {
  userContext?: Input_reverb_event_UserContext | null; 
  id?: string | null; 
  status?: string | null; 
}

export interface Input_reverb_event_FollowUpdated {
  userContext?: Input_reverb_event_UserContext | null; 
  id?: string | null; 
  savedSearchId?: string | null; 
  destroyed?: boolean | null; 
}

export interface Input_reverb_event_BumpsReserved {
  userContext?: Input_reverb_event_UserContext | null; 
  amount?: number | null; 
  price?: Input_reverb_event_Price | null; 
  listing?: Input_reverb_event_Listing | null; 
  budgetType?: string | null; 
}

export interface Input_reverb_event_AddedToCart {
  userContext?: Input_reverb_event_UserContext | null; 
  listing?: Input_reverb_event_Listing | null; 
  otherListings?: (Input_reverb_event_Listing | null)[] | null; 
  referer?: string | null; 
  aid?: string | null; 
  cartItemUuid?: string | null; 
}

export interface Input_reverb_event_RemovedFromCart {
  userContext?: Input_reverb_event_UserContext | null; 
  listing?: Input_reverb_event_Listing | null; 
  cartItemUuid?: string | null; 
}

export interface Input_reverb_event_DiscountCodeApplied {
  userContext?: Input_reverb_event_UserContext | null; 
  discountCode?: string | null; 
  success?: boolean | null; 
  referer?: string | null; 
  error?: string | null; 
}

export interface Input_reverb_event_ShopEmptied {
  shopId?: string | null; 
}

export interface Input_reverb_event_Event {
  messageName?: string | null; 
  payload?: string | null; 
  level?: string | null; 
}

export interface Input_reverb_event_EventRequest {
  events?: (Input_reverb_event_Event | null)[] | null; 
}

export interface Input_reverb_event_AttributedLanding {
  landingId?: string | null; 
  landingTime?: string | null; 
  userId?: string | null; 
  aid?: string | null; 
  referer?: string | null; 
  url?: string | null; 
  utmCampaign?: string | null; 
  cookieId?: string | null; 
  userShippingRegion?: string | null; 
  landingDevice?: string | null; 
  landingBucket?: string | null; 
  orderedAt?: string | null; 
  productId?: string | null; 
  orderId?: string | null; 
  orderDevice?: string | null; 
  registeredAt?: string | null; 
}

export interface Input_reverb_event_UserSignedUp {
  newsletterOptIn?: boolean | null; 
  userId?: string | null; 
  registrationSource?: string | null; 
  referer?: string | null; 
  aid?: string | null; 
  utmCampaign?: string | null; 
  url?: string | null; 
  countryCode?: string | null; 
  sourceProductUuid?: string | null; 
  userContext?: Input_reverb_event_UserContext | null; 
}

export interface Input_reverb_event_ContestSignUp {
  userContext?: Input_reverb_event_UserContext | null; 
  referer?: string | null; 
  aid?: string | null; 
  utmCampaign?: string | null; 
  questionResponse?: string | null; 
}

export interface Input_reverb_event_MailListSignUp {
  userContext?: Input_reverb_event_UserContext | null; 
  email?: string | null; 
  referer?: string | null; 
  listId?: string | null; 
  countryCode?: string | null; 
  source?: string | null; 
  sourceProductUuid?: string | null; 
  userId?: string | null; 
}

export interface Input_reverb_event_ComparisonShoppingPageView {
  listings?: (Input_reverb_event_Listing | null)[] | null; 
  canonicalProductIds?: (string | null)[] | null; 
  lowestPriceForNew?: Input_reverb_event_Price | null; 
  lowestPriceForUsed?: Input_reverb_event_Price | null; 
  userContext?: Input_reverb_event_UserContext | null; 
  requestId?: string | null; 
  buyButtonListingId?: string | null; 
  buyButtonListingType?: string | null; 
  comparisonShoppingPageId?: string | null; 
  buyButtonReason?: string | null; 
  priceGuideId?: string | null; 
  condition?: string | null; 
  referer?: string | null; 
  url?: string | null; 
  utmCampaign?: string | null; 
  utmSource?: string | null; 
  utmMedium?: string | null; 
}

export interface Input_reverb_event_ListingsView {
  listings?: (Input_reverb_event_Listing | null)[] | null; 
  query?: string | null; 
  totalResults?: number | null; 
  userContext?: Input_reverb_event_UserContext | null; 
  viewType?: string | null; 
  curatedLinkIds?: (string | null)[] | null; 
  curatedSetIds?: (string | null)[] | null; 
  bumpedListings?: (Input_reverb_event_Listing | null)[] | null; 
  featuredListing?: Input_reverb_event_Listing | null; 
  requestId?: string | null; 
  bumpAlgorithm?: string | null; 
  url?: string | null; 
  referer?: string | null; 
  utmCampaign?: string | null; 
  aid?: string | null; 
  resultCount?: number | null; 
  version?: number | null; 
  responseTime?: number | null; 
  fallbackStrategy?: string | null; 
  fallbackListings?: (Input_reverb_event_Listing | null)[] | null; 
  totalFallbackListings?: number | null; 
}

export interface Input_reverb_event_ListingView {
  userContext?: Input_reverb_event_UserContext | null; 
  listing?: Input_reverb_event_Listing | null; 
  requestId?: string | null; 
  url?: string | null; 
  referer?: string | null; 
  aid?: string | null; 
  utmCampaign?: string | null; 
}

export interface Input_reverb_event_ListingViewRelatedContent {
  userContext?: Input_reverb_event_UserContext | null; 
  listingViewListingId?: string | null; 
  type?: string | null; 
  url?: string | null; 
  referer?: string | null; 
  listings?: (Input_reverb_event_Listing | null)[] | null; 
  articles?: (Input_reverb_event_Article | null)[] | null; 
}

export interface Input_reverb_event_DigitalListingView {
  userContext?: Input_reverb_event_UserContext | null; 
  digitalListing?: Input_reverb_event_DigitalListing | null; 
  requestId?: string | null; 
}

export interface Input_reverb_event_DigitalListingDownload {
  userContext?: Input_reverb_event_UserContext | null; 
  digitalListingId?: string | null; 
  digitalVariantId?: string | null; 
  requestId?: string | null; 
}

export interface Input_reverb_event_CuratedSetView {
  curatedSetId?: string | null; 
  userContext?: Input_reverb_event_UserContext | null; 
  listings?: (Input_reverb_event_Listing | null)[] | null; 
  requestId?: string | null; 
}

export interface Input_reverb_event_SaleView {
  saleId?: string | null; 
  userContext?: Input_reverb_event_UserContext | null; 
  listings?: (Input_reverb_event_Listing | null)[] | null; 
  requestId?: string | null; 
}

export interface Input_reverb_event_CartView {
  userContext?: Input_reverb_event_UserContext | null; 
  listings?: (Input_reverb_event_Listing | null)[] | null; 
  requestId?: string | null; 
}

export interface Input_reverb_event_ArticleView {
  userContext?: Input_reverb_event_UserContext | null; 
  articleId?: string | null; 
  requestId?: string | null; 
  referer?: string | null; 
  url?: string | null; 
  aid?: string | null; 
  utmCampaign?: string | null; 
}

export interface Input_reverb_event_ArticleViewRelatedContent {
  userContext?: Input_reverb_event_UserContext | null; 
  articleViewArticleId?: string | null; 
  type?: string | null; 
  url?: string | null; 
  referer?: string | null; 
  articles?: (Input_reverb_event_Article | null)[] | null; 
}

export interface Input_reverb_event_PageView {
  userContext?: Input_reverb_event_UserContext | null; 
  referer?: string | null; 
  url?: string | null; 
  aid?: string | null; 
  utmCampaign?: string | null; 
  controller?: string | null; 
  action?: string | null; 
  remoteAddress?: string | null; 
  requestId?: string | null; 
  params?: string | null; 
  method?: string | null; 
  viewRuntime?: number | null; 
  dbRuntime?: number | null; 
  status?: string | null; 
  duration?: number | null; 
  customHeaders?: string | null; 
  oauthAppId?: string | null; 
  devTeam?: string | null; 
  pageExperiments?: string | null; 
  id?: string | null; 
  sku?: string | null; 
  paramsId?: string | null; 
  threadId?: string | null; 
  utmSource?: string | null; 
  utmMedium?: string | null; 
  urlRegion?: string | null; 
}

export interface Input_reverb_event_CheckoutView {
  userContext?: Input_reverb_event_UserContext | null; 
  paymentMethod?: string | null; 
  stepName?: string | null; 
  referer?: string | null; 
  checkoutId?: string | null; 
  checkoutUuid?: string | null; 
}

export interface Input_reverb_event_ComparisonShoppingPagesView {
  comparisonShoppingPages?: (Input_reverb_event_ComparisonShoppingPage | null)[] | null; 
  userContext?: Input_reverb_event_UserContext | null; 
  url?: string | null; 
  referer?: string | null; 
  componentName?: string | null; 
}

export interface Input_reverb_event_ScreenView {
  userContext?: Input_reverb_event_UserContext | null; 
  referer?: string | null; 
  screenName?: string | null; 
  context?: string | null; 
}

export interface Input_reverb_event_BrowserFingerprint {
  hash?: string | null; 
  liedLanguages?: boolean | null; 
  liedResolution?: boolean | null; 
  liedOs?: boolean | null; 
  liedBrowser?: boolean | null; 
  plugins?: number | null; 
  resolution?: string | null; 
  session?: boolean | null; 
  localstorage?: boolean | null; 
}

export interface Input_reverb_event_JsLoad {
  app?: string | null; 
  userContext?: Input_reverb_event_UserContext | null; 
  fingerprint?: Input_reverb_event_BrowserFingerprint | null; 
}

export interface Input_core_apimessages_PublicShopAddress {
  region?: string | null; 
  locality?: string | null; 
  countryCode?: string | null; 
  displayLocation?: string | null; 
  country?: Input_core_apimessages_Country | null; 
}

export interface Input_core_apimessages_AdyenPaymentResult {
  paymentStatus?: core_apimessages_AdyenPaymentResult_PaymentStatus | null; 
  paymentData?: string | null; 
  fingerprintToken?: string | null; 
  challengeToken?: string | null; 
  action?: string | null; 
  threeDsOneRedirectUrl?: string | null; 
  threeDsOneData?: Input_core_apimessages_ThreeDSOneData | null; 
}

export interface Input_core_apimessages_ThreeDSOneData {
  paReq?: string | null; 
  md?: string | null; 
  termUrl?: string | null; 
  redirectUrl?: string | null; 
}

export interface Input_core_apimessages_KYCVerificationCheck {
  verificationType?: string | null; 
  status?: string | null; 
  reverbStatus?: string | null; 
  codes?: (Input_core_apimessages_KYCVerificationCode | null)[] | null; 
  actionRequired?: boolean | null; 
  action?: core_apimessages_KYCAction | null; 
  errorDescription?: string | null; 
}

export interface Input_core_apimessages_KYCVerificationCode {
  code?: string | null; 
}

export interface Input_core_apimessages_KYCAccountDetails {
  bankAccountOwnerName?: string | null; 
  maskedBankAccountNumber?: string | null; 
  bankAccountCountryCode?: string | null; 
  bankAccountCurrencyCode?: string | null; 
  bankAccountOwnerAddress?: Input_core_apimessages_KYCAddress | null; 
  personalInformation?: (Input_core_apimessages_PersonalInformation | null)[] | null; 
  businessTaxId?: string | null; 
  legalBusinessName?: string | null; 
  accountPhoneNumber?: Input_core_apimessages_AdyenPhoneNumber | null; 
  businessRegistrationNumber?: string | null; 
  accountHolderAddress?: Input_core_apimessages_KYCAddress | null; 
  legalEntity?: core_apimessages_AdyenLegalEntity | null; 
  parentCompanyDetails?: Input_core_apimessages_AdyenParentCompanyDetails | null; 
}

export interface Input_core_apimessages_AdyenPhoneNumber {
  phoneNumber?: string | null; 
  countryCode?: string | null; 
}

export interface Input_core_apimessages_ChannelBranding {
  name?: string | null; 
  logoImageUrl?: string | null; 
  completeUrl?: string | null; 
  channel?: core_apimessages_Channel | null; 
  shopIdentifier?: string | null; 
  abandonUrl?: string | null; 
}

export interface Input_core_apimessages_LocalizationSettings {
  locale?: string | null; 
  currency?: string | null; 
  shippingRegion?: string | null; 
}

export interface Input_core_apimessages_CheckoutCartItem {
  listingId?: string | null; 
  quantity?: number | null; 
}

export interface Input_core_apimessages_GoogleShoppingClick {
  listingId?: string | null; 
  comparisonShoppingPageId?: string | null; 
  timestamp?: string | null; 
  origin?: string | null; 
  expiration?: string | null; 
}

export interface Input_core_apimessages_Error {
  message?: string | null; 
  field?: string | null; 
  context?: string | null; 
  errorType?: string | null; 
}

export interface Input_core_apimessages_ErrorResponse {
  errors?: (Input_core_apimessages_Error | null)[] | null; 
}

export interface Input_core_apimessages_LegacyTimestamp {
  seconds?: number | null; 
  nanos?: number | null; 
}

export interface Input_core_apimessages_ArticleCategories {
  categories?: (Input_core_apimessages_ArticleCategory | null)[] | null; 
}

export interface Input_core_apimessages_ArticleCategory {
  id?: string | null; 
  name?: string | null; 
  slug?: string | null; 
}

export interface Input_core_apimessages_Article {
  id?: string | null; 
  title?: string | null; 
  webLink?: Input_core_apimessages_Link | null; 
  articleCategories?: (Input_core_apimessages_ArticleCategory | null)[] | null; 
  slug?: string | null; 
}

export interface Input_core_apimessages_Auction {
  id?: string | null; 
  endAt?: Input_core_apimessages_LegacyTimestamp | null; 
  startAt?: Input_core_apimessages_LegacyTimestamp | null; 
  minBid?: Input_core_apimessages_Money | null; 
  listingId?: string | null; 
  relistIfUnsold?: boolean | null; 
}

export interface Input_core_apimessages_Bid {
  id?: string | null; 
  price?: Input_core_apimessages_Money | null; 
  obfuscatedUserName?: string | null; 
  createdAt?: Input_core_apimessages_LegacyTimestamp | null; 
}

export interface Input_core_apimessages_Brand {
  id?: string | null; 
  name?: string | null; 
  webLink?: Input_core_apimessages_Link | null; 
  slug?: string | null; 
}

export interface Input_core_apimessages_BumpKeyContents {
  jti?: string | null; 
  iat?: number | null; 
  userId?: string | null; 
  sessionId?: string | null; 
  cookieId?: string | null; 
  productId?: string | null; 
  source?: core_apimessages_BumpKeyContents_OffsiteSource | null; 
}

export interface Input_core_apimessages_ShippingPrices {
  shippingPrices?: (Input_core_apimessages_ShippingPrice | null)[] | null; 
  localPickup?: boolean | null; 
  freeExpeditedShipping?: boolean | null; 
  localPickupOnly?: boolean | null; 
  shippingRegionCode?: string | null; 
  shippingAddress?: Input_core_apimessages_Address | null; 
}

export interface Input_core_apimessages_ShippingPrice {
  shippingMethod?: core_apimessages_ShippingMethod | null; 
  rate?: Input_core_apimessages_Money | null; 
  originalRate?: Input_core_apimessages_Money | null; 
  shippingRegionCode?: string | null; 
  carrierCalculated?: boolean | null; 
  destinationPostalCodeNeeded?: boolean | null; 
  regional?: boolean | null; 
}

export interface Input_core_apimessages_FlatRateShippingOption {
  carrier?: string | null; 
  displayTitle?: string | null; 
  displayName?: string | null; 
  optionValue?: string | null; 
  displayDimensions?: string | null; 
  maximumPounds?: number | null; 
  displayPosition?: number | null; 
}

export interface Input_core_apimessages_CreditCard_Brand {
  type?: core_apimessages_CreditCard_Brand_Type | null; 
  name?: string | null; 
}

export interface Input_core_apimessages_CreditCard_Display {
  summary?: string | null; 
  expirationDate?: string | null; 
}

export interface Input_core_apimessages_CreditCard {
  id?: string | null; 
  last4?: string | null; 
  cardType?: string | null; 
  expirationMonth?: string | null; 
  expirationYear?: string | null; 
  cardholderName?: string | null; 
  cardSource?: string | null; 
  primaryBilling?: boolean | null; 
  address?: Input_core_apimessages_Address | null; 
  needsReverification?: boolean | null; 
  primaryForCheckout?: boolean | null; 
  brand?: Input_core_apimessages_CreditCard_Brand | null; 
  display?: Input_core_apimessages_CreditCard_Display | null; 
}

export interface Input_core_apimessages_CreateMyCreditCardResponse {
  creditCard?: Input_core_apimessages_CreditCard | null; 
}

export interface Input_core_apimessages_UpdateMyCreditCardResponse {
  creditCard?: Input_core_apimessages_CreditCard | null; 
}

export interface Input_core_apimessages_DeleteMyCreditCardResponse {
  id?: string | null; 
}

export interface Input_core_apimessages_CartItem {
  uuid?: string | null; 
  listingId?: string | null; 
  orderId?: string | null; 
  subtotal?: Input_core_apimessages_Money | null; 
  shopId?: string | null; 
  quantity?: number | null; 
}

export interface Input_core_apimessages_CheckoutAction {
  type?: core_apimessages_CheckoutAction_Type | null; 
  redirectUrl?: string | null; 
}

export interface Input_core_apimessages_Checkout {
  id?: string | null; 
  checkoutBundlingId?: string | null; 
  paymentMethod?: Input_core_apimessages_CheckoutPaymentMethod | null; 
  shippingAddress?: Input_core_apimessages_Address | null; 
  billingAddress?: Input_core_apimessages_Address | null; 
  orders?: (Input_core_apimessages_CheckoutOrder | null)[] | null; 
  lineItems?: (Input_core_apimessages_CheckoutLineItem | null)[] | null; 
  status?: core_apimessages_Checkout_Status | null; 
  paymentErrorMessage?: string | null; 
  type?: core_apimessages_Checkout_Type | null; 
  creditCard?: Input_core_apimessages_CreditCard | null; 
  guest?: Input_core_apimessages_CheckoutGuest | null; 
  adyenPaymentAction?: string | null; 
}

export interface Input_core_apimessages_CheckoutPaymentMethod {
  type?: core_apimessages_CheckoutPaymentMethod_Type | null; 
  name?: string | null; 
  isComplete?: boolean | null; 
  supportsDiscountCodes?: boolean | null; 
}

export interface Input_core_apimessages_CheckoutOrder {
  id?: string | null; 
  listingId?: string | null; 
  subtotal?: Input_core_apimessages_CheckoutOrder_Subtotal | null; 
  shippingTotal?: Input_core_apimessages_CheckoutOrder_ShippingTotal | null; 
  taxIncluded?: boolean | null; 
  taxLabel?: string | null; 
  shippingMethod?: Input_core_apimessages_CheckoutShippingMethod | null; 
  quantity?: number | null; 
  buyerCanChangeQuantity?: boolean | null; 
  cannotBeShippedToAddress?: boolean | null; 
  availableShippingMethods?: (Input_core_apimessages_CheckoutShippingMethod | null)[] | null; 
}

export interface Input_core_apimessages_CheckoutOrder_Subtotal {
  listingPrice?: Input_core_apimessages_Money | null; 
  discounted?: boolean | null; 
  discount?: Input_core_apimessages_CheckoutOrder_SubtotalDiscount | null; 
}

export interface Input_core_apimessages_CheckoutOrder_SubtotalDiscount {
  type?: core_apimessages_CheckoutOrder_SubtotalDiscount_Type | null; 
  label?: string | null; 
}

export interface Input_core_apimessages_CheckoutOrder_ShippingTotal {
  originalAmountOwed?: Input_core_apimessages_Money | null; 
  amountOwed?: Input_core_apimessages_Money | null; 
  discounted?: boolean | null; 
  discount?: Input_core_apimessages_CheckoutOrder_ShippingTotalDiscount | null; 
}

export interface Input_core_apimessages_CheckoutOrder_ShippingTotalDiscount {
  type?: core_apimessages_CheckoutOrder_ShippingTotalDiscount_Type | null; 
  label?: string | null; 
}

export interface Input_core_apimessages_CheckoutShippingMethod {
  type?: core_apimessages_ShippingMethod | null; 
  name?: string | null; 
  description?: string | null; 
  amount?: Input_core_apimessages_Money | null; 
}

export interface Input_core_apimessages_CheckoutLineItem {
  type?: core_apimessages_CheckoutLineItem_Type | null; 
  label?: string | null; 
  amount?: Input_core_apimessages_Money | null; 
}

export interface Input_core_apimessages_CheckoutGuest {
  firstName?: string | null; 
  lastName?: string | null; 
  email?: string | null; 
  isComplete?: boolean | null; 
}

export interface Input_core_apimessages_CheckoutCreateResponse {
  id?: string | null; 
}

export interface Input_core_apimessages_CheckoutShowRequest {
  id?: string | null; 
}

export interface Input_core_apimessages_CheckoutShowResponse {
  checkout?: Input_core_apimessages_Checkout | null; 
}

export interface Input_core_apimessages_CheckoutUpdateShippingAddressResponse {
  id?: string | null; 
}

export interface Input_core_apimessages_CheckoutSelectShippingAddressResponse {
  id?: string | null; 
}

export interface Input_core_apimessages_CheckoutCreatePaymentRedirectUrlResponse {
  id?: string | null; 
  redirectUrl?: string | null; 
}

export interface Input_core_apimessages_StartCheckoutForListingResponse {
  redirectUrl?: string | null; 
  checkoutId?: string | null; 
}

export interface Input_core_apimessages_ApplyCheckoutDiscountCodeResponse {
  id?: string | null; 
}

export interface Input_core_apimessages_SelectCheckoutCreditCardResponse {
  id?: string | null; 
}

export interface Input_core_apimessages_UpdateCheckoutGuestCreditCardResponse {
  id?: string | null; 
}

export interface Input_core_apimessages_CheckoutUpdateGuestContactInfoRequest {
  id?: string | null; 
  guest?: Input_core_apimessages_GuestCheckoutUserEntry | null; 
}

export interface Input_core_apimessages_CheckoutUpdateGuestContactInfoResponse {
  id?: string | null; 
}

export interface Input_core_apimessages_SelectCheckoutPaymentMethodResponse {
  id?: string | null; 
}

export interface Input_core_apimessages_CheckoutFinalizeRedirectPaymentCheckoutResponse {
  id?: string | null; 
}

export interface Input_core_apimessages_CheckoutFinalizeDigitalWalletPaymentResponse {
  id?: string | null; 
}

export interface Input_core_apimessages_CheckoutFinalizeDirectCheckoutPaymentResponse {
  id?: string | null; 
}

export interface Input_core_apimessages_CheckoutCartEditResponse {
  listingId?: string | null; 
}

export interface Input_core_apimessages_CheckoutUpdateShippingEstimateResponse {
  id?: string | null; 
}

export interface Input_core_apimessages_CheckoutSelectOrderShippingMethodResponse {
  id?: string | null; 
}

export interface Input_core_apimessages_CheckoutActionRequest {
  checkoutId?: string | null; 
  reverbApp?: string | null; 
}

export interface Input_core_apimessages_CheckoutActionResponse {
  action?: Input_core_apimessages_CheckoutAction | null; 
}

export interface Input_core_apimessages_CollectionHeader {
  id?: string | null; 
  title?: string | null; 
  description?: string | null; 
  metaTitle?: string | null; 
  metaDescription?: string | null; 
  collectionType?: core_apimessages_CollectionHeader_CollectionType | null; 
  collectionId?: string | null; 
}

export interface Input_core_apimessages_UserBadgeLinks {
  web?: Input_core_apimessages_Link | null; 
}

export interface Input_core_apimessages_UserNotificationLinks {
  web?: Input_core_apimessages_Link | null; 
}

export interface Input_core_apimessages_UserBadge {
  count?: number | null; 
  displayText?: string | null; 
  Links?: Input_core_apimessages_UserBadgeLinks | null; 
  badgeLinks?: Input_core_apimessages_UserBadgeLinks | null; 
}

export interface Input_core_apimessages_UserNotification {
  notificationType?: core_apimessages_UserNotificationType | null; 
  title?: string | null; 
  description?: string | null; 
  notificationLinks?: Input_core_apimessages_UserNotificationLinks | null; 
  key?: core_apimessages_UserNotification_UserNotificationKey | null; 
}

export interface Input_core_apimessages_CountsLinks {
  self?: Input_core_apimessages_Link | null; 
}

export interface Input_core_apimessages_CountsTotal {
  count?: number | null; 
}

export interface Input_core_apimessages_CountsResponse {
  Links?: Input_core_apimessages_CountsLinks | null; 
  total?: Input_core_apimessages_CountsTotal | null; 
  activeCartItemTotal?: Input_core_apimessages_UserBadge | null; 
  activeOffers?: Input_core_apimessages_UserBadge | null; 
  billingProfile?: Input_core_apimessages_UserBadge | null; 
  buyerActiveOffers?: Input_core_apimessages_UserBadge | null; 
  invoicedStatementCount?: Input_core_apimessages_UserBadge | null; 
  layawayOrders?: Input_core_apimessages_UserBadge | null; 
  outstandingFeedback?: Input_core_apimessages_UserBadge | null; 
  sellerActiveOffers?: Input_core_apimessages_UserBadge | null; 
  sellerOrdersAwaitingShipment?: Input_core_apimessages_UserBadge | null; 
  sellerOrdersRefundRequested?: Input_core_apimessages_UserBadge | null; 
  unpaidOrders?: Input_core_apimessages_UserBadge | null; 
  unreadMessages?: Input_core_apimessages_UserBadge | null; 
  sellerOrdersAwaitingPickup?: Input_core_apimessages_UserBadge | null; 
  buyerOrdersAwaitingPickup?: Input_core_apimessages_UserBadge | null; 
  countsLinks?: Input_core_apimessages_CountsLinks | null; 
  userNotifications?: (Input_core_apimessages_UserNotification | null)[] | null; 
}

export interface Input_core_apimessages_Image {
  source?: string | null; 
  itemId?: string | null; 
  itemType?: string | null; 
  publicId?: string | null; 
  version?: string | null; 
  id?: string | null; 
  fallbackType?: core_apimessages_Image_FallbackType | null; 
  transformation?: Input_core_apimessages_ImageEntry_Transformation | null; 
  width?: number | null; 
  height?: number | null; 
}

export interface Input_core_apimessages_AutomatchingCanonicalProduct {
  id?: string | null; 
  model?: string | null; 
  year?: string | null; 
  finish?: string | null; 
  upc?: string | null; 
  brand?: Input_core_apimessages_Brand | null; 
  primaryImage?: Input_core_apimessages_Image | null; 
}

export interface Input_core_apimessages_CPSuggestions {
  suggestions?: (Input_core_apimessages_CPSuggestion | null)[] | null; 
}

export interface Input_core_apimessages_CPSuggestion {
  canonicalProductId?: string | null; 
  service?: string | null; 
  confidence?: number | null; 
  canonicalProduct?: Input_core_apimessages_AutomatchingCanonicalProduct | null; 
}

export interface Input_core_apimessages_VideoLink {
  youtubeVideoId?: string | null; 
  youtubeLink?: string | null; 
}

export interface Input_core_apimessages_ProductSpec {
  name?: string | null; 
  value?: string | null; 
  path?: string | null; 
  type?: core_apimessages_ProductSpec_Type | null; 
  slug?: string | null; 
}

export interface Input_core_apimessages_CspVariant {
  id?: string | null; 
  name?: string | null; 
  model?: string | null; 
  year?: string | null; 
  finish?: string | null; 
  countryOfOrigin?: string | null; 
}

export interface Input_core_apimessages_CSP {
  id?: string | null; 
  title?: string | null; 
  summary?: string | null; 
  webLink?: Input_core_apimessages_Link | null; 
  newListingsLink?: Input_core_apimessages_Link | null; 
  usedListingsLink?: Input_core_apimessages_Link | null; 
  uuid?: string | null; 
  brandUuid?: string | null; 
  categoryUuids?: (string | null)[] | null; 
  slug?: string | null; 
  metaDescription?: string | null; 
  body?: string | null; 
  model?: string | null; 
  canonicalProductIds?: (string | null)[] | null; 
  upcs?: (string | null)[] | null; 
  finishes?: (string | null)[] | null; 
  generic?: boolean | null; 
  categoryRootUuid?: string | null; 
}

export interface Input_core_apimessages_CSPInventory {
  id?: string | null; 
  usedTotal?: number | null; 
  newTotal?: number | null; 
  newLowPrice?: Input_core_apimessages_Money | null; 
  usedLowPrice?: Input_core_apimessages_Money | null; 
  uuid?: string | null; 
  slug?: string | null; 
}

export interface Input_core_apimessages_CSPVideo {
  videoLinks?: (Input_core_apimessages_VideoLink | null)[] | null; 
}

export interface Input_core_apimessages_CSPSpec {
  productSpecs?: (Input_core_apimessages_ProductSpec | null)[] | null; 
}

export interface Input_core_apimessages_CSPPricing {
  low?: Input_core_apimessages_Money | null; 
  mid?: Input_core_apimessages_Money | null; 
  high?: Input_core_apimessages_Money | null; 
  hasData?: boolean | null; 
}

export interface Input_core_apimessages_CSPReviews {
  reviews?: (Input_core_apimessages_CSPReview | null)[] | null; 
  offset?: number | null; 
  limit?: number | null; 
  total?: number | null; 
  avgRating?: number | null; 
  myReview?: Input_core_apimessages_CSPReview | null; 
}

export interface Input_core_apimessages_CSPReview {
  id?: string | null; 
  body?: string | null; 
  createdAt?: string | null; 
  title?: string | null; 
  rating?: number | null; 
  voteCount?: number | null; 
  reviewer?: Input_core_apimessages_Reviewer | null; 
  verified?: boolean | null; 
  blocked?: boolean | null; 
  isMyReview?: boolean | null; 
  didIVote?: boolean | null; 
}

export interface Input_core_apimessages_Reviewer {
  shortname?: string | null; 
  links?: Input_core_apimessages_ReviewerLinks | null; 
}

export interface Input_core_apimessages_ReviewerLinks {
  avatar?: Input_core_apimessages_Link | null; 
}

export interface Input_core_apimessages_CSPExpressSaleItemBid {
  cspUuid?: string | null; 
  estimatedPayout?: Input_core_apimessages_Money | null; 
  carrier?: string | null; 
  bidId?: string | null; 
  shopName?: string | null; 
}

export interface Input_core_apimessages_CuratedSet {
  id?: string | null; 
  title?: string | null; 
  webLink?: Input_core_apimessages_Link | null; 
  slug?: string | null; 
  setType?: string | null; 
}

export interface Input_core_apimessages_CuratedSetMembership {
  id?: string | null; 
  curatedSetId?: string | null; 
  productId?: string | null; 
}

export interface Input_core_apimessages_ExpressSaleCheckout {
  checkoutId?: string | null; 
  cspId?: string | null; 
  status?: core_apimessages_ExpressSaleCheckout_Status | null; 
  expressSaleItemBid?: Input_core_apimessages_CSPExpressSaleItemBid | null; 
}

export interface Input_core_apimessages_ExpressSaleCheckoutShowRequest {
  checkoutId?: string | null; 
}

export interface Input_core_apimessages_ExpressSaleCheckoutShowResponse {
  expressSaleCheckout?: Input_core_apimessages_ExpressSaleCheckout | null; 
}

export interface Input_core_apimessages_CreateExpressSaleCheckoutResponse {
  checkoutId?: string | null; 
}

export interface Input_core_apimessages_CompleteExpressSaleCheckoutResponse {
  orderId?: string | null; 
}

export interface Input_core_apimessages_FollowGroup {
  calloutLinkText?: string | null; 
  description?: string | null; 
  follows?: (Input_core_apimessages_Follow | null)[] | null; 
  title?: string | null; 
  Links?: Input_core_apimessages_FollowGroupLinks | null; 
}

export interface Input_core_apimessages_Follow {
  following?: boolean | null; 
  header?: string | null; 
  savedSearchType?: string | null; 
  subtitle?: string | null; 
  title?: string | null; 
  Links?: Input_core_apimessages_FollowLinks | null; 
  alert?: Input_core_apimessages_FollowAlert | null; 
  id?: string | null; 
  queryParams?: string | null; 
  followedSubcategories?: (string | null)[] | null; 
}

export interface Input_core_apimessages_FollowLinks {
  self?: Input_core_apimessages_Link | null; 
  alert?: Input_core_apimessages_Link | null; 
  remove?: Input_core_apimessages_Link | null; 
  search?: Input_core_apimessages_Link | null; 
}

export interface Input_core_apimessages_FollowAlert {
  type?: string | null; 
}

export interface Input_core_apimessages_FollowGroupLinks {
  callout?: Input_core_apimessages_Link | null; 
}

export interface Input_core_apimessages_Followers {
  count?: number | null; 
  display?: string | null; 
}

export interface Input_core_apimessages_FollowQueryParams {
  category?: string | null; 
  categoryUuid?: string | null; 
  condition?: (string | null)[] | null; 
  countryOfOrigin?: string | null; 
  cpIds?: (number | null)[] | null; 
  curatedSetId?: number | null; 
  curatedSearchId?: number | null; 
  currency?: string | null; 
  decade?: string | null; 
  finish?: string | null; 
  handmade?: string | null; 
  itemCity?: string | null; 
  itemRegion?: string | null; 
  itemCountry?: string | null; 
  itemState?: string | null; 
  make?: (string | null)[] | null; 
  model?: string | null; 
  priceMax?: string | null; 
  priceMin?: string | null; 
  productType?: string | null; 
  productTypeUuid?: string | null; 
  query?: string | null; 
  yearMax?: string | null; 
  yearMin?: string | null; 
  shopId?: number | null; 
  acceptsGiftCards?: boolean | null; 
  preferredSeller?: boolean | null; 
  listingType?: string | null; 
  shipsTo?: string | null; 
  acceptsPaymentPlans?: boolean | null; 
  freeShipping?: boolean | null; 
  personalProfile?: string | null; 
  freeExpeditedShipping?: boolean | null; 
  zeroPercentFinancing?: boolean | null; 
  decades?: (string | null)[] | null; 
}

export interface Input_core_apimessages_Condition {
  conditionUuid?: string | null; 
  displayName?: string | null; 
  conditionSlug?: string | null; 
  description?: string | null; 
}

export interface Input_core_apimessages_GearCollectionItem {
  id?: string | null; 
  deleted?: boolean | null; 
  title?: string | null; 
  make?: string | null; 
  model?: string | null; 
  finish?: string | null; 
  year?: string | null; 
  price?: Input_core_apimessages_Money | null; 
  description?: string | null; 
  notes?: string | null; 
  canonicalProductId?: string | null; 
  ownerCost?: Input_core_apimessages_Money | null; 
  serialNumber?: string | null; 
  created?: boolean | null; 
  updated?: boolean | null; 
  condition?: Input_core_apimessages_Condition | null; 
  tags?: (Input_core_apimessages_GearCollectionItemTag | null)[] | null; 
  hideListingPhotos?: boolean | null; 
  hideListingDescription?: boolean | null; 
  seedId?: string | null; 
  seedType?: core_apimessages_GearCollectionItem_SeedType | null; 
}

export interface Input_google_protobuf_DoubleValue {
  value?: number | null; 
}

export interface Input_google_protobuf_FloatValue {
  value?: number | null; 
}

export interface Input_google_protobuf_Int64Value {
  value?: number | null; 
}

export interface Input_google_protobuf_UInt64Value {
  value?: number | null; 
}

export interface Input_google_protobuf_Int32Value {
  value?: number | null; 
}

export interface Input_google_protobuf_UInt32Value {
  value?: number | null; 
}

export interface Input_google_protobuf_StringValue {
  value?: string | null; 
}

export interface Input_google_protobuf_BytesValue {
  value?: string | null; 
}

export interface Input_core_apimessages_ShippingRatesForShippingProfile {
  shippingProfileId?: string | null; 
  shippingRates?: (Input_core_apimessages_ShippingRates | null)[] | null; 
}

export interface Input_core_apimessages_ShippingProfile {
  localPickup?: boolean | null; 
  categoryUuids?: (string | null)[] | null; 
  shippingRates?: Input_core_apimessages_ShippingRates | null; 
  name?: string | null; 
  id?: string | null; 
}

export interface Input_core_apimessages_MyShippingProfile {
  id?: string | null; 
  name?: string | null; 
  categoryUuids?: (string | null)[] | null; 
  localPickup?: boolean | null; 
  offersIncrementalRates?: boolean | null; 
}

export interface Input_core_apimessages_ShopShippingProfiles {
  shopUuid?: string | null; 
  shippingProfiles?: (Input_core_apimessages_ShippingProfile | null)[] | null; 
}

export interface Input_core_apimessages_Shipment {
  toAddress?: Input_core_apimessages_Address | null; 
  fromAddress?: Input_core_apimessages_Address | null; 
  package?: Input_core_apimessages_ShippingLabelPackage | null; 
  shippingProtection?: boolean | null; 
  signatureRequired?: boolean | null; 
  mediaMailQualified?: boolean | null; 
  defaultPaymentMethod?: core_apimessages_FeePaymentMethod | null; 
  carrierRates?: (Input_core_apimessages_CarrierRateGroup | null)[] | null; 
  shippingMethod?: core_apimessages_ShippingMethod | null; 
  id?: string | null; 
  orderUuids?: (string | null)[] | null; 
  shippingProtectionPrice?: Input_core_apimessages_Money | null; 
  toAddressIsResidential?: boolean | null; 
}

export interface Input_core_apimessages_CarrierRateGroup {
  displayPosition?: number | null; 
  carrier?: string | null; 
  rates?: (Input_core_apimessages_CarrierRate | null)[] | null; 
}

export interface Input_core_apimessages_CarrierRate {
  displayPosition?: number | null; 
  uuid?: string | null; 
  carrier?: string | null; 
  service?: string | null; 
  description?: string | null; 
  paymentMethod?: core_apimessages_FeePaymentMethod | null; 
  rackRateAmount?: Input_core_apimessages_Money | null; 
  shippingProtectionAmount?: Input_core_apimessages_Money | null; 
  reverbDiscountAmount?: Input_core_apimessages_Money | null; 
  totalAmount?: Input_core_apimessages_Money | null; 
  signatureRequiredAmount?: Input_core_apimessages_Money | null; 
}

export interface Input_core_apimessages_SignatureRequiredCost {
  carrier?: string | null; 
  amount?: Input_core_apimessages_Money | null; 
}

export interface Input_core_apimessages_PreorderInfo {
  id?: string | null; 
  estimatedShipDate?: Input_core_apimessages_LegacyTimestamp | null; 
  onPreorder?: boolean | null; 
  leadTimeDays?: number | null; 
  shipDate?: Input_core_apimessages_LegacyTimestamp | null; 
}

export interface Input_core_apimessages_Listing {
  id?: string | null; 
  title?: string | null; 
  merchandisingUuid?: string | null; 
  price?: Input_core_apimessages_Money | null; 
  shopId?: string | null; 
  sellerId?: string | null; 
  sellerUuid?: string | null; 
  hasInventory?: boolean | null; 
  inventory?: number | null; 
  shopUuid?: string | null; 
  categoryUuids?: (string | null)[] | null; 
  state?: string | null; 
  condition?: Input_core_apimessages_Condition | null; 
  slug?: string | null; 
  listingType?: core_apimessages_Listing_ListingType | null; 
  publishedAt?: Input_core_apimessages_LegacyTimestamp | null; 
  description?: string | null; 
  merchandisingType?: string | null; 
  countryOfOrigin?: string | null; 
  finish?: string | null; 
  make?: string | null; 
  model?: string | null; 
  productTypeId?: string | null; 
  year?: string | null; 
  canonicalProductId?: string | null; 
  seedId?: string | null; 
  seedType?: core_apimessages_Listing_SeedType | null; 
  sku?: string | null; 
  stateDescription?: string | null; 
  taxIncluded?: boolean | null; 
  priceGuideUuid?: string | null; 
  cspUuid?: string | null; 
  currentAuctionId?: string | null; 
  salePrice?: Input_core_apimessages_Money | null; 
  categoryRootUuid?: string | null; 
  taxIncludedHint?: string | null; 
  bumped?: boolean | null; 
  upc?: string | null; 
  exclusiveChannel?: string | null; 
  brandSlug?: string | null; 
  soldAsIs?: boolean | null; 
  bumpEligible?: boolean | null; 
  propSixtyFiveWarning?: string | null; 
  propSixtyFiveWarningImg?: Input_core_apimessages_Link | null; 
  maxBuyerQuantity?: number | null; 
  currency?: string | null; 
  cspId?: string | null; 
  allowedBuyerQuantity?: number | null; 
  sameDayShippingIneligible?: boolean | null; 
  overriddenAttributes?: (string | null)[] | null; 
}

export interface Input_core_apimessages_SellerListing {
  sellerCost?: Input_core_apimessages_Money | null; 
  storageLocation?: string | null; 
  sellerPrice?: Input_core_apimessages_Money | null; 
  handmade?: boolean | null; 
  upcDoesNotApply?: boolean | null; 
  localizedContents?: (Input_core_apimessages_LocalizedListingContent | null)[] | null; 
  shippingProfileId?: string | null; 
  prefersReverbShippingLabel?: boolean | null; 
  taxExempt?: boolean | null; 
}

export interface Input_core_apimessages_ListingCounts {
  id?: string | null; 
  views?: number | null; 
  watchers?: number | null; 
  offers?: number | null; 
}

export interface Input_core_apimessages_ListingInCartCount {
  count?: Input_google_protobuf_Int32Value | null; 
}

export interface Input_core_apimessages_Ribbon {
  display?: string | null; 
  reason?: core_apimessages_Ribbon_Reason | null; 
}

export interface Input_core_apimessages_ListingPricing {
  id?: string | null; 
  buyerPrice?: Input_core_apimessages_Money | null; 
  originalPrice?: Input_core_apimessages_Money | null; 
  ribbon?: Input_core_apimessages_Ribbon | null; 
}

export interface Input_core_apimessages_ListingCuratedSet {
  id?: string | null; 
  slug?: string | null; 
  uuid?: string | null; 
  featuredInSet?: boolean | null; 
  name?: string | null; 
  setType?: string | null; 
}

export interface Input_core_apimessages_CuratedSetsForListing {
  id?: string | null; 
  curatedSets?: (Input_core_apimessages_ListingCuratedSet | null)[] | null; 
}

export interface Input_core_apimessages_ListingSpec {
  productSpecs?: (Input_core_apimessages_ProductSpec | null)[] | null; 
}

export interface Input_core_apimessages_MyUpdatesPromotion {
  id?: string | null; 
  title?: string | null; 
  subtitle?: string | null; 
  url?: Input_core_apimessages_Link | null; 
  startsAt?: Timestamp | null; 
}

export interface Input_google_protobuf_Duration {
  seconds?: number | null; 
  nanos?: number | null; 
}

export interface Input_core_apimessages_LayawayTerms {
  name?: string | null; 
  percentDown?: number | null; 
  timePeriod?: Input_google_protobuf_Duration | null; 
}

export interface Input_core_apimessages_Negotiation {
  id?: string | null; 
  state?: core_apimessages_NegotiationState | null; 
  buyerUuid?: string | null; 
  sellerUuid?: string | null; 
  expiresAt?: Input_core_apimessages_LegacyTimestamp | null; 
  orderUuids?: (string | null)[] | null; 
  lastOffer?: Input_core_apimessages_Offer | null; 
  taxIncluded?: boolean | null; 
  taxIncludedHint?: string | null; 
  buyerOutsideListingShippingRegions?: boolean | null; 
  negotiationType?: core_apimessages_NegotiationType | null; 
  sellerShippingWarning?: string | null; 
}

export interface Input_core_apimessages_Offer {
  offerItems?: (Input_core_apimessages_OfferItem | null)[] | null; 
  message?: string | null; 
  prices?: Input_core_apimessages_OfferPrices | null; 
  createdAt?: Input_core_apimessages_LegacyTimestamp | null; 
  initiatingParty?: core_apimessages_NegotiationParty | null; 
  status?: core_apimessages_Offer_OfferStatus | null; 
  shippingMethod?: core_apimessages_ShippingMethod | null; 
  layawayTerms?: Input_core_apimessages_LayawayTerms | null; 
}

export interface Input_core_apimessages_OfferItem {
  listingId?: string | null; 
  prices?: Input_core_apimessages_OfferPrices | null; 
  quantity?: number | null; 
}

export interface Input_core_apimessages_OfferPrices {
  price?: Input_core_apimessages_ConvertedMoney | null; 
  shippingPrice?: Input_core_apimessages_ConvertedMoney | null; 
  totalPrice?: Input_core_apimessages_ConvertedMoney | null; 
}

export interface Input_core_apimessages_NegotiationOffers {
  offers?: (Input_core_apimessages_Offer | null)[] | null; 
}

export interface Input_core_apimessages_Feedback_Response {
  body?: string | null; 
  createdAt?: Input_core_apimessages_LegacyTimestamp | null; 
}

export interface Input_core_apimessages_Feedback {
  authorUuid?: string | null; 
  orderTitle?: string | null; 
  rating?: number | null; 
  createdAt?: Input_core_apimessages_LegacyTimestamp | null; 
  message?: string | null; 
  type?: core_apimessages_Feedback_Type | null; 
  recipientUuid?: string | null; 
  response?: Input_core_apimessages_Feedback_Response | null; 
  shippingSatisfactory?: Input_google_protobuf_BoolValue | null; 
  conditionSatisfactory?: Input_google_protobuf_BoolValue | null; 
  listingLink?: Input_core_apimessages_Link | null; 
}

export interface Input_core_apimessages_FeedbackSummary {
  userId?: string | null; 
  receivedCount?: number | null; 
  rollingRatingPercentage?: number | null; 
}

export interface Input_core_apimessages_OrderNote {
  id?: string | null; 
  body?: string | null; 
  orderId?: string | null; 
  createdAt?: Input_core_apimessages_LegacyTimestamp | null; 
}

export interface Input_core_apimessages_Order {
  uuid?: string | null; 
  buyerUuid?: string | null; 
  shopUuid?: string | null; 
  listingId?: string | null; 
  status?: core_apimessages_Order_Status | null; 
  shippingMethod?: core_apimessages_ShippingMethod | null; 
  sellerUuid?: string | null; 
  checkoutUuid?: string | null; 
  legacyOrderId?: string | null; 
  createdAt?: Input_core_apimessages_LegacyTimestamp | null; 
  settlementAmountProductSubtotal?: Input_core_apimessages_Money | null; 
  quantity?: number | null; 
  legacyBuyerId?: string | null; 
  paidAt?: Input_core_apimessages_LegacyTimestamp | null; 
  updatedAt?: Input_core_apimessages_LegacyTimestamp | null; 
  shippedAt?: Input_core_apimessages_LegacyTimestamp | null; 
  needsFeedbackForBuyer?: boolean | null; 
  needsFeedbackForSeller?: boolean | null; 
  orderType?: string | null; 
  shippingProvider?: string | null; 
  shippingCode?: string | null; 
  amountProduct?: Input_core_apimessages_Money | null; 
  amountTotal?: Input_core_apimessages_Money | null; 
  amountTax?: Input_core_apimessages_Money | null; 
  amountShipping?: Input_core_apimessages_Money | null; 
  statusDescription?: string | null; 
  webTrackingUrl?: string | null; 
  shipmentStatus?: string | null; 
  orderUrl?: Input_core_apimessages_Link | null; 
  mobileStatus?: string | null; 
  carrierCalculatedShippingAmount?: Input_core_apimessages_Money | null; 
}

export interface Input_core_apimessages_OrderCustomsInfo {
  tariffNumber?: string | null; 
  categoryName?: string | null; 
  description?: string | null; 
  countryOfOrigin?: string | null; 
}

export interface Input_core_apimessages_OrderFeedbacks {
  orderUuid?: string | null; 
  feedbacks?: (Input_core_apimessages_Feedback | null)[] | null; 
}

export interface Input_core_apimessages_BuyerOrder {
  uuid?: string | null; 
  amountOwed?: Input_core_apimessages_Money | null; 
  amountCreditBucks?: Input_core_apimessages_Money | null; 
  amountBonusBucks?: Input_core_apimessages_Money | null; 
  buyerActions?: Input_core_apimessages_BuyerActions | null; 
  amountProduct?: Input_core_apimessages_Money | null; 
  amountProductSubtotal?: Input_core_apimessages_Money | null; 
  amountTotal?: Input_core_apimessages_Money | null; 
  amountTax?: Input_core_apimessages_Money | null; 
  amountShipping?: Input_core_apimessages_Money | null; 
}

export interface Input_core_apimessages_BuyerActions {
  canBeResold?: boolean | null; 
  canMarkReceived?: boolean | null; 
}

export interface Input_core_apimessages_OrderPayments {
  payments?: (Input_core_apimessages_Payment | null)[] | null; 
}

export interface Input_core_apimessages_Payment {
  paymentMethod?: core_apimessages_Payment_PaymentMethod | null; 
  paymentStatus?: core_apimessages_Payment_PaymentStatus | null; 
  amount?: Input_core_apimessages_Money | null; 
}

export interface Input_core_apimessages_SellerOrder {
  uuid?: string | null; 
  shippingLabel?: Input_core_apimessages_OrderShippingLabel | null; 
  packingSlip?: Input_core_apimessages_OrderPackingSlip | null; 
  taxResponsibleParty?: core_apimessages_SellerOrder_TaxResponsibleParty | null; 
}

export interface Input_core_apimessages_OrderShippingLabel {
  shippingLabelWebUrl?: string | null; 
  purchaseShippingLabelWebUrl?: string | null; 
}

export interface Input_core_apimessages_OrderPackingSlip {
  packingSlipWebUrl?: string | null; 
}

export interface Input_core_apimessages_OrderNotes {
  notes?: (Input_core_apimessages_OrderNote | null)[] | null; 
}

export interface Input_core_apimessages_OrderRefundRequests {
  refundRequests?: (Input_core_apimessages_RefundRequest | null)[] | null; 
}

export interface Input_core_apimessages_RefundRequest {
  amount?: Input_core_apimessages_Money | null; 
  type?: core_apimessages_RefundRequest_RefundType | null; 
  state?: core_apimessages_RefundRequest_RefundState | null; 
  createdAt?: Input_core_apimessages_LegacyTimestamp | null; 
  updatedAt?: Input_core_apimessages_LegacyTimestamp | null; 
  id?: string | null; 
  markItemReturnedWebUrl?: string | null; 
  respondToRequestWebUrl?: string | null; 
}

export interface Input_core_apimessages_OrderRefunds {
  refundableState?: core_apimessages_OrderRefunds_RefundableState | null; 
  refundRequests?: (Input_core_apimessages_RefundRequest | null)[] | null; 
  completedRefunds?: (Input_core_apimessages_Refund | null)[] | null; 
}

export interface Input_core_apimessages_Refund {
  id?: string | null; 
  amount?: Input_core_apimessages_ConvertedMoney | null; 
  createdAt?: Input_core_apimessages_LegacyTimestamp | null; 
  updatedAt?: Input_core_apimessages_LegacyTimestamp | null; 
  noteToBuyer?: string | null; 
}

export interface Input_core_apimessages_BuyerRefund {
  id?: string | null; 
  nonBucksRefundAmount?: Input_core_apimessages_ConvertedMoney | null; 
  reverbBucksAmountRefunded?: Input_core_apimessages_Money | null; 
}

export interface Input_core_apimessages_PublicPriceRecord {
  uuid?: string | null; 
  listingId?: string | null; 
  createdAt?: Input_core_apimessages_LegacyTimestamp | null; 
  settlementAmountProductSubtotal?: Input_core_apimessages_Money | null; 
  orderType?: string | null; 
  amountProduct?: Input_core_apimessages_Money | null; 
  amountTotal?: Input_core_apimessages_Money | null; 
  amountTax?: Input_core_apimessages_Money | null; 
  amountShipping?: Input_core_apimessages_Money | null; 
  condition?: Input_core_apimessages_Condition | null; 
}

export interface Input_core_apimessages_OrderBundle {
  amountTotal?: Input_core_apimessages_Money | null; 
  amountProductSubtotal?: Input_core_apimessages_Money | null; 
  amountShipping?: Input_core_apimessages_Money | null; 
  amountCredit?: Input_core_apimessages_Money | null; 
  amountTax?: Input_core_apimessages_Money | null; 
  bonusBucks?: Input_core_apimessages_Money | null; 
  paymentMethod?: core_apimessages_Payment_PaymentMethod | null; 
  uuid?: string | null; 
  localPickup?: boolean | null; 
  id?: string | null; 
}

export interface Input_core_apimessages_PacklinkAccount {
  id?: string | null; 
  email?: string | null; 
  status?: core_apimessages_PacklinkAccount_Status | null; 
}

export interface Input_core_apimessages_PacklinkShipment {
  id?: string | null; 
  orderId?: string | null; 
  packlinkAccountId?: string | null; 
  reference?: string | null; 
  status?: core_apimessages_PacklinkShipment_Status | null; 
}

export interface Input_core_apimessages_CreateMyPlaidLinkTokenResponse {
  linkToken?: string | null; 
}

export interface Input_core_apimessages_SaveMyPlaidAccountResponse {
  plaidAccountId?: string | null; 
}

export interface Input_core_apimessages_CancelPlaidAccountResponse {
  shopId?: string | null; 
}

export interface Input_core_apimessages_SearchFilterPreset {
  collectionId?: string | null; 
  collectionType?: string | null; 
  title?: string | null; 
  url?: string | null; 
  id?: string | null; 
}

export interface Input_core_apimessages_MyDirectCheckoutProfileResponse {
  nameOnAccount?: string | null; 
  maskedNameSummary?: string | null; 
  bankName?: string | null; 
  currency?: string | null; 
  countryCode?: string | null; 
  payoutMethod?: string | null; 
  hasAcceptedReverbBankTerms?: boolean | null; 
  profileErrors?: (string | null)[] | null; 
  plaidAccountId?: string | null; 
}

export interface Input_core_apimessages_EstimatedShipping {
  description?: string | null; 
  rates?: (Input_core_apimessages_ShippingRate | null)[] | null; 
}

export interface Input_core_apimessages_ShippingRate {
  displayName?: string | null; 
  price?: Input_core_apimessages_Money | null; 
}

export interface Input_core_apimessages_Storefront {
  channel?: string | null; 
  slug?: string | null; 
  name?: string | null; 
  shopUuid?: string | null; 
  id?: string | null; 
  description?: string | null; 
  shippingPolicy?: string | null; 
}

export interface Input_core_apimessages_ShippingRegionSetting {
  regionCode?: string | null; 
  regionName?: string | null; 
  isDomestic?: boolean | null; 
  allowedToShipCarrierCalculated?: boolean | null; 
}

export interface Input_core_apimessages_Shop_OfferPolicy {
  autoRejectLowOffers?: boolean | null; 
  lowballPercentage?: number | null; 
}

export interface Input_core_apimessages_Shop {
  uuid?: string | null; 
  name?: string | null; 
  slug?: string | null; 
  currency?: string | null; 
  originCountryCode?: string | null; 
  shopType?: core_apimessages_Shop_ShopType | null; 
  paymentPolicy?: string | null; 
  shippingPolicy?: string | null; 
  id?: string | null; 
  preferredSeller?: boolean | null; 
  quickShipper?: boolean | null; 
  quickResponder?: boolean | null; 
  userUuid?: string | null; 
  onVacation?: boolean | null; 
  description?: string | null; 
  userId?: string | null; 
  website?: string | null; 
  showSold?: boolean | null; 
  vatId?: string | null; 
  recentlyShipped?: boolean | null; 
  quickShipperSpeed?: core_apimessages_Shop_QuickShipperSpeed | null; 
  createdAt?: Timestamp | null; 
  defaultLocale?: string | null; 
  currencySetting?: string | null; 
  shippingRegionSettings?: (Input_core_apimessages_ShippingRegionSetting | null)[] | null; 
  sameDayShippingConfigured?: boolean | null; 
  listableConditions?: (Input_core_apimessages_Condition | null)[] | null; 
  offerPolicy?: Input_core_apimessages_Shop_OfferPolicy | null; 
  shopSupportedLocaleCodes?: (string | null)[] | null; 
}

export interface Input_core_apimessages_ShopReturnPolicy {
  shopUuid?: string | null; 
  returnPolicy?: Input_core_apimessages_ReturnPolicy | null; 
}

export interface Input_core_apimessages_ShopTaxPolicies {
  shopUuid?: string | null; 
  taxPolicies?: (Input_core_apimessages_ShopTaxPolicy | null)[] | null; 
}

export interface Input_core_apimessages_ShopTaxPolicy {
  policyType?: core_apimessages_ShopTaxPolicy_PolicyType | null; 
  displayLocation?: string | null; 
  displayRate?: string | null; 
  vatPolicy?: boolean | null; 
}

export interface Input_core_apimessages_User {
  uuid?: string | null; 
  name?: string | null; 
  shopUuid?: string | null; 
  id?: string | null; 
  firstName?: string | null; 
}

export interface Input_core_apimessages_Sale {
  id?: string | null; 
  slug?: string | null; 
  name?: string | null; 
  code?: string | null; 
  startsAt?: Input_core_apimessages_LegacyTimestamp | null; 
  endsAt?: Input_core_apimessages_LegacyTimestamp | null; 
  summary?: string | null; 
  state?: core_apimessages_Sale_SaleState | null; 
  display?: string | null; 
  withSalePriceDisplay?: string | null; 
  percent?: number | null; 
  buyerIneligibilityReason?: string | null; 
  saleType?: string | null; 
  showCode?: boolean | null; 
  shopSlug?: string | null; 
  shopName?: string | null; 
  links?: Input_core_apimessages_SaleLinks | null; 
}

export interface Input_core_apimessages_SaleLinks {
  self?: Input_core_apimessages_Link | null; 
}

export interface Input_core_apimessages_ContentSponsorship {
  sponsorshipType?: core_apimessages_ContentSponsorship_SponsorshipType | null; 
  partnershipName?: string | null; 
}

export interface Input_core_apimessages_SiteBanner {
  id?: string | null; 
  heading?: string | null; 
  subheading?: string | null; 
  callToAction?: string | null; 
  url?: Input_core_apimessages_Link | null; 
  mobileUrl?: Input_core_apimessages_Link | null; 
  mobileWebUrl?: Input_core_apimessages_Link | null; 
  imageUrl?: string | null; 
  webOnly?: boolean | null; 
  mobileImageUrl?: string | null; 
  startsAt?: Timestamp | null; 
  endsAt?: Timestamp | null; 
  contentSponsorship?: Input_core_apimessages_ContentSponsorship | null; 
  downtime?: boolean | null; 
  hasPhotos?: boolean | null; 
  showOnMobile?: boolean | null; 
  showOnMyUpdates?: boolean | null; 
}

export interface Input_core_apimessages_SellingFees {
  minFee?: Input_core_apimessages_Money | null; 
  maxFee?: Input_core_apimessages_Money | null; 
  sellingFeePercent?: string | null; 
  processingFees?: Input_core_apimessages_ProcessingFees | null; 
}

export interface Input_core_apimessages_ProcessingFees {
  percent?: string | null; 
  flatFee?: Input_core_apimessages_Money | null; 
}

export interface Input_core_apimessages_PriceGuide {
  id?: string | null; 
  title?: string | null; 
  webLink?: Input_core_apimessages_Link | null; 
  priceLow?: Input_core_apimessages_Money | null; 
  priceHigh?: Input_core_apimessages_Money | null; 
  uuid?: string | null; 
}

export interface Input_core_apimessages_ChatDepartment {
  id?: string | null; 
  tag?: string | null; 
}

export interface Input_core_apimessages_Alert {
  title?: string | null; 
  description?: string | null; 
  url?: string | null; 
}

export interface Input_core_apimessages_ReferAFriend {
  shareUrl?: string | null; 
  signUpBonus?: Input_core_apimessages_Money | null; 
  rewardAmount?: Input_core_apimessages_Money | null; 
  minOrderAmount?: Input_core_apimessages_Money | null; 
}

export interface Input_core_apimessages_AdPlacement {
  format?: core_apimessages_AdFormat | null; 
}

export interface Input_core_apimessages_AdPlacementResponse {
  ad?: Input_core_apimessages_Ad | null; 
  adZones?: (Input_core_apimessages_AdZone | null)[] | null; 
  candidates?: (Input_core_apimessages_Candidate | null)[] | null; 
}

export interface Input_core_apimessages_Candidate {
  adGroup?: Input_core_apimessages_AdGroup | null; 
  matches?: (string | null)[] | null; 
  weight?: number | null; 
}

export interface Input_core_apimessages_AdServeResponse {
  ad?: Input_core_apimessages_Ad | null; 
  placements?: (Input_core_apimessages_AdPlacementResponse | null)[] | null; 
}

export interface Input_core_apimessages_UpdateAdResponse {
  ad?: Input_core_apimessages_Ad | null; 
}

export interface Input_core_apimessages_DeleteAdResponse {
  ad?: Input_core_apimessages_Ad | null; 
}

export interface Input_core_apimessages_UpdateAdvertiserResponse {
  advertiser?: Input_core_apimessages_Advertiser | null; 
}

export interface Input_core_apimessages_UpdateAdGroupResponse {
  adGroup?: Input_core_apimessages_AdGroup | null; 
}

export interface Input_core_apimessages_CopyAdGroupResponse {
  adGroup?: Input_core_apimessages_AdGroup | null; 
}

export interface Input_core_apimessages_UpdateAdGroupKeywordsResponse {
  adGroupKeywords?: (Input_core_apimessages_AdGroupKeyword | null)[] | null; 
}

export interface Input_core_apimessages_AdGroupKeyword {
  id?: string | null; 
  keyword?: string | null; 
}

export interface Input_core_apimessages_UpdateAdZoneResponse {
  adZone?: Input_core_apimessages_AdZone | null; 
}

export interface Input_core_apimessages_UpdateAdCampaignResponse {
  adCampaign?: Input_core_apimessages_AdCampaign | null; 
}

export interface Input_core_apimessages_AdvertisersSearchResponse {
  resultUuids?: (string | null)[] | null; 
  offset?: number | null; 
  limit?: number | null; 
  total?: number | null; 
}

export interface Input_core_apimessages_AdCampaignsSearchResponse {
  resultUuids?: (string | null)[] | null; 
  offset?: number | null; 
  limit?: number | null; 
  total?: number | null; 
}

export interface Input_core_apimessages_AdGroupsSearchResponse {
  resultUuids?: (string | null)[] | null; 
  offset?: number | null; 
  limit?: number | null; 
  total?: number | null; 
}

export interface Input_core_apimessages_AdsSearchResponse {
  resultUuids?: (string | null)[] | null; 
  offset?: number | null; 
  limit?: number | null; 
  total?: number | null; 
}

export interface Input_core_apimessages_PriceChange {
  id?: string | null; 
  listingId?: string | null; 
  previousPrice?: Input_core_apimessages_Money | null; 
  newPrice?: Input_core_apimessages_Money | null; 
  currentPriceDropPercent?: number | null; 
  totalPriceDropPercent?: number | null; 
}

export interface Input_core_apimessages_UserService {
  id?: string | null; 
  email?: string | null; 
  provider?: core_apimessages_UserService_Provider | null; 
}

export interface Input_rql_MonitoringData {
  warn?: number | null; 
  timeout?: number | null; 
  owner?: string | null; 
}

export interface Input_google_protobuf_Empty {
  _?: boolean | null; 
}

export interface Input_arbiter_APIErrorResponse {
  errors?: (Input_arbiter_APIError | null)[] | null; 
}

export interface Input_arbiter_APIError {
  message?: string | null; 
}

export interface Input_arbiter_Listing {
  id?: string | null; 
}

export interface Input_arbiter_BumpedSortedListingsRequest {
  userShippingRegion?: string | null; 
  listingIds?: (string | null)[] | null; 
  condition?: string | null; 
  total?: number | null; 
  bumpedMax?: number | null; 
  itemRegion?: string | null; 
  auctionType?: arbiter_AuctionType | null; 
}

export interface Input_arbiter_BulkFeaturedListingRequest {
  requests?: (Input_arbiter_FeaturedListingRequest | null)[] | null; 
}

export interface Input_arbiter_BulkFeaturedListingResponse {
  responses?: (Input_arbiter_FeaturedListingResponse | null)[] | null; 
}

export interface Input_arbiter_FeaturedListingResponse {
  productId?: string | null; 
  bumped?: boolean | null; 
  rank?: number | null; 
  bid?: number | null; 
  qualityScore?: number | null; 
  runnerUp?: Input_arbiter_FeaturedListingResponse | null; 
}

export interface Input_arbiter_BumpedSortedListingsResponse {
  products?: (Input_arbiter_BumpedSortedListingResponseListing | null)[] | null; 
  resultIds?: (string | null)[] | null; 
}

export interface Input_arbiter_BumpedSortedListingResponseListing {
  productId?: string | null; 
  bumped?: boolean | null; 
  rank?: number | null; 
  bid?: number | null; 
  qualityScore?: number | null; 
  discountPercent?: number | null; 
}

export interface Input_arbiter_BulkTrackImpressionsResponse {
  listingIds?: (string | null)[] | null; 
}

export interface Input_arbiter_Interaction {
  uuid?: string | null; 
  userId?: string | null; 
  sessionId?: string | null; 
  cookieId?: string | null; 
  productId?: string | null; 
  bumpRate?: string | null; 
  referrerUrl?: string | null; 
  sellerId?: string | null; 
  componentName?: string | null; 
  position?: number | null; 
  issuedAt?: Timestamp | null; 
  createdAt?: Timestamp | null; 
  interactionType?: arbiter_Interaction_InteractionType | null; 
  offsiteSource?: string | null; 
  currentUrl?: string | null; 
  userExperimentsJson?: string | null; 
  userDeviceName?: string | null; 
}

export interface Input_arbiter_CreateInteractionRequest {
  interaction?: Input_arbiter_Interaction | null; 
}

export interface Input_arbiter_FindInteractionRequest {
  productId?: string | null; 
  userId?: string | null; 
  cookieId?: string | null; 
  orderedAt?: Timestamp | null; 
}

export interface Input_arbiter_FindInteractionResponse {
  interaction?: Input_arbiter_Interaction | null; 
}

export interface Input_arbiter_InteractionTimeSeriesMetric {
  date?: string | null; 
  click?: number | null; 
  addToWatchlist?: number | null; 
  addToCart?: number | null; 
  makeAnOffer?: number | null; 
  total?: number | null; 
  messageSeller?: number | null; 
}

export interface Input_arbiter_SellerInteractionTimeSeriesResponse {
  data?: (Input_arbiter_InteractionTimeSeriesMetric | null)[] | null; 
  click?: number | null; 
  addToWatchlist?: number | null; 
  addToCart?: number | null; 
  makeAnOffer?: number | null; 
  total?: number | null; 
  messageSeller?: number | null; 
}

export interface Input_arbiter_BumpInteractionCountsRequest {
  sellerId?: string | null; 
  listingId?: string | null; 
}

export interface Input_arbiter_BumpInteractionCountsResponse {
  listingId?: string | null; 
  click?: number | null; 
  addToWatchlist?: number | null; 
  addToCart?: number | null; 
  makeAnOffer?: number | null; 
  total?: number | null; 
  messageSeller?: number | null; 
}

export interface Input_arbiter_BulkBumpInteractionCountsRequest {
  requests?: (Input_arbiter_BumpInteractionCountsRequest | null)[] | null; 
}

export interface Input_arbiter_BulkBumpInteractionCountsResponse {
  responses?: (Input_arbiter_BumpInteractionCountsResponse | null)[] | null; 
}

export interface Input_core_apimessages_TaxIdentification {
  id?: string | null; 
  taxId?: string | null; 
  status?: core_apimessages_TaxIdentification_Status | null; 
  taxType?: core_apimessages_TaxIdentification_TaxType | null; 
  countryCode?: string | null; 
  active?: boolean | null; 
}

export interface Input_core_apimessages_NodeRequest_Lookup_Params_Images {
  transform?: core_apimessages_NamedImageTransforms | null; 
  scope?: core_apimessages_Image_Scope | null; 
  limit?: number | null; 
}

export interface Input_core_apimessages_NodeRequest_Lookup_Params_Sales {
  all?: boolean | null; 
}

export interface Input_core_apimessages_NodeRequest_Lookup_Params {
  images?: Input_core_apimessages_NodeRequest_Lookup_Params_Images | null; 
  sales?: Input_core_apimessages_NodeRequest_Lookup_Params_Sales | null; 
  shippingRates?: Input_core_apimessages_NodeRequest_Lookup_Params_ShippingRates | null; 
}

export interface Input_core_apimessages_NodeRequest_Lookup {
  lid?: string | null; 
  rel?: string | null; 
  params?: Input_core_apimessages_NodeRequest_Lookup_Params | null; 
}

export interface Input_core_apimessages_NodeRequest {
  lookups?: (Input_core_apimessages_NodeRequest_Lookup | null)[] | null; 
  debug?: boolean | null; 
}

export interface Input_core_apimessages_NodeResponse_Result_Meta {
  total?: number | null; 
}

export interface Input_core_apimessages_NodeResponse_Result {
  lookup?: Input_core_apimessages_NodeRequest_Lookup | null; 
  meta?: Input_core_apimessages_NodeResponse_Result_Meta | null; 
  listings?: (Input_core_apimessages_Listing | null)[] | null; 
  csps?: (Input_core_apimessages_CSP | null)[] | null; 
  images?: (Input_core_apimessages_Image | null)[] | null; 
  listingsPricings?: (Input_core_apimessages_ListingPricing | null)[] | null; 
  orders?: (Input_core_apimessages_Order | null)[] | null; 
  sales?: (Input_core_apimessages_Sale | null)[] | null; 
  curatedSets?: (Input_core_apimessages_CuratedSet | null)[] | null; 
  packlinkShipments?: (Input_core_apimessages_PacklinkShipment | null)[] | null; 
  shippingRates?: (Input_core_apimessages_ShippingRates | null)[] | null; 
  bumpRates?: (Input_core_apimessages_BumpRate | null)[] | null; 
  cspVariants?: (Input_core_apimessages_CspVariant | null)[] | null; 
  categories?: (Input_core_apimessages_NodesCategory | null)[] | null; 
  gearCollectionItems?: (Input_core_apimessages_GearCollectionItem | null)[] | null; 
  priceGuides?: (Input_core_apimessages_PriceGuide | null)[] | null; 
  cartItems?: (Input_core_apimessages_CartItem | null)[] | null; 
  adyenCheckoutPaymentMethods?: (Input_core_apimessages_AdyenCheckoutPaymentMethods | null)[] | null; 
  taxIdentifications?: (Input_core_apimessages_TaxIdentification | null)[] | null; 
  priceChanges?: (Input_core_apimessages_PriceChange | null)[] | null; 
  adCampaigns?: (Input_core_apimessages_AdCampaign | null)[] | null; 
  advertisers?: (Input_core_apimessages_Advertiser | null)[] | null; 
  adGroups?: (Input_core_apimessages_AdGroup | null)[] | null; 
  adGroupKeywords?: (Input_core_apimessages_AdGroupKeyword | null)[] | null; 
  ads?: (Input_core_apimessages_Ad | null)[] | null; 
  siteBanners?: (Input_core_apimessages_SiteBanner | null)[] | null; 
  shops?: (Input_core_apimessages_Shop | null)[] | null; 
  myUpdatesPromotions?: (Input_core_apimessages_MyUpdatesPromotion | null)[] | null; 
  adZones?: (Input_core_apimessages_AdZone | null)[] | null; 
  listingsSignals?: (Input_core_apimessages_ListingSignals | null)[] | null; 
  universalPromoCampaigns?: (Input_core_apimessages_UniversalPromoCampaign | null)[] | null; 
  shipmentPackages?: (Input_core_apimessages_ShippingLabelPackage | null)[] | null; 
  cspExpressSaleItemBids?: (Input_core_apimessages_CSPExpressSaleItemBid | null)[] | null; 
  orderBundles?: (Input_core_apimessages_OrderBundle | null)[] | null; 
  publicPriceRecords?: (Input_core_apimessages_PublicPriceRecord | null)[] | null; 
  nonUserExperiments?: (Input_core_apimessages_NonUserExperiment | null)[] | null; 
  users?: (Input_core_apimessages_User | null)[] | null; 
  addresses?: (Input_core_apimessages_Address | null)[] | null; 
}

export interface Input_core_apimessages_BumpRate {
  rate?: number | null; 
}

export interface Input_core_apimessages_AdyenCheckoutPaymentMethods {
  adyenCheckoutPaymentMethodsConfig?: string | null; 
}

export interface Input_core_apimessages_ListingSignals {
  id?: string | null; 
  onSaleSignal?: Input_core_apimessages_OnSaleSignal | null; 
  paymentPlanSignal?: Input_core_apimessages_PaymentPlanSignal | null; 
  priceDropSignal?: Input_core_apimessages_PriceDropSignal | null; 
  lowStockSignal?: Input_core_apimessages_LowStockSignal | null; 
  predictedToSellSoonSignal?: Input_core_apimessages_PredictedToSellSoonSignal | null; 
  greatValueSignal?: Input_core_apimessages_GreatValueSignal | null; 
  sharedSignalData?: Input_core_apimessages_SharedSignalData | null; 
  returnPolicySignal?: Input_core_apimessages_ReturnPolicySignal | null; 
  buyWithConfidenceSignal?: Input_core_apimessages_BuyWithConfidenceSignal | null; 
  secureCheckoutSignal?: Input_core_apimessages_SecureCheckoutSignal | null; 
  priceRecommendationData?: Input_core_apimessages_PriceRecommendationData | null; 
  availableNearbyForPickupSignal?: Input_core_apimessages_AvailableNearbyForPickupSignal | null; 
  expeditedShippingAvailableSignal?: Input_core_apimessages_ExpeditedShippingAvailableSignal | null; 
  freeExpeditedShippingSignal?: Input_core_apimessages_FreeExpeditedShippingSignal | null; 
  freeStandardShippingSignal?: Input_core_apimessages_FreeStandardShippingSignal | null; 
  newListingSignal?: Input_core_apimessages_NewListingSignal | null; 
  shipsSoonSignal?: Input_core_apimessages_ShipsSoonSignal | null; 
  availableForPickupSignal?: Input_core_apimessages_AvailableForPickupSignal | null; 
  localPickupOnlySignal?: Input_core_apimessages_LocalPickupOnlySignal | null; 
  inOtherCartsSignal?: Input_core_apimessages_InOtherCartsSignal | null; 
}

export interface Input_core_apimessages_OnSaleSignal {
  isValid?: boolean | null; 
  translations?: Input_core_apimessages_SignalTranslation | null; 
  link?: Input_core_apimessages_SignalLink | null; 
}

export interface Input_core_apimessages_SignalTranslation {
  title?: string | null; 
  subtitle?: string | null; 
  tooltipText?: string | null; 
}

export interface Input_core_apimessages_SignalLink {
  url?: string | null; 
  text?: string | null; 
}

export interface Input_core_apimessages_PaymentPlanSignal {
  isValid?: boolean | null; 
  translations?: Input_core_apimessages_SignalTranslation | null; 
}

export interface Input_core_apimessages_PriceDropSignal {
  isValid?: boolean | null; 
  translations?: Input_core_apimessages_SignalTranslation | null; 
}

export interface Input_core_apimessages_LowStockSignal {
  isValid?: boolean | null; 
  translations?: Input_core_apimessages_SignalTranslation | null; 
}

export interface Input_core_apimessages_PredictedToSellSoonSignal {
  isValid?: boolean | null; 
  translations?: Input_core_apimessages_SignalTranslation | null; 
}

export interface Input_core_apimessages_GreatValueSignal {
  translations?: Input_core_apimessages_SignalTranslation | null; 
  isUsaBrandNew?: boolean | null; 
}

export interface Input_core_apimessages_SharedSignalData {
  buyerPrice?: Input_core_apimessages_Money | null; 
  originalPrice?: Input_core_apimessages_Money | null; 
  sellerLocationDisplay?: string | null; 
}

export interface Input_core_apimessages_ReturnPolicySignal {
  isValid?: boolean | null; 
  translations?: Input_core_apimessages_SignalTranslation | null; 
  link?: Input_core_apimessages_SignalLink | null; 
}

export interface Input_core_apimessages_BuyWithConfidenceSignal {
  isValid?: boolean | null; 
  translations?: Input_core_apimessages_SignalTranslation | null; 
  link?: Input_core_apimessages_SignalLink | null; 
}

export interface Input_core_apimessages_SecureCheckoutSignal {
  isValid?: boolean | null; 
  translations?: Input_core_apimessages_SignalTranslation | null; 
}

export interface Input_core_apimessages_PriceRecommendationData {
  eligibleForPriceRecommendation?: boolean | null; 
  listingConditionUuid?: string | null; 
  canonicalProductId?: number | null; 
}

export interface Input_core_apimessages_AvailableNearbyForPickupSignal {
  translations?: Input_core_apimessages_SignalTranslation | null; 
}

export interface Input_core_apimessages_ExpeditedShippingAvailableSignal {
  translations?: Input_core_apimessages_SignalTranslation | null; 
}

export interface Input_core_apimessages_FreeExpeditedShippingSignal {
  translations?: Input_core_apimessages_SignalTranslation | null; 
}

export interface Input_core_apimessages_FreeStandardShippingSignal {
  translations?: Input_core_apimessages_SignalTranslation | null; 
  freeShippingThresholdRequirementsMet?: boolean | null; 
}

export interface Input_core_apimessages_NewListingSignal {
  translations?: Input_core_apimessages_SignalTranslation | null; 
  isValid?: boolean | null; 
}

export interface Input_core_apimessages_ShipsSoonSignal {
  translations?: Input_core_apimessages_SignalTranslation | null; 
  isValid?: boolean | null; 
}

export interface Input_core_apimessages_AvailableForPickupSignal {
  translations?: Input_core_apimessages_SignalTranslation | null; 
  isValid?: boolean | null; 
}

export interface Input_core_apimessages_LocalPickupOnlySignal {
  translations?: Input_core_apimessages_SignalTranslation | null; 
  isValid?: boolean | null; 
}

export interface Input_core_apimessages_InOtherCartsSignal {
  isValid?: boolean | null; 
  translations?: Input_core_apimessages_SignalTranslation | null; 
}

export interface Input_core_apimessages_NonUserExperiment {
  name?: string | null; 
  bucket?: string | null; 
}

export interface Input_core_apimessages_NodeResponse {
  results?: (Input_core_apimessages_NodeResponse_Result | null)[] | null; 
}

export interface Input_core_apimessages_MeResponse {
  id?: string | null; 
  uuid?: string | null; 
  shopUuid?: string | null; 
  admin?: boolean | null; 
  status?: core_apimessages_UserStatus | null; 
  shopId?: string | null; 
  shopSlug?: string | null; 
  requireOptIn?: boolean | null; 
  profileSlug?: string | null; 
}

export interface Input_core_apimessages_BrandManagerBrandsResponse {
  brandManagerBrands?: (Input_core_apimessages_Brand | null)[] | null; 
  offset?: number | null; 
  limit?: number | null; 
}

export interface Input_core_apimessages_BrandManagerBrandResponse {
  brand?: Input_core_apimessages_Brand | null; 
}

export interface Input_core_apimessages_CountriesResponse {
  countries?: (Input_core_apimessages_Country | null)[] | null; 
}

export interface Input_core_apimessages_CSPsVideoRequest {
  ids?: (string | null)[] | null; 
  slugs?: (string | null)[] | null; 
  uuids?: (string | null)[] | null; 
}

export interface Input_core_apimessages_CSPsVideoResponse {
  videos?: (Input_core_apimessages_CSPVideo | null)[] | null; 
}

export interface Input_core_apimessages_CSPsRequest {
  ids?: (string | null)[] | null; 
  slugs?: (string | null)[] | null; 
  uuids?: (string | null)[] | null; 
}

export interface Input_core_apimessages_CSPsResponse {
  csps?: (Input_core_apimessages_CSP | null)[] | null; 
}

export interface Input_core_apimessages_CSPsInventoryRequest {
  ids?: (string | null)[] | null; 
  uuids?: (string | null)[] | null; 
  slugs?: (string | null)[] | null; 
}

export interface Input_core_apimessages_CSPsInventoryResponse {
  inventories?: (Input_core_apimessages_CSPInventory | null)[] | null; 
}

export interface Input_core_apimessages_CSPsFeaturedListingRequest {
  ids?: (string | null)[] | null; 
  uuids?: (string | null)[] | null; 
  slugs?: (string | null)[] | null; 
}

export interface Input_core_apimessages_CSPsFeaturedListingResponse {
  featuredListingIds?: (string | null)[] | null; 
}

export interface Input_core_apimessages_CSPsSpecsRequest {
  ids?: (string | null)[] | null; 
  slugs?: (string | null)[] | null; 
  uuids?: (string | null)[] | null; 
}

export interface Input_core_apimessages_CSPsSpecsResponse {
  specs?: (Input_core_apimessages_CSPSpec | null)[] | null; 
}

export interface Input_core_apimessages_CuratedSetsRequest {
  ids?: (string | null)[] | null; 
  slugs?: (string | null)[] | null; 
}

export interface Input_core_apimessages_CuratedSetsResponse {
  curatedSets?: (Input_core_apimessages_CuratedSet | null)[] | null; 
}

export interface Input_core_apimessages_FindFollowResponse {
  following?: boolean | null; 
  followers?: Input_core_apimessages_Followers | null; 
  Links?: Input_core_apimessages_FollowLinks | null; 
  follow?: Input_core_apimessages_Follow | null; 
  display?: string | null; 
  header?: string | null; 
  savedSearchType?: string | null; 
  subtitle?: string | null; 
  title?: string | null; 
  alert?: Input_core_apimessages_FollowAlert | null; 
  id?: string | null; 
  queryParams?: string | null; 
  followedSubcategories?: (string | null)[] | null; 
  hidden?: boolean | null; 
}

export interface Input_core_apimessages_ImagesResponse {
  images?: (Input_core_apimessages_ItemImages | null)[] | null; 
}

export interface Input_core_apimessages_ItemImages {
  id?: string | null; 
  images?: (Input_core_apimessages_Image | null)[] | null; 
}

export interface Input_core_apimessages_ImageRequest {
  id?: string | null; 
  uuid?: string | null; 
  slug?: string | null; 
  type?: string | null; 
  transform?: string | null; 
  scope?: string | null; 
  limit?: number | null; 
  namedTransform?: core_apimessages_NamedImageTransforms | null; 
}

export interface Input_core_apimessages_BulkImageRequest {
  requests?: (Input_core_apimessages_ImageRequest | null)[] | null; 
}

export interface Input_core_apimessages_OrderBundleShowResponse {
  orderBundle?: Input_core_apimessages_OrderBundle | null; 
}

export interface Input_core_apimessages_UpdateBankAccountRequest {
  bankDetails?: Input_core_apimessages_BankDetails | null; 
}

export interface Input_core_apimessages_UpdateBankAccountResponse {
  errors?: (Input_core_apimessages_Error | null)[] | null; 
}

export interface Input_core_apimessages_UpdateCompanyRequest {
  companyInformation?: Input_core_apimessages_CompanyInformation | null; 
  personalInformation?: (Input_core_apimessages_PersonalInformation | null)[] | null; 
  accountHolderAddress?: Input_core_apimessages_KYCAddress | null; 
}

export interface Input_core_apimessages_UpdateCompanyResponse {
  errors?: (Input_core_apimessages_Error | null)[] | null; 
}

export interface Input_core_apimessages_MyShopOrderRefundStatsResponse {
  sellerInitiatedRefundCount?: number | null; 
}

export interface Input_core_apimessages_MyShopShippingRatesRequest {
  shippingProfileIds?: (string | null)[] | null; 
}

export interface Input_core_apimessages_MyShopShippingRatesResponse {
  shippingRatesForShippingProfiles?: (Input_core_apimessages_ShippingRatesForShippingProfile | null)[] | null; 
}

export interface Input_core_apimessages_MyShopShippingProfilesRequest {
  _?: boolean | null; 
}

export interface Input_core_apimessages_MyShopShippingProfilesResponse {
  shippingProfiles?: (Input_core_apimessages_MyShippingProfile | null)[] | null; 
}

export interface Input_core_apimessages_UpdateMyShopShippingProfilesResponse {
  shippingProfiles?: (Input_core_apimessages_UpdateMyShippingProfile | null)[] | null; 
}

export interface Input_core_apimessages_UpdateOwnerInformationRequest {
  personalInformation?: (Input_core_apimessages_PersonalInformation | null)[] | null; 
}

export interface Input_core_apimessages_UpdateOwnerInformationResponse {
  errors?: (Input_core_apimessages_Error | null)[] | null; 
}

export interface Input_core_apimessages_ListingsRequest {
  Aid?: string | null; 
  utmCompaign?: string | null; 
  ids?: (string | null)[] | null; 
}

export interface Input_core_apimessages_ListingsResponse {
  listings?: (Input_core_apimessages_Listing | null)[] | null; 
}

export interface Input_core_apimessages_SellerListingsResponse {
  listings?: (Input_core_apimessages_SellerListing | null)[] | null; 
}

export interface Input_core_apimessages_ListingsPricingResponse {
  listings?: (Input_core_apimessages_ListingPricing | null)[] | null; 
}

export interface Input_core_apimessages_ListingsPricingRequest {
  ids?: (string | null)[] | null; 
}

export interface Input_core_apimessages_ListingsSignalsRequest {
  ids?: (string | null)[] | null; 
}

export interface Input_core_apimessages_ListingsSignalsResponse {
  listingsSignals?: (Input_core_apimessages_ListingSignals | null)[] | null; 
}

export interface Input_core_apimessages_ListingsSpecsRequest {
  ids?: (string | null)[] | null; 
}

export interface Input_core_apimessages_ListingsSpecsResponse {
  specs?: (Input_core_apimessages_ListingSpec | null)[] | null; 
}

export interface Input_core_apimessages_ListingCountsRequest {
  ids?: (string | null)[] | null; 
}

export interface Input_core_apimessages_ListingCountsResponse {
  listings?: (Input_core_apimessages_ListingCounts | null)[] | null; 
}

export interface Input_core_apimessages_ShippingPricesResponse {
  prices?: (Input_core_apimessages_Money | null)[] | null; 
  shippingPrices?: (Input_core_apimessages_ShippingPrices | null)[] | null; 
}

export interface Input_core_apimessages_CreateKYCRequest {
  bankDetails?: Input_core_apimessages_BankDetails | null; 
  personalInformation?: (Input_core_apimessages_PersonalInformation | null)[] | null; 
  companyInformation?: Input_core_apimessages_CompanyInformation | null; 
  legalEntity?: string | null; 
}

export interface Input_core_apimessages_CreateKYCResponse {
  errors?: (Input_core_apimessages_Error | null)[] | null; 
}

export interface Input_core_apimessages_SetupPaymentMethodsResponse {
  errors?: (Input_core_apimessages_Error | null)[] | null; 
}

export interface Input_core_apimessages_UpdateShopKYCResponse {
  errors?: (Input_core_apimessages_Error | null)[] | null; 
}

export interface Input_core_apimessages_UploadShopKYCCompanyRegistrationRequest {
  fileKey?: string | null; 
}

export interface Input_core_apimessages_UploadShopKYCCompanyRegistrationResponse {
  _?: boolean | null; 
}

export interface Input_core_apimessages_ProductReviewVoteResponse {
  _?: boolean | null; 
}

export interface Input_core_apimessages_CSPReviewsResponse {
  reviews?: (Input_core_apimessages_CSPReviews | null)[] | null; 
}

export interface Input_core_apimessages_ConvertShopTypeRequest {
  bankDetails?: Input_core_apimessages_BankDetails | null; 
  personalInformation?: (Input_core_apimessages_PersonalInformation | null)[] | null; 
  companyInformation?: Input_core_apimessages_CompanyInformation | null; 
}

export interface Input_core_apimessages_ConvertShopTypeResponse {
  errors?: (Input_core_apimessages_Error | null)[] | null; 
}

export interface Input_core_apimessages_KYCAccountDetailsResponse {
  accountDetails?: Input_core_apimessages_KYCAccountDetails | null; 
}

export interface Input_core_apimessages_CreateKYCPresignedS3UrlResponse {
  url?: string | null; 
  fileKey?: string | null; 
  headers?: string | null; 
}

export interface Input_core_apimessages_KYCBankAccountVerificationRequest {
  fileKey?: string | null; 
}

export interface Input_core_apimessages_KYCPhotoIDVerificationRequest {
  kycPhotoIdType?: core_apimessages_KYCPhotoIDType | null; 
  fileKeys?: (string | null)[] | null; 
}

export interface Input_core_apimessages_CreateBillingCardRequest {
  creditCardId?: string | null; 
  adyenToken?: string | null; 
  adyenCreditCard?: Input_core_apimessages_AdyenCreditCardEntry | null; 
  address?: Input_core_apimessages_AddressEntry | null; 
}

export interface Input_core_apimessages_EstimatedShippingRequest {
  weight?: number | null; 
  length?: number | null; 
  width?: number | null; 
  height?: number | null; 
  fromPostal?: string | null; 
  metric?: boolean | null; 
  toCountrycode?: string | null; 
  fromCountrycode?: string | null; 
}

export interface Input_core_apimessages_EstimateShippingResponse {
  estimatedShipping?: Input_core_apimessages_EstimatedShipping | null; 
}

export interface Input_core_apimessages_KYCVerificationChecksResponse {
  kycVerificationCheck?: (Input_core_apimessages_KYCVerificationCheck | null)[] | null; 
}

export interface Input_core_apimessages_CreateBillingCardResponse {
  creditCard?: Input_core_apimessages_CreditCard | null; 
}

export interface Input_core_apimessages_CuratedSetFeatureRequest {
  id?: string | null; 
  productId?: string | null; 
}

export interface Input_core_apimessages_ArticleCategoriesResponse {
  articleCategories?: Input_core_apimessages_ArticleCategories | null; 
}

export interface Input_core_apimessages_OrdersRequest {
  uuids?: (string | null)[] | null; 
  ids?: (string | null)[] | null; 
}

export interface Input_core_apimessages_OrdersResponse {
  orders?: (Input_core_apimessages_Order | null)[] | null; 
}

export interface Input_core_apimessages_OrderFeedbacksRequest {
  orderUuids?: (string | null)[] | null; 
  orderIds?: (string | null)[] | null; 
}

export interface Input_core_apimessages_OrderFeedbacksResponse {
  orderFeedbacks?: (Input_core_apimessages_OrderFeedbacks | null)[] | null; 
}

export interface Input_core_apimessages_OrderShippingAddressesRequest {
  orderUuids?: (string | null)[] | null; 
  orderIds?: (string | null)[] | null; 
}

export interface Input_core_apimessages_OrderShippingAddressesResponse {
  addresses?: (Input_core_apimessages_Address | null)[] | null; 
}

export interface Input_core_apimessages_BuyerOrdersResponse {
  orders?: (Input_core_apimessages_BuyerOrder | null)[] | null; 
}

export interface Input_core_apimessages_SellerOrdersResponse {
  orders?: (Input_core_apimessages_SellerOrder | null)[] | null; 
}

export interface Input_core_apimessages_CancelOrderResponse {
  order?: Input_core_apimessages_Order | null; 
  relisted?: boolean | null; 
}

export interface Input_core_apimessages_MyAddressesRequest {
  addressType?: core_apimessages_MyAddressType | null; 
}

export interface Input_core_apimessages_MyAddressesResponse {
  addresses?: (Input_core_apimessages_Address | null)[] | null; 
}

export interface Input_core_apimessages_UpdateAddressResponse {
  address?: Input_core_apimessages_Address | null; 
}

export interface Input_core_apimessages_OrderVerifyShippingAddressRequest {
  checkoutUuid?: string | null; 
  orderUuid?: string | null; 
}

export interface Input_core_apimessages_OrderVerifyShippingAddressResponse {
  address?: Input_core_apimessages_Address | null; 
  errorMessage?: string | null; 
  verificationStatus?: core_apimessages_AddressVerificationStatus | null; 
  isResidential?: boolean | null; 
}

export interface Input_core_apimessages_OrderFlatRateShippingOptionsRequest {
  checkoutUuid?: string | null; 
  orderUuid?: string | null; 
}

export interface Input_core_apimessages_OrderFlatRateShippingOptionsResponse {
  flatRateShippingOptions?: (Input_core_apimessages_FlatRateShippingOption | null)[] | null; 
}

export interface Input_core_apimessages_OrdersAddressRequest {
  uuids?: (string | null)[] | null; 
  addressType?: string | null; 
}

export interface Input_core_apimessages_OrdersAddressResponse {
  addresses?: (Input_core_apimessages_Address | null)[] | null; 
}

export interface Input_core_apimessages_OrdersCustomsInfoRequest {
  uuids?: (string | null)[] | null; 
  ids?: (string | null)[] | null; 
}

export interface Input_core_apimessages_OrdersCustomsInfoResponse {
  ordersCustomsInfo?: (Input_core_apimessages_OrderCustomsInfo | null)[] | null; 
}

export interface Input_core_apimessages_NegotiationsRequest {
  ids?: (string | null)[] | null; 
}

export interface Input_core_apimessages_NegotiationsResponse {
  negotiations?: (Input_core_apimessages_Negotiation | null)[] | null; 
}

export interface Input_core_apimessages_OffersRequest {
  ids?: (string | null)[] | null; 
}

export interface Input_core_apimessages_OffersResponse {
  offers?: (Input_core_apimessages_NegotiationOffers | null)[] | null; 
}

export interface Input_core_apimessages_NegotiationsShippingLocationRequest {
  ids?: (string | null)[] | null; 
}

export interface Input_core_apimessages_NegotiationsShippingLocationResponse {
  shippingLocations?: (Input_core_apimessages_Address | null)[] | null; 
}

export interface Input_core_apimessages_UpdateNegotiationResponse {
  negotiation?: Input_core_apimessages_Negotiation | null; 
}

export interface Input_core_apimessages_CreateAutoOfferResponse {
  autoOffer?: Input_core_apimessages_AutoOffer | null; 
}

export interface Input_core_apimessages_AutoOffer {
  id?: string | null; 
  listingId?: string | null; 
  message?: string | null; 
  price?: Input_core_apimessages_Money | null; 
  pushToExisting?: boolean | null; 
  percentage?: number | null; 
}

export interface Input_core_apimessages_AutoOffersRequest {
  listingIds?: (string | null)[] | null; 
}

export interface Input_core_apimessages_AutoOffersResponse {
  autoOffers?: (Input_core_apimessages_AutoOffer | null)[] | null; 
}

export interface Input_core_apimessages_DeleteAutoOfferResponse {
  autoOffer?: Input_core_apimessages_AutoOffer | null; 
}

export interface Input_core_apimessages_RedeemPromotionalCodeResponse {
  message?: string | null; 
}

export interface Input_core_apimessages_VerifyPromotionalCodeResponse {
  success?: boolean | null; 
  message?: string | null; 
}

export interface Input_core_apimessages_FeedCustomizationResponse {
  articleFollows?: (string | null)[] | null; 
  followGroups?: (Input_core_apimessages_FollowGroup | null)[] | null; 
  follows?: (Input_core_apimessages_Follow | null)[] | null; 
}

export interface Input_core_apimessages_ShopsResponse {
  shops?: (Input_core_apimessages_Shop | null)[] | null; 
}

export interface Input_core_apimessages_ArticlesRequest {
  ids?: (string | null)[] | null; 
  slugs?: (string | null)[] | null; 
}

export interface Input_core_apimessages_ArticlesResponse {
  articles?: (Input_core_apimessages_Article | null)[] | null; 
}

export interface Input_core_apimessages_SellingFeesResponse {
  fees?: Input_core_apimessages_SellingFees | null; 
}

export interface Input_core_apimessages_UsersRequest {
  uuids?: (string | null)[] | null; 
}

export interface Input_core_apimessages_UsersResponse {
  users?: (Input_core_apimessages_User | null)[] | null; 
}

export interface Input_core_apimessages_OrderNotesRequest {
  orderIds?: (string | null)[] | null; 
}

export interface Input_core_apimessages_OrderNotesResponse {
  orderNotes?: (Input_core_apimessages_OrderNote | null)[] | null; 
}

export interface Input_core_apimessages_OrderNotesIndexRequest {
  orderUuids?: (string | null)[] | null; 
  orderIds?: (string | null)[] | null; 
}

export interface Input_core_apimessages_OrderNotesIndexResponse {
  orderNotes?: (Input_core_apimessages_OrderNotes | null)[] | null; 
}

export interface Input_core_apimessages_CreateOrderNoteRequest {
  body?: string | null; 
  orderId?: string | null; 
}

export interface Input_core_apimessages_CreateOrderNoteResponse {
  errors?: (Input_core_apimessages_Error | null)[] | null; 
  orderNote?: Input_core_apimessages_OrderNote | null; 
}

export interface Input_core_apimessages_DeleteOrderNotesRequest {
  orderNoteIds?: (string | null)[] | null; 
}

export interface Input_core_apimessages_SearchFilterPresetsRequest {
  categoryUuids?: (string | null)[] | null; 
  collectionType?: core_apimessages_CollectionHeader_CollectionType | null; 
  collectionIds?: (string | null)[] | null; 
  collectionSlugs?: (string | null)[] | null; 
}

export interface Input_core_apimessages_ItemSearchFilterPresets {
  collectionId?: string | null; 
  collectionType?: string | null; 
  presets?: (Input_core_apimessages_SearchFilterPreset | null)[] | null; 
  collectionSlug?: string | null; 
}

export interface Input_core_apimessages_SearchFilterPresetsResponse {
  searchFilterPresets?: (Input_core_apimessages_ItemSearchFilterPresets | null)[] | null; 
}

export interface Input_core_apimessages_RecentlyViewedListingsResponse {
  listingIds?: (string | null)[] | null; 
}

export interface Input_core_apimessages_MyShopResponse {
  shop?: Input_core_apimessages_Shop | null; 
}

export interface Input_core_apimessages_UpdateMyShopResponse {
  errors?: (Input_core_apimessages_Error | null)[] | null; 
  shop?: Input_core_apimessages_Shop | null; 
}

export interface Input_core_apimessages_ShippingProtectionResponse {
  price?: Input_core_apimessages_Money | null; 
  shippingProtectionStatus?: core_apimessages_ShippingProtectionStatus | null; 
  signatureRequiredStatus?: core_apimessages_SignatureRequiredStatus | null; 
  signatureRequiredCosts?: (Input_core_apimessages_SignatureRequiredCost | null)[] | null; 
}

export interface Input_core_apimessages_CreateShipmentResponse {
  shipment?: Input_core_apimessages_Shipment | null; 
  errors?: (Input_core_apimessages_CreateShipmentError | null)[] | null; 
}

export interface Input_core_apimessages_CreateShipmentError {
  message?: string | null; 
  errorType?: core_apimessages_CreateShipmentErrorType | null; 
}

export interface Input_core_apimessages_ShipmentsRequest {
  shipmentUuids?: (string | null)[] | null; 
}

export interface Input_core_apimessages_ShipmentsResponse {
  shipments?: (Input_core_apimessages_Shipment | null)[] | null; 
}

export interface Input_core_apimessages_PurchaseShippingRateResponse {
  errors?: (Input_core_apimessages_Error | null)[] | null; 
}

export interface Input_core_apimessages_RegisterMyPacklinkAccountResponse {
  shopId?: string | null; 
}

export interface Input_core_apimessages_LoginMyPacklinkAccountResponse {
  shopId?: string | null; 
}

export interface Input_core_apimessages_MyPacklinkAccountStatusResponse {
  account?: Input_core_apimessages_PacklinkAccount | null; 
}

export interface Input_core_apimessages_CreatePacklinkDraftResponse {
  shipment?: Input_core_apimessages_PacklinkShipment | null; 
}

export interface Input_core_apimessages_UpdateBillingMethodResponse {
  errors?: (Input_core_apimessages_Error | null)[] | null; 
  creditCard?: Input_core_apimessages_CreditCard | null; 
  adyenPaymentResult?: Input_core_apimessages_AdyenPaymentResult | null; 
  billingMethodUuid?: string | null; 
}

export interface Input_core_apimessages_ShopAddressesRequest {
  uuids?: (string | null)[] | null; 
  ids?: (string | null)[] | null; 
  slugs?: (string | null)[] | null; 
}

export interface Input_core_apimessages_ShopAddressesResponse {
  addresses?: (Input_core_apimessages_PublicShopAddress | null)[] | null; 
}

export interface Input_core_apimessages_TraitsRequest {
  ids?: (string | null)[] | null; 
  type?: core_apimessages_TraitsRequest_TraitableType | null; 
}

export interface Input_core_apimessages_TraitResponse {
  traitableId?: string | null; 
  traits?: (Input_core_apimessages_Trait | null)[] | null; 
}

export interface Input_core_apimessages_TraitsResponse {
  traits?: (Input_core_apimessages_TraitResponse | null)[] | null; 
}

export interface Input_core_apimessages_MyShopOnboardingResponse {
  billingMethodStatus?: core_apimessages_MyShopOnboardingResponse_BillingMethodStatus | null; 
  originCountryCode?: string | null; 
  paypalSetupStatus?: core_apimessages_MyShopOnboardingResponse_PaypalSetupStatus | null; 
  paymentMethod?: core_apimessages_MyShopOnboardingResponse_PaymentMethod | null; 
}

export interface Input_core_apimessages_MyCreditCardsResponse {
  creditCards?: (Input_core_apimessages_CreditCard | null)[] | null; 
}

export interface Input_core_apimessages_MyPayoutBalancesResponse {
  payoutBalances?: (Input_core_apimessages_Money | null)[] | null; 
}

export interface Input_core_apimessages_MyUserServicesResponse {
  userServices?: (Input_core_apimessages_UserService | null)[] | null; 
}

export interface Input_core_apimessages_MyReverbCreditsResponse {
  reverbCredits?: (Input_core_apimessages_Money | null)[] | null; 
}

export interface Input_core_apimessages_ShopShippingProfilesRequest {
  shopUuids?: (string | null)[] | null; 
  ids?: (string | null)[] | null; 
  uuids?: (string | null)[] | null; 
  slugs?: (string | null)[] | null; 
}

export interface Input_core_apimessages_ShopShippingProfilesResponse {
  shopShippingProfiles?: (Input_core_apimessages_ShopShippingProfiles | null)[] | null; 
}

export interface Input_core_apimessages_ChatDepartmentResponse {
  chatDepartment?: Input_core_apimessages_ChatDepartment | null; 
}

export interface Input_core_apimessages_GenerateDraftResponse {
  listing?: Input_core_apimessages_Listing | null; 
  seedCategories?: (Input_core_apimessages_NodesCategory | null)[] | null; 
  sellerCost?: Input_core_apimessages_Money | null; 
}

export interface Input_core_apimessages_UpdateReturnPolicyResponse {
  errors?: (Input_core_apimessages_Error | null)[] | null; 
  returnPolicy?: Input_core_apimessages_ReturnPolicy | null; 
}

export interface Input_core_apimessages_ShopReturnPoliciesRequest {
  shopUuids?: (string | null)[] | null; 
  ids?: (string | null)[] | null; 
  uuids?: (string | null)[] | null; 
  slugs?: (string | null)[] | null; 
}

export interface Input_core_apimessages_ShopReturnPoliciesResponse {
  shopReturnPolicies?: (Input_core_apimessages_ShopReturnPolicy | null)[] | null; 
}

export interface Input_core_apimessages_BulkTaxPoliciesRequest {
  requests?: (Input_core_apimessages_TaxPoliciesRequest | null)[] | null; 
}

export interface Input_core_apimessages_TaxPoliciesRequest {
  id?: string | null; 
  uuid?: string | null; 
  slug?: string | null; 
  type?: core_apimessages_TaxPoliciesRequest_TaxPoliciesType | null; 
}

export interface Input_core_apimessages_BulkTaxPoliciesResponse {
  shops?: (Input_core_apimessages_ShopTaxPolicies | null)[] | null; 
}

export interface Input_core_apimessages_MyShopPaypalProfileResponse_PaypalProfile {
  email?: string | null; 
}

export interface Input_core_apimessages_MyShopPaypalProfileResponse {
  paypalProfile?: Input_core_apimessages_MyShopPaypalProfileResponse_PaypalProfile | null; 
}

export interface Input_core_apimessages_BrandsRequest {
  uuids?: (string | null)[] | null; 
  slugs?: (string | null)[] | null; 
}

export interface Input_core_apimessages_BrandsResponse {
  brands?: (Input_core_apimessages_Brand | null)[] | null; 
}

export interface Input_core_apimessages_Category {
  id?: string | null; 
  name?: string | null; 
  webLink?: Input_core_apimessages_Link | null; 
  children?: (Input_core_apimessages_Category | null)[] | null; 
  cmsLink?: Input_core_apimessages_Link | null; 
  parent?: Input_core_apimessages_Category | null; 
  slug?: string | null; 
  rootSlug?: string | null; 
  cmsUrl?: Input_core_apimessages_Link | null; 
  root?: boolean | null; 
  leaf?: boolean | null; 
}

export interface Input_core_apimessages_CategoryRequest {
  id?: string | null; 
  withChildren?: boolean | null; 
  withParent?: boolean | null; 
  uuid?: string | null; 
  slug?: string | null; 
  type?: core_apimessages_CategoryRequest_CategoryType | null; 
}

export interface Input_core_apimessages_BulkCategoriesRequest {
  requests?: (Input_core_apimessages_CategoryRequest | null)[] | null; 
}

export interface Input_core_apimessages_BulkCategoriesResponse {
  responses?: (Input_core_apimessages_CategoriesResponse | null)[] | null; 
}

export interface Input_core_apimessages_CategoriesResponse {
  categories?: (Input_core_apimessages_Category | null)[] | null; 
}

export interface Input_core_apimessages_CollectionHeaderResponse {
  collectionHeader?: Input_core_apimessages_CollectionHeader | null; 
}

export interface Input_core_apimessages_SearchMetadataResponse {
  title?: string | null; 
}

export interface Input_core_apimessages_FeedbacksResponse {
  feedbacks?: (Input_core_apimessages_Feedback | null)[] | null; 
  total?: number | null; 
  offset?: number | null; 
  limit?: number | null; 
}

export interface Input_core_apimessages_FeedbackSummariesRequest {
  userIds?: (string | null)[] | null; 
  ids?: (string | null)[] | null; 
  uuids?: (string | null)[] | null; 
}

export interface Input_core_apimessages_FeedbackSummariesResponse {
  feedbackSummaries?: (Input_core_apimessages_FeedbackSummary | null)[] | null; 
}

export interface Input_core_apimessages_PreorderInfoRequest {
  listingIds?: (string | null)[] | null; 
}

export interface Input_core_apimessages_PreorderInfoResponse {
  preorderInfo?: (Input_core_apimessages_PreorderInfo | null)[] | null; 
}

export interface Input_core_apimessages_VideosRequest {
  type?: core_apimessages_VideosRequest_VideolinkableType | null; 
  ids?: (string | null)[] | null; 
  uuids?: (string | null)[] | null; 
  slugs?: (string | null)[] | null; 
}

export interface Input_core_apimessages_VideosResponse {
  videos?: (Input_core_apimessages_Video | null)[] | null; 
}

export interface Input_core_apimessages_Video {
  id?: string | null; 
  itemId?: string | null; 
  itemType?: string | null; 
  link?: string | null; 
  youtubeVideoId?: string | null; 
  empty?: boolean | null; 
}

export interface Input_core_apimessages_EstimatedMonthlyPaymentsRequest {
  ids?: (string | null)[] | null; 
}

export interface Input_core_apimessages_EstimatedMonthlyPaymentsResponse {
  estimatedMonthlyPayments?: (Input_core_apimessages_EstimatedMonthlyPayment | null)[] | null; 
}

export interface Input_core_apimessages_EstimatedMonthlyPayment {
  id?: string | null; 
  estimatedMonthlyPayment?: Input_core_apimessages_Money | null; 
  maxTermMonth?: number | null; 
  availableTermMonths?: (number | null)[] | null; 
  lowestAprAtMaxTerm?: number | null; 
  zeroPercentFinancingPlan?: boolean | null; 
  splitPay?: boolean | null; 
}

export interface Input_core_apimessages_OtherBuyersWithListingInCartCountsRequest {
  ids?: (string | null)[] | null; 
}

export interface Input_core_apimessages_OtherBuyersWithListingInCartCountsResponse {
  listingInCartCount?: (Input_core_apimessages_ListingInCartCount | null)[] | null; 
}

export interface Input_core_apimessages_AcceptedPaymentMethodsRequest {
  ids?: (string | null)[] | null; 
  type?: core_apimessages_AcceptedPaymentMethodsRequest_PaymentMethodsType | null; 
}

export interface Input_core_apimessages_AcceptedPaymentMethodsResponse {
  paymentMethods?: (Input_core_apimessages_PaymentMethods | null)[] | null; 
}

export interface Input_core_apimessages_PaymentMethods {
  itemId?: string | null; 
  itemType?: string | null; 
  acceptedPaymentMethods?: (string | null)[] | null; 
}

export interface Input_core_apimessages_DeleteResponse {
  id?: string | null; 
  uuid?: string | null; 
}

export interface Input_core_apimessages_AffirmFinancingPromotionsRequest {
  ids?: (string | null)[] | null; 
}

export interface Input_core_apimessages_AffirmFinancingPromotionsResponse {
  affirmFinancingPromotions?: (Input_core_apimessages_AffirmFinancingPromotion | null)[] | null; 
}

export interface Input_core_apimessages_AffirmFinancingPromotion {
  id?: string | null; 
  financingPlan?: string | null; 
  startsAt?: Input_core_apimessages_LegacyTimestamp | null; 
  endsAt?: Input_core_apimessages_LegacyTimestamp | null; 
  availableTermMonths?: (number | null)[] | null; 
  maxTermMonth?: number | null; 
  zeroPercentFinancing?: boolean | null; 
  links?: Input_core_apimessages_AffirmFinancingPromotionLinks | null; 
}

export interface Input_core_apimessages_AffirmFinancingPromotionLinks {
  curatedSet?: Input_core_apimessages_Link | null; 
}

export interface Input_core_apimessages_AuctionsRequest {
  ids?: (string | null)[] | null; 
}

export interface Input_core_apimessages_AuctionsResponse {
  auctions?: (Input_core_apimessages_Auction | null)[] | null; 
}

export interface Input_core_apimessages_AuctionBidsResponse {
  auctionId?: string | null; 
  bids?: (Input_core_apimessages_Bid | null)[] | null; 
  offset?: number | null; 
  limit?: number | null; 
  total?: number | null; 
}

export interface Input_core_apimessages_BidsCreateResponse {
  bid?: Input_core_apimessages_PrivateBid | null; 
}

export interface Input_core_apimessages_BidDetails {
  auctionId?: string | null; 
  highBidPrice?: Input_core_apimessages_Money | null; 
  totalBids?: number | null; 
}

export interface Input_core_apimessages_AuctionBidDetailsResponse {
  auctionBidDetails?: (Input_core_apimessages_BidDetails | null)[] | null; 
}

export interface Input_core_apimessages_AuctionBidDetailsRequest {
  auctionIds?: (string | null)[] | null; 
}

export interface Input_core_apimessages_MyBidDetails {
  auctionId?: string | null; 
  maxBidPrice?: Input_core_apimessages_Money | null; 
  isWinning?: boolean | null; 
  status?: core_apimessages_MyBidDetails_BidDetailStatus | null; 
}

export interface Input_core_apimessages_MyBidDetailsResponse {
  myBidDetails?: (Input_core_apimessages_MyBidDetails | null)[] | null; 
}

export interface Input_core_apimessages_MyBidDetailsRequest {
  auctionIds?: (string | null)[] | null; 
}

export interface Input_core_apimessages_AccountAlertsResponse {
  alerts?: (Input_core_apimessages_Alert | null)[] | null; 
}

export interface Input_core_apimessages_WatchesResponse {
  watches?: (Input_core_apimessages_WatchResponse | null)[] | null; 
  offset?: number | null; 
  limit?: number | null; 
  total?: number | null; 
}

export interface Input_core_apimessages_WatchResponse {
  listingId?: string | null; 
  watching?: boolean | null; 
}

export interface Input_core_apimessages_OrderPaymentsRequest {
  orderUuids?: (string | null)[] | null; 
  orderIds?: (string | null)[] | null; 
}

export interface Input_core_apimessages_OrderPaymentsResponse {
  orderPayments?: (Input_core_apimessages_OrderPayments | null)[] | null; 
}

export interface Input_core_apimessages_OrderRefundsRequest {
  orderUuids?: (string | null)[] | null; 
  orderIds?: (string | null)[] | null; 
}

export interface Input_core_apimessages_OrderRefundsResponse {
  orderRefunds?: (Input_core_apimessages_OrderRefunds | null)[] | null; 
}

export interface Input_core_apimessages_BuyerRefundsRequest {
  ids?: (string | null)[] | null; 
}

export interface Input_core_apimessages_BuyerRefundsResponse {
  buyerRefunds?: (Input_core_apimessages_BuyerRefund | null)[] | null; 
}

export interface Input_core_apimessages_UpdateWatchResponse {
  listingId?: string | null; 
  userId?: string | null; 
  id?: string | null; 
}

export interface Input_core_apimessages_StorefrontsRequest {
  slugs?: (string | null)[] | null; 
}

export interface Input_core_apimessages_StorefrontsResponse {
  storefronts?: (Input_core_apimessages_Storefront | null)[] | null; 
}

export interface Input_core_apimessages_StorefrontReturnPoliciesRequest {
  slugs?: (string | null)[] | null; 
}

export interface Input_core_apimessages_StorefrontReturnPoliciesResponse {
  returnPolicies?: (Input_core_apimessages_ReturnPolicy | null)[] | null; 
}

export interface Input_core_apimessages_UpdateFeedbackResponse {
  feedback?: Input_core_apimessages_Feedback | null; 
}

export interface Input_core_apimessages_DeclineFeedbackResponse {
  orderUuid?: string | null; 
}

export interface Input_core_apimessages_ListingsCuratedSetsRequest {
  ids?: (string | null)[] | null; 
  curatedSetSlugs?: (string | null)[] | null; 
}

export interface Input_core_apimessages_ListingsCuratedSetsResponse {
  curatedSetsForListings?: (Input_core_apimessages_CuratedSetsForListing | null)[] | null; 
}

export interface Input_core_apimessages_AdminCuratedSetsCurateResponse {
  curatedSetSlug?: string | null; 
  listingId?: string | null; 
  featuredInSet?: boolean | null; 
}

export interface Input_core_apimessages_BulkAddressesRequest_Query {
  relation?: core_apimessages_BulkAddressesRequest_Relation | null; 
  primaryKey?: Input_core_apimessages_PrimaryKey | null; 
}

export interface Input_core_apimessages_BulkAddressesRequest {
  queries?: (Input_core_apimessages_BulkAddressesRequest_Query | null)[] | null; 
}

export interface Input_core_apimessages_BulkAddressesResponse_QueryResult {
  addresses?: (Input_core_apimessages_Address | null)[] | null; 
}

export interface Input_core_apimessages_BulkAddressesResponse {
  results?: (Input_core_apimessages_BulkAddressesResponse_QueryResult | null)[] | null; 
}

export interface Input_core_apimessages_BulkOrdersRequest {
  queries?: (Input_core_apimessages_BulkOrdersRequest_Query | null)[] | null; 
}

export interface Input_core_apimessages_BulkOrdersResponse_QueryResult {
  orders?: (Input_core_apimessages_Order | null)[] | null; 
}

export interface Input_core_apimessages_BulkOrdersResponse {
  results?: (Input_core_apimessages_BulkOrdersResponse_QueryResult | null)[] | null; 
}

export interface Input_core_apimessages_MyCuratedSetMembershipResponse {
  curatedSetMembership?: Input_core_apimessages_CuratedSetMembership | null; 
}

export interface Input_core_apimessages_BulkCuratedSetsRequest_Query {
  relation?: core_apimessages_BulkCuratedSetsRequest_Relation | null; 
  primaryKey?: Input_core_apimessages_PrimaryKey | null; 
  setTypes?: (core_apimessages_CuratedSet_SetType | null)[] | null; 
}

export interface Input_core_apimessages_BulkCuratedSetsRequest {
  queries?: (Input_core_apimessages_BulkCuratedSetsRequest_Query | null)[] | null; 
}

export interface Input_core_apimessages_BulkCuratedSetsResponse_QueryResult {
  curatedSets?: (Input_core_apimessages_CuratedSet | null)[] | null; 
}

export interface Input_core_apimessages_BulkCuratedSetsResponse {
  results?: (Input_core_apimessages_BulkCuratedSetsResponse_QueryResult | null)[] | null; 
}

export interface Input_core_apimessages_ReverifyCreditCardResponse {
  creditCard?: Input_core_apimessages_CreditCard | null; 
}

export interface Input_core_apimessages_ReferAFriendResponse {
  referAFriend?: Input_core_apimessages_ReferAFriend | null; 
}

export interface Input_core_apimessages_CheckoutPaymentResponse {
  checkoutUuid?: string | null; 
  adyenPaymentResult?: Input_core_apimessages_AdyenPaymentResult | null; 
  orderBundleId?: string | null; 
  checkoutId?: string | null; 
  paymentResultUrl?: string | null; 
}

export interface Input_core_apimessages_CheckoutVerifyShopperResponse {
  checkoutUuid?: string | null; 
  adyenPaymentResult?: Input_core_apimessages_AdyenPaymentResult | null; 
  orderBundleId?: string | null; 
  checkoutId?: string | null; 
  paymentResultUrl?: string | null; 
}

export interface Input_core_apimessages_CheckoutIdentifyShopperResponse {
  checkoutUuid?: string | null; 
  adyenPaymentResult?: Input_core_apimessages_AdyenPaymentResult | null; 
  orderBundleId?: string | null; 
  checkoutId?: string | null; 
  paymentResultUrl?: string | null; 
}

export interface Input_core_apimessages_CheckoutChallengeShopperResponse {
  checkoutUuid?: string | null; 
  adyenPaymentResult?: Input_core_apimessages_AdyenPaymentResult | null; 
  orderBundleId?: string | null; 
  checkoutId?: string | null; 
  paymentResultUrl?: string | null; 
}

export interface Input_core_apimessages_GuestCheckoutApplePayLineItem {
  name?: string | null; 
  description?: string | null; 
  amount?: Input_core_apimessages_Money | null; 
}

export interface Input_core_apimessages_GuestCheckoutApplePayLineItemsResponse {
  lineItems?: (Input_core_apimessages_GuestCheckoutApplePayLineItem | null)[] | null; 
  total?: Input_core_apimessages_GuestCheckoutApplePayLineItem | null; 
}

export interface Input_core_apimessages_GuestCheckoutApplePayPaymentResponse {
  orderBundleId?: string | null; 
  paymentResultUrl?: string | null; 
}

export interface Input_core_apimessages_BillingMethodVerifyShopperResponse {
  errors?: (Input_core_apimessages_Error | null)[] | null; 
  creditCard?: Input_core_apimessages_CreditCard | null; 
  adyenPaymentResult?: Input_core_apimessages_AdyenPaymentResult | null; 
  billingMethodUuid?: string | null; 
}

export interface Input_core_apimessages_BillingMethodIdentifyShopperResponse {
  errors?: (Input_core_apimessages_Error | null)[] | null; 
  creditCard?: Input_core_apimessages_CreditCard | null; 
  adyenPaymentResult?: Input_core_apimessages_AdyenPaymentResult | null; 
  billingMethodUuid?: string | null; 
}

export interface Input_core_apimessages_BillingMethodChallengeShopperResponse {
  errors?: (Input_core_apimessages_Error | null)[] | null; 
  creditCard?: Input_core_apimessages_CreditCard | null; 
  adyenPaymentResult?: Input_core_apimessages_AdyenPaymentResult | null; 
  billingMethodUuid?: string | null; 
}

export interface Input_core_apimessages_AdyenThreeDSBillingMethodEntry {
  billingCardEntry?: Input_core_apimessages_BillingCreditCardEntry | null; 
  paymentData?: string | null; 
}

export interface Input_core_apimessages_BumpKeysRequest {
  listingIds?: (string | null)[] | null; 
}

export interface Input_core_apimessages_BumpKeysResponse {
  bumpKeys?: (Input_core_apimessages_BumpKey | null)[] | null; 
}

export interface Input_core_apimessages_TrackBumpInteractionResponse {
  bumpKey?: Input_core_apimessages_BumpKey | null; 
}

export interface Input_core_apimessages_SiteBannerResponse {
  siteBanner?: Input_core_apimessages_SiteBanner | null; 
  siteBanners?: (Input_core_apimessages_SiteBanner | null)[] | null; 
}

export interface Input_core_apimessages_CPSuggestionsRequest {
  listingIds?: (string | null)[] | null; 
}

export interface Input_core_apimessages_CPSuggestionsResponse {
  cpSuggestions?: (Input_core_apimessages_CPSuggestions | null)[] | null; 
}

export interface Input_core_apimessages_DeleteGearCollectionItemResponse {
  gearCollectionItem?: Input_core_apimessages_GearCollectionItem | null; 
}

export interface Input_core_apimessages_UpdateGearCollectionItemResponse {
  gearCollectionItem?: Input_core_apimessages_GearCollectionItem | null; 
}

export interface Input_core_apimessages_CreateTaxIdentificationResponse {
  taxIdentification?: Input_core_apimessages_TaxIdentification | null; 
  shopId?: string | null; 
}

export interface Input_core_apimessages_UpdateTaxIdentificationResponse {
  taxIdentification?: Input_core_apimessages_TaxIdentification | null; 
  shopId?: string | null; 
}

export interface Input_core_apimessages_DeactivateTaxIdentificationResponse {
  taxIdentification?: Input_core_apimessages_TaxIdentification | null; 
  shopId?: string | null; 
}

export interface Input_core_apimessages_AdZonesSearchResponse {
  resultUuids?: (string | null)[] | null; 
}

export interface Input_core_apimessages_RequestAccountDeletionResponse {
  uuid?: string | null; 
}

export interface Input_core_apimessages_DelinkUserServiceResponse {
  _?: boolean | null; 
}

export interface Input_core_apimessages_AdaChatTokenResponse {
  token?: string | null; 
}

export interface Input_core_apimessages_ExperimentsResponse {
  experiments?: (Input_reverb_event_Experiment | null)[] | null; 
}

export interface Input_core_apimessages_MosaicTilesResponse {
  mosaicTiles?: (Input_core_apimessages_MosaicTile | null)[] | null; 
}

export interface Input_core_apimessages_MosaicTile {
  id?: string | null; 
  url?: string | null; 
  imageTitle?: string | null; 
  imageSubtitle?: string | null; 
  imageUrl?: string | null; 
  contentSponsorship?: Input_core_apimessages_ContentSponsorship | null; 
  position?: core_apimessages_MosaicTilePosition | null; 
}

export interface Input_core_apimessages_UpdateUniversalPromoCampaignResponse {
  universalPromoCampaign?: Input_core_apimessages_UniversalPromoCampaign | null; 
}

export interface Input_core_apimessages_AdminUserSearchResponse {
  totalResults?: string | null; 
  page?: string | null; 
  perPage?: string | null; 
  users?: (Input_core_apimessages_UserSearchResult | null)[] | null; 
}

export interface Input_core_apimessages_UserSearchResult {
  id?: string | null; 
  email?: string | null; 
  shopId?: string | null; 
  shopName?: string | null; 
}

export interface Input_core_apimessages_UpdateListingResponse {
  listing?: Input_core_apimessages_Listing | null; 
}

export interface Input_core_apimessages_BearerV2TokenResponse {
  token?: string | null; 
}

export interface Input_core_apimessages_MyCartItemsIndexResponse {
  cartItems?: (Input_core_apimessages_CartItem | null)[] | null; 
}

export interface Input_reverb_search_TopCollectionsResult {
  brandUuids?: (string | null)[] | null; 
  categoryUuids?: (string | null)[] | null; 
}

export interface Input_reverb_search_Document {
  id?: string | null; 
  source?: string | null; 
  type?: string | null; 
  esCsp?: Input_reverb_search_CSPResponse | null; 
  esGearCollectionItem?: Input_reverb_search_GearCollectionItemResponse | null; 
}

export interface Input_reverb_search_CSPResponse {
  id?: string | null; 
  title?: string | null; 
  webLink?: string | null; 
  newListingsLink?: string | null; 
  usedListingsLink?: string | null; 
  cardSquareImageUrl?: string | null; 
  thumbnailImageUrl?: string | null; 
  inventory?: Input_reverb_search_CSPInventory | null; 
  reviewsCount?: number | null; 
  averageReviewRating?: number | null; 
  uuid?: string | null; 
  slug?: string | null; 
}

export interface Input_reverb_search_CSPInventory {
  usedTotal?: number | null; 
  newTotal?: number | null; 
  newLowPrice?: Input_reverb_search_Money | null; 
  usedLowPrice?: Input_reverb_search_Money | null; 
}

export interface Input_reverb_search_Money {
  cents?: number | null; 
  currency?: string | null; 
  amountCents?: number | null; 
}

export interface Input_reverb_search_GearCollectionItemResponse {
  id?: string | null; 
  priceEstimate?: Input_reverb_search_PriceEstimate | null; 
}

export interface Input_reverb_search_PriceEstimate {
  priceLow?: Input_reverb_search_Money | null; 
  priceHigh?: Input_reverb_search_Money | null; 
}

export interface Input_reverb_search_Inventory {
  listingCount?: number | null; 
  listingMinPrice?: Input_reverb_search_Money | null; 
}

export interface Input_reverb_search_SuggestOptionScope {
  id?: string | null; 
  slug?: string | null; 
  output?: string | null; 
  type?: reverb_search_SuggestOptionScope_Type | null; 
}

export interface Input_reverb_search_SuggestOption_CorePayloadParams {
  productType?: string | null; 
  query?: string | null; 
  categoryUuid?: string | null; 
  brandSlug?: string | null; 
  shop?: string | null; 
  id?: string | null; 
  category?: string | null; 
  curatedSetSlug?: string | null; 
}

export interface Input_reverb_search_SuggestOption_CoreFilter {
  name?: string | null; 
  type?: string | null; 
  count?: number | null; 
  params?: Input_reverb_search_SuggestOption_CorePayloadParams | null; 
}

export interface Input_reverb_search_SuggestOption_CorePayload {
  type?: string | null; 
  uuid?: string | null; 
  filter?: string | null; 
  filters?: (Input_reverb_search_SuggestOption_CoreFilter | null)[] | null; 
  params?: Input_reverb_search_SuggestOption_CorePayloadParams | null; 
}

export interface Input_reverb_search_SuggestOption_CSPPayload {
  title?: string | null; 
  categories?: (string | null)[] | null; 
  primaryImage?: string | null; 
}

export interface Input_reverb_search_SuggestOption_CompletionPayload {
  thumbnailUrl?: string | null; 
  inventoryNew?: Input_reverb_search_Inventory | null; 
  inventoryUsed?: Input_reverb_search_Inventory | null; 
}

export interface Input_reverb_search_SuggestOption_LPParams {
  artist?: string | null; 
  label?: string | null; 
  album?: string | null; 
}

export interface Input_reverb_search_SuggestOption_LPMetadata {
  primaryImageUuid?: string | null; 
  artistName?: string | null; 
  labelName?: string | null; 
  releaseDate?: string | null; 
  formatDescriptions?: (string | null)[] | null; 
}

export interface Input_reverb_search_SuggestOption_LPPayload {
  type?: string | null; 
  params?: Input_reverb_search_SuggestOption_LPParams | null; 
  metadata?: Input_reverb_search_SuggestOption_LPMetadata | null; 
}

export interface Input_reverb_search_SuggestOption {
  text?: string | null; 
  output?: string | null; 
  cspPayload?: Input_reverb_search_SuggestOption_CSPPayload | null; 
  corePayload?: Input_reverb_search_SuggestOption_CorePayload | null; 
  lpPayload?: Input_reverb_search_SuggestOption_LPPayload | null; 
  completionPayload?: Input_reverb_search_SuggestOption_CompletionPayload | null; 
  score?: number | null; 
  id?: string | null; 
  slug?: string | null; 
  scope?: Input_reverb_search_SuggestOptionScope | null; 
  scopes?: (Input_reverb_search_SuggestOptionScope | null)[] | null; 
}

export interface Input_reverb_search_Completion {
  text?: string | null; 
  options?: (Input_reverb_search_SuggestOption | null)[] | null; 
  type?: reverb_search_CompletionType | null; 
}

export interface Input_reverb_search_Percentile {
  key?: string | null; 
  count?: number | null; 
  p1?: number | null; 
  p5?: number | null; 
  p25?: number | null; 
  p50?: number | null; 
  p75?: number | null; 
  p95?: number | null; 
  p99?: number | null; 
}

export interface Input_reverb_search_TopCSP {
  count?: number | null; 
  id?: string | null; 
}

export interface Input_reverb_search_OrderMetrics {
  totalAmountProductCentsUsd?: number | null; 
  averageProductPriceCentsUsd?: number | null; 
  topCsps?: (Input_reverb_search_TopCSP | null)[] | null; 
  orderCount?: number | null; 
  totalAmountProductCentsUsdDouble?: number | null; 
  totalSellerRevenueAmount?: Input_reverb_search_Money | null; 
  totalBumpSpendAmount?: Input_reverb_search_Money | null; 
}

export interface Input_reverb_search_PriceStatsResult {
  middle?: Input_reverb_search_Money | null; 
}

export interface Input_reverb_search_PriceStatsResults {
  purchasePrice?: Input_reverb_search_PriceStatsResult | null; 
  publicPrice?: Input_reverb_search_PriceStatsResult | null; 
  docCount?: number | null; 
}

export interface Input_reverb_search_AverageMonthlyProductPrice {
  date?: string | null; 
  averageProductPriceInUsd?: Input_reverb_search_Money | null; 
  docCount?: number | null; 
}

export interface Input_reverb_search_BumpRecommendationsResults {
  bumpRecommendationAmount?: number | null; 
  maxBumpRecommendationAmount?: number | null; 
}

export interface Input_reverb_search_GearCollectionTotalEstimate {
  totalEstimateLow?: Input_reverb_search_Money | null; 
  totalEstimateHigh?: Input_reverb_search_Money | null; 
}

export interface Input_reverb_search_GearCollectionStats {
  totalCollectionEstimate?: Input_reverb_search_GearCollectionTotalEstimate | null; 
}

export interface Input_reverb_search_QuerySpellCorrection {
  correction?: string | null; 
}

export interface Input_reverb_search_SearchResponse_TotalHits {
  value?: number | null; 
  relation?: reverb_search_SearchResponse_TotalHits_Relation | null; 
}

export interface Input_reverb_search_SearchResponse_Suggestion {
  text?: string | null; 
  score?: number | null; 
  frequency?: number | null; 
}

export interface Input_reverb_search_SearchResponse {
  resultIds?: (string | null)[] | null; 
  results?: (Input_reverb_search_Document | null)[] | null; 
  total?: number | null; 
  offset?: number | null; 
  limit?: number | null; 
  completions?: (Input_reverb_search_Completion | null)[] | null; 
  percentiles?: (Input_reverb_search_Percentile | null)[] | null; 
  bestListings?: (Input_reverb_search_BestListing | null)[] | null; 
  resultUuids?: (string | null)[] | null; 
  filters?: (Input_reverb_search_Filter | null)[] | null; 
  bumpIds?: (string | null)[] | null; 
  topCollections?: Input_reverb_search_TopCollectionsResult | null; 
  suggestedQueries?: (string | null)[] | null; 
  fallbackResultIds?: (string | null)[] | null; 
  orderMetrics?: Input_reverb_search_OrderMetrics | null; 
  dateBuckets?: (Input_reverb_search_DateBucket | null)[] | null; 
  priceStats?: Input_reverb_search_PriceStatsResults | null; 
  bumpRecommendations?: Input_reverb_search_BumpRecommendationsResults | null; 
  gearCollectionStats?: Input_reverb_search_GearCollectionStats | null; 
  totalHits?: Input_reverb_search_SearchResponse_TotalHits | null; 
  suggestions?: (Input_reverb_search_SearchResponse_Suggestion | null)[] | null; 
  autodirected?: boolean | null; 
  eligibleAutodirects?: (reverb_search_Autodirects | null)[] | null; 
  averageMonthlyProductPrices?: (Input_reverb_search_AverageMonthlyProductPrice | null)[] | null; 
  querySpellCorrections?: (Input_reverb_search_QuerySpellCorrection | null)[] | null; 
}

export interface Input_reverb_search_BestListing {
  key?: string | null; 
  id?: string | null; 
}

export interface Input_reverb_search_Filter {
  name?: string | null; 
  options?: (Input_reverb_search_FilterOption | null)[] | null; 
  widgetType?: reverb_search_Filter_WidgetType | null; 
  aggregationName?: string | null; 
  key?: string | null; 
}

export interface Input_reverb_search_FilterOption {
  name?: string | null; 
  optionValue?: string | null; 
  selected?: boolean | null; 
  paramName?: string | null; 
  setValues?: (string | null)[] | null; 
  unsetValues?: (string | null)[] | null; 
  count?: Input_google_protobuf_Int32Value | null; 
  all?: boolean | null; 
  subFilter?: Input_reverb_search_Filter | null; 
  urlParamName?: string | null; 
  autoselected?: boolean | null; 
  trackingValue?: string | null; 
}

export interface Input_reverb_search_DateBucket {
  fromDate?: string | null; 
  toDate?: string | null; 
  metrics?: Input_reverb_search_OrderMetrics | null; 
}

export interface Input_reverb_search_NegotiationSearchRequest {
  offset?: number | null; 
  limit?: number | null; 
  sellerUuids?: (string | null)[] | null; 
  buyerUuids?: (string | null)[] | null; 
  states?: (reverb_search_NegotiationSearchRequest_State | null)[] | null; 
  ids?: (string | null)[] | null; 
  listingIds?: (string | null)[] | null; 
  sort?: string | null; 
  fullTextQuery?: string | null; 
  participantUuids?: (string | null)[] | null; 
  negotiationTypes?: (reverb_search_NegotiationSearchRequest_Type | null)[] | null; 
  withAggregations?: (reverb_search_NegotiationSearchRequest_Aggregation | null)[] | null; 
}

export interface Input_reverb_search_LPTransactionsSearchRequest {
  actionableStatuses?: (reverb_search_LPTransactionsSearchRequest_ActionableStatus | null)[] | null; 
  createdAfter?: string | null; 
  createdBefore?: string | null; 
  filterPurchased?: boolean | null; 
  releaseUuids?: (string | null)[] | null; 
  withAggregations?: (reverb_search_LPTransactionsSearchRequest_Aggregation | null)[] | null; 
  withLimitedAggregations?: Input_reverb_search_LimitedAggregation | null; 
}

export interface Input_reverb_search_ShippingRegionFilterResponse {
  filter?: Input_reverb_search_Filter | null; 
}

export interface Input_reverb_search_ListingsAggregationResponse {
  aggregationResults?: (Input_reverb_search_AggregationResult | null)[] | null; 
  topCollections?: Input_reverb_search_TopCollectionsResult | null; 
}

export interface Input_reverb_search_AggregationResult {
  name?: reverb_search_ListingsSearchRequest_Aggregation | null; 
  aggregationDetails?: (Input_reverb_search_AggregationDetails | null)[] | null; 
  displayName?: string | null; 
}

export interface Input_reverb_search_AggregationDetails {
  key?: string | null; 
  count?: number | null; 
  displayName?: string | null; 
}

export interface Input_reverb_search_SubAggregationsByListingRequest {
  index?: reverb_search_SubAggregationsByListingRequest_TargetIndex | null; 
  listingIds?: (string | null)[] | null; 
  sellerUuids?: (string | null)[] | null; 
  withAggregations?: (reverb_search_SubAggregationsByListingRequest_Aggregation | null)[] | null; 
}

export interface Input_reverb_search_SubAggregationsResult {
  filterOptions?: (Input_reverb_search_FilterOption | null)[] | null; 
}

export interface Input_reverb_search_SubAggregationsResponse {
  results?: (Input_reverb_search_SubAggregationsResult | null)[] | null; 
}

export interface Input_reverb_search_ListingsPercolationQueryRequest {
  savedSearchQueryParams?: string | null; 
}

export interface Input_reverb_search_ListingsPercolationQueryResponse {
  esQuery?: string | null; 
}

export interface Input_reverb_taxonomy_Translation {
  uuid?: string | null; 
  locale?: string | null; 
  translation?: string | null; 
}

export interface Input_reverb_taxonomy_Category {
  slug?: string | null; 
  uuid?: string | null; 
  uuidPath?: (string | null)[] | null; 
  slugPath?: (string | null)[] | null; 
  enabled?: boolean | null; 
  public?: boolean | null; 
}

export interface Input_reverb_taxonomy_TraitValue {
  slug?: string | null; 
  uuid?: string | null; 
  uuidPath?: (string | null)[] | null; 
  slugPath?: (string | null)[] | null; 
  name?: string | null; 
}

export interface Input_reverb_taxonomy_Trait {
  slug?: string | null; 
  uuid?: string | null; 
  type?: string | null; 
  name?: string | null; 
  multivalue?: boolean | null; 
  required?: boolean | null; 
  traitValues?: (Input_reverb_taxonomy_TraitValue | null)[] | null; 
}

export interface Input_reverb_taxonomy_GetTraitValueTranslationsResponse {
  traitValueTranslations?: (Input_reverb_taxonomy_Translation | null)[] | null; 
}

export interface Input_reverb_taxonomy_GetCategoryTranslationsRequest {
  _?: boolean | null; 
}

export interface Input_reverb_taxonomy_GetCategoryTranslationsResponse {
  categoryTranslations?: (Input_reverb_taxonomy_Translation | null)[] | null; 
}

export interface Input_reverb_taxonomy_GetCategoriesRequest {
  _?: boolean | null; 
}

export interface Input_reverb_taxonomy_GetCategoriesResponse {
  categories?: (Input_reverb_taxonomy_Category | null)[] | null; 
}

export interface Input_reverb_taxonomy_GetTraitTranslationsRequest {
  _?: boolean | null; 
}

export interface Input_reverb_taxonomy_GetTraitTranslationsResponse {
  traitTranslations?: (Input_reverb_taxonomy_Translation | null)[] | null; 
}

export interface Input_reverb_taxonomy_GetTraitsRequest {
  _?: boolean | null; 
}

export interface Input_reverb_taxonomy_GetTraitsResponse {
  traits?: (Input_reverb_taxonomy_Trait | null)[] | null; 
}

export interface Input_reverb_taxonomy_GetTaxonomyYamlRequest {
  _?: boolean | null; 
}

export interface Input_reverb_taxonomy_GetTaxonomyYamlResponse {
  yaml?: string | null; 
}

export interface Input_reverb_reporting_ctr_CspCtr {
  cspId?: string | null; 
  impressions?: number | null; 
  clicks?: number | null; 
}

export interface Input_reverb_reporting_ctr_CspsCtrByDateRangeRequest {
  cspIds?: (string | null)[] | null; 
  datetimeStart?: string | null; 
  datetimeEnd?: string | null; 
}

export interface Input_reverb_reporting_ctr_CspsCtrByDateRangeResponse {
  ctrs?: (Input_reverb_reporting_ctr_CspCtr | null)[] | null; 
}

export interface Input_reverb_reporting_Int32Value {
  value?: number | null; 
}

export interface Input_reverb_reporting_CSPStatsByDate {
  date?: string | null; 
  liveListingCount?: number | null; 
  minListingPriceUsc?: Input_reverb_reporting_Int32Value | null; 
  orderQuantity?: number | null; 
  totalOrderValueUsc?: number | null; 
  avgOrderPriceUsc?: Input_reverb_reporting_Int32Value | null; 
}

export interface Input_reverb_reporting_CSPStatsByDateResponse {
  byDate?: (Input_reverb_reporting_CSPStatsByDate | null)[] | null; 
}

export interface Input_reverb_reporting_CSPStatsByCSP {
  cspId?: string | null; 
  cspSlug?: string | null; 
  brandSlug?: string | null; 
  liveListingCount?: number | null; 
  minListingPriceUsc?: Input_reverb_reporting_Int32Value | null; 
  orderQuantity?: number | null; 
  totalOrderValueUsc?: number | null; 
  avgOrderPriceUsc?: Input_reverb_reporting_Int32Value | null; 
}

export interface Input_reverb_reporting_CSPStatsByCSPResponse {
  byCsp?: (Input_reverb_reporting_CSPStatsByCSP | null)[] | null; 
  totalCount?: number | null; 
}

export interface Input_reverb_reporting_CSPStats {
  liveListingCount?: number | null; 
  minListingPriceUsc?: Input_reverb_reporting_Int32Value | null; 
  orderQuantity?: number | null; 
  totalOrderValueUsc?: number | null; 
  avgOrderPriceUsc?: Input_reverb_reporting_Int32Value | null; 
}

export interface Input_reverb_reporting_ShopStatsRequest {
  shopId?: string | null; 
  currency?: string | null; 
  startTime?: string | null; 
  endTime?: string | null; 
}

export interface Input_reverb_reporting_ShopStatsByDateRequest {
  shopId?: string | null; 
  currency?: string | null; 
  startTime?: string | null; 
  endTime?: string | null; 
  timeGrouping?: reverb_reporting_TimeGrouping | null; 
  timeZone?: string | null; 
}

export interface Input_reverb_reporting_ShopStatsTimeBucket {
  timestamp?: string | null; 
  salesCents?: number | null; 
}

export interface Input_reverb_reporting_ShopStatsResponse {
  salesCents?: number | null; 
  watchersCount?: number | null; 
  offersCount?: number | null; 
  ordersCount?: number | null; 
}

export interface Input_reverb_reporting_ShopStatsCurrencyCountResponse {
  currencyCount?: number | null; 
}

export interface Input_reverb_reporting_ShopStatsByDateResponse {
  buckets?: (Input_reverb_reporting_ShopStatsTimeBucket | null)[] | null; 
}

export interface Input_rql_Node {
  Id?: string | null; 
}

export interface Input_rql_NodeError {
  type?: rql_NodeError_ErrorType | null; 
  message?: string | null; 
}

export interface Input_rql_BumpedListingsQuery {
  entityType?: string | null; 
  count?: number | null; 
}

export interface Input_rql_BrandStatsSearch {
  dateStart?: string | null; 
  dateEnd?: string | null; 
  condition?: reverb_reporting_Condition | null; 
  orderBy?: reverb_reporting_CSPStatsMetric | null; 
  orderDesc?: boolean | null; 
  limit?: number | null; 
  offset?: number | null; 
}

export interface Input_rql_BrandManager {
  slug?: string | null; 
  id?: string | null; 
}

export interface Input_rql_AuthToken {
  token?: string | null; 
}

export interface Input_rql_Me {
  token?: string | null; 
}

export interface Input_rql_PageInfo {
  limit?: number | null; 
  offset?: number | null; 
  total?: number | null; 
}

export interface Input_rql_SeedableListingFields {
  make?: string | null; 
  model?: string | null; 
  brandSlug?: string | null; 
  finish?: string | null; 
  year?: string | null; 
  canonicalProductId?: string | null; 
  categoryRootUuid?: string | null; 
  categories?: (Input_core_apimessages_NodesCategory | null)[] | null; 
  condition?: Input_core_apimessages_Condition | null; 
  countryOfOrigin?: string | null; 
  comparisonShoppingPageId?: string | null; 
  sellerCost?: Input_core_apimessages_Money | null; 
}

export interface Input_rql_PageMetadata {
  mainClause?: string | null; 
  prefixClause?: string | null; 
  hasSubjectClause?: boolean | null; 
  fallbackSubject?: string | null; 
  inPreposition?: string | null; 
  collectionClause?: string | null; 
}

export interface Input_rql_UpdateEntity {
  _?: boolean | null; 
}

export interface Input_rql_Update {
  entity?: Input_rql_UpdateEntity | null; 
  createdAt?: string | null; 
}

export interface Input_rql_MyUpdatesResponse {
  updates?: (Input_rql_Update | null)[] | null; 
  limit?: number | null; 
  offset?: number | null; 
  total?: number | null; 
}

export interface Input_rql_PublicComponentEntity {
  id?: string | null; 
  type?: string | null; 
}

export interface Input_rql_MyCart {
  cartItems?: (Input_core_apimessages_CartItem | null)[] | null; 
}

export interface Input_rql_CheckoutCartEditResponse {
  id?: string | null; 
}

export interface Input_lp_AdminAlbum {
  uuid?: string | null; 
  slug?: string | null; 
  title?: string | null; 
  genres?: (string | null)[] | null; 
  styles?: (string | null)[] | null; 
  deletedAt?: string | null; 
}

export interface Input_lp_Price {
  amount?: string | null; 
  amountCents?: number | null; 
  currency?: string | null; 
  symbol?: string | null; 
  display?: string | null; 
}

export interface Input_lp_Link {
  href?: string | null; 
}

export interface Input_lp_LPImage {
  Links?: Input_lp_LPImageLinks | null; 
  imageLinks?: Input_lp_LPImageLinks | null; 
  key?: string | null; 
}

export interface Input_lp_LPImageLinks {
  thumbSmall?: Input_lp_Link | null; 
  thumbLarge?: Input_lp_Link | null; 
  original?: Input_lp_Link | null; 
}

export interface Input_lp_ReleaseFormat {
  name?: string | null; 
  uuid?: string | null; 
  descriptions?: (string | null)[] | null; 
  text?: string | null; 
  quantity?: number | null; 
}

export interface Input_lp_AlbumArtist {
  name?: string | null; 
  uuid?: string | null; 
  slug?: string | null; 
  nameVariations?: (string | null)[] | null; 
}

export interface Input_lp_Release {
  releaseDate?: string | null; 
  catalogNumbers?: (string | null)[] | null; 
  labelName?: string | null; 
  labelUuid?: string | null; 
  labelSlug?: string | null; 
  country?: string | null; 
  formats?: (Input_lp_ReleaseFormat | null)[] | null; 
  uuid?: string | null; 
  slug?: string | null; 
  title?: string | null; 
  artistName?: string | null; 
  artistSlug?: string | null; 
  albumSlug?: string | null; 
  releaseSiblingCount?: number | null; 
  masterUuid?: string | null; 
  notes?: string | null; 
  identifiers?: (Input_lp_Identifier | null)[] | null; 
  tracks?: (Input_lp_Track | null)[] | null; 
  companies?: (Input_lp_Company | null)[] | null; 
  collaborators?: (Input_lp_Collaborator | null)[] | null; 
  listingCount?: number | null; 
  hasLiveListings?: boolean | null; 
  id?: string | null; 
  highestPrice?: Input_lp_Price | null; 
  lowestPrice?: Input_lp_Price | null; 
  artists?: (Input_lp_AlbumArtist | null)[] | null; 
  suggestedTitle?: string | null; 
  images?: (Input_lp_LPImage | null)[] | null; 
  attributionId?: string | null; 
  formatQuantity?: number | null; 
}

export interface Input_lp_Identifier {
  type?: string | null; 
  value?: string | null; 
}

export interface Input_lp_Track {
  duration?: string | null; 
  position?: string | null; 
  title?: string | null; 
}

export interface Input_lp_Company {
  function?: string | null; 
  name?: string | null; 
}

export interface Input_lp_Collaborator {
  name?: string | null; 
  role?: string | null; 
}

export interface Input_lp_ReleaseManifest {
  uuid?: string | null; 
  taxonomyUuids?: (string | null)[] | null; 
  suggestedTitle?: string | null; 
  formatQuantity?: number | null; 
}

export interface Input_lp_Album {
  artistSlug?: string | null; 
  artistUuid?: string | null; 
  catalogNumbers?: (string | null)[] | null; 
  collaborators?: (Input_lp_Collaborator | null)[] | null; 
  companies?: (Input_lp_Company | null)[] | null; 
  editorialContent?: string | null; 
  formatDescriptions?: (string | null)[] | null; 
  hasLiveListings?: boolean | null; 
  id?: string | null; 
  identifiers?: (Input_lp_Identifier | null)[] | null; 
  labelName?: string | null; 
  labelSlug?: string | null; 
  labelUuid?: string | null; 
  labelWeight?: number | null; 
  listingCount?: number | null; 
  lowestPriceCents?: number | null; 
  notes?: string | null; 
  releaseDate?: string | null; 
  releaseUuids?: (string | null)[] | null; 
  slug?: string | null; 
  title?: string | null; 
  tracks?: (Input_lp_Track | null)[] | null; 
  uuid?: string | null; 
  artistName?: string | null; 
  highestPrice?: Input_lp_Price | null; 
  lowestPrice?: Input_lp_Price | null; 
  releaseCount?: number | null; 
  artists?: (Input_lp_AlbumArtist | null)[] | null; 
  images?: (Input_lp_LPImage | null)[] | null; 
  attributionId?: string | null; 
  genres?: (string | null)[] | null; 
  deletedAt?: string | null; 
}

export interface Input_lp_Artist {
  id?: string | null; 
  uuid?: string | null; 
  slug?: string | null; 
  name?: string | null; 
  realName?: string | null; 
  profile?: string | null; 
  nameVariations?: (string | null)[] | null; 
  aliases?: (string | null)[] | null; 
  labelUuids?: (string | null)[] | null; 
  masterUuids?: (string | null)[] | null; 
  images?: (Input_lp_LPImage | null)[] | null; 
  listingCount?: number | null; 
}

export interface Input_lp_Author {
  id?: string | null; 
  slug?: string | null; 
  name?: string | null; 
}

export interface Input_lp_Component {
  id?: string | null; 
  pageId?: string | null; 
  position?: number | null; 
  componentType?: string | null; 
  data?: string | null; 
}

export interface Input_lp_CollectionHeader {
  title?: string | null; 
  description?: string | null; 
  metaTitle?: string | null; 
  metaDescription?: string | null; 
  banner?: string | null; 
}

export interface Input_lp_ESListing {
  id?: number | null; 
  images?: (Input_lp_LPImage | null)[] | null; 
  imagesSource?: string | null; 
  state?: string | null; 
}

export interface Input_lp_FacetOption {
  name?: string | null; 
  selected?: boolean | null; 
  queryParams?: string | null; 
  count?: number | null; 
  param?: string | null; 
  value?: string | null; 
  all?: boolean | null; 
  facet?: Input_lp_Facet | null; 
}

export interface Input_lp_Facet {
  name?: string | null; 
  options?: (Input_lp_FacetOption | null)[] | null; 
  widgetType?: string | null; 
}

export interface Input_lp_PriceDrop {
  percent?: number | null; 
  display?: string | null; 
}

export interface Input_lp_ListingState {
  slug?: string | null; 
  description?: string | null; 
}

export interface Input_lp_FeedListingCondition {
  displayName?: string | null; 
  slug?: string | null; 
  uuid?: string | null; 
}

export interface Input_lp_SaleRibbon {
  display?: string | null; 
  value?: string | null; 
  slug?: string | null; 
}

export interface Input_lp_Ribbon {
  display?: string | null; 
  reason?: lp_Ribbon_Reason | null; 
}

export interface Input_lp_FeedListing {
  state?: Input_lp_ListingState | null; 
  priceDrop?: Input_lp_PriceDrop | null; 
  price?: Input_lp_Price | null; 
  condition?: Input_lp_FeedListingCondition | null; 
  auction?: boolean | null; 
  saleRibbon?: Input_lp_SaleRibbon | null; 
  mediaConditionUuid?: string | null; 
  sleeveConditionUuid?: string | null; 
  categoryUuids?: (string | null)[] | null; 
  buyerPrice?: Input_lp_Price | null; 
  originalPrice?: Input_lp_Price | null; 
  ribbon?: Input_lp_Ribbon | null; 
}

export interface Input_lp_FeedItemLinks {
  savedSearch?: Input_lp_Link | null; 
  web?: Input_lp_Link | null; 
  image?: Input_lp_Link | null; 
}

export interface Input_lp_FeedItem {
  id?: string | null; 
  title?: string | null; 
  type?: string | null; 
  Links?: Input_lp_FeedItemLinks | null; 
  feedSource?: string | null; 
  Listing?: Input_lp_FeedListing | null; 
  description?: string | null; 
  subtitle?: string | null; 
}

export interface Input_lp_FeedLinks {
  next?: Input_lp_Link | null; 
  prev?: Input_lp_Link | null; 
}

export interface Input_lp_Label {
  id?: string | null; 
  uuid?: string | null; 
  name?: string | null; 
  slug?: string | null; 
  masterCount?: number | null; 
  artistCount?: number | null; 
  contactInfo?: string | null; 
  profile?: string | null; 
  urls?: (string | null)[] | null; 
}

export interface Input_lp_Auction {
  id?: string | null; 
  endAt?: Timestamp | null; 
  startAt?: Timestamp | null; 
}

export interface Input_lp_CloudinaryPhoto {
  id?: number | null; 
  publicId?: string | null; 
  version?: string | null; 
  format?: string | null; 
  resourceType?: string | null; 
  path?: string | null; 
  previewUrl?: string | null; 
}

export interface Input_lp_PhotosLinks {
  largeCrop?: Input_lp_Link | null; 
  smallCrop?: Input_lp_Link | null; 
  full?: Input_lp_Link | null; 
  thumbnail?: Input_lp_Link | null; 
}

export interface Input_lp_Photos {
  Links?: Input_lp_PhotosLinks | null; 
}

export interface Input_lp_ListingShop {
  id?: number | null; 
  name?: string | null; 
  slug?: string | null; 
}

export interface Input_lp_Location {
  countryCode?: string | null; 
  locality?: string | null; 
  region?: string | null; 
}

export interface Input_lp_ListingLinks {
  shop?: Input_lp_Link | null; 
}

export interface Input_lp_ListingSale {
  id?: number | null; 
  curatedSetId?: number | null; 
  isFeatured?: boolean | null; 
}

export interface Input_lp_Listing {
  id?: number | null; 
  albumUuid?: string | null; 
  releaseCountry?: string | null; 
  releaseGenres?: (string | null)[] | null; 
  formats?: (string | null)[] | null; 
  price?: Input_lp_Price | null; 
  releaseUuid?: string | null; 
  shop?: Input_lp_ListingShop | null; 
  title?: string | null; 
  conditions?: (string | null)[] | null; 
  release?: Input_lp_Release | null; 
  isMyListing?: boolean | null; 
  description?: string | null; 
  storageLocation?: string | null; 
  sellerCost?: Input_lp_Price | null; 
  cloudinaryPhotos?: (Input_lp_CloudinaryPhoto | null)[] | null; 
  album?: Input_lp_Album | null; 
  photos?: Input_lp_Photos | null; 
  location?: Input_lp_Location | null; 
  images?: (Input_lp_LPImage | null)[] | null; 
  mediaConditionUuid?: string | null; 
  sleeveConditionUuid?: string | null; 
  imagesSource?: string | null; 
  sku?: string | null; 
  sellerId?: number | null; 
  Links?: Input_lp_ListingLinks | null; 
  storefront?: Input_lp_ListingShop | null; 
  state?: string | null; 
  saleRibbon?: Input_lp_SaleRibbon | null; 
  sales?: (Input_lp_ListingSale | null)[] | null; 
  offersEnabled?: boolean | null; 
  priceDrop?: Input_lp_PriceDrop | null; 
  hasOfferForBuyer?: boolean | null; 
  acceptedPaymentMethods?: (string | null)[] | null; 
  auction?: Input_lp_Auction | null; 
}

export interface Input_lp_PageImageLinks {
  original?: Input_lp_Link | null; 
}

export interface Input_lp_PageImage {
  Links?: Input_lp_PageImageLinks | null; 
}

export interface Input_lp_Page {
  id?: string | null; 
  slug?: string | null; 
  goLiveAt?: string | null; 
  title?: string | null; 
  description?: string | null; 
  metaTitle?: string | null; 
  metaDescription?: string | null; 
  componentIds?: (string | null)[] | null; 
  imageAttributionUri?: string | null; 
  imageKey?: string | null; 
  authorId?: string | null; 
  pageType?: string | null; 
  blacklistFromEmbeds?: boolean | null; 
}

export interface Input_lp_PublicPage {
  id?: string | null; 
  slug?: string | null; 
  goLiveAt?: string | null; 
  title?: string | null; 
  description?: string | null; 
  metaTitle?: string | null; 
  metaDescription?: string | null; 
  componentIds?: (string | null)[] | null; 
  imageAttributionUri?: string | null; 
  image?: Input_lp_PageImage | null; 
  authorId?: string | null; 
  pageType?: string | null; 
  authorName?: string | null; 
  albumIds?: (string | null)[] | null; 
  imageKey?: string | null; 
}

export interface Input_lp_Pagination {
  total?: number | null; 
  currentPage?: number | null; 
  perPage?: number | null; 
}

export interface Input_lp_SortOption {
  queryParams?: string | null; 
  name?: string | null; 
  selected?: boolean | null; 
}

export interface Input_lp_SaleLinks {
  web?: Input_lp_Link | null; 
}

export interface Input_lp_Sale {
  slug?: string | null; 
  title?: string | null; 
  description?: string | null; 
  metaTitle?: string | null; 
  metaDescription?: string | null; 
  live?: boolean | null; 
  startsAt?: string | null; 
  endsAt?: string | null; 
  banner?: string | null; 
  Links?: Input_lp_SaleLinks | null; 
  buyerIneligibilityReason?: string | null; 
  saleType?: string | null; 
  discountPercent?: number | null; 
  shopName?: string | null; 
  shopSlug?: string | null; 
  curatedSetId?: number | null; 
}

export interface Input_lp_SuggestionMetadata {
  primaryImage?: string | null; 
  artistName?: string | null; 
  labelName?: string | null; 
  releaseYear?: number | null; 
}

export interface Input_lp_Suggestion {
  type?: string | null; 
  url?: string | null; 
  value?: string | null; 
  score?: number | null; 
  metadata?: Input_lp_SuggestionMetadata | null; 
  Links?: Input_lp_SuggestionLinks | null; 
}

export interface Input_lp_SuggestionLinks {
  sell?: Input_lp_Link | null; 
}

export interface Input_lp_SuggestionData {
  suggestions?: (Input_lp_Suggestion | null)[] | null; 
}

export interface Input_lp_ShopLocation {
  region?: string | null; 
  locality?: string | null; 
  countryCode?: string | null; 
  displayLocation?: string | null; 
}

export interface Input_lp_ShopLinks {
  storefrontBanner?: Input_lp_Link | null; 
  avatar?: Input_lp_Link | null; 
}

export interface Input_lp_ShopShippingPolicy {
  regionCode?: string | null; 
  rate?: Input_lp_Price | null; 
  incrementalRate?: Input_lp_Price | null; 
  freeShippingThreshold?: Input_lp_Price | null; 
}

export interface Input_lp_Shop {
  id?: number | null; 
  slug?: string | null; 
  name?: string | null; 
  description?: string | null; 
  preferredSeller?: boolean | null; 
  location?: Input_lp_ShopLocation | null; 
  feedbackCount?: number | null; 
  rating?: number | null; 
  onVacation?: boolean | null; 
  quickShipper?: boolean | null; 
  quickResponder?: boolean | null; 
  isMyShop?: boolean | null; 
  Links?: Input_lp_ShopLinks | null; 
  shippingPolicy?: Input_lp_ShopShippingPolicy | null; 
}

export interface Input_lp_ShopReturnPolicyProfile {
  type?: string | null; 
  name?: string | null; 
  returnWindowDays?: number | null; 
}

export interface Input_lp_ShopReturnPolicies {
  returnPolicyProfiles?: (Input_lp_ShopReturnPolicyProfile | null)[] | null; 
  restockingFeePercent?: number | null; 
  isReverbRecommended?: boolean | null; 
  specialConditions?: string | null; 
}

export interface Input_lp_BulkPagination {
  total?: number | null; 
  offset?: number | null; 
  limit?: number | null; 
}

export interface Input_lp_ExternalOrderTransaction {
  id?: string | null; 
  merchandisingUuid?: string | null; 
  mediaConditionUuid?: string | null; 
  currency?: string | null; 
  price?: string | null; 
  usdPrice?: string | null; 
  source?: string | null; 
}

export interface Input_lp_APIArtist {
  uuid?: string | null; 
  name?: string | null; 
  slug?: string | null; 
  featuredAlbumIds?: (string | null)[] | null; 
  bannerImageKey?: string | null; 
}

export interface Input_lp_APIImage {
  key?: string | null; 
}

export interface Input_lp_APIImageGroup {
  images?: (Input_lp_APIImage | null)[] | null; 
}

export interface Input_lp_APIRelease {
  uuid?: string | null; 
  catalogNumbers?: (string | null)[] | null; 
  title?: string | null; 
  artistName?: string | null; 
  releaseDate?: string | null; 
  formats?: (Input_lp_ReleaseFormat | null)[] | null; 
  genres?: (string | null)[] | null; 
  masterUuid?: string | null; 
  country?: string | null; 
  merchandisingTitle?: string | null; 
  shippingQuantity?: number | null; 
  tracks?: (Input_lp_Track | null)[] | null; 
  collaborators?: (Input_lp_Collaborator | null)[] | null; 
}

export interface Input_lp_APILabel {
  uuid?: string | null; 
  slug?: string | null; 
  name?: string | null; 
}

export interface Input_lp_MyFollowsResponse {
  followGroups?: (Input_lp_FollowGroup | null)[] | null; 
}

export interface Input_lp_FollowGroup {
  follows?: (Input_lp_Follow | null)[] | null; 
  title?: string | null; 
  savedSearchType?: string | null; 
}

export interface Input_lp_Follow {
  title?: string | null; 
  savedSearchType?: string | null; 
  Links?: Input_lp_FollowLinks | null; 
  header?: string | null; 
  subtitle?: string | null; 
  id?: string | null; 
  queryParams?: Input_lp_FollowCreateRequest | null; 
  digestEnabled?: boolean | null; 
}

export interface Input_lp_FollowLinks {
  remove?: Input_lp_Link | null; 
  search?: Input_lp_Link | null; 
  image?: Input_lp_Link | null; 
}

export interface Input_lp_FollowCreateRequest {
  format?: (string | null)[] | null; 
  labels?: (string | null)[] | null; 
  priceMax?: string | null; 
  priceMin?: string | null; 
  currency?: string | null; 
  storefrontSlug?: string | null; 
  album?: string | null; 
  artist?: string | null; 
  release?: string | null; 
  mediaCondition?: (string | null)[] | null; 
  sleeveCondition?: (string | null)[] | null; 
  shipsTo?: (string | null)[] | null; 
  lengths?: (string | null)[] | null; 
}

export interface Input_lp_FindFollowResponse {
  following?: boolean | null; 
}

export interface Input_lp_GetFollowResponse {
  following?: boolean | null; 
  follow?: Input_lp_Follow | null; 
}

export interface Input_lp_ListingsSearchRequest {
  format?: (string | null)[] | null; 
  labels?: (string | null)[] | null; 
  priceMax?: string | null; 
  priceMin?: string | null; 
  currency?: string | null; 
  storefrontSlug?: string | null; 
  album?: string | null; 
  artist?: string | null; 
  release?: string | null; 
  mediaCondition?: (string | null)[] | null; 
  sleeveCondition?: (string | null)[] | null; 
}

export interface Input_lp_ListingsSearchResponse {
  listings?: (Input_lp_Listing | null)[] | null; 
}

export interface Input_lp_FollowDigestUpdateRequest {
  enabled?: boolean | null; 
}

export interface Input_lp_FollowDigestUpdateResponse {
  enabled?: boolean | null; 
}

export interface Input_lp_ShopListingsResponse {
  listings?: (Input_lp_Listing | null)[] | null; 
  facets?: (Input_lp_Facet | null)[] | null; 
  meta?: Input_lp_Pagination | null; 
  sorts?: (Input_lp_SortOption | null)[] | null; 
}

export interface Input_lp_SuggestionsResponse {
  data?: Input_lp_SuggestionData | null; 
}

export interface Input_lp_ReleasesResponse {
  releases?: (Input_lp_Release | null)[] | null; 
}

export interface Input_lp_GuestCartResponse {
  products?: (Input_lp_CartProduct | null)[] | null; 
  selectedPaymentMethod?: string | null; 
}

export interface Input_lp_CartProduct {
  id?: string | null; 
  quantity?: number | null; 
}

export interface Input_lp_ListingsBulkResponse {
  listings?: (Input_lp_ESListing | null)[] | null; 
}

export interface Input_lp_ListingsShowResponse {
  listing?: Input_lp_Listing | null; 
}

export interface Input_lp_AlbumsListingsResponse {
  listings?: (Input_lp_Listing | null)[] | null; 
  facets?: (Input_lp_Facet | null)[] | null; 
  meta?: Input_lp_Pagination | null; 
  sorts?: (Input_lp_SortOption | null)[] | null; 
}

export interface Input_lp_AlbumsIndexResponse {
  albums?: (Input_lp_Album | null)[] | null; 
  facets?: (Input_lp_Facet | null)[] | null; 
  meta?: Input_lp_Pagination | null; 
}

export interface Input_lp_AlbumsReleasesResponse {
  releases?: (Input_lp_Release | null)[] | null; 
  facets?: (Input_lp_Facet | null)[] | null; 
  meta?: Input_lp_Pagination | null; 
  sorts?: (Input_lp_SortOption | null)[] | null; 
}

export interface Input_lp_CartResponse {
  cartItems?: Input_lp_CartItem | null; 
  estimatedTotal?: Input_lp_Price | null; 
  subtotal?: Input_lp_Price | null; 
  shipping?: Input_lp_Price | null; 
  paymentMethodGroups?: Input_lp_PaymentMethodGroup | null; 
}

export interface Input_lp_CartItem {
  merchandisingUuid?: string | null; 
  productId?: number | null; 
  itemPrice?: Input_lp_Price | null; 
  traits?: (string | null)[] | null; 
  title?: string | null; 
  shippingPrice?: Input_lp_Price | null; 
  type?: string | null; 
}

export interface Input_lp_PaymentMethodGroup {
  directCheckout?: Input_lp_Countable | null; 
  paypal?: Input_lp_Countable | null; 
}

export interface Input_lp_Countable {
  count?: number | null; 
}

export interface Input_lp_FeedIndex {
  items?: (Input_lp_FeedItem | null)[] | null; 
  Links?: Input_lp_FeedLinks | null; 
}

export interface Input_lp_LabelResponse {
  label?: Input_lp_Label | null; 
}

export interface Input_lp_ArtistShowResponse {
  artist?: Input_lp_Artist | null; 
}

export interface Input_lp_ShopShowResponse {
  shop?: Input_lp_Shop | null; 
}

export interface Input_lp_ShopReturnPoliciesResponse {
  returnPolicies?: Input_lp_ShopReturnPolicies | null; 
}

export interface Input_lp_SaleShowResponse {
  sale?: Input_lp_Sale | null; 
}

export interface Input_lp_SaleIndexResponse {
  sales?: (Input_lp_Sale | null)[] | null; 
}

export interface Input_lp_PagesResponse {
  pages?: (Input_lp_PublicPage | null)[] | null; 
  meta?: Input_lp_BulkPagination | null; 
}

export interface Input_lp_ComponentsResponse {
  components?: (Input_lp_Component | null)[] | null; 
}

export interface Input_lp_AdminPagesRequest {
  page?: string | null; 
  perPage?: string | null; 
  q?: string | null; 
  ids?: (string | null)[] | null; 
  pageType?: string | null; 
}

export interface Input_lp_AdminPagesResponse {
  pages?: (Input_lp_Page | null)[] | null; 
  meta?: Input_lp_Pagination | null; 
}

export interface Input_lp_PageRequest {
  page?: Input_lp_Page | null; 
}

export interface Input_lp_PageResponse {
  page?: Input_lp_Page | null; 
}

export interface Input_lp_ComponentResponse {
  component?: Input_lp_Component | null; 
}

export interface Input_lp_ComponentRequest {
  component?: Input_lp_Component | null; 
}

export interface Input_lp_ComponentDeleteRequest {
  id?: string | null; 
}

export interface Input_lp_ExternalOrderTransactionsRequest {
  ids?: (string | null)[] | null; 
  merchandisingUuid?: string | null; 
  limit?: string | null; 
  offset?: string | null; 
}

export interface Input_lp_ExternalOrderTransactionsResponse {
  externalOrderTransactions?: (Input_lp_ExternalOrderTransaction | null)[] | null; 
  meta?: Input_lp_BulkPagination | null; 
}

export interface Input_lp_ExternalOrderTransactionResponse {
  externalOrderTransaction?: Input_lp_ExternalOrderTransaction | null; 
}

export interface Input_lp_ExternalOrderTransactionRequest {
  externalOrderTransaction?: Input_lp_ExternalOrderTransaction | null; 
}

export interface Input_lp_AuthorIndexResponse {
  authors?: (Input_lp_Author | null)[] | null; 
}

export interface Input_lp_AuthorRequest {
  author?: Input_lp_Author | null; 
}

export interface Input_lp_AuthorResponse {
  author?: Input_lp_Author | null; 
}

export interface Input_lp_AdminAlbumRequest {
  album?: Input_lp_AdminAlbum | null; 
}

export interface Input_lp_CuratedSetCollectionHeaderResponse {
  collectionHeader?: Input_lp_CollectionHeader | null; 
}

export interface Input_lp_ComponentsRequest {
  ids?: (string | null)[] | null; 
  limit?: string | null; 
  offset?: string | null; 
}

export interface Input_lp_V2AlbumsIndexRequest {
  ids?: (string | null)[] | null; 
  limit?: string | null; 
  offset?: string | null; 
}

export interface Input_lp_APIArtistsResponse {
  artists?: (Input_lp_APIArtist | null)[] | null; 
  meta?: Input_lp_BulkPagination | null; 
}

export interface Input_lp_APIArtists {
  artists?: (Input_lp_APIArtist | null)[] | null; 
}

export interface Input_lp_APIRelatedArtistsResponse {
  artists?: (Input_lp_APIArtists | null)[] | null; 
  meta?: Input_lp_BulkPagination | null; 
}

export interface Input_lp_APIArtistsRequest {
  slugs?: (string | null)[] | null; 
  limit?: string | null; 
  offset?: string | null; 
}

export interface Input_lp_APIRelatedArtistsRequest {
  ids?: (string | null)[] | null; 
  type?: lp_APIArtistType | null; 
  limit?: string | null; 
  offset?: string | null; 
}

export interface Input_lp_APIImagesRequest {
  ids?: (string | null)[] | null; 
  type?: lp_APIImagesRequest_ImageType | null; 
  limit?: string | null; 
  offset?: string | null; 
}

export interface Input_lp_APIImagesResponse {
  imageGroups?: (Input_lp_APIImageGroup | null)[] | null; 
  meta?: Input_lp_BulkPagination | null; 
}

export interface Input_lp_APILabelsRequest {
  releaseIds?: (string | null)[] | null; 
  limit?: string | null; 
  offset?: string | null; 
}

export interface Input_lp_APILabelsResponse {
  labels?: (Input_lp_APILabel | null)[] | null; 
  meta?: Input_lp_BulkPagination | null; 
}

export interface Input_lp_APIReleasesResponse {
  releases?: (Input_lp_APIRelease | null)[] | null; 
  meta?: Input_lp_BulkPagination | null; 
}

export interface Input_lp_APIReleasesRequest {
  ids?: (string | null)[] | null; 
  limit?: string | null; 
  offset?: string | null; 
  barcode?: string | null; 
}

export interface Input_lp_APIErrorDetail {
  target?: string | null; 
  message?: string | null; 
}

export interface Input_lp_APIErrorResponse {
  message?: string | null; 
  errors?: (Input_lp_APIErrorDetail | null)[] | null; 
  requestId?: string | null; 
}

export interface Input_lp_V2AlbumsIndexResponse {
  albums?: (Input_lp_Album | null)[] | null; 
  meta?: Input_lp_BulkPagination | null; 
}

export interface Input_reverb_config_cache_AddressValidationsResponse {
  addresses?: (Input_reverb_config_cache_AddressValidation | null)[] | null; 
}

export interface Input_reverb_config_cache_AddressValidation {
  postalCode?: string | null; 
  state?: string | null; 
}

export interface Input_reverb_config_cache_CurrencyResponse {
  rates?: (Input_reverb_config_cache_ExchangeRate | null)[] | null; 
}

export interface Input_reverb_config_cache_ExchangeRate {
  from?: string | null; 
  to?: string | null; 
  rate?: number | null; 
}

export interface Input_reverb_config_cache_VersionedExchangeRatesRequest {
  version?: string | null; 
  inverseReverseRates?: boolean | null; 
}

export interface Input_reverb_config_cache_VersionedExchangeRatesResponse {
  rates?: (Input_reverb_config_cache_ExchangeRate | null)[] | null; 
}

export interface Input_reverb_config_cache_ExchangeCurrencyResponse {
  amountMinorUnits?: number | null; 
  from?: string | null; 
  to?: string | null; 
}

export interface Input_reverb_config_cache_TaxRatesResponse {
  rates?: (Input_reverb_config_cache_TaxRate | null)[] | null; 
}

export interface Input_reverb_config_cache_TaxRate {
  postalcode?: string | null; 
  totalSalesTaxRate?: string | null; 
  totalSalesTaxRatePrecision?: number | null; 
  state?: string | null; 
}

export interface Input_reverb_config_cache_TranslationsRequest {
  project?: string | null; 
  resource?: string | null; 
  locales?: (string | null)[] | null; 
}

export interface Input_reverb_config_cache_TranslationsResponse_Translation {
  project?: string | null; 
  resource?: string | null; 
  locale?: string | null; 
  content?: string | null; 
}

export interface Input_reverb_config_cache_TranslationsResponse {
  translations?: (Input_reverb_config_cache_TranslationsResponse_Translation | null)[] | null; 
}

export interface Input_reverb_config_cache_Filters {
  productType?: string | null; 
  category?: string | null; 
  brand?: string | null; 
  productFamily?: string | null; 
}

export interface Input_reverb_config_cache_SearchRedirect {
  queryTerm?: string | null; 
  redirectTerm?: string | null; 
  type?: reverb_config_cache_SearchRedirect_Type | null; 
  redirectTerms?: (string | null)[] | null; 
  filters?: Input_reverb_config_cache_Filters | null; 
}

export interface Input_reverb_config_cache_SearchRedirectsRequest {
  _?: boolean | null; 
}

export interface Input_reverb_config_cache_SearchRedirectsResponse {
  redirects?: (Input_reverb_config_cache_SearchRedirect | null)[] | null; 
}

export interface Input_reverb_config_cache_LocalizedAddressFormDisplayName {
  locale?: string | null; 
  displayName?: string | null; 
}

export interface Input_reverb_config_cache_AddressFormField {
  fieldName?: string | null; 
  displayNames?: (Input_reverb_config_cache_LocalizedAddressFormDisplayName | null)[] | null; 
  required?: boolean | null; 
}

export interface Input_reverb_config_cache_AddressFormConfig {
  countryCode?: string | null; 
  fields?: (Input_reverb_config_cache_AddressFormField | null)[] | null; 
}

export interface Input_reverb_config_cache_InternationalAddressFormConfigResponse {
  configs?: (Input_reverb_config_cache_AddressFormConfig | null)[] | null; 
}

export interface Input_braze_GetUserDataRequest {
  externalIds?: (string | null)[] | null; 
  fieldsToExport?: (string | null)[] | null; 
}

export interface Input_braze_GetUserDataResponse {
  message?: string | null; 
  users?: (Input_braze_BrazeUser | null)[] | null; 
  invalidUserIds?: (string | null)[] | null; 
}

export interface Input_braze_BrazeUser {
  externalId?: string | null; 
  email?: string | null; 
  pushSubscribe?: string | null; 
  emailSubscribe?: string | null; 
}

export interface Input_braze_UserTrackRequest {
  attributes?: (Input_braze_UserAttributes | null)[] | null; 
}

export interface Input_braze_UserAttributes {
  externalId?: string | null; 
  brazeId?: string | null; 
  UpdateExistingOnly?: boolean | null; 
  emailSubscribe?: string | null; 
  pushSubscribe?: string | null; 
}

export interface Input_braze_UserTrackResponse {
  message?: string | null; 
}

export interface Input_braze_SetSubscriptionGroupsRequest {
  subscriptionGroupId?: string | null; 
  subscriptionState?: string | null; 
  externalId?: string | null; 
  email?: string | null; 
}

export interface Input_braze_SetSubscriptionGroupsResponse {
  message?: string | null; 
}

export interface Input_braze_GetSubscriptionGroupsRequest {
  externalId?: (string | null)[] | null; 
  email?: (string | null)[] | null; 
}

export interface Input_braze_GetSubscriptionGroupsResponse {
  users?: (Input_braze_SubscriptionUser | null)[] | null; 
  totalCount?: number | null; 
  message?: string | null; 
}

export interface Input_braze_SubscriptionUser {
  email?: string | null; 
  phone?: string | null; 
  externalId?: string | null; 
  subscriptionGroups?: (Input_braze_SubscriptionGroupConfig | null)[] | null; 
}

export interface Input_braze_SubscriptionGroupConfig {
  id?: string | null; 
  name?: string | null; 
  channel?: string | null; 
  status?: string | null; 
}

export interface Input_braze_OptInRecipient {
  externalUserId?: string | null; 
}

export interface Input_braze_TriggerCampaignSendRequest {
  campaignId?: string | null; 
  recipients?: (Input_braze_OptInRecipient | null)[] | null; 
}

export interface Input_braze_TriggerCampaignSendResponse {
  dispatchId?: string | null; 
  message?: string | null; 
}

export interface Input_reverb_pricing_PriceScoreQuery {
  canonicalProductId?: string | null; 
  conditionUuid?: string | null; 
  price?: Input_reverb_pricing_Money | null; 
  countryCode?: string | null; 
}

export interface Input_reverb_pricing_Money {
  amount?: string | null; 
  amountCents?: number | null; 
  currency?: string | null; 
  symbol?: string | null; 
  display?: string | null; 
}

export interface Input_reverb_pricing_PriceScoresRequest {
  priceScoreQueries?: (Input_reverb_pricing_PriceScoreQuery | null)[] | null; 
}

export interface Input_reverb_pricing_PriceRecommendation {
  canonicalProductId?: string | null; 
  conditionUuid?: string | null; 
  priceLow?: Input_reverb_pricing_Money | null; 
  priceHigh?: Input_reverb_pricing_Money | null; 
  priceMiddle?: Input_reverb_pricing_Money | null; 
  priceLowThirtyDaysAgo?: Input_reverb_pricing_Money | null; 
  priceHighThirtyDaysAgo?: Input_reverb_pricing_Money | null; 
  priceMiddleThirtyDaysAgo?: Input_reverb_pricing_Money | null; 
  countryCode?: string | null; 
  comparisonShoppingPageId?: string | null; 
}

export interface Input_reverb_pricing_PriceRecommendationsResponse {
  priceRecommendations?: (Input_reverb_pricing_PriceRecommendation | null)[] | null; 
}

export interface Input_reverb_pricing_PriceScore {
  canonicalProductId?: string | null; 
  conditionUuid?: string | null; 
  priceScore?: number | null; 
}

export interface Input_reverb_pricing_PriceScoresResponse {
  priceScores?: (Input_reverb_pricing_PriceScore | null)[] | null; 
}

export interface Input_reverb_personalization_User {
  id?: string | null; 
  recommendedListingIds?: (string | null)[] | null; 
}

export interface Input_reverb_personalization_GetUserRequest {
  id?: string | null; 
  version?: number | null; 
}

export interface Input_reverb_personalization_RefreshListingRecommendationsRequest {
  _?: boolean | null; 
}

export interface Input_reverb_personalization_RefreshListingRecommendationsRequestV2 {
  runId?: string | null; 
}

export interface Input_reverb_personalization_RefreshTrendingSearchesRequest {
  _?: boolean | null; 
}

export interface Input_reverb_personalization_TrendingSearch {
  query?: string | null; 
  score?: number | null; 
  categorySlug?: string | null; 
  categoryUuid?: string | null; 
}

export interface Input_reverb_personalization_TrendingSearchesResponse {
  trendingSearches?: (Input_reverb_personalization_TrendingSearch | null)[] | null; 
}
export interface CspSearchQueryArgs {
  input?: Input_reverb_search_CSPSearchRequest | null; 
}
export interface CompletionsQueryArgs {
  input?: Input_reverb_search_CompletionsRequest | null; 
}
export interface PriceGuidesSearchQueryArgs {
  input?: Input_reverb_search_PriceGuidesSearchRequest | null; 
}
export interface ListingsSearchQueryArgs {
  input?: Input_reverb_search_ListingsSearchRequest | null; 
}
export interface ListingsAggregationSearchQueryArgs {
  input?: Input_reverb_search_ListingsSearchRequest | null; 
}
export interface ShippingRegionFilterQueryArgs {
  input?: Input_reverb_search_ShippingRegionFilterRequest | null; 
}
export interface BumpedSortedListingsQueryArgs {
  input?: Input_reverb_search_ListingsSearchRequest | null; 
}
export interface PriceRecordsSearchQueryArgs {
  input?: Input_rql_PriceRecordSearchRequest | null; 
}
export interface OrdersSearchQueryArgs {
  input?: Input_rql_OrdersSearchRequest | null; 
}
export interface GearCollectionItemsSearchQueryArgs {
  input?: Input_rql_GearCollectionItemsSearchRequest | null; 
}
export interface SimilarListingsSearchQueryArgs {
  input?: Input_reverb_search_SimilarListingsSearchRequest | null; 
}
export interface UserWatchesSearchQueryArgs {
  input?: Input_core_apimessages_UserWatchesRequest | null; 
}
export interface LpCompletionsQueryArgs {
  input?: Input_reverb_search_LPCompletionsRequest | null; 
}
export interface LpListingsSearchQueryArgs {
  input?: Input_reverb_search_LPListingsSearchRequest | null; 
}
export interface LpAlbumsSearchQueryArgs {
  input?: Input_reverb_search_LPAlbumSearchRequest | null; 
}
export interface LpArtistsSearchQueryArgs {
  input?: Input_reverb_search_LPArtistSearchRequest | null; 
}
export interface LpLabelsSearchQueryArgs {
  input?: Input_reverb_search_LPLabelSearchRequest | null; 
}
export interface LpReleasesSearchQueryArgs {
  input?: Input_reverb_search_LPReleasesSearchRequest | null; 
}
export interface CmsPagesSearchQueryArgs {
  input?: Input_reverb_search_CMSPagesSearchRequest | null; 
}
export interface ExchangeRatesQueryArgs {
  input?: Input_reverb_config_cache_ExchangeRateRequest | null; 
}
export interface CollectionQueryArgs {
  input?: Input_rql_ReflectCollectionQuery | null; 
}
export interface NodeQueryArgs {
  input?: Input_rql_ReflectQuery | null; 
}
export interface ListingsQueryArgs {
  input?: Input_rql_CollectionQuery | null; 
}
export interface CspsQueryArgs {
  input?: Input_rql_CollectionQuery | null; 
}
export interface SellingFeesQueryArgs {
  input?: Input_core_apimessages_SellingFeesRequest | null; 
}
export interface CmsPagesQueryArgs {
  input?: Input_cms_PagesRequest | null; 
}
export interface CmsPagesFetchQueryArgs {
  input?: Input_rql_CollectionWithDraftsQuery | null; 
}
export interface CuratedSetsQueryArgs {
  input?: Input_rql_CollectionQuery | null; 
}
export interface CollectionHeaderQueryArgs {
  input?: Input_core_apimessages_CollectionHeaderRequest | null; 
}
export interface ArticlesQueryArgs {
  input?: Input_rql_CollectionQuery | null; 
}
export interface BrandsQueryArgs {
  input?: Input_rql_CollectionQuery | null; 
}
export interface ChatDepartmentQueryArgs {
  input?: Input_core_apimessages_ChatDepartmentRequest | null; 
}
export interface CategoriesQueryArgs {
  input?: Input_core_apimessages_CategoriesRequest | null; 
}
export interface TraitValuesQueryArgs {
  input?: Input_reverb_taxonomy_GetTraitValueTranslationsRequest | null; 
}
export interface OrderBundlesQueryArgs {
  input?: Input_rql_CollectionQuery | null; 
}
export interface RecentlyViewedListingsQueryArgs {
  input?: Input_core_apimessages_RecentlyViewedListingsRequest | null; 
}
export interface SearchMetadataQueryArgs {
  input?: Input_core_apimessages_SearchMetadataRequest | null; 
}
export interface TrendingSearchesQueryArgs {
  input?: Input_reverb_personalization_GetTrendingSearchesRequest | null; 
}
export interface PriceRecommendationsQueryArgs {
  input?: Input_reverb_pricing_PriceRecommendationsRequest | null; 
}
export interface CspPriceRecommendationsQueryArgs {
  input?: Input_reverb_pricing_CSPPriceRecommendationsRequest | null; 
}
export interface CpSuggestionsQueryArgs {
  input?: Input_rql_CollectionQuery | null; 
}
export interface SeedListingDataQueryArgs {
  input?: Input_core_apimessages_GenerateDraftRequest | null; 
}
export interface AdServeQueryArgs {
  input?: Input_core_apimessages_AdServeRequest | null; 
}
export interface MyDirectCheckoutProfileQueryArgs {
  input?: Input_core_apimessages_MyDirectCheckoutProfileRequest | null; 
}
export interface PromotionalCodeVerifyQueryArgs {
  input?: Input_core_apimessages_VerifyPromotionalCodeRequest | null; 
}
export interface BearerV2TokenQueryArgs {
  input?: Input_core_apimessages_BearerV2TokenRequest | null; 
}
export interface FeaturedListingQueryArgs {
  input?: Input_arbiter_FeaturedListingRequest | null; 
}
export interface AlbumQueryArgs {
  input?: Input_rql_NodeQuery | null; 
}
export interface ArtistQueryArgs {
  input?: Input_rql_NodeQuery | null; 
}
export interface CategoryQueryArgs {
  input?: Input_rql_NodeQuery | null; 
}
export interface CartitemQueryArgs {
  input?: Input_rql_NodeQuery | null; 
}
export interface CmspageQueryArgs {
  input?: Input_rql_NodeQuery | null; 
}
export interface CollectionheaderQueryArgs {
  input?: Input_rql_NodeQuery | null; 
}
export interface CspQueryArgs {
  input?: Input_rql_NodeQuery | null; 
}
export interface CheckoutQueryArgs {
  input?: Input_rql_NodeQuery | null; 
}
export interface CheckoutactionQueryArgs {
  input?: Input_rql_NodeQuery | null; 
}
export interface CuratedsetQueryArgs {
  input?: Input_rql_NodeQuery | null; 
}
export interface ExpresssalecheckoutQueryArgs {
  input?: Input_rql_NodeQuery | null; 
}
export interface GearcollectionitemQueryArgs {
  input?: Input_rql_NodeQuery | null; 
}
export interface OrderQueryArgs {
  input?: Input_rql_NodeQuery | null; 
}
export interface ListingQueryArgs {
  input?: Input_rql_NodeQuery | null; 
}
export interface MyshopQueryArgs {
  input?: Input_rql_NodeQuery | null; 
}
export interface NegotiationQueryArgs {
  input?: Input_rql_NodeQuery | null; 
}
export interface OrderbundleQueryArgs {
  input?: Input_rql_NodeQuery | null; 
}
export interface PagesQueryArgs {
  input?: Input_lp_PagesRequest | null; 
}
export interface PageQueryArgs {
  input?: Input_rql_NodeQuery | null; 
}
export interface PriceguideQueryArgs {
  input?: Input_rql_NodeQuery | null; 
}
export interface PubliccomponentQueryArgs {
  input?: Input_rql_NodeQuery | null; 
}
export interface ReleaseQueryArgs {
  input?: Input_rql_NodeQuery | null; 
}
export interface SaleQueryArgs {
  input?: Input_rql_NodeQuery | null; 
}
export interface SellercheckoutQueryArgs {
  input?: Input_rql_NodeQuery | null; 
}
export interface ShipmentQueryArgs {
  input?: Input_rql_NodeQuery | null; 
}
export interface ShopQueryArgs {
  input?: Input_rql_NodeQuery | null; 
}
export interface StorefrontQueryArgs {
  input?: Input_rql_NodeQuery | null; 
}
export interface UserQueryArgs {
  input?: Input_rql_NodeQuery | null; 
}
export interface ArticleQueryArgs {
  input?: Input_rql_NodeQuery | null; 
}
export interface BrandQueryArgs {
  input?: Input_rql_NodeQuery | null; 
}
export interface AuctionQueryArgs {
  input?: Input_rql_NodeQuery | null; 
}
export interface WatchQueryArgs {
  input?: Input_rql_NodeQuery | null; 
}
export interface SiteBannerQueryArgs {
  input?: Input_core_apimessages_SiteBannerRequest | null; 
}
export interface SitebannerQueryArgs {
  input?: Input_rql_NodeQuery | null; 
}
export interface PricechangeQueryArgs {
  input?: Input_rql_NodeQuery | null; 
}
export interface MyupdateQueryArgs {
  input?: Input_rql_NodeQuery | null; 
}
export interface MyupdatespromotionQueryArgs {
  input?: Input_rql_NodeQuery | null; 
}
export interface ShipmentpackageQueryArgs {
  input?: Input_rql_NodeQuery | null; 
}
export interface PublicpricerecordQueryArgs {
  input?: Input_rql_NodeQuery | null; 
}
export interface AdvertisersSearchQueryArgs {
  input?: Input_core_apimessages_AdvertisersSearchRequest | null; 
}
export interface AdCampaignsSearchQueryArgs {
  input?: Input_core_apimessages_AdCampaignsSearchRequest | null; 
}
export interface AdGroupsSearchQueryArgs {
  input?: Input_core_apimessages_AdGroupsSearchRequest | null; 
}
export interface AdsSearchQueryArgs {
  input?: Input_core_apimessages_AdsSearchRequest | null; 
}
export interface AdZonesSearchQueryArgs {
  input?: Input_core_apimessages_AdZonesSearchRequest | null; 
}
export interface UserSearchQueryArgs {
  input?: Input_core_apimessages_AdminUserSearchRequest | null; 
}
export interface AdvertiserQueryArgs {
  input?: Input_rql_NodeQuery | null; 
}
export interface AdcampaignQueryArgs {
  input?: Input_rql_NodeQuery | null; 
}
export interface AdgroupQueryArgs {
  input?: Input_rql_NodeQuery | null; 
}
export interface AdQueryArgs {
  input?: Input_rql_NodeQuery | null; 
}
export interface AdzoneQueryArgs {
  input?: Input_rql_NodeQuery | null; 
}
export interface UniversalpromocampaignQueryArgs {
  input?: Input_rql_NodeQuery | null; 
}
export interface ImageCspArgs {
  input: Input_core_apimessages_ImagesRequest; 
}
export interface ImagesCspArgs {
  input: Input_rql_ImageQuery; 
}
export interface ReviewsCspArgs {
  input?: Input_core_apimessages_CSPReviewsRequest | null; 
}
export interface SimilarCsPsCspArgs {
  input?: Input_reverb_search_CSPSearchRequest | null; 
}
export interface ExpressSalePriceEstimateCspArgs {
  input?: Input_rql_ExpressSalePriceEstimate | null; 
}
export interface ImagesCategoryArgs {
  input: Input_core_apimessages_ImagesRequest; 
}
export interface ChildCategoriesCategoryArgs {
  input?: Input_reverb_search_ListingsSearchRequest | null; 
}
export interface ImagesBrandArgs {
  input: Input_core_apimessages_ImagesRequest; 
}
export interface MetricsBrandArgs {
  input?: Input_rql_BrandOrderSearch | null; 
}
export interface StatsByCspRqlBrandManagerArgs {
  input?: Input_reverb_reporting_CSPStatsByCSPRequest | null; 
}
export interface StatsByDateRqlBrandManagerArgs {
  input?: Input_reverb_reporting_CSPStatsRequest | null; 
}
export interface TotalStatsRqlBrandManagerArgs {
  input?: Input_reverb_reporting_CSPStatsRequest | null; 
}
export interface ImagesListingArgs {
  input: Input_core_apimessages_ImagesRequest; 
}
export interface ShippingListingArgs {
  input?: Input_core_apimessages_ShippingPricesRequest | null; 
}
export interface ShopListingArgs {
  input?: Input_core_apimessages_ShopsRequest | null; 
}
export interface OrdersListingArgs {
  input?: Input_core_apimessages_BulkOrdersRequest_Query | null; 
}
export interface SimilarCsPsListingArgs {
  input?: Input_reverb_search_CSPSearchRequest | null; 
}
export interface SimilarListingsListingArgs {
  input?: Input_reverb_search_SimilarListingsSearchRequest | null; 
}
export interface OrderPricingListingArgs {
  input?: Input_rql_OrderPricingQuery | null; 
}
export interface SignalsListingArgs {
  input?: Input_reverb_signals_SignalRequest | null; 
}
export interface BannerShopArgs {
  namedTransform?: core_apimessages_NamedImageTransforms | null; 
}
export interface AllShippingRatesCoreApimessagesShippingProfileArgs {
  input?: Input_core_apimessages_NodeRequest_Lookup_Params_ShippingRates | null; 
}
export interface ShopUserArgs {
  input?: Input_core_apimessages_ShopsRequest | null; 
}
export interface FeedbackUserArgs {
  input: Input_core_apimessages_FeedbacksRequest; 
}
export interface ListingsCollectionReleaseArgs {
  input?: Input_reverb_search_LPListingsSearchRequest | null; 
}
export interface AuctionBidsAuctionArgs {
  input: Input_core_apimessages_AuctionBidsRequest; 
}
export interface ImagesPriceGuideArgs {
  input: Input_core_apimessages_ImagesRequest; 
}
export interface ImagesCuratedSetArgs {
  input: Input_core_apimessages_ImagesRequest; 
}
export interface OrderHistoryNegotiationArgs {
  input?: Input_rql_OrderQuery | null; 
}
export interface ImagesArticleArgs {
  input: Input_core_apimessages_ImagesRequest; 
}
export interface ImagesGearCollectionItemArgs {
  input: Input_core_apimessages_ImagesRequest; 
}
export interface FullBleedImageCollectionHeaderArgs {
  transform?: string | null; 
}
export interface ImageCoreApimessagesSearchFilterPresetArgs {
  transform?: string | null; 
}
export interface ActionCheckoutArgs {
  input?: Input_rql_CheckoutActionRequestInput | null; 
}
export interface OrdersSearchMyShopArgs {
  input?: Input_reverb_search_OrderSearchRequest | null; 
}
export interface InteractionsMyShopArgs {
  input?: Input_arbiter_SellerInteractionTimeSeriesRequest | null; 
}
export interface ListingsMyShopArgs {
  input?: Input_reverb_search_ListingsSearchRequest | null; 
}
export interface OrderRefundStatsMyShopArgs {
  input?: Input_core_apimessages_MyShopOrderRefundStatsRequest | null; 
}
export interface OrdersForShipmentSearchSellerCheckoutArgs {
  input?: Input_rql_OrderQuery | null; 
}
export interface ImagesMyUpdatesPromotionArgs {
  input: Input_core_apimessages_ImagesRequest; 
}
export interface FollowsRqlMeArgs {
  input?: Input_rql_FollowsQuery | null; 
}
export interface FeedRqlMeArgs {
  input: Input_rql_FeedQuery; 
}
export interface RecentlyViewedListingsRqlMeArgs {
  input: Input_core_apimessages_RecentlyViewedListingsRequest; 
}
export interface ShipmentsRqlMeArgs {
  input: Input_rql_CollectionQuery; 
}
export interface MyNegotiationsRqlMeArgs {
  input?: Input_rql_NegotiationQuery | null; 
}
export interface MyAuctionsRqlMeArgs {
  input?: Input_reverb_search_AuctionsSearchRequest | null; 
}
export interface OrdersRqlMeArgs {
  input: Input_rql_CollectionQuery; 
}
export interface SellerCheckoutRqlMeArgs {
  input?: Input_rql_SellerCheckoutInput | null; 
}
export interface WatchesRqlMeArgs {
  input?: Input_core_apimessages_WatchesRequest | null; 
}
export interface BrandManagerBrandsRqlMeArgs {
  input?: Input_core_apimessages_BrandManagerBrandsRequest | null; 
}
export interface BrandManagerBrandRqlMeArgs {
  input: Input_core_apimessages_BrandManagerBrandRequest; 
}
export interface RecommendedListingsRqlMeArgs {
  input?: Input_reverb_search_ListingsSearchRequest | null; 
}
export interface UpdatesRqlMeArgs {
  input?: Input_rql_MyUpdatesQuery | null; 
}
export interface CreateBidMutationArgs {
  input?: Input_core_apimessages_BidsCreateRequest | null; 
}
export interface AdminDeleteBidMutationArgs {
  input?: Input_core_apimessages_DeleteRequest | null; 
}
export interface CreateNegotiationMutationArgs {
  input?: Input_core_apimessages_CreateNegotiationRequest | null; 
}
export interface CreateAutoOfferMutationArgs {
  input?: Input_core_apimessages_CreateAutoOfferRequest | null; 
}
export interface UpdateShopKycMutationArgs {
  input?: Input_core_apimessages_UpdateShopKYCRequest | null; 
}
export interface SetupShopPaymentMethodsMutationArgs {
  input?: Input_core_apimessages_SetupPaymentMethodsRequest | null; 
}
export interface UpdateMyShopBillingMethodMutationArgs {
  input?: Input_core_apimessages_UpdateBillingMethodRequest | null; 
}
export interface BillingMethodVerifyShopperMutationArgs {
  input?: Input_core_apimessages_BillingMethodVerifyShopperRequest | null; 
}
export interface BillingMethodIdentifyShopperMutationArgs {
  input?: Input_core_apimessages_BillingMethodIdentifyShopperRequest | null; 
}
export interface BillingMethodChallengeShopperMutationArgs {
  input?: Input_core_apimessages_BillingMethodChallengeShopperRequest | null; 
}
export interface PromotionalCodeRedeemMutationArgs {
  input?: Input_core_apimessages_RedeemPromotionalCodeRequest | null; 
}
export interface UpdateNegotiationMutationArgs {
  input?: Input_core_apimessages_UpdateNegotiationRequest | null; 
}
export interface ShippingProtectionMutationArgs {
  input?: Input_core_apimessages_ShippingProtectionRequest | null; 
}
export interface CreateShipmentMutationArgs {
  input?: Input_core_apimessages_CreateShipmentRequest | null; 
}
export interface PurchaseShippingRateMutationArgs {
  input?: Input_core_apimessages_PurchaseShippingRateRequest | null; 
}
export interface UpdateReturnPolicyMutationArgs {
  input?: Input_core_apimessages_UpdateReturnPolicyRequest | null; 
}
export interface UpdateMyShopMutationArgs {
  input?: Input_core_apimessages_UpdateMyShopRequest | null; 
}
export interface GenerateDraftMutationArgs {
  input?: Input_core_apimessages_GenerateDraftRequest | null; 
}
export interface UpdateMyAddressMutationArgs {
  input?: Input_core_apimessages_UpdateAddressRequest | null; 
}
export interface DeleteMyAddressMutationArgs {
  input?: Input_core_apimessages_AddressDeleteRequest | null; 
}
export interface UpdateMyShopShippingProfilesMutationArgs {
  input?: Input_core_apimessages_UpdateMyShopShippingProfilesRequest | null; 
}
export interface CreateWatchMutationArgs {
  input?: Input_core_apimessages_WatchesCreateRequest | null; 
}
export interface DeleteWatchMutationArgs {
  input?: Input_core_apimessages_WatchesDeleteRequest | null; 
}
export interface UpdateFeedbackRequestMutationArgs {
  input?: Input_core_apimessages_UpdateFeedbackRequest | null; 
}
export interface DeclineFeedbackRequestMutationArgs {
  input?: Input_core_apimessages_DeclineFeedbackRequest | null; 
}
export interface AddListingToCuratedSetMutationArgs {
  input?: Input_core_apimessages_AdminCuratedSetsCurateRequest | null; 
}
export interface RemoveListingFromCuratedSetMutationArgs {
  input?: Input_core_apimessages_AdminCuratedSetsCurateRequest | null; 
}
export interface FeatureListingInCuratedSetMutationArgs {
  input?: Input_core_apimessages_AdminCuratedSetsCurateRequest | null; 
}
export interface UnfeatureListingInCuratedSetMutationArgs {
  input?: Input_core_apimessages_AdminCuratedSetsCurateRequest | null; 
}
export interface VoteProductReviewMutationArgs {
  input?: Input_core_apimessages_ProductReviewVoteRequest | null; 
}
export interface AddListingToMyCuratedSetMutationArgs {
  input?: Input_core_apimessages_MyCuratedSetMembershipRequest | null; 
}
export interface RemoveListingFromMyCuratedSetMutationArgs {
  input?: Input_core_apimessages_MyCuratedSetMembershipRequest | null; 
}
export interface ReverifyCreditCardMutationArgs {
  input?: Input_core_apimessages_ReverifyCreditCardRequest | null; 
}
export interface CreateCheckoutMutationArgs {
  input?: Input_core_apimessages_CheckoutCreateRequest | null; 
}
export interface CreateExpressSaleCheckoutMutationArgs {
  input?: Input_core_apimessages_CreateExpressSaleCheckoutRequest | null; 
}
export interface CompleteExpressSaleCheckoutMutationArgs {
  input?: Input_core_apimessages_CompleteExpressSaleCheckoutRequest | null; 
}
export interface UpdateCheckoutShippingAddressMutationArgs {
  input?: Input_core_apimessages_CheckoutUpdateShippingAddressRequest | null; 
}
export interface SelectCheckoutShippingAddressMutationArgs {
  input?: Input_core_apimessages_CheckoutSelectShippingAddressRequest | null; 
}
export interface SelectCheckoutOrderShippingMethodMutationArgs {
  input?: Input_core_apimessages_CheckoutSelectOrderShippingMethodRequest | null; 
}
export interface UpdateCheckoutShippingEstimateMutationArgs {
  input?: Input_core_apimessages_CheckoutUpdateShippingEstimateRequest | null; 
}
export interface FinalizeDigitalWalletPaymentMutationArgs {
  input?: Input_core_apimessages_CheckoutFinalizeDigitalWalletPaymentRequest | null; 
}
export interface FinalizeDirectCheckoutPaymentMutationArgs {
  input?: Input_core_apimessages_CheckoutFinalizeDirectCheckoutPaymentRequest | null; 
}
export interface CreateCheckoutPaymentRedirectUrlMutationArgs {
  input?: Input_core_apimessages_CheckoutCreatePaymentRedirectUrlRequest | null; 
}
export interface StartCheckoutForListingMutationArgs {
  input?: Input_core_apimessages_StartCheckoutForListingRequest | null; 
}
export interface ApplyCheckoutDiscountCodeMutationArgs {
  input?: Input_core_apimessages_ApplyCheckoutDiscountCodeRequest | null; 
}
export interface SelectCheckoutCreditCardMutationArgs {
  input?: Input_core_apimessages_SelectCheckoutCreditCardRequest | null; 
}
export interface UpdateCheckoutGuestCreditCardMutationArgs {
  input?: Input_core_apimessages_UpdateCheckoutGuestCreditCardRequest | null; 
}
export interface SelectCheckoutPaymentMethodMutationArgs {
  input?: Input_core_apimessages_SelectCheckoutPaymentMethodRequest | null; 
}
export interface EditCartMutationArgs {
  input?: Input_core_apimessages_CheckoutCartEditRequest | null; 
}
export interface EditCheckoutCartMutationArgs {
  input?: Input_rql_CheckoutCartEditRequest | null; 
}
export interface FinalizeRedirectPaymentCheckoutMutationArgs {
  input?: Input_core_apimessages_CheckoutFinalizeRedirectPaymentCheckoutRequest | null; 
}
export interface CheckoutVerifyShopperMutationArgs {
  input?: Input_core_apimessages_CheckoutVerifyShopperRequest | null; 
}
export interface CheckoutIdentifyShopperMutationArgs {
  input?: Input_core_apimessages_CheckoutIdentifyShopperRequest | null; 
}
export interface CheckoutChallengeShopperMutationArgs {
  input?: Input_core_apimessages_CheckoutChallengeShopperRequest | null; 
}
export interface GuestCheckoutVerifyShopperMutationArgs {
  input?: Input_core_apimessages_GuestCheckoutVerifyShopperRequest | null; 
}
export interface GuestCheckoutApplePayLineItemsMutationArgs {
  input?: Input_core_apimessages_GuestCheckoutApplePayLineItemsRequest | null; 
}
export interface GuestCheckoutApplePayPaymentMutationArgs {
  input?: Input_core_apimessages_GuestCheckoutApplePayPaymentRequest | null; 
}
export interface DeleteAutoOfferMutationArgs {
  input?: Input_core_apimessages_DeleteAutoOfferRequest | null; 
}
export interface CancelOrderMutationArgs {
  input?: Input_core_apimessages_CancelOrderRequest | null; 
}
export interface TrackBumpInteractionMutationArgs {
  input?: Input_core_apimessages_TrackBumpInteractionRequest | null; 
}
export interface RegisterMyPacklinkAccountMutationArgs {
  input?: Input_core_apimessages_RegisterMyPacklinkAccountRequest | null; 
}
export interface LoginMyPacklinkAccountMutationArgs {
  input?: Input_core_apimessages_LoginMyPacklinkAccountRequest | null; 
}
export interface CreatePacklinkDraftMutationArgs {
  input?: Input_core_apimessages_CreatePacklinkDraftRequest | null; 
}
export interface CrupdateGearCollectionItemMutationArgs {
  input?: Input_core_apimessages_UpdateGearCollectionItemRequest | null; 
}
export interface DeleteGearCollectionItemMutationArgs {
  input?: Input_core_apimessages_DeleteGearCollectionItemRequest | null; 
}
export interface CreateTaxIdentificationMutationArgs {
  input?: Input_core_apimessages_CreateTaxIdentificationRequest | null; 
}
export interface UpdateTaxIdentificationMutationArgs {
  input?: Input_core_apimessages_UpdateTaxIdentificationRequest | null; 
}
export interface DeactivateTaxIdentificationMutationArgs {
  input?: Input_core_apimessages_DeactivateTaxIdentificationRequest | null; 
}
export interface CreateMyPlaidLinkTokenMutationArgs {
  input?: Input_core_apimessages_CreateMyPlaidLinkTokenRequest | null; 
}
export interface SaveMyPlaidAccountMutationArgs {
  input?: Input_core_apimessages_SaveMyPlaidAccountRequest | null; 
}
export interface DelinkUserServiceMutationArgs {
  input?: Input_core_apimessages_DelinkUserServiceRequest | null; 
}
export interface CancelPlaidAccountMutationArgs {
  input?: Input_core_apimessages_CancelPlaidAccountRequest | null; 
}
export interface UpdateUniversalPromoCampaignMutationArgs {
  input?: Input_core_apimessages_UpdateUniversalPromoCampaignRequest | null; 
}
export interface CrupdateListingMutationArgs {
  input?: Input_core_apimessages_UpdateListingRequest | null; 
}
export interface CreateMyCreditCardMutationArgs {
  input?: Input_core_apimessages_CreateMyCreditCardRequest | null; 
}
export interface UpdateMyCreditCardMutationArgs {
  input?: Input_core_apimessages_UpdateMyCreditCardRequest | null; 
}
export interface DeleteMyCreditCardMutationArgs {
  input?: Input_core_apimessages_DeleteMyCreditCardRequest | null; 
}
export interface RemoveFeedEntryMutationArgs {
  input?: Input_reverb_feed_RemoveEntryRequest | null; 
}
export interface SetMyLpFollowDigestsMutationArgs {
  input?: Input_reverb_feed_SetFollowDigestsByUserRequest | null; 
}
export interface BulkTrackImpressionsMutationArgs {
  input?: Input_arbiter_BulkTrackImpressionsRequest | null; 
}
export interface SetEmailSubscriptionMutationArgs {
  input?: Input_rql_EmailSubscription | null; 
}
export interface SetEmailGlobalSubscribeMutationArgs {
  input?: Input_rql_SetGlobalSubscribeRequest | null; 
}
export interface TriggerOptInEmailMutationArgs {
  input?: Input_rql_Blank | null; 
}
export interface ExchangeCurrencyMutationArgs {
  input?: Input_reverb_config_cache_ExchangeCurrencyRequest | null; 
}
export interface UpdateAdvertiserMutationArgs {
  input?: Input_core_apimessages_UpdateAdvertiserRequest | null; 
}
export interface UpdateAdCampaignMutationArgs {
  input?: Input_core_apimessages_UpdateAdCampaignRequest | null; 
}
export interface UpdateAdGroupMutationArgs {
  input?: Input_core_apimessages_UpdateAdGroupRequest | null; 
}
export interface CopyAdGroupMutationArgs {
  input?: Input_core_apimessages_CopyAdGroupRequest | null; 
}
export interface UpdateAdGroupKeywordsMutationArgs {
  input?: Input_core_apimessages_UpdateAdGroupKeywordsRequest | null; 
}
export interface UpdateAdMutationArgs {
  input?: Input_core_apimessages_UpdateAdRequest | null; 
}
export interface UpdateAdZoneMutationArgs {
  input?: Input_core_apimessages_UpdateAdZoneRequest | null; 
}
export interface DeleteAdMutationArgs {
  input?: Input_core_apimessages_DeleteAdRequest | null; 
}
export interface TokenMparticleMparticleOauthArgs {
  input?: Input_mparticle_TokenRequest | null; 
}
export interface ProfileMparticleMparticleArgs {
  input?: Input_mparticle_ProfileRequest | null; 
}
export interface GetFeedEntriesReverbFeedFeedServiceArgs {
  input?: Input_reverb_feed_EntriesRequest | null; 
}
export interface GetFollowsReverbFeedFeedServiceArgs {
  input?: Input_reverb_feed_FollowsRequest | null; 
}
export interface FindFollowReverbFeedFeedServiceArgs {
  input?: Input_reverb_feed_FindFollowRequest | null; 
}
export interface FindFollowBySearchableReverbFeedFeedServiceArgs {
  input?: Input_reverb_feed_FindFollowBySearchableRequest | null; 
}
export interface FindFollowByIdReverbFeedFeedServiceArgs {
  input?: Input_reverb_feed_FindFollowByIdRequest | null; 
}
export interface FindFollowsBySearchableReverbFeedFeedServiceArgs {
  input?: Input_reverb_feed_FindFollowsBySearchableRequest | null; 
}
export interface GetSavedSearchReverbFeedFeedServiceArgs {
  input?: Input_reverb_feed_GetSavedSearchRequest | null; 
}
export interface CreateSavedSearchReverbFeedFeedServiceArgs {
  input?: Input_reverb_feed_CreateSavedSearchRequest | null; 
}
export interface UpdateSavedSearchReverbFeedFeedServiceArgs {
  input?: Input_reverb_feed_UpdateSavedSearchRequest | null; 
}
export interface RemoveFollowReverbFeedFeedServiceArgs {
  input?: Input_reverb_feed_RemoveFollowRequest | null; 
}
export interface RemoveFollowsBySearchableReverbFeedFeedServiceArgs {
  input?: Input_reverb_feed_RemoveFollowsBySearchableRequest | null; 
}
export interface UpsertFollowReverbFeedFeedServiceArgs {
  input?: Input_reverb_feed_FollowUpdated | null; 
}
export interface SetFollowDigestReverbFeedFeedServiceArgs {
  input?: Input_reverb_feed_SetFollowDigestRequest | null; 
}
export interface SetFollowDigestsByUserReverbFeedFeedServiceArgs {
  input?: Input_reverb_feed_SetFollowDigestsByUserRequest | null; 
}
export interface GetAlertableUsersReverbFeedFeedServiceArgs {
  input?: Input_reverb_feed_AlertableUsersRequest | null; 
}
export interface GetAlertableUsersStreamReverbFeedFeedServiceArgs {
  input?: Input_reverb_feed_AlertableUsersStreamRequest | null; 
}
export interface GetUserDigestsReverbFeedFeedServiceArgs {
  input?: Input_reverb_feed_UserDigestsRequest | null; 
}
export interface ClearUserDigestReverbFeedFeedServiceArgs {
  input?: Input_reverb_feed_ClearUserDigestRequest | null; 
}
export interface PruneFeedReverbFeedFeedServiceArgs {
  input?: Input_reverb_feed_PruneFeedRequest | null; 
}
export interface RemoveEntryReverbFeedFeedServiceArgs {
  input?: Input_reverb_feed_RemoveEntryRequest | null; 
}
export interface GetFollowedSavedSearchesReverbFeedFeedServiceArgs {
  input?: Input_reverb_feed_GetFollowedSavedSearchesRequest | null; 
}
export interface GetMyUpdatesReverbUpdatesUpdatesServiceArgs {
  input?: Input_reverb_updates_MyUpdatesRequest | null; 
}
export interface CreateMyUpdateReverbUpdatesUpdatesServiceArgs {
  input?: Input_reverb_updates_CreateMyUpdateRequest | null; 
}
export interface GetPagesCmsPublicApiArgs {
  input?: Input_cms_PagesRequest | null; 
}
export interface NodesPublicComponentsCmsPublicApiArgs {
  input?: Input_cms_NodeRequest | null; 
}
export interface BumpedSortedListingsArbiterArbiterArgs {
  input?: Input_arbiter_BumpedSortedListingsRequest | null; 
}
export interface FeaturedListingArbiterArbiterArgs {
  input?: Input_arbiter_FeaturedListingRequest | null; 
}
export interface BulkFeaturedListingArbiterArbiterArgs {
  input?: Input_arbiter_BulkFeaturedListingRequest | null; 
}
export interface BulkTrackImpressionsArbiterArbiterArgs {
  input?: Input_arbiter_BulkTrackImpressionsRequest | null; 
}
export interface SellerInteractionTimeSeriesArbiterArbiterArgs {
  input?: Input_arbiter_SellerInteractionTimeSeriesRequest | null; 
}
export interface BulkBumpInteractionCountsArbiterArbiterArgs {
  input?: Input_arbiter_BulkBumpInteractionCountsRequest | null; 
}
export interface BidsCreateCoreApimessagesCoreArgs {
  input?: Input_core_apimessages_BidsCreateRequest | null; 
}
export interface AdminBidsDeleteCoreApimessagesCoreArgs {
  input?: Input_core_apimessages_DeleteRequest | null; 
}
export interface ListingsCoreApimessagesCoreArgs {
  input?: Input_core_apimessages_ListingsRequest | null; 
}
export interface OrdersCustomsInfoCoreApimessagesCoreArgs {
  input?: Input_core_apimessages_OrdersCustomsInfoRequest | null; 
}
export interface MeCoreApimessagesCoreArgs {
  input?: Input_google_protobuf_Empty | null; 
}
export interface BrandManagerBrandsCoreApimessagesCoreArgs {
  input?: Input_core_apimessages_BrandManagerBrandsRequest | null; 
}
export interface BrandManagerBrandCoreApimessagesCoreArgs {
  input?: Input_core_apimessages_BrandManagerBrandRequest | null; 
}
export interface CsPsCoreApimessagesCoreArgs {
  input?: Input_core_apimessages_CSPsRequest | null; 
}
export interface CsPsInventoryCoreApimessagesCoreArgs {
  input?: Input_core_apimessages_CSPsInventoryRequest | null; 
}
export interface CsPsFeaturedListingCoreApimessagesCoreArgs {
  input?: Input_core_apimessages_CSPsFeaturedListingRequest | null; 
}
export interface CsPsVideoCoreApimessagesCoreArgs {
  input?: Input_core_apimessages_CSPsVideoRequest | null; 
}
export interface CsPsSpecsCoreApimessagesCoreArgs {
  input?: Input_core_apimessages_CSPsSpecsRequest | null; 
}
export interface CountriesCoreApimessagesCoreArgs {
  input?: Input_google_protobuf_Empty | null; 
}
export interface CuratedSetsCoreApimessagesCoreArgs {
  input?: Input_core_apimessages_CuratedSetsRequest | null; 
}
export interface ShippingPricesCoreApimessagesCoreArgs {
  input?: Input_core_apimessages_ShippingPricesRequest | null; 
}
export interface UsersCoreApimessagesCoreArgs {
  input?: Input_core_apimessages_UsersRequest | null; 
}
export interface ShopShippingProfilesCoreApimessagesCoreArgs {
  input?: Input_core_apimessages_ShopShippingProfilesRequest | null; 
}
export interface CreateMyCuratedSetsMembershipCoreApimessagesCoreArgs {
  input?: Input_core_apimessages_MyCuratedSetMembershipRequest | null; 
}
export interface DeleteMyCuratedSetsMembershipCoreApimessagesCoreArgs {
  input?: Input_core_apimessages_MyCuratedSetMembershipRequest | null; 
}
export interface MyDirectCheckoutProfileCoreApimessagesCoreArgs {
  input?: Input_core_apimessages_MyDirectCheckoutProfileRequest | null; 
}
export interface MyShopOrderRefundStatsCoreApimessagesCoreArgs {
  input?: Input_core_apimessages_MyShopOrderRefundStatsRequest | null; 
}
export interface MyShopShippingProfilesCoreApimessagesCoreArgs {
  input?: Input_core_apimessages_MyShopShippingProfilesRequest | null; 
}
export interface MyShopShippingRatesCoreApimessagesCoreArgs {
  input?: Input_core_apimessages_MyShopShippingRatesRequest | null; 
}
export interface UpdateMyShopShippingProfilesCoreApimessagesCoreArgs {
  input?: Input_core_apimessages_UpdateMyShopShippingProfilesRequest | null; 
}
export interface ArticlesCoreApimessagesCoreArgs {
  input?: Input_core_apimessages_ArticlesRequest | null; 
}
export interface ShopsCoreApimessagesCoreArgs {
  input?: Input_core_apimessages_ShopsRequest | null; 
}
export interface SearchFilterPresetsCoreApimessagesCoreArgs {
  input?: Input_core_apimessages_SearchFilterPresetsRequest | null; 
}
export interface CategoriesCoreApimessagesCoreArgs {
  input?: Input_core_apimessages_CategoriesRequest | null; 
}
export interface BulkCategoriesCoreApimessagesCoreArgs {
  input?: Input_core_apimessages_BulkCategoriesRequest | null; 
}
export interface CollectionHeaderCoreApimessagesCoreArgs {
  input?: Input_core_apimessages_CollectionHeaderRequest | null; 
}
export interface SearchMetadataCoreApimessagesCoreArgs {
  input?: Input_core_apimessages_SearchMetadataRequest | null; 
}
export interface MyAddressesCoreApimessagesCoreArgs {
  input?: Input_core_apimessages_MyAddressesRequest | null; 
}
export interface DeleteMyAddressCoreApimessagesCoreArgs {
  input?: Input_core_apimessages_AddressDeleteRequest | null; 
}
export interface AutoOfferCreateCoreApimessagesCoreArgs {
  input?: Input_core_apimessages_CreateAutoOfferRequest | null; 
}
export interface AutoOffersCoreApimessagesCoreArgs {
  input?: Input_core_apimessages_AutoOffersRequest | null; 
}
export interface AutoOffersDeleteCoreApimessagesCoreArgs {
  input?: Input_core_apimessages_DeleteAutoOfferRequest | null; 
}
export interface NegotiationsCreateCoreApimessagesCoreArgs {
  input?: Input_core_apimessages_CreateNegotiationRequest | null; 
}
export interface NegotiationsAcceptCoreApimessagesCoreArgs {
  input?: Input_core_apimessages_UpdateNegotiationRequest | null; 
}
export interface NegotiationsRejectCoreApimessagesCoreArgs {
  input?: Input_core_apimessages_UpdateNegotiationRequest | null; 
}
export interface NegotiationsCounterCoreApimessagesCoreArgs {
  input?: Input_core_apimessages_UpdateNegotiationRequest | null; 
}
export interface NegotiationsShippingLocationsCoreApimessagesCoreArgs {
  input?: Input_core_apimessages_NegotiationsShippingLocationRequest | null; 
}
export interface PromotionalCodesRedeemCoreApimessagesCoreArgs {
  input?: Input_core_apimessages_RedeemPromotionalCodeRequest | null; 
}
export interface PromotionalCodesVerifyCoreApimessagesCoreArgs {
  input?: Input_core_apimessages_VerifyPromotionalCodeRequest | null; 
}
export interface RecentlyViewedListingsCoreApimessagesCoreArgs {
  input?: Input_core_apimessages_RecentlyViewedListingsRequest | null; 
}
export interface ListingsPricingCoreApimessagesCoreArgs {
  input?: Input_core_apimessages_ListingsPricingRequest | null; 
}
export interface ListingsSpecsCoreApimessagesCoreArgs {
  input?: Input_core_apimessages_ListingsSpecsRequest | null; 
}
export interface SellerListingsCoreApimessagesCoreArgs {
  input?: Input_core_apimessages_ListingsRequest | null; 
}
export interface ListingCountsCoreApimessagesCoreArgs {
  input?: Input_core_apimessages_ListingCountsRequest | null; 
}
export interface MyCountsCoreApimessagesCoreArgs {
  input?: Input_google_protobuf_Empty | null; 
}
export interface ImagesCoreApimessagesCoreArgs {
  input?: Input_core_apimessages_ImagesRequest | null; 
}
export interface BulkImagesCoreApimessagesCoreArgs {
  input?: Input_core_apimessages_BulkImageRequest | null; 
}
export interface OrdersCoreApimessagesCoreArgs {
  input?: Input_core_apimessages_OrdersRequest | null; 
}
export interface OrdersFeedbacksCoreApimessagesCoreArgs {
  input?: Input_core_apimessages_OrderFeedbacksRequest | null; 
}
export interface DeclineFeedbackCoreApimessagesCoreArgs {
  input?: Input_core_apimessages_DeclineFeedbackRequest | null; 
}
export interface UpdateFeedbackCoreApimessagesCoreArgs {
  input?: Input_core_apimessages_UpdateFeedbackRequest | null; 
}
export interface VerifiedShippingAddressCoreApimessagesCoreArgs {
  input?: Input_core_apimessages_OrderVerifyShippingAddressRequest | null; 
}
export interface OrderFlatRateShippingOptionsCoreApimessagesCoreArgs {
  input?: Input_core_apimessages_OrderFlatRateShippingOptionsRequest | null; 
}
export interface NegotiationsCoreApimessagesCoreArgs {
  input?: Input_core_apimessages_NegotiationsRequest | null; 
}
export interface OffersCoreApimessagesCoreArgs {
  input?: Input_core_apimessages_OffersRequest | null; 
}
export interface SellingFeesCoreApimessagesCoreArgs {
  input?: Input_core_apimessages_SellingFeesRequest | null; 
}
export interface MyShopCoreApimessagesCoreArgs {
  input?: Input_google_protobuf_Empty | null; 
}
export interface UpdateMyShopCoreApimessagesCoreArgs {
  input?: Input_core_apimessages_UpdateMyShopRequest | null; 
}
export interface MyShopKycCoreApimessagesCoreArgs {
  input?: Input_google_protobuf_Empty | null; 
}
export interface UpdateMyShopKycCoreApimessagesCoreArgs {
  input?: Input_core_apimessages_UpdateShopKYCRequest | null; 
}
export interface UploadShopKycCompanyRegistrationCoreApimessagesCoreArgs {
  input?: Input_core_apimessages_UploadShopKYCCompanyRegistrationRequest | null; 
}
export interface UpdateMyShopBillingMethodCoreApimessagesCoreArgs {
  input?: Input_core_apimessages_UpdateBillingMethodRequest | null; 
}
export interface BillingMethodIdentifyShopperCoreApimessagesCoreArgs {
  input?: Input_core_apimessages_BillingMethodIdentifyShopperRequest | null; 
}
export interface BillingMethodChallengeShopperCoreApimessagesCoreArgs {
  input?: Input_core_apimessages_BillingMethodChallengeShopperRequest | null; 
}
export interface BillingMethodVerifyShopperCoreApimessagesCoreArgs {
  input?: Input_core_apimessages_BillingMethodVerifyShopperRequest | null; 
}
export interface SetupShopPaymentMethodsCoreApimessagesCoreArgs {
  input?: Input_core_apimessages_SetupPaymentMethodsRequest | null; 
}
export interface ShippingProtectionCoreApimessagesCoreArgs {
  input?: Input_core_apimessages_ShippingProtectionRequest | null; 
}
export interface CreateShipmentCoreApimessagesCoreArgs {
  input?: Input_core_apimessages_CreateShipmentRequest | null; 
}
export interface ShipmentsCoreApimessagesCoreArgs {
  input?: Input_core_apimessages_ShipmentsRequest | null; 
}
export interface PurchaseShippingRateCoreApimessagesCoreArgs {
  input?: Input_core_apimessages_PurchaseShippingRateRequest | null; 
}
export interface ShopAddressesCoreApimessagesCoreArgs {
  input?: Input_core_apimessages_ShopAddressesRequest | null; 
}
export interface TraitsCoreApimessagesCoreArgs {
  input?: Input_core_apimessages_TraitsRequest | null; 
}
export interface MyShopOnboardingCoreApimessagesCoreArgs {
  input?: Input_google_protobuf_Empty | null; 
}
export interface MyCreditCardsCoreApimessagesCoreArgs {
  input?: Input_google_protobuf_Empty | null; 
}
export interface CreateMyCreditCardCoreApimessagesCoreArgs {
  input?: Input_core_apimessages_CreateMyCreditCardRequest | null; 
}
export interface UpdateMyCreditCardCoreApimessagesCoreArgs {
  input?: Input_core_apimessages_UpdateMyCreditCardRequest | null; 
}
export interface DeleteMyCreditCardCoreApimessagesCoreArgs {
  input?: Input_core_apimessages_DeleteMyCreditCardRequest | null; 
}
export interface MyPayoutBalancesCoreApimessagesCoreArgs {
  input?: Input_google_protobuf_Empty | null; 
}
export interface MyUserServicesCoreApimessagesCoreArgs {
  input?: Input_google_protobuf_Empty | null; 
}
export interface MyReverbCreditsCoreApimessagesCoreArgs {
  input?: Input_google_protobuf_Empty | null; 
}
export interface MyCartItemsIndexCoreApimessagesCoreArgs {
  input?: Input_google_protobuf_Empty | null; 
}
export interface GenerateDraftCoreApimessagesCoreArgs {
  input?: Input_core_apimessages_GenerateDraftRequest | null; 
}
export interface ChatDepartmentCoreApimessagesCoreArgs {
  input?: Input_core_apimessages_ChatDepartmentRequest | null; 
}
export interface UpdateReturnPolicyCoreApimessagesCoreArgs {
  input?: Input_core_apimessages_UpdateReturnPolicyRequest | null; 
}
export interface ShopReturnPoliciesCoreApimessagesCoreArgs {
  input?: Input_core_apimessages_ShopReturnPoliciesRequest | null; 
}
export interface BulkTaxPoliciesCoreApimessagesCoreArgs {
  input?: Input_core_apimessages_BulkTaxPoliciesRequest | null; 
}
export interface MyShopPaypalProfileCoreApimessagesCoreArgs {
  input?: Input_google_protobuf_Empty | null; 
}
export interface AccoutAlertsCoreApimessagesCoreArgs {
  input?: Input_google_protobuf_Empty | null; 
}
export interface BrandsCoreApimessagesCoreArgs {
  input?: Input_core_apimessages_BrandsRequest | null; 
}
export interface FeedbackCoreApimessagesCoreArgs {
  input?: Input_core_apimessages_FeedbacksRequest | null; 
}
export interface FeedbackSummariesCoreApimessagesCoreArgs {
  input?: Input_core_apimessages_FeedbackSummariesRequest | null; 
}
export interface PreorderInfoCoreApimessagesCoreArgs {
  input?: Input_core_apimessages_PreorderInfoRequest | null; 
}
export interface VideosCoreApimessagesCoreArgs {
  input?: Input_core_apimessages_VideosRequest | null; 
}
export interface EstimatedMonthlyPaymentsCoreApimessagesCoreArgs {
  input?: Input_core_apimessages_EstimatedMonthlyPaymentsRequest | null; 
}
export interface OtherBuyersWithListingInCartCountsCoreApimessagesCoreArgs {
  input?: Input_core_apimessages_OtherBuyersWithListingInCartCountsRequest | null; 
}
export interface AcceptedPaymentMethodsCoreApimessagesCoreArgs {
  input?: Input_core_apimessages_AcceptedPaymentMethodsRequest | null; 
}
export interface UpdateMyAddressCoreApimessagesCoreArgs {
  input?: Input_core_apimessages_UpdateAddressRequest | null; 
}
export interface AffirmFinancingPromotionsCoreApimessagesCoreArgs {
  input?: Input_core_apimessages_AffirmFinancingPromotionsRequest | null; 
}
export interface AuctionsCoreApimessagesCoreArgs {
  input?: Input_core_apimessages_AuctionsRequest | null; 
}
export interface BidsCoreApimessagesCoreArgs {
  input?: Input_core_apimessages_AuctionBidsRequest | null; 
}
export interface BidDetailsCoreApimessagesCoreArgs {
  input?: Input_core_apimessages_AuctionBidDetailsRequest | null; 
}
export interface MyBidDetailsCoreApimessagesCoreArgs {
  input?: Input_core_apimessages_MyBidDetailsRequest | null; 
}
export interface MyWatchesCoreApimessagesCoreArgs {
  input?: Input_core_apimessages_WatchesRequest | null; 
}
export interface UserWatchesCoreApimessagesCoreArgs {
  input?: Input_core_apimessages_UserWatchesRequest | null; 
}
export interface OrderShippingAddressesCoreApimessagesCoreArgs {
  input?: Input_core_apimessages_OrderShippingAddressesRequest | null; 
}
export interface BuyerOrdersCoreApimessagesCoreArgs {
  input?: Input_core_apimessages_OrdersRequest | null; 
}
export interface OrderPaymentsCoreApimessagesCoreArgs {
  input?: Input_core_apimessages_OrderPaymentsRequest | null; 
}
export interface OrderNotesCoreApimessagesCoreArgs {
  input?: Input_core_apimessages_OrderNotesIndexRequest | null; 
}
export interface SellerOrdersCoreApimessagesCoreArgs {
  input?: Input_core_apimessages_OrdersRequest | null; 
}
export interface CancelOrderCoreApimessagesCoreArgs {
  input?: Input_core_apimessages_CancelOrderRequest | null; 
}
export interface OrderRefundsCoreApimessagesCoreArgs {
  input?: Input_core_apimessages_OrderRefundsRequest | null; 
}
export interface BuyerRefundsCoreApimessagesCoreArgs {
  input?: Input_core_apimessages_BuyerRefundsRequest | null; 
}
export interface CreateMyWatchesCoreApimessagesCoreArgs {
  input?: Input_core_apimessages_WatchesCreateRequest | null; 
}
export interface DeleteMyWatchesCoreApimessagesCoreArgs {
  input?: Input_core_apimessages_WatchesDeleteRequest | null; 
}
export interface StorefrontsCoreApimessagesCoreArgs {
  input?: Input_core_apimessages_StorefrontsRequest | null; 
}
export interface BulkCuratedSetsCoreApimessagesCoreArgs {
  input?: Input_core_apimessages_BulkCuratedSetsRequest | null; 
}
export interface StorefrontReturnPoliciesCoreApimessagesCoreArgs {
  input?: Input_core_apimessages_StorefrontReturnPoliciesRequest | null; 
}
export interface CspReviewsCoreApimessagesCoreArgs {
  input?: Input_core_apimessages_CSPReviewsRequest | null; 
}
export interface VoteProductReviewCoreApimessagesCoreArgs {
  input?: Input_core_apimessages_ProductReviewVoteRequest | null; 
}
export interface ListingsCuratedSetsCoreApimessagesCoreArgs {
  input?: Input_core_apimessages_ListingsCuratedSetsRequest | null; 
}
export interface AddListingToCuratedSetCoreApimessagesCoreArgs {
  input?: Input_core_apimessages_AdminCuratedSetsCurateRequest | null; 
}
export interface RemoveListingFromCuratedSetCoreApimessagesCoreArgs {
  input?: Input_core_apimessages_AdminCuratedSetsCurateRequest | null; 
}
export interface FeatureListingInCuratedSetCoreApimessagesCoreArgs {
  input?: Input_core_apimessages_AdminCuratedSetsCurateRequest | null; 
}
export interface UnfeatureListingInCuratedSetCoreApimessagesCoreArgs {
  input?: Input_core_apimessages_AdminCuratedSetsCurateRequest | null; 
}
export interface BulkAddressesCoreApimessagesCoreArgs {
  input?: Input_core_apimessages_BulkAddressesRequest | null; 
}
export interface BulkOrdersCoreApimessagesCoreArgs {
  input?: Input_core_apimessages_BulkOrdersRequest | null; 
}
export interface ReverifyCreditCardCoreApimessagesCoreArgs {
  input?: Input_core_apimessages_ReverifyCreditCardRequest | null; 
}
export interface ReferAFriendCoreApimessagesCoreArgs {
  input?: Input_google_protobuf_Empty | null; 
}
export interface CheckoutCreatePaymentRedirectUrlCoreApimessagesCoreArgs {
  input?: Input_core_apimessages_CheckoutCreatePaymentRedirectUrlRequest | null; 
}
export interface StartCheckoutForListingCoreApimessagesCoreArgs {
  input?: Input_core_apimessages_StartCheckoutForListingRequest | null; 
}
export interface ApplyCheckoutDiscountCodeCoreApimessagesCoreArgs {
  input?: Input_core_apimessages_ApplyCheckoutDiscountCodeRequest | null; 
}
export interface SelectCheckoutCreditCardCoreApimessagesCoreArgs {
  input?: Input_core_apimessages_SelectCheckoutCreditCardRequest | null; 
}
export interface UpdateCheckoutGuestCreditCardCoreApimessagesCoreArgs {
  input?: Input_core_apimessages_UpdateCheckoutGuestCreditCardRequest | null; 
}
export interface CheckoutUpdateGuestContactInfoCoreApimessagesCoreArgs {
  input?: Input_core_apimessages_CheckoutUpdateGuestContactInfoRequest | null; 
}
export interface SelectCheckoutPaymentMethodCoreApimessagesCoreArgs {
  input?: Input_core_apimessages_SelectCheckoutPaymentMethodRequest | null; 
}
export interface CheckoutFinalizeDigitalWalletPaymentCoreApimessagesCoreArgs {
  input?: Input_core_apimessages_CheckoutFinalizeDigitalWalletPaymentRequest | null; 
}
export interface CheckoutFinalizeRedirectPaymentCheckoutCoreApimessagesCoreArgs {
  input?: Input_core_apimessages_CheckoutFinalizeRedirectPaymentCheckoutRequest | null; 
}
export interface CheckoutFinalizeDirectCheckoutPaymentCoreApimessagesCoreArgs {
  input?: Input_core_apimessages_CheckoutFinalizeDirectCheckoutPaymentRequest | null; 
}
export interface CheckoutVerifyShopperCoreApimessagesCoreArgs {
  input?: Input_core_apimessages_CheckoutVerifyShopperRequest | null; 
}
export interface CheckoutIdentifyShopperCoreApimessagesCoreArgs {
  input?: Input_core_apimessages_CheckoutIdentifyShopperRequest | null; 
}
export interface CheckoutChallengeShopperCoreApimessagesCoreArgs {
  input?: Input_core_apimessages_CheckoutChallengeShopperRequest | null; 
}
export interface GuestCheckoutVerifyShopperCoreApimessagesCoreArgs {
  input?: Input_core_apimessages_GuestCheckoutVerifyShopperRequest | null; 
}
export interface GuestCheckoutApplePayLineItemsCoreApimessagesCoreArgs {
  input?: Input_core_apimessages_GuestCheckoutApplePayLineItemsRequest | null; 
}
export interface GuestCheckoutApplePayPaymentCoreApimessagesCoreArgs {
  input?: Input_core_apimessages_GuestCheckoutApplePayPaymentRequest | null; 
}
export interface BumpKeysCoreApimessagesCoreArgs {
  input?: Input_core_apimessages_BumpKeysRequest | null; 
}
export interface SiteBannerCoreApimessagesCoreArgs {
  input?: Input_core_apimessages_SiteBannerRequest | null; 
}
export interface SiteBannersCoreApimessagesCoreArgs {
  input?: Input_core_apimessages_SiteBannerRequest | null; 
}
export interface TrackBumpInteractionCoreApimessagesCoreArgs {
  input?: Input_core_apimessages_TrackBumpInteractionRequest | null; 
}
export interface CpSuggestionsCoreApimessagesCoreArgs {
  input?: Input_core_apimessages_CPSuggestionsRequest | null; 
}
export interface NodesAdvertisersCoreApimessagesCoreArgs {
  input?: Input_core_apimessages_NodeRequest | null; 
}
export interface NodesAdCampaignsCoreApimessagesCoreArgs {
  input?: Input_core_apimessages_NodeRequest | null; 
}
export interface NodesAddressesCoreApimessagesCoreArgs {
  input?: Input_core_apimessages_NodeRequest | null; 
}
export interface NodesAdGroupsCoreApimessagesCoreArgs {
  input?: Input_core_apimessages_NodeRequest | null; 
}
export interface NodesAdGroupKeywordsCoreApimessagesCoreArgs {
  input?: Input_core_apimessages_NodeRequest | null; 
}
export interface NodesAdsCoreApimessagesCoreArgs {
  input?: Input_core_apimessages_NodeRequest | null; 
}
export interface NodesAdZonesCoreApimessagesCoreArgs {
  input?: Input_core_apimessages_NodeRequest | null; 
}
export interface NodesCspsCoreApimessagesCoreArgs {
  input?: Input_core_apimessages_NodeRequest | null; 
}
export interface NodesCartItemsCoreApimessagesCoreArgs {
  input?: Input_core_apimessages_NodeRequest | null; 
}
export interface NodesCategoriesCoreApimessagesCoreArgs {
  input?: Input_core_apimessages_NodeRequest | null; 
}
export interface NodesCuratedSetsCoreApimessagesCoreArgs {
  input?: Input_core_apimessages_NodeRequest | null; 
}
export interface NodesImagesCoreApimessagesCoreArgs {
  input?: Input_core_apimessages_NodeRequest | null; 
}
export interface NodesListingsCoreApimessagesCoreArgs {
  input?: Input_core_apimessages_NodeRequest | null; 
}
export interface NodesListingsPricingsCoreApimessagesCoreArgs {
  input?: Input_core_apimessages_NodeRequest | null; 
}
export interface NodesListingsSignalsCoreApimessagesCoreArgs {
  input?: Input_core_apimessages_NodeRequest | null; 
}
export interface NodesOrdersCoreApimessagesCoreArgs {
  input?: Input_core_apimessages_NodeRequest | null; 
}
export interface NodesOrderBundlesCoreApimessagesCoreArgs {
  input?: Input_core_apimessages_NodeRequest | null; 
}
export interface NodesPacklinkShipmentsCoreApimessagesCoreArgs {
  input?: Input_core_apimessages_NodeRequest | null; 
}
export interface NodesSalesCoreApimessagesCoreArgs {
  input?: Input_core_apimessages_NodeRequest | null; 
}
export interface NodesShippingRatesCoreApimessagesCoreArgs {
  input?: Input_core_apimessages_NodeRequest | null; 
}
export interface NodesBumpRatesCoreApimessagesCoreArgs {
  input?: Input_core_apimessages_NodeRequest | null; 
}
export interface NodesCspVariantsCoreApimessagesCoreArgs {
  input?: Input_core_apimessages_NodeRequest | null; 
}
export interface NodesCspExpressSaleItemBidsCoreApimessagesCoreArgs {
  input?: Input_core_apimessages_NodeRequest | null; 
}
export interface NodesGearCollectionItemsCoreApimessagesCoreArgs {
  input?: Input_core_apimessages_NodeRequest | null; 
}
export interface NodesPublicPriceRecordsCoreApimessagesCoreArgs {
  input?: Input_core_apimessages_NodeRequest | null; 
}
export interface NodesUsersCoreApimessagesCoreArgs {
  input?: Input_core_apimessages_NodeRequest | null; 
}
export interface NodesNonUserExperimentsCoreApimessagesCoreArgs {
  input?: Input_core_apimessages_NodeRequest | null; 
}
export interface NodesPriceGuidesCoreApimessagesCoreArgs {
  input?: Input_core_apimessages_NodeRequest | null; 
}
export interface NodesAdyenCheckoutPaymentMethodsCoreApimessagesCoreArgs {
  input?: Input_core_apimessages_NodeRequest | null; 
}
export interface NodesTaxIdentificationsCoreApimessagesCoreArgs {
  input?: Input_core_apimessages_NodeRequest | null; 
}
export interface NodesPriceChangesCoreApimessagesCoreArgs {
  input?: Input_core_apimessages_NodeRequest | null; 
}
export interface NodesSiteBannersCoreApimessagesCoreArgs {
  input?: Input_core_apimessages_NodeRequest | null; 
}
export interface NodesShopsCoreApimessagesCoreArgs {
  input?: Input_core_apimessages_NodeRequest | null; 
}
export interface NodesMyUpdatesPromotionsCoreApimessagesCoreArgs {
  input?: Input_core_apimessages_NodeRequest | null; 
}
export interface NodesUniversalPromoCampaignsCoreApimessagesCoreArgs {
  input?: Input_core_apimessages_NodeRequest | null; 
}
export interface NodesShipmentPackagesCoreApimessagesCoreArgs {
  input?: Input_core_apimessages_NodeRequest | null; 
}
export interface RegisterMyPacklinkAccountCoreApimessagesCoreArgs {
  input?: Input_core_apimessages_RegisterMyPacklinkAccountRequest | null; 
}
export interface LoginMyPacklinkAccountCoreApimessagesCoreArgs {
  input?: Input_core_apimessages_LoginMyPacklinkAccountRequest | null; 
}
export interface MyPacklinkAccountStatusCoreApimessagesCoreArgs {
  input?: Input_google_protobuf_Empty | null; 
}
export interface CreatePacklinkDraftCoreApimessagesCoreArgs {
  input?: Input_core_apimessages_CreatePacklinkDraftRequest | null; 
}
export interface DeleteMyGearCollectionItemCoreApimessagesCoreArgs {
  input?: Input_core_apimessages_DeleteGearCollectionItemRequest | null; 
}
export interface UpdateGearCollectionItemCoreApimessagesCoreArgs {
  input?: Input_core_apimessages_UpdateGearCollectionItemRequest | null; 
}
export interface CreateTaxIdentificationCoreApimessagesCoreArgs {
  input?: Input_core_apimessages_CreateTaxIdentificationRequest | null; 
}
export interface UpdateTaxIdentificationCoreApimessagesCoreArgs {
  input?: Input_core_apimessages_UpdateTaxIdentificationRequest | null; 
}
export interface DeactivateTaxIdentificationCoreApimessagesCoreArgs {
  input?: Input_core_apimessages_DeactivateTaxIdentificationRequest | null; 
}
export interface AdServeCoreApimessagesCoreArgs {
  input?: Input_core_apimessages_AdServeRequest | null; 
}
export interface UpdateAdCampaignCoreApimessagesCoreArgs {
  input?: Input_core_apimessages_UpdateAdCampaignRequest | null; 
}
export interface UpdateAdvertiserCoreApimessagesCoreArgs {
  input?: Input_core_apimessages_UpdateAdvertiserRequest | null; 
}
export interface UpdateAdZoneCoreApimessagesCoreArgs {
  input?: Input_core_apimessages_UpdateAdZoneRequest | null; 
}
export interface AdvertisersSearchCoreApimessagesCoreArgs {
  input?: Input_core_apimessages_AdvertisersSearchRequest | null; 
}
export interface AdCampaignsSearchCoreApimessagesCoreArgs {
  input?: Input_core_apimessages_AdCampaignsSearchRequest | null; 
}
export interface AdGroupsSearchCoreApimessagesCoreArgs {
  input?: Input_core_apimessages_AdGroupsSearchRequest | null; 
}
export interface AdsSearchCoreApimessagesCoreArgs {
  input?: Input_core_apimessages_AdsSearchRequest | null; 
}
export interface AdZonesSearchCoreApimessagesCoreArgs {
  input?: Input_core_apimessages_AdZonesSearchRequest | null; 
}
export interface UpdateAdGroupKeywordsCoreApimessagesCoreArgs {
  input?: Input_core_apimessages_UpdateAdGroupKeywordsRequest | null; 
}
export interface CopyAdGroupCoreApimessagesCoreArgs {
  input?: Input_core_apimessages_CopyAdGroupRequest | null; 
}
export interface UpdateAdGroupCoreApimessagesCoreArgs {
  input?: Input_core_apimessages_UpdateAdGroupRequest | null; 
}
export interface UpdateAdCoreApimessagesCoreArgs {
  input?: Input_core_apimessages_UpdateAdRequest | null; 
}
export interface DeleteAdCoreApimessagesCoreArgs {
  input?: Input_core_apimessages_DeleteAdRequest | null; 
}
export interface CreateMyPlaidLinkTokenCoreApimessagesCoreArgs {
  input?: Input_core_apimessages_CreateMyPlaidLinkTokenRequest | null; 
}
export interface SaveMyPlaidAccountCoreApimessagesCoreArgs {
  input?: Input_core_apimessages_SaveMyPlaidAccountRequest | null; 
}
export interface CancelPlaidAccountCoreApimessagesCoreArgs {
  input?: Input_core_apimessages_CancelPlaidAccountRequest | null; 
}
export interface RequestAccountDeletionCoreApimessagesCoreArgs {
  input?: Input_google_protobuf_Empty | null; 
}
export interface DelinkUserServiceCoreApimessagesCoreArgs {
  input?: Input_core_apimessages_DelinkUserServiceRequest | null; 
}
export interface AdaChatTokenCoreApimessagesCoreArgs {
  input?: Input_google_protobuf_Empty | null; 
}
export interface BearerV2TokenCoreApimessagesCoreArgs {
  input?: Input_core_apimessages_BearerV2TokenRequest | null; 
}
export interface ExperimentsCoreApimessagesCoreArgs {
  input?: Input_google_protobuf_Empty | null; 
}
export interface MosaicTilesHomepageCoreApimessagesCoreArgs {
  input?: Input_google_protobuf_Empty | null; 
}
export interface UpdateUniversalPromoCampaignCoreApimessagesCoreArgs {
  input?: Input_core_apimessages_UpdateUniversalPromoCampaignRequest | null; 
}
export interface CheckoutCreateCoreApimessagesCoreArgs {
  input?: Input_core_apimessages_CheckoutCreateRequest | null; 
}
export interface CheckoutShowCoreApimessagesCoreArgs {
  input?: Input_core_apimessages_CheckoutShowRequest | null; 
}
export interface CheckoutCartEditCoreApimessagesCoreArgs {
  input?: Input_core_apimessages_CheckoutCartEditRequest | null; 
}
export interface CheckoutActionCoreApimessagesCoreArgs {
  input?: Input_core_apimessages_CheckoutActionRequest | null; 
}
export interface CheckoutSelectShippingAddressCoreApimessagesCoreArgs {
  input?: Input_core_apimessages_CheckoutSelectShippingAddressRequest | null; 
}
export interface CheckoutUpdateShippingAddressCoreApimessagesCoreArgs {
  input?: Input_core_apimessages_CheckoutUpdateShippingAddressRequest | null; 
}
export interface CheckoutSelectOrderShippingMethodCoreApimessagesCoreArgs {
  input?: Input_core_apimessages_CheckoutSelectOrderShippingMethodRequest | null; 
}
export interface CheckoutUpdateShippingEstimateCoreApimessagesCoreArgs {
  input?: Input_core_apimessages_CheckoutUpdateShippingEstimateRequest | null; 
}
export interface ExpressSaleCheckoutShowCoreApimessagesCoreArgs {
  input?: Input_core_apimessages_ExpressSaleCheckoutShowRequest | null; 
}
export interface CreateExpressSaleCheckoutCoreApimessagesCoreArgs {
  input?: Input_core_apimessages_CreateExpressSaleCheckoutRequest | null; 
}
export interface CompleteExpressSaleCheckoutCoreApimessagesCoreArgs {
  input?: Input_core_apimessages_CompleteExpressSaleCheckoutRequest | null; 
}
export interface AdminUserSearchCoreApimessagesCoreArgs {
  input?: Input_core_apimessages_AdminUserSearchRequest | null; 
}
export interface UpdateListingCoreApimessagesCoreArgs {
  input?: Input_core_apimessages_UpdateListingRequest | null; 
}
export interface ListingsSearchReverbSearchRpcSearchArgs {
  input?: Input_reverb_search_ListingsSearchRequest | null; 
}
export interface CmsPagesSearchReverbSearchRpcSearchArgs {
  input?: Input_reverb_search_CMSPagesSearchRequest | null; 
}
export interface CspSearchReverbSearchRpcSearchArgs {
  input?: Input_reverb_search_CSPSearchRequest | null; 
}
export interface NegotiationsSearchReverbSearchRpcSearchArgs {
  input?: Input_reverb_search_NegotiationSearchRequest | null; 
}
export interface CompletionsReverbSearchRpcSearchArgs {
  input?: Input_reverb_search_CompletionsRequest | null; 
}
export interface LpCompletionsReverbSearchRpcSearchArgs {
  input?: Input_reverb_search_LPCompletionsRequest | null; 
}
export interface OrdersSearchReverbSearchRpcSearchArgs {
  input?: Input_reverb_search_OrderSearchRequest | null; 
}
export interface LpAlbumsSearchReverbSearchRpcSearchArgs {
  input?: Input_reverb_search_LPAlbumSearchRequest | null; 
}
export interface LpArtistsSearchReverbSearchRpcSearchArgs {
  input?: Input_reverb_search_LPArtistSearchRequest | null; 
}
export interface LpLabelsSearchReverbSearchRpcSearchArgs {
  input?: Input_reverb_search_LPLabelSearchRequest | null; 
}
export interface LpTransactionsSearchReverbSearchRpcSearchArgs {
  input?: Input_reverb_search_LPTransactionsSearchRequest | null; 
}
export interface LpReleasesSearchReverbSearchRpcSearchArgs {
  input?: Input_reverb_search_LPReleasesSearchRequest | null; 
}
export interface PriceGuidesSearchReverbSearchRpcSearchArgs {
  input?: Input_reverb_search_PriceGuidesSearchRequest | null; 
}
export interface LpListingsSearchReverbSearchRpcSearchArgs {
  input?: Input_reverb_search_LPListingsSearchRequest | null; 
}
export interface AuctionsSearchReverbSearchRpcSearchArgs {
  input?: Input_reverb_search_AuctionsSearchRequest | null; 
}
export interface GearCollectionItemsSearchReverbSearchRpcSearchArgs {
  input?: Input_reverb_search_GearCollectionItemsSearchRequest | null; 
}
export interface ShippingRegionFilterReverbSearchRpcSearchArgs {
  input?: Input_reverb_search_ShippingRegionFilterRequest | null; 
}
export interface ListingsAggregationReverbSearchRpcSearchArgs {
  input?: Input_reverb_search_ListingsSearchRequest | null; 
}
export interface SubAggregationsByListingReverbSearchRpcSearchArgs {
  input?: Input_reverb_search_SubAggregationsByListingRequest | null; 
}
export interface ListingsPercolationQueryReverbSearchRpcSearchArgs {
  input?: Input_reverb_search_ListingsPercolationQueryRequest | null; 
}
export interface SimilarListingsSearchReverbSearchRpcSearchArgs {
  input?: Input_reverb_search_SimilarListingsSearchRequest | null; 
}
export interface GetTraitValueTranslationsReverbTaxonomyTaxonomyServiceArgs {
  input?: Input_reverb_taxonomy_GetTraitValueTranslationsRequest | null; 
}
export interface GetCategoryTranslationsReverbTaxonomyTaxonomyServiceArgs {
  input?: Input_reverb_taxonomy_GetCategoryTranslationsRequest | null; 
}
export interface GetCategoriesReverbTaxonomyTaxonomyServiceArgs {
  input?: Input_reverb_taxonomy_GetCategoriesRequest | null; 
}
export interface GetTraitTranslationsReverbTaxonomyTaxonomyServiceArgs {
  input?: Input_reverb_taxonomy_GetTraitTranslationsRequest | null; 
}
export interface GetTraitsReverbTaxonomyTaxonomyServiceArgs {
  input?: Input_reverb_taxonomy_GetTraitsRequest | null; 
}
export interface GetTaxonomyYamlReverbTaxonomyTaxonomyServiceArgs {
  input?: Input_reverb_taxonomy_GetTaxonomyYamlRequest | null; 
}
export interface CspStatsTotalReverbReportingReportingArgs {
  input?: Input_reverb_reporting_CSPStatsRequest | null; 
}
export interface CspStatsByDateReverbReportingReportingArgs {
  input?: Input_reverb_reporting_CSPStatsRequest | null; 
}
export interface CspStatsByCspReverbReportingReportingArgs {
  input?: Input_reverb_reporting_CSPStatsByCSPRequest | null; 
}
export interface ShopStatsReverbReportingReportingArgs {
  input?: Input_reverb_reporting_ShopStatsRequest | null; 
}
export interface ShopStatsByDateReverbReportingReportingArgs {
  input?: Input_reverb_reporting_ShopStatsByDateRequest | null; 
}
export interface ShopStatsCurrencyCountReverbReportingReportingArgs {
  input?: Input_reverb_reporting_ShopStatsRequest | null; 
}
export interface CspsCtrByDateRangeReverbReportingReportingArgs {
  input?: Input_reverb_reporting_ctr_CspsCtrByDateRangeRequest | null; 
}
export interface GetPagesLpLpArgs {
  input?: Input_lp_PagesRequest | null; 
}
export interface GetComponentsLpLpArgs {
  input?: Input_lp_ComponentsRequest | null; 
}
export interface GetAlbumsLpLpArgs {
  input?: Input_lp_V2AlbumsIndexRequest | null; 
}
export interface GetArtistsLpLpArgs {
  input?: Input_lp_APIArtistsRequest | null; 
}
export interface GetRelatedArtistsLpLpArgs {
  input?: Input_lp_APIRelatedArtistsRequest | null; 
}
export interface GetLabelsLpLpArgs {
  input?: Input_lp_APILabelsRequest | null; 
}
export interface GetReleasesLpLpArgs {
  input?: Input_lp_APIReleasesRequest | null; 
}
export interface GetImagesLpLpArgs {
  input?: Input_lp_APIImagesRequest | null; 
}
export interface GetExchangeRatesReverbConfigCacheConfigServiceArgs {
  input?: Input_reverb_config_cache_ExchangeRateRequest | null; 
}
export interface GetVersionedExchangeRatesReverbConfigCacheConfigServiceArgs {
  input?: Input_reverb_config_cache_VersionedExchangeRatesRequest | null; 
}
export interface ExchangeCurrencyReverbConfigCacheConfigServiceArgs {
  input?: Input_reverb_config_cache_ExchangeCurrencyRequest | null; 
}
export interface TaxRatesReverbConfigCacheConfigServiceArgs {
  input?: Input_google_protobuf_Empty | null; 
}
export interface AddressValidationsReverbConfigCacheConfigServiceArgs {
  input?: Input_google_protobuf_Empty | null; 
}
export interface GetTranslationsReverbConfigCacheConfigServiceArgs {
  input?: Input_reverb_config_cache_TranslationsRequest | null; 
}
export interface GetSearchRedirectsReverbConfigCacheConfigServiceArgs {
  input?: Input_reverb_config_cache_SearchRedirectsRequest | null; 
}
export interface GetInternationalAddressFormConfigReverbConfigCacheConfigServiceArgs {
  input?: Input_google_protobuf_Empty | null; 
}
export interface GetSubscriptionGroupsBrazeBrazeArgs {
  input?: Input_braze_GetSubscriptionGroupsRequest | null; 
}
export interface SetSubscriptionGroupsBrazeBrazeArgs {
  input?: Input_braze_SetSubscriptionGroupsRequest | null; 
}
export interface GetUserDataBrazeBrazeArgs {
  input?: Input_braze_GetUserDataRequest | null; 
}
export interface UserTrackBrazeBrazeArgs {
  input?: Input_braze_UserTrackRequest | null; 
}
export interface TriggerCampaignSendBrazeBrazeArgs {
  input?: Input_braze_TriggerCampaignSendRequest | null; 
}
export interface GetPriceRecommendationsReverbPricingPricingArgs {
  input?: Input_reverb_pricing_PriceRecommendationsRequest | null; 
}
export interface GetCspPriceRecommendationsReverbPricingPricingArgs {
  input?: Input_reverb_pricing_CSPPriceRecommendationsRequest | null; 
}
export interface GetPriceScoresReverbPricingPricingArgs {
  input?: Input_reverb_pricing_PriceScoresRequest | null; 
}
export interface GetUserReverbPersonalizationPersonalizationArgs {
  input?: Input_reverb_personalization_GetUserRequest | null; 
}
export interface RefreshListingRecommendationsReverbPersonalizationPersonalizationArgs {
  input?: Input_reverb_personalization_RefreshListingRecommendationsRequest | null; 
}
export interface RefreshListingRecsV2ReverbPersonalizationPersonalizationArgs {
  input?: Input_reverb_personalization_RefreshListingRecommendationsRequestV2 | null; 
}
export interface RefreshTrendingSearchesReverbPersonalizationPersonalizationArgs {
  input?: Input_reverb_personalization_RefreshTrendingSearchesRequest | null; 
}
export interface GetTrendingSearchesReverbPersonalizationPersonalizationArgs {
  input?: Input_reverb_personalization_GetTrendingSearchesRequest | null; 
}

export enum reverb_search_CSPSearchRequest_Aggregation {
  BRAND_NAMES = "BRAND_NAMES",
  FINISHES = "FINISHES",
  CATEGORY_UUIDS = "CATEGORY_UUIDS",
  DECADES = "DECADES",
}

export enum reverb_search_FullTextQueryOperand {
  OR = "OR",
  AND = "AND",
}

export enum reverb_search_CSPSearchRequest_Sort {
  NONE = "NONE",
  QUALITY_DESC = "QUALITY_DESC",
  LISTING_COUNT_DESC = "LISTING_COUNT_DESC",
  TITLE_RAW_ASC = "TITLE_RAW_ASC",
  CREATED_AT_ASC = "CREATED_AT_ASC",
  RECENT_ORDERS_COUNT_DESC = "RECENT_ORDERS_COUNT_DESC",
  TRENDING_DESC = "TRENDING_DESC",
  RECENT_ORDERS_COUNT_ASC = "RECENT_ORDERS_COUNT_ASC",
  RECENT_ORDERS_COUNT_USED_DESC = "RECENT_ORDERS_COUNT_USED_DESC",
  RECENT_ORDERS_COUNT_NEW_DESC = "RECENT_ORDERS_COUNT_NEW_DESC",
  RECENT_ORDERS_COUNT_USED_ASC = "RECENT_ORDERS_COUNT_USED_ASC",
  RECENT_ORDERS_COUNT_NEW_ASC = "RECENT_ORDERS_COUNT_NEW_ASC",
  LISTING_MIN_PRICE_USED_DESC = "LISTING_MIN_PRICE_USED_DESC",
  LISTING_MIN_PRICE_NEW_DESC = "LISTING_MIN_PRICE_NEW_DESC",
  LISTING_MIN_PRICE_USED_ASC = "LISTING_MIN_PRICE_USED_ASC",
  LISTING_MIN_PRICE_NEW_ASC = "LISTING_MIN_PRICE_NEW_ASC",
  AVERAGE_ORDER_PRICE_USED_ASC = "AVERAGE_ORDER_PRICE_USED_ASC",
  AVERAGE_ORDER_PRICE_USED_DESC = "AVERAGE_ORDER_PRICE_USED_DESC",
  AVERAGE_ORDER_PRICE_NEW_ASC = "AVERAGE_ORDER_PRICE_NEW_ASC",
  AVERAGE_ORDER_PRICE_NEW_DESC = "AVERAGE_ORDER_PRICE_NEW_DESC",
  AVERAGE_ORDER_PRICE_ASC = "AVERAGE_ORDER_PRICE_ASC",
  AVERAGE_ORDER_PRICE_DESC = "AVERAGE_ORDER_PRICE_DESC",
  LIVE_LISTINGS_USED_ASC = "LIVE_LISTINGS_USED_ASC",
  LIVE_LISTINGS_NEW_ASC = "LIVE_LISTINGS_NEW_ASC",
  LIVE_LISTINGS_USED_DESC = "LIVE_LISTINGS_USED_DESC",
  LIVE_LISTINGS_NEW_DESC = "LIVE_LISTINGS_NEW_DESC",
  LIVE_LISTINGS_ASC = "LIVE_LISTINGS_ASC",
  LIVE_LISTINGS_DESC = "LIVE_LISTINGS_DESC",
  IMPRESSIONS_ASC = "IMPRESSIONS_ASC",
  IMPRESSIONS_DESC = "IMPRESSIONS_DESC",
}

export enum reverb_search_Autodirects {
  DEFAULT = "DEFAULT",
  STANDARDIZED = "STANDARDIZED",
  IMPROVED_DATA = "IMPROVED_DATA",
  NEVER = "NEVER",
}

export enum reverb_search_Context {
  INITIAL_QUERY = "INITIAL_QUERY",
}

export enum core_apimessages_NamedImageTransforms {
  THUMB = "THUMB",
  CARD_SQUARE = "CARD_SQUARE",
  CARD_WIDE = "CARD_WIDE",
  LARGE = "LARGE",
  SUPERSIZE = "SUPERSIZE",
  BANNER_WIDE = "BANNER_WIDE",
  BANNER_4_1 = "BANNER_4_1",
  SHOP_BANNER = "SHOP_BANNER",
  USER_AVATAR = "USER_AVATAR",
}

export enum core_apimessages_Image_FallbackType {
  NONE = "NONE",
  LP_CANONICAL = "LP_CANONICAL",
}

export enum reverb_search_ListingsSearchRequest_Sort {
  NONE = "NONE",
  PUBLISHED_AT_ASC = "PUBLISHED_AT_ASC",
  PUBLISHED_AT_DESC = "PUBLISHED_AT_DESC",
  PRICE_ASC = "PRICE_ASC",
  PRICE_DESC = "PRICE_DESC",
  BUMPED_FIRST = "BUMPED_FIRST",
  CURATED = "CURATED",
  CURATED_DATE_ADDED = "CURATED_DATE_ADDED",
  LQS_DESCENDING = "LQS_DESCENDING",
  RANDOM = "RANDOM",
  WATCHERS_COUNT_ASC = "WATCHERS_COUNT_ASC",
  WATCHERS_COUNT_DESC = "WATCHERS_COUNT_DESC",
  FILTERED_IDS = "FILTERED_IDS",
  PRICING_SCORE = "PRICING_SCORE",
  PRICE_IN_COUNTRY = "PRICE_IN_COUNTRY",
  BUMP_SCORE = "BUMP_SCORE",
  EXPERIMENTAL_BUMP_RANKING = "EXPERIMENTAL_BUMP_RANKING",
  PROXIMITY_ASC = "PROXIMITY_ASC",
  RETURN_WINDOW = "RETURN_WINDOW",
  RETURN_WINDOW_PRICE_DESC = "RETURN_WINDOW_PRICE_DESC",
}

export enum reverb_search_ListingsSearchRequest_Aggregation {
  CATEGORY_UUIDS = "CATEGORY_UUIDS",
  BRAND_UUIDS = "BRAND_UUIDS",
  BRAND_SLUGS = "BRAND_SLUGS",
  CATEGORY_SLUGS = "CATEGORY_SLUGS",
  CONDITION_SLUGS = "CONDITION_SLUGS",
  DECADES = "DECADES",
  CURATED_SETS = "CURATED_SETS",
  TRAITS = "TRAITS",
  CANONICAL_FINISH = "CANONICAL_FINISH",
  BUMP_RATE_PERCENTILES = "BUMP_RATE_PERCENTILES",
  BUMP_RATE_RECOMMENDATIONS = "BUMP_RATE_RECOMMENDATIONS",
  SALE_DISCOUNT_PERCENT = "SALE_DISCOUNT_PERCENT",
  SHOP_ID = "SHOP_ID",
  COUNTRY_OF_ORIGIN = "COUNTRY_OF_ORIGIN",
}

export enum reverb_search_ListingsSearchRequest_Collapsible {
  COLLAPSIBLE_NONE = "COLLAPSIBLE_NONE",
  CSP_NEW_CONDITION = "CSP_NEW_CONDITION",
  CSP_NEW_CONDITION_SINGLE_FINISH = "CSP_NEW_CONDITION_SINGLE_FINISH",
}

export enum reverb_search_ListingsSearchRequest_PriceValue {
  PRICE_VALUE_NONE = "PRICE_VALUE_NONE",
  GOOD = "GOOD",
  GREAT = "GREAT",
}

export enum reverb_search_Distance_DistanceUnit {
  MI = "MI",
}

export enum reverb_search_Location_LocationType {
  POSTAL_CODE = "POSTAL_CODE",
}

export enum reverb_search_TrackTotalHits {
  EXACT = "EXACT",
  NONE = "NONE",
  FUZZ = "FUZZ",
}

export enum reverb_search_ListingsSearchRequest_MyShopAggregation {
  STATES = "STATES",
}

export enum reverb_search_ListingItemRegionRelation {
  ITEM_REGION_ONLY = "ITEM_REGION_ONLY",
  INCLUDE_TRADE_REGIONS = "INCLUDE_TRADE_REGIONS",
}

export enum reverb_reporting_Condition {
  ALL = "ALL",
  NEW = "NEW",
  USED = "USED",
}

export enum reverb_reporting_CSPStatsMetric {
  TOTAL_ORDER_VALUE_USC = "TOTAL_ORDER_VALUE_USC",
  ORDER_QUANTITY = "ORDER_QUANTITY",
  AVG_ORDER_PRICE_USC = "AVG_ORDER_PRICE_USC",
  LIVE_LISTING_COUNT = "LIVE_LISTING_COUNT",
  MIN_LISTING_PRICE_USC = "MIN_LISTING_PRICE_USC",
}

export enum core_apimessages_ProductSpec_Type {
  BRAND = "BRAND",
  MODEL = "MODEL",
  FINISH = "FINISH",
  YEAR = "YEAR",
  COUNTRY_OF_ORIGIN = "COUNTRY_OF_ORIGIN",
  CATEGORY = "CATEGORY",
  TRAIT = "TRAIT",
  CONDITION = "CONDITION",
}

export enum core_apimessages_Listing_ListingType {
  AUCTION = "AUCTION",
  MAKE_AN_OFFER = "MAKE_AN_OFFER",
  BUY_IT_NOW = "BUY_IT_NOW",
  DIGITAL = "DIGITAL",
  CORE_AUCTION = "CORE_AUCTION",
}

export enum core_apimessages_Listing_SeedType {
  ComparisonShoppingPage = "ComparisonShoppingPage",
  CanonicalProduct = "CanonicalProduct",
  PriceGuide = "PriceGuide",
  Product = "Product",
  Order = "Order",
  GearCollectionItem = "GearCollectionItem",
}

export enum core_apimessages_Sale_SaleState {
  LIVE = "LIVE",
  ENDED = "ENDED",
  UPCOMING = "UPCOMING",
}

export enum core_apimessages_Ribbon_Reason {
  PRICE_DROP = "PRICE_DROP",
  SALE = "SALE",
}

export enum core_apimessages_ShippingMethod {
  UNKNOWN = "UNKNOWN",
  SHIPPED = "SHIPPED",
  LOCAL = "LOCAL",
  EXPEDITED_SHIPPING = "EXPEDITED_SHIPPING",
  DIGITAL_DELIVERY = "DIGITAL_DELIVERY",
  COMBINED_SHIPPING = "COMBINED_SHIPPING",
}

export enum core_apimessages_Channel {
  REVERB = "REVERB",
  SELLER_SITE = "SELLER_SITE",
  LP = "LP",
}

export enum core_apimessages_Shop_ShopType {
  UNKNOWN = "UNKNOWN",
  INDIVIDUAL = "INDIVIDUAL",
  BUSINESS = "BUSINESS",
}

export enum core_apimessages_Shop_QuickShipperSpeed {
  NO_BUCKET = "NO_BUCKET",
  UNDER_24 = "UNDER_24",
  UNDER_48 = "UNDER_48",
  UNDER_72 = "UNDER_72",
}

export enum core_apimessages_ShippingRates_RegionType {
  COUNTRY = "COUNTRY",
  SUBREGION = "SUBREGION",
  SUPERREGION = "SUPERREGION",
  EVERYWHERE_ELSE = "EVERYWHERE_ELSE",
}

export enum core_apimessages_ShopTaxPolicy_PolicyType {
  SELLER = "SELLER",
  MARKETPLACE_REGION = "MARKETPLACE_REGION",
  AUTO_CALCULATED = "AUTO_CALCULATED",
}

export enum core_apimessages_Feedback_Type {
  RECEIVED = "RECEIVED",
  BUYER = "BUYER",
  SELLER = "SELLER",
}

export enum reverb_search_LPListingsSearchRequest_Condition {
  NONE = "NONE",
  NEW = "NEW",
  USED = "USED",
}

export enum core_apimessages_MyBidDetails_BidDetailStatus {
  NOT_BIDDING = "NOT_BIDDING",
  LOST = "LOST",
  LOSING = "LOSING",
  WINNING = "WINNING",
  WON = "WON",
}

export enum core_apimessages_BulkOrdersRequest_Relation {
  UNKNOWN = "UNKNOWN",
  SELF = "SELF",
  ORDER_BUNDLE = "ORDER_BUNDLE",
  LISTING = "LISTING",
}

export enum core_apimessages_PrimaryKey_Type {
  UNKNOWN = "UNKNOWN",
  ID = "ID",
  UUID = "UUID",
  SLUG = "SLUG",
}

export enum core_apimessages_BulkOrdersRequest_Party {
  SELLER = "SELLER",
  BUYER = "BUYER",
}

export enum core_apimessages_Order_Status {
  UNPAID = "UNPAID",
  PAYMENT_PENDING = "PAYMENT_PENDING",
  PARTIALLY_PAID = "PARTIALLY_PAID",
  PAID = "PAID",
  SHIPPED = "SHIPPED",
  PICKED_UP = "PICKED_UP",
  RECEIVED = "RECEIVED",
  PRESUMED_RECEIVED = "PRESUMED_RECEIVED",
  CANCELLED = "CANCELLED",
  REFUNDED = "REFUNDED",
  LAYAWAY_FORFEITED = "LAYAWAY_FORFEITED",
}

export enum core_apimessages_AddressVerificationStatus {
  VERIFIED = "VERIFIED",
  NOT_VERIFIED = "NOT_VERIFIED",
}

export enum core_apimessages_Payment_PaymentMethod {
  DIRECT_CHECKOUT = "DIRECT_CHECKOUT",
  PAYPAL = "PAYPAL",
  AFFIRM = "AFFIRM",
  OTHER = "OTHER",
  DC_VIA_PAYPAL = "DC_VIA_PAYPAL",
  PAYPAL_MANUAL = "PAYPAL_MANUAL",
  ANDROID_PAY = "ANDROID_PAY",
  APPLE_PAY = "APPLE_PAY",
  SOFORT = "SOFORT",
  BANK_WIRE = "BANK_WIRE",
  CASH = "CASH",
  CHECK = "CHECK",
  CREDIT_CARD = "CREDIT_CARD",
  MONEY_ORDER = "MONEY_ORDER",
  ESCROW_COM = "ESCROW_COM",
  KLARNA_ACCOUNT = "KLARNA_ACCOUNT",
}

export enum core_apimessages_Payment_PaymentStatus {
  REFUNDED = "REFUNDED",
  COMPLETED = "COMPLETED",
  PENDING = "PENDING",
  FAILED = "FAILED",
  NONE = "NONE",
  CANCELLED = "CANCELLED",
}

export enum core_apimessages_PacklinkShipment_Status {
  PENDING = "PENDING",
  SUCCESS = "SUCCESS",
  FAILED = "FAILED",
}

export enum core_apimessages_OrderRefunds_RefundableState {
  REFUNDABLE = "REFUNDABLE",
  SELLER_REFUNDABLE = "SELLER_REFUNDABLE",
  NON_REFUNDABLE = "NON_REFUNDABLE",
}

export enum core_apimessages_RefundRequest_RefundType {
  FULL = "FULL",
  PARTIAL = "PARTIAL",
}

export enum core_apimessages_RefundRequest_RefundState {
  APPROVED = "APPROVED",
  CONDITIONALLY_APPROVED = "CONDITIONALLY_APPROVED",
  CANCELLED = "CANCELLED",
  DENIED = "DENIED",
  PENDING = "PENDING",
  PENDING_SELLER_RESPONSE = "PENDING_SELLER_RESPONSE",
}

export enum core_apimessages_SellerOrder_TaxResponsibleParty {
  REVERB = "REVERB",
  SELLER = "SELLER",
}

export enum reverb_signals_Signal_Group {
  RESERVED = "RESERVED",
  NUDGE = "NUDGE",
  EXPERIMENTAL = "EXPERIMENTAL",
  ANDROID_NUDGES = "ANDROID_NUDGES",
  IOS_NUDGES = "IOS_NUDGES",
  ITEM_PAGE_NUDGES = "ITEM_PAGE_NUDGES",
  ITEM_PAGE_WHY_TO_BUY = "ITEM_PAGE_WHY_TO_BUY",
  ITEM_PAGE_WHY_REVERB = "ITEM_PAGE_WHY_REVERB",
  CART_PAGE_WHY_TO_BUY = "CART_PAGE_WHY_TO_BUY",
  ANDROID_WHY_TO_BUY = "ANDROID_WHY_TO_BUY",
  ANDROID_WHY_REVERB = "ANDROID_WHY_REVERB",
  IOS_WHY_TO_BUY = "IOS_WHY_TO_BUY",
  IOS_WHY_REVERB = "IOS_WHY_REVERB",
  MP_GRID_CARD = "MP_GRID_CARD",
  MP_GRID_PROX_CARD = "MP_GRID_PROX_CARD",
  MP_LIST_CARD = "MP_LIST_CARD",
  MP_LIST_PROX_CARD = "MP_LIST_PROX_CARD",
}

export enum reverb_signals_SignalImageType {
  PNG_34_3X = "PNG_34_3X",
  SVG = "SVG",
}

export enum reverb_signals_Signal_Name {
  ON_SALE = "ON_SALE",
  PAYMENT_PLAN = "PAYMENT_PLAN",
  PRICE_DROP = "PRICE_DROP",
  FREE_EXPEDITED_SHIPPING = "FREE_EXPEDITED_SHIPPING",
  FREE_STANDARD_SHIPPING = "FREE_STANDARD_SHIPPING",
  LOW_STOCK = "LOW_STOCK",
  PREDICTED_TO_SELL_SOON = "PREDICTED_TO_SELL_SOON",
  GREAT_VALUE = "GREAT_VALUE",
  RETURN_POLICY = "RETURN_POLICY",
  EXPEDITED_SHIPPING_AVAILABLE = "EXPEDITED_SHIPPING_AVAILABLE",
  AVAILABLE_NEARBY_FOR_PICKUP = "AVAILABLE_NEARBY_FOR_PICKUP",
  BUY_WITH_CONFIDENCE = "BUY_WITH_CONFIDENCE",
  SECURE_CHECKOUT = "SECURE_CHECKOUT",
  NEW_LISTING = "NEW_LISTING",
  SHIPS_SOON = "SHIPS_SOON",
  LOCAL_PICKUP_ONLY = "LOCAL_PICKUP_ONLY",
  AVAILABLE_FOR_PICKUP = "AVAILABLE_FOR_PICKUP",
  IN_OTHER_CARTS = "IN_OTHER_CARTS",
}

export enum reverb_signals_Signal_Slot {
  VALUE = "VALUE",
  FINANCING = "FINANCING",
  SHIPPING_CHARGE = "SHIPPING_CHARGE",
  URGENCY = "URGENCY",
  SELLER_TRUST = "SELLER_TRUST",
  SPEED = "SPEED",
  CHECKOUT_TRUST = "CHECKOUT_TRUST",
  REVERB_TRUST = "REVERB_TRUST",
  LOCAL = "LOCAL",
}

export enum core_apimessages_NegotiationState {
  ACTIVE = "ACTIVE",
  ACCEPTED = "ACCEPTED",
  REJECTED = "REJECTED",
  EXPIRED = "EXPIRED",
}

export enum core_apimessages_NegotiationParty {
  BUYER = "BUYER",
  SELLER = "SELLER",
}

export enum core_apimessages_Offer_OfferStatus {
  ACTIVE = "ACTIVE",
  COUNTERED = "COUNTERED",
  ACCEPTED = "ACCEPTED",
  REJECTED = "REJECTED",
  EXPIRED = "EXPIRED",
}

export enum core_apimessages_NegotiationType {
  STANDARD = "STANDARD",
  AUTO_PUSH_OFFER = "AUTO_PUSH_OFFER",
  EMAIL = "EMAIL",
}

export enum core_apimessages_GearCollectionItem_SeedType {
  Unknown = "Unknown",
  None = "None",
  Order = "Order",
  Product = "Product",
  CanonicalProduct = "CanonicalProduct",
}

export enum cms_PublicComponent_SearchType {
  NONE = "NONE",
  LISTING = "LISTING",
  CSP = "CSP",
}

export enum reverb_search_SuggestOptionScope_Type {
  NONE = "NONE",
  PRODUCT_TYPE = "PRODUCT_TYPE",
  BRAND = "BRAND",
}

export enum reverb_search_CompletionType {
  ALL = "ALL",
  CSP = "CSP",
  BRAND = "BRAND",
  BRAND_MODEL = "BRAND_MODEL",
  FREE_TEXT = "FREE_TEXT",
  PRODUCT_TYPE = "PRODUCT_TYPE",
  SUB_CATEGORY = "SUB_CATEGORY",
  SHOP = "SHOP",
  PRODUCT_FAMILY = "PRODUCT_FAMILY",
}

export enum reverb_search_Filter_WidgetType {
  CHECKBOX = "CHECKBOX",
  RADIO = "RADIO",
  NESTED_SELECT = "NESTED_SELECT",
  TEXT = "TEXT",
  RANGE = "RANGE",
  NONE = "NONE",
  SORT = "SORT",
  REGION_SELECT = "REGION_SELECT",
}

export enum reverb_search_SearchResponse_TotalHits_Relation {
  EQ = "EQ",
  GTE = "GTE",
}

export enum reverb_search_PriceGuidesSearchRequest_Aggregation {
  BRAND_NAMES = "BRAND_NAMES",
  CATEGORY_UUIDS = "CATEGORY_UUIDS",
  DECADES = "DECADES",
}

export enum reverb_search_OrderSearchRequest_Aggregation {
  BRAND_SLUGS = "BRAND_SLUGS",
  CATEGORY_SLUGS = "CATEGORY_SLUGS",
  CONDITION_SLUGS = "CONDITION_SLUGS",
  SHIPPING_METHODS = "SHIPPING_METHODS",
  ACTIONABLE_STATUS_GROUPS = "ACTIONABLE_STATUS_GROUPS",
}

export enum rql_GearCollectionItemsSearchRequest_Party {
  OWNER = "OWNER",
}

export enum reverb_search_GearCollectionItemsSearchRequest_Aggregation {
  CATEGORY_UUIDS = "CATEGORY_UUIDS",
  TAGS = "TAGS",
}

export enum core_apimessages_UserWatchesRequest_ListingState {
  ALL = "ALL",
  LIVE = "LIVE",
  NOT_LIVE = "NOT_LIVE",
}

export enum reverb_search_LPReleasesSearchRequest_Aggregation {
  COUNTRIES = "COUNTRIES",
  FORMATS = "FORMATS",
  INVENTORY = "INVENTORY",
}

export enum core_apimessages_CollectionHeader_CollectionType {
  Category = "Category",
  Brand = "Brand",
  CuratedSearch = "CuratedSearch",
  CuratedSet = "CuratedSet",
  ProductType = "ProductType",
}

export enum core_apimessages_CheckoutPaymentMethod_Type {
  DIRECT_CHECKOUT = "DIRECT_CHECKOUT",
  ANDROID_PAY = "ANDROID_PAY",
  APPLE_PAY = "APPLE_PAY",
  PAYPAL = "PAYPAL",
  DC_VIA_PAYPAL = "DC_VIA_PAYPAL",
  AFFIRM = "AFFIRM",
  SOFORT = "SOFORT",
  KLARNA_ACCOUNT = "KLARNA_ACCOUNT",
}

export enum core_apimessages_CheckoutOrder_SubtotalDiscount_Type {
  SALE = "SALE",
  OFFER = "OFFER",
}

export enum core_apimessages_CheckoutOrder_ShippingTotalDiscount_Type {
  COMBINED_PARENT = "COMBINED_PARENT",
  COMBINED_CHILD = "COMBINED_CHILD",
  FREE_SHIPPING_THRESHOLD = "FREE_SHIPPING_THRESHOLD",
}

export enum core_apimessages_CheckoutLineItem_Type {
  AMOUNT_LISTING_SUBTOTAL = "AMOUNT_LISTING_SUBTOTAL",
  AMOUNT_SHIPPING = "AMOUNT_SHIPPING",
  AMOUNT_TAX = "AMOUNT_TAX",
  AMOUNT_CREDIT = "AMOUNT_CREDIT",
  AMOUNT_OWED = "AMOUNT_OWED",
}

export enum core_apimessages_Checkout_Status {
  AWAITING_PAYMENT = "AWAITING_PAYMENT",
  FETCHING_TOKEN = "FETCHING_TOKEN",
  TOKEN_FETCH_SUCCESS = "TOKEN_FETCH_SUCCESS",
  TOKEN_FETCH_FAILURE = "TOKEN_FETCH_FAILURE",
  PAYMENT_IN_PROGRESS = "PAYMENT_IN_PROGRESS",
  REQUIRES_3DS_AUTHENTICATION = "REQUIRES_3DS_AUTHENTICATION",
  PAYMENT_SUCCESS = "PAYMENT_SUCCESS",
  DUPLICATE_PAYMENT = "DUPLICATE_PAYMENT",
  CHECKOUT_PROCESSING_FAILURE = "CHECKOUT_PROCESSING_FAILURE",
  CHECKOUT_INFORMATION_FAILURE = "CHECKOUT_INFORMATION_FAILURE",
  INVALID_SHIPPING_ADDRESS_FAILURE = "INVALID_SHIPPING_ADDRESS_FAILURE",
  PAYMENT_INFORMATION_FAILURE = "PAYMENT_INFORMATION_FAILURE",
  USER_IN_SANCTIONED_REGION_FAILURE = "USER_IN_SANCTIONED_REGION_FAILURE",
  LISTING_AVAILABILITY_FAILURE = "LISTING_AVAILABILITY_FAILURE",
  STANDARD_USER_ATTEMPTED_GUEST_CHECKOUT_FAILURE = "STANDARD_USER_ATTEMPTED_GUEST_CHECKOUT_FAILURE",
  LISTING_PURCHASE_RATE_LIMIT_FAILURE = "LISTING_PURCHASE_RATE_LIMIT_FAILURE",
  SHIPMENT_CREATION_FAILURE = "SHIPMENT_CREATION_FAILURE",
  PENDING_EXPRESS_SALE_ORDERS_LIMIT_FAILURE = "PENDING_EXPRESS_SALE_ORDERS_LIMIT_FAILURE",
}

export enum core_apimessages_Checkout_Type {
  STANDARD = "STANDARD",
  GUEST = "GUEST",
}

export enum core_apimessages_CreditCard_Brand_Type {
  UNKNOWN = "UNKNOWN",
  VISA = "VISA",
  MASTERCARD = "MASTERCARD",
  AMEX = "AMEX",
  DISCOVER = "DISCOVER",
  JCB = "JCB",
}

export enum core_apimessages_CheckoutAction_Type {
  AWAITING_PAYMENT = "AWAITING_PAYMENT",
  PROCESSING_PAYMENT = "PROCESSING_PAYMENT",
  PAYMENT_FAILURE = "PAYMENT_FAILURE",
  CHECKOUT_FAILURE = "CHECKOUT_FAILURE",
  REQUIRES_AUTHENTICATION = "REQUIRES_AUTHENTICATION",
  CHECKOUT_SUCCESS = "CHECKOUT_SUCCESS",
}

export enum core_apimessages_ExpressSaleCheckout_Status {
  AWAITING_PAYMENT = "AWAITING_PAYMENT",
  PAYMENT_IN_PROGRESS = "PAYMENT_IN_PROGRESS",
  COMPLETED = "COMPLETED",
  INACTIVE_BID = "INACTIVE_BID",
}

export enum core_apimessages_MyShopOnboardingResponse_BillingMethodStatus {
  NOT_REQUIRED = "NOT_REQUIRED",
  REQUIRED = "REQUIRED",
  COMPLETED = "COMPLETED",
}

export enum core_apimessages_MyShopOnboardingResponse_PaypalSetupStatus {
  PAYPAL_NOT_COMPLETED = "PAYPAL_NOT_COMPLETED",
  PAYPAL_COMPLETED = "PAYPAL_COMPLETED",
}

export enum core_apimessages_MyShopOnboardingResponse_PaymentMethod {
  NOT_SETUP = "NOT_SETUP",
  REVERB_PAYMENTS = "REVERB_PAYMENTS",
  PAYPAL = "PAYPAL",
}

export enum core_apimessages_PersonalInformation_AdyenShareholderType {
  UNKNOWN = "UNKNOWN",
  OWNER = "OWNER",
  CONTROLLER = "CONTROLLER",
}

export enum core_apimessages_AdyenLegalEntity {
  INDIVIDUAL = "INDIVIDUAL",
  BUSINESS = "BUSINESS",
}

export enum core_apimessages_PacklinkAccount_Status {
  PENDING = "PENDING",
  COMPLETED = "COMPLETED",
  FAILED = "FAILED",
}

export enum core_apimessages_TaxIdentification_Status {
  PENDING_VERIFICATION = "PENDING_VERIFICATION",
  FAILED_VERIFICATION = "FAILED_VERIFICATION",
  VERIFIED = "VERIFIED",
}

export enum core_apimessages_TaxIdentification_TaxType {
  VAT = "VAT",
  GST = "GST",
  SALES_TAX = "SALES_TAX",
  EPR = "EPR",
  QST = "QST",
}

export enum core_apimessages_FeePaymentMethod {
  PAYOUT_DEDUCTION = "PAYOUT_DEDUCTION",
  STATEMENT_BILLING = "STATEMENT_BILLING",
}

export enum core_apimessages_ContentSponsorship_SponsorshipType {
  AD = "AD",
  PARTNERSHIP = "PARTNERSHIP",
}

export enum core_apimessages_AdCampaign_AdStatus {
  DRAFT = "DRAFT",
  ACTIVE = "ACTIVE",
  INACTIVE = "INACTIVE",
}

export enum core_apimessages_AdGroup_AdStatus {
  DRAFT = "DRAFT",
  ACTIVE = "ACTIVE",
  INACTIVE = "INACTIVE",
}

export enum core_apimessages_AdZone_AdZoneStatus {
  ACTIVE = "ACTIVE",
  INACTIVE = "INACTIVE",
}

export enum core_apimessages_AdFormat {
  IMAGE_AD = "IMAGE_AD",
}

export enum rql_FollowsQuery_Channel {
  REVERB = "REVERB",
  LP = "LP",
}

export enum reverb_feed_SearchableType {
  FILTERED_QUERY = "FILTERED_QUERY",
  COMPARISON_SHOPPING_PAGE = "COMPARISON_SHOPPING_PAGE",
  CURATED_SET = "CURATED_SET",
  SHOP = "SHOP",
  BRAND = "BRAND",
  CATEGORY = "CATEGORY",
  PRODUCT_TYPE = "PRODUCT_TYPE",
  CURATED_SEARCH = "CURATED_SEARCH",
  PROFILE = "PROFILE",
  ALBUM = "ALBUM",
  RELEASE = "RELEASE",
  LABEL = "LABEL",
  ARTIST = "ARTIST",
}

export enum rql_FeedQuery_Channel {
  REVERB = "REVERB",
  LP = "LP",
}

export enum reverb_feed_FeedEntry_EntryType {
  LISTING = "LISTING",
  CSP = "CSP",
  ARTICLE = "ARTICLE",
  SHOP = "SHOP",
  FILTERED_QUERY = "FILTERED_QUERY",
  PROFILE = "PROFILE",
  ALBUM = "ALBUM",
  RELEASE = "RELEASE",
  PAGE = "PAGE",
  LABEL = "LABEL",
  ARTIST = "ARTIST",
  REMOVE = "REMOVE",
}

export enum reverb_feed_FeedSourceType {
  NONE = "NONE",
  SAVED_SEARCH = "SAVED_SEARCH",
  WATCH = "WATCH",
}

export enum core_apimessages_UserStatus {
  NOT_SET = "NOT_SET",
  IN_GOOD_STANDING = "IN_GOOD_STANDING",
  SUSPENDED = "SUSPENDED",
  UNDER_REVIEW = "UNDER_REVIEW",
  SUSPENDED_OUTSTANDING_INVOICE = "SUSPENDED_OUTSTANDING_INVOICE",
  REQUIRES_EMAIL_VERIFICATION = "REQUIRES_EMAIL_VERIFICATION",
}

export enum core_apimessages_UserNotificationType {
  UNKNOWN_USER_NOTIFICATION_TYPE = "UNKNOWN_USER_NOTIFICATION_TYPE",
  NEW_FEATURE_ALERT = "NEW_FEATURE_ALERT",
  ACTION_NEEDED = "ACTION_NEEDED",
}

export enum core_apimessages_UserNotification_UserNotificationKey {
  UNKNOWN = "UNKNOWN",
  COMBINE_AND_SAVE = "COMBINE_AND_SAVE",
  FREE_SHIPPING_THRESHOLD = "FREE_SHIPPING_THRESHOLD",
  NEW_AD_DASH = "NEW_AD_DASH",
  PACKLINK = "PACKLINK",
  GEAR_COLLECTIONS = "GEAR_COLLECTIONS",
  WITHHOLD_PAYOUTS = "WITHHOLD_PAYOUTS",
}

export enum rql_NegotiationQuery_Party {
  BUYER = "BUYER",
  SELLER = "SELLER",
}

export enum rql_NegotiationQuery_State {
  ACTIVE = "ACTIVE",
  ACCEPTED = "ACCEPTED",
  REJECTED = "REJECTED",
  EXPIRED = "EXPIRED",
}

export enum reverb_search_AuctionsSearchRequest_Aggregation {
  USER_BID_STATUS = "USER_BID_STATUS",
}

export enum reverb_search_AuctionsSearchRequest_UserBidStatus {
  ACTIVE = "ACTIVE",
  ALL = "ALL",
  WON = "WON",
  LOST = "LOST",
}

export enum reverb_search_AuctionsSearchRequest_MerchandisingType {
  LP = "LP",
  DIGITAL = "DIGITAL",
}

export enum core_apimessages_WatchesRequest_ListingState {
  ALL = "ALL",
  LIVE = "LIVE",
  NOT_LIVE = "NOT_LIVE",
}

export enum rql_EmailSubscription_TranslationKey {
  DEALS_AND_STEALS = "DEALS_AND_STEALS",
  FEED = "FEED",
  NEWSLETTER = "NEWSLETTER",
  SALE_ALERTS = "SALE_ALERTS",
  SELLER_NEWSLETTER = "SELLER_NEWSLETTER",
  SPECIAL_EVENTS = "SPECIAL_EVENTS",
  WATCH = "WATCH",
  OFFERS_AND_PROMOTIONS = "OFFERS_AND_PROMOTIONS",
}

export enum rql_SubscribeState {
  UNSUBSCRIBED = "UNSUBSCRIBED",
  SUBSCRIBED = "SUBSCRIBED",
  OPTED_IN = "OPTED_IN",
}

export enum reverb_updates_Entity_EntityType {
  UNKNOWN = "UNKNOWN",
  PRICE_DROP_ON_WATCHED = "PRICE_DROP_ON_WATCHED",
  PRICE_DROP_ON_ITEM_IN_CART = "PRICE_DROP_ON_ITEM_IN_CART",
  SITE_BANNER = "SITE_BANNER",
  WATCHED_ITEM_SOLD = "WATCHED_ITEM_SOLD",
  CATEGORY_AFFINITY = "CATEGORY_AFFINITY",
  PREDICTED_TO_SELL_SOON = "PREDICTED_TO_SELL_SOON",
  NEW_LISTINGS_FROM_FOLLOWED_SHOP = "NEW_LISTINGS_FROM_FOLLOWED_SHOP",
  NEW_OFFER_ON_WATCHED_ITEM = "NEW_OFFER_ON_WATCHED_ITEM",
  NEW_SALE_FROM_FOLLOWED_SHOP = "NEW_SALE_FROM_FOLLOWED_SHOP",
  RECOMMENDED_LISTING = "RECOMMENDED_LISTING",
  PROMOTION = "PROMOTION",
}

export enum core_apimessages_UserService_Provider {
  UNKNOWN = "UNKNOWN",
  APPLE = "APPLE",
  FACEBOOK = "FACEBOOK",
  GOOGLE = "GOOGLE",
}

export enum core_apimessages_MosaicTilePosition {
  LEFT = "LEFT",
  CENTER = "CENTER",
  RIGHT = "RIGHT",
}

export enum core_apimessages_BearerV2TokenRequest_Client {
  UNKNOWN = "UNKNOWN",
  MOBILE = "MOBILE",
}

export enum arbiter_AuctionType {
  CSP = "CSP",
  ALL_INCLUSIVE = "ALL_INCLUSIVE",
  CONDITION_INCLUSIVE = "CONDITION_INCLUSIVE",
  EXPERIMENTAL_CSP = "EXPERIMENTAL_CSP",
}

export enum core_apimessages_SiteBannerRequest_VisibilityScope {
  NONE = "NONE",
  MOBILE = "MOBILE",
  MY_UPDATES = "MY_UPDATES",
}

export enum core_apimessages_AdCampaignsSearchRequest_Status {
  ANY = "ANY",
  DRAFT = "DRAFT",
  ACTIVE = "ACTIVE",
  INACTIVE = "INACTIVE",
}

export enum core_apimessages_AdminUserSearchRequest_ActivatedFilter {
  NONE = "NONE",
  ACTIVATED = "ACTIVATED",
  NOT_ACTIVATED = "NOT_ACTIVATED",
}

export enum core_apimessages_SetupPaymentMethodsRequestBusinessAdyenDetails_AdyenShareholderType {
  UNKNOWN = "UNKNOWN",
  OWNER = "OWNER",
  CONTROLLER = "CONTROLLER",
}

export enum core_apimessages_AdyenPaymentResult_PaymentStatus {
  SUCCESS = "SUCCESS",
  IDENTIFY_SHOPPER_REQUIRED = "IDENTIFY_SHOPPER_REQUIRED",
  CHALLENGE_SHOPPER_REQUIRED = "CHALLENGE_SHOPPER_REQUIRED",
  FAILED = "FAILED",
  REDIRECT_SHOPPER_REQUIRED = "REDIRECT_SHOPPER_REQUIRED",
}

export enum core_apimessages_NegotiationAction {
  CREATE = "CREATE",
  ACCEPT = "ACCEPT",
  REJECT = "REJECT",
  COUNTER = "COUNTER",
}

export enum core_apimessages_Shipment_ShipmentType {
  STANDARD = "STANDARD",
  ADDITIONAL = "ADDITIONAL",
}

export enum core_apimessages_ShippingProtectionStatus {
  PROTECTION_OPTIONAL = "PROTECTION_OPTIONAL",
  PROTECTION_REQUIRED = "PROTECTION_REQUIRED",
  PROTECTION_NOT_SUPPORTED = "PROTECTION_NOT_SUPPORTED",
}

export enum core_apimessages_SignatureRequiredStatus {
  SIGNATURE_OPTIONAL = "SIGNATURE_OPTIONAL",
  SIGNATURE_REQUIRED = "SIGNATURE_REQUIRED",
  SIGNATURE_NOT_SUPPORTED = "SIGNATURE_NOT_SUPPORTED",
  SIGNATURE_REQUIRED_WITH_INSURANCE = "SIGNATURE_REQUIRED_WITH_INSURANCE",
}

export enum core_apimessages_MyAddressType {
  SHIPPING = "SHIPPING",
  SHOP = "SHOP",
  EU_ODR_PLATFORM = "EU_ODR_PLATFORM",
}

export enum core_apimessages_CuratedSet_SetType {
  NONE = "NONE",
  LP_SELLER_PICKS = "LP_SELLER_PICKS",
}

export enum core_apimessages_CheckoutFinalizeDigitalWalletPaymentRequest_ResultConfirmation {
  ASYNC = "ASYNC",
  SYNC = "SYNC",
}

export enum core_apimessages_CancelOrderRequest_CancellationReason {
  UNKNOWN = "UNKNOWN",
  ALREADY_SOLD_REASON = "ALREADY_SOLD_REASON",
  BUYER_ABANDONED_REASON = "BUYER_ABANDONED_REASON",
  PAYMENT_ARRANGEMENT_REASON = "PAYMENT_ARRANGEMENT_REASON",
}

export enum arbiter_Interaction_InteractionType {
  CLICK = "CLICK",
  ADD_TO_WATCHLIST = "ADD_TO_WATCHLIST",
  ADD_TO_CART = "ADD_TO_CART",
  MAKE_AN_OFFER = "MAKE_AN_OFFER",
  MESSAGE_SELLER = "MESSAGE_SELLER",
}

export enum core_apimessages_GearCollectionItemEntry_Source {
  NONE = "NONE",
  BLANK_FORM = "BLANK_FORM",
  SEEDED_FORM = "SEEDED_FORM",
  PAST_PURCHASE = "PAST_PURCHASE",
  EMAIL = "EMAIL",
  CREATED_BY_REVERB = "CREATED_BY_REVERB",
  ADMIN_CSV_IMPORT = "ADMIN_CSV_IMPORT",
  PRICE_GUIDE_TOOL = "PRICE_GUIDE_TOOL",
}

export enum core_apimessages_PreorderInfoEntry_TimeType {
  SHIP_DATE = "SHIP_DATE",
  LEAD_TIME = "LEAD_TIME",
}

export enum core_apimessages_PreorderInfoEntry_LeadTimeUnit {
  DAYS = "DAYS",
  WEEKS = "WEEKS",
}

export enum google_protobuf_FieldDescriptorProto_Label {
  LABEL_OPTIONAL = "LABEL_OPTIONAL",
  LABEL_REQUIRED = "LABEL_REQUIRED",
  LABEL_REPEATED = "LABEL_REPEATED",
}

export enum google_protobuf_FieldDescriptorProto_Type {
  TYPE_DOUBLE = "TYPE_DOUBLE",
  TYPE_FLOAT = "TYPE_FLOAT",
  TYPE_INT64 = "TYPE_INT64",
  TYPE_UINT64 = "TYPE_UINT64",
  TYPE_INT32 = "TYPE_INT32",
  TYPE_FIXED64 = "TYPE_FIXED64",
  TYPE_FIXED32 = "TYPE_FIXED32",
  TYPE_BOOL = "TYPE_BOOL",
  TYPE_STRING = "TYPE_STRING",
  TYPE_GROUP = "TYPE_GROUP",
  TYPE_MESSAGE = "TYPE_MESSAGE",
  TYPE_BYTES = "TYPE_BYTES",
  TYPE_UINT32 = "TYPE_UINT32",
  TYPE_ENUM = "TYPE_ENUM",
  TYPE_SFIXED32 = "TYPE_SFIXED32",
  TYPE_SFIXED64 = "TYPE_SFIXED64",
  TYPE_SINT32 = "TYPE_SINT32",
  TYPE_SINT64 = "TYPE_SINT64",
}

export enum google_protobuf_FieldOptions_CType {
  STRING = "STRING",
  CORD = "CORD",
  STRING_PIECE = "STRING_PIECE",
}

export enum google_protobuf_FieldOptions_JSType {
  JS_NORMAL = "JS_NORMAL",
  JS_STRING = "JS_STRING",
  JS_NUMBER = "JS_NUMBER",
}

export enum google_protobuf_MethodOptions_IdempotencyLevel {
  IDEMPOTENCY_UNKNOWN = "IDEMPOTENCY_UNKNOWN",
  NO_SIDE_EFFECTS = "NO_SIDE_EFFECTS",
  IDEMPOTENT = "IDEMPOTENT",
}

export enum google_protobuf_FileOptions_OptimizeMode {
  SPEED = "SPEED",
  CODE_SIZE = "CODE_SIZE",
  LITE_RUNTIME = "LITE_RUNTIME",
}

export enum reverb_feed_FeedEntryUpdated_Action {
  ADD = "ADD",
  REMOVE = "REMOVE",
  REMOVE_ALL = "REMOVE_ALL",
  REMOVE_BY_SOURCE = "REMOVE_BY_SOURCE",
  ADD_BY_SOURCE = "ADD_BY_SOURCE",
  REMOVE_DIGEST = "REMOVE_DIGEST",
}

export enum reverb_feed_FollowsTopic_Action {
  REMOVE = "REMOVE",
  REMOVE_BY_SEARCHABLE = "REMOVE_BY_SEARCHABLE",
}

export enum reverb_updates_Update_Action {
  UNKNOWN = "UNKNOWN",
  ADD = "ADD",
  ADD_USERS = "ADD_USERS",
}

export enum reverb_updates_PruneMyUpdates_PruneType {
  UNKNOWN = "UNKNOWN",
  USER = "USER",
  UPDATE = "UPDATE",
}

export enum reverb_event_ComponentInteraction_InteractionType {
  CLICK = "CLICK",
  HOVER = "HOVER",
  SWIPE = "SWIPE",
  FORCE_TAP = "FORCE_TAP",
}

export enum reverb_event_MobileInteraction_InteractionType {
  TAP = "TAP",
  DRAG = "DRAG",
  FORCE_TAP = "FORCE_TAP",
}

export enum reverb_event_EntityUpdated_Action {
  UPDATED = "UPDATED",
  DELETED = "DELETED",
}

export enum reverb_event_OrderUpdated_Status {
  UNPAID = "UNPAID",
  PAYMENT_PENDING = "PAYMENT_PENDING",
  PARTIALLY_PAID = "PARTIALLY_PAID",
  PAID = "PAID",
  SHIPPED = "SHIPPED",
  PICKED_UP = "PICKED_UP",
  RECEIVED = "RECEIVED",
  PRESUMED_RECEIVED = "PRESUMED_RECEIVED",
  CANCELLED = "CANCELLED",
  REFUNDED = "REFUNDED",
  LAYAWAY_FORFEITED = "LAYAWAY_FORFEITED",
}

export enum reverb_event_NegotiationUpdated_Status {
  REJECTED = "REJECTED",
  ACCEPTED = "ACCEPTED",
  EXPIRED = "EXPIRED",
}

export enum reverb_event_UserUpdated_UserStatus {
  IN_GOOD_STANDING = "IN_GOOD_STANDING",
  UNDER_REVIEW = "UNDER_REVIEW",
  SUSPENDED = "SUSPENDED",
  SUSPENDED_OUTSTANDING_INVOICE = "SUSPENDED_OUTSTANDING_INVOICE",
}

export enum reverb_event_ListingsView_ViewType {
  SEARCHING = "SEARCHING",
  BROWSING = "BROWSING",
  HOMEPAGE = "HOMEPAGE",
  BRAND = "BRAND",
  CURATED_SEARCH = "CURATED_SEARCH",
  SHOP = "SHOP",
  CURATED_SET = "CURATED_SET",
}

export enum reverb_event_ArticleViewRelatedContent_RelatedContentType {
  ARTICLES = "ARTICLES",
}

export enum reverb_event_CheckoutView_StepName {
  CART = "CART",
  SHIPPING_REGISTRATION = "SHIPPING_REGISTRATION",
  BILLING = "BILLING",
  PLACE_ORDER = "PLACE_ORDER",
  CONFIRMATION = "CONFIRMATION",
  ASYNC_PAYMENT_IN_PROGRESS = "ASYNC_PAYMENT_IN_PROGRESS",
  ASYNC_PAYPAL_TOKEN_FETCH_IN_PROGRESS = "ASYNC_PAYPAL_TOKEN_FETCH_IN_PROGRESS",
}

export enum reverb_event_MailerAction {
  SENT = "SENT",
  OPENED = "OPENED",
}

export enum reverb_event_CollectionView {
  HYDRA = "HYDRA",
  SALE = "SALE",
  CURATED_SET = "CURATED_SET",
  FEED = "FEED",
  HOMEPAGE = "HOMEPAGE",
  PRICE_GUIDE = "PRICE_GUIDE",
  SEARCH = "SEARCH",
}

export enum reverb_event_ListingStatus {
  DRAFT = "DRAFT",
  LIVE = "LIVE",
  DRAFTS = "DRAFTS",
  SOLD_OUT = "SOLD_OUT",
  ORDERED = "ORDERED",
  NOT_DRAFTS = "NOT_DRAFTS",
  SUSPENDED = "SUSPENDED",
  VACATION = "VACATION",
  ENDED = "ENDED",
}

export enum reverb_event_DeviceName {
  IOS = "IOS",
  ANDROID = "ANDROID",
  TOUCH = "TOUCH",
  WEB = "WEB",
}

export enum reverb_event_GoogleClickOrigin {
  REVERB = "REVERB",
  SELLERSITES = "SELLERSITES",
}

export enum core_apimessages_KYCAction {
  NONE = "NONE",
  UPLOAD_DOCUMENT = "UPLOAD_DOCUMENT",
  UPDATE_INFORMATION = "UPDATE_INFORMATION",
}

export enum core_apimessages_KYCPhotoIDType {
  PASSPORT = "PASSPORT",
  ID_CARD = "ID_CARD",
  DRIVING_LICENSE = "DRIVING_LICENSE",
}

export enum core_apimessages_BumpKeyContents_OffsiteSource {
  NONE = "NONE",
  EMAIL = "EMAIL",
}

export enum core_apimessages_Image_Scope {
  ALL = "ALL",
  PHOTOS = "PHOTOS",
  SMALL_HEADER_IMAGE = "SMALL_HEADER_IMAGE",
  HEADER_IMAGE = "HEADER_IMAGE",
  FACEBOOK_IMAGE = "FACEBOOK_IMAGE",
  PRODUCT_MANUAL = "PRODUCT_MANUAL",
  APP_STORE_BANNER = "APP_STORE_BANNER",
  HOMEPAGE_IMAGE = "HOMEPAGE_IMAGE",
  HERO_IMAGE = "HERO_IMAGE",
  VERTICAL_MOSAIC_IMAGE = "VERTICAL_MOSAIC_IMAGE",
  SHOP_BANNER_960 = "SHOP_BANNER_960",
  DESKTOP_IMAGE = "DESKTOP_IMAGE",
  SQUARE_MOSAIC_IMAGE = "SQUARE_MOSAIC_IMAGE",
  FULL_BLEED_HOMEPAGE_IMAGE = "FULL_BLEED_HOMEPAGE_IMAGE",
  APP_STORE_ICON = "APP_STORE_ICON",
  STOREFRONT_BANNER_1500 = "STOREFRONT_BANNER_1500",
  FULL_BLEED_IMAGE = "FULL_BLEED_IMAGE",
  SHOP_BANNER = "SHOP_BANNER",
  AVATAR = "AVATAR",
  FULL_BLEED_BRAND = "FULL_BLEED_BRAND",
  MOBILE_IMAGE = "MOBILE_IMAGE",
  IMAGE = "IMAGE",
}

export enum core_apimessages_CreateShipmentErrorType {
  SHIPMENT_FORM_BASE_ERROR = "SHIPMENT_FORM_BASE_ERROR",
  SHIPMENT_FORM_CUSTOMS_ERROR = "SHIPMENT_FORM_CUSTOMS_ERROR",
  SHIPMENT_FORM_CUSTOMS_SIGNER_ERROR = "SHIPMENT_FORM_CUSTOMS_SIGNER_ERROR",
}

export enum core_apimessages_TraitsRequest_TraitableType {
  Product = "Product",
}

export enum core_apimessages_TaxPoliciesRequest_TaxPoliciesType {
  SHOP = "SHOP",
  PRODUCT = "PRODUCT",
}

export enum core_apimessages_CategoryRequest_CategoryType {
  UNKNOWN = "UNKNOWN",
  CATEGORY = "CATEGORY",
  ARTICLE = "ARTICLE",
  ALL_FLAT = "ALL_FLAT",
}

export enum core_apimessages_VideosRequest_VideolinkableType {
  PRODUCT = "PRODUCT",
  SHOP = "SHOP",
}

export enum core_apimessages_AcceptedPaymentMethodsRequest_PaymentMethodsType {
  PRODUCT = "PRODUCT",
  SHOP = "SHOP",
}

export enum core_apimessages_BulkAddressesRequest_Relation {
  UNKNOWN = "UNKNOWN",
  MY_SHIPPING = "MY_SHIPPING",
  MY_SHOP = "MY_SHOP",
  ORDER_SHIPPING = "ORDER_SHIPPING",
  ORDER_BUNDLE_SHIPPING = "ORDER_BUNDLE_SHIPPING",
  EU_ODR_PLATFORM = "EU_ODR_PLATFORM",
}

export enum core_apimessages_BulkCuratedSetsRequest_Relation {
  SELF = "SELF",
  STOREFRONT = "STOREFRONT",
}

export enum reverb_search_NegotiationSearchRequest_Aggregation {
  STATES = "STATES",
  CHANNELS = "CHANNELS",
  SELLER_CHANNELS = "SELLER_CHANNELS",
  ACTIVE_SELLER_ACTION_REQUIRED = "ACTIVE_SELLER_ACTION_REQUIRED",
  NEGOTIATION_TYPES = "NEGOTIATION_TYPES",
  LISTING_NEGOTIATION_METRICS = "LISTING_NEGOTIATION_METRICS",
}

export enum reverb_search_NegotiationSearchRequest_State {
  ACTIVE = "ACTIVE",
  ACCEPTED = "ACCEPTED",
  REJECTED = "REJECTED",
  EXPIRED = "EXPIRED",
}

export enum reverb_search_NegotiationSearchRequest_Type {
  AUTO_PUSH_OFFER = "AUTO_PUSH_OFFER",
  EMAIL = "EMAIL",
  STANDARD = "STANDARD",
}

export enum reverb_search_LPTransactionsSearchRequest_ActionableStatus {
  AWAITING_PICKUP = "AWAITING_PICKUP",
  AWAITING_SHIPMENT = "AWAITING_SHIPMENT",
  CANCELLED = "CANCELLED",
  LAYAWAY = "LAYAWAY",
  LAYAWAY_FORFEITED = "LAYAWAY_FORFEITED",
  PAYMENT_PENDING = "PAYMENT_PENDING",
  PICKED_UP = "PICKED_UP",
  PREORDER = "PREORDER",
  RECEIVED = "RECEIVED",
  REFUNDED = "REFUNDED",
  REFUND_APPROVED = "REFUND_APPROVED",
  REFUND_REQUESTED = "REFUND_REQUESTED",
  SHIPPED = "SHIPPED",
  UNPAID = "UNPAID",
}

export enum reverb_search_LPTransactionsSearchRequest_Aggregation {
  ACTIONABLE_STATUSES = "ACTIONABLE_STATUSES",
  PRICE_PERCENTILES = "PRICE_PERCENTILES",
  PRICE_PERCENTILES_BY_MEDIA_CONDITION = "PRICE_PERCENTILES_BY_MEDIA_CONDITION",
}

export enum reverb_search_SubAggregationsByListingRequest_TargetIndex {
  NEGOTIATIONS = "NEGOTIATIONS",
}

export enum reverb_search_SubAggregationsByListingRequest_Aggregation {
  LISTING_NEGOTIATION_METRICS = "LISTING_NEGOTIATION_METRICS",
}

export enum reverb_reporting_TimeGrouping {
  DAY = "DAY",
  MONTH = "MONTH",
}

export enum rql_NodeError_ErrorType {
  UNKNOWN = "UNKNOWN",
  NOT_FOUND = "NOT_FOUND",
}

export enum rql_PublicComponentEntity_EntityType {
  LISTING = "LISTING",
  CSP = "CSP",
}

export enum lp_Ribbon_Reason {
  PRICE_DROP = "PRICE_DROP",
  SALE = "SALE",
}

export enum lp_APIArtistType {
  RELEASE = "RELEASE",
  ALBUM = "ALBUM",
}

export enum lp_APIImagesRequest_ImageType {
  Release = "Release",
  Album = "Album",
}

export enum reverb_config_cache_SearchRedirect_Type {
  Brand = "Brand",
  BrandModel = "BrandModel",
  ProductFamily = "ProductFamily",
}

export type Node = CSP | Listing | Order | Negotiation | User | Article | PriceGuide | GearCollectionItem | CMSPage;


export type PublicComponentEntity = Listing | CSP;


export type Reflection = Album | Artist | Category | CartItem | CMSPage | CollectionHeader | CSP | Checkout | CheckoutAction | CuratedSet | ExpressSaleCheckout | GearCollectionItem | Order | Listing | MyShop | Negotiation | OrderBundle | Page | PriceGuide | PublicComponent | Release | Sale | SellerCheckout | Shipment | Shop | Storefront | User | Article | Brand | Auction | Watch | SiteBanner | PriceChange | MyUpdate | MyUpdatesPromotion | ShipmentPackage | PublicPriceRecord | Advertiser | AdCampaign | AdGroup | Ad | AdZone | UniversalPromoCampaign;


export type FeedEntry = Article | Listing;

export namespace CommonsOffersEditOfferForm {
  export type Variables = {
    listingId?: string | null;
    negotiationId?: string | null;
    isSeller: boolean;
  }

  export type Query = {
    __typename?: "Query";
    exchangeRates?: ExchangeRates | null; 
    listing?: Listing | null; 
    me?: Me | null; 
  }

  export type ExchangeRates = {
    __typename?: "reverb_config_cache_CurrencyResponse";
    rates?: (Rates | null)[] | null; 
  }

  export type Rates = {
    __typename?: "reverb_config_cache_ExchangeRate";
    from?: string | null; 
    to?: string | null; 
    rate?: number | null; 
  }

  export type Listing = {
    __typename?: "Listing";
    _id?: string | null; 
  } & OfferListingFragment.Fragment & SellerOfferListingFragment.Fragment

  export type Me = {
    __typename?: "rql_Me";
    uuid?: string | null; 
    activeNegotiation?: ActiveNegotiation | null; 
  }

  export type ActiveNegotiation = {
    __typename?: "reverb_search_SearchResponse";
    negotiations?: (Negotiations | null)[] | null; 
  }

  export type Negotiations = {
    __typename?: "Negotiation";
    _id?: string | null; 
    id?: string | null; 
    buyerUuid?: string | null; 
    sellerUuid?: string | null; 
    taxIncluded?: boolean | null; 
    taxIncludedHint?: string | null; 
    sellerShippingWarning?: string | null; 
    buyer?: Buyer | null; 
    shippingLocation?: ShippingLocation | null; 
    lastOffer?: LastOffer | null; 
  }

  export type Buyer = {
    __typename?: "User";
    _id?: string | null; 
    name?: string | null; 
    shop?: Shop | null; 
  }

  export type Shop = {
    __typename?: "core_apimessages_Shop";
    name?: string | null; 
    slug?: string | null; 
  }

  export type ShippingLocation = {
    __typename?: "core_apimessages_Address";
    displayLocation?: string | null; 
  }

  export type LastOffer = {
    __typename?: "core_apimessages_Offer";
    status?: core_apimessages_Offer_OfferStatus | null; 
    offerItems?: (OfferItems | null)[] | null; 
    prices?: Prices | null; 
  }

  export type OfferItems = {
    __typename?: "core_apimessages_OfferItem";
    quantity?: number | null; 
  }

  export type Prices = {
    __typename?: "core_apimessages_OfferPrices";
    price?: Price | null; 
    shippingPrice?: ShippingPrice | null; 
    totalPrice?: TotalPrice | null; 
  }

  export type Price = {
    __typename?: "core_apimessages_ConvertedMoney";
    display?: Display | null; 
    original?: Original | null; 
  }

  export type Display = {
    __typename?: "core_apimessages_Money";
    amount?: string | null; 
    amountCents?: number | null; 
    currency?: string | null; 
    symbol?: string | null; 
    display?: string | null; 
  }

  export type Original = {
    __typename?: "core_apimessages_Money";
    amount?: string | null; 
    amountCents?: number | null; 
    currency?: string | null; 
    symbol?: string | null; 
    display?: string | null; 
  }

  export type ShippingPrice = {
    __typename?: "core_apimessages_ConvertedMoney";
    display?: _Display | null; 
    original?: _Original | null; 
  }

  export type _Display = {
    __typename?: "core_apimessages_Money";
    amount?: string | null; 
    amountCents?: number | null; 
    currency?: string | null; 
    symbol?: string | null; 
    display?: string | null; 
  }

  export type _Original = {
    __typename?: "core_apimessages_Money";
    amount?: string | null; 
    amountCents?: number | null; 
    currency?: string | null; 
    symbol?: string | null; 
    display?: string | null; 
  }

  export type TotalPrice = {
    __typename?: "core_apimessages_ConvertedMoney";
    display?: __Display | null; 
    original?: __Original | null; 
  }

  export type __Display = {
    __typename?: "core_apimessages_Money";
    amount?: string | null; 
    amountCents?: number | null; 
    currency?: string | null; 
    symbol?: string | null; 
    display?: string | null; 
  }

  export type __Original = {
    __typename?: "core_apimessages_Money";
    amount?: string | null; 
    amountCents?: number | null; 
    currency?: string | null; 
    symbol?: string | null; 
    display?: string | null; 
  }
}
export namespace CommonsOffersNewOfferForm {
  export type Variables = {
    listingId?: string | null;
    shippingRegionCode?: string | null;
    usePrimaryShippingAddress?: boolean | null;
    isSeller: boolean;
  }

  export type Query = {
    __typename?: "Query";
    countries?: Countries | null; 
    exchangeRates?: ExchangeRates | null; 
    listing?: Listing | null; 
    me?: Me | null; 
  }

  export type Countries = {
    __typename?: "core_apimessages_CountriesResponse";
    countries?: (_Countries | null)[] | null; 
  }

  export type _Countries = {
    __typename?: "core_apimessages_Country";
    name?: string | null; 
    countryCode?: string | null; 
  }

  export type ExchangeRates = {
    __typename?: "reverb_config_cache_CurrencyResponse";
    rates?: (Rates | null)[] | null; 
  }

  export type Rates = {
    __typename?: "reverb_config_cache_ExchangeRate";
    from?: string | null; 
    to?: string | null; 
    rate?: number | null; 
  }

  export type Listing = {
    __typename?: "Listing";
    _id?: string | null; 
    shipping?: Shipping | null; 
    priceRecommendation?: PriceRecommendation | null; 
  } & OfferListingFragment.Fragment & SellerOfferListingFragment.Fragment

  export type Shipping = {
    __typename?: "core_apimessages_ShippingPrices";
    localPickupOnly?: boolean | null; 
    shippingRegionCode?: string | null; 
    shippingAddress?: ShippingAddress | null; 
    shippingPrices?: (ShippingPrices | null)[] | null; 
  }

  export type ShippingAddress = {
    __typename?: "core_apimessages_Address";
    postalCode?: string | null; 
  }

  export type ShippingPrices = {
    __typename?: "core_apimessages_ShippingPrice";
    rate?: Rate | null; 
    originalRate?: OriginalRate | null; 
    shippingMethod?: core_apimessages_ShippingMethod | null; 
    carrierCalculated?: boolean | null; 
    destinationPostalCodeNeeded?: boolean | null; 
  }

  export type Rate = {
    __typename?: "core_apimessages_Money";
    amount?: string | null; 
    amountCents?: number | null; 
    currency?: string | null; 
    symbol?: string | null; 
    display?: string | null; 
  }

  export type OriginalRate = {
    __typename?: "core_apimessages_Money";
    amount?: string | null; 
    amountCents?: number | null; 
    currency?: string | null; 
    symbol?: string | null; 
    display?: string | null; 
  }

  export type PriceRecommendation = {
    __typename?: "reverb_pricing_PriceRecommendation";
    priceMiddle?: PriceMiddle | null; 
  }

  export type PriceMiddle = {
    __typename?: "reverb_pricing_Money";
    amountCents?: number | null; 
    currency?: string | null; 
  }

  export type Me = {
    __typename?: "rql_Me";
    uuid?: string | null; 
    offerCount?: OfferCount | null; 
  }

  export type OfferCount = {
    __typename?: "reverb_search_SearchResponse";
    total?: number | null; 
  }
}
export namespace CommonsOffersCreateOfferForm {
  export type Variables = {
    input?: Input_core_apimessages_CreateNegotiationRequest | null;
  }

  export type Mutation = {
    __typename?: "Mutation";
    createNegotiation?: CreateNegotiation | null; 
  }

  export type CreateNegotiation = {
    __typename?: "core_apimessages_NegotiationsResponse";
    negotiations?: (Negotiations | null)[] | null; 
  }

  export type Negotiations = {
    __typename?: "core_apimessages_Negotiation";
    id?: string | null; 
    lastOffer?: LastOffer | null; 
  }

  export type LastOffer = {
    __typename?: "core_apimessages_Offer";
    offerItems?: (OfferItems | null)[] | null; 
    initiatingParty?: core_apimessages_NegotiationParty | null; 
    prices?: Prices | null; 
  }

  export type OfferItems = {
    __typename?: "core_apimessages_OfferItem";
    listingId?: string | null; 
    quantity?: number | null; 
  }

  export type Prices = {
    __typename?: "core_apimessages_OfferPrices";
    price?: Price | null; 
    shippingPrice?: ShippingPrice | null; 
    totalPrice?: TotalPrice | null; 
  }

  export type Price = {
    __typename?: "core_apimessages_ConvertedMoney";
    original?: Original | null; 
  }

  export type Original = {
    __typename?: "core_apimessages_Money";
    amount?: string | null; 
    amountCents?: number | null; 
    currency?: string | null; 
    symbol?: string | null; 
    display?: string | null; 
  }

  export type ShippingPrice = {
    __typename?: "core_apimessages_ConvertedMoney";
    original?: _Original | null; 
  }

  export type _Original = {
    __typename?: "core_apimessages_Money";
    amount?: string | null; 
    amountCents?: number | null; 
    currency?: string | null; 
    symbol?: string | null; 
    display?: string | null; 
  }

  export type TotalPrice = {
    __typename?: "core_apimessages_ConvertedMoney";
    display?: Display | null; 
    original?: __Original | null; 
  }

  export type Display = {
    __typename?: "core_apimessages_Money";
    amount?: string | null; 
    amountCents?: number | null; 
    currency?: string | null; 
    symbol?: string | null; 
    display?: string | null; 
  }

  export type __Original = {
    __typename?: "core_apimessages_Money";
    amount?: string | null; 
    amountCents?: number | null; 
    currency?: string | null; 
    symbol?: string | null; 
    display?: string | null; 
  }
}
export namespace CommonsOffersUpdateOfferForm {
  export type Variables = {
    input?: Input_core_apimessages_UpdateNegotiationRequest | null;
  }

  export type Mutation = {
    __typename?: "Mutation";
    updateNegotiation?: UpdateNegotiation | null; 
  }

  export type UpdateNegotiation = {
    __typename?: "core_apimessages_UpdateNegotiationResponse";
    negotiation?: Negotiation | null; 
  }

  export type Negotiation = {
    __typename?: "core_apimessages_Negotiation";
    id?: string | null; 
    state?: core_apimessages_NegotiationState | null; 
  }
}
export namespace CoreAutoOffersCreateAutoOfferMutation {
  export type Variables = {
    input?: Input_core_apimessages_CreateAutoOfferRequest | null;
  }

  export type Mutation = {
    __typename?: "Mutation";
    createAutoOffer?: CreateAutoOffer | null; 
  }

  export type CreateAutoOffer = {
    __typename?: "core_apimessages_CreateAutoOfferResponse";
    autoOffer?: AutoOffer | null; 
  }

  export type AutoOffer = {
    __typename?: "core_apimessages_AutoOffer";
    id?: string | null; 
    listingId?: string | null; 
    message?: string | null; 
    price?: Price | null; 
    percentage?: number | null; 
  }

  export type Price = {
    __typename?: "core_apimessages_Money";
    amount?: string | null; 
    amountCents?: number | null; 
    currency?: string | null; 
    symbol?: string | null; 
    display?: string | null; 
  }
}
export namespace CoreAutoOffersDeleteAutoOfferMutation {
  export type Variables = {
    input?: Input_core_apimessages_DeleteAutoOfferRequest | null;
  }

  export type Mutation = {
    __typename?: "Mutation";
    deleteAutoOffer?: DeleteAutoOffer | null; 
  }

  export type DeleteAutoOffer = {
    __typename?: "core_apimessages_DeleteAutoOfferResponse";
    autoOffer?: AutoOffer | null; 
  }

  export type AutoOffer = {
    __typename?: "core_apimessages_AutoOffer";
    id?: string | null; 
    listingId?: string | null; 
    message?: string | null; 
    price?: Price | null; 
    percentage?: number | null; 
  }

  export type Price = {
    __typename?: "core_apimessages_Money";
    amount?: string | null; 
    amountCents?: number | null; 
    currency?: string | null; 
    symbol?: string | null; 
    display?: string | null; 
  }
}
export namespace CommonsCmsListingsCollection {
  export type Variables = {
    acceptsGiftCards?: boolean | null;
    acceptsOffers?: boolean | null;
    acceptsPaymentPlans?: boolean | null;
    brandUuids?: (string | null)[] | null;
    bumpedOnly: boolean;
    boostByBumpRate: boolean;
    categorySlugs?: (string | null)[] | null;
    categoryUuids?: (string | null)[] | null;
    conditionSlugs?: (string | null)[] | null;
    countryOfOrigin?: (string | null)[] | null;
    curatedSetId?: string | null;
    currency?: string | null;
    freeExpeditedShipping?: boolean | null;
    freeShipping?: boolean | null;
    handmade?: boolean | null;
    holidaySale?: boolean | null;
    itemRegion?: string | null;
    itemRegionRelation?: reverb_search_ListingItemRegionRelation | null;
    limit?: number | null;
    listingIds?: (string | null)[] | null;
    onSale?: boolean | null;
    preferredSeller?: boolean | null;
    priceMax?: string | null;
    priceMin?: string | null;
    query?: string | null;
    saleCuratedSetId?: string | null;
    saleSlugs?: (string | null)[] | null;
    shippingRegionCodes?: (string | null)[] | null;
    shopSlugs?: (string | null)[] | null;
    sort?: reverb_search_ListingsSearchRequest_Sort | null;
    yearMax?: string | null;
    yearMin?: string | null;
    showListingLocation: boolean;
    adKeywords?: (string | null)[] | null;
    hasAdKeywords: boolean;
    traitSlugs?: (string | null)[] | null;
    dealsOrWellPriced?: boolean | null;
    priceValueV2?: reverb_search_ListingsSearchRequest_PriceValue | null;
    shipsToMe?: boolean | null;
    shouldSkipTracking: boolean;
    multiClientExperiments?: (Input_reverb_search_ExperimentData | null)[] | null;
  }

  export type Query = {
    __typename?: "Query";
    listingsSearch?: ListingsSearch | null; 
    adServe?: AdServe | null; 
  }

  export type ListingsSearch = {
    __typename?: "reverb_search_SearchResponse";
    listings?: (Listings | null)[] | null; 
  }

  export type Listings = {
    __typename?: "Listing";
    _id?: string | null; 
  } & ListingsCollection.Fragment & mParticleListingFields.Fragment & BumpKey.Fragment & ShopFields.Fragment

  export type AdServe = {
    __typename?: "core_apimessages_AdServeResponse";
    ad?: Ad | null; 
  }

  export type Ad = {
    __typename?: "core_apimessages_Ad";
    imageAdCreative?: ImageAdCreative | null; 
  } & AdData.Fragment

  export type ImageAdCreative =ImageAdCreativeData.Fragment
}
export namespace CommonsCmsCspFeature {
  export type Variables = {
    ids?: (string | null)[] | null;
  }

  export type Query = {
    __typename?: "Query";
    csps?: (Csps | null)[] | null; 
  }

  export type Csps = {
    __typename?: "CSP";
    _id?: string | null; 
    summary?: string | null; 
  } & CSPCard.Fragment
}
export namespace CommonsCmsCspTiles {
  export type Variables = {
    ids?: (string | null)[] | null;
    fullTextQuery?: string | null;
    brandNames?: (string | null)[] | null;
    condition?: string | null;
    countryOfOrigin?: (string | null)[] | null;
    categoryUuids?: (string | null)[] | null;
    sort?: reverb_search_CSPSearchRequest_Sort | null;
    traitSlugs?: (string | null)[] | null;
    yearMin?: number | null;
    yearMax?: number | null;
  }

  export type Query = {
    __typename?: "Query";
    cspSearch?: CspSearch | null; 
  }

  export type CspSearch = {
    __typename?: "reverb_search_SearchResponse";
    csps?: (Csps | null)[] | null; 
  }

  export type Csps = {
    __typename?: "CSP";
    _id?: string | null; 
    metaDescription?: string | null; 
    summary?: string | null; 
    brand?: Brand | null; 
  } & CSPCard.Fragment

  export type Brand = {
    __typename?: "Brand";
    _id?: string | null; 
    name?: string | null; 
  }
}
export namespace CommonsCmsRecentlyViewedListings {
  export type Variables = {
    limit?: number | null;
    showListingLocation: boolean;
    shouldSkipTracking: boolean;
  }

  export type Query = {
    __typename?: "Query";
    recentlyViewedListings?: (RecentlyViewedListings | null)[] | null; 
  }

  export type RecentlyViewedListings = {
    __typename?: "Listing";
    _id?: string | null; 
  } & ListingsCollection.Fragment & mParticleListingFields.Fragment & ShopFields.Fragment
}
export namespace CommonsCmsCspCollection {
  export type Variables = {
    curatedSetId?: string | null;
    fullTextQuery?: string | null;
    brandNames?: (string | null)[] | null;
    brandSlugs?: (string | null)[] | null;
    condition?: string | null;
    countryOfOrigin?: (string | null)[] | null;
    limit?: number | null;
    categoryUuids?: (string | null)[] | null;
    sort?: reverb_search_CSPSearchRequest_Sort | null;
    traitSlugs?: (string | null)[] | null;
    slugs?: (string | null)[] | null;
    yearMin?: number | null;
    yearMax?: number | null;
  }

  export type Query = {
    __typename?: "Query";
    cspSearch?: CspSearch | null; 
  }

  export type CspSearch = {
    __typename?: "reverb_search_SearchResponse";
    csps?: (Csps | null)[] | null; 
  }

  export type Csps = {
    __typename?: "CSP";
    _id?: string | null; 
    metaDescription?: string | null; 
    summary?: string | null; 
    brand?: Brand | null; 
  } & CSPCard.Fragment

  export type Brand = {
    __typename?: "Brand";
    _id?: string | null; 
    name?: string | null; 
  }
}
export namespace CommonsCmsArticlesCollection {
  export type Variables = {
    ids?: (string | null)[] | null;
  }

  export type Query = {
    __typename?: "Query";
    articles?: (Articles | null)[] | null; 
  }

  export type Articles = {
    __typename?: "Article";
    _id?: string | null; 
    id?: string | null; 
    title?: string | null; 
    articleCategories?: (ArticleCategories | null)[] | null; 
    webLink?: WebLink | null; 
    images?: (Images | null)[] | null; 
  }

  export type ArticleCategories = {
    __typename?: "core_apimessages_ArticleCategory";
    name?: string | null; 
  }

  export type WebLink = {
    __typename?: "core_apimessages_Link";
    href?: string | null; 
  }

  export type Images = {
    __typename?: "core_apimessages_Image";
    source?: string | null; 
  }
}
export namespace CommonsCmsCategoryCollection {
  export type Variables = {
    categoryUuids?: (string | null)[] | null;
  }

  export type Query = {
    __typename?: "Query";
    categories?: (Categories | null)[] | null; 
  }

  export type Categories = {
    __typename?: "Category";
    _id?: string | null; 
    id?: string | null; 
    name?: string | null; 
    slug?: string | null; 
    rootSlug?: string | null; 
    cmsLink?: CmsLink | null; 
    images?: (Images | null)[] | null; 
  }

  export type CmsLink = {
    __typename?: "core_apimessages_Link";
    href?: string | null; 
  }

  export type Images = {
    __typename?: "core_apimessages_Image";
    source?: string | null; 
  }
}
export namespace CommonsCmsSubcategoryNav {
  export type Variables = {
    ids?: (string | null)[] | null;
    slugs?: (string | null)[] | null;
  }

  export type Query = {
    __typename?: "Query";
    categories?: (Categories | null)[] | null; 
  }

  export type Categories = {
    __typename?: "Category";
    _id?: string | null; 
    id?: string | null; 
    name?: string | null; 
    slug?: string | null; 
    rootSlug?: string | null; 
    cmsLink?: CmsLink | null; 
    images?: (Images | null)[] | null; 
    childCategories?: (ChildCategories | null)[] | null; 
    parentCategories?: (ParentCategories | null)[] | null; 
  }

  export type CmsLink = {
    __typename?: "core_apimessages_Link";
    href?: string | null; 
  }

  export type Images = {
    __typename?: "core_apimessages_Image";
    source?: string | null; 
  }

  export type ChildCategories = {
    __typename?: "Category";
    _id?: string | null; 
    id?: string | null; 
    name?: string | null; 
    slug?: string | null; 
    rootSlug?: string | null; 
    cmsLink?: _CmsLink | null; 
    images?: (_Images | null)[] | null; 
  }

  export type _CmsLink = {
    __typename?: "core_apimessages_Link";
    href?: string | null; 
  }

  export type _Images = {
    __typename?: "core_apimessages_Image";
    source?: string | null; 
  }

  export type ParentCategories = {
    __typename?: "Category";
    _id?: string | null; 
    id?: string | null; 
    name?: string | null; 
    slug?: string | null; 
    rootSlug?: string | null; 
    cmsLink?: __CmsLink | null; 
    images?: (__Images | null)[] | null; 
  }

  export type __CmsLink = {
    __typename?: "core_apimessages_Link";
    href?: string | null; 
  }

  export type __Images = {
    __typename?: "core_apimessages_Image";
    source?: string | null; 
  }
}
export namespace CommonsCmsCuratedSetCollection {
  export type Variables = {
    ids?: (string | null)[] | null;
  }

  export type Query = {
    __typename?: "Query";
    curatedSets?: (CuratedSets | null)[] | null; 
  }

  export type CuratedSets = {
    __typename?: "CuratedSet";
    _id?: string | null; 
    id?: string | null; 
    title?: string | null; 
    webLink?: WebLink | null; 
    images?: (Images | null)[] | null; 
  }

  export type WebLink = {
    __typename?: "core_apimessages_Link";
    href?: string | null; 
  }

  export type Images = {
    __typename?: "core_apimessages_Image";
    source?: string | null; 
  }
}
export namespace CoreCmsPageCards {
  export type Variables = {
    cms1Slugs?: (string | null)[] | null;
    cms2Slugs?: (string | null)[] | null;
  }

  export type Query = {
    __typename?: "Query";
    cmsPages?: (CmsPages | null)[] | null; 
    articles?: (Articles | null)[] | null; 
  }

  export type CmsPages = {
    __typename?: "CMSPage";
    _id?: string | null; 
    slug?: string | null; 
    title?: string | null; 
    pageType?: string | null; 
    channels?: (string | null)[] | null; 
    image?: Image | null; 
    pageNotFound?: boolean | null; 
  }

  export type Image = {
    __typename?: "cms_PageImage";
    imageUrl?: string | null; 
  }

  export type Articles = {
    __typename?: "Article";
    _id?: string | null; 
    slug?: string | null; 
    title?: string | null; 
    webLink?: WebLink | null; 
    images?: (Images | null)[] | null; 
  }

  export type WebLink = {
    __typename?: "core_apimessages_Link";
    href?: string | null; 
  }

  export type Images = {
    __typename?: "core_apimessages_Image";
    source?: string | null; 
  }
}
export namespace CommonsCmsBrandCollection {
  export type Variables = {
    maxCount?: number | null;
    curatedSetId?: string | null;
    onSale?: boolean | null;
    saleCuratedSetId?: string | null;
    priceMax?: string | null;
    priceMin?: string | null;
    yearMax?: string | null;
    yearMin?: string | null;
    categorySlugs?: (string | null)[] | null;
    query?: string | null;
  }

  export type Query = {
    __typename?: "Query";
    listingsSearch?: ListingsSearch | null; 
  }

  export type ListingsSearch = {
    __typename?: "reverb_search_SearchResponse";
    topCollections?: TopCollections | null; 
  }

  export type TopCollections = {
    __typename?: "reverb_search_TopCollectionsResult";
    brands?: (Brands | null)[] | null; 
  }

  export type Brands = {
    __typename?: "Brand";
    _id?: string | null; 
    id?: string | null; 
    name?: string | null; 
    slug?: string | null; 
    webLink?: WebLink | null; 
    images?: (Images | null)[] | null; 
  }

  export type WebLink = {
    __typename?: "core_apimessages_Link";
    href?: string | null; 
  }

  export type Images = {
    __typename?: "core_apimessages_Image";
    source?: string | null; 
  }
}
export namespace CommonsWatchedListings {
  export type Variables = {
    limit?: number | null;
    showListingLocation: boolean;
    shouldSkipTracking: boolean;
  }

  export type Query = {
    __typename?: "Query";
    me?: Me | null; 
  }

  export type Me = {
    __typename?: "rql_Me";
    uuid?: string | null; 
    watches?: Watches | null; 
  }

  export type Watches = {
    __typename?: "WatchCollection";
    nodes?: (Nodes | null)[] | null; 
  }

  export type Nodes = {
    __typename?: "Watch";
    _id?: string | null; 
    listing?: Listing | null; 
  }

  export type Listing = {
    __typename?: "Listing";
    _id?: string | null; 
  } & ListingsCollection.Fragment & mParticleListingFields.Fragment & ShopFields.Fragment
}
export namespace CommonsMParticleArticle {
  export type Variables = {
    slug?: string | null;
  }

  export type Query = {
    __typename?: "Query";
    article?: Article | null; 
  }

  export type Article = {
    __typename?: "Article";
    _id?: string | null; 
    categories?: (Categories | null)[] | null; 
  }

  export type Categories = {
    __typename?: "core_apimessages_Category";
    slug?: string | null; 
  }
}
export namespace CommonsShippingRegionFilter {
  export type Variables = {
    paramName?: string | null;
    selectedValues?: (string | null)[] | null;
  }

  export type Query = {
    __typename?: "Query";
    shippingRegionFilter?: ShippingRegionFilter | null; 
  }

  export type ShippingRegionFilter = {
    __typename?: "reverb_search_ShippingRegionFilterResponse";
    filter?: Filter | null; 
  }

  export type Filter = {
    __typename?: "reverb_search_Filter";
    name?: string | null; 
    aggregationName?: string | null; 
    widgetType?: reverb_search_Filter_WidgetType | null; 
    options?: (Options | null)[] | null; 
  }

  export type Options = {
    __typename?: "reverb_search_FilterOption";
    count?: Count | null; 
    name?: string | null; 
    selected?: boolean | null; 
    paramName?: string | null; 
    setValues?: (string | null)[] | null; 
    unsetValues?: (string | null)[] | null; 
    all?: boolean | null; 
    optionValue?: string | null; 
  }

  export type Count = {
    __typename?: "google_protobuf_Int32Value";
    value?: number | null; 
  }
}
export namespace CommonsCmsCmsEmbed {
  export type Variables = {
    slug?: string | null;
    admin?: boolean | null;
  }

  export type Query = {
    __typename?: "Query";
    pages?: (Pages | null)[] | null; 
  }

  export type Pages = {
    __typename?: "CMSPage";
    _id?: string | null; 
    id?: string | null; 
    slug?: string | null; 
    actionText?: string | null; 
    actionUrl?: string | null; 
    authorName?: string | null; 
    description?: string | null; 
    goLiveAt?: string | null; 
    headerStyle?: string | null; 
    layoutSlug?: string | null; 
    pageType?: string | null; 
    searchPlaceholder?: string | null; 
    title?: string | null; 
    metaTitle?: string | null; 
    metaDescription?: string | null; 
    noIndex?: boolean | null; 
    image?: Image | null; 
    metaImage?: MetaImage | null; 
    secondaryImage?: SecondaryImage | null; 
    components?: (Components | null)[] | null; 
    live?: boolean | null; 
    pageNotFound?: boolean | null; 
  }

  export type Image = {
    __typename?: "cms_PageImage";
    imageUrl?: string | null; 
  }

  export type MetaImage = {
    __typename?: "cms_PageImage";
    imageUrl?: string | null; 
  }

  export type SecondaryImage = {
    __typename?: "cms_PageImage";
    imageUrl?: string | null; 
  }

  export type Components = {
    __typename?: "PublicComponent";
    _id?: string | null; 
    id?: string | null; 
    position?: number | null; 
    componentType?: string | null; 
    data?: string | null; 
    layoutSection?: string | null; 
    experimentKey?: string | null; 
    experimentBucket?: string | null; 
  }
}
export namespace CommonsSimilarCspsRow {
  export type Variables = {
    similarCspSlug?: string | null;
    similarListingId?: string | null;
    limit?: number | null;
  }

  export type Query = {
    __typename?: "Query";
    cspSearch?: CspSearch | null; 
  }

  export type CspSearch = {
    __typename?: "reverb_search_SearchResponse";
    csps?: (Csps | null)[] | null; 
  }

  export type Csps = {
    __typename?: "CSP";
    _id?: string | null; 
  } & CSPCard.Fragment
}
export namespace CreateMyWatches {
  export type Variables = {
    input?: Input_core_apimessages_WatchesCreateRequest | null;
  }

  export type Mutation = {
    __typename?: "Mutation";
    createWatch?: CreateWatch | null; 
  }

  export type CreateWatch = {
    __typename?: "core_apimessages_UpdateWatchResponse";
    id?: string | null; 
    listing?: Listing | null; 
  }

  export type Listing = {
    __typename?: "Listing";
    id?: string | null; 
    _id?: string | null; 
    watching?: boolean | null; 
  }
}
export namespace DeleteMyWatches {
  export type Variables = {
    input?: Input_core_apimessages_WatchesDeleteRequest | null;
  }

  export type Mutation = {
    __typename?: "Mutation";
    deleteWatch?: DeleteWatch | null; 
  }

  export type DeleteWatch = {
    __typename?: "core_apimessages_UpdateWatchResponse";
    id?: string | null; 
    listing?: Listing | null; 
  }

  export type Listing = {
    __typename?: "Listing";
    _id?: string | null; 
    id?: string | null; 
    watching?: boolean | null; 
  }
}
export namespace CommonsMParticleListing {
  export type Variables = {
    ids?: (string | null)[] | null;
    shouldSkipTracking: boolean;
  }

  export type Query = {
    __typename?: "Query";
    listings?: (Listings | null)[] | null; 
  }

  export type Listings = {
    __typename?: "Listing";
    _id?: string | null; 
  } & mParticleListingFields.Fragment
}
export namespace CoreAdBannerWrapper {
  export type Variables = {
    keywords?: (string | null)[] | null;
  }

  export type Query = {
    __typename?: "Query";
    adServe?: AdServe | null; 
  }

  export type AdServe = {
    __typename?: "core_apimessages_AdServeResponse";
    ad?: Ad | null; 
  }

  export type Ad = {
    __typename?: "core_apimessages_Ad";
    imageAdCreative?: ImageAdCreative | null; 
  } & AdData.Fragment

  export type ImageAdCreative =ImageAdCreativeData.Fragment
}
export namespace CoreAdEndedListingPage {
  export type Variables = {
    categories?: (string | null)[] | null;
  }

  export type Query = {
    __typename?: "Query";
    adServe?: AdServe | null; 
  }

  export type AdServe = {
    __typename?: "core_apimessages_AdServeResponse";
    ad?: Ad | null; 
  }

  export type Ad = {
    __typename?: "core_apimessages_Ad";
    imageAdCreative?: ImageAdCreative | null; 
  } & AdData.Fragment

  export type ImageAdCreative = {
    __typename?: "core_apimessages_ImageAdCreative";
    cspRowQuery?: CspRowQuery | null; 
  } & ImageAdCreativeData.Fragment

  export type CspRowQuery =AdCspRowQueryData.Fragment
}
export namespace CoreDevAdPreviews {
  export type Variables = {
    offset?: number | null;
    limit?: number | null;
    status?: core_apimessages_AdCampaignsSearchRequest_Status | null;
    adZoneSlugs?: (string | null)[] | null;
    withinDate?: string | null;
    advertiserUuids?: (string | null)[] | null;
    advertiserOffset?: number | null;
    advertiserLimit?: number | null;
  }

  export type Query = {
    __typename?: "Query";
    adCampaignsSearch?: AdCampaignsSearch | null; 
    advertisersSearch?: AdvertisersSearch | null; 
    countries?: Countries | null; 
    adZonesSearch?: AdZonesSearch | null; 
  }

  export type AdCampaignsSearch = {
    __typename?: "core_apimessages_AdCampaignsSearchResponse";
    offset?: number | null; 
    limit?: number | null; 
    total?: number | null; 
    adCampaigns?: (AdCampaigns | null)[] | null; 
  }

  export type AdCampaigns = {
    __typename?: "AdCampaign";
    _id?: string | null; 
    adGroupCollection?: AdGroupCollection | null; 
  } & AdCampaignData.Fragment

  export type AdGroupCollection = {
    __typename?: "AdGroupCollection";
    _ids?: (string | null)[] | null; 
    adGroups?: (AdGroups | null)[] | null; 
  }

  export type AdGroups = {
    __typename?: "AdGroup";
    _id?: string | null; 
    adCollection?: AdCollection | null; 
  } & AdGroupWithoutKeywordsData.Fragment

  export type AdCollection = {
    __typename?: "AdCollection";
    _ids?: (string | null)[] | null; 
    ads?: (Ads | null)[] | null; 
  }

  export type Ads = {
    __typename?: "Ad";
    _id?: string | null; 
    uuid?: string | null; 
    imageAdCreative?: ImageAdCreative | null; 
  }

  export type ImageAdCreative = {
    __typename?: "core_apimessages_ImageAdCreative";
    cspRowQuery?: CspRowQuery | null; 
  } & ImageAdCreativeData.Fragment

  export type CspRowQuery =AdCspRowQueryData.Fragment

  export type AdvertisersSearch = {
    __typename?: "core_apimessages_AdvertisersSearchResponse";
    offset?: number | null; 
    limit?: number | null; 
    total?: number | null; 
    advertisers?: (Advertisers | null)[] | null; 
  }

  export type Advertisers = {
    __typename?: "Advertiser";
    _id?: string | null; 
    uuid?: string | null; 
    name?: string | null; 
  }

  export type Countries = {
    __typename?: "core_apimessages_CountriesResponse";
    countries?: (_Countries | null)[] | null; 
  }

  export type _Countries = {
    __typename?: "core_apimessages_Country";
    name?: string | null; 
    countryCode?: string | null; 
  }

  export type AdZonesSearch = {
    __typename?: "core_apimessages_AdZonesSearchResponse";
    adZones?: (AdZones | null)[] | null; 
  }

  export type AdZones = {
    __typename?: "AdZone";
    _id?: string | null; 
    slug?: string | null; 
  }
}
export namespace CoreAdImageFeature {
  export type Variables = {
    categories?: (string | null)[] | null;
    adZone?: string | null;
  }

  export type Query = {
    __typename?: "Query";
    adServe?: AdServe | null; 
  }

  export type AdServe = {
    __typename?: "core_apimessages_AdServeResponse";
    placements?: (Placements | null)[] | null; 
  }

  export type Placements = {
    __typename?: "core_apimessages_AdPlacementResponse";
    adZones?: (AdZones | null)[] | null; 
    ad?: Ad | null; 
  }

  export type AdZones = {
    __typename?: "core_apimessages_AdZone";
    slug?: string | null; 
  }

  export type Ad = {
    __typename?: "core_apimessages_Ad";
    imageAdCreative?: ImageAdCreative | null; 
  } & AdData.Fragment

  export type ImageAdCreative =ImageAdCreativeData.Fragment
}
export namespace CommonsCmsDynamicPage {
  export type Variables = {
    slug?: string | null;
    admin?: boolean | null;
  }

  export type Query = {
    __typename?: "Query";
    pages?: (Pages | null)[] | null; 
  }

  export type Pages = {
    __typename?: "CMSPage";
    _id?: string | null; 
    id?: string | null; 
    slug?: string | null; 
    title?: string | null; 
    description?: string | null; 
    metaTitle?: string | null; 
    metaDescription?: string | null; 
    componentIds?: (string | null)[] | null; 
    pageType?: string | null; 
    channels?: (string | null)[] | null; 
    locale?: string | null; 
    layoutSlug?: string | null; 
    headerStyle?: string | null; 
    actionText?: string | null; 
    actionUrl?: string | null; 
    searchPlaceholder?: string | null; 
    noIndex?: boolean | null; 
    components?: (Components | null)[] | null; 
    image?: Image | null; 
    metaImage?: MetaImage | null; 
    secondaryImage?: SecondaryImage | null; 
    breadcrumbs?: string | null; 
    authorName?: string | null; 
    goLiveAt?: string | null; 
    live?: boolean | null; 
    pageNotFound?: boolean | null; 
  }

  export type Components = {
    __typename?: "PublicComponent";
    _id?: string | null; 
    id?: string | null; 
    position?: number | null; 
    componentType?: string | null; 
    data?: string | null; 
    layoutSection?: string | null; 
    experimentKey?: string | null; 
    experimentBucket?: string | null; 
  }

  export type Image = {
    __typename?: "cms_PageImage";
    imageUrl?: string | null; 
  }

  export type MetaImage = {
    __typename?: "cms_PageImage";
    imageUrl?: string | null; 
  }

  export type SecondaryImage = {
    __typename?: "cms_PageImage";
    imageUrl?: string | null; 
  }
}
export namespace CommonsMParticleOrderBundles {
  export type Variables = {
    id?: string | null;
  }

  export type Query = {
    __typename?: "Query";
    orderBundles?: (OrderBundles | null)[] | null; 
  }

  export type OrderBundles = {
    __typename?: "OrderBundle";
    _id?: string | null; 
    paymentMethod?: core_apimessages_Payment_PaymentMethod | null; 
    localPickup?: boolean | null; 
    amountTax?: AmountTax | null; 
    amountShipping?: AmountShipping | null; 
    amountProductSubtotal?: AmountProductSubtotal | null; 
    orders?: Orders | null; 
  }

  export type AmountTax = {
    __typename?: "core_apimessages_Money";
    amount?: string | null; 
  }

  export type AmountShipping = {
    __typename?: "core_apimessages_Money";
    amount?: string | null; 
  }

  export type AmountProductSubtotal = {
    __typename?: "core_apimessages_Money";
    amount?: string | null; 
  }

  export type Orders = {
    __typename?: "OrderCollection";
    nodes?: (Nodes | null)[] | null; 
  }

  export type Nodes = {
    __typename?: "Order";
    _id?: string | null; 
    id?: string | null; 
    quantity?: number | null; 
    settlementAmountProductSubtotal?: SettlementAmountProductSubtotal | null; 
    listing?: Listing | null; 
  }

  export type SettlementAmountProductSubtotal = {
    __typename?: "core_apimessages_Money";
    amount?: string | null; 
  }

  export type Listing = {
    __typename?: "Listing";
    _id?: string | null; 
  } & mParticleListingFields.Fragment
}
export namespace CoreCheckoutPaymentLayout {
  export type Variables = {
    id?: string | null;
    reverbApp?: string | null;
  }

  export type Query = {
    __typename?: "Query";
    checkout?: Checkout | null; 
    me?: Me | null; 
  }

  export type Checkout = {
    __typename?: "Checkout";
    _id?: string | null; 
    id?: string | null; 
    action?: Action | null; 
  } & PaymentLayoutCheckoutFields.Fragment & CheckoutTrackingFields.Fragment

  export type Action = {
    __typename?: "CheckoutAction";
    _id?: string | null; 
  } & CheckoutActionHookFields.Fragment

  export type Me = {
    __typename?: "rql_Me";
    uuid?: string | null; 
  } & PaymentLayoutMeFields.Fragment
}
export namespace MyShopTaxPolicyData {
  export type Variables = {
  }

  export type Query = {
    __typename?: "Query";
    me?: Me | null; 
    countries?: Countries | null; 
  }

  export type Me = {
    __typename?: "rql_Me";
    uuid?: string | null; 
    shop?: Shop | null; 
  }

  export type Shop = {
    __typename?: "MyShop";
    _id?: string | null; 
    address?: Address | null; 
  }

  export type Address = {
    __typename?: "core_apimessages_Address";
    countryCode?: string | null; 
  }

  export type Countries = {
    __typename?: "core_apimessages_CountriesResponse";
    countries?: (_Countries | null)[] | null; 
  }

  export type _Countries = {
    __typename?: "core_apimessages_Country";
    name?: string | null; 
    countryCode?: string | null; 
    subregions?: (Subregions | null)[] | null; 
  }

  export type Subregions = {
    __typename?: "core_apimessages_Subregion";
    name?: string | null; 
    code?: string | null; 
  }
}
export namespace CoreDashboardUpdateShopEuAddress {
  export type Variables = {
    input?: Input_core_apimessages_UpdateAddressRequest | null;
  }

  export type Mutation = {
    __typename?: "Mutation";
    updateMyAddress?: UpdateMyAddress | null; 
  }

  export type UpdateMyAddress = {
    __typename?: "core_apimessages_UpdateAddressResponse";
    address?: Address | null; 
  }

  export type Address = {
    __typename?: "core_apimessages_Address";
    uuid?: string | null; 
  }
}
export namespace DeleteEuAddress {
  export type Variables = {
    input?: Input_core_apimessages_AddressDeleteRequest | null;
  }

  export type Mutation = {
    __typename?: "Mutation";
    deleteMyAddress?: DeleteMyAddress | null; 
  }

  export type DeleteMyAddress = {
    __typename?: "core_apimessages_DeleteResponse";
    uuid?: string | null; 
  }
}
export namespace CoreDashboardEuOdrAddress {
  export type Variables = {
    slug?: string | null;
  }

  export type Query = {
    __typename?: "Query";
    countries?: Countries | null; 
    shop?: Shop | null; 
  }

  export type Countries = {
    __typename?: "core_apimessages_CountriesResponse";
    countries?: (_Countries | null)[] | null; 
  }

  export type _Countries = {
    __typename?: "core_apimessages_Country";
    name?: string | null; 
    countryCode?: string | null; 
    subregions?: (Subregions | null)[] | null; 
  }

  export type Subregions = {
    __typename?: "core_apimessages_Subregion";
    name?: string | null; 
    code?: string | null; 
  }

  export type Shop = {
    __typename?: "Shop";
    _id?: string | null; 
    euOdrAddress?: EuOdrAddress | null; 
  }

  export type EuOdrAddress = {
    __typename?: "core_apimessages_Address";
    name?: string | null; 
    streetAddress?: string | null; 
    displayLocation?: string | null; 
    postalCode?: string | null; 
    email?: string | null; 
    phone?: string | null; 
    countryCode?: string | null; 
    region?: string | null; 
    locality?: string | null; 
    uuid?: string | null; 
  }
}
export namespace ReverifyCreditCardMutation {
  export type Variables = {
    input?: Input_core_apimessages_ReverifyCreditCardRequest | null;
  }

  export type Mutation = {
    __typename?: "Mutation";
    reverifyCreditCard?: ReverifyCreditCard | null; 
  }

  export type ReverifyCreditCard = {
    __typename?: "core_apimessages_ReverifyCreditCardResponse";
    creditCard?: CreditCard | null; 
  }

  export type CreditCard = {
    __typename?: "core_apimessages_CreditCard";
    id?: string | null; 
    last4?: string | null; 
    cardType?: string | null; 
    expirationYear?: string | null; 
    expirationMonth?: string | null; 
    cardholderName?: string | null; 
    needsReverification?: boolean | null; 
    primaryForCheckout?: boolean | null; 
  }
}
export namespace SearchUsers {
  export type Variables = {
    input?: Input_core_apimessages_AdminUserSearchRequest | null;
  }

  export type Query = {
    __typename?: "Query";
    userSearch?: UserSearch | null; 
  }

  export type UserSearch = {
    __typename?: "core_apimessages_AdminUserSearchResponse";
    users?: (Users | null)[] | null; 
  }

  export type Users = {
    __typename?: "core_apimessages_UserSearchResult";
    id?: string | null; 
    email?: string | null; 
    shopId?: string | null; 
    shopName?: string | null; 
  }
}
export namespace DiscoRecentlyViewedListingPhotosRow {
  export type Variables = {
  }

  export type Query = {
    __typename?: "Query";
    recentlyViewedListings?: (RecentlyViewedListings | null)[] | null; 
  }

  export type RecentlyViewedListings = {
    __typename?: "Listing";
    _id?: string | null; 
  } & PhotoTileData.Fragment
}
export namespace CoreUpdateAdCampaign {
  export type Variables = {
    input?: Input_core_apimessages_UpdateAdCampaignRequest | null;
  }

  export type Mutation = {
    __typename?: "Mutation";
    updateAdCampaign?: UpdateAdCampaign | null; 
  }

  export type UpdateAdCampaign = {
    __typename?: "core_apimessages_UpdateAdCampaignResponse";
    adCampaign?: AdCampaign | null; 
  }

  export type AdCampaign = {
    __typename?: "core_apimessages_AdCampaign";
    name?: string | null; 
    uuid?: string | null; 
    description?: string | null; 
    status?: core_apimessages_AdCampaign_AdStatus | null; 
    startsAt?: Timestamp | null; 
    endsAt?: Timestamp | null; 
    advertiserUuid?: string | null; 
  }
}
export namespace CoreAdAdminAdGroups {
  export type Variables = {
    adCampaignUuid?: string | null;
    advertiserUuid?: string | null;
  }

  export type Query = {
    __typename?: "Query";
    adcampaign?: Adcampaign | null; 
    advertiser?: Advertiser | null; 
  }

  export type Adcampaign = {
    __typename?: "AdCampaign";
    _id?: string | null; 
    uuid?: string | null; 
    name?: string | null; 
    adGroupCollection?: AdGroupCollection | null; 
  }

  export type AdGroupCollection = {
    __typename?: "AdGroupCollection";
    _ids?: (string | null)[] | null; 
    adGroups?: (AdGroups | null)[] | null; 
  }

  export type AdGroups = {
    __typename?: "AdGroup";
    _id?: string | null; 
  } & AdGroupData.Fragment

  export type Advertiser = {
    __typename?: "Advertiser";
    _id?: string | null; 
  } & AdvertiserData.Fragment
}
export namespace CoreAdAdminAdvertisers {
  export type Variables = {
    offset?: number | null;
    limit?: number | null;
  }

  export type Query = {
    __typename?: "Query";
    advertisersSearch?: AdvertisersSearch | null; 
  }

  export type AdvertisersSearch = {
    __typename?: "core_apimessages_AdvertisersSearchResponse";
    offset?: number | null; 
    limit?: number | null; 
    total?: number | null; 
    advertisers?: (Advertisers | null)[] | null; 
  }

  export type Advertisers = {
    __typename?: "Advertiser";
    _id?: string | null; 
  } & AdvertiserData.Fragment
}
export namespace CoreAdAdminAdGroupForm {
  export type Variables = {
    uuid?: string | null;
  }

  export type Query = {
    __typename?: "Query";
    adgroup?: Adgroup | null; 
    countries?: Countries | null; 
    adZonesSearch?: AdZonesSearch | null; 
  }

  export type Adgroup = {
    __typename?: "AdGroup";
    _id?: string | null; 
  } & AdGroupWithKeywordsData.Fragment

  export type Countries = {
    __typename?: "core_apimessages_CountriesResponse";
    countries?: (_Countries | null)[] | null; 
  }

  export type _Countries = {
    __typename?: "core_apimessages_Country";
    name?: string | null; 
    countryCode?: string | null; 
  }

  export type AdZonesSearch = {
    __typename?: "core_apimessages_AdZonesSearchResponse";
    adZones?: (AdZones | null)[] | null; 
  }

  export type AdZones = {
    __typename?: "AdZone";
    _id?: string | null; 
    slug?: string | null; 
  }
}
export namespace CoreUpdateAd {
  export type Variables = {
    input?: Input_core_apimessages_UpdateAdRequest | null;
  }

  export type Mutation = {
    __typename?: "Mutation";
    updateAd?: UpdateAd | null; 
  }

  export type UpdateAd = {
    __typename?: "core_apimessages_UpdateAdResponse";
    ad?: Ad | null; 
  }

  export type Ad = {
    __typename?: "core_apimessages_Ad";
    uuid?: string | null; 
    adGroupUuid?: string | null; 
    adCampaignUuid?: string | null; 
    imageAdCreative?: ImageAdCreative | null; 
    localizedContents?: (LocalizedContents | null)[] | null; 
  }

  export type ImageAdCreative =ImageAdCreativeData.Fragment

  export type LocalizedContents = {
    __typename?: "core_apimessages_AdLocalizedContent";
    locale?: string | null; 
    imageAdCreative?: _ImageAdCreative | null; 
  }

  export type _ImageAdCreative =ImageAdCreativeData.Fragment
}
export namespace CoreAdAdminAdZoneForm {
  export type Variables = {
    uuid?: string | null;
  }

  export type Query = {
    __typename?: "Query";
    adzone?: Adzone | null; 
  }

  export type Adzone = {
    __typename?: "AdZone";
    _id?: string | null; 
  } & AdZoneData.Fragment
}
export namespace CoreUpdateAdZone {
  export type Variables = {
    input?: Input_core_apimessages_UpdateAdZoneRequest | null;
  }

  export type Mutation = {
    __typename?: "Mutation";
    updateAdZone?: UpdateAdZone | null; 
  }

  export type UpdateAdZone = {
    __typename?: "core_apimessages_UpdateAdZoneResponse";
    adZone?: AdZone | null; 
  }

  export type AdZone = {
    __typename?: "core_apimessages_AdZone";
    uuid?: string | null; 
    name?: string | null; 
    slug?: string | null; 
    status?: core_apimessages_AdZone_AdZoneStatus | null; 
    description?: string | null; 
  }
}
export namespace CoreUpdateAdGroup {
  export type Variables = {
    input?: Input_core_apimessages_UpdateAdGroupRequest | null;
  }

  export type Mutation = {
    __typename?: "Mutation";
    updateAdGroup?: UpdateAdGroup | null; 
  }

  export type UpdateAdGroup = {
    __typename?: "core_apimessages_UpdateAdGroupResponse";
    adGroup?: AdGroup | null; 
  }

  export type AdGroup = {
    __typename?: "core_apimessages_AdGroup";
    name?: string | null; 
    uuid?: string | null; 
    status?: core_apimessages_AdGroup_AdStatus | null; 
    targetedCountryCodes?: (string | null)[] | null; 
    targetedCategoryUuids?: (string | null)[] | null; 
    targetedBrandSlugs?: (string | null)[] | null; 
    targetedAdZones?: (TargetedAdZones | null)[] | null; 
    targetedDevices?: (string | null)[] | null; 
  }

  export type TargetedAdZones = {
    __typename?: "core_apimessages_AdGroupZone";
    adZone?: AdZone | null; 
    startsAt?: Timestamp | null; 
    endsAt?: Timestamp | null; 
  }

  export type AdZone = {
    __typename?: "core_apimessages_AdZone";
    slug?: string | null; 
  }
}
export namespace CoreUpdateAdGroupKeywords {
  export type Variables = {
    input?: Input_core_apimessages_UpdateAdGroupKeywordsRequest | null;
  }

  export type Mutation = {
    __typename?: "Mutation";
    updateAdGroupKeywords?: UpdateAdGroupKeywords | null; 
  }

  export type UpdateAdGroupKeywords = {
    __typename?: "core_apimessages_UpdateAdGroupKeywordsResponse";
    adGroupKeywords?: (AdGroupKeywords | null)[] | null; 
  }

  export type AdGroupKeywords = {
    __typename?: "core_apimessages_AdGroupKeyword";
    id?: string | null; 
  }
}
export namespace CoreUpdateAdvertiser {
  export type Variables = {
    input?: Input_core_apimessages_UpdateAdvertiserRequest | null;
  }

  export type Mutation = {
    __typename?: "Mutation";
    updateAdvertiser?: UpdateAdvertiser | null; 
  }

  export type UpdateAdvertiser = {
    __typename?: "core_apimessages_UpdateAdvertiserResponse";
    advertiser?: Advertiser | null; 
  }

  export type Advertiser = {
    __typename?: "core_apimessages_Advertiser";
    name?: string | null; 
    uuid?: string | null; 
    brandSlugs?: (string | null)[] | null; 
    shopSlugs?: (string | null)[] | null; 
  }
}
export namespace CoreAdAdminAdCampaigns {
  export type Variables = {
    advertiserUuid?: string | null;
  }

  export type Query = {
    __typename?: "Query";
    advertiser?: Advertiser | null; 
  }

  export type Advertiser = {
    __typename?: "Advertiser";
    _id?: string | null; 
    adCampaignCollection?: AdCampaignCollection | null; 
  } & AdvertiserData.Fragment

  export type AdCampaignCollection = {
    __typename?: "AdCampaignCollection";
    _ids?: (string | null)[] | null; 
    adCampaigns?: (AdCampaigns | null)[] | null; 
  }

  export type AdCampaigns = {
    __typename?: "AdCampaign";
    _id?: string | null; 
  } & AdCampaignData.Fragment
}
export namespace CoreAdAdminAdZones {
  export type Variables = {
    offset?: number | null;
    limit?: number | null;
  }

  export type Query = {
    __typename?: "Query";
    adZonesSearch?: AdZonesSearch | null; 
  }

  export type AdZonesSearch = {
    __typename?: "core_apimessages_AdZonesSearchResponse";
    adZones?: (AdZones | null)[] | null; 
  }

  export type AdZones = {
    __typename?: "AdZone";
    _id?: string | null; 
  } & AdZoneData.Fragment
}
export namespace CoreAdAdminAdCampaignForm {
  export type Variables = {
    uuid?: string | null;
  }

  export type Query = {
    __typename?: "Query";
    adcampaign?: Adcampaign | null; 
  }

  export type Adcampaign = {
    __typename?: "AdCampaign";
    _id?: string | null; 
  } & AdCampaignData.Fragment
}
export namespace CoreAdAdminAdvertiserForm {
  export type Variables = {
    uuid?: string | null;
  }

  export type Query = {
    __typename?: "Query";
    advertiser?: Advertiser | null; 
  }

  export type Advertiser = {
    __typename?: "Advertiser";
    _id?: string | null; 
  } & AdvertiserData.Fragment
}
export namespace CoreAdAdminAdForm {
  export type Variables = {
    uuid?: string | null;
  }

  export type Query = {
    __typename?: "Query";
    ad?: Ad | null; 
  }

  export type Ad = {
    __typename?: "Ad";
    _id?: string | null; 
    localizedContents?: (LocalizedContents | null)[] | null; 
  } & AdCardData.Fragment

  export type LocalizedContents = {
    __typename?: "core_apimessages_AdLocalizedContent";
    locale?: string | null; 
    imageAdCreative?: ImageAdCreative | null; 
  }

  export type ImageAdCreative = {
    __typename?: "core_apimessages_ImageAdCreative";
    cspRowQuery?: CspRowQuery | null; 
  } & ImageAdCreativeData.Fragment

  export type CspRowQuery =AdCspRowQueryData.Fragment
}
export namespace CoreAdAdminAds {
  export type Variables = {
    adGroupUuid?: string | null;
    adCampaignUuid?: string | null;
    advertiserUuid?: string | null;
  }

  export type Query = {
    __typename?: "Query";
    adgroup?: Adgroup | null; 
    adcampaign?: Adcampaign | null; 
    advertiser?: Advertiser | null; 
  }

  export type Adgroup = {
    __typename?: "AdGroup";
    _id?: string | null; 
    name?: string | null; 
    uuid?: string | null; 
    adCollection?: AdCollection | null; 
  }

  export type AdCollection = {
    __typename?: "AdCollection";
    _ids?: (string | null)[] | null; 
    ads?: (Ads | null)[] | null; 
  }

  export type Ads = {
    __typename?: "Ad";
    _id?: string | null; 
  } & AdCardData.Fragment

  export type Adcampaign = {
    __typename?: "AdCampaign";
    _id?: string | null; 
    uuid?: string | null; 
    name?: string | null; 
  }

  export type Advertiser = {
    __typename?: "Advertiser";
    _id?: string | null; 
  } & AdvertiserData.Fragment
}
export namespace CoreDeleteAd {
  export type Variables = {
    input?: Input_core_apimessages_DeleteAdRequest | null;
  }

  export type Mutation = {
    __typename?: "Mutation";
    DeleteAd?: DeleteAd | null; 
  }

  export type DeleteAd = {
    __typename?: "core_apimessages_DeleteAdResponse";
    ad?: Ad | null; 
  }

  export type Ad = {
    __typename?: "core_apimessages_Ad";
    uuid?: string | null; 
    deletedAt?: Timestamp | null; 
  }
}
export namespace CoreCopyAdGroup {
  export type Variables = {
    input?: Input_core_apimessages_CopyAdGroupRequest | null;
  }

  export type Mutation = {
    __typename?: "Mutation";
    copyAdGroup?: CopyAdGroup | null; 
  }

  export type CopyAdGroup = {
    __typename?: "core_apimessages_CopyAdGroupResponse";
    adGroup?: AdGroup | null; 
  }

  export type AdGroup = {
    __typename?: "core_apimessages_AdGroup";
    name?: string | null; 
    uuid?: string | null; 
    status?: core_apimessages_AdGroup_AdStatus | null; 
    targetedCountryCodes?: (string | null)[] | null; 
    targetedCategoryUuids?: (string | null)[] | null; 
    targetedBrandSlugs?: (string | null)[] | null; 
    targetedAdZones?: (TargetedAdZones | null)[] | null; 
    targetedDevices?: (string | null)[] | null; 
  }

  export type TargetedAdZones = {
    __typename?: "core_apimessages_AdGroupZone";
    adZone?: AdZone | null; 
    startsAt?: Timestamp | null; 
    endsAt?: Timestamp | null; 
  }

  export type AdZone = {
    __typename?: "core_apimessages_AdZone";
    slug?: string | null; 
  }
}
export namespace CorePayoutsCreateMyPlaidLinkToken {
  export type Variables = {
    input?: Input_core_apimessages_CreateMyPlaidLinkTokenRequest | null;
  }

  export type Mutation = {
    __typename?: "Mutation";
    createMyPlaidLinkToken?: CreateMyPlaidLinkToken | null; 
  }

  export type CreateMyPlaidLinkToken = {
    __typename?: "core_apimessages_CreateMyPlaidLinkTokenResponse";
    linkToken?: string | null; 
  }
}
export namespace CorePayoutsSaveMyPlaidAccount {
  export type Variables = {
    input?: Input_core_apimessages_SaveMyPlaidAccountRequest | null;
  }

  export type Mutation = {
    __typename?: "Mutation";
    saveMyPlaidAccount?: SaveMyPlaidAccount | null; 
  }

  export type SaveMyPlaidAccount = {
    __typename?: "core_apimessages_SaveMyPlaidAccountResponse";
    plaidAccountId?: string | null; 
  }
}
export namespace CorePayoutsCancelPlaidAccount {
  export type Variables = {
    input?: Input_core_apimessages_CancelPlaidAccountRequest | null;
  }

  export type Mutation = {
    __typename?: "Mutation";
    cancelPlaidAccount?: CancelPlaidAccount | null; 
  }

  export type CancelPlaidAccount = {
    __typename?: "core_apimessages_CancelPlaidAccountResponse";
    shopId?: string | null; 
  }
}
export namespace StartCheckoutForListing {
  export type Variables = {
    input?: Input_core_apimessages_StartCheckoutForListingRequest | null;
  }

  export type Mutation = {
    __typename?: "Mutation";
    startCheckoutForListing?: StartCheckoutForListing | null; 
  }

  export type StartCheckoutForListing = {
    __typename?: "core_apimessages_StartCheckoutForListingResponse";
    redirectUrl?: string | null; 
  }
}
export namespace CorePacklinkCreateDraft {
  export type Variables = {
    input?: Input_core_apimessages_CreatePacklinkDraftRequest | null;
  }

  export type Mutation = {
    __typename?: "Mutation";
    createPacklinkDraft?: CreatePacklinkDraft | null; 
  }

  export type CreatePacklinkDraft = {
    __typename?: "core_apimessages_CreatePacklinkDraftResponse";
    shipment?: Shipment | null; 
  }

  export type Shipment = {
    __typename?: "core_apimessages_PacklinkShipment";
    id?: string | null; 
  }
}
export namespace CoreShopSettingsCreateTaxIdentification {
  export type Variables = {
    input?: Input_core_apimessages_CreateTaxIdentificationRequest | null;
  }

  export type Mutation = {
    __typename?: "Mutation";
    createTaxIdentification?: CreateTaxIdentification | null; 
  }

  export type CreateTaxIdentification = {
    __typename?: "core_apimessages_CreateTaxIdentificationResponse";
    shop?: Shop | null; 
  }

  export type Shop = {
    __typename?: "MyShop";
    _id?: string | null; 
    taxIdentifications?: (TaxIdentifications | null)[] | null; 
  }

  export type TaxIdentifications = {
    __typename?: "core_apimessages_TaxIdentification";
    id?: string | null; 
    taxId?: string | null; 
    taxType?: core_apimessages_TaxIdentification_TaxType | null; 
    status?: core_apimessages_TaxIdentification_Status | null; 
    countryCode?: string | null; 
  }
}
export namespace CorePacklinkShippingLabelButton {
  export type Variables = {
    orderId?: string | null;
    authOnly: boolean;
  }

  export type Query = {
    __typename?: "Query";
    order?: Order | null; 
    me?: Me | null; 
  }

  export type Order = {
    __typename?: "Order";
    _id?: string | null; 
  } & OrderPacklinkShipmentData.Fragment

  export type Me =MyShopPacklinkAccountData.Fragment
}
export namespace CoreCheckoutFinalizeDirectCheckoutPayment {
  export type Variables = {
    input?: Input_core_apimessages_CheckoutFinalizeDirectCheckoutPaymentRequest | null;
  }

  export type Mutation = {
    __typename?: "Mutation";
    finalizeDirectCheckoutPayment?: FinalizeDirectCheckoutPayment | null; 
  }

  export type FinalizeDirectCheckoutPayment = {
    __typename?: "core_apimessages_CheckoutFinalizeDirectCheckoutPaymentResponse";
    checkout?: Checkout | null; 
  }

  export type Checkout = {
    __typename?: "Checkout";
    _id?: string | null; 
    id?: string | null; 
  }
}
export namespace CoreListingsSearchShippingPrompt {
  export type Variables = {
    ids?: (string | null)[] | null;
    shippingRegionCodes?: (string | null)[] | null;
    statuses?: (string | null)[] | null;
  }

  export type Query = {
    __typename?: "Query";
    listingsSearch?: ListingsSearch | null; 
  }

  export type ListingsSearch = {
    __typename?: "reverb_search_SearchResponse";
    listings?: (Listings | null)[] | null; 
  }

  export type Listings = {
    __typename?: "Listing";
    _id?: string | null; 
    id?: string | null; 
    title?: string | null; 
    slug?: string | null; 
    state?: string | null; 
    price?: Price | null; 
    images?: (Images | null)[] | null; 
  }

  export type Price = {
    __typename?: "core_apimessages_Money";
    amountCents?: number | null; 
    display?: string | null; 
  }

  export type Images = {
    __typename?: "core_apimessages_Image";
    source?: string | null; 
  }
}
export namespace CoreCreditCardWalletCreateFormLayout {
  export type Variables = {
  }

  export type Query = {
    __typename?: "Query";
    countries?: Countries | null; 
    me?: Me | null; 
  }

  export type Countries = {
    __typename?: "core_apimessages_CountriesResponse";
    countries?: (_Countries | null)[] | null; 
  }

  export type _Countries = {
    __typename?: "core_apimessages_Country";
    countryCode?: string | null; 
    name?: string | null; 
    subregionRequired?: boolean | null; 
    subregions?: (Subregions | null)[] | null; 
  }

  export type Subregions = {
    __typename?: "core_apimessages_Subregion";
    code?: string | null; 
    name?: string | null; 
  }

  export type Me = {
    __typename?: "rql_Me";
    uuid?: string | null; 
    shippingAddresses?: (ShippingAddresses | null)[] | null; 
  } & CreditCardWalletCreateFormFields.Fragment

  export type ShippingAddresses = {
    __typename?: "core_apimessages_Address";
    primary?: boolean | null; 
  }
}
export namespace CoreCheckoutRedirectReturnLayout {
  export type Variables = {
    id?: string | null;
    reverbApp?: string | null;
  }

  export type Query = {
    __typename?: "Query";
    checkout?: Checkout | null; 
  }

  export type Checkout = {
    __typename?: "Checkout";
    _id?: string | null; 
    action?: Action | null; 
  } & RedirectReturnCheckoutFields.Fragment & CheckoutTrackingFields.Fragment

  export type Action = {
    __typename?: "CheckoutAction";
    _id?: string | null; 
  } & CheckoutActionHookFields.Fragment
}
export namespace CoreCheckoutFinalizeRedirectPaymentCheckout {
  export type Variables = {
    input?: Input_core_apimessages_CheckoutFinalizeRedirectPaymentCheckoutRequest | null;
  }

  export type Mutation = {
    __typename?: "Mutation";
    finalizeCheckout?: FinalizeCheckout | null; 
  }

  export type FinalizeCheckout = {
    __typename?: "core_apimessages_CheckoutFinalizeRedirectPaymentCheckoutResponse";
    checkout?: Checkout | null; 
  }

  export type Checkout = {
    __typename?: "Checkout";
    _id?: string | null; 
  }
}
export namespace CoreCreditCardWalletUpdateMyCreditCard {
  export type Variables = {
    input?: Input_core_apimessages_UpdateMyCreditCardRequest | null;
  }

  export type Mutation = {
    __typename?: "Mutation";
    updateMyCreditCard?: UpdateMyCreditCard | null; 
  }

  export type UpdateMyCreditCard = {
    __typename?: "core_apimessages_UpdateMyCreditCardResponse";
    creditCard?: CreditCard | null; 
  }

  export type CreditCard = {
    __typename?: "core_apimessages_CreditCard";
    id?: string | null; 
    cardholderName?: string | null; 
    primaryForCheckout?: boolean | null; 
    display?: Display | null; 
    address?: Address | null; 
  }

  export type Display = {
    __typename?: "core_apimessages_CreditCard_Display";
    summary?: string | null; 
    expirationDate?: string | null; 
  }

  export type Address = {
    __typename?: "core_apimessages_Address";
    name?: string | null; 
    streetAddress?: string | null; 
    extendedAddress?: string | null; 
    locality?: string | null; 
    region?: string | null; 
    regionName?: string | null; 
    postalCode?: string | null; 
    phone?: string | null; 
    countryCode?: string | null; 
    country?: Country | null; 
  }

  export type Country = {
    __typename?: "core_apimessages_Country";
    countryCode?: string | null; 
  }
}
export namespace CorePacklinkRegisterAccount {
  export type Variables = {
    input?: Input_core_apimessages_RegisterMyPacklinkAccountRequest | null;
  }

  export type Mutation = {
    __typename?: "Mutation";
    registerMyPacklinkAccount?: RegisterMyPacklinkAccount | null; 
  }

  export type RegisterMyPacklinkAccount = {
    __typename?: "core_apimessages_RegisterMyPacklinkAccountResponse";
    shopId?: string | null; 
  }
}
export namespace CorePriceGuideSearchGrid {
  export type Variables = {
    q?: string | null;
    categorySlugs?: (string | null)[] | null;
    categoryUuids?: (string | null)[] | null;
    brandNames?: (string | null)[] | null;
    offset?: number | null;
    decades?: (string | null)[] | null;
    aggs?: (reverb_search_PriceGuidesSearchRequest_Aggregation | null)[] | null;
  }

  export type Query = {
    __typename?: "Query";
    priceGuidesSearch?: PriceGuidesSearch | null; 
  }

  export type PriceGuidesSearch = {
    __typename?: "reverb_search_SearchResponse";
    total?: number | null; 
    offset?: number | null; 
    limit?: number | null; 
    filters?: (Filters | null)[] | null; 
    priceGuides?: (PriceGuides | null)[] | null; 
  }

  export type Filters =FlatFilter.Fragment

  export type PriceGuides = {
    __typename?: "PriceGuide";
    _id?: string | null; 
    id?: string | null; 
    title?: string | null; 
    priceLow?: PriceLow | null; 
    priceHigh?: PriceHigh | null; 
    webLink?: WebLink | null; 
    images?: (Images | null)[] | null; 
  }

  export type PriceLow = {
    __typename?: "core_apimessages_Money";
    display?: string | null; 
  }

  export type PriceHigh = {
    __typename?: "core_apimessages_Money";
    display?: string | null; 
  }

  export type WebLink = {
    __typename?: "core_apimessages_Link";
    href?: string | null; 
  }

  export type Images = {
    __typename?: "core_apimessages_Image";
    source?: string | null; 
  }
}
export namespace CoreCheckoutSelectCreditCard {
  export type Variables = {
    input?: Input_core_apimessages_SelectCheckoutCreditCardRequest | null;
  }

  export type Mutation = {
    __typename?: "Mutation";
    selectCheckoutCreditCard?: SelectCheckoutCreditCard | null; 
  }

  export type SelectCheckoutCreditCard = {
    __typename?: "core_apimessages_SelectCheckoutCreditCardResponse";
    checkout?: Checkout | null; 
  }

  export type Checkout = {
    __typename?: "Checkout";
    _id?: string | null; 
  }
}
export namespace StartDigitalWalletCheckoutForListing {
  export type Variables = {
    input?: Input_core_apimessages_StartCheckoutForListingRequest | null;
  }

  export type Mutation = {
    __typename?: "Mutation";
    startCheckoutForListing?: StartCheckoutForListing | null; 
  }

  export type StartCheckoutForListing = {
    __typename?: "core_apimessages_StartCheckoutForListingResponse";
    checkoutId?: string | null; 
  }
}
export namespace UpdateShippingEstimateMutation {
  export type Variables = {
    input?: Input_core_apimessages_CheckoutUpdateShippingEstimateRequest | null;
  }

  export type Mutation = {
    __typename?: "Mutation";
    updateCheckoutShippingEstimate?: UpdateCheckoutShippingEstimate | null; 
  }

  export type UpdateCheckoutShippingEstimate = {
    __typename?: "core_apimessages_CheckoutUpdateShippingEstimateResponse";
    checkout?: Checkout | null; 
  }

  export type Checkout = {
    __typename?: "Checkout";
    _id?: string | null; 
    lineItems?: (LineItems | null)[] | null; 
  }

  export type LineItems = {
    __typename?: "core_apimessages_CheckoutLineItem";
    type?: core_apimessages_CheckoutLineItem_Type | null; 
    label?: string | null; 
    amount?: Amount | null; 
  }

  export type Amount = {
    __typename?: "core_apimessages_Money";
    amount?: string | null; 
    amountCents?: number | null; 
    currency?: string | null; 
    symbol?: string | null; 
    display?: string | null; 
  }
}
export namespace FinalizeDigitalWalletPayment {
  export type Variables = {
    input?: Input_core_apimessages_CheckoutFinalizeDigitalWalletPaymentRequest | null;
  }

  export type Mutation = {
    __typename?: "Mutation";
    finalizeDigitalWalletPayment?: FinalizeDigitalWalletPayment | null; 
  }

  export type FinalizeDigitalWalletPayment = {
    __typename?: "core_apimessages_CheckoutFinalizeDigitalWalletPaymentResponse";
    id?: string | null; 
  }
}
export namespace CoreCspReviews {
  export type Variables = {
    limit?: number | null;
    slug?: string | null;
    offset?: number | null;
  }

  export type Query = {
    __typename?: "Query";
    csp?: Csp | null; 
  }

  export type Csp = {
    __typename?: "CSP";
    _id?: string | null; 
    reviews?: Reviews | null; 
  } & CSPReviewCSP.Fragment

  export type Reviews =CSPReviews.Fragment
}
export namespace VoteProductReview {
  export type Variables = {
    input?: Input_core_apimessages_ProductReviewVoteRequest | null;
  }

  export type Mutation = {
    __typename?: "Mutation";
    voteProductReview?: VoteProductReview | null; 
  }

  export type VoteProductReview = {
    __typename?: "core_apimessages_ProductReviewVoteResponse";
    _?: boolean | null; 
  }
}
export namespace CartSignals {
  export type Variables = {
    id?: string | null;
    skipLoadingSignals: boolean;
  }

  export type Query = {
    __typename?: "Query";
    listing?: Listing | null; 
  }

  export type Listing = {
    __typename?: "Listing";
    _id?: string | null; 
    id?: string | null; 
    signals?: (Signals | null)[] | null; 
  }

  export type Signals = {
    __typename?: "reverb_signals_Signal";
    name?: reverb_signals_Signal_Name | null; 
    title?: string | null; 
    icon?: string | null; 
  }
}
export namespace CorePacklinkLoginAccount {
  export type Variables = {
    input?: Input_core_apimessages_LoginMyPacklinkAccountRequest | null;
  }

  export type Mutation = {
    __typename?: "Mutation";
    loginMyPacklinkAccount?: LoginMyPacklinkAccount | null; 
  }

  export type LoginMyPacklinkAccount = {
    __typename?: "core_apimessages_LoginMyPacklinkAccountResponse";
    shopId?: string | null; 
  }
}
export namespace CoreListingEuOdrAddress {
  export type Variables = {
    slug?: string | null;
  }

  export type Query = {
    __typename?: "Query";
    shop?: Shop | null; 
  }

  export type Shop = {
    __typename?: "Shop";
    _id?: string | null; 
  } & EUODRAddress.Fragment
}
export namespace CspFeaturedListing {
  export type Variables = {
    id?: string | null;
  }

  export type Query = {
    __typename?: "Query";
    listing?: Listing | null; 
  }

  export type Listing = {
    __typename?: "Listing";
    _id?: string | null; 
    id?: string | null; 
  } & FeaturedListingWithPrice.Fragment & WatchBadgeData.Fragment & Item2ProductViewTrackingData.Fragment
}
export namespace CoreAutoOfferModal {
  export type Variables = {
    listingId?: string | null;
  }

  export type Query = {
    __typename?: "Query";
    listing?: Listing | null; 
  }

  export type Listing = {
    __typename?: "Listing";
    _id?: string | null; 
  } & ModalSidebarListingFragment.Fragment & AutoOfferListingFragment.Fragment
}
export namespace CoreShopSettingsVatLayout {
  export type Variables = {
  }

  export type Query = {
    __typename?: "Query";
    me?: Me | null; 
    countries?: Countries | null; 
  }

  export type Me = {
    __typename?: "rql_Me";
    uuid?: string | null; 
    shop?: Shop | null; 
  }

  export type Shop = {
    __typename?: "MyShop";
    _id?: string | null; 
    taxIdentifications?: (TaxIdentifications | null)[] | null; 
  }

  export type TaxIdentifications = {
    __typename?: "core_apimessages_TaxIdentification";
    id?: string | null; 
    taxId?: string | null; 
    taxType?: core_apimessages_TaxIdentification_TaxType | null; 
    status?: core_apimessages_TaxIdentification_Status | null; 
    countryCode?: string | null; 
  }

  export type Countries = {
    __typename?: "core_apimessages_CountriesResponse";
    countries?: (_Countries | null)[] | null; 
  }

  export type _Countries = {
    __typename?: "core_apimessages_Country";
    countryCode?: string | null; 
    name?: string | null; 
  }
}
export namespace SubmitCheckoutVerifyShopper {
  export type Variables = {
    input?: Input_core_apimessages_CheckoutVerifyShopperRequest | null;
  }

  export type Mutation = {
    __typename?: "Mutation";
    checkoutVerifyShopper?: CheckoutVerifyShopper | null; 
  }

  export type CheckoutVerifyShopper = {
    __typename?: "core_apimessages_CheckoutVerifyShopperResponse";
    adyenPaymentResult?: AdyenPaymentResult | null; 
    paymentResultUrl?: string | null; 
  }

  export type AdyenPaymentResult = {
    __typename?: "core_apimessages_AdyenPaymentResult";
    action?: string | null; 
  }
}
export namespace SubmitGuestCheckoutVerifyShopper {
  export type Variables = {
    input?: Input_core_apimessages_GuestCheckoutVerifyShopperRequest | null;
  }

  export type Mutation = {
    __typename?: "Mutation";
    guestCheckoutVerifyShopper?: GuestCheckoutVerifyShopper | null; 
  }

  export type GuestCheckoutVerifyShopper = {
    __typename?: "core_apimessages_CheckoutVerifyShopperResponse";
    adyenPaymentResult?: AdyenPaymentResult | null; 
    paymentResultUrl?: string | null; 
  }

  export type AdyenPaymentResult = {
    __typename?: "core_apimessages_AdyenPaymentResult";
    action?: string | null; 
  }
}
export namespace CoreGiftCardCreditCards {
  export type Variables = {
  }

  export type Query = {
    __typename?: "Query";
    me?: Me | null; 
  }

  export type Me = {
    __typename?: "rql_Me";
    uuid?: string | null; 
    creditCards?: (CreditCards | null)[] | null; 
  }

  export type CreditCards = {
    __typename?: "core_apimessages_CreditCard";
    id?: string | null; 
    last4?: string | null; 
    cardType?: string | null; 
    expirationMonth?: string | null; 
    expirationYear?: string | null; 
  }
}
export namespace CorePacklinkAccountStatus {
  export type Variables = {
  }

  export type Query = {
    __typename?: "Query";
    me?: Me | null; 
  }

  export type Me = {
    __typename?: "rql_Me";
    uuid?: string | null; 
    shop?: Shop | null; 
  }

  export type Shop = {
    __typename?: "MyShop";
    _id?: string | null; 
    packlink?: Packlink | null; 
  }

  export type Packlink = {
    __typename?: "core_apimessages_MyPacklinkAccountStatusResponse";
    account?: Account | null; 
  }

  export type Account = {
    __typename?: "core_apimessages_PacklinkAccount";
    email?: string | null; 
    status?: core_apimessages_PacklinkAccount_Status | null; 
  }
}
export namespace CoreShopSettingsUpdateTaxIdentification {
  export type Variables = {
    input?: Input_core_apimessages_UpdateTaxIdentificationRequest | null;
  }

  export type Mutation = {
    __typename?: "Mutation";
    updateTaxIdentification?: UpdateTaxIdentification | null; 
  }

  export type UpdateTaxIdentification = {
    __typename?: "core_apimessages_UpdateTaxIdentificationResponse";
    shop?: Shop | null; 
  }

  export type Shop = {
    __typename?: "MyShop";
    _id?: string | null; 
    taxIdentifications?: (TaxIdentifications | null)[] | null; 
  }

  export type TaxIdentifications = {
    __typename?: "core_apimessages_TaxIdentification";
    id?: string | null; 
    taxId?: string | null; 
    status?: core_apimessages_TaxIdentification_Status | null; 
    countryCode?: string | null; 
  }
}
export namespace CoreShopSettingsDeactivateTaxIdentification {
  export type Variables = {
    input?: Input_core_apimessages_DeactivateTaxIdentificationRequest | null;
  }

  export type Mutation = {
    __typename?: "Mutation";
    deactivateTaxIdentification?: DeactivateTaxIdentification | null; 
  }

  export type DeactivateTaxIdentification = {
    __typename?: "core_apimessages_DeactivateTaxIdentificationResponse";
    shop?: Shop | null; 
  }

  export type Shop = {
    __typename?: "MyShop";
    _id?: string | null; 
    taxIdentifications?: (TaxIdentifications | null)[] | null; 
  }

  export type TaxIdentifications = {
    __typename?: "core_apimessages_TaxIdentification";
    id?: string | null; 
    taxId?: string | null; 
    status?: core_apimessages_TaxIdentification_Status | null; 
    countryCode?: string | null; 
    active?: boolean | null; 
  }
}
export namespace CoreProductFamilyPageLayout {
  export type Variables = {
    query?: string | null;
    traitSlugs?: (string | null)[] | null;
    listingsRowLimit?: number | null;
    listingsRowCuratedSetSlugs?: (string | null)[] | null;
    listingsGridLimit?: number | null;
    listingsGridOffset?: number | null;
    currency?: string | null;
    priceMax?: string | null;
    priceMin?: string | null;
    yearMax?: string | null;
    yearMin?: string | null;
    sortSlug?: string | null;
    categorySlugs?: (string | null)[] | null;
    brandSlugs?: (string | null)[] | null;
    aggs?: (reverb_search_ListingsSearchRequest_Aggregation | null)[] | null;
    conditionSlugs?: (string | null)[] | null;
    onSale?: boolean | null;
    handmade?: boolean | null;
    freeShipping?: boolean | null;
    freeExpeditedShipping?: boolean | null;
    acceptsOffers?: boolean | null;
    acceptsGiftCards?: boolean | null;
    preferredSeller?: boolean | null;
    acceptsPaymentPlans?: boolean | null;
    itemRegion?: string | null;
    shippingRegionCodes?: (string | null)[] | null;
    decades?: (string | null)[] | null;
    cspSort?: reverb_search_CSPSearchRequest_Sort | null;
    localPickup?: boolean | null;
    combinedShipping?: boolean | null;
    acceptsAffirm?: boolean | null;
    showOnlySold?: boolean | null;
    withProximityFilter?: Input_reverb_search_ProximityFilterRequest | null;
    traitValues?: (string | null)[] | null;
    dealsOrWellPriced?: boolean | null;
    slug?: string | null;
    shouldUseListingsGrid: boolean;
  }

  export type Query = {
    __typename?: "Query";
    cspSearch?: CspSearch | null; 
    listingsRowSearch?: ListingsRowSearch | null; 
    listingsGridSearch?: ListingsGridSearch | null; 
    cmsPage?: (CmsPage | null)[] | null; 
  }

  export type CspSearch = {
    __typename?: "reverb_search_SearchResponse";
    csps?: (Csps | null)[] | null; 
  }

  export type Csps = {
    __typename?: "CSP";
    _id?: string | null; 
  } & CSPCard.Fragment & ProductFamilyHeaderFields.Fragment

  export type ListingsRowSearch = {
    __typename?: "reverb_search_SearchResponse";
    listings?: (Listings | null)[] | null; 
  }

  export type Listings = {
    __typename?: "Listing";
    _id?: string | null; 
  } & ListingCardFields.Fragment

  export type ListingsGridSearch = {
    __typename?: "reverb_search_SearchResponse";
    total?: number | null; 
    offset?: number | null; 
    limit?: number | null; 
    filters?: (Filters | null)[] | null; 
    listings?: (_Listings | null)[] | null; 
  }

  export type Filters =NestedFilter.Fragment

  export type _Listings = {
    __typename?: "Listing";
    _id?: string | null; 
  } & ListingCardFields.Fragment

  export type CmsPage = {
    __typename?: "CMSPage";
    _id?: string | null; 
    title?: string | null; 
    metaTitle?: string | null; 
    metaDescription?: string | null; 
  }
}
export namespace CoreRecommendedPriceRange {
  export type Variables = {
    priceRecommendationQueries?: (Input_reverb_pricing_PriceRecommendationQuery | null)[] | null;
    loggedOut: boolean;
  }

  export type Query = {
    __typename?: "Query";
    priceRecommendations?: PriceRecommendations | null; 
    me?: Me | null; 
    exchangeRates?: ExchangeRates | null; 
  }

  export type PriceRecommendations = {
    __typename?: "reverb_pricing_PriceRecommendationsResponse";
    priceRecommendations?: (_PriceRecommendations | null)[] | null; 
  }

  export type _PriceRecommendations = {
    __typename?: "reverb_pricing_PriceRecommendation";
    canonicalProductId?: string | null; 
    conditionUuid?: string | null; 
    priceLow?: PriceLow | null; 
    priceHigh?: PriceHigh | null; 
  }

  export type PriceLow = {
    __typename?: "reverb_pricing_Money";
    amountCents?: number | null; 
    amount?: string | null; 
    currency?: string | null; 
  }

  export type PriceHigh = {
    __typename?: "reverb_pricing_Money";
    amountCents?: number | null; 
    amount?: string | null; 
    currency?: string | null; 
  }

  export type Me = {
    __typename?: "rql_Me";
    uuid?: string | null; 
    shop?: Shop | null; 
  }

  export type Shop = {
    __typename?: "MyShop";
    _id?: string | null; 
    currency?: string | null; 
  }

  export type ExchangeRates = {
    __typename?: "reverb_config_cache_CurrencyResponse";
    rates?: (Rates | null)[] | null; 
  }

  export type Rates = {
    __typename?: "reverb_config_cache_ExchangeRate";
    from?: string | null; 
    to?: string | null; 
    rate?: number | null; 
  }
}
export namespace CoreCreditCardWalletEditFormLayout {
  export type Variables = {
  }

  export type Query = {
    __typename?: "Query";
    countries?: Countries | null; 
    me?: Me | null; 
  }

  export type Countries = {
    __typename?: "core_apimessages_CountriesResponse";
    countries?: (_Countries | null)[] | null; 
  }

  export type _Countries = {
    __typename?: "core_apimessages_Country";
    countryCode?: string | null; 
    name?: string | null; 
    subregionRequired?: boolean | null; 
    subregions?: (Subregions | null)[] | null; 
  }

  export type Subregions = {
    __typename?: "core_apimessages_Subregion";
    code?: string | null; 
    name?: string | null; 
  }

  export type Me = {
    __typename?: "rql_Me";
    uuid?: string | null; 
  } & CreditCardEditFormFields.Fragment
}
export namespace MyShopOrderRefundStats {
  export type Variables = {
    input?: Input_core_apimessages_MyShopOrderRefundStatsRequest | null;
  }

  export type Query = {
    __typename?: "Query";
    me?: Me | null; 
  }

  export type Me = {
    __typename?: "rql_Me";
    uuid?: string | null; 
    shop?: Shop | null; 
  }

  export type Shop = {
    __typename?: "MyShop";
    _id?: string | null; 
    uuid?: string | null; 
    orderRefundStats?: OrderRefundStats | null; 
  }

  export type OrderRefundStats = {
    __typename?: "core_apimessages_MyShopOrderRefundStatsResponse";
    sellerInitiatedRefundCount?: number | null; 
  }
}
export namespace CoreCreateExpressSaleCheckout {
  export type Variables = {
    input?: Input_core_apimessages_CreateExpressSaleCheckoutRequest | null;
  }

  export type Mutation = {
    __typename?: "Mutation";
    createExpressSaleCheckout?: CreateExpressSaleCheckout | null; 
  }

  export type CreateExpressSaleCheckout = {
    __typename?: "core_apimessages_CreateExpressSaleCheckoutResponse";
    checkoutId?: string | null; 
  }
}
export namespace CoreCompleteExpressSaleCheckout {
  export type Variables = {
    input?: Input_core_apimessages_CompleteExpressSaleCheckoutRequest | null;
  }

  export type Mutation = {
    __typename?: "Mutation";
    completeExpressSaleCheckout?: CompleteExpressSaleCheckout | null; 
  }

  export type CompleteExpressSaleCheckout = {
    __typename?: "core_apimessages_CompleteExpressSaleCheckoutResponse";
    orderId?: string | null; 
  }
}
export namespace CoreExpressSaleCheckoutShow {
  export type Variables = {
    checkoutId?: string | null;
  }

  export type Query = {
    __typename?: "Query";
    expresssalecheckout?: Expresssalecheckout | null; 
    me?: Me | null; 
  }

  export type Expresssalecheckout = {
    __typename?: "ExpressSaleCheckout";
    _id?: string | null; 
    status?: core_apimessages_ExpressSaleCheckout_Status | null; 
    csp?: Csp | null; 
    expressSaleItemBid?: ExpressSaleItemBid | null; 
  }

  export type Csp = {
    __typename?: "CSP";
    _id?: string | null; 
    id?: string | null; 
    title?: string | null; 
    brand?: Brand | null; 
    finishes?: (string | null)[] | null; 
    image?: Image | null; 
    specs?: Specs | null; 
  }

  export type Brand = {
    __typename?: "Brand";
    _id?: string | null; 
    name?: string | null; 
  }

  export type Image = {
    __typename?: "core_apimessages_Image";
    source?: string | null; 
  }

  export type Specs = {
    __typename?: "core_apimessages_CSPSpec";
    productSpecs?: (ProductSpecs | null)[] | null; 
  }

  export type ProductSpecs = {
    __typename?: "core_apimessages_ProductSpec";
    type?: core_apimessages_ProductSpec_Type | null; 
    name?: string | null; 
    value?: string | null; 
  }

  export type ExpressSaleItemBid = {
    __typename?: "core_apimessages_CSPExpressSaleItemBid";
    bidId?: string | null; 
    carrier?: string | null; 
    shopName?: string | null; 
    estimatedPayout?: EstimatedPayout | null; 
  }

  export type EstimatedPayout = {
    __typename?: "core_apimessages_Money";
    display?: string | null; 
    amount?: string | null; 
    amountCents?: number | null; 
  }

  export type Me = {
    __typename?: "rql_Me";
    uuid?: string | null; 
    shippingAddresses?: (ShippingAddresses | null)[] | null; 
  }

  export type ShippingAddresses = {
    __typename?: "core_apimessages_Address";
    uuid?: string | null; 
    name?: string | null; 
    streetAddress?: string | null; 
    extendedAddress?: string | null; 
    locality?: string | null; 
    region?: string | null; 
    postalCode?: string | null; 
    countryCode?: string | null; 
    phone?: string | null; 
    primary?: boolean | null; 
    legacyId?: string | null; 
  }
}
export namespace CorePromotionalCodeVerify {
  export type Variables = {
    token?: string | null;
  }

  export type Query = {
    __typename?: "Query";
    promotionalCodeVerify?: PromotionalCodeVerify | null; 
  }

  export type PromotionalCodeVerify = {
    __typename?: "core_apimessages_VerifyPromotionalCodeResponse";
    success?: boolean | null; 
    message?: string | null; 
  }
}
export namespace CoreSellFlowSearch {
  export type Variables = {
    q?: string | null;
    decades?: (string | null)[] | null;
    finishes?: (string | null)[] | null;
    brandNames?: (string | null)[] | null;
    category_uuids?: (string | null)[] | null;
    sellCardLimit?: number | null;
    excludedCategoryUuids?: (string | null)[] | null;
    boostByClicks?: boolean | null;
    fullTextQueryOperand?: reverb_search_FullTextQueryOperand | null;
    sort?: reverb_search_CSPSearchRequest_Sort | null;
    fuzzy?: boolean | null;
    offset?: number | null;
    listingsThatShipTo?: string | null;
    hasExpressSaleBid: boolean;
  }

  export type Query = {
    __typename?: "Query";
    cspSearch?: CspSearch | null; 
  }

  export type CspSearch = {
    __typename?: "reverb_search_SearchResponse";
    filters?: (Filters | null)[] | null; 
    csps?: (Csps | null)[] | null; 
    total?: number | null; 
    offset?: number | null; 
    limit?: number | null; 
  }

  export type Filters =FlatFilter.Fragment

  export type Csps = {
    __typename?: "CSP";
    _id?: string | null; 
  } & SellCardData.Fragment & ExpressSaleItemBidData.Fragment
}
export namespace CoreSellFormMyShippingProfiles {
  export type Variables = {
    shopId: string;
  }

  export type Query = {
    __typename?: "Query";
    shop?: Shop | null; 
  }

  export type Shop = {
    __typename?: "Shop";
    _id?: string | null; 
  } & ShippingProfilePrices.Fragment
}
export namespace CoreSellFormNewListingLayout {
  export type Variables = {
    shouldSeedListingData: boolean;
    seedId?: string | null;
    seedType?: core_apimessages_Listing_SeedType | null;
  }

  export type Query = {
    __typename?: "Query";
    me?: Me | null; 
    seedListingData?: SeedListingData | null; 
    countries?: Countries | null; 
  }

  export type Me = {
    __typename?: "rql_Me";
    shop?: Shop | null; 
  } & SellFormSetupData.Fragment

  export type Shop = {
    __typename?: "MyShop";
    _id?: string | null; 
    defaultLocale?: string | null; 
  }

  export type SeedListingData = {
    __typename?: "rql_SeedableListingFields";
    make?: string | null; 
    model?: string | null; 
    brandSlug?: string | null; 
    categoryRootUuid?: string | null; 
    canonicalProductId?: string | null; 
    comparisonShoppingPageId?: string | null; 
    finish?: string | null; 
    year?: string | null; 
    countryOfOrigin?: string | null; 
    categories?: (Categories | null)[] | null; 
    sellerCost?: SellerCost | null; 
  }

  export type Categories = {
    __typename?: "core_apimessages_NodesCategory";
    id?: string | null; 
    name?: string | null; 
    root?: boolean | null; 
    leaf?: boolean | null; 
  }

  export type SellerCost = {
    __typename?: "core_apimessages_Money";
    amount?: string | null; 
    amountCents?: number | null; 
    currency?: string | null; 
    display?: string | null; 
  }

  export type Countries =SellFormViewCountryFields.Fragment
}
export namespace CoreSellFormCspSeedData {
  export type Variables = {
    cspId?: string | null;
  }

  export type Query = {
    __typename?: "Query";
    csp?: Csp | null; 
  }

  export type Csp = {
    __typename?: "CSP";
    _id?: string | null; 
  } & SellFormCanonicalProductCardData.Fragment
}
export namespace CoreSellFormEditListingLayout {
  export type Variables = {
    listingId: string;
  }

  export type Query = {
    __typename?: "Query";
    me?: Me | null; 
    listing?: Listing | null; 
    countries?: Countries | null; 
  }

  export type Me =SellFormSetupData.Fragment

  export type Listing = {
    __typename?: "Listing";
    _id?: string | null; 
  } & HydrateSellForm.Fragment

  export type Countries =SellFormViewCountryFields.Fragment
}
export namespace CoreListingUpdate {
  export type Variables = {
    input?: Input_core_apimessages_UpdateListingRequest | null;
  }

  export type Mutation = {
    __typename?: "Mutation";
    crupdateListing?: CrupdateListing | null; 
  }

  export type CrupdateListing = {
    __typename?: "Listing";
    _id?: string | null; 
  } & HydrateSellForm.Fragment
}
export namespace CoreSellFormSubmitShopData {
  export type Variables = {
    input?: Input_core_apimessages_UpdateMyShopRequest | null;
  }

  export type Mutation = {
    __typename?: "Mutation";
    updateMyShop?: UpdateMyShop | null; 
  }

  export type UpdateMyShop = {
    __typename?: "core_apimessages_UpdateMyShopResponse";
    shop?: Shop | null; 
  }

  export type Shop = {
    __typename?: "core_apimessages_Shop";
    id?: string | null; 
  }
}
export namespace CoreSellFormSetupPage {
  export type Variables = {
  }

  export type Query = {
    __typename?: "Query";
    me?: Me | null; 
    countries?: Countries | null; 
  }

  export type Me = {
    __typename?: "rql_Me";
    shippingAddresses?: (ShippingAddresses | null)[] | null; 
  } & SellFormSetupData.Fragment

  export type ShippingAddresses =ShopAddressFields.Fragment

  export type Countries = {
    __typename?: "core_apimessages_CountriesResponse";
    countries?: (_Countries | null)[] | null; 
  }

  export type _Countries = {
    __typename?: "core_apimessages_Country";
    name?: string | null; 
    countryCode?: string | null; 
    subregionRequired?: boolean | null; 
    subregions?: (Subregions | null)[] | null; 
  }

  export type Subregions = {
    __typename?: "core_apimessages_Subregion";
    code?: string | null; 
    name?: string | null; 
  }
}
export namespace CoreSellFlowCsp {
  export type Variables = {
    id?: string | null;
  }

  export type Query = {
    __typename?: "Query";
    csp?: Csp | null; 
  }

  export type Csp = {
    __typename?: "CSP";
    _id?: string | null; 
    title?: string | null; 
    image?: Image | null; 
  }

  export type Image = {
    __typename?: "core_apimessages_Image";
    source?: string | null; 
  }
}
export namespace CoreOrderSearchAddPastPurchasesToGearCollection {
  export type Variables = {
    actionableStatuses?: (string | null)[] | null;
    listingCategoryUuids?: (string | null)[] | null;
    createdAfterDate?: string | null;
    minAmountProductCentsUsd?: string | null;
    limit?: number | null;
    withoutGearCollectionItemOnly?: boolean | null;
  }

  export type Query = {
    __typename?: "Query";
    ordersSearch?: OrdersSearch | null; 
  }

  export type OrdersSearch = {
    __typename?: "reverb_search_SearchResponse";
    orders?: (Orders | null)[] | null; 
  }

  export type Orders = {
    __typename?: "Order";
    _id?: string | null; 
  } & QuickAddOrderCardFields.Fragment
}
export namespace CoreCspVariantPickerCsp {
  export type Variables = {
    id?: string | null;
  }

  export type Query = {
    __typename?: "Query";
    csp?: Csp | null; 
  }

  export type Csp = {
    __typename?: "CSP";
    _id?: string | null; 
    variants?: (Variants | null)[] | null; 
  } & CSPSummaryCardData.Fragment

  export type Variants = {
    __typename?: "core_apimessages_CspVariant";
    id?: string | null; 
    name?: string | null; 
    model?: string | null; 
    year?: string | null; 
    finish?: string | null; 
  }
}
export namespace CoreCrupdateGearCollectionItem {
  export type Variables = {
    input?: Input_core_apimessages_UpdateGearCollectionItemRequest | null;
  }

  export type Mutation = {
    __typename?: "Mutation";
    crupdateGearCollectionItem?: CrupdateGearCollectionItem | null; 
  }

  export type CrupdateGearCollectionItem = {
    __typename?: "GearCollectionItem";
    _id?: string | null; 
  } & GearCollectionItemShowDisplay.Fragment
}
export namespace CoreDeleteGearCollectionItem {
  export type Variables = {
    input?: Input_core_apimessages_DeleteGearCollectionItemRequest | null;
  }

  export type Mutation = {
    __typename?: "Mutation";
    deleteGearCollectionItem?: DeleteGearCollectionItem | null; 
  }

  export type DeleteGearCollectionItem = {
    __typename?: "GearCollectionItem";
    _id?: string | null; 
  } & GearCollectionItemShowDisplay.Fragment
}
export namespace CoreGearCollectionItemForm {
  export type Variables = {
    shouldSeedListingData: boolean;
    shouldFetchCsp: boolean;
    seedId?: string | null;
    seedType?: core_apimessages_Listing_SeedType | null;
    cspId?: string | null;
    shouldFetchOrder: boolean;
  }

  export type Query = {
    __typename?: "Query";
    seedListingData?: SeedListingData | null; 
    csp?: Csp | null; 
    order?: Order | null; 
  }

  export type SeedListingData = {
    __typename?: "rql_SeedableListingFields";
    make?: string | null; 
    model?: string | null; 
    brandSlug?: string | null; 
    categoryRootUuid?: string | null; 
    canonicalProductId?: string | null; 
    finish?: string | null; 
    year?: string | null; 
    categories?: (Categories | null)[] | null; 
  }

  export type Categories = {
    __typename?: "core_apimessages_NodesCategory";
    id?: string | null; 
    name?: string | null; 
    root?: boolean | null; 
    leaf?: boolean | null; 
  }

  export type Csp = {
    __typename?: "CSP";
    _id?: string | null; 
  } & CSPSummaryCardData.Fragment

  export type Order = {
    __typename?: "Order";
    _id?: string | null; 
    amountProduct?: AmountProduct | null; 
  }

  export type AmountProduct = {
    __typename?: "core_apimessages_Money";
    amount?: string | null; 
    currency?: string | null; 
  }
}
export namespace CoreGearCollectionItemShowLayout {
  export type Variables = {
    id?: string | null;
  }

  export type Query = {
    __typename?: "Query";
    gearcollectionitem?: Gearcollectionitem | null; 
    exchangeRates?: ExchangeRates | null; 
  }

  export type Gearcollectionitem = {
    __typename?: "GearCollectionItem";
    _id?: string | null; 
  } & GearCollectionItemShowDisplay.Fragment

  export type ExchangeRates = {
    __typename?: "reverb_config_cache_CurrencyResponse";
    rates?: (Rates | null)[] | null; 
  }

  export type Rates = {
    __typename?: "reverb_config_cache_ExchangeRate";
    from?: string | null; 
    to?: string | null; 
    rate?: number | null; 
  }
}
export namespace SearchGearCollectionItemIndex {
  export type Variables = {
    limit?: number | null;
    offset?: number | null;
    categoryUuids?: (string | null)[] | null;
    currency?: string | null;
    tags?: (string | null)[] | null;
  }

  export type Query = {
    __typename?: "Query";
    gearCollectionItemsSearch?: GearCollectionItemsSearch | null; 
    statsSearch?: StatsSearch | null; 
  }

  export type GearCollectionItemsSearch = {
    __typename?: "reverb_search_SearchResponse";
    total?: number | null; 
    offset?: number | null; 
    limit?: number | null; 
    filters?: (Filters | null)[] | null; 
    gearCollectionItems?: (GearCollectionItems | null)[] | null; 
  }

  export type Filters =FlatFilter.Fragment

  export type GearCollectionItems = {
    __typename?: "GearCollectionItem";
    _id?: string | null; 
  } & GearCollectionIndexCard.Fragment

  export type StatsSearch = {
    __typename?: "reverb_search_SearchResponse";
    total?: number | null; 
    gearCollectionStats?: GearCollectionStats | null; 
  }

  export type GearCollectionStats = {
    __typename?: "reverb_search_GearCollectionStats";
    totalCollectionEstimate?: TotalCollectionEstimate | null; 
  }

  export type TotalCollectionEstimate = {
    __typename?: "reverb_search_GearCollectionTotalEstimate";
    totalEstimateLow?: TotalEstimateLow | null; 
    totalEstimateHigh?: TotalEstimateHigh | null; 
  }

  export type TotalEstimateLow = {
    __typename?: "reverb_search_Money";
    amountCents?: number | null; 
    currency?: string | null; 
  }

  export type TotalEstimateHigh = {
    __typename?: "reverb_search_Money";
    amountCents?: number | null; 
    currency?: string | null; 
  }
}
export namespace CoreListingRecommendedShopsRow {
  export type Variables = {
    itemRegion?: string | null;
    brandSlugs?: (string | null)[] | null;
    categorySlugs?: (string | null)[] | null;
  }

  export type Query = {
    __typename?: "Query";
    listingsAggregationSearch?: ListingsAggregationSearch | null; 
  }

  export type ListingsAggregationSearch = {
    __typename?: "reverb_search_ListingsAggregationResponse";
    shops?: (Shops | null)[] | null; 
  }

  export type Shops = {
    __typename?: "Shop";
    _id?: string | null; 
    id?: string | null; 
    slug?: string | null; 
    address?: Address | null; 
  } & ShopCardFields.Fragment

  export type Address = {
    __typename?: "core_apimessages_Address";
    countryCode?: string | null; 
  }
}
export namespace CoreCheckoutAuthorizationLayout {
  export type Variables = {
    id?: string | null;
    reverbApp?: string | null;
  }

  export type Query = {
    __typename?: "Query";
    checkout?: Checkout | null; 
  }

  export type Checkout = {
    __typename?: "Checkout";
    _id?: string | null; 
    id?: string | null; 
    checkoutBundlingId?: string | null; 
    adyenPaymentAction?: string | null; 
    action?: Action | null; 
  } & CheckoutTotalAmountFields.Fragment & CheckoutTrackingFields.Fragment

  export type Action = {
    __typename?: "CheckoutAction";
    _id?: string | null; 
  } & CheckoutActionHookFields.Fragment
}
export namespace CoreCspHeader {
  export type Variables = {
    soldListingId?: string | null;
  }

  export type Query = {
    __typename?: "Query";
    listing?: Listing | null; 
  }

  export type Listing = {
    __typename?: "Listing";
    _id?: string | null; 
    title?: string | null; 
    images?: (Images | null)[] | null; 
  }

  export type Images = {
    __typename?: "core_apimessages_Image";
    source?: string | null; 
  }
}
export namespace CoreWithSuggestionCheckListingsSearch {
  export type Variables = {
    query?: string | null;
  }

  export type Query = {
    __typename?: "Query";
    listingsSearch?: ListingsSearch | null; 
  }

  export type ListingsSearch = {
    __typename?: "reverb_search_SearchResponse";
    total?: number | null; 
  }
}
export namespace CoreListingLayout {
  export type Variables = {
    id?: string | null;
    loggedOut: boolean;
    shouldSkipTracking: boolean;
    itemRegion?: string | null;
    itemRegionRelation?: reverb_search_ListingItemRegionRelation | null;
  }

  export type Query = {
    __typename?: "Query";
    listing?: Listing | null; 
    me?: Me | null; 
  }

  export type Listing = {
    __typename?: "Listing";
    _id?: string | null; 
    id?: string | null; 
    similarListings?: (SimilarListings | null)[] | null; 
    csp?: Csp | null; 
    shop?: Shop | null; 
    pricing?: Pricing | null; 
    shipmentPackage?: ShipmentPackage | null; 
    experiments?: (Experiments | null)[] | null; 
  } & ShippingWarningData.Fragment & Item2PricingData.Fragment & Item2DescriptionData.Fragment & Item2ShopListingData.Fragment & Item2BuyingGuideData.Fragment & Item2TitleData.Fragment & Item2BreadcrumbsData.Fragment & Item2Image.Fragment & Item2Video.Fragment & Item2FlagListingData.Fragment & Item2AdminButtonsData.Fragment & Item2MetadataData.Fragment & Item2OrderDetailsData.Fragment & Item2ProductViewTrackingData.Fragment & Item2EndedListingData.Fragment & Item2PaidLandingData.Fragment & WatchBadgeData.Fragment & SignalsData.Fragment & Item2ShopReviewsData.Fragment & Item2ProductSpecsData.Fragment & ItemFooterFields.Fragment & Item2AdWithCspsRowContainerData.Fragment & Item2ShopModuleData.Fragment & Item2ShopOverviewData.Fragment & Item2ProductModuleData.Fragment

  export type SimilarListings = {
    __typename?: "Listing";
    _id?: string | null; 
  } & SimilarListingsFields.Fragment

  export type Csp = {
    __typename?: "CSP";
    _id?: string | null; 
    featuredListing?: FeaturedListing | null; 
    slug?: string | null; 
  } & CSPPgCard.Fragment

  export type FeaturedListing = {
    __typename?: "arbiter_FeaturedListingResponse";
    listing?: _Listing | null; 
  }

  export type _Listing = {
    __typename?: "Listing";
    _id?: string | null; 
    price?: Price | null; 
  }

  export type Price = {
    __typename?: "core_apimessages_Money";
    display?: string | null; 
  }

  export type Shop = {
    __typename?: "Shop";
    _id?: string | null; 
    name?: string | null; 
  }

  export type Pricing = {
    __typename?: "core_apimessages_ListingPricing";
    buyerPrice?: BuyerPrice | null; 
  }

  export type BuyerPrice = {
    __typename?: "core_apimessages_Money";
    amount?: string | null; 
    currency?: string | null; 
  }

  export type ShipmentPackage = {
    __typename?: "ShipmentPackage";
    _id?: string | null; 
    width?: Width | null; 
    height?: Height | null; 
    length?: Length | null; 
    weight?: Weight | null; 
  }

  export type Width = {
    __typename?: "core_apimessages_Measurement";
    value?: string | null; 
    unit?: string | null; 
  }

  export type Height = {
    __typename?: "core_apimessages_Measurement";
    value?: string | null; 
    unit?: string | null; 
  }

  export type Length = {
    __typename?: "core_apimessages_Measurement";
    value?: string | null; 
    unit?: string | null; 
  }

  export type Weight = {
    __typename?: "core_apimessages_Measurement";
    value?: string | null; 
    unit?: string | null; 
  }

  export type Experiments = {
    __typename?: "core_apimessages_NonUserExperiment";
    name?: string | null; 
    bucket?: string | null; 
  }

  export type Me = {
    __typename?: "rql_Me";
    myNegotiations?: MyNegotiations | null; 
  } & Item2PriceWithShippingCartItemData.Fragment & Item2LoggedInOffersCountData.Fragment & Item2FlagListingMeData.Fragment

  export type MyNegotiations = {
    __typename?: "reverb_search_SearchResponse";
    negotiations?: (Negotiations | null)[] | null; 
  }

  export type Negotiations = {
    __typename?: "Negotiation";
    _id?: string | null; 
  } & Item2PricingNegotiationsData.Fragment
}
export namespace CoreUserSubscriptions {
  export type Variables = {
  }

  export type Query = {
    __typename?: "Query";
    me?: Me | null; 
  }

  export type Me = {
    __typename?: "rql_Me";
    uuid?: string | null; 
    requireOptIn?: boolean | null; 
    emailSubscriptions?: (EmailSubscriptions | null)[] | null; 
    emailGlobalSubscribe?: rql_SubscribeState | null; 
  }

  export type EmailSubscriptions = {
    __typename?: "rql_EmailSubscription";
    id?: string | null; 
    subscribed?: boolean | null; 
    translationKey?: rql_EmailSubscription_TranslationKey | null; 
  }
}
export namespace UpdateEmailSubscription {
  export type Variables = {
    input?: Input_rql_EmailSubscription | null;
  }

  export type Mutation = {
    __typename?: "Mutation";
    setEmailSubscription?: SetEmailSubscription | null; 
  }

  export type SetEmailSubscription = {
    __typename?: "rql_EmailSubscription";
    id?: string | null; 
    subscribed?: boolean | null; 
    translationKey?: rql_EmailSubscription_TranslationKey | null; 
  }
}
export namespace SetEmailGlobalSubscribe {
  export type Variables = {
    input?: Input_rql_SetGlobalSubscribeRequest | null;
  }

  export type Mutation = {
    __typename?: "Mutation";
    setEmailGlobalSubscribe?: SetEmailGlobalSubscribe | null; 
  }

  export type SetEmailGlobalSubscribe = {
    __typename?: "rql_Me";
    uuid?: string | null; 
    emailGlobalSubscribe?: rql_SubscribeState | null; 
  }
}
export namespace TriggerOptInEmail {
  export type Variables = {
    input?: Input_rql_Blank | null;
  }

  export type Mutation = {
    __typename?: "Mutation";
    triggerOptInEmail?: TriggerOptInEmail | null; 
  }

  export type TriggerOptInEmail = {
    __typename?: "braze_TriggerCampaignSendResponse";
    dispatchId?: string | null; 
  }
}
export namespace GuestCheckoutApplePayLineItems {
  export type Variables = {
    input?: Input_core_apimessages_GuestCheckoutApplePayLineItemsRequest | null;
  }

  export type Mutation = {
    __typename?: "Mutation";
    guestCheckoutApplePayLineItems?: GuestCheckoutApplePayLineItems | null; 
  }

  export type GuestCheckoutApplePayLineItems = {
    __typename?: "core_apimessages_GuestCheckoutApplePayLineItemsResponse";
    lineItems?: (LineItems | null)[] | null; 
    total?: Total | null; 
  }

  export type LineItems = {
    __typename?: "core_apimessages_GuestCheckoutApplePayLineItem";
    name?: string | null; 
    description?: string | null; 
    amount?: Amount | null; 
  }

  export type Amount = {
    __typename?: "core_apimessages_Money";
    amount?: string | null; 
    amountCents?: number | null; 
    currency?: string | null; 
    symbol?: string | null; 
    display?: string | null; 
  }

  export type Total = {
    __typename?: "core_apimessages_GuestCheckoutApplePayLineItem";
    name?: string | null; 
    description?: string | null; 
    amount?: _Amount | null; 
  }

  export type _Amount = {
    __typename?: "core_apimessages_Money";
    amount?: string | null; 
    amountCents?: number | null; 
    currency?: string | null; 
    symbol?: string | null; 
    display?: string | null; 
  }
}
export namespace GuestCheckoutApplePayPayment {
  export type Variables = {
    input?: Input_core_apimessages_GuestCheckoutApplePayPaymentRequest | null;
  }

  export type Mutation = {
    __typename?: "Mutation";
    guestCheckoutApplePayPayment?: GuestCheckoutApplePayPayment | null; 
  }

  export type GuestCheckoutApplePayPayment = {
    __typename?: "core_apimessages_GuestCheckoutApplePayPaymentResponse";
    orderBundleId?: string | null; 
    paymentResultUrl?: string | null; 
  }
}
export namespace CoreCreditCardWalletIndex {
  export type Variables = {
  }

  export type Query = {
    __typename?: "Query";
    me?: Me | null; 
  }

  export type Me = {
    __typename?: "rql_Me";
    uuid?: string | null; 
  } & CreditCardWalletLayoutFields.Fragment
}
export namespace PaymentSelectionModalData {
  export type Variables = {
    listingId?: string | null;
  }

  export type Query = {
    __typename?: "Query";
    listing?: Listing | null; 
  }

  export type Listing = {
    __typename?: "Listing";
    _id?: string | null; 
    acceptedPaymentMethods?: (string | null)[] | null; 
  } & BuyListingNowApplePayData.Fragment
}
export namespace CoreBrandCompletions {
  export type Variables = {
    query?: string | null;
    skip: boolean;
  }

  export type Query = {
    __typename?: "Query";
    completions?: Completions | null; 
  }

  export type Completions = {
    __typename?: "reverb_search_SearchResponse";
    completions?: (_Completions | null)[] | null; 
  }

  export type _Completions = {
    __typename?: "reverb_search_Completion";
    text?: string | null; 
    type?: reverb_search_CompletionType | null; 
    options?: (Options | null)[] | null; 
  }

  export type Options = {
    __typename?: "reverb_search_SuggestOption";
    slug?: string | null; 
    output?: string | null; 
  }
}
export namespace CorePayoutsMyDirectCheckoutProfile {
  export type Variables = {
    input?: Input_core_apimessages_MyDirectCheckoutProfileRequest | null;
  }

  export type Query = {
    __typename?: "Query";
    myDirectCheckoutProfile?: MyDirectCheckoutProfile | null; 
  }

  export type MyDirectCheckoutProfile = {
    __typename?: "core_apimessages_MyDirectCheckoutProfileResponse";
    plaidAccountId?: string | null; 
    nameOnAccount?: string | null; 
    maskedNameSummary?: string | null; 
    bankName?: string | null; 
    countryCode?: string | null; 
    payoutMethod?: string | null; 
    hasAcceptedReverbBankTerms?: boolean | null; 
    profileErrors?: (string | null)[] | null; 
    currency?: string | null; 
  }
}
export namespace CoreUserWatchlistLayout {
  export type Variables = {
    useLiveListings: boolean;
    profileSlug?: string | null;
    limit?: number | null;
    offset?: number | null;
  }

  export type Query = {
    __typename?: "Query";
    liveWatches?: LiveWatches | null; 
    endedWatches?: EndedWatches | null; 
    user?: User | null; 
  }

  export type LiveWatches = {
    __typename?: "WatchCollection";
    pageInfo?: PageInfo | null; 
    nodes?: (Nodes | null)[] | null; 
  }

  export type PageInfo = {
    __typename?: "rql_PageInfo";
    total?: number | null; 
  }

  export type Nodes = {
    __typename?: "Watch";
    _id?: string | null; 
    listing?: Listing | null; 
  }

  export type Listing = {
    __typename?: "Listing";
    _id?: string | null; 
    id?: string | null; 
  } & ListViewListings.Fragment

  export type EndedWatches = {
    __typename?: "WatchCollection";
    pageInfo?: _PageInfo | null; 
    nodes?: (_Nodes | null)[] | null; 
  }

  export type _PageInfo = {
    __typename?: "rql_PageInfo";
    total?: number | null; 
  }

  export type _Nodes = {
    __typename?: "Watch";
    _id?: string | null; 
    listing?: _Listing | null; 
  }

  export type _Listing = {
    __typename?: "Listing";
    _id?: string | null; 
    id?: string | null; 
  } & ListViewListings.Fragment

  export type User = {
    __typename?: "User";
    _id?: string | null; 
    firstName?: string | null; 
  }
}
export namespace CoreWatchlistLayout {
  export type Variables = {
    useLiveListings: boolean;
    limit?: number | null;
    offset?: number | null;
  }

  export type Query = {
    __typename?: "Query";
    me?: Me | null; 
  }

  export type Me = {
    __typename?: "rql_Me";
    id?: string | null; 
    uuid?: string | null; 
    profileSlug?: string | null; 
    liveWatches?: LiveWatches | null; 
    endedWatches?: EndedWatches | null; 
  }

  export type LiveWatches = {
    __typename?: "WatchCollection";
    pageInfo?: PageInfo | null; 
    nodes?: (Nodes | null)[] | null; 
  }

  export type PageInfo = {
    __typename?: "rql_PageInfo";
    total?: number | null; 
  }

  export type Nodes = {
    __typename?: "Watch";
    _id?: string | null; 
    listing?: Listing | null; 
  }

  export type Listing = {
    __typename?: "Listing";
    _id?: string | null; 
    id?: string | null; 
  } & ListViewListings.Fragment

  export type EndedWatches = {
    __typename?: "WatchCollection";
    pageInfo?: _PageInfo | null; 
    nodes?: (_Nodes | null)[] | null; 
  }

  export type _PageInfo = {
    __typename?: "rql_PageInfo";
    total?: number | null; 
  }

  export type _Nodes = {
    __typename?: "Watch";
    _id?: string | null; 
    listing?: _Listing | null; 
  }

  export type _Listing = {
    __typename?: "Listing";
    _id?: string | null; 
    id?: string | null; 
  } & ListViewListings.Fragment
}
export namespace MultiOrderCustomsInfoQuery {
  export type Variables = {
  }

  export type Query = {
    __typename?: "Query";
    exchangeRates?: ExchangeRates | null; 
  }

  export type ExchangeRates = {
    __typename?: "reverb_config_cache_CurrencyResponse";
    rates?: (Rates | null)[] | null; 
  }

  export type Rates = {
    __typename?: "reverb_config_cache_ExchangeRate";
    from?: string | null; 
    to?: string | null; 
    rate?: number | null; 
  }
}
export namespace CoreShippingLabelEditShipment {
  export type Variables = {
    shipmentId?: string | null;
    checkoutUuid?: string | null;
    actionableStatuses?: (string | null)[] | null;
  }

  export type Query = {
    __typename?: "Query";
    me?: Me | null; 
    countries?: Countries | null; 
  }

  export type Me = {
    __typename?: "rql_Me";
    uuid?: string | null; 
    shipments?: (Shipments | null)[] | null; 
    sellerCheckout?: SellerCheckout | null; 
  }

  export type Shipments = {
    __typename?: "Shipment";
    _id?: string | null; 
    id?: string | null; 
    orders?: (Orders | null)[] | null; 
    toAddress?: ToAddress | null; 
    fromAddress?: FromAddress | null; 
    package?: Package | null; 
    shippingProtection?: boolean | null; 
    shippingProtectionPrice?: ShippingProtectionPrice | null; 
    signatureRequired?: boolean | null; 
    mediaMailQualified?: boolean | null; 
    toAddressIsResidential?: boolean | null; 
  }

  export type Orders = {
    __typename?: "Order";
    _id?: string | null; 
    id?: string | null; 
    legacyOrderId?: string | null; 
  }

  export type ToAddress = {
    __typename?: "core_apimessages_Address";
    name?: string | null; 
    streetAddress?: string | null; 
    extendedAddress?: string | null; 
    postalCode?: string | null; 
    phone?: string | null; 
    region?: string | null; 
    locality?: string | null; 
    countryCode?: string | null; 
  }

  export type FromAddress = {
    __typename?: "core_apimessages_Address";
    name?: string | null; 
    streetAddress?: string | null; 
    extendedAddress?: string | null; 
    postalCode?: string | null; 
    phone?: string | null; 
    region?: string | null; 
    locality?: string | null; 
    countryCode?: string | null; 
  }

  export type Package = {
    __typename?: "core_apimessages_ShippingLabelPackage";
    predefinedPackage?: string | null; 
    length?: Length | null; 
    height?: Height | null; 
    width?: Width | null; 
    weight?: Weight | null; 
  }

  export type Length = {
    __typename?: "core_apimessages_Measurement";
    value?: string | null; 
    unit?: string | null; 
  }

  export type Height = {
    __typename?: "core_apimessages_Measurement";
    value?: string | null; 
    unit?: string | null; 
  }

  export type Width = {
    __typename?: "core_apimessages_Measurement";
    value?: string | null; 
    unit?: string | null; 
  }

  export type Weight = {
    __typename?: "core_apimessages_Measurement";
    value?: string | null; 
    unit?: string | null; 
  }

  export type ShippingProtectionPrice = {
    __typename?: "core_apimessages_Money";
    amount?: string | null; 
    amountCents?: number | null; 
    currency?: string | null; 
    symbol?: string | null; 
  }

  export type SellerCheckout = {
    __typename?: "SellerCheckout";
    _id?: string | null; 
    ordersForShipmentSearch?: OrdersForShipmentSearch | null; 
    flatRateShippingOptions?: FlatRateShippingOptions | null; 
  }

  export type OrdersForShipmentSearch = {
    __typename?: "reverb_search_SearchResponse";
    ordersForShipment?: (OrdersForShipment | null)[] | null; 
  }

  export type OrdersForShipment = {
    __typename?: "Order";
    _id?: string | null; 
    listing?: Listing | null; 
  } & ShippingLabelOrderData.Fragment

  export type Listing = {
    __typename?: "Listing";
    _id?: string | null; 
  } & ShippingLabelListingData.Fragment

  export type FlatRateShippingOptions = {
    __typename?: "core_apimessages_OrderFlatRateShippingOptionsResponse";
    flatRateShippingOptions?: (_FlatRateShippingOptions | null)[] | null; 
  }

  export type _FlatRateShippingOptions = {
    __typename?: "core_apimessages_FlatRateShippingOption";
    carrier?: string | null; 
    displayTitle?: string | null; 
    displayName?: string | null; 
    optionValue?: string | null; 
    displayDimensions?: string | null; 
    maximumPounds?: number | null; 
    displayPosition?: number | null; 
  }

  export type Countries = {
    __typename?: "core_apimessages_CountriesResponse";
    countries?: (_Countries | null)[] | null; 
  }

  export type _Countries =ShippingLabelCountriesData.Fragment
}
export namespace CoreShippingLabelEditShipmentForManualOrder {
  export type Variables = {
    shipmentId?: string | null;
    orderUuid?: string | null;
  }

  export type Query = {
    __typename?: "Query";
    me?: Me | null; 
    order?: Order | null; 
    countries?: Countries | null; 
  }

  export type Me = {
    __typename?: "rql_Me";
    uuid?: string | null; 
    shipments?: (Shipments | null)[] | null; 
  }

  export type Shipments = {
    __typename?: "Shipment";
    _id?: string | null; 
    id?: string | null; 
    orders?: (Orders | null)[] | null; 
    toAddress?: ToAddress | null; 
    fromAddress?: FromAddress | null; 
    package?: Package | null; 
    shippingProtection?: boolean | null; 
    shippingProtectionPrice?: ShippingProtectionPrice | null; 
    signatureRequired?: boolean | null; 
    mediaMailQualified?: boolean | null; 
  }

  export type Orders = {
    __typename?: "Order";
    _id?: string | null; 
    id?: string | null; 
    legacyOrderId?: string | null; 
  }

  export type ToAddress = {
    __typename?: "core_apimessages_Address";
    name?: string | null; 
    streetAddress?: string | null; 
    extendedAddress?: string | null; 
    postalCode?: string | null; 
    phone?: string | null; 
    region?: string | null; 
    locality?: string | null; 
    countryCode?: string | null; 
  }

  export type FromAddress = {
    __typename?: "core_apimessages_Address";
    name?: string | null; 
    streetAddress?: string | null; 
    extendedAddress?: string | null; 
    postalCode?: string | null; 
    phone?: string | null; 
    region?: string | null; 
    locality?: string | null; 
    countryCode?: string | null; 
  }

  export type Package = {
    __typename?: "core_apimessages_ShippingLabelPackage";
    predefinedPackage?: string | null; 
    length?: Length | null; 
    height?: Height | null; 
    width?: Width | null; 
    weight?: Weight | null; 
  }

  export type Length = {
    __typename?: "core_apimessages_Measurement";
    value?: string | null; 
    unit?: string | null; 
  }

  export type Height = {
    __typename?: "core_apimessages_Measurement";
    value?: string | null; 
    unit?: string | null; 
  }

  export type Width = {
    __typename?: "core_apimessages_Measurement";
    value?: string | null; 
    unit?: string | null; 
  }

  export type Weight = {
    __typename?: "core_apimessages_Measurement";
    value?: string | null; 
    unit?: string | null; 
  }

  export type ShippingProtectionPrice = {
    __typename?: "core_apimessages_Money";
    amount?: string | null; 
    amountCents?: number | null; 
    currency?: string | null; 
    symbol?: string | null; 
  }

  export type Order = {
    __typename?: "Order";
    _id?: string | null; 
    listing?: Listing | null; 
    flatRateShippingOptions?: FlatRateShippingOptions | null; 
  } & ShippingLabelOrderData.Fragment

  export type Listing = {
    __typename?: "Listing";
    _id?: string | null; 
  } & ShippingLabelListingData.Fragment

  export type FlatRateShippingOptions = {
    __typename?: "core_apimessages_OrderFlatRateShippingOptionsResponse";
    flatRateShippingOptions?: (_FlatRateShippingOptions | null)[] | null; 
  }

  export type _FlatRateShippingOptions = {
    __typename?: "core_apimessages_FlatRateShippingOption";
    carrier?: string | null; 
    displayTitle?: string | null; 
    displayName?: string | null; 
    optionValue?: string | null; 
    displayDimensions?: string | null; 
    maximumPounds?: number | null; 
    displayPosition?: number | null; 
  }

  export type Countries = {
    __typename?: "core_apimessages_CountriesResponse";
    countries?: (_Countries | null)[] | null; 
  }

  export type _Countries =ShippingLabelCountriesData.Fragment
}
export namespace CoreShippingLabelForm {
  export type Variables = {
    checkoutUuid?: string | null;
    actionableStatuses?: (string | null)[] | null;
  }

  export type Query = {
    __typename?: "Query";
    me?: Me | null; 
    countries?: Countries | null; 
  }

  export type Me = {
    __typename?: "rql_Me";
    uuid?: string | null; 
    sellerCheckout?: SellerCheckout | null; 
    shop?: Shop | null; 
  }

  export type SellerCheckout = {
    __typename?: "SellerCheckout";
    _id?: string | null; 
    ordersForShipmentSearch?: OrdersForShipmentSearch | null; 
    verifiedShippingAddress?: VerifiedShippingAddress | null; 
    flatRateShippingOptions?: FlatRateShippingOptions | null; 
  }

  export type OrdersForShipmentSearch = {
    __typename?: "reverb_search_SearchResponse";
    ordersForShipment?: (OrdersForShipment | null)[] | null; 
  }

  export type OrdersForShipment = {
    __typename?: "Order";
    _id?: string | null; 
    listing?: Listing | null; 
  } & ShippingLabelOrderData.Fragment

  export type Listing = {
    __typename?: "Listing";
    _id?: string | null; 
    shipmentPackage?: ShipmentPackage | null; 
  } & ShippingLabelListingData.Fragment

  export type ShipmentPackage = {
    __typename?: "ShipmentPackage";
    _id?: string | null; 
    width?: Width | null; 
    height?: Height | null; 
    length?: Length | null; 
    weight?: Weight | null; 
  }

  export type Width = {
    __typename?: "core_apimessages_Measurement";
    value?: string | null; 
    unit?: string | null; 
  }

  export type Height = {
    __typename?: "core_apimessages_Measurement";
    value?: string | null; 
    unit?: string | null; 
  }

  export type Length = {
    __typename?: "core_apimessages_Measurement";
    value?: string | null; 
    unit?: string | null; 
  }

  export type Weight = {
    __typename?: "core_apimessages_Measurement";
    value?: string | null; 
    unit?: string | null; 
  }

  export type VerifiedShippingAddress = {
    __typename?: "core_apimessages_OrderVerifyShippingAddressResponse";
    address?: Address | null; 
    verificationStatus?: core_apimessages_AddressVerificationStatus | null; 
    isResidential?: boolean | null; 
  }

  export type Address = {
    __typename?: "core_apimessages_Address";
    name?: string | null; 
    streetAddress?: string | null; 
    extendedAddress?: string | null; 
    locality?: string | null; 
    region?: string | null; 
    postalCode?: string | null; 
    countryCode?: string | null; 
    phone?: string | null; 
  }

  export type FlatRateShippingOptions = {
    __typename?: "core_apimessages_OrderFlatRateShippingOptionsResponse";
    flatRateShippingOptions?: (_FlatRateShippingOptions | null)[] | null; 
  }

  export type _FlatRateShippingOptions = {
    __typename?: "core_apimessages_FlatRateShippingOption";
    carrier?: string | null; 
    displayTitle?: string | null; 
    displayName?: string | null; 
    optionValue?: string | null; 
    displayDimensions?: string | null; 
    maximumPounds?: number | null; 
    displayPosition?: number | null; 
  }

  export type Shop = {
    __typename?: "MyShop";
    _id?: string | null; 
    address?: _Address | null; 
  }

  export type _Address = {
    __typename?: "core_apimessages_Address";
    name?: string | null; 
    streetAddress?: string | null; 
    extendedAddress?: string | null; 
    locality?: string | null; 
    region?: string | null; 
    postalCode?: string | null; 
    countryCode?: string | null; 
    phone?: string | null; 
  }

  export type Countries = {
    __typename?: "core_apimessages_CountriesResponse";
    countries?: (_Countries | null)[] | null; 
  }

  export type _Countries =ShippingLabelCountriesData.Fragment
}
export namespace CoreShippingLabelFormForManualOrder {
  export type Variables = {
    orderUuid?: string | null;
  }

  export type Query = {
    __typename?: "Query";
    order?: Order | null; 
    me?: Me | null; 
    countries?: Countries | null; 
  }

  export type Order = {
    __typename?: "Order";
    _id?: string | null; 
    listing?: Listing | null; 
    verifiedShippingAddress?: VerifiedShippingAddress | null; 
    flatRateShippingOptions?: FlatRateShippingOptions | null; 
  } & ShippingLabelOrderData.Fragment

  export type Listing = {
    __typename?: "Listing";
    _id?: string | null; 
  } & ShippingLabelListingData.Fragment

  export type VerifiedShippingAddress = {
    __typename?: "core_apimessages_OrderVerifyShippingAddressResponse";
    address?: Address | null; 
    verificationStatus?: core_apimessages_AddressVerificationStatus | null; 
    isResidential?: boolean | null; 
  }

  export type Address = {
    __typename?: "core_apimessages_Address";
    name?: string | null; 
    streetAddress?: string | null; 
    extendedAddress?: string | null; 
    locality?: string | null; 
    region?: string | null; 
    postalCode?: string | null; 
    countryCode?: string | null; 
    phone?: string | null; 
  }

  export type FlatRateShippingOptions = {
    __typename?: "core_apimessages_OrderFlatRateShippingOptionsResponse";
    flatRateShippingOptions?: (_FlatRateShippingOptions | null)[] | null; 
  }

  export type _FlatRateShippingOptions = {
    __typename?: "core_apimessages_FlatRateShippingOption";
    carrier?: string | null; 
    displayTitle?: string | null; 
    displayName?: string | null; 
    optionValue?: string | null; 
    displayDimensions?: string | null; 
    maximumPounds?: number | null; 
    displayPosition?: number | null; 
  }

  export type Me = {
    __typename?: "rql_Me";
    uuid?: string | null; 
    shop?: Shop | null; 
  }

  export type Shop = {
    __typename?: "MyShop";
    _id?: string | null; 
    address?: _Address | null; 
  }

  export type _Address = {
    __typename?: "core_apimessages_Address";
    name?: string | null; 
    streetAddress?: string | null; 
    extendedAddress?: string | null; 
    locality?: string | null; 
    region?: string | null; 
    postalCode?: string | null; 
    countryCode?: string | null; 
    phone?: string | null; 
  }

  export type Countries = {
    __typename?: "core_apimessages_CountriesResponse";
    countries?: (_Countries | null)[] | null; 
  }

  export type _Countries =ShippingLabelCountriesData.Fragment
}
export namespace ShippingProtection {
  export type Variables = {
    input?: Input_core_apimessages_ShippingProtectionRequest | null;
  }

  export type Mutation = {
    __typename?: "Mutation";
    shippingProtection?: ShippingProtection | null; 
  }

  export type ShippingProtection = {
    __typename?: "core_apimessages_ShippingProtectionResponse";
    price?: Price | null; 
    shippingProtectionStatus?: core_apimessages_ShippingProtectionStatus | null; 
    signatureRequiredStatus?: core_apimessages_SignatureRequiredStatus | null; 
    signatureRequiredCosts?: (SignatureRequiredCosts | null)[] | null; 
  }

  export type Price = {
    __typename?: "core_apimessages_Money";
    amount?: string | null; 
    amountCents?: number | null; 
    currency?: string | null; 
    symbol?: string | null; 
    display?: string | null; 
  }

  export type SignatureRequiredCosts = {
    __typename?: "core_apimessages_SignatureRequiredCost";
    carrier?: string | null; 
    amount?: Amount | null; 
  }

  export type Amount = {
    __typename?: "core_apimessages_Money";
    display?: string | null; 
  }
}
export namespace CreateShipment {
  export type Variables = {
    input?: Input_core_apimessages_CreateShipmentRequest | null;
  }

  export type Mutation = {
    __typename?: "Mutation";
    createShipment?: CreateShipment | null; 
  }

  export type CreateShipment = {
    __typename?: "Shipment";
    _id?: string | null; 
    id?: string | null; 
    toAddress?: ToAddress | null; 
    fromAddress?: FromAddress | null; 
    package?: Package | null; 
    shippingProtection?: boolean | null; 
    signatureRequired?: boolean | null; 
    mediaMailQualified?: boolean | null; 
    defaultPaymentMethod?: core_apimessages_FeePaymentMethod | null; 
    carrierRates?: (CarrierRates | null)[] | null; 
    shippingMethod?: core_apimessages_ShippingMethod | null; 
    toAddressIsResidential?: boolean | null; 
  }

  export type ToAddress = {
    __typename?: "core_apimessages_Address";
    name?: string | null; 
    streetAddress?: string | null; 
    extendedAddress?: string | null; 
    postalCode?: string | null; 
    phone?: string | null; 
    region?: string | null; 
    locality?: string | null; 
    countryCode?: string | null; 
  }

  export type FromAddress = {
    __typename?: "core_apimessages_Address";
    name?: string | null; 
    streetAddress?: string | null; 
    extendedAddress?: string | null; 
    postalCode?: string | null; 
    phone?: string | null; 
    region?: string | null; 
    locality?: string | null; 
    countryCode?: string | null; 
  }

  export type Package = {
    __typename?: "core_apimessages_ShippingLabelPackage";
    predefinedPackage?: string | null; 
    length?: Length | null; 
    height?: Height | null; 
    width?: Width | null; 
    weight?: Weight | null; 
  }

  export type Length = {
    __typename?: "core_apimessages_Measurement";
    value?: string | null; 
    unit?: string | null; 
  }

  export type Height = {
    __typename?: "core_apimessages_Measurement";
    value?: string | null; 
    unit?: string | null; 
  }

  export type Width = {
    __typename?: "core_apimessages_Measurement";
    value?: string | null; 
    unit?: string | null; 
  }

  export type Weight = {
    __typename?: "core_apimessages_Measurement";
    value?: string | null; 
    unit?: string | null; 
  }

  export type CarrierRates = {
    __typename?: "core_apimessages_CarrierRateGroup";
    displayPosition?: number | null; 
    carrier?: string | null; 
    rates?: (Rates | null)[] | null; 
  }

  export type Rates = {
    __typename?: "core_apimessages_CarrierRate";
    displayPosition?: number | null; 
    uuid?: string | null; 
    carrier?: string | null; 
    service?: string | null; 
    description?: string | null; 
    paymentMethod?: core_apimessages_FeePaymentMethod | null; 
    rackRateAmount?: RackRateAmount | null; 
    shippingProtectionAmount?: ShippingProtectionAmount | null; 
    reverbDiscountAmount?: ReverbDiscountAmount | null; 
    totalAmount?: TotalAmount | null; 
    signatureRequiredAmount?: SignatureRequiredAmount | null; 
  }

  export type RackRateAmount = {
    __typename?: "core_apimessages_Money";
    amount?: string | null; 
    amountCents?: number | null; 
    currency?: string | null; 
    symbol?: string | null; 
    display?: string | null; 
  }

  export type ShippingProtectionAmount = {
    __typename?: "core_apimessages_Money";
    amount?: string | null; 
    amountCents?: number | null; 
    currency?: string | null; 
    symbol?: string | null; 
    display?: string | null; 
  }

  export type ReverbDiscountAmount = {
    __typename?: "core_apimessages_Money";
    amount?: string | null; 
    amountCents?: number | null; 
    currency?: string | null; 
    symbol?: string | null; 
    display?: string | null; 
  }

  export type TotalAmount = {
    __typename?: "core_apimessages_Money";
    amount?: string | null; 
    amountCents?: number | null; 
    currency?: string | null; 
    symbol?: string | null; 
    display?: string | null; 
  }

  export type SignatureRequiredAmount = {
    __typename?: "core_apimessages_Money";
    amount?: string | null; 
    amountCents?: number | null; 
    currency?: string | null; 
    symbol?: string | null; 
    display?: string | null; 
  }
}
export namespace PurchaseShippingRate {
  export type Variables = {
    input?: Input_core_apimessages_PurchaseShippingRateRequest | null;
  }

  export type Mutation = {
    __typename?: "Mutation";
    purchaseShippingRate?: PurchaseShippingRate | null; 
  }

  export type PurchaseShippingRate = {
    __typename?: "core_apimessages_PurchaseShippingRateResponse";
    errors?: (Errors | null)[] | null; 
  }

  export type Errors = {
    __typename?: "core_apimessages_Error";
    message?: string | null; 
  }
}
export namespace CoreShippingLabelShipments {
  export type Variables = {
    shipmentId?: string | null;
  }

  export type Query = {
    __typename?: "Query";
    me?: Me | null; 
  }

  export type Me = {
    __typename?: "rql_Me";
    uuid?: string | null; 
    shipments?: (Shipments | null)[] | null; 
  }

  export type Shipments = {
    __typename?: "Shipment";
    _id?: string | null; 
    id?: string | null; 
    orders?: (Orders | null)[] | null; 
    toAddress?: ToAddress | null; 
    fromAddress?: FromAddress | null; 
    package?: Package | null; 
    shippingProtection?: boolean | null; 
    signatureRequired?: boolean | null; 
    mediaMailQualified?: boolean | null; 
    defaultPaymentMethod?: core_apimessages_FeePaymentMethod | null; 
    carrierRates?: (CarrierRates | null)[] | null; 
    shippingMethod?: core_apimessages_ShippingMethod | null; 
  }

  export type Orders = {
    __typename?: "Order";
    _id?: string | null; 
    id?: string | null; 
    legacyOrderId?: string | null; 
  }

  export type ToAddress = {
    __typename?: "core_apimessages_Address";
    name?: string | null; 
    streetAddress?: string | null; 
    extendedAddress?: string | null; 
    postalCode?: string | null; 
    phone?: string | null; 
    region?: string | null; 
    locality?: string | null; 
    countryCode?: string | null; 
  }

  export type FromAddress = {
    __typename?: "core_apimessages_Address";
    name?: string | null; 
    streetAddress?: string | null; 
    extendedAddress?: string | null; 
    postalCode?: string | null; 
    phone?: string | null; 
    region?: string | null; 
    locality?: string | null; 
    countryCode?: string | null; 
  }

  export type Package = {
    __typename?: "core_apimessages_ShippingLabelPackage";
    predefinedPackage?: string | null; 
    length?: Length | null; 
    height?: Height | null; 
    width?: Width | null; 
    weight?: Weight | null; 
  }

  export type Length = {
    __typename?: "core_apimessages_Measurement";
    value?: string | null; 
    unit?: string | null; 
  }

  export type Height = {
    __typename?: "core_apimessages_Measurement";
    value?: string | null; 
    unit?: string | null; 
  }

  export type Width = {
    __typename?: "core_apimessages_Measurement";
    value?: string | null; 
    unit?: string | null; 
  }

  export type Weight = {
    __typename?: "core_apimessages_Measurement";
    value?: string | null; 
    unit?: string | null; 
  }

  export type CarrierRates = {
    __typename?: "core_apimessages_CarrierRateGroup";
    displayPosition?: number | null; 
    carrier?: string | null; 
    rates?: (Rates | null)[] | null; 
  }

  export type Rates = {
    __typename?: "core_apimessages_CarrierRate";
    displayPosition?: number | null; 
    uuid?: string | null; 
    carrier?: string | null; 
    service?: string | null; 
    description?: string | null; 
    paymentMethod?: core_apimessages_FeePaymentMethod | null; 
    rackRateAmount?: RackRateAmount | null; 
    shippingProtectionAmount?: ShippingProtectionAmount | null; 
    reverbDiscountAmount?: ReverbDiscountAmount | null; 
    totalAmount?: TotalAmount | null; 
    signatureRequiredAmount?: SignatureRequiredAmount | null; 
  }

  export type RackRateAmount = {
    __typename?: "core_apimessages_Money";
    amount?: string | null; 
    amountCents?: number | null; 
    currency?: string | null; 
    symbol?: string | null; 
    display?: string | null; 
  }

  export type ShippingProtectionAmount = {
    __typename?: "core_apimessages_Money";
    amount?: string | null; 
    amountCents?: number | null; 
    currency?: string | null; 
    symbol?: string | null; 
    display?: string | null; 
  }

  export type ReverbDiscountAmount = {
    __typename?: "core_apimessages_Money";
    amount?: string | null; 
    amountCents?: number | null; 
    currency?: string | null; 
    symbol?: string | null; 
    display?: string | null; 
  }

  export type TotalAmount = {
    __typename?: "core_apimessages_Money";
    amount?: string | null; 
    amountCents?: number | null; 
    currency?: string | null; 
    symbol?: string | null; 
    display?: string | null; 
  }

  export type SignatureRequiredAmount = {
    __typename?: "core_apimessages_Money";
    amount?: string | null; 
    amountCents?: number | null; 
    currency?: string | null; 
    symbol?: string | null; 
    display?: string | null; 
  }
}
export namespace CoreListingSimilarListingsGrid {
  export type Variables = {
    limit?: number | null;
    offset?: number | null;
    query?: string | null;
    currency?: string | null;
    priceMax?: string | null;
    priceMin?: string | null;
    decades?: (string | null)[] | null;
    yearMax?: string | null;
    yearMin?: string | null;
    sortSlug?: string | null;
    categorySlugs?: (string | null)[] | null;
    brandSlugs?: (string | null)[] | null;
    aggs?: (reverb_search_ListingsSearchRequest_Aggregation | null)[] | null;
    conditionSlugs?: (string | null)[] | null;
    onSale?: boolean | null;
    holidaySale?: boolean | null;
    handmade?: boolean | null;
    freeShipping?: boolean | null;
    freeExpeditedShipping?: boolean | null;
    acceptsOffers?: boolean | null;
    acceptsGiftCards?: boolean | null;
    preferredSeller?: boolean | null;
    acceptsPaymentPlans?: boolean | null;
    itemRegion?: string | null;
    shippingRegionCode?: (string | null)[] | null;
    showOnlySold?: boolean | null;
    showSold?: boolean | null;
    traitValues?: (string | null)[] | null;
    itemState?: (string | null)[] | null;
    itemCity?: (string | null)[] | null;
    shopSlug?: string | null;
    curatedSetSlugs?: (string | null)[] | null;
    saleSlugs?: (string | null)[] | null;
    cspSlug?: string | null;
    combinedShipping?: boolean | null;
    acceptsAffirm?: boolean | null;
    terminateEarly?: boolean | null;
    fallbackToOr?: boolean | null;
    withProximityFilter?: Input_reverb_search_ProximityFilterRequest | null;
    localPickup?: boolean | null;
    minSaleDiscountPercent?: string | null;
    useExperimentalQuery?: boolean | null;
    boostedItemRegionCode?: string | null;
    bestMatchSignalsV2ExperimentGroup?: number | null;
    ecsBoostExperimentGroup?: number | null;
    useExperimentalRecall?: boolean | null;
    mpTotalPriceExperimentGroup?: number | null;
    useTotalPrice?: boolean | null;
    countryOfOrigin?: (string | null)[] | null;
    contexts?: (reverb_search_Context | null)[] | null;
    autodirects?: reverb_search_Autodirects | null;
    similarListingIds?: (string | null)[] | null;
    multiClientExperiments?: (Input_reverb_search_ExperimentData | null)[] | null;
  }

  export type Query = {
    __typename?: "Query";
    listingsSearch?: ListingsSearch | null; 
  }

  export type ListingsSearch = {
    __typename?: "reverb_search_SearchResponse";
    listings?: (Listings | null)[] | null; 
    filters?: (Filters | null)[] | null; 
    total?: number | null; 
    offset?: number | null; 
    limit?: number | null; 
  }

  export type Listings = {
    __typename?: "Listing";
    _id?: string | null; 
  } & SimilarListingsFields.Fragment

  export type Filters = {
    __typename?: "reverb_search_Filter";
    options?: (Options | null)[] | null; 
  } & NestedFilter.Fragment

  export type Options = {
    __typename?: "reverb_search_FilterOption";
    selected?: boolean | null; 
    autoselected?: boolean | null; 
  }
}
export namespace CoreListingRelatedBuyingGuide {
  export type Variables = {
    id?: string | null;
  }

  export type Query = {
    __typename?: "Query";
    listing?: Listing | null; 
  }

  export type Listing = {
    __typename?: "Listing";
    _id?: string | null; 
    model?: string | null; 
    make?: string | null; 
    categories?: (Categories | null)[] | null; 
  }

  export type Categories = {
    __typename?: "Category";
    _id?: string | null; 
    name?: string | null; 
    slug?: string | null; 
  }
}
export namespace CoreSaleHeader {
  export type Variables = {
    collectionType?: core_apimessages_CollectionHeader_CollectionType | null;
    collectionSlug?: string | null;
  }

  export type Query = {
    __typename?: "Query";
    collectionHeader?: CollectionHeader | null; 
  }

  export type CollectionHeader = {
    __typename?: "CollectionHeader";
    _id?: string | null; 
    sale?: Sale | null; 
  } & CollectionInfo.Fragment

  export type Sale = {
    __typename?: "core_apimessages_Sale";
    id?: string | null; 
    buyerIneligibilityReason?: string | null; 
    state?: core_apimessages_Sale_SaleState | null; 
    percent?: number | null; 
    code?: string | null; 
    showCode?: boolean | null; 
    shopName?: string | null; 
    shopSlug?: string | null; 
    saleType?: string | null; 
    startsAt?: StartsAt | null; 
    endsAt?: EndsAt | null; 
  }

  export type StartsAt = {
    __typename?: "google_protobuf_Timestamp";
    seconds?: number | null; 
  }

  export type EndsAt = {
    __typename?: "google_protobuf_Timestamp";
    seconds?: number | null; 
  }
}
export namespace CoreListingCombineAndSaveRow {
  export type Variables = {
    combinedShipping?: boolean | null;
    boostCombinedShippingCategories?: (string | null)[] | null;
    shopId?: string | null;
  }

  export type Query = {
    __typename?: "Query";
    listingsSearch?: ListingsSearch | null; 
  }

  export type ListingsSearch = {
    __typename?: "reverb_search_SearchResponse";
    listings?: (Listings | null)[] | null; 
  }

  export type Listings = {
    __typename?: "Listing";
    _id?: string | null; 
  } & ListingsCollection.Fragment
}
export namespace CoreListingSimilarListings {
  export type Variables = {
    listingId?: string | null;
    itemRegion?: string | null;
    itemRegionRelation?: reverb_search_ListingItemRegionRelation | null;
  }

  export type Query = {
    __typename?: "Query";
    listing?: Listing | null; 
  }

  export type Listing = {
    __typename?: "Listing";
    _id?: string | null; 
    similarListings?: (SimilarListings | null)[] | null; 
  }

  export type SimilarListings = {
    __typename?: "Listing";
    _id?: string | null; 
  } & SimilarListingsFields.Fragment
}
export namespace CoreShopInfo {
  export type Variables = {
    shop?: string | null;
  }

  export type Query = {
    __typename?: "Query";
    shop?: Shop | null; 
  }

  export type Shop = {
    __typename?: "Shop";
    _id?: string | null; 
    id?: string | null; 
    description?: string | null; 
    website?: string | null; 
    name?: string | null; 
    shippingPolicy?: string | null; 
    video?: Video | null; 
  } & ShopReturnPoliciesFragment.Fragment & ShopTaxPoliciesData.Fragment

  export type Video = {
    __typename?: "core_apimessages_Video";
    youtubeVideoId?: string | null; 
    empty?: boolean | null; 
  }
}
export namespace CoreShopContainer {
  export type Variables = {
    shop?: string | null;
  }

  export type Query = {
    __typename?: "Query";
    shop?: Shop | null; 
    shopListingsLive?: ShopListingsLive | null; 
    shopListingsAll?: ShopListingsAll | null; 
  }

  export type Shop = {
    __typename?: "Shop";
    _id?: string | null; 
  } & ShopContainerFragment.Fragment & ShopHeaderFragment.Fragment & ShopMetadataFragment.Fragment & ShopTabsFragment.Fragment

  export type ShopListingsLive = {
    __typename?: "reverb_search_SearchResponse";
    total?: number | null; 
  }

  export type ShopListingsAll = {
    __typename?: "reverb_search_SearchResponse";
    total?: number | null; 
  }
}
export namespace CoreShopFeedback {
  export type Variables = {
    shop?: string | null;
  }

  export type Query = {
    __typename?: "Query";
    shop?: Shop | null; 
  }

  export type Shop = {
    __typename?: "Shop";
    _id?: string | null; 
    id?: string | null; 
    slug?: string | null; 
  }
}
export namespace CoreSiteBannerHero {
  export type Variables = {
  }

  export type Query = {
    __typename?: "Query";
    siteBanner?: SiteBanner | null; 
  }

  export type SiteBanner = {
    __typename?: "core_apimessages_SiteBanner";
    id?: string | null; 
    heading?: string | null; 
    subheading?: string | null; 
    callToAction?: string | null; 
    url?: Url | null; 
    hasPhotos?: boolean | null; 
    imageUrl?: string | null; 
    contentSponsorship?: ContentSponsorship | null; 
  }

  export type Url = {
    __typename?: "core_apimessages_Link";
    href?: string | null; 
  }

  export type ContentSponsorship = {
    __typename?: "core_apimessages_ContentSponsorship";
    sponsorshipType?: core_apimessages_ContentSponsorship_SponsorshipType | null; 
    partnershipName?: string | null; 
  }
}
export namespace CoreSearchCompletionsQuery {
  export type Variables = {
    query?: string | null;
    skip: boolean;
  }

  export type Query = {
    __typename?: "Query";
    completions?: Completions | null; 
  }

  export type Completions = {
    __typename?: "reverb_search_SearchResponse";
    completions?: (_Completions | null)[] | null; 
  }

  export type _Completions = {
    __typename?: "reverb_search_Completion";
    text?: string | null; 
    type?: reverb_search_CompletionType | null; 
    options?: (Options | null)[] | null; 
  }

  export type Options = {
    __typename?: "reverb_search_SuggestOption";
    score?: number | null; 
    slug?: string | null; 
    id?: string | null; 
    text?: string | null; 
    output?: string | null; 
    scopes?: (Scopes | null)[] | null; 
    completionPayload?: CompletionPayload | null; 
  }

  export type Scopes = {
    __typename?: "reverb_search_SuggestOptionScope";
    output?: string | null; 
    slug?: string | null; 
    type?: reverb_search_SuggestOptionScope_Type | null; 
  }

  export type CompletionPayload = {
    __typename?: "reverb_search_SuggestOption_CompletionPayload";
    thumbnailUrl?: string | null; 
    inventoryNew?: InventoryNew | null; 
    inventoryUsed?: InventoryUsed | null; 
  }

  export type InventoryNew = {
    __typename?: "reverb_search_Inventory";
    listingCount?: number | null; 
    listingMinPrice?: ListingMinPrice | null; 
  }

  export type ListingMinPrice = {
    __typename?: "reverb_search_Money";
    cents?: number | null; 
    currency?: string | null; 
  }

  export type InventoryUsed = {
    __typename?: "reverb_search_Inventory";
    listingCount?: number | null; 
    listingMinPrice?: _ListingMinPrice | null; 
  }

  export type _ListingMinPrice = {
    __typename?: "reverb_search_Money";
    cents?: number | null; 
    currency?: string | null; 
  }
}
export namespace CoreMosaicTilesHomepage {
  export type Variables = {
  }

  export type Query = {
    __typename?: "Query";
    mosaicTilesHomepage?: MosaicTilesHomepage | null; 
  }

  export type MosaicTilesHomepage = {
    __typename?: "core_apimessages_MosaicTilesResponse";
    mosaicTiles?: (MosaicTiles | null)[] | null; 
  }

  export type MosaicTiles = {
    __typename?: "core_apimessages_MosaicTile";
    id?: string | null; 
    url?: string | null; 
    imageUrl?: string | null; 
    position?: core_apimessages_MosaicTilePosition | null; 
    imageTitle?: string | null; 
    imageSubtitle?: string | null; 
    contentSponsorship?: ContentSponsorship | null; 
  }

  export type ContentSponsorship = {
    __typename?: "core_apimessages_ContentSponsorship";
    sponsorshipType?: core_apimessages_ContentSponsorship_SponsorshipType | null; 
    partnershipName?: string | null; 
  }
}
export namespace CoreListingCspCard {
  export type Variables = {
    id?: string | null;
  }

  export type Query = {
    __typename?: "Query";
    csp?: Csp | null; 
  }

  export type Csp = {
    __typename?: "CSP";
    _id?: string | null; 
    id?: string | null; 
    title?: string | null; 
    reviews?: Reviews | null; 
    webLink?: WebLink | null; 
    image?: Image | null; 
    inventory?: Inventory | null; 
  }

  export type Reviews = {
    __typename?: "core_apimessages_CSPReviews";
    total?: number | null; 
    avgRating?: number | null; 
  }

  export type WebLink = {
    __typename?: "core_apimessages_Link";
    href?: string | null; 
  }

  export type Image = {
    __typename?: "core_apimessages_Image";
    source?: string | null; 
  }

  export type Inventory = {
    __typename?: "core_apimessages_CSPInventory";
    newLowPrice?: NewLowPrice | null; 
    usedLowPrice?: UsedLowPrice | null; 
  }

  export type NewLowPrice = {
    __typename?: "core_apimessages_Money";
    amountCents?: number | null; 
    display?: string | null; 
  }

  export type UsedLowPrice = {
    __typename?: "core_apimessages_Money";
    amountCents?: number | null; 
    display?: string | null; 
  }
}
export namespace CoreMarketplaceCspRow {
  export type Variables = {
    autodirects?: reverb_search_Autodirects | null;
    brands?: (string | null)[] | null;
    categories?: (string | null)[] | null;
    condition?: string | null;
    contexts?: (reverb_search_Context | null)[] | null;
    countryOfOrigin?: (string | null)[] | null;
    curatedSetSlugs?: (string | null)[] | null;
    currency?: string | null;
    decades?: (string | null)[] | null;
    fullTextQuery?: string | null;
    listingsThatShipTo?: string | null;
    priceMin?: string | null;
    priceMax?: string | null;
    sort?: reverb_search_CSPSearchRequest_Sort | null;
    traitValues?: (string | null)[] | null;
    yearMax?: number | null;
    yearMin?: number | null;
  }

  export type Query = {
    __typename?: "Query";
    cspSearch?: CspSearch | null; 
  }

  export type CspSearch = {
    __typename?: "reverb_search_SearchResponse";
    csps?: (Csps | null)[] | null; 
  }

  export type Csps = {
    __typename?: "CSP";
    _id?: string | null; 
  } & CSPCard.Fragment
}
export namespace CoreReverbHeader {
  export type Variables = {
  }

  export type Query = {
    __typename?: "Query";
    me?: Me | null; 
  }

  export type Me = {
    __typename?: "rql_Me";
    uuid?: string | null; 
  } & ReverbHeaderCartBadgeData.Fragment & ReverbHeaderUserMenuData.Fragment
}
export namespace TrendingSearchesQuery {
  export type Variables = {
  }

  export type Query = {
    __typename?: "Query";
    trendingSearches?: TrendingSearches | null; 
  }

  export type TrendingSearches = {
    __typename?: "reverb_personalization_TrendingSearchesResponse";
    trendingSearches?: (_TrendingSearches | null)[] | null; 
  }

  export type _TrendingSearches = {
    __typename?: "reverb_personalization_TrendingSearch";
    query?: string | null; 
    categoryUuid?: string | null; 
    categorySlug?: string | null; 
  }
}
export namespace CoreCheckoutPaymentInProgressLayout {
  export type Variables = {
    id?: string | null;
    reverbApp?: string | null;
  }

  export type Query = {
    __typename?: "Query";
    checkout?: Checkout | null; 
  }

  export type Checkout = {
    __typename?: "Checkout";
    _id?: string | null; 
    action?: Action | null; 
  } & CheckoutTrackingFields.Fragment

  export type Action = {
    __typename?: "CheckoutAction";
    _id?: string | null; 
  } & CheckoutActionHookFields.Fragment
}
export namespace CoreCheckoutLayout {
  export type Variables = {
    id?: string | null;
    reverbApp?: string | null;
    loggedOut: boolean;
  }

  export type Query = {
    __typename?: "Query";
    countries?: Countries | null; 
    checkout?: Checkout | null; 
    me?: Me | null; 
  }

  export type Countries = {
    __typename?: "core_apimessages_CountriesResponse";
    countries?: (_Countries | null)[] | null; 
  }

  export type _Countries = {
    __typename?: "core_apimessages_Country";
    countryCode?: string | null; 
    name?: string | null; 
    subregionRequired?: boolean | null; 
    subregions?: (Subregions | null)[] | null; 
  }

  export type Subregions = {
    __typename?: "core_apimessages_Subregion";
    code?: string | null; 
    name?: string | null; 
  }

  export type Checkout = {
    __typename?: "Checkout";
    _id?: string | null; 
    paymentMethod?: PaymentMethod | null; 
    shippingAddress?: ShippingAddress | null; 
    orders?: (Orders | null)[] | null; 
    action?: Action | null; 
  } & CheckoutOrderSummaryFields.Fragment & CheckoutShippingAddressFormFields.Fragment & CheckoutPaymentMethodFields.Fragment & CheckoutContinueButtonFields.Fragment & CheckoutStepErrorMessageFields.Fragment & CheckoutDisplayFields.Fragment & CheckoutTrackingFields.Fragment

  export type PaymentMethod = {
    __typename?: "core_apimessages_CheckoutPaymentMethod";
    isComplete?: boolean | null; 
  }

  export type ShippingAddress = {
    __typename?: "core_apimessages_Address";
    id?: string | null; 
    isComplete?: boolean | null; 
  }

  export type Orders = {
    __typename?: "core_apimessages_CheckoutOrder";
    cannotBeShippedToAddress?: boolean | null; 
    shippingMethod?: ShippingMethod | null; 
  }

  export type ShippingMethod = {
    __typename?: "core_apimessages_CheckoutShippingMethod";
    type?: core_apimessages_ShippingMethod | null; 
  }

  export type Action = {
    __typename?: "CheckoutAction";
    _id?: string | null; 
  } & CheckoutActionHookFields.Fragment

  export type Me = {
    __typename?: "rql_Me";
    uuid?: string | null; 
    shippingAddresses?: (ShippingAddresses | null)[] | null; 
    creditCards?: (CreditCards | null)[] | null; 
  }

  export type ShippingAddresses = {
    __typename?: "core_apimessages_Address";
    uuid?: string | null; 
  }

  export type CreditCards = {
    __typename?: "core_apimessages_CreditCard";
    id?: string | null; 
  }
}
export namespace CoreFeedbackSellerShopInfo {
  export type Variables = {
    listingId?: string | null;
    channel?: core_apimessages_Channel | null;
  }

  export type Query = {
    __typename?: "Query";
    listing?: Listing | null; 
  }

  export type Listing = {
    __typename?: "Listing";
    _id?: string | null; 
    shop?: Shop | null; 
  }

  export type Shop = {
    __typename?: "Shop";
    _id?: string | null; 
    name?: string | null; 
    slug?: string | null; 
  }
}
export namespace DeclineFeedbackMutation {
  export type Variables = {
    input?: Input_core_apimessages_DeclineFeedbackRequest | null;
  }

  export type Mutation = {
    __typename?: "Mutation";
    declineFeedbackRequest?: DeclineFeedbackRequest | null; 
  }

  export type DeclineFeedbackRequest = {
    __typename?: "core_apimessages_DeclineFeedbackResponse";
    orderUuid?: string | null; 
  }
}
export namespace UpdateFeedback {
  export type Variables = {
    input?: Input_core_apimessages_UpdateFeedbackRequest | null;
  }

  export type Mutation = {
    __typename?: "Mutation";
    updateFeedbackRequest?: UpdateFeedbackRequest | null; 
  }

  export type UpdateFeedbackRequest = {
    __typename?: "core_apimessages_UpdateFeedbackResponse";
    feedback?: Feedback | null; 
  }

  export type Feedback = {
    __typename?: "core_apimessages_Feedback";
    rating?: number | null; 
    shippingSatisfactory?: ShippingSatisfactory | null; 
    conditionSatisfactory?: ConditionSatisfactory | null; 
    message?: string | null; 
  }

  export type ShippingSatisfactory = {
    __typename?: "google_protobuf_BoolValue";
    value?: boolean | null; 
  }

  export type ConditionSatisfactory = {
    __typename?: "google_protobuf_BoolValue";
    value?: boolean | null; 
  }
}
export namespace CoreFeedbackOrderInfo {
  export type Variables = {
    orderUuid?: string | null;
    buyerShopChannel?: core_apimessages_Channel | null;
  }

  export type Query = {
    __typename?: "Query";
    me?: Me | null; 
  }

  export type Me = {
    __typename?: "rql_Me";
    uuid?: string | null; 
    orders?: (Orders | null)[] | null; 
  }

  export type Orders = {
    __typename?: "Order";
    _id?: string | null; 
    legacyOrderId?: string | null; 
    buyerUuid?: string | null; 
    buyer?: Buyer | null; 
    status?: core_apimessages_Order_Status | null; 
    amountTotal?: AmountTotal | null; 
    shippedAt?: ShippedAt | null; 
    createdAt?: CreatedAt | null; 
    listing?: Listing | null; 
  }

  export type Buyer = {
    __typename?: "User";
    _id?: string | null; 
    name?: string | null; 
    shop?: Shop | null; 
  }

  export type Shop = {
    __typename?: "core_apimessages_Shop";
    name?: string | null; 
    slug?: string | null; 
  }

  export type AmountTotal = {
    __typename?: "core_apimessages_Money";
    amount?: string | null; 
    amountCents?: number | null; 
    currency?: string | null; 
    symbol?: string | null; 
    display?: string | null; 
  }

  export type ShippedAt = {
    __typename?: "google_protobuf_Timestamp";
    seconds?: number | null; 
  }

  export type CreatedAt = {
    __typename?: "google_protobuf_Timestamp";
    seconds?: number | null; 
  }

  export type Listing = {
    __typename?: "Listing";
    _id?: string | null; 
    id?: string | null; 
    slug?: string | null; 
    title?: string | null; 
    merchandisingType?: string | null; 
    shopUuid?: string | null; 
    images?: (Images | null)[] | null; 
  }

  export type Images = {
    __typename?: "core_apimessages_Image";
    source?: string | null; 
  }
}
export namespace CoreMyAccountCreditCardsLayout {
  export type Variables = {
  }

  export type Query = {
    __typename?: "Query";
    me?: Me | null; 
  }

  export type Me = {
    __typename?: "rql_Me";
    uuid?: string | null; 
  } & MyAccountCreditCardListFields.Fragment
}
export namespace CoreAdaChatTokenQuery {
  export type Variables = {
  }

  export type Query = {
    __typename?: "Query";
    me?: Me | null; 
  }

  export type Me = {
    __typename?: "rql_Me";
    id?: string | null; 
    uuid?: string | null; 
    adaChatToken?: AdaChatToken | null; 
  }

  export type AdaChatToken = {
    __typename?: "core_apimessages_AdaChatTokenResponse";
    token?: string | null; 
  }
}
export namespace MeRecommendedListingsGrid {
  export type Variables = {
    query?: string | null;
    currency?: string | null;
    priceMax?: string | null;
    priceMin?: string | null;
    decades?: (string | null)[] | null;
    yearMax?: string | null;
    yearMin?: string | null;
    sortSlug?: string | null;
    limit?: number | null;
    offset?: number | null;
    categorySlugs?: (string | null)[] | null;
    brandSlugs?: (string | null)[] | null;
    aggs?: (reverb_search_ListingsSearchRequest_Aggregation | null)[] | null;
    conditionSlugs?: (string | null)[] | null;
    onSale?: boolean | null;
    handmade?: boolean | null;
    freeShipping?: boolean | null;
    freeExpeditedShipping?: boolean | null;
    acceptsOffers?: boolean | null;
    acceptsGiftCards?: boolean | null;
    preferredSeller?: boolean | null;
    acceptsPaymentPlans?: boolean | null;
    itemRegion?: string | null;
    shippingRegionCode?: (string | null)[] | null;
    showOnlySold?: boolean | null;
    showSold?: boolean | null;
    traitValues?: (string | null)[] | null;
    itemState?: (string | null)[] | null;
    itemCity?: (string | null)[] | null;
    shopSlug?: string | null;
    curatedSetSlugs?: (string | null)[] | null;
    saleSlugs?: (string | null)[] | null;
    cspSlug?: string | null;
    sort?: reverb_search_ListingsSearchRequest_Sort | null;
    combinedShipping?: boolean | null;
    acceptsAffirm?: boolean | null;
    terminateEarly?: boolean | null;
    collapsible?: reverb_search_ListingsSearchRequest_Collapsible | null;
    fallbackToOr?: boolean | null;
    withProximityFilter?: Input_reverb_search_ProximityFilterRequest | null;
    localPickup?: boolean | null;
    shouldSkipTracking: boolean;
    version?: number | null;
  }

  export type Query = {
    __typename?: "Query";
    me?: Me | null; 
  }

  export type Me = {
    __typename?: "rql_Me";
    uuid?: string | null; 
    recommendedListings?: RecommendedListings | null; 
  }

  export type RecommendedListings = {
    __typename?: "reverb_search_SearchResponse";
    total?: number | null; 
    offset?: number | null; 
    limit?: number | null; 
    filters?: (Filters | null)[] | null; 
    listings?: (Listings | null)[] | null; 
  }

  export type Filters =NestedFilter.Fragment

  export type Listings = {
    __typename?: "Listing";
    _id?: string | null; 
  } & ListingsCollection.Fragment & mParticleListingFields.Fragment
}
export namespace MeRecommendedListings {
  export type Variables = {
    limit?: number | null;
    offset?: number | null;
    shouldSkipTracking: boolean;
    version?: number | null;
  }

  export type Query = {
    __typename?: "Query";
    me?: Me | null; 
  }

  export type Me = {
    __typename?: "rql_Me";
    uuid?: string | null; 
    recommendedListings?: RecommendedListings | null; 
  }

  export type RecommendedListings = {
    __typename?: "reverb_search_SearchResponse";
    listings?: (Listings | null)[] | null; 
  }

  export type Listings = {
    __typename?: "Listing";
    _id?: string | null; 
  } & ListingsCollection.Fragment & mParticleListingFields.Fragment
}
export namespace CoreCheckoutFetchDigitalWalletPaymentCheckout {
  export type Variables = {
    id?: string | null;
    reverbApp?: string | null;
  }

  export type Query = {
    __typename?: "Query";
    checkout?: Checkout | null; 
  }

  export type Checkout = {
    __typename?: "Checkout";
    _id?: string | null; 
    action?: Action | null; 
    status?: core_apimessages_Checkout_Status | null; 
    paymentErrorMessage?: string | null; 
    orderBundle?: OrderBundle | null; 
  }

  export type Action = {
    __typename?: "CheckoutAction";
    _id?: string | null; 
    type?: core_apimessages_CheckoutAction_Type | null; 
    redirectUrl?: string | null; 
  }

  export type OrderBundle = {
    __typename?: "OrderBundle";
    _id?: string | null; 
    id?: string | null; 
  }
}
export namespace Item2SellerReviews {
  export type Variables = {
    sellerUuid?: string | null;
    type?: core_apimessages_Feedback_Type | null;
    limit?: number | null;
    offset?: number | null;
  }

  export type Query = {
    __typename?: "Query";
    user?: User | null; 
  }

  export type User = {
    __typename?: "User";
    _id?: string | null; 
    feedback?: Feedback | null; 
    shop?: Shop | null; 
  }

  export type Feedback = {
    __typename?: "core_apimessages_FeedbacksResponse";
    total?: number | null; 
    feedbacks?: (Feedbacks | null)[] | null; 
  }

  export type Feedbacks =Item2FeedbackItemData.Fragment

  export type Shop = {
    __typename?: "core_apimessages_Shop";
    slug?: string | null; 
  }
}
export namespace CoreCategoryTopProducts {
  export type Variables = {
    currentCategorySlugs?: (string | null)[] | null;
    categoryUUIDs?: (string | null)[] | null;
    bestSellerThreshold?: number | null;
  }

  export type Query = {
    __typename?: "Query";
    categories?: (Categories | null)[] | null; 
    cspSearch?: CspSearch | null; 
  }

  export type Categories = {
    __typename?: "Category";
    _id?: string | null; 
  } & TopProductsCategory.Fragment

  export type CspSearch = {
    __typename?: "reverb_search_SearchResponse";
    csps?: (Csps | null)[] | null; 
  }

  export type Csps = {
    __typename?: "CSP";
    _id?: string | null; 
  } & TopProductsCSP.Fragment
}
export namespace GetBillingMethod {
  export type Variables = {
  }

  export type Query = {
    __typename?: "Query";
    countries?: Countries | null; 
    me?: Me | null; 
  }

  export type Countries = {
    __typename?: "core_apimessages_CountriesResponse";
    countries?: (_Countries | null)[] | null; 
  }

  export type _Countries = {
    __typename?: "core_apimessages_Country";
    name?: string | null; 
    countryCode?: string | null; 
    subregions?: (Subregions | null)[] | null; 
  }

  export type Subregions = {
    __typename?: "core_apimessages_Subregion";
    name?: string | null; 
    code?: string | null; 
  }

  export type Me =myShopBillingMethods.Fragment
}
export namespace UpdateMyShopBillingMethod {
  export type Variables = {
    input?: Input_core_apimessages_UpdateBillingMethodRequest | null;
  }

  export type Mutation = {
    __typename?: "Mutation";
    updateMyShopBillingMethod?: UpdateMyShopBillingMethod | null; 
  }

  export type UpdateMyShopBillingMethod = {
    __typename?: "core_apimessages_UpdateBillingMethodResponse";
    errors?: (Errors | null)[] | null; 
    creditCard?: CreditCard | null; 
    adyenPaymentResult?: AdyenPaymentResult | null; 
    billingMethodUuid?: string | null; 
    me?: Me | null; 
  }

  export type Errors = {
    __typename?: "core_apimessages_Error";
    message?: string | null; 
  }

  export type CreditCard = {
    __typename?: "core_apimessages_CreditCard";
    id?: string | null; 
  }

  export type AdyenPaymentResult = {
    __typename?: "core_apimessages_AdyenPaymentResult";
    action?: string | null; 
    paymentStatus?: core_apimessages_AdyenPaymentResult_PaymentStatus | null; 
    fingerprintToken?: string | null; 
    challengeToken?: string | null; 
    paymentData?: string | null; 
    threeDsOneData?: ThreeDsOneData | null; 
  }

  export type ThreeDsOneData = {
    __typename?: "core_apimessages_ThreeDSOneData";
    paReq?: string | null; 
    md?: string | null; 
    termUrl?: string | null; 
    redirectUrl?: string | null; 
  }

  export type Me =myShopBillingMethods.Fragment
}
export namespace CoreCreditCardWalletCreateMyCreditCard {
  export type Variables = {
    input?: Input_core_apimessages_CreateMyCreditCardRequest | null;
  }

  export type Mutation = {
    __typename?: "Mutation";
    createMyCreditCard?: CreateMyCreditCard | null; 
  }

  export type CreateMyCreditCard = {
    __typename?: "core_apimessages_CreateMyCreditCardResponse";
    creditCard?: CreditCard | null; 
  }

  export type CreditCard = {
    __typename?: "core_apimessages_CreditCard";
    id?: string | null; 
  }
}
export namespace CoreCheckoutUpdateGuestCreditCard {
  export type Variables = {
    input?: Input_core_apimessages_UpdateCheckoutGuestCreditCardRequest | null;
  }

  export type Mutation = {
    __typename?: "Mutation";
    updateCheckoutGuestCreditCard?: UpdateCheckoutGuestCreditCard | null; 
  }

  export type UpdateCheckoutGuestCreditCard = {
    __typename?: "core_apimessages_UpdateCheckoutGuestCreditCardResponse";
    checkout?: Checkout | null; 
  }

  export type Checkout = {
    __typename?: "Checkout";
    _id?: string | null; 
  }
}
export namespace BillingMethodVerifyShopper {
  export type Variables = {
    input?: Input_core_apimessages_BillingMethodVerifyShopperRequest | null;
  }

  export type Mutation = {
    __typename?: "Mutation";
    billingMethodVerifyShopper?: BillingMethodVerifyShopper | null; 
  }

  export type BillingMethodVerifyShopper = {
    __typename?: "core_apimessages_BillingMethodVerifyShopperResponse";
    creditCard?: CreditCard | null; 
    billingMethodUuid?: string | null; 
    adyenPaymentResult?: AdyenPaymentResult | null; 
    me?: Me | null; 
  }

  export type CreditCard = {
    __typename?: "core_apimessages_CreditCard";
    id?: string | null; 
  }

  export type AdyenPaymentResult = {
    __typename?: "core_apimessages_AdyenPaymentResult";
    action?: string | null; 
    paymentStatus?: core_apimessages_AdyenPaymentResult_PaymentStatus | null; 
    challengeToken?: string | null; 
    paymentData?: string | null; 
  }

  export type Me =myShopBillingMethods.Fragment
}
export namespace CoreCheckoutSelectShippingAddress {
  export type Variables = {
    input?: Input_core_apimessages_CheckoutSelectShippingAddressRequest | null;
  }

  export type Mutation = {
    __typename?: "Mutation";
    selectCheckoutShippingAddress?: SelectCheckoutShippingAddress | null; 
  }

  export type SelectCheckoutShippingAddress = {
    __typename?: "core_apimessages_CheckoutSelectShippingAddressResponse";
    checkout?: Checkout | null; 
  }

  export type Checkout = {
    __typename?: "Checkout";
    _id?: string | null; 
  }
}
export namespace CoreCheckoutCreateKlarnaPaymentRedirectUrl {
  export type Variables = {
    input?: Input_core_apimessages_CheckoutCreatePaymentRedirectUrlRequest | null;
  }

  export type Mutation = {
    __typename?: "Mutation";
    createCheckoutPaymentRedirectUrl?: CreateCheckoutPaymentRedirectUrl | null; 
  }

  export type CreateCheckoutPaymentRedirectUrl = {
    __typename?: "core_apimessages_CheckoutCreatePaymentRedirectUrlResponse";
    checkout?: Checkout | null; 
    redirectUrl?: string | null; 
  }

  export type Checkout = {
    __typename?: "Checkout";
    _id?: string | null; 
  }
}
export namespace CoreItem2CspReviews {
  export type Variables = {
    limit?: number | null;
    id?: string | null;
    offset?: number | null;
  }

  export type Query = {
    __typename?: "Query";
    listing?: Listing | null; 
  }

  export type Listing = {
    __typename?: "Listing";
    _id?: string | null; 
    csp?: Csp | null; 
  }

  export type Csp = {
    __typename?: "CSP";
    _id?: string | null; 
    reviews?: Reviews | null; 
  } & CSPReviewCSP.Fragment

  export type Reviews =CSPReviews.Fragment
}
export namespace Item2PaymentOptionsData {
  export type Variables = {
    listingId?: string | null;
  }

  export type Query = {
    __typename?: "Query";
    listing?: Listing | null; 
  }

  export type Listing = {
    __typename?: "Listing";
    _id?: string | null; 
    acceptedPaymentMethods?: (string | null)[] | null; 
  }
}
export namespace CoreCheckoutUpdateShippingAddress {
  export type Variables = {
    input?: Input_core_apimessages_CheckoutUpdateShippingAddressRequest | null;
  }

  export type Mutation = {
    __typename?: "Mutation";
    updateCheckoutShippingAddress?: UpdateCheckoutShippingAddress | null; 
  }

  export type UpdateCheckoutShippingAddress = {
    __typename?: "core_apimessages_CheckoutUpdateShippingAddressResponse";
    checkout?: Checkout | null; 
  }

  export type Checkout = {
    __typename?: "Checkout";
    _id?: string | null; 
  }
}
export namespace Countries {
  export type Variables = {
  }

  export type Query = {
    __typename?: "Query";
    countries?: Countries | null; 
  }

  export type Countries = {
    __typename?: "core_apimessages_CountriesResponse";
    countries?: (_Countries | null)[] | null; 
  }

  export type _Countries = {
    __typename?: "core_apimessages_Country";
    name?: string | null; 
    countryCode?: string | null; 
    subregions?: (Subregions | null)[] | null; 
  }

  export type Subregions = {
    __typename?: "core_apimessages_Subregion";
    name?: string | null; 
    code?: string | null; 
  }
}
export namespace AddressBook {
  export type Variables = {
  }

  export type Query = {
    __typename?: "Query";
    countries?: Countries | null; 
    me?: Me | null; 
  }

  export type Countries = {
    __typename?: "core_apimessages_CountriesResponse";
    countries?: (_Countries | null)[] | null; 
  }

  export type _Countries = {
    __typename?: "core_apimessages_Country";
    name?: string | null; 
    countryCode?: string | null; 
    subregions?: (Subregions | null)[] | null; 
  }

  export type Subregions = {
    __typename?: "core_apimessages_Subregion";
    name?: string | null; 
    code?: string | null; 
  }

  export type Me = {
    __typename?: "rql_Me";
    uuid?: string | null; 
    shippingAddresses?: (ShippingAddresses | null)[] | null; 
  }

  export type ShippingAddresses = {
    __typename?: "core_apimessages_Address";
    uuid?: string | null; 
    name?: string | null; 
    streetAddress?: string | null; 
    extendedAddress?: string | null; 
    locality?: string | null; 
    region?: string | null; 
    regionName?: string | null; 
    postalCode?: string | null; 
    countryCode?: string | null; 
    country?: Country | null; 
    phone?: string | null; 
    primary?: boolean | null; 
    legacyId?: string | null; 
    isComplete?: boolean | null; 
  }

  export type Country = {
    __typename?: "core_apimessages_Country";
    countryCode?: string | null; 
    name?: string | null; 
  }
}
export namespace UpdateMyAddress {
  export type Variables = {
    input?: Input_core_apimessages_UpdateAddressRequest | null;
  }

  export type Mutation = {
    __typename?: "Mutation";
    updateMyAddress?: UpdateMyAddress | null; 
  }

  export type UpdateMyAddress = {
    __typename?: "core_apimessages_UpdateAddressResponse";
    address?: Address | null; 
  }

  export type Address = {
    __typename?: "core_apimessages_Address";
    uuid?: string | null; 
    name?: string | null; 
    streetAddress?: string | null; 
    extendedAddress?: string | null; 
    locality?: string | null; 
    region?: string | null; 
    regionName?: string | null; 
    postalCode?: string | null; 
    countryCode?: string | null; 
    country?: Country | null; 
    phone?: string | null; 
    primary?: boolean | null; 
    legacyId?: string | null; 
    isComplete?: boolean | null; 
  }

  export type Country = {
    __typename?: "core_apimessages_Country";
    countryCode?: string | null; 
    name?: string | null; 
  }
}
export namespace DeleteMyAddress {
  export type Variables = {
    input?: Input_core_apimessages_AddressDeleteRequest | null;
  }

  export type Mutation = {
    __typename?: "Mutation";
    deleteMyAddress?: DeleteMyAddress | null; 
  }

  export type DeleteMyAddress = {
    __typename?: "core_apimessages_DeleteResponse";
    uuid?: string | null; 
  }
}
export namespace CoreAddressSummary {
  export type Variables = {
    countriesOverride: boolean;
  }

  export type Query = {
    __typename?: "Query";
    countries?: Countries | null; 
    intlAddressFormConfig?: IntlAddressFormConfig | null; 
  }

  export type Countries = {
    __typename?: "core_apimessages_CountriesResponse";
    countries?: (_Countries | null)[] | null; 
  }

  export type _Countries = {
    __typename?: "core_apimessages_Country";
    name?: string | null; 
    countryCode?: string | null; 
    subregions?: (Subregions | null)[] | null; 
  }

  export type Subregions = {
    __typename?: "core_apimessages_Subregion";
    name?: string | null; 
    code?: string | null; 
  }

  export type IntlAddressFormConfig = {
    __typename?: "reverb_config_cache_InternationalAddressFormConfigResponse";
    configs?: (Configs | null)[] | null; 
  }

  export type Configs = {
    __typename?: "reverb_config_cache_AddressFormConfig";
    countryCode?: string | null; 
    fields?: (Fields | null)[] | null; 
  }

  export type Fields = {
    __typename?: "reverb_config_cache_AddressFormField";
    fieldName?: string | null; 
    displayNames?: (DisplayNames | null)[] | null; 
    required?: boolean | null; 
  }

  export type DisplayNames = {
    __typename?: "reverb_config_cache_LocalizedAddressFormDisplayName";
    locale?: string | null; 
    displayName?: string | null; 
  }
}
export namespace SearchPriceGuideToolTransactionTable {
  export type Variables = {
    canonicalProductIds?: (string | null)[] | null;
    sellerCountries?: (string | null)[] | null;
    conditionSlugs?: (string | null)[] | null;
    createdAfterDate?: string | null;
    actionableStatuses?: (string | null)[] | null;
    limit?: number | null;
    offset?: number | null;
  }

  export type Query = {
    __typename?: "Query";
    priceRecordsSearch?: PriceRecordsSearch | null; 
  }

  export type PriceRecordsSearch = {
    __typename?: "reverb_search_SearchResponse";
    priceRecords?: (PriceRecords | null)[] | null; 
    total?: number | null; 
    offset?: number | null; 
  }

  export type PriceRecords = {
    __typename?: "PublicPriceRecord";
    _id?: string | null; 
  } & TransactionTablePriceRecordsData.Fragment
}
export namespace SearchPriceGuideToolTransactionGraph {
  export type Variables = {
    canonicalProductIds?: (string | null)[] | null;
    sellerCountries?: (string | null)[] | null;
    conditionUuids?: (string | null)[] | null;
    createdAfterDate?: string | null;
    actionableStatuses?: (string | null)[] | null;
  }

  export type Query = {
    __typename?: "Query";
    priceRecordsSearch?: PriceRecordsSearch | null; 
  }

  export type PriceRecordsSearch = {
    __typename?: "reverb_search_SearchResponse";
    averageMonthlyProductPrices?: (AverageMonthlyProductPrices | null)[] | null; 
  }

  export type AverageMonthlyProductPrices = {
    __typename?: "reverb_search_AverageMonthlyProductPrice";
    date?: string | null; 
    docCount?: number | null; 
    averageProductPriceInUsd?: AverageProductPriceInUsd | null; 
  }

  export type AverageProductPriceInUsd = {
    __typename?: "reverb_search_Money";
    amountCents?: number | null; 
    currency?: string | null; 
  }
}
export namespace DataServicesPriceGuideToolEstimatesContainer {
  export type Variables = {
    priceRecommendationQueries?: (Input_reverb_pricing_PriceRecommendationQuery | null)[] | null;
  }

  export type Query = {
    __typename?: "Query";
    priceRecommendations?: PriceRecommendations | null; 
    exchangeRates?: ExchangeRates | null; 
  }

  export type PriceRecommendations = {
    __typename?: "reverb_pricing_PriceRecommendationsResponse";
    priceRecommendations?: (_PriceRecommendations | null)[] | null; 
  }

  export type _PriceRecommendations = {
    __typename?: "reverb_pricing_PriceRecommendation";
    priceLow?: PriceLow | null; 
    priceMiddle?: PriceMiddle | null; 
    priceHigh?: PriceHigh | null; 
    priceMiddleThirtyDaysAgo?: PriceMiddleThirtyDaysAgo | null; 
  }

  export type PriceLow = {
    __typename?: "reverb_pricing_Money";
    amountCents?: number | null; 
    currency?: string | null; 
  }

  export type PriceMiddle = {
    __typename?: "reverb_pricing_Money";
    amountCents?: number | null; 
    currency?: string | null; 
  }

  export type PriceHigh = {
    __typename?: "reverb_pricing_Money";
    amountCents?: number | null; 
    currency?: string | null; 
  }

  export type PriceMiddleThirtyDaysAgo = {
    __typename?: "reverb_pricing_Money";
    amountCents?: number | null; 
    currency?: string | null; 
  }

  export type ExchangeRates = {
    __typename?: "reverb_config_cache_CurrencyResponse";
    rates?: (Rates | null)[] | null; 
  }

  export type Rates = {
    __typename?: "reverb_config_cache_ExchangeRate";
    to?: string | null; 
    from?: string | null; 
    rate?: number | null; 
  }
}
export namespace CorePriceGuideToolFormContainer {
  export type Variables = {
    cspSlug?: string | null;
  }

  export type Query = {
    __typename?: "Query";
    csp?: Csp | null; 
  }

  export type Csp = {
    __typename?: "CSP";
    _id?: string | null; 
  } & PriceGuideToolFormContainerData.Fragment
}
export namespace SearchPriceGuideToolGearCollectionItems {
  export type Variables = {
    canonicalProductIds?: (string | null)[] | null;
  }

  export type Query = {
    __typename?: "Query";
    gearCollectionItemsSearch?: GearCollectionItemsSearch | null; 
  }

  export type GearCollectionItemsSearch = {
    __typename?: "reverb_search_SearchResponse";
    gearCollectionItems?: (GearCollectionItems | null)[] | null; 
  }

  export type GearCollectionItems = {
    __typename?: "GearCollectionItem";
    _id?: string | null; 
    id?: string | null; 
  }
}
export namespace CoreRecentlyViewedCspsRow {
  export type Variables = {
  }

  export type Query = {
    __typename?: "Query";
    recentlyViewedListings?: (RecentlyViewedListings | null)[] | null; 
  }

  export type RecentlyViewedListings = {
    __typename?: "Listing";
    _id?: string | null; 
    csp?: Csp | null; 
  }

  export type Csp = {
    __typename?: "CSP";
    _id?: string | null; 
  } & CSPCard.Fragment
}
export namespace CoreCategoryBestSellersSearch {
  export type Variables = {
    categoryUuids?: (string | null)[] | null;
    bestSellerThreshold?: number | null;
  }

  export type Query = {
    __typename?: "Query";
    cspSearch?: CspSearch | null; 
  }

  export type CspSearch = {
    __typename?: "reverb_search_SearchResponse";
    resultIds?: (string | null)[] | null; 
  }
}
export namespace CoreCspLayoutQuery {
  export type Variables = {
    limit?: number | null;
    bumpLimit?: number | null;
    cspSlug?: string | null;
    hfid?: string | null;
    hfidPresent: boolean;
    shippingRegionCode?: string | null;
    shippingRegionCodes?: (string | null)[] | null;
    canonicalFinishes?: (string | null)[] | null;
    canonicalFinish?: string | null;
    offset?: number | null;
    traitValues?: (string | null)[] | null;
    fretboardMaterial?: string | null;
    includeFullFinancingFields: boolean;
    showListingLocation: boolean;
    itemRegion?: string | null;
    itemRegionRelation?: reverb_search_ListingItemRegionRelation | null;
    shouldHideBump: boolean;
    priceMin?: string | null;
    priceMax?: string | null;
    conditionSlugs?: (string | null)[] | null;
    aggs?: (reverb_search_ListingsSearchRequest_Aggregation | null)[] | null;
    query?: string | null;
    categorySlugs?: (string | null)[] | null;
    sortSlug?: string | null;
    sort?: reverb_search_ListingsSearchRequest_Sort | null;
    localPickup?: boolean | null;
    acceptsOffers?: boolean | null;
    onSale?: boolean | null;
    freeShipping?: boolean | null;
    freeExpeditedShipping?: boolean | null;
    combinedShipping?: boolean | null;
    acceptsPaymentPlans?: boolean | null;
    dealsAndSteals?: boolean | null;
    decades?: (string | null)[] | null;
    yearMax?: string | null;
    yearMin?: string | null;
    acceptsGiftCards?: boolean | null;
    preferredSeller?: boolean | null;
    acceptsAffirm?: boolean | null;
    withProximityFilter?: Input_reverb_search_ProximityFilterRequest | null;
    shouldSkipTracking: boolean;
    auctionType?: arbiter_AuctionType | null;
    userCurrency?: string | null;
    fallbackToEverywhereElse?: boolean | null;
  }

  export type Query = {
    __typename?: "Query";
    csp?: Csp | null; 
    allListings?: AllListings | null; 
    featuredListing?: FeaturedListing | null; 
    allBumped?: AllBumped | null; 
    hfid?: Hfid | null; 
    finishAgg?: FinishAgg | null; 
    fretboardMaterialAgg?: FretboardMaterialAgg | null; 
    exchangeRates?: ExchangeRates | null; 
  }

  export type Csp = {
    __typename?: "CSP";
    _id?: string | null; 
    id?: string | null; 
    title?: string | null; 
    summary?: string | null; 
    body?: string | null; 
    metaDescription?: string | null; 
    model?: string | null; 
    generic?: boolean | null; 
    finishes?: (string | null)[] | null; 
    brand?: Brand | null; 
    categories?: (Categories | null)[] | null; 
    videos?: Videos | null; 
    specs?: Specs | null; 
    supersize_images?: (SupersizeImages | null)[] | null; 
    large_images?: (LargeImages | null)[] | null; 
    hero_image?: (HeroImage | null)[] | null; 
    cspImage?: (CspImage | null)[] | null; 
    variants?: (Variants | null)[] | null; 
  } & CSPAdditionalTrackingFields.Fragment & CSPReviewJumplinksData.Fragment & FeaturedListingCSP.Fragment & CSPProductFamilyCTAData.Fragment

  export type Brand = {
    __typename?: "Brand";
    _id?: string | null; 
    name?: string | null; 
    slug?: string | null; 
    webLink?: WebLink | null; 
  }

  export type WebLink = {
    __typename?: "core_apimessages_Link";
    href?: string | null; 
  }

  export type Categories = {
    __typename?: "Category";
    _id?: string | null; 
    id?: string | null; 
    name?: string | null; 
    slug?: string | null; 
    webLink?: _WebLink | null; 
    cmsUrl?: CmsUrl | null; 
    parentCategories?: (ParentCategories | null)[] | null; 
  }

  export type _WebLink = {
    __typename?: "core_apimessages_Link";
    href?: string | null; 
  }

  export type CmsUrl = {
    __typename?: "core_apimessages_Link";
    href?: string | null; 
  }

  export type ParentCategories = {
    __typename?: "Category";
    _id?: string | null; 
    id?: string | null; 
    name?: string | null; 
    slug?: string | null; 
    rootSlug?: string | null; 
    webLink?: __WebLink | null; 
    cmsUrl?: _CmsUrl | null; 
  }

  export type __WebLink = {
    __typename?: "core_apimessages_Link";
    href?: string | null; 
  }

  export type _CmsUrl = {
    __typename?: "core_apimessages_Link";
    href?: string | null; 
  }

  export type Videos = {
    __typename?: "core_apimessages_CSPVideo";
    videoLinks?: (VideoLinks | null)[] | null; 
  }

  export type VideoLinks = {
    __typename?: "core_apimessages_VideoLink";
    youtubeLink?: string | null; 
    youtubeVideoId?: string | null; 
  }

  export type Specs = {
    __typename?: "core_apimessages_CSPSpec";
    productSpecs?: (ProductSpecs | null)[] | null; 
  }

  export type ProductSpecs = {
    __typename?: "core_apimessages_ProductSpec";
    type?: core_apimessages_ProductSpec_Type | null; 
    name?: string | null; 
    path?: string | null; 
    value?: string | null; 
  }

  export type SupersizeImages = {
    __typename?: "core_apimessages_Image";
    source?: string | null; 
  }

  export type LargeImages = {
    __typename?: "core_apimessages_Image";
    source?: string | null; 
  }

  export type HeroImage = {
    __typename?: "core_apimessages_Image";
    source?: string | null; 
  }

  export type CspImage = {
    __typename?: "core_apimessages_Image";
    source?: string | null; 
  }

  export type Variants = {
    __typename?: "core_apimessages_CspVariant";
    id?: string | null; 
  }

  export type AllListings = {
    __typename?: "reverb_search_SearchResponse";
    total?: number | null; 
    offset?: number | null; 
    listings?: (Listings | null)[] | null; 
    fallbackListings?: (FallbackListings | null)[] | null; 
    filters?: (Filters | null)[] | null; 
  }

  export type Listings = {
    __typename?: "Listing";
    _id?: string | null; 
  } & ListingData.Fragment & ListingsCollection.Fragment & mParticleListingFields.Fragment & FullFinancingFields.Fragment

  export type FallbackListings = {
    __typename?: "Listing";
    _id?: string | null; 
  } & ListingData.Fragment & ListingsCollection.Fragment & mParticleListingFields.Fragment & FullFinancingFields.Fragment

  export type Filters =NestedFilter.Fragment

  export type FeaturedListing = {
    __typename?: "arbiter_FeaturedListingResponse";
    listing?: Listing | null; 
  }

  export type Listing = {
    __typename?: "Listing";
    _id?: string | null; 
  } & ListingData.Fragment & ListingsCollection.Fragment & mParticleListingFields.Fragment & FullFinancingFields.Fragment & ShopFields.Fragment & BumpKey.Fragment & FeaturedListingWithPrice.Fragment

  export type AllBumped = {
    __typename?: "ListingCollection";
    listings?: (_Listings | null)[] | null; 
  }

  export type _Listings = {
    __typename?: "Listing";
    _id?: string | null; 
  } & ListingData.Fragment & ListingsCollection.Fragment & mParticleListingFields.Fragment & FullFinancingFields.Fragment & BumpKey.Fragment

  export type Hfid = {
    __typename?: "Listing";
    _id?: string | null; 
  } & ListingData.Fragment & ListingsCollection.Fragment & mParticleListingFields.Fragment & FullFinancingFields.Fragment & BumpKey.Fragment & FeaturedListingWithPrice.Fragment

  export type FinishAgg = {
    __typename?: "reverb_search_ListingsAggregationResponse";
    aggregationResults?: (AggregationResults | null)[] | null; 
  }

  export type AggregationResults = {
    __typename?: "reverb_search_AggregationResult";
    name?: reverb_search_ListingsSearchRequest_Aggregation | null; 
    aggregationDetails?: (AggregationDetails | null)[] | null; 
  }

  export type AggregationDetails = {
    __typename?: "reverb_search_AggregationDetails";
    key?: string | null; 
    count?: number | null; 
  }

  export type FretboardMaterialAgg = {
    __typename?: "reverb_search_ListingsAggregationResponse";
    aggregationResults?: (_AggregationResults | null)[] | null; 
  }

  export type _AggregationResults = {
    __typename?: "reverb_search_AggregationResult";
    name?: reverb_search_ListingsSearchRequest_Aggregation | null; 
    displayName?: string | null; 
    aggregationDetails?: (_AggregationDetails | null)[] | null; 
  }

  export type _AggregationDetails = {
    __typename?: "reverb_search_AggregationDetails";
    key?: string | null; 
    displayName?: string | null; 
    count?: number | null; 
  }

  export type ExchangeRates = {
    __typename?: "reverb_config_cache_CurrencyResponse";
    rates?: (Rates | null)[] | null; 
  }

  export type Rates = {
    __typename?: "reverb_config_cache_ExchangeRate";
    to?: string | null; 
    from?: string | null; 
    rate?: number | null; 
  }
}
export namespace Item2FeedbackMetadata {
  export type Variables = {
    sellerUuid?: string | null;
  }

  export type Query = {
    __typename?: "Query";
    user?: User | null; 
  }

  export type User = {
    __typename?: "User";
    _id?: string | null; 
    allTotal?: AllTotal | null; 
    buyerTotal?: BuyerTotal | null; 
    sellerTotal?: SellerTotal | null; 
  }

  export type AllTotal = {
    __typename?: "core_apimessages_FeedbacksResponse";
    total?: number | null; 
  }

  export type BuyerTotal = {
    __typename?: "core_apimessages_FeedbacksResponse";
    total?: number | null; 
  }

  export type SellerTotal = {
    __typename?: "core_apimessages_FeedbacksResponse";
    total?: number | null; 
  }
}
export namespace CoreUpdateUniversalPromoCampaign {
  export type Variables = {
    input?: Input_core_apimessages_UpdateUniversalPromoCampaignRequest | null;
  }

  export type Mutation = {
    __typename?: "Mutation";
    updateUniversalPromoCampaign?: UpdateUniversalPromoCampaign | null; 
  }

  export type UpdateUniversalPromoCampaign = {
    __typename?: "core_apimessages_UpdateUniversalPromoCampaignResponse";
    universalPromoCampaign?: UniversalPromoCampaign | null; 
  }

  export type UniversalPromoCampaign = {
    __typename?: "core_apimessages_UniversalPromoCampaign";
    id?: string | null; 
  }
}
export namespace CoreUniversalPromoCampaign {
  export type Variables = {
    campaignId?: string | null;
  }

  export type Query = {
    __typename?: "Query";
    universalpromocampaign?: Universalpromocampaign | null; 
  }

  export type Universalpromocampaign = {
    __typename?: "UniversalPromoCampaign";
    _id?: string | null; 
    id?: string | null; 
    name?: string | null; 
    code?: string | null; 
    expiresAt?: Timestamp | null; 
    marketingChannel?: string | null; 
    newBuyer?: boolean | null; 
    categories?: (Categories | null)[] | null; 
    redemptionLimit?: number | null; 
    hasRedemptionLimit?: boolean | null; 
    universalPromoCurrencies?: (UniversalPromoCurrencies | null)[] | null; 
  }

  export type Categories = {
    __typename?: "core_apimessages_NodesCategory";
    id?: string | null; 
  }

  export type UniversalPromoCurrencies = {
    __typename?: "core_apimessages_UniversalPromoCurrency";
    amount?: Amount | null; 
    minPurchaseAmount?: MinPurchaseAmount | null; 
  }

  export type Amount = {
    __typename?: "core_apimessages_Money";
    currency?: string | null; 
    amount?: string | null; 
  }

  export type MinPurchaseAmount = {
    __typename?: "core_apimessages_Money";
    currency?: string | null; 
    amount?: string | null; 
  }
}
export namespace CoreExchangeRates {
  export type Variables = {
  }

  export type Query = {
    __typename?: "Query";
    exchangeRates?: ExchangeRates | null; 
  }

  export type ExchangeRates = {
    __typename?: "reverb_config_cache_CurrencyResponse";
    rates?: (Rates | null)[] | null; 
  }

  export type Rates = {
    __typename?: "reverb_config_cache_ExchangeRate";
    from?: string | null; 
    to?: string | null; 
    rate?: number | null; 
  }
}
export namespace CombinedMarketplaceBumpTracking {
  export type Variables = {
    input?: Input_arbiter_BulkTrackImpressionsRequest | null;
  }

  export type Mutation = {
    __typename?: "Mutation";
    bulkTrackImpressions?: BulkTrackImpressions | null; 
  }

  export type BulkTrackImpressions = {
    __typename?: "arbiter_BulkTrackImpressionsResponse";
    listingIds?: (string | null)[] | null; 
  }
}
export namespace CoreMarketplaceCombinedMarketplaceSearch {
  export type Variables = {
    query?: string | null;
    currency?: string | null;
    priceMax?: string | null;
    priceMin?: string | null;
    decades?: (string | null)[] | null;
    yearMax?: string | null;
    yearMin?: string | null;
    sortSlug?: string | null;
    limit?: number | null;
    offset?: number | null;
    categorySlugs?: (string | null)[] | null;
    brandSlugs?: (string | null)[] | null;
    aggs?: (reverb_search_ListingsSearchRequest_Aggregation | null)[] | null;
    conditionSlugs?: (string | null)[] | null;
    onSale?: boolean | null;
    holidaySale?: boolean | null;
    handmade?: boolean | null;
    freeShipping?: boolean | null;
    freeExpeditedShipping?: boolean | null;
    acceptsOffers?: boolean | null;
    acceptsGiftCards?: boolean | null;
    preferredSeller?: boolean | null;
    acceptsPaymentPlans?: boolean | null;
    itemRegion?: string | null;
    bumpedItemRegion?: string | null;
    shippingRegionCode?: (string | null)[] | null;
    showOnlySold?: boolean | null;
    showSold?: boolean | null;
    traitValues?: (string | null)[] | null;
    itemState?: (string | null)[] | null;
    itemCity?: (string | null)[] | null;
    shopSlug?: string | null;
    curatedSetSlugs?: (string | null)[] | null;
    saleSlugs?: (string | null)[] | null;
    cspSlug?: string | null;
    boostByBumpRate?: boolean | null;
    bumpCount?: number | null;
    bumpOffset?: number | null;
    bumpLimit?: number | null;
    sort?: reverb_search_ListingsSearchRequest_Sort | null;
    combinedShipping?: boolean | null;
    acceptsAffirm?: boolean | null;
    terminateEarly?: boolean | null;
    fallbackToOr?: boolean | null;
    shouldntLoadBumps: boolean;
    withProximityFilter?: Input_reverb_search_ProximityFilterRequest | null;
    localPickup?: boolean | null;
    minSaleDiscountPercent?: string | null;
    useExperimentalQuery?: boolean | null;
    boostedItemRegionCode?: string | null;
    bestMatchSignalsV2ExperimentGroup?: number | null;
    ecsBoostExperimentGroup?: number | null;
    useExperimentalRecall?: boolean | null;
    shouldntLoadSuggestions: boolean;
    usingListView: boolean;
    mpTotalPriceExperimentGroup?: number | null;
    useTotalPrice?: boolean | null;
    countryOfOrigin?: (string | null)[] | null;
    contexts?: (reverb_search_Context | null)[] | null;
    autodirects?: reverb_search_Autodirects | null;
    excludeLocalPickupOnly?: boolean | null;
    dealsAndSteals?: boolean | null;
    signalGroups?: (reverb_signals_Signal_Group | null)[] | null;
    useSignalSystem: boolean;
    multiClientExperiments?: (Input_reverb_search_ExperimentData | null)[] | null;
  }

  export type Query = {
    __typename?: "Query";
    bumpedSearch?: BumpedSearch | null; 
    aggsSearch?: AggsSearch | null; 
    listingsSearch?: ListingsSearch | null; 
  }

  export type BumpedSearch = {
    __typename?: "reverb_search_SearchResponse";
    listings?: (Listings | null)[] | null; 
  }

  export type Listings = {
    __typename?: "Listing";
    _id?: string | null; 
    signals?: (Signals | null)[] | null; 
  } & ListingCardFields.Fragment & WatchBadgeData.Fragment & BumpKey.Fragment & ShopFields.Fragment & ListViewListings.Fragment

  export type Signals =ListingCardSignalsData.Fragment

  export type AggsSearch = {
    __typename?: "reverb_search_SearchResponse";
    filters?: (Filters | null)[] | null; 
  }

  export type Filters =NestedFilter.Fragment

  export type ListingsSearch = {
    __typename?: "reverb_search_SearchResponse";
    total?: number | null; 
    offset?: number | null; 
    limit?: number | null; 
    suggestedQueries?: (string | null)[] | null; 
    eligibleAutodirects?: (reverb_search_Autodirects | null)[] | null; 
    listings?: (_Listings | null)[] | null; 
    fallbackListings?: (FallbackListings | null)[] | null; 
    suggestions?: (Suggestions | null)[] | null; 
  }

  export type _Listings = {
    __typename?: "Listing";
    _id?: string | null; 
    signals?: (_Signals | null)[] | null; 
  } & ListingCardFields.Fragment & WatchBadgeData.Fragment & InOtherCartsCardData.Fragment & ShopFields.Fragment & ListViewListings.Fragment

  export type _Signals =ListingCardSignalsData.Fragment

  export type FallbackListings = {
    __typename?: "Listing";
    _id?: string | null; 
    signals?: (__Signals | null)[] | null; 
  } & ListingCardFields.Fragment & InOtherCartsCardData.Fragment & WatchBadgeData.Fragment

  export type __Signals =ListingCardSignalsData.Fragment

  export type Suggestions =MarketplaceSuggestions.Fragment
}
export namespace CoreMarketplaceHeader {
  export type Variables = {
    collectionType?: core_apimessages_CollectionHeader_CollectionType | null;
    collectionSlug?: string | null;
    skipCollectionHeader: boolean;
    categorySlugs?: (string | null)[] | null;
    brandSlugs?: (string | null)[] | null;
    conditionSlugs?: (string | null)[] | null;
    curatedSetSlug?: string | null;
    shopSlug?: string | null;
    yearMin?: string | null;
    yearMax?: string | null;
    query?: string | null;
  }

  export type Query = {
    __typename?: "Query";
    collectionHeader?: CollectionHeader | null; 
    searchMetadata?: SearchMetadata | null; 
  }

  export type CollectionHeader = {
    __typename?: "CollectionHeader";
    _id?: string | null; 
  } & CollectionInfo.Fragment

  export type SearchMetadata = {
    __typename?: "core_apimessages_SearchMetadataResponse";
    title?: string | null; 
  }
}
export namespace CoreShopMarketplace {
  export type Variables = {
    shop?: string | null;
  }

  export type Query = {
    __typename?: "Query";
    shop?: Shop | null; 
  }

  export type Shop = {
    __typename?: "Shop";
    _id?: string | null; 
    name?: string | null; 
    id?: string | null; 
    userId?: string | null; 
    onVacation?: boolean | null; 
    showSold?: boolean | null; 
  }
}
export namespace CoreAddressFormFieldsConfigsQuery {
  export type Variables = {
  }

  export type Query = {
    __typename?: "Query";
    intlAddressFormConfig?: IntlAddressFormConfig | null; 
  }

  export type IntlAddressFormConfig = {
    __typename?: "reverb_config_cache_InternationalAddressFormConfigResponse";
    configs?: (Configs | null)[] | null; 
  }

  export type Configs = {
    __typename?: "reverb_config_cache_AddressFormConfig";
    countryCode?: string | null; 
    fields?: (Fields | null)[] | null; 
  }

  export type Fields = {
    __typename?: "reverb_config_cache_AddressFormField";
    fieldName?: string | null; 
    displayNames?: (DisplayNames | null)[] | null; 
    required?: boolean | null; 
  }

  export type DisplayNames = {
    __typename?: "reverb_config_cache_LocalizedAddressFormDisplayName";
    locale?: string | null; 
    displayName?: string | null; 
  }
}
export namespace CoreSellerDashboardRevenue {
  export type Variables = {
    startDate?: string | null;
    endDate?: string | null;
    categorySlugs?: (string | null)[] | null;
    brandSlugs?: (string | null)[] | null;
    conditionSlugs?: (string | null)[] | null;
    soldWithBumpOnly?: boolean | null;
    soldWithoutBumpOnly?: boolean | null;
  }

  export type Query = {
    __typename?: "Query";
    me?: Me | null; 
  }

  export type Me = {
    __typename?: "rql_Me";
    uuid?: string | null; 
    shop?: Shop | null; 
  }

  export type Shop = {
    __typename?: "MyShop";
    _id?: string | null; 
    slug?: string | null; 
    interactions?: Interactions | null; 
    ordersSearch?: OrdersSearch | null; 
  }

  export type Interactions = {
    __typename?: "arbiter_SellerInteractionTimeSeriesResponse";
    click?: number | null; 
    addToCart?: number | null; 
    addToWatchlist?: number | null; 
    makeAnOffer?: number | null; 
    total?: number | null; 
  }

  export type OrdersSearch = {
    __typename?: "reverb_search_SearchResponse";
    orderMetrics?: OrderMetrics | null; 
    dateBuckets?: (DateBuckets | null)[] | null; 
    filters?: (Filters | null)[] | null; 
  }

  export type OrderMetrics = {
    __typename?: "reverb_search_OrderMetrics";
    orderCount?: number | null; 
    totalSellerRevenueAmount?: TotalSellerRevenueAmount | null; 
    totalBumpSpendAmount?: TotalBumpSpendAmount | null; 
  }

  export type TotalSellerRevenueAmount = {
    __typename?: "reverb_search_Money";
    cents?: number | null; 
    currency?: string | null; 
  }

  export type TotalBumpSpendAmount = {
    __typename?: "reverb_search_Money";
    currency?: string | null; 
    cents?: number | null; 
  }

  export type DateBuckets = {
    __typename?: "reverb_search_DateBucket";
    toDate?: string | null; 
    fromDate?: string | null; 
    metrics?: Metrics | null; 
  }

  export type Metrics = {
    __typename?: "reverb_search_OrderMetrics";
    totalSellerRevenueAmount?: _TotalSellerRevenueAmount | null; 
    totalBumpSpendAmount?: _TotalBumpSpendAmount | null; 
  }

  export type _TotalSellerRevenueAmount = {
    __typename?: "reverb_search_Money";
    cents?: number | null; 
    currency?: string | null; 
  }

  export type _TotalBumpSpendAmount = {
    __typename?: "reverb_search_Money";
    currency?: string | null; 
    cents?: number | null; 
  }

  export type Filters =NestedFilter.Fragment
}
export namespace CoreSellerDashboardListings {
  export type Variables = {
    shopSlug?: string | null;
    offset?: number | null;
    limit?: number | null;
    categorySlugs?: (string | null)[] | null;
    brandSlugs?: (string | null)[] | null;
    conditionSlugs?: (string | null)[] | null;
    query?: string | null;
  }

  export type Query = {
    __typename?: "Query";
    listingsSearch?: ListingsSearch | null; 
  }

  export type ListingsSearch = {
    __typename?: "reverb_search_SearchResponse";
    total?: number | null; 
    offset?: number | null; 
    limit?: number | null; 
    listings?: (Listings | null)[] | null; 
  }

  export type Listings = {
    __typename?: "Listing";
    _id?: string | null; 
  } & CoreSellerDashboardListing.Fragment
}
export namespace CoreBumpRecommendationListing {
  export type Variables = {
    id?: string | null;
  }

  export type Query = {
    __typename?: "Query";
    listing?: Listing | null; 
  }

  export type Listing = {
    __typename?: "Listing";
    _id?: string | null; 
  } & CoreBumpRecommendationListingCard.Fragment & BumpRecommendationsFragment.Fragment
}
export namespace CoreCheckoutUpdateOrderQuantity {
  export type Variables = {
    checkoutId?: string | null;
    listingId?: string | null;
    quantity?: number | null;
  }

  export type Mutation = {
    __typename?: "Mutation";
    editCheckoutCart?: EditCheckoutCart | null; 
  }

  export type EditCheckoutCart = {
    __typename?: "rql_CheckoutCartEditResponse";
    checkout?: Checkout | null; 
  }

  export type Checkout = {
    __typename?: "Checkout";
    _id?: string | null; 
  } & CheckoutOrderSummaryFields.Fragment
}
export namespace CoreCheckoutApplyDiscountCode {
  export type Variables = {
    input?: Input_core_apimessages_ApplyCheckoutDiscountCodeRequest | null;
  }

  export type Mutation = {
    __typename?: "Mutation";
    applyCheckoutDiscountCode?: ApplyCheckoutDiscountCode | null; 
  }

  export type ApplyCheckoutDiscountCode = {
    __typename?: "core_apimessages_ApplyCheckoutDiscountCodeResponse";
    checkout?: Checkout | null; 
  }

  export type Checkout = {
    __typename?: "Checkout";
    _id?: string | null; 
    id?: string | null; 
  } & CheckoutOrderSummaryFields.Fragment
}
export namespace CoreCheckoutSelectOrderShippingMethod {
  export type Variables = {
    input?: Input_core_apimessages_CheckoutSelectOrderShippingMethodRequest | null;
  }

  export type Mutation = {
    __typename?: "Mutation";
    selectCheckoutOrderShippingMethod?: SelectCheckoutOrderShippingMethod | null; 
  }

  export type SelectCheckoutOrderShippingMethod = {
    __typename?: "core_apimessages_CheckoutSelectOrderShippingMethodResponse";
    checkout?: Checkout | null; 
  }

  export type Checkout = {
    __typename?: "Checkout";
    _id?: string | null; 
    id?: string | null; 
    orders?: (Orders | null)[] | null; 
  } & CheckoutOrderSummaryFields.Fragment

  export type Orders = {
    __typename?: "core_apimessages_CheckoutOrder";
    listingId?: string | null; 
    shippingMethod?: ShippingMethod | null; 
  }

  export type ShippingMethod = {
    __typename?: "core_apimessages_CheckoutShippingMethod";
    name?: string | null; 
    type?: core_apimessages_ShippingMethod | null; 
  }
}
export namespace Item2ShopPolicies {
  export type Variables = {
    listingId?: string | null;
    euUser: boolean;
  }

  export type Query = {
    __typename?: "Query";
    listing?: Listing | null; 
  }

  export type Listing = {
    __typename?: "Listing";
    _id?: string | null; 
    shop?: Shop | null; 
  } & ShopPoliciesData.Fragment

  export type Shop = {
    __typename?: "Shop";
    _id?: string | null; 
    uuid?: string | null; 
  } & EUODRAddress.Fragment
}
export namespace CoreCheckoutShippingLayout {
  export type Variables = {
    id?: string | null;
    reverbApp?: string | null;
  }

  export type Query = {
    __typename?: "Query";
    countries?: Countries | null; 
    checkout?: Checkout | null; 
    me?: Me | null; 
  }

  export type Countries = {
    __typename?: "core_apimessages_CountriesResponse";
    countries?: (_Countries | null)[] | null; 
  }

  export type _Countries = {
    __typename?: "core_apimessages_Country";
    countryCode?: string | null; 
    name?: string | null; 
    subregionRequired?: boolean | null; 
    subregions?: (Subregions | null)[] | null; 
  }

  export type Subregions = {
    __typename?: "core_apimessages_Subregion";
    code?: string | null; 
    name?: string | null; 
  }

  export type Checkout = {
    __typename?: "Checkout";
    _id?: string | null; 
    action?: Action | null; 
  } & CheckoutShippingLayoutCheckoutFields.Fragment & CheckoutTrackingFields.Fragment

  export type Action = {
    __typename?: "CheckoutAction";
    _id?: string | null; 
  } & CheckoutActionHookFields.Fragment

  export type Me =CheckoutShippingLayoutMeFields.Fragment
}
export namespace SelectableCreditCardListQuery {
  export type Variables = {
  }

  export type Query = {
    __typename?: "Query";
    me?: Me | null; 
  }

  export type Me = {
    __typename?: "rql_Me";
    uuid?: string | null; 
    creditCards?: (CreditCards | null)[] | null; 
  }

  export type CreditCards = {
    __typename?: "core_apimessages_CreditCard";
    id?: string | null; 
    last4?: string | null; 
    cardType?: string | null; 
    expirationYear?: string | null; 
    expirationMonth?: string | null; 
    cardholderName?: string | null; 
    needsReverification?: boolean | null; 
    primaryForCheckout?: boolean | null; 
  }
}
export namespace AdyenOnboardingForm {
  export type Variables = {
  }

  export type Query = {
    __typename?: "Query";
    countries?: Countries | null; 
    me?: Me | null; 
  }

  export type Countries = {
    __typename?: "core_apimessages_CountriesResponse";
    countries?: (_Countries | null)[] | null; 
  }

  export type _Countries = {
    __typename?: "core_apimessages_Country";
    name?: string | null; 
    countryCode?: string | null; 
    subregions?: (Subregions | null)[] | null; 
  }

  export type Subregions = {
    __typename?: "core_apimessages_Subregion";
    name?: string | null; 
    code?: string | null; 
  }

  export type Me = {
    __typename?: "rql_Me";
    uuid?: string | null; 
    shop?: Shop | null; 
    creditCards?: (CreditCards | null)[] | null; 
  }

  export type Shop = {
    __typename?: "MyShop";
    _id?: string | null; 
    currency?: string | null; 
    originCountryCode?: string | null; 
    shopType?: core_apimessages_Shop_ShopType | null; 
    billingMethodStatus?: core_apimessages_MyShopOnboardingResponse_BillingMethodStatus | null; 
    paypalSetupStatus?: core_apimessages_MyShopOnboardingResponse_PaypalSetupStatus | null; 
    returnPolicy?: ReturnPolicy | null; 
    paypalProfile?: PaypalProfile | null; 
    kycAccountDetails?: KycAccountDetails | null; 
  }

  export type ReturnPolicy = {
    __typename?: "core_apimessages_ReturnPolicy";
    newReturnWindowDays?: number | null; 
    usedReturnWindowDays?: number | null; 
    restockingFeePercent?: number | null; 
    specialConditions?: string | null; 
  }

  export type PaypalProfile = {
    __typename?: "core_apimessages_MyShopPaypalProfileResponse_PaypalProfile";
    email?: string | null; 
  }

  export type KycAccountDetails = {
    __typename?: "core_apimessages_KYCAccountDetails";
    accountPhoneNumber?: AccountPhoneNumber | null; 
    accountHolderAddress?: AccountHolderAddress | null; 
    personalInformation?: (PersonalInformation | null)[] | null; 
    bankAccountOwnerName?: string | null; 
    maskedBankAccountNumber?: string | null; 
    bankAccountCountryCode?: string | null; 
    bankAccountCurrencyCode?: string | null; 
    bankAccountOwnerAddress?: BankAccountOwnerAddress | null; 
    businessTaxId?: string | null; 
    legalBusinessName?: string | null; 
    businessRegistrationNumber?: string | null; 
    parentCompanyDetails?: ParentCompanyDetails | null; 
  }

  export type AccountPhoneNumber = {
    __typename?: "core_apimessages_AdyenPhoneNumber";
    phoneNumber?: string | null; 
    countryCode?: string | null; 
  }

  export type AccountHolderAddress = {
    __typename?: "core_apimessages_KYCAddress";
    streetAddress?: string | null; 
    postalCode?: string | null; 
    region?: string | null; 
    locality?: string | null; 
    countryCode?: string | null; 
    houseNumber?: string | null; 
  }

  export type PersonalInformation = {
    __typename?: "core_apimessages_PersonalInformation";
    firstName?: string | null; 
    lastName?: string | null; 
    phoneNumber?: string | null; 
    idNumber?: string | null; 
    maskedIdNumber?: string | null; 
    dateOfBirth?: DateOfBirth | null; 
    shareholderType?: core_apimessages_PersonalInformation_AdyenShareholderType | null; 
    jobTitle?: string | null; 
  }

  export type DateOfBirth = {
    __typename?: "core_apimessages_Date";
    day?: string | null; 
    month?: string | null; 
    year?: string | null; 
  }

  export type BankAccountOwnerAddress = {
    __typename?: "core_apimessages_KYCAddress";
    streetAddress?: string | null; 
    postalCode?: string | null; 
    region?: string | null; 
    locality?: string | null; 
    countryCode?: string | null; 
    houseNumber?: string | null; 
  }

  export type ParentCompanyDetails = {
    __typename?: "core_apimessages_AdyenParentCompanyDetails";
    companyCode?: string | null; 
    countryCode?: string | null; 
    legalBusinessName?: string | null; 
    registrationNumber?: string | null; 
    stockExchange?: string | null; 
    stockNumber?: string | null; 
    stockTicker?: string | null; 
  }

  export type CreditCards = {
    __typename?: "core_apimessages_CreditCard";
    id?: string | null; 
    last4?: string | null; 
    cardType?: string | null; 
    expirationYear?: string | null; 
    expirationMonth?: string | null; 
    cardholderName?: string | null; 
  }
}
export namespace UpdateMyShop {
  export type Variables = {
    input?: Input_core_apimessages_UpdateMyShopRequest | null;
  }

  export type Mutation = {
    __typename?: "Mutation";
    updateMyShop?: UpdateMyShop | null; 
  }

  export type UpdateMyShop = {
    __typename?: "core_apimessages_UpdateMyShopResponse";
    errors?: (Errors | null)[] | null; 
  }

  export type Errors = {
    __typename?: "core_apimessages_Error";
    message?: string | null; 
  }
}
export namespace UpdateShopKyc {
  export type Variables = {
    input?: Input_core_apimessages_UpdateShopKYCRequest | null;
  }

  export type Mutation = {
    __typename?: "Mutation";
    updateShopKYC?: UpdateShopKyc | null; 
  }

  export type UpdateShopKyc = {
    __typename?: "core_apimessages_UpdateShopKYCResponse";
    errors?: (Errors | null)[] | null; 
  }

  export type Errors = {
    __typename?: "core_apimessages_Error";
    message?: string | null; 
  }
}
export namespace SetupShopPaymentMethods {
  export type Variables = {
    input?: Input_core_apimessages_SetupPaymentMethodsRequest | null;
  }

  export type Mutation = {
    __typename?: "Mutation";
    setupShopPaymentMethods?: SetupShopPaymentMethods | null; 
  }

  export type SetupShopPaymentMethods = {
    __typename?: "core_apimessages_SetupPaymentMethodsResponse";
    errors?: (Errors | null)[] | null; 
  }

  export type Errors = {
    __typename?: "core_apimessages_Error";
    message?: string | null; 
  }
}
export namespace RemoveFeedEntry {
  export type Variables = {
    input?: Input_reverb_feed_RemoveEntryRequest | null;
  }

  export type Mutation = {
    __typename?: "Mutation";
    removeFeedEntry?: RemoveFeedEntry | null; 
  }

  export type RemoveFeedEntry = {
    __typename?: "reverb_feed_RemoveEntryResponse";
    entry?: Entry | null; 
  }

  export type Entry = {
    __typename?: "reverb_feed_FeedEntry";
    id?: number | null; 
    type?: reverb_feed_FeedEntry_EntryType | null; 
    deleted?: boolean | null; 
  }
}
export namespace CoreHomePageFeed {
  export type Variables = {
    readFromDatabase?: boolean | null;
  }

  export type Query = {
    __typename?: "Query";
    me?: Me | null; 
  }

  export type Me = {
    __typename?: "rql_Me";
    uuid?: string | null; 
    feed?: Feed | null; 
  }

  export type Feed = {
    __typename?: "reverb_feed_FeedResponse";
    total?: number | null; 
    offset?: number | null; 
    limit?: number | null; 
    entries?: (Entries | null)[] | null; 
  }

  export type Entries = {
    __typename?: "reverb_feed_FeedEntry";
    entry?: Entry | null; 
  } & MixedFeedRow.Fragment

  export type Entry =ListingInlineFragment

  export type ListingInlineFragment = {
    __typename?: "Listing";
    _id?: string | null; 
  }
}
export namespace CoreFeedSearch {
  export type Variables = {
    query?: string | null;
    currency?: string | null;
    priceMax?: string | null;
    priceMin?: string | null;
    yearMax?: string | null;
    yearMin?: string | null;
    sortSlug?: string | null;
    limit?: number | null;
    offset?: number | null;
    categorySlugs?: (string | null)[] | null;
    brandSlugs?: (string | null)[] | null;
    aggs?: (reverb_search_ListingsSearchRequest_Aggregation | null)[] | null;
    conditionSlugs?: (string | null)[] | null;
    onSale?: boolean | null;
    handmade?: boolean | null;
    freeShipping?: boolean | null;
    freeExpeditedShipping?: boolean | null;
    acceptsOffers?: boolean | null;
    acceptsGiftCards?: boolean | null;
    preferredSeller?: boolean | null;
    acceptsPaymentPlans?: boolean | null;
    itemRegion?: string | null;
    shippingRegionCode?: (string | null)[] | null;
    decades?: (string | null)[] | null;
    readFromDatabase?: boolean | null;
    showListingLocation: boolean;
    dealsAndSteals?: boolean | null;
  }

  export type Query = {
    __typename?: "Query";
    me?: Me | null; 
  }

  export type Me = {
    __typename?: "rql_Me";
    uuid?: string | null; 
    follows?: Follows | null; 
    feed?: Feed | null; 
  }

  export type Follows = {
    __typename?: "reverb_feed_GetFollowsResponse";
    total?: number | null; 
  }

  export type Feed = {
    __typename?: "reverb_feed_FeedResponse";
    total?: number | null; 
    offset?: number | null; 
    limit?: number | null; 
    filters?: (Filters | null)[] | null; 
    entries?: (Entries | null)[] | null; 
  }

  export type Filters =NestedFilter.Fragment

  export type Entries = {
    __typename?: "reverb_feed_FeedEntry";
    entry?: Entry | null; 
  } & MixedFeedRow.Fragment

  export type Entry =ListingInlineFragment

  export type ListingInlineFragment = {
    __typename?: "Listing";
    _id?: string | null; 
  } & ShopFields.Fragment
}

export namespace Item2LoggedInOffersCountData {
  export type Fragment = {
    __typename?: "rql_Me";
    id?: string | null; 
    profile?: Profile | null; 
  }

  export type Profile = {
    __typename?: "mparticle_ProfileResponse";
    totalBuyerOffersCreated?: number | null; 
  }
}

export namespace SellerOfferListingFragment {
  export type Fragment = {
    __typename?: "Listing";
    _id?: string | null; 
    sellerPrice?: SellerPrice | null; 
    sellerCost?: SellerCost | null; 
  }

  export type SellerPrice = {
    __typename?: "core_apimessages_Money";
    amount?: string | null; 
    amountCents?: number | null; 
    currency?: string | null; 
    symbol?: string | null; 
    display?: string | null; 
  }

  export type SellerCost = {
    __typename?: "core_apimessages_Money";
    display?: string | null; 
  }
}

export namespace OfferListingFragment {
  export type Fragment = {
    __typename?: "Listing";
    _id?: string | null; 
    id?: string | null; 
    title?: string | null; 
    hasInventory?: boolean | null; 
    inventory?: number | null; 
    images?: (Images | null)[] | null; 
    condition?: Condition | null; 
    price?: Price | null; 
    taxIncluded?: boolean | null; 
    taxIncludedHint?: string | null; 
    shop?: Shop | null; 
    sale?: Sale | null; 
  }

  export type Images = {
    __typename?: "core_apimessages_Image";
    source?: string | null; 
  }

  export type Condition = {
    __typename?: "core_apimessages_Condition";
    displayName?: string | null; 
    conditionSlug?: string | null; 
  }

  export type Price = {
    __typename?: "core_apimessages_Money";
    amount?: string | null; 
    amountCents?: number | null; 
    currency?: string | null; 
    symbol?: string | null; 
    display?: string | null; 
  }

  export type Shop = {
    __typename?: "Shop";
    _id?: string | null; 
    name?: string | null; 
    currency?: string | null; 
    slug?: string | null; 
    address?: Address | null; 
  }

  export type Address = {
    __typename?: "core_apimessages_Address";
    displayLocation?: string | null; 
    locality?: string | null; 
    region?: string | null; 
    postalCode?: string | null; 
    countryCode?: string | null; 
  }

  export type Sale = {
    __typename?: "core_apimessages_Sale";
    id?: string | null; 
  }
}

export namespace AutoOfferListingFragment {
  export type Fragment = {
    __typename?: "Listing";
    _id?: string | null; 
    id?: string | null; 
    title?: string | null; 
    price?: Price | null; 
    condition?: Condition | null; 
    sellerCost?: SellerCost | null; 
    taxIncluded?: boolean | null; 
    taxIncludedHint?: string | null; 
    sellerPrice?: SellerPrice | null; 
    counts?: Counts | null; 
    autoOffers?: AutoOffers | null; 
  }

  export type Price = {
    __typename?: "core_apimessages_Money";
    amount?: string | null; 
    amountCents?: number | null; 
    currency?: string | null; 
    symbol?: string | null; 
    display?: string | null; 
  }

  export type Condition = {
    __typename?: "core_apimessages_Condition";
    displayName?: string | null; 
  }

  export type SellerCost = {
    __typename?: "core_apimessages_Money";
    display?: string | null; 
  }

  export type SellerPrice = {
    __typename?: "core_apimessages_Money";
    amountCents?: number | null; 
    display?: string | null; 
    currency?: string | null; 
  }

  export type Counts = {
    __typename?: "core_apimessages_ListingCounts";
    watchers?: number | null; 
  }

  export type AutoOffers = {
    __typename?: "core_apimessages_AutoOffer";
    id?: string | null; 
    listingId?: string | null; 
    message?: string | null; 
    price?: _Price | null; 
    percentage?: number | null; 
  }

  export type _Price = {
    __typename?: "core_apimessages_Money";
    amount?: string | null; 
    currency?: string | null; 
  }
}

export namespace Item2PriceWithShippingCartItemData {
  export type Fragment = {
    __typename?: "rql_Me";
    id?: string | null; 
    cart?: Cart | null; 
  }

  export type Cart = {
    __typename?: "rql_MyCart";
    cartItems?: (CartItems | null)[] | null; 
  }

  export type CartItems = {
    __typename?: "core_apimessages_CartItem";
    shopId?: string | null; 
    listingId?: string | null; 
    subtotal?: Subtotal | null; 
  }

  export type Subtotal = {
    __typename?: "core_apimessages_Money";
    amountCents?: number | null; 
    currency?: string | null; 
  }
}

export namespace Item2PriceWithShippingData {
  export type Fragment = {
    __typename?: "Listing";
    _id?: string | null; 
    id?: string | null; 
    state?: string | null; 
    stateDescription?: string | null; 
    taxIncluded?: boolean | null; 
    taxIncludedHint?: string | null; 
    listingType?: core_apimessages_Listing_ListingType | null; 
    pricing?: Pricing | null; 
    shop?: Shop | null; 
  } & ListingShippingDisplayData.Fragment

  export type Pricing = {
    __typename?: "core_apimessages_ListingPricing";
    originalPrice?: OriginalPrice | null; 
    ribbon?: Ribbon | null; 
    buyerPrice?: BuyerPrice | null; 
  }

  export type OriginalPrice = {
    __typename?: "core_apimessages_Money";
    display?: string | null; 
  }

  export type Ribbon = {
    __typename?: "core_apimessages_Ribbon";
    display?: string | null; 
  }

  export type BuyerPrice = {
    __typename?: "core_apimessages_Money";
    amountCents?: number | null; 
    currency?: string | null; 
    display?: string | null; 
  }

  export type Shop = {
    __typename?: "Shop";
    _id?: string | null; 
    id?: string | null; 
  }
}

export namespace CSPLightboxData {
  export type Fragment = {
    __typename?: "CSP";
    _id?: string | null; 
    squareImage?: (SquareImage | null)[] | null; 
    fullsizeImage?: (FullsizeImage | null)[] | null; 
    videos?: Videos | null; 
  }

  export type SquareImage = {
    __typename?: "core_apimessages_Image";
    source?: string | null; 
  }

  export type FullsizeImage = {
    __typename?: "core_apimessages_Image";
    source?: string | null; 
  }

  export type Videos = {
    __typename?: "core_apimessages_CSPVideo";
    videoLinks?: (VideoLinks | null)[] | null; 
  }

  export type VideoLinks = {
    __typename?: "core_apimessages_VideoLink";
    youtubeVideoId?: string | null; 
  }
}

export namespace NestedFilter {
  export type Fragment = {
    __typename?: "reverb_search_Filter";
    name?: string | null; 
    key?: string | null; 
    aggregationName?: string | null; 
    widgetType?: reverb_search_Filter_WidgetType | null; 
    options?: (Options | null)[] | null; 
  }

  export type Options = {
    __typename?: "reverb_search_FilterOption";
    count?: Count | null; 
    name?: string | null; 
    selected?: boolean | null; 
    autoselected?: boolean | null; 
    paramName?: string | null; 
    setValues?: (string | null)[] | null; 
    unsetValues?: (string | null)[] | null; 
    all?: boolean | null; 
    optionValue?: string | null; 
    trackingValue?: string | null; 
    subFilter?: SubFilter | null; 
  }

  export type Count = {
    __typename?: "google_protobuf_Int32Value";
    value?: number | null; 
  }

  export type SubFilter = {
    __typename?: "reverb_search_Filter";
    widgetType?: reverb_search_Filter_WidgetType | null; 
    options?: (_Options | null)[] | null; 
  }

  export type _Options = {
    __typename?: "reverb_search_FilterOption";
    count?: _Count | null; 
    name?: string | null; 
    selected?: boolean | null; 
    autoselected?: boolean | null; 
    paramName?: string | null; 
    setValues?: (string | null)[] | null; 
    unsetValues?: (string | null)[] | null; 
    all?: boolean | null; 
    optionValue?: string | null; 
    trackingValue?: string | null; 
    subFilter?: _SubFilter | null; 
  }

  export type _Count = {
    __typename?: "google_protobuf_Int32Value";
    value?: number | null; 
  }

  export type _SubFilter = {
    __typename?: "reverb_search_Filter";
    widgetType?: reverb_search_Filter_WidgetType | null; 
    options?: (__Options | null)[] | null; 
  }

  export type __Options = {
    __typename?: "reverb_search_FilterOption";
    count?: __Count | null; 
    name?: string | null; 
    selected?: boolean | null; 
    autoselected?: boolean | null; 
    paramName?: string | null; 
    setValues?: (string | null)[] | null; 
    unsetValues?: (string | null)[] | null; 
    all?: boolean | null; 
    optionValue?: string | null; 
    trackingValue?: string | null; 
  }

  export type __Count = {
    __typename?: "google_protobuf_Int32Value";
    value?: number | null; 
  }
}

export namespace FlatFilter {
  export type Fragment = {
    __typename?: "reverb_search_Filter";
    name?: string | null; 
    key?: string | null; 
    aggregationName?: string | null; 
    widgetType?: reverb_search_Filter_WidgetType | null; 
    options?: (Options | null)[] | null; 
  }

  export type Options = {
    __typename?: "reverb_search_FilterOption";
    count?: Count | null; 
    name?: string | null; 
    selected?: boolean | null; 
    paramName?: string | null; 
    setValues?: (string | null)[] | null; 
    unsetValues?: (string | null)[] | null; 
    all?: boolean | null; 
    optionValue?: string | null; 
  }

  export type Count = {
    __typename?: "google_protobuf_Int32Value";
    value?: number | null; 
  }
}

export namespace CSPPgCard {
  export type Fragment = {
    __typename?: "CSP";
    _id?: string | null; 
    title?: string | null; 
    webLink?: WebLink | null; 
    image?: Image | null; 
    inventory?: Inventory | null; 
    reviews?: Reviews | null; 
    specs?: Specs | null; 
  }

  export type WebLink = {
    __typename?: "core_apimessages_Link";
    path?: string | null; 
  }

  export type Image = {
    __typename?: "core_apimessages_Image";
    source?: string | null; 
  }

  export type Inventory = {
    __typename?: "core_apimessages_CSPInventory";
    newLowPrice?: NewLowPrice | null; 
    usedLowPrice?: UsedLowPrice | null; 
    usedTotal?: number | null; 
    newTotal?: number | null; 
  }

  export type NewLowPrice = {
    __typename?: "core_apimessages_Money";
    display?: string | null; 
    amountCents?: number | null; 
  }

  export type UsedLowPrice = {
    __typename?: "core_apimessages_Money";
    display?: string | null; 
    amountCents?: number | null; 
  }

  export type Reviews = {
    __typename?: "core_apimessages_CSPReviews";
    total?: number | null; 
    avgRating?: number | null; 
  }

  export type Specs = {
    __typename?: "core_apimessages_CSPSpec";
    productSpecs?: (ProductSpecs | null)[] | null; 
  }

  export type ProductSpecs = {
    __typename?: "core_apimessages_ProductSpec";
    type?: core_apimessages_ProductSpec_Type | null; 
    name?: string | null; 
    value?: string | null; 
    path?: string | null; 
  }
}

export namespace ListingShippingDisplayData {
  export type Fragment = {
    __typename?: "Listing";
    _id?: string | null; 
    shop?: Shop | null; 
    shipping?: Shipping | null; 
  }

  export type Shop = {
    __typename?: "Shop";
    _id?: string | null; 
    freeDomesticShippingRate?: FreeDomesticShippingRate | null; 
  }

  export type FreeDomesticShippingRate = {
    __typename?: "core_apimessages_ShippingRates";
    regionCode?: string | null; 
    freeShippingThreshold?: FreeShippingThreshold | null; 
  }

  export type FreeShippingThreshold = {
    __typename?: "core_apimessages_Money";
    amountCents?: number | null; 
    currency?: string | null; 
  }

  export type Shipping = {
    __typename?: "core_apimessages_ShippingPrices";
    freeExpeditedShipping?: boolean | null; 
    localPickupOnly?: boolean | null; 
    shippingPrices?: (ShippingPrices | null)[] | null; 
  }

  export type ShippingPrices = {
    __typename?: "core_apimessages_ShippingPrice";
    shippingMethod?: core_apimessages_ShippingMethod | null; 
    carrierCalculated?: boolean | null; 
    destinationPostalCodeNeeded?: boolean | null; 
    rate?: Rate | null; 
    regional?: boolean | null; 
  }

  export type Rate = {
    __typename?: "core_apimessages_Money";
    amount?: string | null; 
    amountCents?: number | null; 
    currency?: string | null; 
    display?: string | null; 
  }
}

export namespace SellerInfoData {
  export type Fragment = {
    __typename?: "Listing";
    _id?: string | null; 
    seller?: Seller | null; 
    shop?: Shop | null; 
  }

  export type Seller = {
    __typename?: "User";
    _id?: string | null; 
    feedbackSummary?: FeedbackSummary | null; 
  }

  export type FeedbackSummary = {
    __typename?: "core_apimessages_FeedbackSummary";
    receivedCount?: number | null; 
    rollingRatingPercentage?: number | null; 
  }

  export type Shop = {
    __typename?: "Shop";
    _id?: string | null; 
    name?: string | null; 
    slug?: string | null; 
    preferredSeller?: boolean | null; 
    quickShipper?: boolean | null; 
    quickResponder?: boolean | null; 
    address?: Address | null; 
  }

  export type Address = {
    __typename?: "core_apimessages_Address";
    displayLocation?: string | null; 
  }
}

export namespace ModalSidebarListingFragment {
  export type Fragment = {
    __typename?: "Listing";
    _id?: string | null; 
    id?: string | null; 
    title?: string | null; 
    slug?: string | null; 
    condition?: Condition | null; 
    images?: (Images | null)[] | null; 
  }

  export type Condition = {
    __typename?: "core_apimessages_Condition";
    displayName?: string | null; 
  }

  export type Images = {
    __typename?: "core_apimessages_Image";
    source?: string | null; 
  }
}

export namespace CSPAdditionalTrackingFields {
  export type Fragment = {
    __typename?: "CSP";
    _id?: string | null; 
    id?: string | null; 
    slug?: string | null; 
    brand?: Brand | null; 
    categories?: (Categories | null)[] | null; 
    inventory?: Inventory | null; 
  }

  export type Brand = {
    __typename?: "Brand";
    _id?: string | null; 
    slug?: string | null; 
  }

  export type Categories = {
    __typename?: "Category";
    _id?: string | null; 
    slug?: string | null; 
    rootSlug?: string | null; 
    parentCategories?: (ParentCategories | null)[] | null; 
  }

  export type ParentCategories = {
    __typename?: "Category";
    _id?: string | null; 
    slug?: string | null; 
  }

  export type Inventory = {
    __typename?: "core_apimessages_CSPInventory";
    usedTotal?: number | null; 
    newTotal?: number | null; 
  }
}

export namespace CSPCard {
  export type Fragment = {
    __typename?: "CSP";
    _id?: string | null; 
    id?: string | null; 
    title?: string | null; 
    slug?: string | null; 
    averageReviewRating?: number | null; 
    reviewsCount?: number | null; 
    webLink?: WebLink | null; 
    image?: Image | null; 
    brand?: Brand | null; 
    categories?: (Categories | null)[] | null; 
    inventory?: Inventory | null; 
    finishes?: (string | null)[] | null; 
  } & CSPAdditionalTrackingFields.Fragment

  export type WebLink = {
    __typename?: "core_apimessages_Link";
    path?: string | null; 
    href?: string | null; 
  }

  export type Image = {
    __typename?: "core_apimessages_Image";
    source?: string | null; 
  }

  export type Brand = {
    __typename?: "Brand";
    _id?: string | null; 
    slug?: string | null; 
    name?: string | null; 
  }

  export type Categories = {
    __typename?: "Category";
    _id?: string | null; 
    slug?: string | null; 
    rootSlug?: string | null; 
    name?: string | null; 
    parentCategories?: (ParentCategories | null)[] | null; 
  }

  export type ParentCategories = {
    __typename?: "Category";
    _id?: string | null; 
    name?: string | null; 
  }

  export type Inventory = {
    __typename?: "core_apimessages_CSPInventory";
    newLowPrice?: NewLowPrice | null; 
    usedLowPrice?: UsedLowPrice | null; 
    usedTotal?: number | null; 
    newTotal?: number | null; 
  }

  export type NewLowPrice = {
    __typename?: "core_apimessages_Money";
    display?: string | null; 
    amount?: string | null; 
    amountCents?: number | null; 
    currency?: string | null; 
  }

  export type UsedLowPrice = {
    __typename?: "core_apimessages_Money";
    display?: string | null; 
    amount?: string | null; 
    amountCents?: number | null; 
    currency?: string | null; 
  }
}

export namespace WatchBadgeData {
  export type Fragment = {
    __typename?: "Listing";
    _id?: string | null; 
    id?: string | null; 
    title?: string | null; 
    watching?: boolean | null; 
    watchThumbnails?: (WatchThumbnails | null)[] | null; 
  }

  export type WatchThumbnails = {
    __typename?: "core_apimessages_Image";
    source?: string | null; 
  }
}

export namespace mParticleListingFields {
  export type Fragment = {
    __typename?: "Listing";
    id?: string | null; 
    _id?: string | null; 
    title?: string | null; 
    brandSlug?: string | null; 
    categoryRootUuid?: string | null; 
    make?: string | null; 
    categoryUuids?: (string | null)[] | null; 
    state?: string | null; 
    listingType?: core_apimessages_Listing_ListingType | null; 
    bumpEligible?: boolean | null; 
    shopId?: string | null; 
    inventory?: number | null; 
    soldAsIs?: boolean | null; 
    acceptedPaymentMethods?: (string | null)[] | null; 
    currency?: string | null; 
    condition?: Condition | null; 
    categories?: (Categories | null)[] | null; 
    csp?: Csp | null; 
    pricing?: Pricing | null; 
    publishedAt?: PublishedAt | null; 
    sale?: Sale | null; 
    shipping?: Shipping | null; 
    shop?: Shop | null; 
  }

  export type Condition = {
    __typename?: "core_apimessages_Condition";
    conditionUuid?: string | null; 
    conditionSlug?: string | null; 
  }

  export type Categories = {
    __typename?: "Category";
    _id?: string | null; 
    slug?: string | null; 
    rootSlug?: string | null; 
  }

  export type Csp = {
    __typename?: "CSP";
    _id?: string | null; 
    id?: string | null; 
    slug?: string | null; 
    brand?: Brand | null; 
  }

  export type Brand = {
    __typename?: "Brand";
    _id?: string | null; 
    slug?: string | null; 
  }

  export type Pricing = {
    __typename?: "core_apimessages_ListingPricing";
    buyerPrice?: BuyerPrice | null; 
  }

  export type BuyerPrice = {
    __typename?: "core_apimessages_Money";
    amount?: string | null; 
    currency?: string | null; 
    amountCents?: number | null; 
  }

  export type PublishedAt = {
    __typename?: "google_protobuf_Timestamp";
    seconds?: number | null; 
  }

  export type Sale = {
    __typename?: "core_apimessages_Sale";
    code?: string | null; 
    buyerIneligibilityReason?: string | null; 
  }

  export type Shipping = {
    __typename?: "core_apimessages_ShippingPrices";
    shippingPrices?: (ShippingPrices | null)[] | null; 
    freeExpeditedShipping?: boolean | null; 
    localPickupOnly?: boolean | null; 
    localPickup?: boolean | null; 
  }

  export type ShippingPrices = {
    __typename?: "core_apimessages_ShippingPrice";
    shippingMethod?: core_apimessages_ShippingMethod | null; 
    carrierCalculated?: boolean | null; 
    destinationPostalCodeNeeded?: boolean | null; 
    rate?: Rate | null; 
  }

  export type Rate = {
    __typename?: "core_apimessages_Money";
    amount?: string | null; 
    amountCents?: number | null; 
    currency?: string | null; 
    display?: string | null; 
  }

  export type Shop = {
    __typename?: "Shop";
    _id?: string | null; 
    address?: Address | null; 
    returnPolicy?: ReturnPolicy | null; 
  }

  export type Address = {
    __typename?: "core_apimessages_Address";
    countryCode?: string | null; 
  }

  export type ReturnPolicy = {
    __typename?: "core_apimessages_ReturnPolicy";
    newReturnWindowDays?: number | null; 
    usedReturnWindowDays?: number | null; 
  }
}

export namespace ImageAdCreativeData {
  export type Fragment = {
    __typename?: "core_apimessages_ImageAdCreative";
    title?: string | null; 
    titleColor?: string | null; 
    subtitle?: string | null; 
    subtitleColor?: string | null; 
    ctaText?: string | null; 
    ctaHref?: string | null; 
    ctaTextColor?: string | null; 
    ctaButtonColor?: string | null; 
    backgroundImage?: string | null; 
    mobileBackgroundImage?: string | null; 
    backgroundColor?: string | null; 
    backgroundColors?: (string | null)[] | null; 
    overlayImage?: string | null; 
    description?: string | null; 
    partnershipText?: string | null; 
    hideAdCallout?: boolean | null; 
  }
}

export namespace AdCampaignData {
  export type Fragment = {
    __typename?: "AdCampaign";
    _id?: string | null; 
    uuid?: string | null; 
    name?: string | null; 
    status?: core_apimessages_AdCampaign_AdStatus | null; 
    startsAt?: Timestamp | null; 
    endsAt?: Timestamp | null; 
    advertiserUuid?: string | null; 
  }
}

export namespace AdData {
  export type Fragment = {
    __typename?: "core_apimessages_Ad";
    uuid?: string | null; 
    format?: core_apimessages_AdFormat | null; 
    adGroupUuid?: string | null; 
    adGroupName?: string | null; 
    adCampaignUuid?: string | null; 
    advertiserUuid?: string | null; 
  }
}

export namespace AdCspRowQueryData {
  export type Fragment = {
    __typename?: "core_apimessages_CspRowQuery";
    brandSlugs?: (string | null)[] | null; 
    categoryUuids?: (string | null)[] | null; 
    cspSlugs?: (string | null)[] | null; 
    rowTitle?: string | null; 
    sort?: string | null; 
  }
}

export namespace AdGroupWithoutKeywordsData {
  export type Fragment = {
    __typename?: "AdGroup";
    _id?: string | null; 
    uuid?: string | null; 
    name?: string | null; 
    adCampaignUuid?: string | null; 
    targetedCategoryUuids?: (string | null)[] | null; 
    targetedCountryCodes?: (string | null)[] | null; 
    targetedDevices?: (string | null)[] | null; 
    targetedBrandSlugs?: (string | null)[] | null; 
    targetedAdZones?: (TargetedAdZones | null)[] | null; 
  }

  export type TargetedAdZones = {
    __typename?: "core_apimessages_AdGroupZone";
    adZone?: AdZone | null; 
    startsAt?: Timestamp | null; 
    endsAt?: Timestamp | null; 
  }

  export type AdZone = {
    __typename?: "core_apimessages_AdZone";
    slug?: string | null; 
  }
}

export namespace AddToCartButtonData {
  export type Fragment = {
    __typename?: "Listing";
    _id?: string | null; 
    id?: string | null; 
    sellerId?: string | null; 
    preorderInfo?: PreorderInfo | null; 
  }

  export type PreorderInfo = {
    __typename?: "core_apimessages_PreorderInfo";
    onPreorder?: boolean | null; 
    estimatedShipDate?: EstimatedShipDate | null; 
  }

  export type EstimatedShipDate = {
    __typename?: "google_protobuf_Timestamp";
    seconds?: number | null; 
  }
}

export namespace ListingCardFields {
  export type Fragment = {
    __typename?: "Listing";
    _id?: string | null; 
    id?: string | null; 
    title?: string | null; 
    slug?: string | null; 
    listingType?: core_apimessages_Listing_ListingType | null; 
    upc?: string | null; 
    state?: string | null; 
    stateDescription?: string | null; 
    bumped?: boolean | null; 
    watching?: boolean | null; 
    soldAsIs?: boolean | null; 
    condition?: Condition | null; 
    pricing?: Pricing | null; 
    images?: (Images | null)[] | null; 
    shipping?: Shipping | null; 
    shop?: Shop | null; 
  } & ListingShippingDisplayData.Fragment & ListingGreatValueData.Fragment & WatchBadgeData.Fragment

  export type Condition = {
    __typename?: "core_apimessages_Condition";
    displayName?: string | null; 
    conditionSlug?: string | null; 
    conditionUuid?: string | null; 
  }

  export type Pricing = {
    __typename?: "core_apimessages_ListingPricing";
    buyerPrice?: BuyerPrice | null; 
    originalPrice?: OriginalPrice | null; 
    ribbon?: Ribbon | null; 
  }

  export type BuyerPrice = {
    __typename?: "core_apimessages_Money";
    display?: string | null; 
    currency?: string | null; 
    amount?: string | null; 
    amountCents?: number | null; 
  }

  export type OriginalPrice = {
    __typename?: "core_apimessages_Money";
    display?: string | null; 
  }

  export type Ribbon = {
    __typename?: "core_apimessages_Ribbon";
    display?: string | null; 
  }

  export type Images = {
    __typename?: "core_apimessages_Image";
    source?: string | null; 
  }

  export type Shipping = {
    __typename?: "core_apimessages_ShippingPrices";
    shippingPrices?: (ShippingPrices | null)[] | null; 
    freeExpeditedShipping?: boolean | null; 
    localPickupOnly?: boolean | null; 
    localPickup?: boolean | null; 
  }

  export type ShippingPrices = {
    __typename?: "core_apimessages_ShippingPrice";
    shippingMethod?: core_apimessages_ShippingMethod | null; 
    carrierCalculated?: boolean | null; 
    destinationPostalCodeNeeded?: boolean | null; 
    rate?: Rate | null; 
  }

  export type Rate = {
    __typename?: "core_apimessages_Money";
    amount?: string | null; 
    amountCents?: number | null; 
    currency?: string | null; 
    display?: string | null; 
  }

  export type Shop = {
    __typename?: "Shop";
    _id?: string | null; 
    returnPolicy?: ReturnPolicy | null; 
    address?: Address | null; 
  }

  export type ReturnPolicy = {
    __typename?: "core_apimessages_ReturnPolicy";
    usedReturnWindowDays?: number | null; 
    newReturnWindowDays?: number | null; 
  }

  export type Address = {
    __typename?: "core_apimessages_Address";
    locality?: string | null; 
    region?: string | null; 
    country?: Country | null; 
  }

  export type Country = {
    __typename?: "core_apimessages_Country";
    countryCode?: string | null; 
    name?: string | null; 
  }
}

export namespace InOtherCartsCardData {
  export type Fragment = {
    __typename?: "Listing";
    _id?: string | null; 
    id?: string | null; 
    otherBuyersWithListingInCartCounts?: number | null; 
  }
}

export namespace ListingsCollection {
  export type Fragment = {
    __typename?: "Listing";
    _id?: string | null; 
    id?: string | null; 
    bumped?: boolean | null; 
    categoryUuids?: (string | null)[] | null; 
    slug?: string | null; 
    title?: string | null; 
    description?: string | null; 
    listingType?: core_apimessages_Listing_ListingType | null; 
    condition?: Condition | null; 
    price?: Price | null; 
    pricing?: Pricing | null; 
    images?: (Images | null)[] | null; 
    watching?: boolean | null; 
    state?: string | null; 
    stateDescription?: string | null; 
    shipping?: Shipping | null; 
    shop?: Shop | null; 
  } & AddToCartButtonData.Fragment & WatchBadgeData.Fragment

  export type Condition = {
    __typename?: "core_apimessages_Condition";
    displayName?: string | null; 
    conditionSlug?: string | null; 
  }

  export type Price = {
    __typename?: "core_apimessages_Money";
    amountCents?: number | null; 
    display?: string | null; 
  }

  export type Pricing = {
    __typename?: "core_apimessages_ListingPricing";
    buyerPrice?: BuyerPrice | null; 
    originalPrice?: OriginalPrice | null; 
    ribbon?: Ribbon | null; 
  }

  export type BuyerPrice = {
    __typename?: "core_apimessages_Money";
    display?: string | null; 
    currency?: string | null; 
    amountCents?: number | null; 
  }

  export type OriginalPrice = {
    __typename?: "core_apimessages_Money";
    display?: string | null; 
  }

  export type Ribbon = {
    __typename?: "core_apimessages_Ribbon";
    display?: string | null; 
  }

  export type Images = {
    __typename?: "core_apimessages_Image";
    source?: string | null; 
  }

  export type Shipping = {
    __typename?: "core_apimessages_ShippingPrices";
    shippingPrices?: (ShippingPrices | null)[] | null; 
    freeExpeditedShipping?: boolean | null; 
    localPickupOnly?: boolean | null; 
  }

  export type ShippingPrices = {
    __typename?: "core_apimessages_ShippingPrice";
    shippingMethod?: core_apimessages_ShippingMethod | null; 
    carrierCalculated?: boolean | null; 
    destinationPostalCodeNeeded?: boolean | null; 
    rate?: Rate | null; 
  }

  export type Rate = {
    __typename?: "core_apimessages_Money";
    amount?: string | null; 
    amountCents?: number | null; 
    currency?: string | null; 
    display?: string | null; 
  }

  export type Shop = {
    __typename?: "Shop";
    _id?: string | null; 
    address?: Address | null; 
  }

  export type Address = {
    __typename?: "core_apimessages_Address";
    country?: Country | null; 
  }

  export type Country = {
    __typename?: "core_apimessages_Country";
    countryCode?: string | null; 
    name?: string | null; 
  }
}

export namespace BumpKey {
  export type Fragment = {
    __typename?: "Listing";
    _id?: string | null; 
    bumpKey?: BumpKey | null; 
  }

  export type BumpKey = {
    __typename?: "core_apimessages_BumpKey";
    key?: string | null; 
  }
}

export namespace FinancingFields {
  export type Fragment = {
    __typename?: "Listing";
    _id?: string | null; 
    estimatedMonthlyPaymentPlan?: EstimatedMonthlyPaymentPlan | null; 
  }

  export type EstimatedMonthlyPaymentPlan = {
    __typename?: "core_apimessages_EstimatedMonthlyPayment";
    estimatedMonthlyPayment?: EstimatedMonthlyPayment | null; 
  }

  export type EstimatedMonthlyPayment = {
    __typename?: "core_apimessages_Money";
    display?: string | null; 
  }
}

export namespace ShopFields {
  export type Fragment = {
    __typename?: "Listing";
    _id?: string | null; 
    shop?: Shop | null; 
  }

  export type Shop = {
    __typename?: "Shop";
    _id?: string | null; 
    address?: Address | null; 
  }

  export type Address = {
    __typename?: "core_apimessages_Address";
    locality?: string | null; 
    countryCode?: string | null; 
    region?: string | null; 
  }
}

export namespace ListingCardSignalsData {
  export type Fragment = {
    __typename?: "reverb_signals_Signal";
    name?: reverb_signals_Signal_Name | null; 
    title?: string | null; 
    icon?: string | null; 
  }
}

export namespace FullFinancingFields {
  export type Fragment = {
    __typename?: "Listing";
    _id?: string | null; 
    estimatedMonthlyPaymentPlan?: EstimatedMonthlyPaymentPlan | null; 
    pricing?: Pricing | null; 
  }

  export type EstimatedMonthlyPaymentPlan = {
    __typename?: "core_apimessages_EstimatedMonthlyPayment";
    estimatedMonthlyPayment?: EstimatedMonthlyPayment | null; 
    maxTermMonth?: number | null; 
    availableTermMonths?: (number | null)[] | null; 
    lowestAprAtMaxTerm?: number | null; 
    zeroPercentFinancingPlan?: boolean | null; 
    splitPay?: boolean | null; 
  }

  export type EstimatedMonthlyPayment = {
    __typename?: "core_apimessages_Money";
    display?: string | null; 
  }

  export type Pricing = {
    __typename?: "core_apimessages_ListingPricing";
    buyerPrice?: BuyerPrice | null; 
  }

  export type BuyerPrice = {
    __typename?: "core_apimessages_Money";
    display?: string | null; 
  }
}

export namespace ListingGreatValueData {
  export type Fragment = {
    __typename?: "Listing";
    _id?: string | null; 
    pricing?: Pricing | null; 
    condition?: Condition | null; 
    priceRecommendation?: PriceRecommendation | null; 
    shop?: Shop | null; 
    currency?: string | null; 
  }

  export type Pricing = {
    __typename?: "core_apimessages_ListingPricing";
    buyerPrice?: BuyerPrice | null; 
  }

  export type BuyerPrice = {
    __typename?: "core_apimessages_Money";
    currency?: string | null; 
    amountCents?: number | null; 
  }

  export type Condition = {
    __typename?: "core_apimessages_Condition";
    conditionSlug?: string | null; 
  }

  export type PriceRecommendation = {
    __typename?: "reverb_pricing_PriceRecommendation";
    priceMiddle?: PriceMiddle | null; 
  }

  export type PriceMiddle = {
    __typename?: "reverb_pricing_Money";
    amountCents?: number | null; 
    currency?: string | null; 
  }

  export type Shop = {
    __typename?: "Shop";
    _id?: string | null; 
    address?: Address | null; 
  }

  export type Address = {
    __typename?: "core_apimessages_Address";
    country?: Country | null; 
  }

  export type Country = {
    __typename?: "core_apimessages_Country";
    countryCode?: string | null; 
  }
}

export namespace CheckoutTotalAmountFields {
  export type Fragment = {
    __typename?: "Checkout";
    _id?: string | null; 
    lineItems?: (LineItems | null)[] | null; 
  }

  export type LineItems = {
    __typename?: "core_apimessages_CheckoutLineItem";
    type?: core_apimessages_CheckoutLineItem_Type | null; 
    amount?: Amount | null; 
  }

  export type Amount = {
    __typename?: "core_apimessages_Money";
    amountCents?: number | null; 
    currency?: string | null; 
  }
}

export namespace CheckoutTrackingFields {
  export type Fragment = {
    __typename?: "Checkout";
    _id?: string | null; 
    id?: string | null; 
    paymentMethod?: PaymentMethod | null; 
  }

  export type PaymentMethod = {
    __typename?: "core_apimessages_CheckoutPaymentMethod";
    type?: core_apimessages_CheckoutPaymentMethod_Type | null; 
  }
}

export namespace CheckoutShippingAddressFormFields {
  export type Fragment = {
    __typename?: "Checkout";
    _id?: string | null; 
    id?: string | null; 
    shippingAddress?: ShippingAddress | null; 
  } & CheckoutNewShippingAddressFormFields.Fragment & CheckoutExistingShippingAddressFormFields.Fragment

  export type ShippingAddress = {
    __typename?: "core_apimessages_Address";
    countryCode?: string | null; 
  }
}

export namespace CheckoutStepErrorMessageFields {
  export type Fragment = {
    __typename?: "Checkout";
    _id?: string | null; 
    paymentErrorMessage?: string | null; 
  }
}

export namespace CheckoutStandardCreditCardCreateFormFields {
  export type Fragment = {
    __typename?: "Checkout";
    _id?: string | null; 
    id?: string | null; 
    shippingAddress?: ShippingAddress | null; 
  } & CheckoutTrackingFields.Fragment

  export type ShippingAddress = {
    __typename?: "core_apimessages_Address";
    id?: string | null; 
    uuid?: string | null; 
    name?: string | null; 
    streetAddress?: string | null; 
    extendedAddress?: string | null; 
    postalCode?: string | null; 
    region?: string | null; 
    regionName?: string | null; 
    locality?: string | null; 
    phone?: string | null; 
    primary?: boolean | null; 
    isComplete?: boolean | null; 
    countryCode?: string | null; 
    country?: Country | null; 
  }

  export type Country = {
    __typename?: "core_apimessages_Country";
    name?: string | null; 
  }
}

export namespace CheckoutAddressSummaryFields {
  export type Fragment = {
    __typename?: "Checkout";
    _id?: string | null; 
    shippingAddress?: ShippingAddress | null; 
  }

  export type ShippingAddress = {
    __typename?: "core_apimessages_Address";
    uuid?: string | null; 
    name?: string | null; 
    streetAddress?: string | null; 
    extendedAddress?: string | null; 
    locality?: string | null; 
    regionName?: string | null; 
    postalCode?: string | null; 
    country?: Country | null; 
    phone?: string | null; 
    isComplete?: boolean | null; 
  }

  export type Country = {
    __typename?: "core_apimessages_Country";
    countryCode?: string | null; 
    name?: string | null; 
  }
}

export namespace PaymentLayoutCheckoutFields {
  export type Fragment = {
    __typename?: "Checkout";
    _id?: string | null; 
  } & CheckoutAddressSummaryFields.Fragment & CheckoutOrderSummaryFields.Fragment & CheckoutStepErrorMessageFields.Fragment & CheckoutDisplayFields.Fragment
}

export namespace PaymentLayoutMeFields {
  export type Fragment = {
    __typename?: "rql_Me";
    uuid?: string | null; 
    shippingAddresses?: (ShippingAddresses | null)[] | null; 
  }

  export type ShippingAddresses = {
    __typename?: "core_apimessages_Address";
    uuid?: string | null; 
  }
}

export namespace CSPReviewJumplinksData {
  export type Fragment = {
    __typename?: "CSP";
    _id?: string | null; 
    reviews?: Reviews | null; 
  }

  export type Reviews = {
    __typename?: "core_apimessages_CSPReviews";
    total?: number | null; 
    avgRating?: number | null; 
  }
}

export namespace Item2AffirmCalloutData {
  export type Fragment = {
    __typename?: "Listing";
    _id?: string | null; 
    estimatedMonthlyPaymentPlan?: EstimatedMonthlyPaymentPlan | null; 
    pricing?: Pricing | null; 
  }

  export type EstimatedMonthlyPaymentPlan = {
    __typename?: "core_apimessages_EstimatedMonthlyPayment";
    estimatedMonthlyPayment?: EstimatedMonthlyPayment | null; 
    maxTermMonth?: number | null; 
    availableTermMonths?: (number | null)[] | null; 
    lowestAprAtMaxTerm?: number | null; 
    zeroPercentFinancingPlan?: boolean | null; 
    splitPay?: boolean | null; 
  }

  export type EstimatedMonthlyPayment = {
    __typename?: "core_apimessages_Money";
    display?: string | null; 
  }

  export type Pricing = {
    __typename?: "core_apimessages_ListingPricing";
    buyerPrice?: BuyerPrice | null; 
  }

  export type BuyerPrice = {
    __typename?: "core_apimessages_Money";
    display?: string | null; 
  }
}

export namespace Item2FlagListingData {
  export type Fragment = {
    __typename?: "Listing";
    _id?: string | null; 
    id?: string | null; 
    state?: string | null; 
    sellerId?: string | null; 
  }
}

export namespace Item2FlagListingMeData {
  export type Fragment = {
    __typename?: "rql_Me";
    uuid?: string | null; 
    status?: core_apimessages_UserStatus | null; 
  }
}

export namespace Item2AdminButtonsData {
  export type Fragment = {
    __typename?: "Listing";
    _id?: string | null; 
    id?: string | null; 
    slug?: string | null; 
    canonicalProductId?: string | null; 
  }
}

export namespace CSPReviewCSP {
  export type Fragment = {
    __typename?: "CSP";
    _id?: string | null; 
    id?: string | null; 
    title?: string | null; 
    slug?: string | null; 
  }
}

export namespace CSPReviews {
  export type Fragment = {
    __typename?: "core_apimessages_CSPReviews";
    total?: number | null; 
    limit?: number | null; 
    offset?: number | null; 
    avgRating?: number | null; 
    myReview?: MyReview | null; 
    reviews?: (Reviews | null)[] | null; 
  }

  export type MyReview =CspReviewData.Fragment

  export type Reviews =CspReviewData.Fragment
}

export namespace CspReviewData {
  export type Fragment = {
    __typename?: "core_apimessages_CSPReview";
    id?: string | null; 
    body?: string | null; 
    createdAt?: string | null; 
    title?: string | null; 
    rating?: number | null; 
    voteCount?: number | null; 
    reviewer?: Reviewer | null; 
    verified?: boolean | null; 
    blocked?: boolean | null; 
    isMyReview?: boolean | null; 
    didIVote?: boolean | null; 
  }

  export type Reviewer = {
    __typename?: "core_apimessages_Reviewer";
    shortname?: string | null; 
    links?: Links | null; 
  }

  export type Links = {
    __typename?: "core_apimessages_ReviewerLinks";
    avatar?: Avatar | null; 
  }

  export type Avatar = {
    __typename?: "core_apimessages_Link";
    href?: string | null; 
  }
}

export namespace ShippingWarningData {
  export type Fragment = {
    __typename?: "Listing";
    _id?: string | null; 
    id?: string | null; 
    slug?: string | null; 
    shipping?: Shipping | null; 
    shop?: Shop | null; 
  }

  export type Shipping = {
    __typename?: "core_apimessages_ShippingPrices";
    localPickupOnly?: boolean | null; 
    shippingPrices?: (ShippingPrices | null)[] | null; 
  }

  export type ShippingPrices = {
    __typename?: "core_apimessages_ShippingPrice";
    shippingMethod?: core_apimessages_ShippingMethod | null; 
    carrierCalculated?: boolean | null; 
    destinationPostalCodeNeeded?: boolean | null; 
    rate?: Rate | null; 
  }

  export type Rate = {
    __typename?: "core_apimessages_Money";
    amount?: string | null; 
    amountCents?: number | null; 
    currency?: string | null; 
    display?: string | null; 
  }

  export type Shop = {
    __typename?: "Shop";
    _id?: string | null; 
    userUuid?: string | null; 
  }
}

export namespace ItemFooterFields {
  export type Fragment = {
    __typename?: "Listing";
    _id?: string | null; 
    id?: string | null; 
    categoryRootUuid?: string | null; 
    state?: string | null; 
    shopId?: string | null; 
    shop?: Shop | null; 
    shipping?: Shipping | null; 
    csp?: Csp | null; 
  } & RecommendedShopsRowListingFields.Fragment

  export type Shop = {
    __typename?: "Shop";
    _id?: string | null; 
    name?: string | null; 
    slug?: string | null; 
    address?: Address | null; 
  }

  export type Address = {
    __typename?: "core_apimessages_Address";
    countryCode?: string | null; 
  }

  export type Shipping = {
    __typename?: "core_apimessages_ShippingPrices";
    localPickupOnly?: boolean | null; 
    shippingPrices?: (ShippingPrices | null)[] | null; 
  }

  export type ShippingPrices = {
    __typename?: "core_apimessages_ShippingPrice";
    shippingMethod?: core_apimessages_ShippingMethod | null; 
    rate?: Rate | null; 
  }

  export type Rate = {
    __typename?: "core_apimessages_Money";
    amountCents?: number | null; 
  }

  export type Csp = {
    __typename?: "CSP";
    _id?: string | null; 
    slug?: string | null; 
  }
}

export namespace Item2BreadcrumbsData {
  export type Fragment = {
    __typename?: "Listing";
    _id?: string | null; 
    id?: string | null; 
    make?: string | null; 
    brandSlug?: string | null; 
    categories?: (Categories | null)[] | null; 
    csp?: Csp | null; 
  }

  export type Categories = {
    __typename?: "Category";
    _id?: string | null; 
    id?: string | null; 
    slug?: string | null; 
    name?: string | null; 
    rootSlug?: string | null; 
    webLink?: WebLink | null; 
    cmsLink?: CmsLink | null; 
  }

  export type WebLink = {
    __typename?: "core_apimessages_Link";
    href?: string | null; 
  }

  export type CmsLink = {
    __typename?: "core_apimessages_Link";
    href?: string | null; 
  }

  export type Csp = {
    __typename?: "CSP";
    _id?: string | null; 
    id?: string | null; 
    specs?: Specs | null; 
  }

  export type Specs = {
    __typename?: "core_apimessages_CSPSpec";
    productSpecs?: (ProductSpecs | null)[] | null; 
  }

  export type ProductSpecs = {
    __typename?: "core_apimessages_ProductSpec";
    type?: core_apimessages_ProductSpec_Type | null; 
    name?: string | null; 
    value?: string | null; 
    path?: string | null; 
  }
}

export namespace CheckoutCreditCardSummaryFields {
  export type Fragment = {
    __typename?: "Checkout";
    _id?: string | null; 
    creditCard?: CreditCard | null; 
  }

  export type CreditCard = {
    __typename?: "core_apimessages_CreditCard";
    needsReverification?: boolean | null; 
    cardType?: string | null; 
    brand?: Brand | null; 
    display?: Display | null; 
  }

  export type Brand = {
    __typename?: "core_apimessages_CreditCard_Brand";
    type?: core_apimessages_CreditCard_Brand_Type | null; 
    name?: string | null; 
  }

  export type Display = {
    __typename?: "core_apimessages_CreditCard_Display";
    summary?: string | null; 
    expirationDate?: string | null; 
  }
}

export namespace AdGroupData {
  export type Fragment = {
    __typename?: "AdGroup";
    _id?: string | null; 
    uuid?: string | null; 
    name?: string | null; 
  }
}

export namespace AdvertiserData {
  export type Fragment = {
    __typename?: "Advertiser";
    _id?: string | null; 
    uuid?: string | null; 
    name?: string | null; 
    brandSlugs?: (string | null)[] | null; 
    shopSlugs?: (string | null)[] | null; 
  }
}

export namespace AdGroupWithKeywordsData {
  export type Fragment = {
    __typename?: "AdGroup";
    _id?: string | null; 
    uuid?: string | null; 
    name?: string | null; 
    targetedCategoryUuids?: (string | null)[] | null; 
    targetedBrandSlugs?: (string | null)[] | null; 
    targetedCountryCodes?: (string | null)[] | null; 
    targetedDevices?: (string | null)[] | null; 
    targetedAdZones?: (TargetedAdZones | null)[] | null; 
    adGroupKeywords?: (AdGroupKeywords | null)[] | null; 
  }

  export type TargetedAdZones = {
    __typename?: "core_apimessages_AdGroupZone";
    adZone?: AdZone | null; 
    startsAt?: Timestamp | null; 
    endsAt?: Timestamp | null; 
  }

  export type AdZone = {
    __typename?: "core_apimessages_AdZone";
    slug?: string | null; 
  }

  export type AdGroupKeywords = {
    __typename?: "core_apimessages_AdGroupKeyword";
    keyword?: string | null; 
  }
}

export namespace AdZoneData {
  export type Fragment = {
    __typename?: "AdZone";
    _id?: string | null; 
    uuid?: string | null; 
    name?: string | null; 
    slug?: string | null; 
    status?: core_apimessages_AdZone_AdZoneStatus | null; 
    description?: string | null; 
  }
}

export namespace AdCardData {
  export type Fragment = {
    __typename?: "Ad";
    _id?: string | null; 
    format?: core_apimessages_AdFormat | null; 
    uuid?: string | null; 
    imageAdCreative?: ImageAdCreative | null; 
  }

  export type ImageAdCreative =ImageAdCreativeData.Fragment
}

export namespace Item2ShopModuleData {
  export type Fragment = {
    __typename?: "Listing";
    _id?: string | null; 
    id?: string | null; 
    seller?: Seller | null; 
    shop?: Shop | null; 
  } & Item2ShopReviewsData.Fragment

  export type Seller = {
    __typename?: "User";
    _id?: string | null; 
    id?: string | null; 
    uuid?: string | null; 
    avatar?: Avatar | null; 
  }

  export type Avatar = {
    __typename?: "core_apimessages_Image";
    source?: string | null; 
  }

  export type Shop = {
    __typename?: "Shop";
    _id?: string | null; 
    name?: string | null; 
    slug?: string | null; 
    preferredSeller?: boolean | null; 
    quickShipper?: boolean | null; 
    quickResponder?: boolean | null; 
    address?: Address | null; 
    createdAt?: Timestamp | null; 
    orders?: Orders | null; 
  }

  export type Address = {
    __typename?: "core_apimessages_Address";
    displayLocation?: string | null; 
    countryCode?: string | null; 
  }

  export type Orders = {
    __typename?: "reverb_search_SearchResponse";
    total?: number | null; 
  }
}

export namespace Item2AdWithCspsRowContainerData {
  export type Fragment = {
    __typename?: "Listing";
    _id?: string | null; 
    id?: string | null; 
    categoryRootUuid?: string | null; 
    categoryUuids?: (string | null)[] | null; 
  }
}

export namespace MarketplaceSuggestions {
  export type Fragment = {
    __typename?: "reverb_search_SearchResponse_Suggestion";
    text?: string | null; 
  }
}

export namespace OrderPacklinkShipmentData {
  export type Fragment = {
    __typename?: "Order";
    _id?: string | null; 
    legacyOrderId?: string | null; 
    packlinkShipment?: PacklinkShipment | null; 
  }

  export type PacklinkShipment = {
    __typename?: "core_apimessages_PacklinkShipment";
    reference?: string | null; 
    status?: core_apimessages_PacklinkShipment_Status | null; 
  }
}

export namespace MyShopPacklinkAccountData {
  export type Fragment = {
    __typename?: "rql_Me";
    uuid?: string | null; 
    shop?: Shop | null; 
  }

  export type Shop = {
    __typename?: "MyShop";
    _id?: string | null; 
    packlink?: Packlink | null; 
  }

  export type Packlink = {
    __typename?: "core_apimessages_MyPacklinkAccountStatusResponse";
    account?: Account | null; 
  }

  export type Account = {
    __typename?: "core_apimessages_PacklinkAccount";
    status?: core_apimessages_PacklinkAccount_Status | null; 
  }
}

export namespace CheckoutCardContinueButtonFields {
  export type Fragment = {
    __typename?: "Checkout";
    _id?: string | null; 
    id?: string | null; 
    shippingAddress?: ShippingAddress | null; 
    paymentMethod?: PaymentMethod | null; 
    orders?: (Orders | null)[] | null; 
  } & CheckoutTotalAmountFields.Fragment

  export type ShippingAddress = {
    __typename?: "core_apimessages_Address";
    isComplete?: boolean | null; 
  }

  export type PaymentMethod = {
    __typename?: "core_apimessages_CheckoutPaymentMethod";
    isComplete?: boolean | null; 
  }

  export type Orders = {
    __typename?: "core_apimessages_CheckoutOrder";
    cannotBeShippedToAddress?: boolean | null; 
  }
}

export namespace CheckoutDiscountCodeFormFields {
  export type Fragment = {
    __typename?: "Checkout";
    _id?: string | null; 
    id?: string | null; 
    paymentMethod?: PaymentMethod | null; 
  }

  export type PaymentMethod = {
    __typename?: "core_apimessages_CheckoutPaymentMethod";
    type?: core_apimessages_CheckoutPaymentMethod_Type | null; 
  }
}

export namespace Item2ProductSpecsData {
  export type Fragment = {
    __typename?: "Listing";
    _id?: string | null; 
    publishedAt?: PublishedAt | null; 
    hasInventory?: boolean | null; 
    condition?: Condition | null; 
    specs?: Specs | null; 
  }

  export type PublishedAt = {
    __typename?: "google_protobuf_Timestamp";
    seconds?: number | null; 
  }

  export type Condition = {
    __typename?: "core_apimessages_Condition";
    conditionUuid?: string | null; 
  }

  export type Specs = {
    __typename?: "core_apimessages_ListingSpec";
    productSpecs?: (ProductSpecs | null)[] | null; 
  }

  export type ProductSpecs = {
    __typename?: "core_apimessages_ProductSpec";
    name?: string | null; 
    value?: string | null; 
    path?: string | null; 
    slug?: string | null; 
    type?: core_apimessages_ProductSpec_Type | null; 
  }
}

export namespace ListViewListings {
  export type Fragment = {
    __typename?: "Listing";
    _id?: string | null; 
    id?: string | null; 
    categoryUuids?: (string | null)[] | null; 
    state?: string | null; 
    shop?: Shop | null; 
    seller?: Seller | null; 
    csp?: Csp | null; 
  } & AddToCartButtonData.Fragment & ListingCardFields.Fragment

  export type Shop = {
    __typename?: "Shop";
    _id?: string | null; 
    name?: string | null; 
    slug?: string | null; 
    preferredSeller?: boolean | null; 
    quickShipper?: boolean | null; 
    quickResponder?: boolean | null; 
    address?: Address | null; 
  }

  export type Address = {
    __typename?: "core_apimessages_Address";
    locality?: string | null; 
    region?: string | null; 
    displayLocation?: string | null; 
    country?: Country | null; 
  }

  export type Country = {
    __typename?: "core_apimessages_Country";
    countryCode?: string | null; 
    name?: string | null; 
  }

  export type Seller = {
    __typename?: "User";
    _id?: string | null; 
    feedbackSummary?: FeedbackSummary | null; 
  }

  export type FeedbackSummary = {
    __typename?: "core_apimessages_FeedbackSummary";
    receivedCount?: number | null; 
    rollingRatingPercentage?: number | null; 
  }

  export type Csp = {
    __typename?: "CSP";
    _id?: string | null; 
    webLink?: WebLink | null; 
  }

  export type WebLink = {
    __typename?: "core_apimessages_Link";
    href?: string | null; 
  }
}

export namespace PriceWithShippingSortListingData {
  export type Fragment = {
    __typename?: "Listing";
    _id?: string | null; 
    id?: string | null; 
    pricing?: Pricing | null; 
    shipping?: Shipping | null; 
  }

  export type Pricing = {
    __typename?: "core_apimessages_ListingPricing";
    buyerPrice?: BuyerPrice | null; 
  }

  export type BuyerPrice = {
    __typename?: "core_apimessages_Money";
    amountCents?: number | null; 
  }

  export type Shipping = {
    __typename?: "core_apimessages_ShippingPrices";
    shippingPrices?: (ShippingPrices | null)[] | null; 
  }

  export type ShippingPrices = {
    __typename?: "core_apimessages_ShippingPrice";
    shippingMethod?: core_apimessages_ShippingMethod | null; 
    rate?: Rate | null; 
  }

  export type Rate = {
    __typename?: "core_apimessages_Money";
    amountCents?: number | null; 
  }
}

export namespace FeaturedListingShopInfoData {
  export type Fragment = {
    __typename?: "Listing";
    _id?: string | null; 
    id?: string | null; 
    state?: string | null; 
    seller?: Seller | null; 
    shop?: Shop | null; 
    shipping?: Shipping | null; 
  }

  export type Seller = {
    __typename?: "User";
    _id?: string | null; 
    id?: string | null; 
    uuid?: string | null; 
    feedbackSummary?: FeedbackSummary | null; 
  }

  export type FeedbackSummary = {
    __typename?: "core_apimessages_FeedbackSummary";
    rollingRatingPercentage?: number | null; 
    receivedCount?: number | null; 
  }

  export type Shop = {
    __typename?: "Shop";
    _id?: string | null; 
    name?: string | null; 
    slug?: string | null; 
    preferredSeller?: boolean | null; 
    quickShipper?: boolean | null; 
    quickResponder?: boolean | null; 
    address?: Address | null; 
    paymentPolicy?: string | null; 
    createdAt?: Timestamp | null; 
    orders?: Orders | null; 
  }

  export type Address = {
    __typename?: "core_apimessages_Address";
    displayLocation?: string | null; 
    countryCode?: string | null; 
  }

  export type Orders = {
    __typename?: "reverb_search_SearchResponse";
    total?: number | null; 
  }

  export type Shipping = {
    __typename?: "core_apimessages_ShippingPrices";
    localPickupOnly?: boolean | null; 
  }
}

export namespace RedirectReturnCheckoutFields {
  export type Fragment = {
    __typename?: "Checkout";
    _id?: string | null; 
    id?: string | null; 
    status?: core_apimessages_Checkout_Status | null; 
  }
}

export namespace CreditCardEditFormFields {
  export type Fragment = {
    __typename?: "rql_Me";
    creditCards?: (CreditCards | null)[] | null; 
  }

  export type CreditCards = {
    __typename?: "core_apimessages_CreditCard";
    id?: string | null; 
    brand?: Brand | null; 
    display?: Display | null; 
    address?: Address | null; 
    expirationMonth?: string | null; 
    expirationYear?: string | null; 
    cardholderName?: string | null; 
    primaryForCheckout?: boolean | null; 
  }

  export type Brand = {
    __typename?: "core_apimessages_CreditCard_Brand";
    type?: core_apimessages_CreditCard_Brand_Type | null; 
    name?: string | null; 
  }

  export type Display = {
    __typename?: "core_apimessages_CreditCard_Display";
    summary?: string | null; 
    expirationDate?: string | null; 
  }

  export type Address = {
    __typename?: "core_apimessages_Address";
    countryCode?: string | null; 
    name?: string | null; 
    streetAddress?: string | null; 
    extendedAddress?: string | null; 
    locality?: string | null; 
    region?: string | null; 
    postalCode?: string | null; 
    phone?: string | null; 
  }
}

export namespace Item2EndedListingData {
  export type Fragment = {
    __typename?: "Listing";
    _id?: string | null; 
    id?: string | null; 
    state?: string | null; 
  }
}

export namespace Item2ProductModuleData {
  export type Fragment = {
    __typename?: "Listing";
    _id?: string | null; 
    id?: string | null; 
    categories?: (Categories | null)[] | null; 
    csp?: Csp | null; 
  }

  export type Categories = {
    __typename?: "Category";
    _id?: string | null; 
    id?: string | null; 
    slug?: string | null; 
    name?: string | null; 
    rootSlug?: string | null; 
    webLink?: WebLink | null; 
    cmsLink?: CmsLink | null; 
    parentCategories?: (ParentCategories | null)[] | null; 
  }

  export type WebLink = {
    __typename?: "core_apimessages_Link";
    href?: string | null; 
  }

  export type CmsLink = {
    __typename?: "core_apimessages_Link";
    href?: string | null; 
  }

  export type ParentCategories = {
    __typename?: "Category";
    _id?: string | null; 
    slug?: string | null; 
  }

  export type Csp = {
    __typename?: "CSP";
    _id?: string | null; 
    id?: string | null; 
    title?: string | null; 
    webLink?: _WebLink | null; 
    image?: Image | null; 
    inventory?: Inventory | null; 
    specs?: Specs | null; 
  }

  export type _WebLink = {
    __typename?: "core_apimessages_Link";
    path?: string | null; 
  }

  export type Image = {
    __typename?: "core_apimessages_Image";
    source?: string | null; 
  }

  export type Inventory = {
    __typename?: "core_apimessages_CSPInventory";
    newLowPrice?: NewLowPrice | null; 
    usedLowPrice?: UsedLowPrice | null; 
    usedTotal?: number | null; 
    newTotal?: number | null; 
  }

  export type NewLowPrice = {
    __typename?: "core_apimessages_Money";
    display?: string | null; 
    amountCents?: number | null; 
  }

  export type UsedLowPrice = {
    __typename?: "core_apimessages_Money";
    display?: string | null; 
    amountCents?: number | null; 
  }

  export type Specs = {
    __typename?: "core_apimessages_CSPSpec";
    productSpecs?: (ProductSpecs | null)[] | null; 
  }

  export type ProductSpecs = {
    __typename?: "core_apimessages_ProductSpec";
    type?: core_apimessages_ProductSpec_Type | null; 
    name?: string | null; 
    value?: string | null; 
    path?: string | null; 
  }
}

export namespace BuyListingNowApplePayData {
  export type Fragment = {
    __typename?: "Listing";
    _id?: string | null; 
    id?: string | null; 
    currency?: string | null; 
    adyenCheckoutPaymentMethodsConfig?: string | null; 
  }
}

export namespace CheckoutOrderSummaryOrderItemFields {
  export type Fragment = {
    __typename?: "Checkout";
    _id?: string | null; 
    orders?: (Orders | null)[] | null; 
  } & CheckoutOrderSummaryOrderItemSubtotalFields.Fragment & CheckoutOrderSummaryOrderItemShippingTotalFields.Fragment & CheckoutOrderSummaryImageFields.Fragment & CheckoutOrderQuantitySelectorFields.Fragment & CheckoutOrderShippingSelectorFields.Fragment

  export type Orders = {
    __typename?: "core_apimessages_CheckoutOrder";
    cannotBeShippedToAddress?: boolean | null; 
    subtotal?: Subtotal | null; 
    taxIncluded?: boolean | null; 
    taxLabel?: string | null; 
    listingId?: string | null; 
    listing?: Listing | null; 
  }

  export type Subtotal = {
    __typename?: "core_apimessages_CheckoutOrder_Subtotal";
    discounted?: boolean | null; 
    discount?: Discount | null; 
  }

  export type Discount = {
    __typename?: "core_apimessages_CheckoutOrder_SubtotalDiscount";
    label?: string | null; 
    type?: core_apimessages_CheckoutOrder_SubtotalDiscount_Type | null; 
  }

  export type Listing = {
    __typename?: "Listing";
    _id?: string | null; 
    title?: string | null; 
    shop?: Shop | null; 
  }

  export type Shop = {
    __typename?: "Shop";
    _id?: string | null; 
    name?: string | null; 
    userUuid?: string | null; 
    address?: Address | null; 
  }

  export type Address = {
    __typename?: "core_apimessages_Address";
    displayLocation?: string | null; 
  }
}

export namespace KlarnaCalloutListingFields {
  export type Fragment = {
    __typename?: "Listing";
    _id?: string | null; 
  } & KlarnaPaymentPlanFields.Fragment
}

export namespace EUODRAddress {
  export type Fragment = {
    __typename?: "Shop";
    _id?: string | null; 
    vatId?: string | null; 
    euOdrAddress?: EuOdrAddress | null; 
  }

  export type EuOdrAddress = {
    __typename?: "core_apimessages_Address";
    name?: string | null; 
    streetAddress?: string | null; 
    displayLocation?: string | null; 
    postalCode?: string | null; 
    email?: string | null; 
    phone?: string | null; 
  }
}

export namespace Item2ShopOverviewData {
  export type Fragment = {
    __typename?: "Listing";
    _id?: string | null; 
    seller?: Seller | null; 
    shop?: Shop | null; 
  }

  export type Seller = {
    __typename?: "User";
    _id?: string | null; 
    feedbackSummary?: FeedbackSummary | null; 
  }

  export type FeedbackSummary = {
    __typename?: "core_apimessages_FeedbackSummary";
    rollingRatingPercentage?: number | null; 
    receivedCount?: number | null; 
  }

  export type Shop = {
    __typename?: "Shop";
    _id?: string | null; 
    name?: string | null; 
    slug?: string | null; 
    address?: Address | null; 
  }

  export type Address = {
    __typename?: "core_apimessages_Address";
    displayLocation?: string | null; 
    countryCode?: string | null; 
  }
}

export namespace Item2Video {
  export type Fragment = {
    __typename?: "Listing";
    _id?: string | null; 
    video?: Video | null; 
    csp?: Csp | null; 
  }

  export type Video = {
    __typename?: "core_apimessages_Video";
    id?: string | null; 
    youtubeVideoId?: string | null; 
    empty?: boolean | null; 
  }

  export type Csp = {
    __typename?: "CSP";
    _id?: string | null; 
    videos?: Videos | null; 
  }

  export type Videos = {
    __typename?: "core_apimessages_CSPVideo";
    videoLinks?: (VideoLinks | null)[] | null; 
  }

  export type VideoLinks = {
    __typename?: "core_apimessages_VideoLink";
    youtubeVideoId?: string | null; 
  }
}

export namespace FeaturedListingWithPrice {
  export type Fragment = {
    __typename?: "Listing";
    _id?: string | null; 
    price?: Price | null; 
    bumped?: boolean | null; 
  } & FeaturedListingModuleData.Fragment

  export type Price = {
    __typename?: "core_apimessages_Money";
    amount?: string | null; 
    amountCents?: number | null; 
  }
}

export namespace FeaturedListingCSP {
  export type Fragment = {
    __typename?: "CSP";
    _id?: string | null; 
    id?: string | null; 
    inventory?: Inventory | null; 
    categories?: (Categories | null)[] | null; 
  }

  export type Inventory = {
    __typename?: "core_apimessages_CSPInventory";
    newTotal?: number | null; 
    usedTotal?: number | null; 
  }

  export type Categories = {
    __typename?: "Category";
    _id?: string | null; 
    rootSlug?: string | null; 
    slug?: string | null; 
  }
}

export namespace CheckoutOrderSummaryOrderItemSubtotalFields {
  export type Fragment = {
    __typename?: "Checkout";
    _id?: string | null; 
    orders?: (Orders | null)[] | null; 
  }

  export type Orders = {
    __typename?: "core_apimessages_CheckoutOrder";
    quantity?: number | null; 
    listing?: Listing | null; 
    subtotal?: Subtotal | null; 
  }

  export type Listing = {
    __typename?: "Listing";
    _id?: string | null; 
    pricing?: Pricing | null; 
  }

  export type Pricing = {
    __typename?: "core_apimessages_ListingPricing";
    originalPrice?: OriginalPrice | null; 
    buyerPrice?: BuyerPrice | null; 
  }

  export type OriginalPrice = {
    __typename?: "core_apimessages_Money";
    display?: string | null; 
    currency?: string | null; 
  }

  export type BuyerPrice = {
    __typename?: "core_apimessages_Money";
    display?: string | null; 
    currency?: string | null; 
  }

  export type Subtotal = {
    __typename?: "core_apimessages_CheckoutOrder_Subtotal";
    listingPrice?: ListingPrice | null; 
    discounted?: boolean | null; 
    discount?: Discount | null; 
  }

  export type ListingPrice = {
    __typename?: "core_apimessages_Money";
    display?: string | null; 
    currency?: string | null; 
  }

  export type Discount = {
    __typename?: "core_apimessages_CheckoutOrder_SubtotalDiscount";
    type?: core_apimessages_CheckoutOrder_SubtotalDiscount_Type | null; 
    label?: string | null; 
  }
}

export namespace CheckoutPaymentMethodFields {
  export type Fragment = {
    __typename?: "Checkout";
    _id?: string | null; 
    paymentMethod?: PaymentMethod | null; 
  } & CheckoutCreditCardFormFields.Fragment

  export type PaymentMethod = {
    __typename?: "core_apimessages_CheckoutPaymentMethod";
    type?: core_apimessages_CheckoutPaymentMethod_Type | null; 
  }
}

export namespace Item2FeedbackItemData {
  export type Fragment = {
    __typename?: "core_apimessages_Feedback";
    author?: Author | null; 
    createdAt?: CreatedAt | null; 
    message?: string | null; 
    orderTitle?: string | null; 
    rating?: number | null; 
    recipient?: Recipient | null; 
    listingLink?: ListingLink | null; 
    response?: Response | null; 
    type?: core_apimessages_Feedback_Type | null; 
  }

  export type Author = {
    __typename?: "User";
    _id?: string | null; 
    name?: string | null; 
  }

  export type CreatedAt = {
    __typename?: "google_protobuf_Timestamp";
    seconds?: number | null; 
  }

  export type Recipient = {
    __typename?: "User";
    _id?: string | null; 
    name?: string | null; 
  }

  export type ListingLink = {
    __typename?: "core_apimessages_Link";
    href?: string | null; 
  }

  export type Response = {
    __typename?: "core_apimessages_Feedback_Response";
    body?: string | null; 
    createdAt?: _CreatedAt | null; 
  }

  export type _CreatedAt = {
    __typename?: "google_protobuf_Timestamp";
    seconds?: number | null; 
  }
}

export namespace Item2ShopReturnPoliciesData {
  export type Fragment = {
    __typename?: "Listing";
    _id?: string | null; 
    id?: string | null; 
    acceptedPaymentMethods?: (string | null)[] | null; 
    condition?: Condition | null; 
    estimatedMonthlyPaymentPlan?: EstimatedMonthlyPaymentPlan | null; 
    shop?: Shop | null; 
    soldAsIs?: boolean | null; 
  }

  export type Condition = {
    __typename?: "core_apimessages_Condition";
    conditionSlug?: string | null; 
  }

  export type EstimatedMonthlyPaymentPlan = {
    __typename?: "core_apimessages_EstimatedMonthlyPayment";
    estimatedMonthlyPayment?: EstimatedMonthlyPayment | null; 
    maxTermMonth?: number | null; 
  }

  export type EstimatedMonthlyPayment = {
    __typename?: "core_apimessages_Money";
    display?: string | null; 
  }

  export type Shop = {
    __typename?: "Shop";
    _id?: string | null; 
    userUuid?: string | null; 
    returnPolicy?: ReturnPolicy | null; 
  }

  export type ReturnPolicy = {
    __typename?: "core_apimessages_ReturnPolicy";
    newReturnWindowDays?: number | null; 
    usedReturnWindowDays?: number | null; 
    restockingFeePercent?: number | null; 
    specialConditions?: string | null; 
    legacyReturnPolicyText?: string | null; 
  }
}

export namespace Item2PaidLandingData {
  export type Fragment = {
    __typename?: "Listing";
    _id?: string | null; 
    id?: string | null; 
  } & FeaturedListingModuleData.Fragment
}

export namespace CMSPageEducationSectionData {
  export type Fragment = {
    __typename?: "CMSPage";
    _id?: string | null; 
    slug?: string | null; 
    title?: string | null; 
    image?: Image | null; 
  }

  export type Image = {
    __typename?: "cms_PageImage";
    imageUrl?: string | null; 
  }
}

export namespace ProductFamilyHeaderFields {
  export type Fragment = {
    __typename?: "CSP";
    _id?: string | null; 
    brand?: Brand | null; 
    categories?: (Categories | null)[] | null; 
  }

  export type Brand = {
    __typename?: "Brand";
    _id?: string | null; 
    slug?: string | null; 
    name?: string | null; 
  }

  export type Categories = {
    __typename?: "Category";
    _id?: string | null; 
    parent?: Parent | null; 
  }

  export type Parent = {
    __typename?: "core_apimessages_Category";
    slug?: string | null; 
    name?: string | null; 
    cmsLink?: CmsLink | null; 
  }

  export type CmsLink = {
    __typename?: "core_apimessages_Link";
    href?: string | null; 
  }
}

export namespace Item2TitleData {
  export type Fragment = {
    __typename?: "Listing";
    _id?: string | null; 
    id?: string | null; 
    title?: string | null; 
    condition?: Condition | null; 
    categories?: (Categories | null)[] | null; 
    csp?: Csp | null; 
  }

  export type Condition = {
    __typename?: "core_apimessages_Condition";
    conditionSlug?: string | null; 
    displayName?: string | null; 
  }

  export type Categories = {
    __typename?: "Category";
    _id?: string | null; 
    id?: string | null; 
    slug?: string | null; 
    name?: string | null; 
    rootSlug?: string | null; 
  }

  export type Csp = {
    __typename?: "CSP";
    _id?: string | null; 
    id?: string | null; 
  }
}

export namespace ShopCardFields {
  export type Fragment = {
    __typename?: "Shop";
    _id?: string | null; 
    name?: string | null; 
    preferredSeller?: boolean | null; 
    quickShipper?: boolean | null; 
    address?: Address | null; 
    user?: User | null; 
  }

  export type Address = {
    __typename?: "core_apimessages_Address";
    displayLocation?: string | null; 
  }

  export type User = {
    __typename?: "User";
    _id?: string | null; 
    avatar?: Avatar | null; 
    feedbackSummary?: FeedbackSummary | null; 
  }

  export type Avatar = {
    __typename?: "core_apimessages_Image";
    source?: string | null; 
  }

  export type FeedbackSummary = {
    __typename?: "core_apimessages_FeedbackSummary";
    rollingRatingPercentage?: number | null; 
    receivedCount?: number | null; 
  }
}

export namespace Item2ShopShippingPoliciesData {
  export type Fragment = {
    __typename?: "Listing";
    _id?: string | null; 
    shipping?: Shipping | null; 
    shop?: Shop | null; 
    allShippingPrices?: AllShippingPrices | null; 
  }

  export type Shipping = {
    __typename?: "core_apimessages_ShippingPrices";
    localPickup?: boolean | null; 
    shippingPrices?: (ShippingPrices | null)[] | null; 
  }

  export type ShippingPrices = {
    __typename?: "core_apimessages_ShippingPrice";
    shippingMethod?: core_apimessages_ShippingMethod | null; 
    rate?: Rate | null; 
  }

  export type Rate = {
    __typename?: "core_apimessages_Money";
    display?: string | null; 
  }

  export type Shop = {
    __typename?: "Shop";
    _id?: string | null; 
    shippingPolicy?: string | null; 
    address?: Address | null; 
  }

  export type Address = {
    __typename?: "core_apimessages_Address";
    displayLocation?: string | null; 
  }

  export type AllShippingPrices = {
    __typename?: "core_apimessages_ShippingPrices";
    shippingPrices?: (_ShippingPrices | null)[] | null; 
  }

  export type _ShippingPrices = {
    __typename?: "core_apimessages_ShippingPrice";
    shippingMethod?: core_apimessages_ShippingMethod | null; 
    rate?: _Rate | null; 
    shippingRegionCode?: string | null; 
  }

  export type _Rate = {
    __typename?: "core_apimessages_Money";
    display?: string | null; 
  }
}

export namespace Item2PricingData {
  export type Fragment = {
    __typename?: "Listing";
    _id?: string | null; 
    id?: string | null; 
    listingType?: core_apimessages_Listing_ListingType | null; 
    inventory?: number | null; 
    hasInventory?: boolean | null; 
    maxBuyerQuantity?: number | null; 
    make?: string | null; 
    model?: string | null; 
    state?: string | null; 
    condition?: Condition | null; 
  } & AddToCartButtonData.Fragment & Item2PriceWithShippingData.Fragment & CompareOtherSellersLinkData.Fragment & ListingFinancingCalloutFields.Fragment & SignalsData.Fragment & Item2StatsData.Fragment

  export type Condition = {
    __typename?: "core_apimessages_Condition";
    conditionSlug?: string | null; 
  }
}

export namespace Item2PricingNegotiationsData {
  export type Fragment = {
    __typename?: "Negotiation";
    _id?: string | null; 
    id?: string | null; 
    lastOffer?: LastOffer | null; 
  }

  export type LastOffer = {
    __typename?: "core_apimessages_Offer";
    status?: core_apimessages_Offer_OfferStatus | null; 
  }
}

export namespace Item2StatsData {
  export type Fragment = {
    __typename?: "Listing";
    _id?: string | null; 
    id?: string | null; 
    hasInventory?: boolean | null; 
    condition?: Condition | null; 
    publishedAt?: PublishedAt | null; 
    listingType?: core_apimessages_Listing_ListingType | null; 
    counts?: Counts | null; 
  }

  export type Condition = {
    __typename?: "core_apimessages_Condition";
    conditionUuid?: string | null; 
  }

  export type PublishedAt = {
    __typename?: "google_protobuf_Timestamp";
    seconds?: number | null; 
  }

  export type Counts = {
    __typename?: "core_apimessages_ListingCounts";
    id?: string | null; 
    views?: number | null; 
    offers?: number | null; 
    watchers?: number | null; 
  }
}

export namespace ExpressSaleItemBidData {
  export type Fragment = {
    __typename?: "CSP";
    _id?: string | null; 
    expressSalePriceEstimate?: ExpressSalePriceEstimate | null; 
    expressSaleItemBid?: ExpressSaleItemBid | null; 
  }

  export type ExpressSalePriceEstimate = {
    __typename?: "reverb_pricing_PriceRecommendation";
    priceLow?: PriceLow | null; 
    priceHigh?: PriceHigh | null; 
  }

  export type PriceLow = {
    __typename?: "reverb_pricing_Money";
    amountCents?: number | null; 
    currency?: string | null; 
  }

  export type PriceHigh = {
    __typename?: "reverb_pricing_Money";
    amountCents?: number | null; 
    currency?: string | null; 
  }

  export type ExpressSaleItemBid = {
    __typename?: "core_apimessages_CSPExpressSaleItemBid";
    cspUuid?: string | null; 
    bidId?: string | null; 
    carrier?: string | null; 
    shopName?: string | null; 
    estimatedPayout?: EstimatedPayout | null; 
  }

  export type EstimatedPayout = {
    __typename?: "core_apimessages_Money";
    display?: string | null; 
    amount?: string | null; 
  }
}

export namespace ShippingProfilePrices {
  export type Fragment = {
    __typename?: "Shop";
    _id?: string | null; 
    shippingProfiles?: (ShippingProfiles | null)[] | null; 
  }

  export type ShippingProfiles = {
    __typename?: "core_apimessages_ShippingProfile";
    name?: string | null; 
    id?: string | null; 
    localPickup?: boolean | null; 
    allShippingRates?: (AllShippingRates | null)[] | null; 
  }

  export type AllShippingRates = {
    __typename?: "core_apimessages_ShippingRates";
    regionCode?: string | null; 
    regionName?: string | null; 
    rateType?: string | null; 
    rate?: Rate | null; 
    incrementalRate?: IncrementalRate | null; 
    expeditedRate?: ExpeditedRate | null; 
    regionalRates?: (RegionalRates | null)[] | null; 
    regionalExpeditedRates?: (RegionalExpeditedRates | null)[] | null; 
  }

  export type Rate = {
    __typename?: "core_apimessages_Money";
    display?: string | null; 
  }

  export type IncrementalRate = {
    __typename?: "core_apimessages_Money";
    display?: string | null; 
  }

  export type ExpeditedRate = {
    __typename?: "core_apimessages_Money";
    display?: string | null; 
  }

  export type RegionalRates = {
    __typename?: "core_apimessages_RegionalShippingRate";
    areas?: (string | null)[] | null; 
    rate?: _Rate | null; 
  }

  export type _Rate = {
    __typename?: "core_apimessages_Money";
    display?: string | null; 
  }

  export type RegionalExpeditedRates = {
    __typename?: "core_apimessages_RegionalShippingRate";
    areas?: (string | null)[] | null; 
    rate?: __Rate | null; 
  }

  export type __Rate = {
    __typename?: "core_apimessages_Money";
    display?: string | null; 
  }
}

export namespace SellFormViewShopFields {
  export type Fragment = {
    __typename?: "Shop";
    _id?: string | null; 
    currencySetting?: string | null; 
    defaultLocale?: string | null; 
    shopSupportedLocaleCodes?: (string | null)[] | null; 
    preferredSeller?: boolean | null; 
    listableConditions?: (ListableConditions | null)[] | null; 
    offerPolicy?: OfferPolicy | null; 
    returnPolicy?: ReturnPolicy | null; 
    taxPolicies?: (TaxPolicies | null)[] | null; 
  } & SellFormShopShipping.Fragment

  export type ListableConditions = {
    __typename?: "core_apimessages_Condition";
    displayName?: string | null; 
    conditionSlug?: string | null; 
  }

  export type OfferPolicy = {
    __typename?: "core_apimessages_Shop_OfferPolicy";
    autoRejectLowOffers?: boolean | null; 
    lowballPercentage?: number | null; 
  }

  export type ReturnPolicy = {
    __typename?: "core_apimessages_ReturnPolicy";
    newReturnWindowDays?: number | null; 
    usedReturnWindowDays?: number | null; 
  }

  export type TaxPolicies = {
    __typename?: "core_apimessages_ShopTaxPolicy";
    vatPolicy?: boolean | null; 
  }
}

export namespace SellFormViewCountryFields {
  export type Fragment = {
    __typename?: "core_apimessages_CountriesResponse";
    countries?: (Countries | null)[] | null; 
  }

  export type Countries = {
    __typename?: "core_apimessages_Country";
    name?: string | null; 
    countryCode?: string | null; 
  }
}

export namespace SellFormShopShipping {
  export type Fragment = {
    __typename?: "Shop";
    _id?: string | null; 
    currencySetting?: string | null; 
    sameDayShippingConfigured?: boolean | null; 
    shippingRegionSettings?: (ShippingRegionSettings | null)[] | null; 
    address?: Address | null; 
  } & ShippingProfilePrices.Fragment

  export type ShippingRegionSettings = {
    __typename?: "core_apimessages_ShippingRegionSetting";
    regionCode?: string | null; 
    regionName?: string | null; 
    isDomestic?: boolean | null; 
    allowedToShipCarrierCalculated?: boolean | null; 
  }

  export type Address = {
    __typename?: "core_apimessages_Address";
    region?: string | null; 
    postalCode?: string | null; 
    countryCode?: string | null; 
  }
}

export namespace SellFormCanonicalProductCardData {
  export type Fragment = {
    __typename?: "CSP";
    _id?: string | null; 
    title?: string | null; 
    model?: string | null; 
    image?: Image | null; 
    variants?: (Variants | null)[] | null; 
    categories?: (Categories | null)[] | null; 
    brand?: Brand | null; 
  }

  export type Image = {
    __typename?: "core_apimessages_Image";
    source?: string | null; 
  }

  export type Variants = {
    __typename?: "core_apimessages_CspVariant";
    id?: string | null; 
    name?: string | null; 
    model?: string | null; 
    year?: string | null; 
    finish?: string | null; 
    countryOfOrigin?: string | null; 
  }

  export type Categories = {
    __typename?: "Category";
    _id?: string | null; 
    name?: string | null; 
  }

  export type Brand = {
    __typename?: "Brand";
    _id?: string | null; 
    name?: string | null; 
  }
}

export namespace HydrateSellForm {
  export type Fragment = {
    __typename?: "Listing";
    _id?: string | null; 
    id?: string | null; 
    state?: string | null; 
    sku?: string | null; 
    year?: string | null; 
    countryOfOrigin?: string | null; 
    canonicalProductId?: string | null; 
    categoryRootUuid?: string | null; 
    seedId?: string | null; 
    seedType?: core_apimessages_Listing_SeedType | null; 
    categories?: (Categories | null)[] | null; 
    localizedContents?: (LocalizedContents | null)[] | null; 
    handmade?: boolean | null; 
    traits?: (Traits | null)[] | null; 
    condition?: Condition | null; 
    hasInventory?: boolean | null; 
    inventory?: number | null; 
    upc?: string | null; 
    upcDoesNotApply?: boolean | null; 
    taxExempt?: boolean | null; 
    video?: Video | null; 
    bumpRate?: BumpRate | null; 
    bumpEligible?: boolean | null; 
    images?: (Images | null)[] | null; 
    shippingProfileId?: string | null; 
    allShippingPrices?: AllShippingPrices | null; 
    shipmentPackage?: ShipmentPackage | null; 
    prefersReverbShippingLabel?: boolean | null; 
    sameDayShippingIneligible?: boolean | null; 
    sellerPrice?: SellerPrice | null; 
    sellerCost?: SellerCost | null; 
    soldAsIs?: boolean | null; 
    listingType?: core_apimessages_Listing_ListingType | null; 
    overriddenAttributes?: (string | null)[] | null; 
    preorderInfo?: PreorderInfo | null; 
    shop?: Shop | null; 
  }

  export type Categories = {
    __typename?: "Category";
    _id?: string | null; 
    id?: string | null; 
    name?: string | null; 
    root?: boolean | null; 
    leaf?: boolean | null; 
    rootSlug?: string | null; 
  }

  export type LocalizedContents = {
    __typename?: "core_apimessages_LocalizedListingContent";
    locale?: string | null; 
    make?: string | null; 
    model?: string | null; 
    finish?: string | null; 
    title?: string | null; 
    description?: string | null; 
    prop65Warning?: string | null; 
    defaultForShop?: boolean | null; 
  }

  export type Traits = {
    __typename?: "core_apimessages_Trait";
    keyId?: string | null; 
    valueId?: string | null; 
  }

  export type Condition = {
    __typename?: "core_apimessages_Condition";
    conditionSlug?: string | null; 
  }

  export type Video = {
    __typename?: "core_apimessages_Video";
    link?: string | null; 
  }

  export type BumpRate = {
    __typename?: "core_apimessages_BumpRate";
    rate?: number | null; 
  }

  export type Images = {
    __typename?: "core_apimessages_Image";
    id?: string | null; 
    source?: string | null; 
    itemId?: string | null; 
    version?: string | null; 
    itemType?: string | null; 
    publicId?: string | null; 
    height?: number | null; 
    width?: number | null; 
    transformation?: Transformation | null; 
  }

  export type Transformation = {
    __typename?: "core_apimessages_ImageEntry_Transformation";
    x?: string | null; 
    y?: string | null; 
    width?: string | null; 
    height?: string | null; 
    crop?: string | null; 
    angle?: number | null; 
  }

  export type AllShippingPrices = {
    __typename?: "core_apimessages_ShippingPrices";
    localPickup?: boolean | null; 
    shippingPrices?: (ShippingPrices | null)[] | null; 
  }

  export type ShippingPrices = {
    __typename?: "core_apimessages_ShippingPrice";
    shippingRegionCode?: string | null; 
    shippingMethod?: core_apimessages_ShippingMethod | null; 
    carrierCalculated?: boolean | null; 
    originalRate?: OriginalRate | null; 
  }

  export type OriginalRate = {
    __typename?: "core_apimessages_Money";
    amount?: string | null; 
    currency?: string | null; 
  }

  export type ShipmentPackage = {
    __typename?: "ShipmentPackage";
    _id?: string | null; 
    length?: Length | null; 
    width?: Width | null; 
    height?: Height | null; 
    weight?: Weight | null; 
  }

  export type Length = {
    __typename?: "core_apimessages_Measurement";
    value?: string | null; 
    unit?: string | null; 
  }

  export type Width = {
    __typename?: "core_apimessages_Measurement";
    value?: string | null; 
    unit?: string | null; 
  }

  export type Height = {
    __typename?: "core_apimessages_Measurement";
    value?: string | null; 
    unit?: string | null; 
  }

  export type Weight = {
    __typename?: "core_apimessages_Measurement";
    value?: string | null; 
    unit?: string | null; 
  }

  export type SellerPrice = {
    __typename?: "core_apimessages_Money";
    amountCents?: number | null; 
    currency?: string | null; 
    amount?: string | null; 
    display?: string | null; 
  }

  export type SellerCost = {
    __typename?: "core_apimessages_Money";
    amountCents?: number | null; 
    currency?: string | null; 
    amount?: string | null; 
    display?: string | null; 
  }

  export type PreorderInfo = {
    __typename?: "core_apimessages_PreorderInfo";
    shipDate?: ShipDate | null; 
    leadTimeDays?: number | null; 
  }

  export type ShipDate = {
    __typename?: "google_protobuf_Timestamp";
    seconds?: number | null; 
  }

  export type Shop = {
    __typename?: "Shop";
    _id?: string | null; 
  } & SellFormViewShopFields.Fragment
}

export namespace ShopAddressFields {
  export type Fragment = {
    __typename?: "core_apimessages_Address";
    primary?: boolean | null; 
    name?: string | null; 
    streetAddress?: string | null; 
    extendedAddress?: string | null; 
    region?: string | null; 
    locality?: string | null; 
    postalCode?: string | null; 
    phone?: string | null; 
    countryCode?: string | null; 
    isComplete?: boolean | null; 
  }
}

export namespace SellFormSetupData {
  export type Fragment = {
    __typename?: "rql_Me";
    uuid?: string | null; 
    firstName?: string | null; 
    shop?: Shop | null; 
  }

  export type Shop = {
    __typename?: "MyShop";
    _id?: string | null; 
    name?: string | null; 
    currencySetting?: string | null; 
    defaultLocale?: string | null; 
    address?: Address | null; 
  }

  export type Address =ShopAddressFields.Fragment
}

export namespace SellCardData {
  export type Fragment = {
    __typename?: "CSP";
    _id?: string | null; 
    id?: string | null; 
    title?: string | null; 
    finishes?: (string | null)[] | null; 
    canonicalProductIds?: (string | null)[] | null; 
    image?: Image | null; 
    slug?: string | null; 
  }

  export type Image = {
    __typename?: "core_apimessages_Image";
    source?: string | null; 
  }
}

export namespace GcIndexCardPrices {
  export type Fragment = {
    __typename?: "GearCollectionItem";
    _id?: string | null; 
    id?: string | null; 
    created?: boolean | null; 
    updated?: boolean | null; 
    canonicalProductId?: string | null; 
    price?: Price | null; 
    esPriceEstimate?: EsPriceEstimate | null; 
  }

  export type Price = {
    __typename?: "core_apimessages_Money";
    amountCents?: number | null; 
    currency?: string | null; 
  }

  export type EsPriceEstimate = {
    __typename?: "reverb_search_PriceEstimate";
    priceLow?: PriceLow | null; 
    priceHigh?: PriceHigh | null; 
  }

  export type PriceLow = {
    __typename?: "reverb_search_Money";
    amountCents?: number | null; 
    currency?: string | null; 
  }

  export type PriceHigh = {
    __typename?: "reverb_search_Money";
    amountCents?: number | null; 
    currency?: string | null; 
  }
}

export namespace QuickAddOrderCardFields {
  export type Fragment = {
    __typename?: "Order";
    _id?: string | null; 
    legacyOrderId?: string | null; 
    createdAt?: CreatedAt | null; 
    paidAt?: PaidAt | null; 
    listing?: Listing | null; 
  }

  export type CreatedAt = {
    __typename?: "google_protobuf_Timestamp";
    seconds?: number | null; 
  }

  export type PaidAt = {
    __typename?: "google_protobuf_Timestamp";
    seconds?: number | null; 
  }

  export type Listing = {
    __typename?: "Listing";
    _id?: string | null; 
    title?: string | null; 
    csp?: Csp | null; 
    images?: (Images | null)[] | null; 
  }

  export type Csp = {
    __typename?: "CSP";
    _id?: string | null; 
    id?: string | null; 
  }

  export type Images = {
    __typename?: "core_apimessages_Image";
    source?: string | null; 
  }
}

export namespace GearCollectionIndexCard {
  export type Fragment = {
    __typename?: "GearCollectionItem";
    _id?: string | null; 
    id?: string | null; 
    deleted?: boolean | null; 
    title?: string | null; 
    description?: string | null; 
    tags?: (Tags | null)[] | null; 
    images?: (Images | null)[] | null; 
    listing?: Listing | null; 
    originalListing?: OriginalListing | null; 
    csp?: Csp | null; 
  } & GcIndexCardPrices.Fragment

  export type Tags = {
    __typename?: "core_apimessages_GearCollectionItemTag";
    name?: string | null; 
  }

  export type Images = {
    __typename?: "core_apimessages_Image";
    source?: string | null; 
  }

  export type Listing = {
    __typename?: "Listing";
    _id?: string | null; 
    id?: string | null; 
  }

  export type OriginalListing = {
    __typename?: "Listing";
    _id?: string | null; 
    images?: (_Images | null)[] | null; 
  }

  export type _Images = {
    __typename?: "core_apimessages_Image";
    source?: string | null; 
  }

  export type Csp = {
    __typename?: "CSP";
    _id?: string | null; 
    slug?: string | null; 
    image?: Image | null; 
  }

  export type Image = {
    __typename?: "core_apimessages_Image";
    source?: string | null; 
  }
}

export namespace CSPSummaryCardData {
  export type Fragment = {
    __typename?: "CSP";
    _id?: string | null; 
    id?: string | null; 
    title?: string | null; 
    image?: Image | null; 
  }

  export type Image = {
    __typename?: "core_apimessages_Image";
    source?: string | null; 
  }
}

export namespace CSPCardData {
  export type Fragment = {
    __typename?: "CSP";
    _id?: string | null; 
    id?: string | null; 
    title?: string | null; 
    finishes?: (string | null)[] | null; 
    canonicalProductIds?: (string | null)[] | null; 
    image?: Image | null; 
  }

  export type Image = {
    __typename?: "core_apimessages_Image";
    source?: string | null; 
  }
}

export namespace GearCollectionItemShowDisplay {
  export type Fragment = {
    __typename?: "GearCollectionItem";
    _id?: string | null; 
    id?: string | null; 
    title?: string | null; 
    description?: string | null; 
    notes?: string | null; 
    make?: string | null; 
    model?: string | null; 
    finish?: string | null; 
    year?: string | null; 
    canonicalProductId?: string | null; 
    serialNumber?: string | null; 
    hideListingPhotos?: boolean | null; 
    hideListingDescription?: boolean | null; 
    condition?: Condition | null; 
    tags?: (Tags | null)[] | null; 
    price?: Price | null; 
    ownerCost?: OwnerCost | null; 
    categories?: (Categories | null)[] | null; 
    originalListing?: OriginalListing | null; 
    listing?: Listing | null; 
    csp?: Csp | null; 
    dataServicesPriceEstimate?: DataServicesPriceEstimate | null; 
    images?: (_Images | null)[] | null; 
  }

  export type Condition = {
    __typename?: "core_apimessages_Condition";
    conditionSlug?: string | null; 
  }

  export type Tags = {
    __typename?: "core_apimessages_GearCollectionItemTag";
    name?: string | null; 
  }

  export type Price = {
    __typename?: "core_apimessages_Money";
    amount?: string | null; 
    amountCents?: number | null; 
    currency?: string | null; 
  }

  export type OwnerCost = {
    __typename?: "core_apimessages_Money";
    amount?: string | null; 
    amountCents?: number | null; 
    currency?: string | null; 
  }

  export type Categories = {
    __typename?: "Category";
    _id?: string | null; 
    id?: string | null; 
    name?: string | null; 
    root?: boolean | null; 
    leaf?: boolean | null; 
  }

  export type OriginalListing = {
    __typename?: "Listing";
    _id?: string | null; 
    id?: string | null; 
    description?: string | null; 
    title?: string | null; 
    images?: (Images | null)[] | null; 
  }

  export type Images = {
    __typename?: "core_apimessages_Image";
    source?: string | null; 
  }

  export type Listing = {
    __typename?: "Listing";
    _id?: string | null; 
    id?: string | null; 
  }

  export type Csp = {
    __typename?: "CSP";
    _id?: string | null; 
    id?: string | null; 
    title?: string | null; 
    image?: Image | null; 
  }

  export type Image = {
    __typename?: "core_apimessages_Image";
    source?: string | null; 
  }

  export type DataServicesPriceEstimate = {
    __typename?: "reverb_pricing_PriceRecommendation";
    priceLow?: PriceLow | null; 
    priceHigh?: PriceHigh | null; 
    priceMiddle?: PriceMiddle | null; 
    priceMiddleThirtyDaysAgo?: PriceMiddleThirtyDaysAgo | null; 
  }

  export type PriceLow = {
    __typename?: "reverb_pricing_Money";
    amountCents?: number | null; 
    currency?: string | null; 
  }

  export type PriceHigh = {
    __typename?: "reverb_pricing_Money";
    amountCents?: number | null; 
    currency?: string | null; 
  }

  export type PriceMiddle = {
    __typename?: "reverb_pricing_Money";
    amountCents?: number | null; 
    currency?: string | null; 
  }

  export type PriceMiddleThirtyDaysAgo = {
    __typename?: "reverb_pricing_Money";
    amountCents?: number | null; 
    currency?: string | null; 
  }

  export type _Images = {
    __typename?: "core_apimessages_Image";
    id?: string | null; 
    source?: string | null; 
    publicId?: string | null; 
    version?: string | null; 
    fallbackType?: core_apimessages_Image_FallbackType | null; 
    transformation?: Transformation | null; 
  }

  export type Transformation = {
    __typename?: "core_apimessages_ImageEntry_Transformation";
    x?: string | null; 
    y?: string | null; 
    width?: string | null; 
    height?: string | null; 
    angle?: number | null; 
    crop?: string | null; 
  }
}

export namespace RecommendedShopsRowListingFields {
  export type Fragment = {
    __typename?: "Listing";
    _id?: string | null; 
    id?: string | null; 
    brandSlug?: string | null; 
    categories?: (Categories | null)[] | null; 
  }

  export type Categories = {
    __typename?: "Category";
    _id?: string | null; 
    slug?: string | null; 
  }
}

export namespace Item2ReturnPolicyData {
  export type Fragment = {
    __typename?: "Listing";
    _id?: string | null; 
    condition?: Condition | null; 
    shop?: Shop | null; 
    soldAsIs?: boolean | null; 
  }

  export type Condition = {
    __typename?: "core_apimessages_Condition";
    conditionSlug?: string | null; 
  }

  export type Shop = {
    __typename?: "Shop";
    _id?: string | null; 
    returnPolicy?: ReturnPolicy | null; 
  }

  export type ReturnPolicy = {
    __typename?: "core_apimessages_ReturnPolicy";
    newReturnWindowDays?: number | null; 
    usedReturnWindowDays?: number | null; 
  }
}

export namespace Item2Image {
  export type Fragment = {
    __typename?: "Listing";
    _id?: string | null; 
    title?: string | null; 
    state?: string | null; 
    largeImages?: (LargeImages | null)[] | null; 
    supersizeImages?: (SupersizeImages | null)[] | null; 
    cardSquareImages?: (CardSquareImages | null)[] | null; 
    video?: Video | null; 
    csp?: Csp | null; 
  }

  export type LargeImages = {
    __typename?: "core_apimessages_Image";
    source?: string | null; 
  }

  export type SupersizeImages = {
    __typename?: "core_apimessages_Image";
    source?: string | null; 
  }

  export type CardSquareImages = {
    __typename?: "core_apimessages_Image";
    source?: string | null; 
  }

  export type Video = {
    __typename?: "core_apimessages_Video";
    youtubeVideoId?: string | null; 
    empty?: boolean | null; 
  }

  export type Csp = {
    __typename?: "CSP";
    _id?: string | null; 
    videos?: Videos | null; 
  }

  export type Videos = {
    __typename?: "core_apimessages_CSPVideo";
    videoLinks?: (VideoLinks | null)[] | null; 
  }

  export type VideoLinks = {
    __typename?: "core_apimessages_VideoLink";
    youtubeVideoId?: string | null; 
  }
}

export namespace CSP2HeaderData {
  export type Fragment = {
    __typename?: "CSP";
    _id?: string | null; 
    id?: string | null; 
    title?: string | null; 
    brand?: Brand | null; 
    categories?: (Categories | null)[] | null; 
    cspImage?: (CspImage | null)[] | null; 
    specs?: Specs | null; 
  }

  export type Brand = {
    __typename?: "Brand";
    _id?: string | null; 
    name?: string | null; 
    webLink?: WebLink | null; 
  }

  export type WebLink = {
    __typename?: "core_apimessages_Link";
    href?: string | null; 
  }

  export type Categories = {
    __typename?: "Category";
    _id?: string | null; 
    name?: string | null; 
    cmsUrl?: CmsUrl | null; 
  }

  export type CmsUrl = {
    __typename?: "core_apimessages_Link";
    href?: string | null; 
  }

  export type CspImage = {
    __typename?: "core_apimessages_Image";
    source?: string | null; 
  }

  export type Specs = {
    __typename?: "core_apimessages_CSPSpec";
    productSpecs?: (ProductSpecs | null)[] | null; 
  }

  export type ProductSpecs = {
    __typename?: "core_apimessages_ProductSpec";
    type?: core_apimessages_ProductSpec_Type | null; 
    name?: string | null; 
    value?: string | null; 
    path?: string | null; 
  }
}

export namespace CreditCardWalletLayoutFields {
  export type Fragment =CreditCardWalletRowFields.Fragment
}

export namespace CheckoutContinueButtonFields {
  export type Fragment = {
    __typename?: "Checkout";
    _id?: string | null; 
    id?: string | null; 
    paymentMethod?: PaymentMethod | null; 
  } & CheckoutCardContinueButtonFields.Fragment

  export type PaymentMethod = {
    __typename?: "core_apimessages_CheckoutPaymentMethod";
    type?: core_apimessages_CheckoutPaymentMethod_Type | null; 
  }
}

export namespace Item2ProductViewTrackingData {
  export type Fragment = {
    __typename?: "Listing";
    _id?: string | null; 
  } & mParticleListingFields.Fragment
}

export namespace ShippingLabelOrderData {
  export type Fragment = {
    __typename?: "Order";
    _id?: string | null; 
    id?: string | null; 
    buyerUuid?: string | null; 
    shippingMethod?: core_apimessages_ShippingMethod | null; 
    legacyOrderId?: string | null; 
    quantity?: number | null; 
    listingId?: string | null; 
    settlementAmountProductSubtotal?: SettlementAmountProductSubtotal | null; 
    createdAt?: CreatedAt | null; 
    paidAt?: PaidAt | null; 
    customsInfo?: CustomsInfo | null; 
    amountShipping?: AmountShipping | null; 
    carrierCalculatedShippingAmount?: CarrierCalculatedShippingAmount | null; 
  }

  export type SettlementAmountProductSubtotal = {
    __typename?: "core_apimessages_Money";
    amount?: string | null; 
    amountCents?: number | null; 
    currency?: string | null; 
    symbol?: string | null; 
  }

  export type CreatedAt = {
    __typename?: "google_protobuf_Timestamp";
    seconds?: number | null; 
  }

  export type PaidAt = {
    __typename?: "google_protobuf_Timestamp";
    seconds?: number | null; 
  }

  export type CustomsInfo = {
    __typename?: "core_apimessages_OrderCustomsInfo";
    description?: string | null; 
    tariffNumber?: string | null; 
    categoryName?: string | null; 
    countryOfOrigin?: string | null; 
  }

  export type AmountShipping = {
    __typename?: "core_apimessages_Money";
    amount?: string | null; 
    amountCents?: number | null; 
    currency?: string | null; 
    symbol?: string | null; 
    display?: string | null; 
  }

  export type CarrierCalculatedShippingAmount = {
    __typename?: "core_apimessages_Money";
    amount?: string | null; 
    amountCents?: number | null; 
    currency?: string | null; 
    symbol?: string | null; 
    display?: string | null; 
  }
}

export namespace ShippingLabelCountriesData {
  export type Fragment = {
    __typename?: "core_apimessages_Country";
    name?: string | null; 
    countryCode?: string | null; 
    subregionRequired?: boolean | null; 
    subregions?: (Subregions | null)[] | null; 
  }

  export type Subregions = {
    __typename?: "core_apimessages_Subregion";
    code?: string | null; 
    name?: string | null; 
  }
}

export namespace ShippingLabelListingData {
  export type Fragment = {
    __typename?: "Listing";
    _id?: string | null; 
    title?: string | null; 
    merchandisingType?: string | null; 
    images?: (Images | null)[] | null; 
  }

  export type Images = {
    __typename?: "core_apimessages_Image";
    source?: string | null; 
  }
}

export namespace SimilarListingsFields {
  export type Fragment = {
    __typename?: "Listing";
    _id?: string | null; 
    id?: string | null; 
  } & ListingCardFields.Fragment & AddToCartButtonData.Fragment
}

export namespace ShopMetadataFragment {
  export type Fragment = {
    __typename?: "Shop";
    _id?: string | null; 
    name?: string | null; 
    slug?: string | null; 
    user?: User | null; 
  }

  export type User = {
    __typename?: "User";
    _id?: string | null; 
    feedbackSummary?: FeedbackSummary | null; 
  }

  export type FeedbackSummary = {
    __typename?: "core_apimessages_FeedbackSummary";
    rollingRatingPercentage?: number | null; 
    receivedCount?: number | null; 
  }
}

export namespace ShopReturnPoliciesFragment {
  export type Fragment = {
    __typename?: "Shop";
    _id?: string | null; 
    userUuid?: string | null; 
    returnPolicy?: ReturnPolicy | null; 
  }

  export type ReturnPolicy = {
    __typename?: "core_apimessages_ReturnPolicy";
    newReturnWindowDays?: number | null; 
    usedReturnWindowDays?: number | null; 
    restockingFeePercent?: number | null; 
    specialConditions?: string | null; 
  }
}

export namespace ShopContainerFragment {
  export type Fragment = {
    __typename?: "Shop";
    _id?: string | null; 
    id?: string | null; 
    showSold?: boolean | null; 
    slug?: string | null; 
    freeDomesticShippingRate?: FreeDomesticShippingRate | null; 
    sales?: (Sales | null)[] | null; 
  }

  export type FreeDomesticShippingRate = {
    __typename?: "core_apimessages_ShippingRates";
    regionCode?: string | null; 
    freeShippingThreshold?: FreeShippingThreshold | null; 
  }

  export type FreeShippingThreshold = {
    __typename?: "core_apimessages_Money";
    display?: string | null; 
  }

  export type Sales = {
    __typename?: "core_apimessages_Sale";
    slug?: string | null; 
    name?: string | null; 
    endsAt?: EndsAt | null; 
    percent?: number | null; 
    buyerIneligibilityReason?: string | null; 
    showCode?: boolean | null; 
  }

  export type EndsAt = {
    __typename?: "google_protobuf_Timestamp";
    seconds?: number | null; 
  }
}

export namespace ShopHeaderFragment {
  export type Fragment = {
    __typename?: "Shop";
    _id?: string | null; 
    slug?: string | null; 
    name?: string | null; 
    preferredSeller?: boolean | null; 
    quickShipper?: boolean | null; 
    quickResponder?: boolean | null; 
    description?: string | null; 
    userUuid?: string | null; 
    userId?: string | null; 
    address?: Address | null; 
    banner?: Banner | null; 
    user?: User | null; 
  }

  export type Address = {
    __typename?: "core_apimessages_Address";
    displayLocation?: string | null; 
  }

  export type Banner = {
    __typename?: "core_apimessages_Image";
    source?: string | null; 
  }

  export type User = {
    __typename?: "User";
    _id?: string | null; 
    id?: string | null; 
    avatar?: Avatar | null; 
  }

  export type Avatar = {
    __typename?: "core_apimessages_Image";
    source?: string | null; 
  }
}

export namespace ShopTabsFragment {
  export type Fragment = {
    __typename?: "Shop";
    _id?: string | null; 
    user?: User | null; 
  }

  export type User = {
    __typename?: "User";
    _id?: string | null; 
    feedbackSummary?: FeedbackSummary | null; 
  }

  export type FeedbackSummary = {
    __typename?: "core_apimessages_FeedbackSummary";
    rollingRatingPercentage?: number | null; 
    receivedCount?: number | null; 
  }
}

export namespace ShopTaxPoliciesData {
  export type Fragment = {
    __typename?: "Shop";
    _id?: string | null; 
    taxPolicies?: (TaxPolicies | null)[] | null; 
  }

  export type TaxPolicies = {
    __typename?: "core_apimessages_ShopTaxPolicy";
    displayLocation?: string | null; 
    displayRate?: string | null; 
    policyType?: core_apimessages_ShopTaxPolicy_PolicyType | null; 
  }
}

export namespace ReverbHeaderUserMenuData {
  export type Fragment = {
    __typename?: "rql_Me";
    shop?: Shop | null; 
    reverbCredits?: (ReverbCredits | null)[] | null; 
    payoutBalances?: (PayoutBalances | null)[] | null; 
  }

  export type Shop = {
    __typename?: "MyShop";
    _id?: string | null; 
    slug?: string | null; 
    paymentMethod?: core_apimessages_MyShopOnboardingResponse_PaymentMethod | null; 
  }

  export type ReverbCredits = {
    __typename?: "core_apimessages_Money";
    display?: string | null; 
    currency?: string | null; 
  }

  export type PayoutBalances = {
    __typename?: "core_apimessages_Money";
    display?: string | null; 
    currency?: string | null; 
  }
}

export namespace ReverbHeaderCartBadgeData {
  export type Fragment = {
    __typename?: "rql_Me";
    reverbCredits?: (ReverbCredits | null)[] | null; 
  }

  export type ReverbCredits = {
    __typename?: "core_apimessages_Money";
    display?: string | null; 
    currency?: string | null; 
  }
}

export namespace PhotoTileData {
  export type Fragment = {
    __typename?: "Listing";
    _id?: string | null; 
    id?: string | null; 
    slug?: string | null; 
    title?: string | null; 
    images?: (Images | null)[] | null; 
  }

  export type Images = {
    __typename?: "core_apimessages_Image";
    source?: string | null; 
  }
}

export namespace CheckoutOrderSummaryOrderItemShippingTotalFields {
  export type Fragment = {
    __typename?: "Checkout";
    _id?: string | null; 
    orders?: (Orders | null)[] | null; 
  }

  export type Orders = {
    __typename?: "core_apimessages_CheckoutOrder";
    shippingTotal?: ShippingTotal | null; 
  }

  export type ShippingTotal = {
    __typename?: "core_apimessages_CheckoutOrder_ShippingTotal";
    originalAmountOwed?: OriginalAmountOwed | null; 
    amountOwed?: AmountOwed | null; 
    discounted?: boolean | null; 
    discount?: Discount | null; 
  }

  export type OriginalAmountOwed = {
    __typename?: "core_apimessages_Money";
    display?: string | null; 
  }

  export type AmountOwed = {
    __typename?: "core_apimessages_Money";
    display?: string | null; 
  }

  export type Discount = {
    __typename?: "core_apimessages_CheckoutOrder_ShippingTotalDiscount";
    type?: core_apimessages_CheckoutOrder_ShippingTotalDiscount_Type | null; 
    label?: string | null; 
  }
}

export namespace Item2BuyingGuideData {
  export type Fragment = {
    __typename?: "Listing";
    _id?: string | null; 
    make?: string | null; 
    model?: string | null; 
    categories?: (Categories | null)[] | null; 
  }

  export type Categories = {
    __typename?: "Category";
    _id?: string | null; 
    slug?: string | null; 
  }
}

export namespace FeaturedListingModuleData {
  export type Fragment = {
    __typename?: "Listing";
    _id?: string | null; 
    title?: string | null; 
    slug?: string | null; 
    description?: string | null; 
    condition?: Condition | null; 
  } & Item2Image.Fragment & FeaturedListingShopInfoData.Fragment & Item2PricingData.Fragment & Item2ReturnPolicyData.Fragment

  export type Condition = {
    __typename?: "core_apimessages_Condition";
    displayName?: string | null; 
    conditionSlug?: string | null; 
  }
}

export namespace CheckoutCreditCardWalletFields {
  export type Fragment = {
    __typename?: "Checkout";
    _id?: string | null; 
    id?: string | null; 
    shippingAddress?: ShippingAddress | null; 
    paymentMethod?: PaymentMethod | null; 
    creditCard?: CreditCard | null; 
  } & CheckoutCreditCardSummaryFields.Fragment

  export type ShippingAddress = {
    __typename?: "core_apimessages_Address";
    uuid?: string | null; 
    id?: string | null; 
  }

  export type PaymentMethod = {
    __typename?: "core_apimessages_CheckoutPaymentMethod";
    isComplete?: boolean | null; 
  }

  export type CreditCard = {
    __typename?: "core_apimessages_CreditCard";
    id?: string | null; 
  }
}

export namespace CheckoutActionHookFields {
  export type Fragment = {
    __typename?: "CheckoutAction";
    _id?: string | null; 
    type?: core_apimessages_CheckoutAction_Type | null; 
    redirectUrl?: string | null; 
  }
}

export namespace CompareOtherSellersLinkData {
  export type Fragment = {
    __typename?: "Listing";
    _id?: string | null; 
    csp?: Csp | null; 
  }

  export type Csp = {
    __typename?: "CSP";
    _id?: string | null; 
    id?: string | null; 
    webLink?: WebLink | null; 
  }

  export type WebLink = {
    __typename?: "core_apimessages_Link";
    href?: string | null; 
  }
}

export namespace CheckoutOrderQuantitySelectorFields {
  export type Fragment = {
    __typename?: "Checkout";
    _id?: string | null; 
    orders?: (Orders | null)[] | null; 
  }

  export type Orders = {
    __typename?: "core_apimessages_CheckoutOrder";
    quantity?: number | null; 
    listingId?: string | null; 
    buyerCanChangeQuantity?: boolean | null; 
    listing?: Listing | null; 
  }

  export type Listing = {
    __typename?: "Listing";
    _id?: string | null; 
    allowedBuyerQuantity?: number | null; 
    inventory?: number | null; 
  }
}

export namespace CountriesData {
  export type Fragment = {
    __typename?: "Query";
    countries?: Countries | null; 
  }

  export type Countries = {
    __typename?: "core_apimessages_CountriesResponse";
    countries?: (_Countries | null)[] | null; 
  }

  export type _Countries = {
    __typename?: "core_apimessages_Country";
    name?: string | null; 
    countryCode?: string | null; 
  }
}

export namespace CheckoutOrderSummaryImageFields {
  export type Fragment = {
    __typename?: "Checkout";
    _id?: string | null; 
    orders?: (Orders | null)[] | null; 
  }

  export type Orders = {
    __typename?: "core_apimessages_CheckoutOrder";
    listing?: Listing | null; 
  }

  export type Listing = {
    __typename?: "Listing";
    _id?: string | null; 
    title?: string | null; 
    images?: (Images | null)[] | null; 
  }

  export type Images = {
    __typename?: "core_apimessages_Image";
    source?: string | null; 
  }
}

export namespace TopProductsCategory {
  export type Fragment = {
    __typename?: "Category";
    _id?: string | null; 
    id?: string | null; 
    slug?: string | null; 
    children?: (Children | null)[] | null; 
  }

  export type Children = {
    __typename?: "core_apimessages_Category";
    name?: string | null; 
    slug?: string | null; 
  }
}

export namespace TopProductsCSP {
  export type Fragment = {
    __typename?: "CSP";
    _id?: string | null; 
    summary?: string | null; 
    categories?: (Categories | null)[] | null; 
  } & CSPCard.Fragment

  export type Categories = {
    __typename?: "Category";
    _id?: string | null; 
    name?: string | null; 
  }
}

export namespace KlarnaPaymentPlanFields {
  export type Fragment = {
    __typename?: "Listing";
    _id?: string | null; 
    pricing?: Pricing | null; 
    shippingPrice?: ShippingPrice | null; 
  }

  export type Pricing = {
    __typename?: "core_apimessages_ListingPricing";
    buyerPrice?: BuyerPrice | null; 
  }

  export type BuyerPrice = {
    __typename?: "core_apimessages_Money";
    amountCents?: number | null; 
    currency?: string | null; 
  }

  export type ShippingPrice = {
    __typename?: "core_apimessages_Money";
    amountCents?: number | null; 
  }
}

export namespace myShopBillingMethods {
  export type Fragment = {
    __typename?: "rql_Me";
    uuid?: string | null; 
    shop?: Shop | null; 
    creditCards?: (CreditCards | null)[] | null; 
  }

  export type Shop = {
    __typename?: "MyShop";
    _id?: string | null; 
    id?: string | null; 
    currency?: string | null; 
    originCountryCode?: string | null; 
    shopType?: core_apimessages_Shop_ShopType | null; 
    billingMethodStatus?: core_apimessages_MyShopOnboardingResponse_BillingMethodStatus | null; 
    paypalSetupStatus?: core_apimessages_MyShopOnboardingResponse_PaypalSetupStatus | null; 
    paypalProfile?: PaypalProfile | null; 
  }

  export type PaypalProfile = {
    __typename?: "core_apimessages_MyShopPaypalProfileResponse_PaypalProfile";
    email?: string | null; 
  }

  export type CreditCards = {
    __typename?: "core_apimessages_CreditCard";
    id?: string | null; 
    last4?: string | null; 
    cardType?: string | null; 
    expirationYear?: string | null; 
    expirationMonth?: string | null; 
    cardholderName?: string | null; 
    primaryBilling?: boolean | null; 
    address?: Address | null; 
  }

  export type Address = {
    __typename?: "core_apimessages_Address";
    postalCode?: string | null; 
    countryCode?: string | null; 
  }
}

export namespace Item2DescriptionData {
  export type Fragment = {
    __typename?: "Listing";
    _id?: string | null; 
    id?: string | null; 
    description?: string | null; 
    soldAsIs?: boolean | null; 
  } & Item2Prop65WarningData.Fragment
}

export namespace CreditCardWalletRowFields {
  export type Fragment = {
    __typename?: "rql_Me";
    uuid?: string | null; 
    creditCards?: (CreditCards | null)[] | null; 
  } & CreditCardWalletRowSummaryFields.Fragment

  export type CreditCards = {
    __typename?: "core_apimessages_CreditCard";
    id?: string | null; 
  }
}

export namespace Item2ShopTaxPoliciesData {
  export type Fragment = {
    __typename?: "Listing";
    _id?: string | null; 
    taxPolicies?: (TaxPolicies | null)[] | null; 
  }

  export type TaxPolicies = {
    __typename?: "core_apimessages_ShopTaxPolicy";
    displayRate?: string | null; 
    displayLocation?: string | null; 
    policyType?: core_apimessages_ShopTaxPolicy_PolicyType | null; 
  }
}

export namespace CreditCardWalletCreateFormFields {
  export type Fragment = {
    __typename?: "rql_Me";
    shippingAddresses?: (ShippingAddresses | null)[] | null; 
  }

  export type ShippingAddresses = {
    __typename?: "core_apimessages_Address";
    id?: string | null; 
    uuid?: string | null; 
    name?: string | null; 
    streetAddress?: string | null; 
    extendedAddress?: string | null; 
    postalCode?: string | null; 
    region?: string | null; 
    regionName?: string | null; 
    locality?: string | null; 
    phone?: string | null; 
    primary?: boolean | null; 
    isComplete?: boolean | null; 
    countryCode?: string | null; 
    country?: Country | null; 
  }

  export type Country = {
    __typename?: "core_apimessages_Country";
    name?: string | null; 
  }
}

export namespace CheckoutGuestCreditCardCreateFormFields {
  export type Fragment = {
    __typename?: "Checkout";
    _id?: string | null; 
    id?: string | null; 
    paymentMethod?: PaymentMethod | null; 
    shippingAddress?: ShippingAddress | null; 
  } & CheckoutCreditCardSummaryFields.Fragment & CheckoutTrackingFields.Fragment

  export type PaymentMethod = {
    __typename?: "core_apimessages_CheckoutPaymentMethod";
    isComplete?: boolean | null; 
  }

  export type ShippingAddress = {
    __typename?: "core_apimessages_Address";
    id?: string | null; 
    uuid?: string | null; 
    name?: string | null; 
    streetAddress?: string | null; 
    extendedAddress?: string | null; 
    postalCode?: string | null; 
    region?: string | null; 
    regionName?: string | null; 
    locality?: string | null; 
    phone?: string | null; 
    primary?: boolean | null; 
    isComplete?: boolean | null; 
    countryCode?: string | null; 
    country?: Country | null; 
  }

  export type Country = {
    __typename?: "core_apimessages_Country";
    name?: string | null; 
  }
}

export namespace CheckoutExistingShippingAddressFormFields {
  export type Fragment = {
    __typename?: "Checkout";
    _id?: string | null; 
    id?: string | null; 
    shippingAddress?: ShippingAddress | null; 
  } & CheckoutTrackingFields.Fragment

  export type ShippingAddress = {
    __typename?: "core_apimessages_Address";
    id?: string | null; 
  }
}

export namespace Item2Prop65WarningData {
  export type Fragment = {
    __typename?: "Listing";
    _id?: string | null; 
    sellerId?: string | null; 
    propSixtyFiveWarning?: string | null; 
    propSixtyFiveWarningImg?: PropSixtyFiveWarningImg | null; 
  }

  export type PropSixtyFiveWarningImg = {
    __typename?: "core_apimessages_Link";
    href?: string | null; 
  }
}

export namespace CheckoutNewShippingAddressFormFields {
  export type Fragment = {
    __typename?: "Checkout";
    _id?: string | null; 
    id?: string | null; 
    guest?: Guest | null; 
    shippingAddress?: ShippingAddress | null; 
  }

  export type Guest = {
    __typename?: "core_apimessages_CheckoutGuest";
    firstName?: string | null; 
    lastName?: string | null; 
    email?: string | null; 
  }

  export type ShippingAddress = {
    __typename?: "core_apimessages_Address";
    name?: string | null; 
    streetAddress?: string | null; 
    extendedAddress?: string | null; 
    locality?: string | null; 
    region?: string | null; 
    postalCode?: string | null; 
    countryCode?: string | null; 
    phone?: string | null; 
  }
}

export namespace Item2ShopListingData {
  export type Fragment = {
    __typename?: "Listing";
    _id?: string | null; 
    id?: string | null; 
    state?: string | null; 
    seller?: Seller | null; 
    shop?: Shop | null; 
    shipping?: Shipping | null; 
  }

  export type Seller = {
    __typename?: "User";
    _id?: string | null; 
    id?: string | null; 
    uuid?: string | null; 
    feedbackSummary?: FeedbackSummary | null; 
  }

  export type FeedbackSummary = {
    __typename?: "core_apimessages_FeedbackSummary";
    rollingRatingPercentage?: number | null; 
    receivedCount?: number | null; 
  }

  export type Shop = {
    __typename?: "Shop";
    _id?: string | null; 
    name?: string | null; 
    slug?: string | null; 
    preferredSeller?: boolean | null; 
    quickShipper?: boolean | null; 
    quickResponder?: boolean | null; 
    address?: Address | null; 
    paymentPolicy?: string | null; 
    createdAt?: Timestamp | null; 
    orders?: Orders | null; 
  }

  export type Address = {
    __typename?: "core_apimessages_Address";
    displayLocation?: string | null; 
    countryCode?: string | null; 
    country?: Country | null; 
  }

  export type Country = {
    __typename?: "core_apimessages_Country";
    name?: string | null; 
  }

  export type Orders = {
    __typename?: "reverb_search_SearchResponse";
    total?: number | null; 
  }

  export type Shipping = {
    __typename?: "core_apimessages_ShippingPrices";
    localPickupOnly?: boolean | null; 
  }
}

export namespace ListingFinancingCalloutFields {
  export type Fragment = {
    __typename?: "Listing";
    _id?: string | null; 
    acceptedPaymentMethods?: (string | null)[] | null; 
  } & Item2AffirmCalloutData.Fragment & KlarnaCalloutListingFields.Fragment
}

export namespace Item2OrderDetailsData {
  export type Fragment = {
    __typename?: "Listing";
    _id?: string | null; 
    orders?: Orders | null; 
  }

  export type Orders = {
    __typename?: "OrderCollection";
    nodes?: (Nodes | null)[] | null; 
  }

  export type Nodes = {
    __typename?: "Order";
    _id?: string | null; 
    legacyOrderId?: string | null; 
    status?: core_apimessages_Order_Status | null; 
    paidAt?: PaidAt | null; 
    orderUrl?: OrderUrl | null; 
    createdAt?: CreatedAt | null; 
  }

  export type PaidAt = {
    __typename?: "google_protobuf_Timestamp";
    seconds?: number | null; 
  }

  export type OrderUrl = {
    __typename?: "core_apimessages_Link";
    href?: string | null; 
  }

  export type CreatedAt = {
    __typename?: "google_protobuf_Timestamp";
    seconds?: number | null; 
  }
}

export namespace CheckoutCreditCardFormFields {
  export type Fragment = {
    __typename?: "Checkout";
    _id?: string | null; 
  } & CheckoutCreditCardWalletFields.Fragment & CheckoutStandardCreditCardCreateFormFields.Fragment
}

export namespace Item2ListingPaymentPoliciesData {
  export type Fragment = {
    __typename?: "Listing";
    _id?: string | null; 
    acceptedPaymentMethods?: (string | null)[] | null; 
  }
}

export namespace MyAccountCreditCardEditFormFields {
  export type Fragment = {
    __typename?: "rql_Me";
    creditCards?: (CreditCards | null)[] | null; 
  } & CreditCardWalletRowFields.Fragment

  export type CreditCards = {
    __typename?: "core_apimessages_CreditCard";
    brand?: Brand | null; 
    display?: Display | null; 
  }

  export type Brand = {
    __typename?: "core_apimessages_CreditCard_Brand";
    type?: core_apimessages_CreditCard_Brand_Type | null; 
    name?: string | null; 
  }

  export type Display = {
    __typename?: "core_apimessages_CreditCard_Display";
    summary?: string | null; 
  }
}

export namespace Item2MetadataData {
  export type Fragment = {
    __typename?: "Listing";
    _id?: string | null; 
    id?: string | null; 
    title?: string | null; 
    description?: string | null; 
    finish?: string | null; 
    make?: string | null; 
    model?: string | null; 
    slug?: string | null; 
    inventory?: number | null; 
    state?: string | null; 
    brandSlug?: string | null; 
    categories?: (Categories | null)[] | null; 
    condition?: Condition | null; 
    pricing?: Pricing | null; 
    preorderInfo?: PreorderInfo | null; 
    csp?: Csp | null; 
    shop?: Shop | null; 
    metaImage?: (MetaImage | null)[] | null; 
    experiments?: (Experiments | null)[] | null; 
  }

  export type Categories = {
    __typename?: "Category";
    _id?: string | null; 
    id?: string | null; 
    name?: string | null; 
    rootSlug?: string | null; 
    cmsLink?: CmsLink | null; 
  }

  export type CmsLink = {
    __typename?: "core_apimessages_Link";
    href?: string | null; 
  }

  export type Condition = {
    __typename?: "core_apimessages_Condition";
    conditionSlug?: string | null; 
  }

  export type Pricing = {
    __typename?: "core_apimessages_ListingPricing";
    buyerPrice?: BuyerPrice | null; 
  }

  export type BuyerPrice = {
    __typename?: "core_apimessages_Money";
    amount?: string | null; 
    currency?: string | null; 
  }

  export type PreorderInfo = {
    __typename?: "core_apimessages_PreorderInfo";
    onPreorder?: boolean | null; 
  }

  export type Csp = {
    __typename?: "CSP";
    _id?: string | null; 
    reviews?: Reviews | null; 
  }

  export type Reviews = {
    __typename?: "core_apimessages_CSPReviews";
    total?: number | null; 
    avgRating?: number | null; 
  }

  export type Shop = {
    __typename?: "Shop";
    _id?: string | null; 
    name?: string | null; 
    onVacation?: boolean | null; 
  }

  export type MetaImage = {
    __typename?: "core_apimessages_Image";
    source?: string | null; 
  }

  export type Experiments = {
    __typename?: "core_apimessages_NonUserExperiment";
    name?: string | null; 
    bucket?: string | null; 
  }
}

export namespace CheckoutOrderSummaryLineItemsFields {
  export type Fragment = {
    __typename?: "Checkout";
    _id?: string | null; 
    lineItems?: (LineItems | null)[] | null; 
  }

  export type LineItems = {
    __typename?: "core_apimessages_CheckoutLineItem";
    type?: core_apimessages_CheckoutLineItem_Type | null; 
    label?: string | null; 
    amount?: Amount | null; 
  }

  export type Amount = {
    __typename?: "core_apimessages_Money";
    display?: string | null; 
    currency?: string | null; 
  }
}

export namespace TransactionTablePriceRecordsData {
  export type Fragment = {
    __typename?: "PublicPriceRecord";
    _id?: string | null; 
    condition?: Condition | null; 
    createdAt?: CreatedAt | null; 
    amountProduct?: AmountProduct | null; 
  }

  export type Condition = {
    __typename?: "core_apimessages_Condition";
    displayName?: string | null; 
  }

  export type CreatedAt = {
    __typename?: "google_protobuf_Timestamp";
    seconds?: number | null; 
  }

  export type AmountProduct = {
    __typename?: "core_apimessages_Money";
    display?: string | null; 
  }
}

export namespace PriceGuideToolFormContainerData {
  export type Fragment = {
    __typename?: "CSP";
    _id?: string | null; 
    id?: string | null; 
    title?: string | null; 
    brand?: Brand | null; 
    categoryRootUuid?: string | null; 
    categoryUuids?: (string | null)[] | null; 
    image?: Image | null; 
    variants?: (Variants | null)[] | null; 
    slug?: string | null; 
  }

  export type Brand = {
    __typename?: "Brand";
    _id?: string | null; 
    id?: string | null; 
    name?: string | null; 
  }

  export type Image = {
    __typename?: "core_apimessages_Image";
    source?: string | null; 
  }

  export type Variants = {
    __typename?: "core_apimessages_CspVariant";
    id?: string | null; 
    finish?: string | null; 
    model?: string | null; 
    name?: string | null; 
    year?: string | null; 
  }
}

export namespace CSPProductFamilyCTAData {
  export type Fragment = {
    __typename?: "CSP";
    _id?: string | null; 
    productFamilyCalloutImage?: ProductFamilyCalloutImage | null; 
    specs?: Specs | null; 
  }

  export type ProductFamilyCalloutImage = {
    __typename?: "core_apimessages_Image";
    source?: string | null; 
  }

  export type Specs = {
    __typename?: "core_apimessages_CSPSpec";
    productSpecs?: (ProductSpecs | null)[] | null; 
  }

  export type ProductSpecs = {
    __typename?: "core_apimessages_ProductSpec";
    type?: core_apimessages_ProductSpec_Type | null; 
    name?: string | null; 
    value?: string | null; 
    path?: string | null; 
  }
}

export namespace Item2ShopReviewsData {
  export type Fragment = {
    __typename?: "Listing";
    _id?: string | null; 
    sellerUuid?: string | null; 
    shop?: Shop | null; 
    seller?: Seller | null; 
  }

  export type Shop = {
    __typename?: "Shop";
    _id?: string | null; 
    id?: string | null; 
  }

  export type Seller = {
    __typename?: "User";
    _id?: string | null; 
    feedbackSummary?: FeedbackSummary | null; 
  }

  export type FeedbackSummary = {
    __typename?: "core_apimessages_FeedbackSummary";
    receivedCount?: number | null; 
    rollingRatingPercentage?: number | null; 
  }
}

export namespace MyAccountCreditCardListFields {
  export type Fragment = {
    __typename?: "rql_Me";
    creditCards?: (CreditCards | null)[] | null; 
  } & MyAccountCreditCardEditFormFields.Fragment

  export type CreditCards = {
    __typename?: "core_apimessages_CreditCard";
    id?: string | null; 
  }
}

export namespace CreditCardWalletRowSummaryFields {
  export type Fragment = {
    __typename?: "rql_Me";
    uuid?: string | null; 
    creditCards?: (CreditCards | null)[] | null; 
  }

  export type CreditCards = {
    __typename?: "core_apimessages_CreditCard";
    id?: string | null; 
    primaryForCheckout?: boolean | null; 
    display?: Display | null; 
    brand?: Brand | null; 
    address?: Address | null; 
  }

  export type Display = {
    __typename?: "core_apimessages_CreditCard_Display";
    summary?: string | null; 
    expirationDate?: string | null; 
  }

  export type Brand = {
    __typename?: "core_apimessages_CreditCard_Brand";
    type?: core_apimessages_CreditCard_Brand_Type | null; 
    name?: string | null; 
  }

  export type Address = {
    __typename?: "core_apimessages_Address";
    name?: string | null; 
    streetAddress?: string | null; 
    extendedAddress?: string | null; 
    locality?: string | null; 
    regionName?: string | null; 
    postalCode?: string | null; 
    country?: Country | null; 
  }

  export type Country = {
    __typename?: "core_apimessages_Country";
    countryCode?: string | null; 
  }
}

export namespace CheckoutOrderShippingSelectorFields {
  export type Fragment = {
    __typename?: "Checkout";
    _id?: string | null; 
    orders?: (Orders | null)[] | null; 
  }

  export type Orders = {
    __typename?: "core_apimessages_CheckoutOrder";
    listingId?: string | null; 
    availableShippingMethods?: (AvailableShippingMethods | null)[] | null; 
    shippingMethod?: ShippingMethod | null; 
  }

  export type AvailableShippingMethods = {
    __typename?: "core_apimessages_CheckoutShippingMethod";
    name?: string | null; 
    type?: core_apimessages_ShippingMethod | null; 
  }

  export type ShippingMethod = {
    __typename?: "core_apimessages_CheckoutShippingMethod";
    name?: string | null; 
    type?: core_apimessages_ShippingMethod | null; 
  }
}

export namespace SignalsData {
  export type Fragment = {
    __typename?: "Listing";
    _id?: string | null; 
    id?: string | null; 
    signals?: (Signals | null)[] | null; 
  }

  export type Signals = {
    __typename?: "reverb_signals_Signal";
    name?: reverb_signals_Signal_Name | null; 
    group?: reverb_signals_Signal_Group | null; 
    title?: string | null; 
    subtitle?: string | null; 
    link?: Link | null; 
    icon?: string | null; 
    tooltipText?: string | null; 
  }

  export type Link = {
    __typename?: "reverb_signals_SignalLink";
    text?: string | null; 
    url?: string | null; 
  }
}

export namespace ListingData {
  export type Fragment = {
    __typename?: "Listing";
    _id?: string | null; 
    upc?: string | null; 
    finish?: string | null; 
    model?: string | null; 
    shopUuid?: string | null; 
  } & SellerInfoData.Fragment
}

export namespace CollectionInfo {
  export type Fragment = {
    __typename?: "CollectionHeader";
    _id?: string | null; 
    title?: string | null; 
    metaTitle?: string | null; 
    collectionId?: string | null; 
    collectionType?: core_apimessages_CollectionHeader_CollectionType | null; 
    description?: string | null; 
    fullBleedImage?: FullBleedImage | null; 
  }

  export type FullBleedImage = {
    __typename?: "core_apimessages_Image";
    source?: string | null; 
  }
}

export namespace CheckoutDisplayFields {
  export type Fragment = {
    __typename?: "Checkout";
    _id?: string | null; 
    shippingAddress?: ShippingAddress | null; 
    paymentMethod?: PaymentMethod | null; 
  }

  export type ShippingAddress = {
    __typename?: "core_apimessages_Address";
    isComplete?: boolean | null; 
  }

  export type PaymentMethod = {
    __typename?: "core_apimessages_CheckoutPaymentMethod";
    isComplete?: boolean | null; 
  }
}

export namespace CoreSellerDashboardListing {
  export type Fragment = {
    __typename?: "Listing";
    _id?: string | null; 
    id?: string | null; 
    slug?: string | null; 
    title?: string | null; 
    sku?: string | null; 
    price?: Price | null; 
    bumpRate?: BumpRate | null; 
    bumpRecommendations?: BumpRecommendations | null; 
    bumpInteractionsCounts?: BumpInteractionsCounts | null; 
    images?: (Images | null)[] | null; 
  } & BumpRecommendationsAttributes.Fragment

  export type Price = {
    __typename?: "core_apimessages_Money";
    display?: string | null; 
    amountCents?: number | null; 
    currency?: string | null; 
  }

  export type BumpRate = {
    __typename?: "core_apimessages_BumpRate";
    rate?: number | null; 
  }

  export type BumpRecommendations = {
    __typename?: "reverb_search_BumpRecommendationsResults";
    bumpRecommendationAmount?: number | null; 
  }

  export type BumpInteractionsCounts = {
    __typename?: "arbiter_BumpInteractionCountsResponse";
    total?: number | null; 
  }

  export type Images = {
    __typename?: "core_apimessages_Image";
    source?: string | null; 
  }
}

export namespace BumpRecommendationsAttributes {
  export type Fragment = {
    __typename?: "Listing";
    _id?: string | null; 
    condition?: Condition | null; 
    csp?: Csp | null; 
  }

  export type Condition = {
    __typename?: "core_apimessages_Condition";
    conditionUuid?: string | null; 
    conditionSlug?: string | null; 
    displayName?: string | null; 
  }

  export type Csp = {
    __typename?: "CSP";
    _id?: string | null; 
    id?: string | null; 
    title?: string | null; 
    slug?: string | null; 
  }
}

export namespace BumpRecommendationsFragment {
  export type Fragment = {
    __typename?: "Listing";
    _id?: string | null; 
    bumpRecommendations?: BumpRecommendations | null; 
  }

  export type BumpRecommendations = {
    __typename?: "reverb_search_BumpRecommendationsResults";
    bumpRecommendationAmount?: number | null; 
  }
}

export namespace CoreBumpRecommendationListingCard {
  export type Fragment = {
    __typename?: "Listing";
    images?: (Images | null)[] | null; 
    _id?: string | null; 
    hasInventory?: boolean | null; 
    sellerPrice?: SellerPrice | null; 
    shipping?: Shipping | null; 
  } & mParticleListingFields.Fragment & BumpRecommendationsAttributes.Fragment

  export type Images = {
    __typename?: "core_apimessages_Image";
    source?: string | null; 
  }

  export type SellerPrice = {
    __typename?: "core_apimessages_Money";
    amount?: string | null; 
    amountCents?: number | null; 
    currency?: string | null; 
    display?: string | null; 
  }

  export type Shipping = {
    __typename?: "core_apimessages_ShippingPrices";
    shippingPrices?: (ShippingPrices | null)[] | null; 
  }

  export type ShippingPrices = {
    __typename?: "core_apimessages_ShippingPrice";
    shippingRegionCode?: string | null; 
    originalRate?: OriginalRate | null; 
  }

  export type OriginalRate = {
    __typename?: "core_apimessages_Money";
    amount?: string | null; 
    amountCents?: number | null; 
    currency?: string | null; 
    display?: string | null; 
  }
}

export namespace CheckoutOrderSummaryFields {
  export type Fragment = {
    __typename?: "Checkout";
    _id?: string | null; 
    id?: string | null; 
    orders?: (Orders | null)[] | null; 
    paymentMethod?: PaymentMethod | null; 
  } & CheckoutDiscountCodeFormFields.Fragment & CheckoutOrderSummaryOrderItemFields.Fragment & CheckoutOrderSummaryLineItemsFields.Fragment

  export type Orders = {
    __typename?: "core_apimessages_CheckoutOrder";
    listingId?: string | null; 
  }

  export type PaymentMethod = {
    __typename?: "core_apimessages_CheckoutPaymentMethod";
    type?: core_apimessages_CheckoutPaymentMethod_Type | null; 
    isComplete?: boolean | null; 
    supportsDiscountCodes?: boolean | null; 
  }
}

export namespace ShopPoliciesData {
  export type Fragment = {
    __typename?: "Listing";
    _id?: string | null; 
    id?: string | null; 
  } & Item2ListingPaymentPoliciesData.Fragment & Item2ShopShippingPoliciesData.Fragment & Item2ShopReturnPoliciesData.Fragment & Item2ShopTaxPoliciesData.Fragment
}

export namespace CheckoutShippingLayoutMeFields {
  export type Fragment = {
    __typename?: "rql_Me";
    uuid?: string | null; 
    shippingAddresses?: (ShippingAddresses | null)[] | null; 
  }

  export type ShippingAddresses = {
    __typename?: "core_apimessages_Address";
    uuid?: string | null; 
  }
}

export namespace CheckoutShippingLayoutCheckoutFields {
  export type Fragment = {
    __typename?: "Checkout";
    _id?: string | null; 
    id?: string | null; 
    shippingAddress?: ShippingAddress | null; 
    orders?: (Orders | null)[] | null; 
  } & CheckoutOrderSummaryFields.Fragment & CheckoutShippingAddressFormFields.Fragment & CheckoutDisplayFields.Fragment

  export type ShippingAddress = {
    __typename?: "core_apimessages_Address";
    uuid?: string | null; 
    countryCode?: string | null; 
  }

  export type Orders = {
    __typename?: "core_apimessages_CheckoutOrder";
    cannotBeShippedToAddress?: boolean | null; 
  }
}

export namespace MixedFeedRow {
  export type Fragment = {
    __typename?: "reverb_feed_FeedEntry";
    id?: number | null; 
    type?: reverb_feed_FeedEntry_EntryType | null; 
    deleted?: boolean | null; 
    metadata?: Metadata | null; 
    localizedContents?: (LocalizedContents | null)[] | null; 
    entry?: Entry | null; 
  }

  export type Metadata = {
    __typename?: "reverb_feed_FeedMetadata";
    sourceType?: reverb_feed_FeedSourceType | null; 
  }

  export type LocalizedContents = {
    __typename?: "reverb_feed_FollowLocalizedContents";
    locale?: string | null; 
    title?: string | null; 
    shortDescription?: string | null; 
  }

  export type Entry =ArticleInlineFragment | ListingInlineFragment

  export type ArticleInlineFragment = {
    __typename?: "Article";
    _id?: string | null; 
    id?: string | null; 
    title?: string | null; 
    images?: (Images | null)[] | null; 
    webLink?: WebLink | null; 
    articleCategories?: (ArticleCategories | null)[] | null; 
  }

  export type Images = {
    __typename?: "core_apimessages_Image";
    source?: string | null; 
  }

  export type WebLink = {
    __typename?: "core_apimessages_Link";
    href?: string | null; 
  }

  export type ArticleCategories = {
    __typename?: "core_apimessages_ArticleCategory";
    name?: string | null; 
    slug?: string | null; 
  }

  export type ListingInlineFragment = {
    __typename?: "Listing";
    _id?: string | null; 
  } & ListingsCollection.Fragment
}
